webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	__webpack_require__(4);
	
	__webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var element = document.getElementById('minto__main');
	
	_angular2.default.element(element).ready(function () {
	    _angular2.default.bootstrap(element, ['minto'], { strictDi: false });
	});

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(5);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/index.js!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "*{box-sizing:border-box}html{font-family:Nexa-Bold,sans pro,\"serif\";font-size:16px;line-height:22px;height:100%}body{background:#fff;display:flex;flex-direction:column;min-height:100vh;overflow-x:hidden;min-width:1024px}@media (max-width:1024px){body{overflow-x:auto}}@media (max-width:1160px){body .section1-unit1a{overflow-x:auto;min-width:1160px}}@media (max-width:1300px){body .section1-unit1c{overflow-x:auto;min-width:1300px}}img{max-width:100%}button{border:none;box-shadow:none}input:focus::-webkit-input-placeholder{color:transparent!important}input:focus:-moz-placeholder,input:focus::-moz-placeholder{color:transparent!important}input:focus:-ms-input-placeholder{color:transparent!important}#minto__main{min-height:100vh;display:flex;flex-direction:column}.wrapper{max-width:1024px;margin:0 auto;height:100%}.content.wrapper{padding-bottom:20px;clear:both}@media (min-width:768px){.content.wrapper{padding-bottom:40px}}.clearfix:after{content:\".\";visibility:hidden;display:block;height:0;clear:both;font-size:0}h1,h2,h3,h4,h5,p{margin:0}p{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;font-weight:400;line-height:27px}a{text-decoration:underline;color:#12195f}h3{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:24px;font-weight:800}@media (min-width:1024px){h3{font-size:27px}}.container:not(.ng-scope){flex:1;overflow:hidden;padding-bottom:40px}@media (min-width:768px){.container:not(.ng-scope){padding-bottom:90px}}@media (max-width:1360px){.corporate-inquiry .content{flex-wrap:wrap}.corporate-inquiry .contact-adresses{margin-left:256px}}@media (max-width:1024px){.content-caption-box:after{content:none}}.video-block{position:fixed;background:rgba(0,0,0,.85);visibility:hidden;transition:all .2s;z-index:1000;top:0;left:0;width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;opacity:0}.video-block iframe{transition:transform .2s;transform:scale(.1)}.video-block .video-wrapper{position:relative}.video-block .close-button{position:absolute;font-size:60px;top:-10px;right:0;color:#fff;transition:transform .3s,top .2s .2s,opacity .2s;transform:rotate(1turn);cursor:pointer}.video-block .close-button:hover{opacity:.6}.modal-video-trigger{position:absolute;z-index:-1;opacity:0;width:0}.modal-video-trigger:checked+.video-block{visibility:visible;opacity:1}.modal-video-trigger:checked+.video-block iframe{transform:scale(1)}.modal-video-trigger:checked+.video-block .close-button{transform:rotate(0);top:-30px}.error-callout{width:750px;height:365px;padding:50px 40px;background:url(/assets/images/error-callout.svg) no-repeat;position:relative}.error-text{font-size:50px;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";color:#1e2978;line-height:120%}.error-text:first-line{line-height:100%}.m__button{cursor:pointer}@keyframes hollow-button{0%{box-shadow:5px -5px 10px 5px rgba(1,130,179,.5)}25%{box-shadow:-5px -5px 10px 5px rgba(1,130,179,.5)}50%{box-shadow:-5px 5px 10px 5px rgba(1,130,179,.5)}75%{box-shadow:5px 5px 10px 5px rgba(1,130,179,.5)}to{box-shadow:5px -5px 10px 5px rgba(1,130,179,.5)}}.live-minto-course .header{background:url(/assets/images/livecourse_header_bg.png)}.live-minto-course .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.buy-the-course{margin-bottom:0}.buy-the-course .header{background:url(/assets/images/buy-the-course_header_bg.png)}.buy-the-course .underheader{position:relative}.buy-the-course .back__button{top:0}.buy-the-course .content{display:flex;flex-wrap:wrap}.buy-the-course .container{padding-bottom:300px}.buy-the-course .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.buy-the-course .content-heading{font-size:23px;font-family:Nexa-Bold,sans pro,\"serif\";padding:0 20px 0 350px}.buy-the-course .content-heading--payment-num{padding:0 0 7px;margin-left:46px;font-size:18px;display:inline-block}.buy-the-course .content-heading--payment-sum{padding:0 0 30px;margin-left:46px;font-size:18px;display:inline-block}.buy-the-course .content-text{padding:5px 20px 0 350px;margin-top:18px;margin-bottom:25px}.buy-the-course .contacts-input-box{margin:0 0 0 10px;width:538px}.buy-the-course .buy-the-course__right-aside{width:315px}.buy-the-course .buy-the-course__left-aside{width:340px;margin-left:25px;position:relative}.buy-the-course input,.buy-the-course textarea{padding:7px 5px 2px;color:#1e2977}.buy-the-course .field-wrap{margin-bottom:13px;font-size:16px;color:#050e61;position:relative}.buy-the-course .field-wrap label{margin-left:11px}.buy-the-course .field-wrap_address textarea{height:70px;border-bottom:1px solid #e6e6ef}.buy-the-course .field-wrap--last{margin-bottom:15px}.buy-the-course .field-wrap__dropdown{cursor:pointer}.buy-the-course .field-wrap__dropdown:after{content:url(/assets/images/buy-the-course_arrowdown.png);position:absolute;right:14px;bottom:10px}.buy-the-course .field-wrap--right{margin-bottom:0;position:inherit;float:right}.buy-the-course .input-message__fild--right{height:205px;width:195px}.buy-the-course .input-message__fild--left{width:335px;height:255px}.buy-the-course .field_file{float:right;position:relative;height:120px;width:120px;vertical-align:bottom;background:#fff;padding:20px;font-size:13px;line-height:17px;display:flex;color:#1e2977;align-items:flex-end}.buy-the-course .field_file:before{content:\"+\";font-size:60px;position:absolute;top:31px;left:17px;font-family:Nexa-Light,sans pro,\"serif\"}.buy-the-course .field_file input[type=file]{display:none}.buy-the-course .payment-section{margin-left:327px;width:100%}.buy-the-course .payment-box1{margin-top:14px;float:left}.policies .header,.press .header,.TCs .header,.testimonials .header{background:url(/assets/images/T&Cs-header_bg.png)}.policies .CoverImage,.press .CoverImage,.TCs .CoverImage,.testimonials .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}@media (max-width:767px){.policies .back__button,.press .back__button,.TCs .back__button,.testimonials .back__button{left:20px}}.policies .right-aside,.press .right-aside,.TCs .right-aside,.testimonials .right-aside{position:relative;float:left}@media (max-width:767px){.policies .right-aside,.press .right-aside,.TCs .right-aside,.testimonials .right-aside{width:100%;height:40px}}.policies .content-heading,.press .content-heading,.TCs .content-heading,.testimonials .content-heading{padding:40px 20px 0}@media (min-width:768px){.policies .content-heading,.press .content-heading,.TCs .content-heading,.testimonials .content-heading{padding:40px 20px 0 120px}}.press .header{background-image:url(\"/assets/images/press-header.jpg\");background-size:cover}.flex{display:flex}.flex-column{flex-direction:column}.margin-bottom-50{margin-bottom:50px}.margin-bottom-30{margin-bottom:30px}.margin-bottom-10{margin-bottom:10px}.error404 .header{background:url(/assets/images/error404.jpg)}.error404 .content-caption-box{margin-left:110px;height:600px}.loading{background:url(/assets/images/loading-wheel.gif)}.divider{border-bottom:3px solid #000;padding-bottom:45px;margin-bottom:45px}.margin-60{margin-bottom:60px}.margin-top-80{margin-top:80px!important}.empty{width:10px;display:inline-block}.intro-list{display:flex;width:600px;justify-content:space-between;padding-left:20px}.text__blue{color:#1e2977}.text__blue img{margin:0 auto;display:block}.font__nexa-bold,.font__nexa-bold div,.font__nexa-bold p{font-family:Nexa-bold,sans pro,\"serif\"!important}.memo-note{position:relative;height:522px;width:557px;float:right;background:url(\"/assets/images/notes.png\") no-repeat;background-size:cover}.memo-note p{position:absolute;width:354px;top:121px;right:56px;transform:rotate(7deg);font-family:Comic Sans MS;font-size:17px;line-height:30px;opacity:.8;z-index:10}ul.bullet-list{padding:0}ul.bullet-list li{list-style:none;display:list-item;margin-left:40px}ul.bullet-list li:before{content:\"\";border:2px solid #000;border-radius:40px;margin-top:7px;margin-left:-13px;position:absolute}ul.bullet-list .level2 li:before{content:\"-\";border:0;border-radius:0;margin-top:0}ul.bullet-list .square{border-radius:0}.memo-paper{margin-top:60px;position:relative}.memo-paper span{display:inline-block;width:100%}.memo-paper__header{display:flex!important}.memo-paper__header p{flex:1}.memo-paper>div{padding:45px 70px;font-family:Source Sans Pro,sans pro,Arial,serif;background-image:url(/assets/images/grey-paper.png);font-size:18px;line-height:30px;position:relative;z-index:2}.memo-paper:before{top:28px;right:10px;width:51px;height:46%;background:#000;box-shadow:0 0 20px 10px rgba(0,0,0,.6);opacity:.6;transform:skew(-2deg)}.memo-paper:after,.memo-paper:before{content:\"\";position:absolute;z-index:1}.memo-paper:after{left:49px;bottom:-95px;width:94.6%;height:100px;background:url(\"/assets/images/paper-shadow-bottom.png\") no-repeat;background-size:contain}.memo-paper ul{margin:0}.memo-paper ol>li{margin-top:9px}.memo-paper .memo-paper-title{font-weight:700;letter-spacing:1px}.memo-paper .memo-paper-description{margin-top:0;padding-top:0}.memo-paper .memo-wrapper{display:flex;width:100%;justify-content:flex-start;padding:0}.memo-paper .memo-column{width:max-content;padding:0;vertical-align:top}.memo-paper .no-decoration{list-style-type:none}.memo-paper--yelow{margin-top:60px;margin-bottom:40px;position:relative}.memo-paper--yelow>div{padding:45px 70px;background:#fefab5;font-size:18px;line-height:30px;position:relative;z-index:2}.memo-paper--yelow:before{content:\"\";position:absolute;top:28px;right:10px;width:51px;height:46%;background:#000;box-shadow:0 0 20px 10px rgba(0,0,0,.6);opacity:.6;transform:skew(-2deg);z-index:1}.memo-paper--yelow ul{margin:0}.memo-paper-horizontal{position:relative;margin:20px 0}.memo-paper-horizontal div{position:relative;padding:92px;font-family:Times New Roman;background:#ededed;font-size:18px;line-height:30px;width:97%;z-index:2}.memo-paper-horizontal:before{top:45px;left:23px;width:94.4%;transform:skew(-3deg)}.memo-paper-horizontal:after,.memo-paper-horizontal:before{content:\"\";position:absolute;height:45%;background:#9a9a9a;box-shadow:0 0 20px 12px rgba(0,0,0,.4);opacity:.6;z-index:1}.memo-paper-horizontal:after{bottom:-5px;left:26px;width:94%;transform:skew(3deg)}.image__center{display:block;margin:0 auto}.white{color:#fff}.center{text-align:center}.horizontal-ul-list{padding:0;margin:0;list-style:none;display:flex;align-items:center;justify-content:center}.horizontal-ul-list li{padding-right:10px}.element-arr{position:absolute;right:-16px;top:50%;transform:translateY(-50%)}.long-arr{width:280px;height:90px;position:absolute;top:-90px;left:-185px}.long-arr .long-arr-part1.long-arr-part1_short{width:185px;transform:rotate(28deg);left:85px}.long-arr .long-arr-part2.long-arr-part2_short{left:80px;transform:rotate(28deg)}.long-arr .long-arr-part1{width:280px;position:absolute;height:4px;background-color:#fff;transform:rotate(18deg);left:0;bottom:40px}.long-arr .long-arr-part2{position:absolute;top:-7px;left:-12px;width:0;height:0;border-style:solid;border-width:9.5px 21px 9.5px 0;border-color:transparent #fff transparent transparent;transform:rotate(23deg)}.unit-diagram-descriptionbox .diagram-description ol{margin:0}.separator.separator_hidden{opacity:0}.diagram-description ol li{font-size:17px;line-height:1.2;padding-bottom:10px}.anchors-menu{font-weight:700;font-family:Source Sans Pro,Arial,sans-serif;font-size:18px;line-height:28px}.anchors-menu .anchor{color:#000;text-decoration:none}.anchors-menu .anchor:hover{text-decoration:underline}.double-column{column-count:2;column-gap:30px;margin-top:30px}@font-face{font-family:Nexa-Bold;src:url(\"/assets/fonts/Nexa-Bold.otf\");font-style:normal;font-weight:400}@font-face{font-family:Nexa-Light;src:url(\"/assets/fonts/Nexa-Light.otf\");font-style:Bold;font-weight:400}/*! normalize.css v4.1.1 | MIT License | github.com/necolas/normalize.css */html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block}audio:not([controls]){display:none;height:0}progress{vertical-align:baseline}[hidden],template{display:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}b,strong{font-weight:inherit;font-weight:bolder}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background-color:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}img{border-style:none}svg:not(:root){overflow:hidden}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}figure{margin:1em 40px}hr{box-sizing:content-box;height:0;overflow:visible}button,input,optgroup,select,textarea{font:inherit;margin:0}optgroup{font-weight:700}button,input{overflow:visible}button,select{text-transform:none}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:none;padding:0}[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring,button:-moz-focusring{outline:1px dotted ButtonText}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{box-sizing:border-box;color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}[type=checkbox],[type=radio]{box-sizing:border-box;padding:0}[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}::-webkit-input-placeholder{color:inherit;opacity:.54}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}.ui-draggable-disabled{cursor:default!important}.header{background:url(/assets/images/concept_header_bg.png);display:flex;flex:1 100%;margin-bottom:80px}.header-box,.header-logo{position:relative}.header-logo{float:left;width:124px;height:99px;margin:36px 0 35px 70px;top:-10px;display:block}.header-logo text{font-size:15px;letter-spacing:18px}.header-logo svg{transition:filter .45s;filter:drop-shadow(0 0 0 #fff)}.header-logo svg:hover{transition:filter .65s;filter:drop-shadow(1.3px 0 0 #fff)}.header-caption{position:absolute;left:335px;bottom:-110px;font-size:36px;line-height:36px;width:1000%;display:inline-block;color:#fff;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\"}.header-caption:after{content:\"\";background:#fff;display:block;height:2px;width:100%;margin-top:5px;position:relative;right:4px}.FlexEmbed{display:block;overflow:hidden;position:relative}.FlexEmbed:before{content:\"\";display:block;width:100%}.FlexEmbed--2by1:before{padding-bottom:50%}.FlexEmbed--16by9:before{padding-bottom:56.25%}.FlexEmbed--4by3:before{padding-bottom:75%}.CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-height:157px;max-width:100%}.container:not(.homepage) .container:not(.homepage) .header-logo{width:124px;height:99px;margin:46px 0 35px 70px}.contact-section-wrapper,.content-box{margin-left:215px;clear:right;padding-top:0;margin-right:50px}.contact-section-wrapper a,.content-box a{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;font-weight:400;line-height:27px}.content-caption{position:relative;line-height:24px;color:#12195f;margin:30px 0 20px 120px;font-family:Nexa-Bold,sans pro,\"serif\"}.content-caption:after{content:\"\";position:absolute;bottom:-9px;left:0;height:100%;width:1000%;border-bottom:2px solid #12195f}.content-heading{padding:0 20px 0 120px;color:#12195f;line-height:27px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:21px}@media (min-width:1024px){.content-heading{font-size:24px}}.content-subheading{color:#12195f;padding:0 20px 0 120px;font-size:12px;font-weight:400}.content-text{padding:25px 0 0 120px;color:#12195f;font-size:15px;line-height:22px}@media (min-width:1024px){.content-text{font-size:18px;line-height:25px}}.list__content-text{padding:25px 135px 0 140px}.list__content-text .content-text{padding:0;color:#12195f}.content-img{margin:55px 0 0 114px;width:750px;padding:0}.side-nav{background:#fff;padding:5px 20px 13px;margin:0 0 0 50px;display:inline-block}.side-nav-box{margin-top:6px;float:left;height:100%}@media (min-width:768px){.side-nav-box{display:block;width:250px}}@media (min-width:1024px){.side-nav-box{width:300px}}.side-nav__item{font-family:Nexa-Light,sans pro,\"serif\";display:block;width:138px;color:#12195f;padding:18px 5px 7px;margin-top:7px;font-size:11px;line-height:15px;text-decoration:none;cursor:pointer;border-bottom:1px solid #f3f3f7;text-transform:uppercase}@media (min-width:1024px){.side-nav__item{font-size:14px;width:160px}}.side-nav__item:first-of-type{margin-top:0}.side-nav__item--current{font-family:Nexa-Bold,sans pro,\"serif\"}.side-nav--stickytop{margin-top:0}.proposals{display:flex;justify-content:flex-start;margin:60px 0 0 120px;padding:0}.proposal{width:100%;margin-left:200px;position:relative}.proposal-heading{margin-bottom:35px;color:#12195f}.proposal-button,.proposal-logo{display:inline-block}.proposal-button{position:absolute;padding:5px 28px 3px;font-family:Nexa-Bold,sans pro,\"serif\";margin-left:30px;font-size:21px;text-align:center;text-decoration:none;cursor:pointer;background-color:#050e61;border-radius:8px;border:3px solid #050e61;color:#fff}.proposal .m__button{display:inline-block;width:177px;margin-top:15px}.payment-boxes{position:relative;padding:20px 0 0 20px}.counter-box{height:41px;display:inline-block;position:relative;left:12px;top:8px;width:110px;background:#fff}.counter-value{text-align:center;font-size:23px;font-family:Nexa-Bold,sans pro,\"serif\";color:#1e2977;position:absolute;left:4.5px}.payment-value-box{display:inline-block}.payment-value__count{margin-left:9px;background:#fff;min-width:160px;padding:9px 12px 5px;font-family:Nexa-Bold,sans pro,\"serif\";color:#1e2977}.payment-mode{position:relative;top:56px;right:145px;text-decoration:none;cursor:pointer}.payment-mode--first{top:52px}.payment-boxes__errors{margin-bottom:20px}.homepage-boxes{margin-top:25px;flex-wrap:inherit;display:flex;justify-content:space-between;width:685px;padding:0}.homepage-boxes a{text-decoration:none}.homepage-box{background-color:rgba(0,0,0,.25);width:215px;height:135px;border:1px solid #fff;display:flex;align-items:center;justify-content:center;margin-bottom:20px}.homepage-box__littleboxes{justify-content:space-between;flex-wrap:wrap}.homepage-box__littlebox{background-color:rgba(0,0,0,.25);width:215px;height:63px;border:1px solid #fff;margin:10px 0 0;display:flex;align-items:center;justify-content:center;transition:border 0s}.homepage-box__littlebox:first-of-type{margin-top:0}.homepage-box__text{font-size:31px;font-family:Nexa-Light,sans pro,\"serif\";line-height:36px;color:#fff;text-align:left;padding:0 25px;width:100%}.homepage-box__text--littlebox{padding:0 0 0 15px;font-size:27px}.homepage-box,.homepage-box__littlebox{transition:box-shadow .45s ease-in-out;box-shadow:inset 0 0 0 0 #fff}.homepage-box .homepage-box__text,.homepage-box__littlebox .homepage-box__text{transition:text-shadow .45s ease-in-out;text-shadow:0 0 0 #fff,0 0 0 #fff,0 0 0 #fff,0 0 0 #fff}.homepage-box:hover,.homepage-box__littlebox:hover{transition:box-shadow .65s ease-in-out;box-shadow:inset 0 0 0 .5px #fff}.homepage-box:hover .homepage-box__text,.homepage-box__littlebox:hover .homepage-box__text{text-shadow:-.25px -.25px 0 #fff,.25px -.25px 0 #fff,-.25px .25px 0 #fff,.25px .25px 0 #fff;transition:text-shadow .65s ease-in-out}input::-webkit-input-placeholder,textarea::-webkit-input-placeholder{color:#050e61;opacity:1}input,textarea{display:block;width:100%;margin:2px 10px;border:none;border-bottom:1px solid #e6e6ef;transition:border-color .25s ease,box-shadow .25s ease;color:#050e61;font-family:Nexa-Light,sans pro,\"serif\"!important}input:focus,textarea:focus{outline:0}textarea{border:none;resize:none}.field__invalid{border:3px solid red}.field-wrap{margin-bottom:20px;font-size:16px;color:#050e61;position:relative}.field-wrap:last-child{margin-bottom:0}.textarea__send__img{content:url(/assets/images/textarea-arrow.png);position:absolute;bottom:4px;left:100%;margin-left:4px;cursor:pointer}.textarea__send{position:absolute;bottom:10px;right:-19px}.textarea__send__link{font-family:Nexa-Light,sans pro,\"serif\";text-decoration:none;color:#050e61;background:#f7f7f7;padding:10px 20px 8px;right:6px;position:relative}.input-message__fild{min-height:200px;width:100%}.bg__white{background:#fff}.contact-adress{width:260px;height:150px}.contact-adress .email{display:block;width:300px}.contact-adress:first-child{margin-top:63px;margin-bottom:65px}@media (min-width:768px){.contact-adress{width:235px}}.contact-adress__head{font-size:17px;font-weight:800}.contact-adress__head,.contact-adress__info{font-family:Source Sans Pro,sans pro,Arial,serif;color:#12195f}.contact-adress__info{font-size:15px;font-weight:400;line-height:24px}.footer{position:relative;height:76px;width:100%;z-index:100;bottom:0;left:0;overflow:visible}.footer:hover .footer-container{height:70px}.footer-container{position:absolute;bottom:0;height:100%;width:100%;display:flex;justify-content:center;align-items:center;background-color:#020c7e;transition:height .2s}.footer-list{display:flex;list-style:none;font-size:14px;color:#fff;margin:0}.footer-list a{color:#fff!important;text-decoration:none!important}.footer-list__small-left-indent{margin-left:3px}.footer-list__item-left-indent{margin-left:20px}.footer-logo{width:56px;height:36px;cursor:pointer}.footer-nav{padding:15px 0;position:relative;z-index:10}.footer-nav>*{margin:0 35px 0 0}.footer-nav__item{text-decoration:none;color:#fff;font-family:Nexa-Light,sans pro,\"serif\";font-size:16px;cursor:pointer}.footer-subnav{position:relative;display:inline-block;cursor:default}.footer .drop-up{position:absolute;display:flex;overflow:hidden}.footer .drop-up .drop-up-container{background-color:#020c7e;width:100%;position:absolute;opacity:0;transition:bottom .2s}.footer .language__select{position:relative}.footer .language__select .drop-up{top:-75px;height:60px;width:103px;left:-8px}.footer .language__select .drop-up .drop-up-container{padding:6px 2px;height:60px;position:absolute;bottom:-120px}.footer .language__select .footer-nav__item{cursor:default}.footer .language__select:hover .drop-up-container{bottom:0;opacity:1}.footer .language__select input,.footer .language__select label{display:inline-block}.footer .language__select .lang-container{padding:2px 6px;width:100%;position:relative}.footer .language__select label{color:#fff;width:100%;font-family:Nexa-Light,sans pro,\"serif\";cursor:pointer}.footer .language__select input{position:absolute;margin:4px;width:auto;right:0;top:0;cursor:pointer}.footer .share-buttons{position:relative}.footer .share-buttons .drop-up{top:-105px;height:90px;width:75px;left:-10px}.footer .share-buttons .drop-up .drop-up-container{padding:6px 2px;height:90px;bottom:-180px}.footer .share-buttons .drop-up a{text-decoration:none;color:#fff;width:100%;font-family:Nexa-Light,sans pro,\"serif\";cursor:pointer;display:inline-block}.footer .share-buttons .footer-nav__item{cursor:default}.footer .share-buttons:hover .drop-up-container{bottom:0;opacity:1;text-align:center}.footer .share-buttons #twitter-widget-0,.footer .share-buttons .fb-share-button,.footer .share-buttons .IN-widget{margin:0 auto 7px;display:block;text-align:center;display:block!important}.footer .share-buttons a{text-decoration:none;color:#fff;width:100%;font-family:Nexa-Light,sans pro,\"serif\";cursor:pointer}.m__button{padding:8px 32px 7px;font-family:Nexa-Bold,sans pro,\"serif\"!important;font-size:16px;min-width:140px;text-align:center}.back__button,.m__button,.sign-up__button{text-decoration:none;font-weight:400;color:#fff;background-color:#020c7e}.back__button,.sign-up__button{left:60px;position:absolute;padding:12px 48px 6px 70px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:15px}.back__button:before{content:\"\\25C4\";position:absolute;left:38px;top:11px;font-size:19px}.payment-button{position:relative;padding:12px 26px;text-decoration:none;font-family:Nexa-Bold,sans pro,\"serif\";font-size:15px;font-weight:400;color:#fff;background-color:#020c7e}.sign-up__button{padding:9.5px 96px;top:57%;left:0}.sign-up__button__text{position:relative;right:85px}.sign-up__button:after{content:url(/assets/images/buy-the-course_inlogo.png);position:absolute;left:165px;top:6px}.buynow__button{position:relative;top:45px;left:60px;padding:5px 24px;text-decoration:none;border-radius:5px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:17px;font-weight:400;color:#fff;background-color:#43a3c6}.login__button{margin:0 auto;padding:5px 32px;margin-bottom:20px}.login-signup__button,.login__button{text-decoration:none;border-radius:5px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:21px;font-weight:400;color:#02043f;background-color:#fff}.login-signup__button{height:100%;padding:5px 20px}.tabs{margin:0;padding:0;list-style:none}.tab-content{position:relative}.tab-content .content-item{opacity:0;pointer-events:none;transition:opacity 1s;visibility:hidden;position:absolute;left:0;top:50px;width:100%;height:100%}.tab-content .content-item.active{visibility:visible;pointer-events:all;opacity:1}.unit-1:before{background-image:url(\"/assets/images/section-1-bg.png\")}.unit-1 .unit-video .unit-wrapper{padding:65px 80px}.unit-1 .marked,.unit-1 .unit-name{color:#fc922c}.unit-1 .video{border:5px solid #fc922c;color:#fc922c}.unit-1 .finish{border-top:3px solid #fc922c;border-bottom:3px solid #fc922c}.unit-1 .finish-button{background:#fc922c}.unit-1 .finish-button:hover{background:#f27803}.unit-2>section{background-color:#fff}.unit-2:before{background-image:url(\"/assets/images/section-2-bg.jpg\");background-object-fit:cover}.unit-2 #unit-video_2 .unit-wrapper{padding:0 80px 65px}.unit-2 #unit-video .unit-wrapper{padding:65px 80px}.unit-2 .marked,.unit-2 .unit-name{color:#a7dec3}.unit-2 .video{border:5px solid #a7dec3;color:#a7dec3}.unit-2 .finish{border-top:3px solid #a7dec3;border-bottom:3px solid #a7dec3}.unit-2 .finish-button{background:#a7dec3}.unit-2 .finish-button:hover{background:#82d0aa}.unit-2 .diagram{background:linear-gradient(135deg,hsla(0,0%,100%,.6),hsla(0,0%,100%,0) 40%),url(\"/assets/images/section-2-bg.jpg\");background-size:cover}.unit-3>section{background-color:#fff}.unit-3:before{background-image:url(\"/assets/images/section-3-bg.jpg\")}.unit-3 .marked,.unit-3 .unit-name{color:#2d6766}.unit-3 .video{border:5px solid #a7dec3;color:#a7dec3}.unit-3 .finish{border-top:3px solid #a7dec3;border-bottom:3px solid #a7dec3}.unit-3 .finish-button{background:#a7dec3}.unit-3 .finish-button:hover{background:#82d0aa}.unit-3 .diagram{background-image:url(\"/assets/images/section-3-bg.jpg\");margin-bottom:60px}.unit-4 .unit-header,.unit-4 h2.background{background-image:url(/assets/images/section-4-bg.jpg);background-size:cover;background-position-y:65%;background-repeat:no-repeat}.unit-4 #unit-video .unit-wrapper{padding:65px 80px}.unit-4 .marked,.unit-4 .unit-name{color:#fcf390}.unit-4 .video{border:5px solid #fcf390;color:#fcf390}.unit-4 .finish{border-top:3px solid #fcf390;border-bottom:3px solid #fcf390}.unit-4 .finish-button{display:block;text-decoration:none;text-transform:uppercase;text-align:center;font-size:17px;transition:background .3s ease;color:#050e61!important;background:#fcf390}.unit-4 .finish-button:hover{background:#fbee5e}.unit-4 .diagram{background-image:url(\"/assets/images/section-4-diagram-bg.png\")}.unit-5 .unit-video .unit-wrapper{padding:65px 80px!important}.unit-5 .unit-diagram{max-width:1440px;margin:0 auto;padding-left:80px;padding-right:80px;text-align:left;user-select:auto}.unit-5>section{background-color:#fff}.unit-5 .simplest__structure-answer{user-select:none}.unit-5 .simplest__structure-framework__diagram .simplest__structure-framework__diagram-box,.unit-5 .simplest__structure-framework__diagram .simplest__structure-framework__top-box-points{position:relative;z-index:3}.unit-5 .scq-diagram-dnd-wrapper.unit-diagram{padding-left:0;padding-right:0}.unit-5 .framework-diagram__sub-title,.unit-5 .framework-diagram__title{padding-left:0!important;padding-right:0!important}.unit-5 .scq-diagram-dnd-framework-wrapper .framework-diagram__components{padding-right:0}.unit-5 .scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework__tasks>div{flex:1}.unit-5 .scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-answers>div{width:100%}.unit-5 .blue-paper__right-shadow{right:10px;left:auto;transform:skew(-3deg)}.unit-5 .blue-paper__left-shadow,.unit-5 .blue-paper__right-shadow{content:\"\";position:absolute;top:21px;width:51px;height:46%;background:rgba(0,0,0,.7);box-shadow:0 0 20px 10px rgba(0,0,0,.6);opacity:.6;z-index:1}.unit-5 .blue-paper__left-shadow{left:15px;transform:skew(5deg)}.unit-5 .blue-paper{content:\"\";position:relative;height:auto;background-size:cover;background-position:50%;margin:30px 0;padding:30px 40px 50px;color:#000;width:100%;z-index:2}.unit-5 .blue-paper .right-shadow{content:\"\";position:absolute;top:12px;right:-4px;left:auto;width:51px;height:46%;background:#000;box-shadow:0 0 20px 10px rgba(0,0,0,.6);opacity:.6;transform:skew(-2deg);z-index:-1}.unit-5 .blue-paper p:first-child{margin:0}.unit-5 .blue-paper .separator{width:100%;height:3px;background-color:#000;margin-bottom:30px}.unit-5 .blue-paper>div{padding:0}.unit-5 .blue-paper .span-marginX{margin-right:20px;margin-left:27px}.unit-5 .blue-paper h5{text-align:left;border-bottom:none;padding-top:0}.unit-5 .new_blue_paper{background-image:url(\"/assets/images/blue-paper-5D.png\");color:#050e61;background-size:100% 100%;padding-top:40px;padding-bottom:30px}.unit-5 .new_blue_paper:after{display:none}.unit-5 .blue-paper:after{content:\"\";position:absolute;left:0;bottom:-100px;width:100%;height:100px;background:url(/assets/images/paper-shadow-bottom.png) no-repeat;z-index:1;background-size:contain}.unit-5 .grey-paper{background-image:url(\"/assets/images/grey-paper.png\");background-size:100% 100%;padding:60px 80px 100px}.unit-5 .grey-paper:after,.unit-5 .grey-paper:before{display:none}.unit-5:before{background-image:url(/assets/images/section-5-bg1.jpg);background-position-y:-250px}.unit-5 .marked,.unit-5 .unit-name{color:#f0e527}.unit-5 .video{border:5px solid #f0e527;color:#f0e527}.unit-5 .finish{border-top:3px solid #f0e527;border-bottom:3px solid #f0e527}.unit-5 .finish-button{background:#f0e527}.unit-5 .finish-button:hover{background:#d5ca0f}.unit-5 .diagram{background-image:url(\"/assets/images/section-5-bg1.jpg\")}.unit-5 .unit>section{background-color:#fff}.unit5b .intro__introduction,.unit5c .intro__introduction{background-image:url(\"/assets/images/consultants-paper.png\");background-repeat:no-repeat;height:1170px;padding:350px 116px 57px 117px!important;background-size:100% auto}.unit5b .intro__introduction li,.unit5b .intro__introduction p,.unit5c .intro__introduction li,.unit5c .intro__introduction p{color:#1b1b1b;font-size:19px;font-family:Source Sans Pro,sans pro,Arial,serif;line-height:24px;font-weight:400}.unit{animation-name:fadeIn;animation-duration:1.5s;animation-fill-mode:forwards;opacity:0}.unit:before{content:\"\";position:fixed;background-repeat:no-repeat;background-size:cover;height:100vh;width:100%;top:0;left:0;z-index:-1}.unit .intro,.unit p{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;line-height:28px}.desc-scq-diagram{width:100%}.desc-scq-diagram .scq-text{display:flex;flex-direction:column;align-items:flex-end}.desc-scq-diagram .scq-text .scq-block{border:3px solid #050e61;height:58px;width:300px;border-radius:15px;padding:8px;margin-bottom:10px}.desc-scq-diagram .scq-text .scq-block p{color:#050e61;font-size:20px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:20px}.desc-scq-diagram__title{position:absolute}.desc-scq-diagram__title p{color:#050e61;font-size:24px;font-family:Nexa-Bold,sans pro,\"serif\"}.desc-scq-diagram .scq-diagram{width:100%;display:flex;flex-direction:column;align-items:center}.desc-scq-diagram .scq-diagram .scq-block{border:3px solid #000;border-radius:15px;padding:6px;max-width:210px;min-height:90px}.desc-scq-diagram .scq-diagram .scq-block p{line-height:20px;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.desc-scq-diagram .scq-diagram svg{height:100px;width:900px}.desc-scq-diagram .scq-diagram svg line{stroke:#000;stroke-width:3px}.desc-scq-diagram .scq-diagram .scq-diagram-body{display:flex;justify-content:space-between;width:100%}.desc-scq-diagram .scq-diagram .scq-diagram-body__list ul{width:210px;padding-inline-start:20px}.desc-scq-diagram .scq-diagram .scq-diagram-body__list ul li{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;font-size:16px;line-height:18px}.highlight-word{color:#fd7f23}.sheet-of-paper{background-image:url(\"/assets/images/sheet-of-paper.png\");max-width:700px;margin-top:-38px;padding-top:190px;margin-left:281px;width:57vw;height:610px;position:absolute;background-size:cover;background-repeat:no-repeat;padding-right:88px;padding-left:86px;transform:translateY(-100vh);animation-name:showPaperSheet;animation-duration:2s;animation-delay:1s;animation-fill-mode:forwards;display:flex;flex-direction:column}.sheet-of-paper__long-bg{background-image:url(\"/assets/images/sheet-of-paper-long.png\");max-width:1013px;background-size:cover;background-repeat:repeat-y;width:92.8vw;position:absolute;left:0;top:689px;z-index:-1}.sheet-of-paper .correct-paper-answer{animation-name:fadeIn;animation-duration:1s;animation-fill-mode:forwards;opacity:0;border-bottom:2px dashed #000;padding-bottom:10px;margin-bottom:10px}.sheet-of-paper .correct-paper-answer__text{font-family:TimesNewRoman;font-size:16px;line-height:18px}.sheet-of-paper .correct-paper-answer__text:first-child{margin-bottom:10px}.sheet-of-paper .horizontal-line{width:100%;height:2px;background-color:#000;border:none}.sheet-of-paper .student-paper-answer{animation-duration:1s}.sheet-of-paper .student-paper-answer__expand{position:absolute;margin-top:-20px!important;right:119px;cursor:pointer;z-index:999999}.sheet-of-paper .student-paper-answer__field{max-width:100%;margin:0;font-family:Nexa-Bold,sans pro,\"serif\"!important;font-size:16px;line-height:18px;color:#000;background:transparent;font-weight:400}.sheet-of-paper .student-paper-answer__field::-webkit-scrollbar{width:0!important}.sheet-of-paper .student-paper-answer__field::placeholder{font-family:TimesNewRoman!important;font-size:16px;color:#000}.paper-header{display:flex;width:100%;padding-top:10px}.paper-header>div{display:flex;width:50%;flex-direction:column}.paper-header>div p{font-family:Nexa-Bold,sans pro,\"serif\"!important;color:#000;line-height:21px;font-size:17px;width:min-content}.paper-header>div:last-child{width:fit-content;align-items:center}.intro p{clear:both}.unit-wrapper{max-width:1085px;margin:0 auto;padding:65px 80px 50px}.no-top-margin,.no-top-margin div{margin-top:0;padding-top:0}.unit-section-title{font-size:53px;margin-top:0;color:#050e61;line-height:53px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit-section-title.background{color:#fff}.unit-section-title.background span{display:block;max-width:1085px;margin:0 auto;padding:30px 83px 21px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.exercise{padding:0 0 25px;font-size:18px}.exercise .exercise-number{font-size:51px;line-height:68px;color:#050e61;display:block;font-family:Nexa-Bold,sans pro,\"serif\"}.exercise .exercise-subtitle,.exercise .exercise-title{display:block;margin:25px 0;font-size:48px;line-height:60px;margin:0 0 25px;font-weight:600;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.exercise .exercise-title+.exercise-subtitle{margin-top:-25px}.exercise .exercise-pre-description{font-family:Source Sans Pro,Arial,\"serif\";font-size:13px;line-height:20px}.exercise .exercise-description{font-family:Source Sans Pro,Arial,\"serif\";font-size:18px}.exercise .exercise-reference{display:block;text-align:right;margin-top:40px;font-family:Source Sans Pro,Arial,\"serif\";font-size:16px;line-height:18px}.exercise .exercise-wrapper{padding-top:0}.exercise .exercise-text-1,.exercise [class*=exercise-text]{font-family:Source Sans Pro,sans pro,Arial,serif}.exercise .exercise-text-1{margin-bottom:20px}.exercise .exercise-text-2,.exercise .exercise-text-3{font-family:Source Sans Pro,sans pro,Arial,serif}.exercise .exercise-text-3 strong{color:#050e61;font-size:24px}.exercise .exercise-topic{color:#050e61;font-size:38px;line-height:1;margin-bottom:30px}.blue-paper{color:#050e61;margin-bottom:20px;background-image:url(\"/assets/images/paper-note-blue.png\");background-size:contain;background-repeat:no-repeat;padding:10px 25px;height:535px}.blue-paper .reference,.blue-paper>p,.blue-paper li{font-family:Nexa-Bold,sans pro,\"serif\"}.blue-paper>div{padding:10px 50px}.blue-paper p{margin:0;line-height:25px}.blue-paper p:first-child{margin-top:20px}.blue-paper .blue-paper-title,.blue-paper h5{text-align:center;font-family:Nexa-Bold,sans pro,\"serif\";font-size:32px;padding:35px 0 25px;border-bottom:3px solid #000}.blue-paper .blue-paper-title span,.blue-paper h5 span{display:inline-block}.blue-paper .blue-paper-title span:first-child,.blue-paper h5 span:first-child{font-size:32px}.blue-paper .blue-paper-title span:last-child,.blue-paper h5 span:last-child{font-size:24px;line-height:30px;margin-top:10px}.blue-paper .reference{text-align:right;margin:20px 0}.blue-paper .cite{margin-top:20px;font-family:Nexa-Light,sans pro,\"serif\"}.diagram{position:relative;min-height:620px;background-repeat:no-repeat;background-size:cover}.diagram .unit-wrapper{padding:44px 80px 45px}.structure{text-align:center}.structure img{margin:10px 0}.exercise-text-2{margin-bottom:40px}.exercise-text-2 span,.exercise-text-3 span{color:#050e61;margin:25px 0;display:inline-block;font-weight:700}.exercise-2 .exercise-text-1{margin-bottom:50px}.exercise-2 .blue-paper{height:700px}.exercise-2 .blue-paper h5{font-size:32px;text-align:left}.unit__table{border:2px solid #000;border-radius:14px;overflow:hidden;margin:20px 0}.unit__table-4 .unit__table-row>div{width:25%}.unit__table-3 .unit__table-row>div{width:33%}.unit__table-row{display:flex}.unit__table-header{align-items:flex-start}.unit__table-header>div{height:75px}.unit__table-row>div{font-weight:400;font-size:16px;padding:10px;border-right:1px solid #000}.unit__table-row>div:last-child{border-right:none}.unit__table-row:not(.unit__table-header)>div{min-height:170px}.unit__table-row{border-bottom:1px solid #000}.unit__table-row:last-child{border-bottom:0}.unit__table-list{margin-left:20px}.unit__table-1-2 .unit__table-header>div{height:45px;text-align:center}.unit__table-1-2 .unit__table-sub__header{height:45px}.unit__table-1-2 .unit__table-sub__header>div{text-align:center;height:45px}.unit__table-1-2 .unit__table-row>div{width:25%}.unit__table-1-2 .unit__table-row>div:last-child{width:75%}.grey-paper{margin:30px 0;font-family:Times New Roman!important;position:relative}.grey-paper:after,.grey-paper:before{z-index:-1;position:absolute;content:\"\";bottom:1em;width:50%;top:80%;background:#777;box-shadow:0 1em .5em #777}.grey-paper:before{transform:rotate(-3deg);left:.5em}.grey-paper:after{transform:rotate(3deg);right:.5em}.grey-paper p{font-family:Times New Roman!important}.grey-paper .grey__paper-title{font-family:Times New Roman;font-weight:700;margin:25px 0;font-size:24px}.grey-paper .grey__paper-title--small{font-family:Times New Roman;margin-bottom:15px}.grey-paper ul{list-style:none}.grey-paper .pater__divider{margin:25px 0;text-align:center}.exercise-situation{margin-top:20px;display:flex}.exercise-situation>div:first-child{width:225px;margin-right:20px;margin-top:30px}.exercise-situation .exercise-situation-title{color:#050e61;border:3px solid #000;padding:12px 5px;border-radius:10px;font-size:15px;width:190px}.exercise-situation .exercise-situation-row{display:flex;justify-content:space-between;margin-bottom:25px;font-family:Source Sans Pro,Arial,sans-serif}.exercise-situation .exercise-situation-row>div:first-child{margin-right:50px;flex:1 0 15%}.exercise-situation .exercise-situation-col{flex:0 0 85%}.piramid__title{position:relative;margin:35px 0}.piramid__title p{float:left;width:400px}.piramid__title img{float:right;position:relative;top:-80px}.exercise-title--small{color:#050e61;font-size:24px;font-family:Nexa-Bold,sans pro,\"serif\"!important}.diagram-outline{stroke:#050e61}.diagram-connector{stroke-width:3;fill:none}.s1a-color,.s1c-color,.s1d-color{stroke:#fff}.s1d-arrow{fill:#fff}.remove-margin{padding-top:0}.boxed-note{margin-top:30px;border:3px solid #000;border-radius:15px;padding:30px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:16px;line-height:22px}.margin20{margin-bottom:20px}.unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61;position:relative}.diagram-task{float:left;width:100%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}.submit{text-align:right!important;margin-top:30px;margin-right:10%}.submit.on__hold{opacity:0}.submit.on__hold button{cursor:default!important}.submit a{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#fc922c;border-radius:10px;padding:5px 10px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.submit a.next-exercise-button{display:none;transition:opacity .5s;transition-delay:.3s;opacity:0}#slots,.slots{margin:0 auto}#slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;position:relative}#slots td{font-size:0}.separator{position:relative;height:88px}.separator svg{position:absolute;top:-2px;left:0;z-index:2}#elements{width:auto;height:auto;margin:54px auto 0;text-align:center}#elements td{padding:10px}.slots td{padding:0 10px;font-size:0}#slots .answer-field,#slots div[id]{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #fff;border-radius:15px;margin:0 0 0 10px;background:none;transition:all .2s ease}#slots .answer-field{margin-left:0;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\"!important;line-height:16px;color:#fff}#slots .answer-field:hover{transform:scale(1.5) translateY(-14px);z-index:100;position:relative;background:#a7dec3}#slots .answer-field:hover+.hint{transform:translateX(-5px);opacity:0!important}#elements div:first-child,#slots div:first-child{margin-left:0}#slots div.hovered{background:hsla(0,0%,100%,.3)}.slot.slot-empty{background:none!important}.list-element{width:auto!important;height:auto!important;max-width:320px;color:#050e61;display:flex;position:relative;padding:2px;border-radius:0;border:none;margin-bottom:5px;line-height:22px;background:none;font-size:17px;cursor:move;text-align:left;box-shadow:none}.list-element__number{margin-top:2px;min-width:20px;display:flex;justify-content:center}.list-element__description{margin-left:15px}.list-element:hover{border-radius:8px;background:hsla(0,0%,100%,.5)}.list-element.element-list_drop{width:165px!important;height:84px!important;padding:4px 8px;margin:0 0 0 10px;position:absolute;top:100%;z-index:1;background:#a7dec3;border-radius:13px;border:2px solid #fff;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s;overflow:auto!important;cursor:move;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:16px;text-align:left}.ui-draggable-dragging{position:absolute;z-index:5}.element-list_drop .list-element__number{display:none!important}.element-list_drop .list-element__description{margin-left:0!important}.blue-element.element{background-color:#a7dec3;border:2px solid #a7dec3}#slots .fixed-answer,.element{display:inline-block;width:165px;height:84px;padding:4px 8px;border-radius:13px;border:2px solid #fc922c;margin:0 0 0 10px;background:#fc922c;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .1s,box-shadow .3s,border .3s,background .1s}.fixed-answer:hover,.list-element.element-list_drop:hover{transform:scale(1.5);z-index:100000!important;box-shadow:0 2px 6px #000!important}#slots .fixed-answer{position:relative;z-index:3}#slots .hint{position:absolute;top:-15px;right:90px;transition:all .4s;opacity:0;z-index:3}.element.ui-draggable.ui-draggable-dragging{transform:scale(1.25)!important;transform-origin:50% 50%}.element.ui-draggable .ui-draggable-dragging_hover{transform:scale(1)!important}.wrong{box-shadow:0 0 5px 2px red!important}.correct{border:2px solid #fff!important}.diagram-description{text-align:left;clear:both}.checkboxes-task{text-align:left}.example-description{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;font-size:34px;line-height:1;margin-bottom:20px}#slots .steps .step{height:40px}#slots .steps .separator{height:20px}#slots .steps svg{overflow:visible}#slots .steps td{font-size:18px;line-height:28px}#slots .steps td .step{background-color:#f0e527;cursor:pointer;position:relative;z-index:9999;font-family:Nexa-Bold,sans pro,\"serif\"}.situation{color:#fff;text-align:left;margin-top:50px;font-size:14px}.situation ul{padding-left:15px}.checkbox__hint input+label{border:3px solid red!important}.diagram.simplest_structure{min-height:440px;margin-bottom:85px}.show-diagram{display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%}.show-diagram .diagram-question{position:absolute;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;line-height:24px;font-size:24px;margin-top:-78px;margin-left:-173px}.show-diagram .diagram-box{height:100px;width:205px;border:3px solid #000;border-radius:15px;margin:0 8px;padding:3px 7px 0}.show-diagram .diagram-box.text-center{display:flex;justify-content:center;align-items:center}.show-diagram .diagram-box p{font-family:Nexa-Bold,sans pro,\"serif\";color:#00008b;line-height:17px;font-size:17px}.show-diagram .connector{height:100px}.show-diagram .connector svg{height:210px;width:1000px}.show-diagram .diagram-slots{display:flex;flex-direction:row;justify-content:space-around;align-items:center}.show-diagram .diagram-slots .connector svg{width:100%}.checkbox{position:relative;height:16px}.checkbox input+label{position:absolute;top:4px;display:block;height:22px;width:22px;border:3px solid #fff;border-radius:9px;box-shadow:0 0 3px rgba(0,0,0,.5);z-index:2;cursor:pointer}.checkbox input+label:after{content:\"\";position:absolute;display:block;top:0;left:0;box-shadow:inset 0 0 3px 0 #000;height:16px;width:16px;border:none;border-radius:9px;background:#fff;z-index:1;opacity:0;transition:opacity .2s}.checkbox input:disabled+label{cursor:default}input[type=checkbox]{opacity:0}input[type=checkbox]:checked+label:after{opacity:1}input[type=radio]{opacity:0}input[type=radio]:checked+label:after{opacity:1}.scq__note{display:flex}.scq__note div:last-child{margin-left:50px}.scq__note-title{margin:10px 0;font-weight:600}.flex-row{display:flex}.flex-row>div{width:50%!important;margin:0 10px}.scq-diagram-dnd-framework-wrapper .r1-block__bottom-part{border-top:none}.scq-diagram-dnd-framework-wrapper .r1-block__top-part{position:relative;top:8px}.scq-diagram-dnd-framework-wrapper .simplest__structure-answer-content{display:flex;flex-direction:column;justify-content:space-between}.scq-diagram-dnd-framework-wrapper .simplest__arrow-button{display:none}.scq-diagram-dnd-framework-wrapper .simplest__structure-answer--dropped .box-title{font-size:12px!important}.scq-diagram-dnd-framework-wrapper .box-title{font-size:14px!important}.scq-diagram-dnd-framework-wrapper .simplest__structure-answers{display:flex;justify-content:space-between;margin-bottom:40px;margin-top:60px}.scq-diagram-dnd-framework-wrapper .simplest__structure-answers .simplest__structure-answer{height:62px;width:300px;background:#f0e527;border-radius:7px;text-align:left;padding:11px 0 10px 45px;box-shadow:0 3px 4px 2px rgba(0,0,0,.41)}.scq-diagram-dnd-framework-wrapper .simplest__structure-answers .simplest__structure-answer.ui-draggable-handle{cursor:move;cursor:-webkit-grab}.scq-diagram-dnd-framework-wrapper .simplest__structure-answers .simplest__structure-answer.ui-draggable-handle:active{cursor:-webkit-grabbing}.scq-diagram-dnd-framework-wrapper .simplest__structure-box.ui-droppable{border:4px solid #fff;border-radius:10px;height:70px;width:308px}.scq-diagram-dnd-framework-wrapper .simplest__structure-box span{z-index:10}.scq-diagram-dnd-framework-wrapper .simplest__structure-answer--dropped{box-shadow:none!important;border-radius:0!important}.scq-diagram-dnd-framework-wrapper .note{top:-46px;left:0;background-color:#fff;color:#050e61;padding:12px 15px;border-radius:7px;min-width:110px;text-align:left}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-triple .simplest__structure-framework__diagram-box-bottom{margin-top:50px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-triple .simplest__structure-framework__diagram-box{background-color:#fff;min-height:50px;padding:5px;width:110px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-triple .simplest__structure-framework__diagram-box p{font-size:13px;color:#050e61;text-align:left;line-height:15px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-triple .simplest__structure-framework__diagram-header{height:64px;margin-top:35px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-triple .simplest__structure-framework__diagram-header p{font-size:14px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework{text-align:left}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-wrapper{width:100%}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-wrapper .situation-title{text-transform:uppercase;text-align:center;font-family:Nexa-Bold,sans pro,\"serif\";margin-bottom:15px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__situation-desc{font-family:Nexa-Bold,sans pro,\"serif\";font-size:17.1px;line-height:20px;color:#fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__situation-desc ul{margin-block-start:0;margin-block-end:0}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-top-bottom{display:flex;width:100%}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-top-bottom__desc{margin:0 auto;display:flex;flex-direction:column;justify-content:space-between}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-top-bottom__desc .simplest__structure-framework__diagram-box{display:flex;align-items:center}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-desc-text{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:14px;margin-top:15px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points{display:flex;justify-content:space-between}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points>ul,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points>ul{list-style:none;max-width:155px;padding-inline-start:11px;margin-right:5px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points>ul>li,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points>ul>li{text-indent:-11px;font-size:14px;color:#fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points>ul>li:before,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points>ul>li:before{content:\"-\";margin-right:5px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points>ul>li>ul,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points>ul>li>ul{padding-inline-start:16px;list-style-type:disc}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__bottom-box-points>ul>li>ul>li,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__top-box-points>ul>li>ul>li{text-indent:0;line-height:18px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram{display:flex;flex-direction:column;align-items:center;height:min-content}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram svg{position:absolute;width:400px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram svg line,.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram svg path{stroke:#fff;stroke-width:3px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram svg path{fill:#fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram__summarize-bottom-box{width:65%;margin-top:-38px;margin-left:134px;margin-bottom:15px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram__summarize-bottom-box__dashed-top{width:100%;border-bottom:3px dashed #fff;margin-left:3px;margin-bottom:-2px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram__summarize-bottom-box__dashed-bottom{width:100%;border-top:3px dashed #fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram__summarize-bottom-box__dashed-bottom p{margin-top:5px;text-align:center;font-size:14px;color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";line-height:15px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-box{min-height:80px;width:135px;border:3px solid #fff;border-radius:15px;padding:8px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-box p{font-family:Nexa-Bold,sans pro,\"serif\";font-size:15px;text-align:center;color:#fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__diagram-box-bottom{margin-top:80px;width:100%;display:flex;justify-content:space-between}.scq-diagram-dnd-framework-wrapper .simplest__structure-square.simplest__structure-framework-box{height:200px!important}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__tasks{display:flex;position:relative}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__tasks>div{width:50%;padding:0 10px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__tasks .submit{position:absolute;bottom:0;right:0;margin:0}.scq-diagram-dnd-framework-wrapper .structure-box-list{padding-left:10px;border:4px solid #fff;padding-top:4px}.scq-diagram-dnd-framework-wrapper .structure-box-list li,.scq-diagram-dnd-framework-wrapper .structure-box-list p{font-size:14px;color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";line-height:18px}.scq-diagram-dnd-framework-wrapper .structure-box-list ul{margin-block-start:9px;margin-block-end:5px;padding-inline-start:27px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-box{height:140px!important;width:100%!important;border-radius:10px;border:4px solid #fff}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__solution{margin-top:60px;padding:0 10px;text-align:center}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework__image{margin-bottom:20px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-answers{margin-top:80px;display:flex;flex-wrap:wrap}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-answers>div{width:47%;height:114px;padding:5px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-answers .simplest__structure-framework-answer{height:104px;width:100%;background:#f0e527;padding:10px;border-radius:10px;font-size:16px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-answers .simplest__structure-framework-answer div{font-size:14px}.scq-diagram-dnd-framework-wrapper .simplest__structure-framework-answers .simplest__structure-answer--dropped.simplest__structure-framework-answer{border-radius:3px!important;overflow:visible}.scq-diagram-dnd-framework-wrapper .framework-diagram .simple-separator{margin-top:4px;height:4px;border-top:4px dashed #fff;position:relative;top:76px;z-index:4}.scq-diagram-dnd-framework-wrapper .framework-diagram__exercise-title,.scq-diagram-dnd-framework-wrapper .framework-diagram__sub-title,.scq-diagram-dnd-framework-wrapper .framework-diagram__title{text-align:left;padding-left:120px;padding-right:120px;font-size:22px;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-weight:700}.scq-diagram-dnd-framework-wrapper .framework-diagram__exercise-title{margin:0 auto;width:fit-content;padding:0}.scq-diagram-dnd-framework-wrapper .framework-diagram__title{padding-top:40px}.scq-diagram-dnd-framework-wrapper .framework-diagram__title span{font-size:24px;font-weight:bolder}.scq-diagram-dnd-framework-wrapper .framework-diagram__sub-title{margin-top:20px}.scq-diagram-dnd-framework-wrapper .framework-diagram__components{margin-top:40px;padding-right:40px}.scq-diagram-dnd-framework-wrapper .framework-diagram .r1-block__top-part{border-bottom:4px dashed;border-bottom-color:transparent;border-bottom-left-radius:0;border-bottom-right-radius:0}.scq-diagram-dnd-framework-wrapper .framework-diagram .r1-block__bottom-part{border-top:4px dashed;border-top-color:transparent;border-top-left-radius:0;border-top-right-radius:0}.scq-diagram-dnd-framework-wrapper .framework-diagram .r1-block__title,.scq-diagram-dnd-framework-wrapper .framework-diagram .r2-block__title,.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__image-title{position:relative;top:-10px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__image{margin-bottom:40px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle{width:45%}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .bottom_box,.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .top_box{height:60px!important}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .top_box{position:relative;top:3px;border-bottom-left-radius:0;border-bottom-right-radius:0;border-bottom:none}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .bottom_box{position:relative;bottom:3px;border-top-left-radius:0;border-top-right-radius:0;border-top:none}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .solution-separator{z-index:4;position:relative;bottom:59px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .solution-separator .top-line{height:4px;background-image:linear-gradient(90deg,#fff 50%,hsla(0,0%,100%,0) 0);background-position:bottom left 4px;background-size:20px 4px;background-repeat:repeat-x}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__middle .solution-separator .bottom-line{background-image:linear-gradient(90deg,#fff 65%,hsla(0,0%,100%,0) 0);background-position:top right 13px;background-size:20px 4px;background-repeat:repeat-x;height:4px;position:relative;top:-3px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__connectors{width:100%;position:relative;top:-1px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__submit{bottom:45px;right:15px!important}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-answers{width:30%;margin-top:0;display:block}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-answers>div{width:24vw;height:auto}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-answers .simplest__structure-framework-answer{height:auto;min-height:104px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework__solution{margin-top:-50px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-answers .simplest__structure-framework-answer div{font-size:12px}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-box{height:70px!important}.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-box.r1-block__box,.scq-diagram-dnd-framework-wrapper .framework-diagram .simplest__structure-framework-box.r2-block__box{height:140px!important}.scq-diagram-dnd-framework-wrapper .framework-diagram .structure-answers .simplest__structure-answer--dropped{font-size:12px}.scq-diagram-dnd-framework-wrapper .framework-diagram .structure-answers .simplest__structure-answer--dropped.simplest__structure-framework-answer{min-height:0}.scq-diagram-dnd-framework-wrapper .framework-diagram .structure-answers__title{height:auto;text-transform:uppercase;font-size:16px;margin-top:-15px}.simplest__structure-block{display:flex;justify-content:flex-end;margin-bottom:55px}.simplest__structure-block .simplest__structure-task{max-width:530px;text-align:left}.simplest__structure-block .simplest__structure-task.hide{opacity:0}.simplest__structure-block textarea{border:4px solid #fff;background:transparent;border-radius:7px;padding:4px;padding-left:40px;padding-top:6px;font-weight:700;margin:0;font-family:Nexa-Bold,sans pro,\"serif\"!important}.simplest__structure-btn{background:#f0e527;border:3px solid #fff;border-radius:15px;padding:5px 10px;cursor:pointer;padding-top:10px;text-transform:uppercase}.simplest__structure-btn-disabled{opacity:.5;pointer-events:none!important}.simplest__structure-box{width:400px;position:relative}.simplest__structure-box span{position:absolute;left:13px;top:11px}.simplest__structure-diagram{position:inherit}.simplest__structure-diagram .submit{margin:0;float:none}.simplest__structure-subtitle,.simplest__structure-title{margin-bottom:70px;text-align:left;font-size:26px;line-height:1.1}.simplest__structure-subtitle{font-size:20px}.simplest__structure-note{height:240px;width:700px;padding:15px 40px 15px 20px;position:absolute;left:0;bottom:-40px;z-index:101;background:#f1f8f7;border-top-right-radius:15px;border-bottom-right-radius:15px;box-shadow:1px 2px 16px 4px rgba(0,0,0,.58);text-align:left;transform:translate(-660px,-100px);transition:all .5s}.simplest__structure-note:hover{transform:translateY(-100px)}.simplest__structure-note .simplest__structure-note__title{font-size:15px;font-family:Georgia;transform:rotate(-90deg);position:absolute;right:-52px;bottom:109px;text-decoration:underline;color:#000}.simplest__structure-note .simplest__structure-text{font-size:14px;color:#000;font-family:Georgia;overflow-y:scroll;overflow-x:hidden;height:100%}.scq-diagram-dnd-wrapper .simplest__text-area{color:#fff}.scq-diagram-dnd-wrapper .submit{position:relative;top:-75px;right:-125px}.scq-diagram-dnd-wrapper .simplest__structure-task{padding-top:8px}.scq-diagram-dnd-wrapper .simplest__structure-block{color:#fff}.scq-diagram-dnd-wrapper .note{top:-46px;left:0;background-color:#fff;color:#050e61;padding:12px 15px;border-radius:7px;min-width:110px;text-align:left}.homepage{background:url(/assets/images/Homepage_bg.png);background-repeat:no-repeat;background-size:cover;overflow:auto;min-height:100vh;display:block;margin-bottom:-50px}@media (max-width:767px){.homepage{min-width:767px}}.homepage .header-logo{left:-60px}.homepage .content{display:flex;justify-content:center;flex-wrap:wrap}.homepage .content-box{width:690px;display:flex;justify-content:flex-start;flex-wrap:inherit;padding:0 10px;margin:0 auto}@media (min-width:768px){.homepage .content-box{justify-content:center;padding:0}}.homepage .header{background:none;margin-bottom:50px;display:inherit}.homepage .content-caption{font-size:64px;font-family:Nexa-Light,sans pro,\"serif\";font-weight:400;color:#fff;line-height:60px;margin:0 0 10px;top:0;left:0;border:none}@media (min-width:768px){.homepage .content-caption{margin:0}}.homepage .content-caption:after{display:none}.homepage .content-text{padding:0 5px;font-size:22px;font-weight:400;color:#fff;margin-left:40px;text-align:left;width:350px;padding:0}.workbook__course .header{background:url(/assets/images/workbook-course.jpg)}.workbook__course .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.workbook__course .proposal{margin-left:0}.workbook__course .proposal .m__button{margin-top:0;vertical-align:top}.workbook__course .proposal form{display:inline-block;vertical-align:top}.workbook__course .proposal-logo{margin-right:10px}.workbook__course .list__content-text{padding:25px 135px 0 136px;margin:0}.workbook__course .list__content-text li{padding-left:20px}.workbook__course .list__content-text li:first-child{margin-bottom:25px}.about-barbara .content-box{display:flex}.about-barbara .header{background:url(/assets/images/about_barbara.png);background-position:50%;background-repeat:no-repeat;background-size:cover}.about-barbara .barbara-image{display:block;margin:0 0 0 96px;max-width:300px;padding:6px 10px;width:100%;height:100%;box-sizing:content-box}@media (min-width:768px){.about-barbara .barbara-image{margin:0 0 0 73px}}@media (min-width:1024px){.about-barbara .barbara-image{margin:0 0 0 23px}}.about-barbara .barbara-about{padding:0 20px 0 40px;width:100%;clear:both;color:#12195f}.about-barbara .barbara-about p{font-size:15px;line-height:22px}@media (min-width:1024px){.about-barbara .barbara-about p{font-size:18px;line-height:25px}}.header{background:url(/assets/images/login-alt-header_bg.png);margin-bottom:115px}.toast{animation-name:fadeIn;animation-duration:1s;animation-fill-mode:forwards;opacity:0}.login{color:#020c7e;font-family:Nexa-Bold,sans pro,\"serif\";background:url(/assets/images/login-background.png);background-position:0 150px;background-size:100% 100%}.login .hide{opacity:0}.login__title{font-size:54px;margin-left:5px;font-family:Nexa-Bold,sans pro,\"serif\";margin-bottom:13px}.login__box{width:100%;height:321px;background:rgba(37,37,37,.05);box-shadow:1px 1.732px 7px rgba(36,36,36,.68);padding:60px 75.5px}.login__links{display:flex;flex-direction:row;justify-content:flex-start;align-items:center}.login__sign-up{background:none;padding-left:14px;font-size:20px;font-family:Nexa-Light,sans pro,\"serif\";text-decoration:none;pointer-events:none!important}.login__separator{margin:0 14px}.login__login_link{background:none;font-size:20px;text-decoration:none}.login__lable-login{width:70px;font-size:20px}.login__form{display:flex;flex-direction:row;margin-top:85px}.login__form .form-div{width:50%}.login__form .form-div__label{width:70%;color:#020c7e;font-size:20px}.login__form .form-div__input{background:none;width:50%;margin:0;margin-bottom:7px}.login__form .form-div__input::placeholder{color:#707070}.login__form .form-div__error{font-size:12px;margin-bottom:23px;margin-top:-13px;color:#ed4956}.login__form .form-div__link{font-size:15px;font-family:Nexa-Light,sans pro,\"serif\";text-decoration:none}.login__form .form-div__login{opacity:.8;background-color:#dadada;box-shadow:2px 1.732px 5px;padding:4px 10px;border-radius:15px;cursor:pointer;width:130px}.login__underline{height:2px;background:#f7f7f7;width:100%;margin-top:-40px}.online-course .content-box{position:relative;margin-right:0}.online-course .content-box .inner-text{margin-left:-6px}.online-course .content-box>img{position:absolute;top:34px;left:25px}.online-course .header{background:url(/assets/images/online-course-header.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover}.online-course .online__course-menu{padding:15px 0 0 92px;display:flex;flex-wrap:wrap}@media (min-width:768px) and (max-width:1023px){.online-course .online__course-menu{padding:15px 0 0 72px}}@media (min-width:1024px){.online-course .online__course-menu{padding:15px 0 0 20px}}.online-course .online__course-menu-item{display:flex;width:216px;height:140px;padding:35px 12px;font-size:30px;color:#fff;font-family:Nexa-Light,sans pro,\"serif\";margin:7px 9px;text-decoration:none;line-height:1.2;letter-spacing:2px;transition:background-size .2s,text-shadow .2s;background-position:50%;background-repeat:no-repeat;cursor:pointer}.online-course .online__course-menu-item:hover{background-size:105% 105%!important;text-shadow:1px 0 0 currentColor}.online-course .online__course-menu-item.column-1{padding:36px 35px}.online-course .online__course-menu-item.column-2{padding:36px 37px}.online-course .online__course-menu-item.column-3{padding:36px 13px}.online-course .online__course-menu-item.login{background:url(/assets/images/online_login.jpg);background-size:100% 100%;order:1}.online-course .online__course-menu-item.try_course{background:url(/assets/images/online_try.jpg);background-size:100% 100%;order:2}.online-course .online__course-menu-item.testimonials{background:url(/assets/images/online_testimonials.jpg);background-size:100% 100%;order:3}.online-course .online__course-menu-item.barbara_minto{background:url(/assets/images/online_barbara.jpg);background-size:100% 100%;order:4}.online-course .online__course-menu-item.buy_course{background:url(/assets/images/online_buy-course.jpg);background-size:100% 100%;order:5}.online-course .online__course-menu-item.corporate_inquiry{background:url(/assets/images/online_corporate_inquiry.jpg);background-size:100% 100%;order:6}.contact .textarea__send__link{position:relative;height:40px;padding:10px 30px 8px}.contact .textarea__send__link span{position:relative;font-size:24px;top:3px}.contact .contact-section-wrapper{width:100%;margin-left:310px}@media (min-width:768px){.contact .contact-section-wrapper{margin-left:43px;display:flex;flex-wrap:wrap}}@media (min-width:1024px){.contact .contact-section-wrapper{justify-content:space-between;margin-left:-10px}}@media (min-width:768px){.contact .content.wrapper{display:flex}}.contact .contact-adresses{display:flex;width:100%;justify-content:flex-start;flex-wrap:wrap;padding-left:10px;width:170px}.contact .contact-adresses:first-child{margin-top:63px}@media (min-width:768px){.contact .contact-adresses{padding-left:20px}}@media (min-width:1024px){.contact .contact-adresses{padding-left:0}}.contact .contact-section{width:480px;margin-bottom:20px;float:left}.contact .contact-section form{padding:0 20px}.contact .header{background:url(/assets/images/contact-header_bg.png)}.contact .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.contact .content-caption{font-weight:400;font-size:16px;margin:3px 20px 0;font-family:Source Sans Pro,sans pro,Arial,serif}@media (min-width:768px){.contact .content-caption{margin:3px 0 0 40px}}@media (min-width:1024px){.contact .content-caption{font-size:18px;line-height:22px}}.contact .content-caption:after{display:none}.contact .content-text{color:#2795be}.contact .contacts-input-box{max-width:450px;padding-bottom:0;padding:20px;margin:10px 0}@media (min-width:768px){.contact .contacts-input-box{width:100%;margin:20px 0 0 20px;padding:20px 20px 0}}.testimonials .container{padding-bottom:100px}.testimonials .header{background:url(/assets/images/testimonials-header_bg.png)!important;background-position:50%!important;background-repeat:no-repeat!important;background-size:cover!important;max-width:100%!important}.testimonials .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.testimonials .m__button{position:absolute;top:50px;left:60px;width:152px;font-size:15px}.minto-textbook .header{background:url(/assets/images/minto-textbook-header.png)}.minto-textbook .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.minto-textbook .proposals{flex-wrap:wrap;justify-content:flex-start;margin:10px 0 0 120px;padding:0}.minto-textbook .proposal{padding-right:0;width:177px;margin:0 20px 40px 0;display:flex;flex-wrap:wrap}.minto-textbook .proposal:first-child{margin-right:100px}@media (min-width:768px){.minto-textbook .proposal:first-child{margin-right:50px}}@media (min-width:1024px){.minto-textbook .proposal:first-child{margin-right:110px}}.minto-textbook .proposal-logo{display:inline-block}.minto-textbook .proposal-heading{margin-bottom:35px;color:#2795be;font-size:16px}@media (min-width:1024px){.minto-textbook .proposal-heading{font-size:18px}}.minto-textbook .proposal-heading--minto-textbook{font-size:14px;line-height:1.4;color:#050e61;margin-left:20px}@media (min-width:1024px){.minto-textbook .proposal-heading--minto-textbook{font-size:17px}}.minto-textbook .proposal .m__button{height:36px;margin:0}.minto-textbook .proposal .proposal-logo{margin:0 0 15px}.minto-textbook .proposal-heading.proposal-heading--minto-textbook{width:150px;margin:0;padding-right:20px}.corporate-inquiry .right-aside{position:relative;float:left;top:45px}.corporate-inquiry .content{display:flex}.corporate-inquiry .header{background:url(/assets/images/corporate-inquiry_bg.jpg)}.corporate-inquiry .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.corporate-inquiry .content-caption{font-weight:400;font-family:Source Sans Pro,sans pro,\"serif\";font-size:16px;margin:3px 0 0 40px}.corporate-inquiry .content-caption:after{display:none}.corporate-inquiry .content-text{color:#2795be}.summary-app .header{background:url(/assets/images/barbara-in-your-pocket__header.png)}.summary-app .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.summary-app .content-text{color:#12195f}.summary-app .proposals{flex-wrap:wrap}.summary-app .proposal{margin:0;width:50%}.summary-app .proposal-heading{margin-bottom:15px;font-size:14px}@media (min-width:1024px){.summary-app .proposal-heading{margin-bottom:17px;font-size:17px}}.summary-app .proposal-applogo{display:inline-block;width:150px;height:150px;background:#0182b3;text-align:center;padding-top:25px;border-style:none;border-radius:10px;font-family:Nexa-Bold,sans pro,\"serif\"}.summary-app .proposal-applogo text{font-size:15px;letter-spacing:18px}.summary-app .proposal-applogo svg{transition:filter .45s;filter:drop-shadow(0 0 0 #fff)}.summary-app .proposal-applogo svg:hover{transition:filter .65s;filter:drop-shadow(1.3px 0 0 #fff)}.policies .content-box{margin:0;padding-left:0}@media (min-width:768px){.policies .content-box{margin-left:215px}}.policies .header{background:url(/assets/images/policies-header_bg.png)}.policies .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.header-version{position:absolute;right:1rem;color:#fff;font-size:.8rem}.step__diagram .so_what_text{color:#fff;position:absolute;padding:0 4px;right:0;top:103px;font-size:16px;background:rgba(0,0,0,.5);border-radius:15px;border:3px solid #fff;transition-duration:.5s}.step__diagram .showDocument .answers,.step__diagram .showDocument .diagram-body__pyramid,.step__diagram .showDocument .diagram-body__right-arrows{animation-duration:2s;animation-delay:1s;animation-fill-mode:forwards}.step__diagram .showDocument .diagram-body__pyramid,.step__diagram .showDocument .diagram-body__right-arrows{animation-name:hidePyramid}.step__diagram .showDocument .answers{animation-name:moveSCQ}.step__diagram .blinking-animation{animation-name:blinkingButton;animation-duration:.7s;animation-iteration-count:99999}@keyframes blinkingButton{0%{opacity:0}to{opacity:1}}.step__diagram .step__diagram-title{color:#050e61;font-size:26px;line-height:1.2;margin-bottom:40px}.step__diagram .diagram-body__diagram{display:flex;flex-direction:row;justify-content:space-between}.step__diagram .diagram-body__diagram .task-wrapper{flex:4}.step__diagram .diagram-body__diagram .task-wrapper .additionalInfoBox{margin-top:15px}.step__diagram .diagram-body__diagram .task-wrapper .task{border:3px solid #050e61;border-radius:10px;padding:4px;margin-left:auto;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:flex-end;color:#050e61;font-family:Nexa-Bold,sans pro,\"serif\"}.step__diagram .diagram-body__diagram .task-wrapper .task-number{background:#fff;border:2px solid #050e61;padding:2px 9px;border-radius:30px;height:100%}.step__diagram .diagram-body__diagram .task-wrapper .task-number span{position:relative;top:2px;left:.7px}.step__diagram .diagram-body__diagram .task-wrapper .task-title{height:100%;margin-top:4px;margin-left:8px;opacity:0}.step__diagram .diagram-body__diagram .task-wrapper .task .end-text-animation{animation-name:fadeIn;animation-duration:.5s;animation-fill-mode:forwards}.step__diagram .diagram-body__diagram .answers{flex:3;padding-top:35px;position:relative}.step__diagram .diagram-body__diagram .answers__box{font-family:Nexa-Bold,sans pro,\"serif\";background:transparent;margin-bottom:10px;border:3px solid #fff;border-radius:10px;width:100%;color:#050e61;min-height:76px;display:flex;flex-direction:row;justify-content:flex-start}.step__diagram .diagram-body__diagram .answers__box-title{width:17%;line-height:16px;padding:4px 8px 0 4px}.step__diagram .diagram-body__diagram .answers__box-text{padding-top:4px;max-width:83%;font-size:17px;opacity:0;line-height:16px}.step__diagram .diagram-body__diagram .arrows{flex:5;height:293px}.step__diagram .diagram-body .answers-input{padding-top:4px;max-width:83%;font-size:17px;line-height:16px;color:#050e61;background-color:transparent;font-family:Nexa-Bold,sans pro,\"serif\"!important;overflow:hidden;margin:0;opacity:0;animation-name:fadeIn;animation-duration:1s;animation-fill-mode:forwards}.step__diagram .diagram-body .answers-input::placeholder{font-family:Nexa-Light,sans pro,\"serif\"}.step__diagram .diagram-body__pyramid{display:flex;flex-direction:column;align-items:center}.step__diagram .diagram-body__pyramid .pyramid-question{display:flex;margin-top:40px;width:280px;margin-left:-288px;padding:50px;position:absolute;opacity:0}.step__diagram .diagram-body__pyramid .pyramid-question p{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.step__diagram .diagram-body__pyramid .additional-pyramid-box{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;top:50px;right:-260px;position:absolute!important;opacity:0;display:flex;flex-direction:column;justify-content:space-around}.step__diagram .diagram-body__pyramid .additional-pyramid-box .text{opacity:1!important}.step__diagram .diagram-body__pyramid .show-pyramid,.step__diagram .diagram-body__pyramid .show-pyramid-text{animation-name:fadeIn;animation-duration:1s;animation-fill-mode:forwards}.step__diagram .diagram-body__pyramid .pyramid-box{background:transparent;border:3px solid #fff;border-radius:20px;min-height:110px;width:220px;position:relative;padding:8px}.step__diagram .diagram-body__pyramid .pyramid-box .text{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;position:relative;opacity:0;line-height:20px}.step__diagram .diagram-body__pyramid .pyramid-body{position:relative;left:3000px;transition-duration:1s}.step__diagram .diagram-body__pyramid .pyramid-body:first-child{transition-delay:1s}.step__diagram .diagram-body__pyramid .pyramid-body:nth-child(2){transition-delay:1.5s}.step__diagram .diagram-body__pyramid .pyramid-body:nth-child(3){transition-delay:2s}.step__diagram .diagram-body__pyramid .pyramid-body:nth-child(4){transition-delay:2.5s}.step__diagram .diagram-body__pyramid .show-pyramid-body{left:0}.step__diagram .diagram-body__pyramid .pyramid-connectors{width:924px;height:70px}.step__diagram .diagram-body__pyramid .pyramid-blocks{width:100%;height:110px;display:flex;flex-direction:row;justify-content:space-between}.step__diagram .diagram-body__pyramid .pyramid-steps{font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;position:absolute;margin-left:-437px;margin-top:327px;opacity:0;animation-delay:1.7s!important}.step__diagram .diagram-body__right-arrows{position:absolute;top:220px;height:340px;width:310px}.step__diagram .step__diagram-slider{background:rgba(0,0,0,.5);padding:10px;border-radius:15px;color:#fff;display:flex;flex-direction:row;justify-content:flex-end;align-items:center;margin-bottom:40px;margin-top:40px}.step__diagram .step__diagram-slider .step__diagram-slider__button{background:none;border:3px solid #fff;border-radius:40px;padding:4px 14px 1px;color:#fff;font-size:14px;text-transform:uppercase;cursor:pointer;outline:none;margin-left:6px}.step__diagram .step__diagram-slider .step__diagram-slider__button[disabled]{color:gray;border-color:gray}@keyframes hidePyramid{0%{transform:translateX(0)}to{transform:translateX(-100vw)}}@keyframes showPaperSheet{0%{transform:translateY(-100vh)}to{transform:translateY(0)}}@keyframes moveSCQ{0%{transform:translate(0)}to{transform:translate(-694px,160px)}}@keyframes fadeOut{0%{opacity:1}to{opacity:0}}@keyframes slideIn{0%{opacity:0;top:6px}to{opacity:1;top:0}}@keyframes slideOut{0%{opacity:1;top:0}to{opacity:0;top:6px}}.step__diagram-steps{display:flex}.step__diagram-steps .step__diagram-steps--col:first-child{margin-right:150px}.step__diagram-steps--col{display:flex;flex-direction:column;align-items:center}.step__diagram-steps--row{display:flex;position:relative}.step__diagram-steps--row>.step__diagram-step::first-child{margin-top:25px}.step__diagram-step{outline:none;background:#f0e527;border:4px solid #fff;color:#050e61;font-size:18px;width:200px;border-radius:6px;padding:7px 1px 1px;margin:10px}.step__diagram-step.active{color:#fff;background:#050e61}.step__diagram-step:disabled{color:#646bad;background:#acacac}.step__diagram-path{position:relative}.step__diagram-path.step-1{width:17px;background:#fff;height:4px;transform:rotate(90deg)}.step__diagram-path.step-2{width:174px;height:4px;background:#fff;position:relative;left:184px;top:-62px;transform:rotate(-21deg)}.step__diagram-path.step-3{position:absolute;width:20px;height:4px;background:#fff;left:208px;top:27px}.step__diagram-path.step-4{position:absolute;left:220px;width:100px;height:4px;background:#fff;top:54px;transform:rotate(-190deg)}.step__diagram-path.step-5,.step__diagram-path.step-6{width:17px;background:#fff;height:4px;transform:rotate(90deg)}.step__diagram-path:after{content:\"\";width:0;height:0;border-top:5px solid transparent;border-left:10px solid #fff;border-bottom:5px solid transparent;position:absolute;right:-3px;top:-3px}.step__diagram--2 .first-step-text{position:absolute;top:12px}.step__diagram--2 .pyramid-builder-demo__circle{background-color:#fff;position:absolute;right:-42px;bottom:-39px}.step__diagram--2 .ng-hide-add{animation-name:fadeOut;animation-duration:1s}.step__diagram--2 .ng-hide-remove{animation-name:fadeIn;animation-duration:1s}.step__diagram--2 .yellow-text{color:#f0e527;margin-top:20px;margin-bottom:60px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:21px}.step__diagram--2 .small-white-text{color:#fff;font-size:15px;margin-bottom:10px}.step__diagram--2 .step__diagram-body{height:656px}.step__diagram--2 .step__diagram-desc{display:flex;flex-direction:row}.step__diagram--2 .step__diagram-desc p{margin-left:13px;color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";font-size:25px}.step__diagram--2 .step__diagram-buttons{display:flex;flex-direction:row;justify-content:space-between;position:relative;bottom:425px;width:1085px;right:80px}.step__diagram--2 .step__diagram-buttons button{background-color:transparent;outline:none;z-index:9999}.step__diagram--2 .step__diagram-buttons button img{border-radius:50%;height:55px;object-fit:none}.step__diagram--2 .step__diagram-buttons button:hover img{background-color:rgba(0,0,0,.4)}.step__diagram--2 .step__diagram-smallDiagram{display:flex;justify-content:flex-end}.step__diagram--2 .step__diagram-bigDiagram{box-shadow:0 0 300px 200px rgba(0,0,0,.75);position:absolute;top:30%;left:36%;animation-name:fadeIn;animation-duration:.5s;animation-fill-mode:forwards;background:rgba(0,0,0,.69)}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}.step__diagram--2 .scq-diagram{width:100%;display:flex;justify-content:space-between;font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;margin-bottom:12px}.step__diagram--2 .scq-diagram__title{width:29%;font-size:20px;line-height:8px}.step__diagram--2 .scq-diagram__arrow{width:19%;background-image:url(\"/assets/images/5a-1-step-7-arrow.png\");background-repeat:no-repeat;background-size:contain}.step__diagram--2 .scq-diagram__box{width:45%;border:3px solid #fff;border-radius:8px;display:flex}.step__diagram--2 .scq-diagram__box p:first-child{min-width:10%;text-align:center}.two-columns{display:flex;flex-direction:row}.two-columns .second-column{display:flex;flex-direction:column;align-items:center;padding-top:104px}.two-columns .second-column .yellow-text{max-width:222px;margin-top:0;margin-bottom:0}.two-columns.ng-hide-remove{animation-name:fadeInOtherBlock;animation-delay:1s;animation-duration:1s;animation-fill-mode:forwards;opacity:0;height:0}.two-columns.ng-hide:not(.ng-hide-animate){height:0;overflow:hidden;display:flex!important}.two-columns.ng-hide:not(.ng-hide-animate) .step__diagram-title{position:static!important}.small-white-text__list .small-white-text{line-height:17px;margin-bottom:7px}.newBlock{margin-top:5px}.newBlock.ng-hide-remove{animation-name:fadeInOtherBlock;animation-delay:1s;animation-duration:1s;animation-fill-mode:forwards;opacity:0;height:0}@keyframes fadeInOtherBlock{0%{opacity:0;height:0}1%{opacity:0;height:auto}to{opacity:1}}.step__diagram-ex-desc{font-family:Nexa-Bold,sans pro,\"serif\"!important;color:#fff;font-size:16px!important;margin-left:22px;line-height:20px}.step__diagram-main-title{margin-bottom:25px}.step__diagram-main-title p{font-family:Nexa-Bold,sans pro,\"serif\";font-size:19px;color:#050e61}.step__diagram-step-1-table{padding:7px;width:100%;flex-direction:column;justify-content:space-between}.step__diagram-step-1-table,.step__diagram-step-1-table .block{border:3px solid #fff;border-radius:15px;display:flex}.step__diagram-step-1-table .block p{font-size:18px;margin-bottom:0;font-family:Nexa-Bold,sans pro,\"serif\";padding:6px 15px;color:#fff}.step__diagram-step-1-table .block p:nth-child(2){text-align:center}.step__diagram-step-1-table .block p:first-child{background:#fff;mix-blend-mode:screen;color:#000!important;border-top-left-radius:5px;border-bottom-left-radius:5px}.step__diagram-title p{font-family:Nexa-Bold,sans pro,\"serif\";font-size:19px;color:#050e61;line-height:21px}.step__diagram-content{max-width:680px;display:flex;flex-direction:column;align-items:flex-start;background-repeat:no-repeat;padding:15px 22px}.step__diagram-content.ng-hide-remove{opacity:0}.step__diagram-content-header{color:#fff;font-family:Nexa-Bold,sans pro,\"serif\"!important;font-size:20px!important;margin-bottom:15px}.step__diagram-content .step-1__list{list-style:none;padding-inline-start:0}.step__diagram-content .step-1__list li{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:12px;line-height:15px}.step__diagram-content .step-1__diagram{width:100%;max-width:615px}.step__diagram-content .step-2__box{border-radius:15px;border:3px solid #fff;padding:12px;max-width:330px}.step__diagram-content .step-2__box-text{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:12px}.step__diagram-content .step-3__box{border-radius:15px;border:3px solid #fff;padding:12px;max-width:230px;min-width:217px;min-height:97px}.step__diagram-content .step-3__box-text{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:15px;line-height:18px}.step__diagram-content .step-7__diagram{margin-top:30px;background-image:url(\"/assets/images/5a-1-step-7-diagram.png\");background-size:contain;background-repeat:no-repeat;min-height:300px;width:100%}.scq-diagram-dnd-wrapper{transition-duration:2s}.scq-diagram-dnd-wrapper .sheet-of-paper{margin-left:-38px;width:92.8vw;max-width:1013px;padding-right:125px;padding-left:128px;padding-top:265px;z-index:12;margin-top:380px;height:693px;animation-delay:3s;transform:translateY(-200vh)}.scq-diagram-dnd-wrapper .sheet-of-paper__static{animation-delay:0s!important;animation-duration:0s!important}.scq-diagram-dnd-wrapper .sheet-of-paper__field{resize:none;overflow-y:scroll}.scq-diagram-dnd-wrapper .sheet-of-paper .correct-paper-answer{text-align:left;margin-bottom:10px}.scq-diagram-dnd-wrapper .sheet-of-paper .correct-paper-answer ol,.scq-diagram-dnd-wrapper .sheet-of-paper .correct-paper-answer p{font-size:16px;line-height:18px;font-family:Nexa-Bold,sans pro,\"serif\";color:#000}.scq-diagram-dnd-wrapper .sheet-of-paper .correct-paper-answer li,.scq-diagram-dnd-wrapper .sheet-of-paper .correct-paper-answer p,.scq-diagram-dnd-wrapper .sheet-of-paper .student-paper-answer__field{font-family:Nexa-Bold,sans pro,\"serif\";font-size:18px;font-weight:400}.scq-diagram-dnd-wrapper .sheet-of-paper__shadow{padding:0;margin:0;height:40px;animation-name:none}.scq-diagram-dnd-wrapper .simplest__structure-task{padding-left:30px;text-indent:-27px}.scq-diagram-dnd-wrapper #next{top:578px}.scq-diagram-dnd-wrapper .button-with-paper-anim{position:relative;top:588px;opacity:0;animation-name:fadeIn;animation-duration:1s;animation-delay:5s;animation-fill-mode:forwards}.scq-diagram-dnd-wrapper .button-with-paper{position:relative;top:618px}.scq-diagram-dnd-wrapper .simplest__structure-box{margin-left:auto}.scq-diagram-dnd-wrapper .simplest__structure-box textarea{background-color:rgba(5,14,97,.15);color:#fff}.scq-diagram-dnd-wrapper .simplest__structure-task{max-width:450px}.scq-diagram-dnd-wrapper .show-diagram .diagram-box{border-color:#fff;min-height:114px}.scq-diagram-dnd-wrapper .show-diagram .diagram-box p{color:#fff}.scq-diagram-dnd-wrapper .show-diagram svg line{stroke:#fff;stroke-width:3px}.growLayout{animation-name:growLayout;animation-duration:2s;animation-delay:3s;animation-fill-mode:forwards}.growLayout_static{animation-delay:0s!important;animation-duration:0s!important;height:1100px!important}@keyframes growLayout{0%{height:822px}to{height:1100px}}#scq-diagram-dnd .simplest__structure-block{color:#050e61;min-height:52px}#scq-diagram-dnd .simplest__structure-block span{z-index:3}#scq-diagram-dnd .hovered{background-color:hsla(0,0%,100%,.3)}#scq-diagram-dnd .simplest__structure-task{margin-right:auto;padding-left:30px;text-indent:-27px}#scq-diagram-dnd .simplest__structure-note{height:260px}#scq-diagram-dnd .simplest__structure-note .simplest__structure-note__title{bottom:119px}#scq-diagram-dnd .simplest__structure-answers-wrapper{display:flex;flex-direction:row;justify-content:space-between;min-height:45px;margin-bottom:30px}#scq-diagram-dnd .simplest__structure-answers-wrapper .simplest__structure-answer-repeat{width:292px;margin:0 12px}#scq-diagram-dnd .simplest__structure-answers-wrapper .simplest__structure-answer-repeat:first-child{margin-left:0}#scq-diagram-dnd .simplest__structure-answers-wrapper .simplest__structure-answer-repeat:last-child{margin-right:0}#scq-diagram-dnd .simplest__structure-answers-wrapper .simplest__structure-answer{box-shadow:0 3px 4px 2px rgba(0,0,0,.41);background:#f0e527;padding:10px;border-radius:7px;font-size:16px;text-align:left;height:100%}#scq-diagram-dnd .simplest__structure-answers-wrapper .simplest__structure-answer--dropped{padding-left:45px;border-radius:4px;box-shadow:none}#scq-diagram-dnd .simplest__structure-box{height:65px;cursor:move}#scq-diagram-dnd .simplest__structure-box-styles{width:300px;border:4px solid #fff;border-radius:7px;min-height:45px;height:65px}#scq-diagram-dnd .simplest__structure-box-styles:not(.simplest__structure-box) span{position:relative;right:106px;top:12px}.highlight__diagram-interactive-box{background-color:#5dd298!important}.highlight__diagram .highlight__diagram-title{color:#050e61;font-size:22px;margin-bottom:30px}.highlight__diagram .highlight__diagram-number{color:#050e61;font-size:22px}.highlight__diagram .highlight__diagram-block{background:#a7dec3;color:#050e61;width:220px;min-height:114px;padding:10px;border-radius:13px;margin-right:30px;font-size:16px;line-height:16px;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s;cursor:pointer;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;-o-user-select:none;position:relative}.highlight__diagram .highlight__diagram-block:not(:last-child):after{content:\"\";position:absolute;width:0;height:0;border-top:10px solid transparent;border-bottom:10px solid transparent;border-left:10px solid #000;right:-21px;top:50%;transform:translateY(-50%)}.highlight__diagram .highlight__diagram-block div{display:inline}.highlight__diagram .highlight__diagram-block .simplest__structure-task .correct-answer-box{margin-left:4px;display:block}.highlight__diagram .highlight__diagram-block .simplest__structure-task .correct-answer-box_7,.highlight__diagram .highlight__diagram-block .simplest__structure-task .correct-answer-box_8{margin-left:3px}.highlight__diagram .highlight__diagram-block .simplest__structure-task .correct-answer-box_11{margin-left:5px}.highlight__diagram .highlight__diagram-block .simplest__structure-task .highlight__answer{color:#be390a}.highlight__diagram .highlight__diagram-block .simplest__structure-task .highlight__answer.highlight__answer_correct{display:inline;margin-left:-1px}.highlight__diagram .highlight__diagram-block .simplest__structure-task .highlight__answer.highlight__answer_correct.highlight__answer_correct_6{display:inline-block}.highlight__diagram .highlight__diagram-block .simplest__structure-task .highlight__answer.highlight__answer_example{display:inline;margin-left:0}.highlight__diagram .highlight__diagram-block .ng-scope{margin-left:4px;display:inline-block}.highlight__diagram .highlight__diagram-block .ng-scope:first-of-type{word-spacing:1px}.highlight__diagram .highlight__diagram-block--wrapper{display:flex;margin-top:10px}.highlight__diagram .highlight__diagram-btn{background:#a7dec3;border:3px solid #fff;border-radius:15px;padding:5px 10px;cursor:pointer;padding-top:10px;text-transform:uppercase}#pyramid-step-2{position:fixed;pointer-events:none;height:200px;top:calc(50% - 100px);background:#000;right:0;z-index:99999999}.pyramid__link{fill:none;stroke-width:2px;stroke:#fff}.pyramid__node{fill:#fff;stroke-width:3px}.pyramid__node_wrp{position:relative}.pyramid__node foreignObject body{width:100%;min-width:0;min-height:0;background:none;padding-right:20px}.pyramid__node foreignObject textarea{width:calc(100% - 6px);height:80px;stroke:none;background:#0968ac;border:3px solid transparent;border-radius:8px;margin-left:3px;color:#fff;font-size:14px;line-height:1.2;padding:3px 7px;position:relative;z-index:5;margin-bottom:0;overflow-y:hidden}.pyramid__node_q{display:flex;justify-content:flex-start;align-items:center;flex-direction:row;padding:2px 4px 3px;overflow:hidden}.pyramid__node_q p{font-size:12px;font-family:Nexa-Bold,sans pro,\"serif\";color:#0968ac}.pyramid__node_q input{height:20px;font-family:Nexa-Bold,sans pro,\"serif\"!important;font-size:12px;margin-left:4px;border:none;color:#0968ac;margin-right:0}.pyramid__node_btns{position:absolute;right:-20px;top:0;height:100%;z-index:99;opacity:0;cursor:default;display:flex;flex-direction:column}.pyramid__node_btnsMinus{margin-top:2px}.pyramid__node_btnsPlus{margin-bottom:2px;margin-top:auto}.pyramid__node_btns div{padding:0 2px;cursor:pointer}.pyramid__node_btns svg{width:12px;height:15px}.tabs__wrapper{cursor:move}.open-pyramid-builder{position:fixed;bottom:55px;right:30px;z-index:9999999;cursor:pointer;user-select:none;display:flex;align-items:center}.open-pyramid-builder__circle{padding:5px;border-radius:100px;background-color:#0968ac;border:1px solid #fff;margin-left:20px}.open-pyramid-builder__label{padding-top:10px;white-space:nowrap;font-size:18px;color:#fff;z-index:9}.open-pyramid-builder__label button{background-color:#0968ac;color:#fff;padding:12px 20px 7px;border-radius:5px;border:1px solid #fff;cursor:pointer}.pyramid-builder-demo__modal{position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);z-index:200;display:flex;flex-direction:column;justify-content:center;align-items:center}.pyramid-builder-demo__modal-instruction{max-width:80%;background-color:rgba(0,0,0,.6);color:#fff;padding:42px;border-radius:50px;box-shadow:0 0 24px 8px rgba(0,0,0,.75)}.pyramid-builder-demo__modal li,.pyramid-builder-demo__modal p{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:18px;max-width:1000px}.pyramid-builder-demo__modal ol{list-style:none}.pyramid-builder-demo__circle{border-radius:100%;background-color:#00bfff;bottom:4px;right:-22px;width:150px;height:150px;position:fixed;opacity:0;animation:scaleIn 3s infinite cubic-bezier(.36,.11,.89,.32)}@keyframes scaleIn{0%{transform:scale(.1);opacity:.5}to{transform:scale(1);opacity:0}}.pyramid__options{width:400px;background:#0968ac;border-radius:10px;box-shadow:0 2px 5px 0 #000;padding:10px;color:#fff;cursor:move;position:absolute;left:30px;top:60px;z-index:90;height:76px!important;overflow:hidden}.pyramid__options.open{height:auto!important}.pyramid__options.open .fa-pencil{display:none}.pyramid__options.open .fa-times{display:block!important}.pyramid__options .pyramid__options-piramid{background-color:#3482ba;border-radius:5px;border:2px solid #6ba4cd;padding:0 10px}.pyramid__options .pyramid__options-title{font-family:Nexa-Light,sans pro,\"serif\";font-size:20px;position:relative}.pyramid__options .pyramid__options-title button{position:absolute;right:0;background:none;color:#fff;outline:none;cursor:pointer}.pyramid__options .pyramid__options-title button .fa-times{display:none}.pyramid__options .pyramid__options-title__input,.pyramid__options .pyramid__options__input-sm{margin:10px 0}.pyramid__options .pyramid__options-title__input input,.pyramid__options .pyramid__options__input-sm input{font-family:Nexa-Light,sans pro,\"serif\"!important;margin-left:0;margin-right:0;border-radius:5px;color:#0968ac;padding:1px 0 0 15px}.pyramid__options .pyramid__options-title__input input::-webkit-input-placeholder,.pyramid__options .pyramid__options__input-sm input::-webkit-input-placeholder{color:#0968ac}.pyramid__options .pyramid__options-title__input input::-moz-placeholder,.pyramid__options .pyramid__options__input-sm input::-moz-placeholder{color:#0968ac}.pyramid__options .pyramid__options-title__input input:-ms-input-placeholder,.pyramid__options .pyramid__options__input-sm input:-ms-input-placeholder{color:#0968ac}.pyramid__options .pyramid__options-title__input input:-moz-placeholder,.pyramid__options .pyramid__options__input-sm input:-moz-placeholder{color:#0968ac}.pyramid__options .pyramid__options-title__input input:focus:focus:-moz-placeholder,.pyramid__options .pyramid__options__input-sm input:focus:focus:-moz-placeholder{color:transparent}.pyramid__options .pyramid__options-title__input input:focus:-ms-input-placeholder,.pyramid__options .pyramid__options__input-sm input:focus:-ms-input-placeholder{color:transparent}.pyramid__options .pyramid__options-title__input input:focus::-webkit-input-placeholder,.pyramid__options .pyramid__options__input-sm input:focus::-webkit-input-placeholder{color:transparent}.pyramid__options .pyramid__options__input-sm input{display:inline-block;width:60px;font-weight:700;font-size:16px;margin-left:5px}.pyramid__options .pyramid__options-subtitle{font-size:14px}.pyramid__options .pyramid__options-subtitle>div{display:inline-block;width:7px;height:7px;border:2px solid #fff;padding:4px;border-radius:8px;margin-right:7px;cursor:pointer;top:1px;position:relative;background:none}.pyramid__options .pyramid__options-subtitle>div.active{background:#fff}.pyramid__options .pyramid__options-controls{margin-left:50px}.pyramid__options-footer{display:flex;flex-direction:column}.pyramid__options-footer button{color:#fff!important;background:none;border:none;width:40%;text-align:left}.pyramid__options-disabled{display:flex;align-items:center}.pyramid__options-disabled:hover span{opacity:1;transform:translateX(0)}.pyramid__options-disabled button{opacity:.7;width:auto;pointer-events:none}.pyramid__options-disabled span{font-size:.7em;opacity:0;transition:.5s;margin-top:1px;transform:translateX(-15px)}.pyramid__options-counter{display:flex;margin-left:10px}.pyramid__options-counter .pyramid__options-counter__model{margin-right:5px;background:#fff;border-radius:5px;color:#0968ac;padding:1px 5px 0;width:50px;text-align:center}.pyramid__options-counter .pyramid__options-counter__control{position:relative;margin-left:5px}.pyramid__options-counter .pyramid__options-counter__control span:first-child{position:absolute;transform:rotate(-90deg);display:block;top:-5px;cursor:pointer}.pyramid__options-counter .pyramid__options-counter__control span:last-child{transform:rotate(90deg);display:block;position:absolute;top:5px;left:-2px;cursor:pointer}.pyramid__options-style{display:flex;flex-direction:column;justify-content:center;margin-bottom:10px;margin-top:10px}.pyramid__options-style span{display:block}.pyramid__options-style .rz-bubble{display:none}.pyramid__options-style .rzslider{margin-top:10px;margin-bottom:15px}.pyramid__options-style .rzslider .rz-pointer:after{position:absolute;top:6px;left:6px;width:8px;height:8px;background:#0868ac!important;border-radius:4px;content:\"\"}.pyramid__options-style .rzslider .rz-pointer{top:-8px;z-index:3;width:20px;height:20px;cursor:pointer;background-color:#fff;border-radius:16px;border:2px;user-select:none;outline:none}.pyramid__builder{position:fixed;left:0;right:0;top:0;bottom:0;z-index:1000000;display:none;max-width:100%;overflow:hidden}.pyramid__builder__additional-pyramid-box{border:3px solid #fff;padding:3px 7px;width:170px;min-height:80px;border-radius:8px;position:absolute;top:300px;left:25%}.pyramid__builder__additional-pyramid-box p{color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";line-height:1.2;font-size:14px}@media (min-width:1000px){.pyramid__builder .pyramid__builder__additional-pyramid-box{left:30%}}@media (min-width:1441px){.pyramid__builder .pyramid__builder__additional-pyramid-box{left:37%}}@media (min-width:1590px){.pyramid__builder .pyramid__builder__additional-pyramid-box{left:43%}}@media (min-width:1700px){.pyramid__builder .pyramid__builder__additional-pyramid-box{left:43%}}.pyramid__builder.open{display:block}.pyramid__builder-body{position:relative}.pyramid__builder-body:before{content:\"\";position:absolute;width:100000px;left:-50000px;bottom:0;height:10000px;z-index:-1}.pyramid__builder .flex>div{width:50%;padding:25px}.pyramid__builder textarea{border:2px solid #fff;border-radius:10px;background:#0968ac;color:#fff;padding:10px;font-family:Nexa-Bold,sans pro,\"serif\"!important;margin-left:0}.pyramid__builder textarea::-webkit-input-placeholder{color:#fff}.pyramid__builder textarea::-moz-placeholder{color:#fff}.pyramid__builder textarea:-ms-input-placeholder{color:#fff}.pyramid__builder textarea:-moz-placeholder{color:#fff}.pyramid__builder textarea:focus:focus:-moz-placeholder{color:transparent}.pyramid__builder textarea:focus:-ms-input-placeholder{color:transparent}.pyramid__builder textarea:focus::-webkit-input-placeholder{color:transparent}.pyramid__builder .pyramid__builder-situation{height:300px}.pyramid__builder .pyramid__builder-r__situation{margin-top:102px}.pyramid__builder .pyramid__builder-r{position:relative}.pyramid__builder .r__arrow-1{left:24%;transform:rotate(40deg)}.pyramid__builder .r__arrow-1,.pyramid__builder .r__arrow-2{width:162px;position:absolute;height:2px;background:#fff;top:120px}.pyramid__builder .r__arrow-2{right:24%;transform:rotate(-40deg)}.pyramid__builder-wrapper{background:#0968ac;height:100%;overflow:hidden}.pyramid__builder--open{overflow:hidden}.pyramid__builder .tabs{display:flex;background:#fff;left:0;top:0;right:0;position:fixed;z-index:100}.pyramid__builder .tabs .tabs-logo,.pyramid__builder .tabs .tabs-text{display:inline-block;vertical-align:middle;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:180px}.pyramid__builder .tabs .tabs-text{margin-top:5px}.pyramid__builder .tabs .tabs-logo{margin-right:7px}.pyramid__builder .tabs .tab__title{font-size:.85rem}.pyramid__builder .tabs .tab__title_close{position:absolute;right:2px;top:0;z-index:5;font-size:1.5rem;font-weight:400;font-family:Arial}.pyramid__builder .tabs .tab__title_close:hover{color:red}.pyramid__builder .tabs li{min-width:250px;text-align:center;display:flex;flex:0;align-items:center;justify-content:center;height:50px;border-radius:10px 10px 0 0;border:2px solid #fff;border-bottom:none;margin-left:-5px;background:#4f8ebc;box-shadow:inset 0 -1px 5px -2px #000}.pyramid__builder .tabs li.active{box-shadow:none}.pyramid__builder .tabs li.active,.pyramid__builder .tabs li:hover{background:#0968ac}.pyramid__builder .tabs li:first-of-type{margin-left:0;z-index:2}.pyramid__builder .tabs li:nth-child(2){z-index:1}.pyramid__builder .tabs li:nth-child(3){z-index:0}.pyramid__builder .tabs li a{width:100%;height:100%;text-decoration:none;padding:10px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:#fff;position:relative}.pyramid__builder .tabs li input{display:inline-block;margin:0;background:none;border:none;width:145px;font-size:16px;line-height:22px;color:#fff;font-family:Nexa-Bold,sans pro,\"serif\"!important}.pyramid__builder .tab-content{padding-top:35px;transform-origin:0 0;width:100%;margin:0 auto}.pyramid__builder-tree__diagram{position:relative}.pyramid__builder-scq{display:flex;flex-direction:column;align-items:flex-end}.pyramid__builder-scqWrap{width:50%}.pyramid__builder-scq-header{width:60%;margin-bottom:-2px}.pyramid__builder-scq-header p{padding:3px 9px;width:fit-content;border-radius:8px;font-size:16px;font-family:Nexa-Bold,sans pro,\"serif\";background:#fff;color:#050e61}.pyramid__builder-scq__box-title{position:absolute;top:15px;left:20px;color:#fff}.pyramid__builder-scq__box{position:relative;margin-bottom:30px}.pyramid__builder-scq__box textarea{padding-left:46px}", ""]);
	
	// exports


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(2);
	
	var angular = _interopRequireWildcard(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _ngstorage = __webpack_require__(90);
	
	var _ngstorage2 = _interopRequireDefault(_ngstorage);
	
	var _blocks = __webpack_require__(91);
	
	var _blocks2 = _interopRequireDefault(_blocks);
	
	var _core = __webpack_require__(275);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _services = __webpack_require__(456);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _modules = __webpack_require__(498);
	
	var _modules2 = _interopRequireDefault(_modules);
	
	var _components = __webpack_require__(846);
	
	var _components2 = _interopRequireDefault(_components);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	angular.module('minto', ['minto.services', 'minto.modules', 'minto.components', 'minto.blocks', 'minto.core']).run(["$rootScope", "$location", "$window", function ($rootScope, $location, $window) {
	  // track routes
	  $rootScope.$watch('userId', function () {
	    $window.ga('create', 'UA-159953041-1', 'auto', {
	      userId: $rootScope.userId
	    });
	    $window.ga('send', 'pageview', { page: $location.path() });
	  });
	  $rootScope.$on('$locationChangeSuccess', function (event) {
	    if (!$window.ga) return;
	
	    $window.ga('send', 'pageview', { page: $location.path() });
	  });
	}]);

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _notes = __webpack_require__(92);
	
	var _notes2 = _interopRequireDefault(_notes);
	
	var _courseHeader = __webpack_require__(94);
	
	var _courseHeader2 = _interopRequireDefault(_courseHeader);
	
	var _paper = __webpack_require__(98);
	
	var _paper2 = _interopRequireDefault(_paper);
	
	var _plainText = __webpack_require__(100);
	
	var _plainText2 = _interopRequireDefault(_plainText);
	
	var _diagramComplete = __webpack_require__(102);
	
	var _diagramComplete2 = _interopRequireDefault(_diagramComplete);
	
	var _unitFinish = __webpack_require__(104);
	
	var _unitFinish2 = _interopRequireDefault(_unitFinish);
	
	var _highliteWord = __webpack_require__(215);
	
	var _highliteWord2 = _interopRequireDefault(_highliteWord);
	
	var _courseVideo = __webpack_require__(216);
	
	var _courseVideo2 = _interopRequireDefault(_courseVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var blocks = _angular2.default.module('minto.blocks', []);
	
	blocks.directive('notes', _notes2.default);
	blocks.directive('courseHeader', ['authService', '$state', _courseHeader2.default]);
	blocks.directive('paper', _paper2.default);
	blocks.directive('plainText', _plainText2.default);
	blocks.directive('diagramComplete', _diagramComplete2.default);
	blocks.component('unitFinish', _unitFinish2.default);
	blocks.component('courseVideo', _courseVideo2.default);
	blocks.directive('highliteWord', _highliteWord2.default);
	
	exports.default = blocks;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _notesPartial = __webpack_require__(93);
	
	var _notesPartial2 = _interopRequireDefault(_notesPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	        template: _notesPartial2.default
	    };
	};

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "<div class='memo-note'>\n    <p ng-transclude></p>\n</div>x\n"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _courseHeaderPartial = __webpack_require__(95);
	
	var _courseHeaderPartial2 = _interopRequireDefault(_courseHeaderPartial);
	
	__webpack_require__(96);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HELP_IDS_CONSTANTS = {
	  // 1
	  imposingTheStructure: 'imposing-the-structure',
	  pickingOutThePoints: 'cementing-the-rules',
	  cementingTheRules: 'picking-out-the-points',
	  graspingTheMessage: 'grasping-the-message',
	  // 2
	  ideasFitTogether: 'ideas-fit-together',
	  creatingQuestion: 'creating-question',
	  // 3
	  deductiveReasoning: 'deductive-reasoning',
	  summarizingDeductive: 'summarizing-deductive',
	  unearthingEmbeddedArguments: 'unearthing-embedded-arguments',
	  inductiveReasoning: 'inductive-reasoning',
	  identifyingInductivePoints: 'identifying-inductive-points',
	  inductionFromDeduction: 'induction-from-deduction',
	  deductionToInduction: 'deduction-to-induction',
	  avoidingDeductiveArguments: 'avoiding-deductive-arguments',
	  // 4
	  practiceInSeeing: 'practice-in-seeing',
	  findingReadersQuestion: 'finding-readers-question',
	  spottingSCQ: 'spotting-scq',
	  applyingSCQProcess: 'applying-scq-process',
	  practiceInSeeing3: 'practice-in-seeing-3',
	  // 5
	  defineProblem: 'define-problem',
	  practiceDefiningProblem: 'practice-defining-problem',
	  definingMoreComplexProblems: 'defining-more-complex-problems',
	  writingAGoodProposal: 'writing-a-good-proposal'
	};
	
	exports.default = function (authService, $state) {
	
	  return {
	    scope: {
	      bg: '@',
	      hideLogo: '@'
	    },
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    link: function link(scope) {
	      scope.logout = function () {
	        authService.logOut();
	      };
	
	      scope.showTestDrivePopup = false;
	      scope.togglePopup = function () {
	        scope.showTestDrivePopup = !scope.showTestDrivePopup;
	      };
	
	      scope.openOption = null;
	      scope.showNavigationPanel = false;
	      scope.toogleNavigationPanel = function (option) {
	        if (scope.openOption !== option && scope.showNavigationPanel) {
	          scope.openOption = option;
	        } else {
	          scope.openOption = option;
	          scope.showNavigationPanel = !scope.showNavigationPanel;
	        }
	      };
	
	      scope.handleUrlChange = function (option) {
	        if (scope.openOption === 'nav') {
	          $state.go('course.' + option);
	        } else {
	          if ($state.current.name === 'site.help') {
	            document.getElementById(HELP_IDS_CONSTANTS[option]).scrollIntoView({
	              behavior: "smooth"
	            });
	          } else {
	            $state.go('site.help', { sectionId: HELP_IDS_CONSTANTS[option], prevRoute: $state.current.name });
	          }
	        }
	      };
	
	      scope.getActiveSection = function (routeName) {
	        return routeName === $state.current.name;
	      };
	
	      scope.bodyOpen = false;
	      scope.toggleNavBar = function () {
	        scope.bodyOpen = !scope.bodyOpen;
	        scope.showNavigationPanel = false;
	      };
	
	      scope.$watch('showNavigationPanel', function () {
	        if (scope.showNavigationPanel) {
	          scope.sectionsList = angular.element('.course__nav-panel__sections-wrapper');
	          scope.maxScroll = scope.sectionsList[0].offsetHeight - 90;
	
	          scope.sectionsList.bind('scroll', function (e) {
	            scope.currentScroll = e.delegateTarget.scrollTop;
	          });
	
	          var activeElement = scope.sectionsList.find('.active')[0];
	          var activeElementOffsetTop = activeElement ? activeElement.offsetTop - scope.sectionsList[0].offsetTop - 60 : 0;
	
	          switch (true) {
	            case activeElementOffsetTop <= 0:
	              scope.sectionsList.scrollTop(0);
	              break;
	            case activeElementOffsetTop >= scope.maxScroll:
	              scope.sectionsList.scrollTop(scope.maxScroll);
	              break;
	            default:
	              scope.sectionsList.scrollTop(activeElementOffsetTop);
	          }
	        }
	      });
	
	      scope.currentScroll = 0;
	      scope.scrollTo = function (direction) {
	        if (direction === 'up') {
	          var newScroll = scope.currentScroll - 15;
	          if (newScroll <= 0) {
	            scope.sectionsList.scrollTop(0);
	          } else {
	            scope.sectionsList.scrollTop(newScroll);
	          }
	        } else if (direction === 'down') {
	          var _newScroll = scope.currentScroll + 15;
	          if (_newScroll >= scope.maxScroll) {
	            scope.sectionsList.scrollTop(scope.maxScroll);
	          } else {
	            scope.sectionsList.scrollTop(_newScroll);
	          }
	        }
	      };
	    },
	    template: _courseHeaderPartial2.default
	  };
	};

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	module.exports = "<header class=\"unit-header\" id=\"top-header\">\n  <div class=\"course-nav-bar\">\n    <div class=\"course__nav-icon\" ng-click=\"toggleNavBar()\"></div>\n    <div class=\"course__nav\" ng-class=\"{menu__open: bodyOpen}\">\n      <div class=\"course__nav-body\" ng-show=\"bodyOpen\">\n        <a ui-sref=\"site.dashboard\">DASHBOARD</a>\n        <a ng-click=\"toogleNavigationPanel('nav')\" href=\"\">NAVIGATION</a>\n<!--        <a ui-sref=\"site.help({sectionId: 12324124})\" href=\"\">HELP</a>-->\n        <a ng-click=\"toogleNavigationPanel('help')\" href=\"\">HELP</a>\n        <a href=\"\" ng-click=\"togglePopup()\">DRIVE</a>\n        <img ng-click=\"logout()\" class=\"course__nav-body__logout\" src=\"/assets/images/logout-button.png\" />\n      </div>\n\n      <div class=\"course__nav-panel\" ng-show=\"bodyOpen && showNavigationPanel\">\n        <div ng-click=\"scrollTo('up')\" class=\"course__nav-panel__arrow-wrapper\">\n          <div class=\"course__nav-panel__top-arrow\"></div>\n        </div>\n        <div class=\"course__nav-panel__sections-wrapper\">\n          <span>1. The Basic Pyramid</span>\n          <ul>\n            <li><span ng-class=\"{'active': getActiveSection('course.imposingTheStructure')}\" ng-click=\"handleUrlChange('imposingTheStructure')\">1A. Imposing The Structure</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.pickingOutThePoints')}\" ng-click=\"handleUrlChange('pickingOutThePoints')\">1B. Cementing The Rules</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.cementingTheRules')}\" ng-click=\"handleUrlChange('cementingTheRules')\">1C. Picking Out The Points</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.graspingTheMessage')}\" ng-click=\"handleUrlChange('graspingTheMessage')\">1D. Grasping The Message</span></li>\n          </ul>\n          <span>2. How The Ideas Fit Together</span>\n          <ul>\n            <li><span ng-class=\"{'active': getActiveSection('course.ideasFitTogether')}\" ng-click=\"handleUrlChange('ideasFitTogether')\">2A. Ideas Fit Together</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.creatingQuestion')}\" ng-click=\"handleUrlChange('creatingQuestion')\">2B. Creating Question</span></li>\n          </ul>\n          <span>3. Presenting the Reasoning</span>\n          <ul>\n            <li><span ng-class=\"{'active': getActiveSection('course.deductiveReasoning')}\" ng-click=\"handleUrlChange('deductiveReasoning')\">3A1. Deductive Reasoning</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.summarizingDeductive')}\" ng-click=\"handleUrlChange('summarizingDeductive')\">3A2. Summarizing Deductive</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.unearthingEmbeddedArguments')}\" ng-click=\"handleUrlChange('unearthingEmbeddedArguments')\">3A3. Unearthing Embedded Arguments</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.inductiveReasoning')}\" ng-click=\"handleUrlChange('inductiveReasoning')\">3B1. Inductive Reasoning</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.identifyingInductivePoints')}\" ng-click=\"handleUrlChange('identifyingInductivePoints')\">3B2. Identifying Inductive Points</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.inductionFromDeduction')}\" ng-click=\"handleUrlChange('inductionFromDeduction')\">3B3. Induction From Deduction</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.deductionToInduction')}\" ng-click=\"handleUrlChange('deductionToInduction')\">3B4. Deduction To Induction</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.avoidingDeductiveArguments')}\" ng-click=\"handleUrlChange('avoidingDeductiveArguments')\">3C. Avoiding Deductive Arguments</span></li>\n          </ul>\n          <span>4. How to Write an Introduction</span>\n          <ul>\n            <li><span ng-class=\"{'active': getActiveSection('course.practiceInSeeing')}\" ng-click=\"handleUrlChange('practiceInSeeing')\">4A. Practice In Seeing</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.findingReadersQuestion')}\" ng-click=\"handleUrlChange('findingReadersQuestion')\">4B1. Finding Readers Question</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.spottingSCQ')}\" ng-click=\"handleUrlChange('spottingSCQ')\">4B2. Spotting SCQ</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.applyingSCQProcess')}\" ng-click=\"handleUrlChange('applyingSCQProcess')\">4C1. Applying SCQ Process</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.practiceInSeeing3')}\" ng-click=\"handleUrlChange('practiceInSeeing3')\">4C2. Practice In Seeing 2</span></li>\n          </ul>\n          <span>5. How to Define a Problem</span>\n          <ul>\n            <li><span ng-class=\"{'active': getActiveSection('course.defineProblem')}\" ng-click=\"handleUrlChange('defineProblem')\">5A. Define Problem</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.practiceDefiningProblem')}\" ng-click=\"handleUrlChange('practiceDefiningProblem')\">5B. Practice Defining Problem</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.definingMoreComplexProblems')}\" ng-click=\"handleUrlChange('definingMoreComplexProblems')\">5C. Defining More Complex Problems</span></li>\n            <li><span ng-class=\"{'active': getActiveSection('course.writingAGoodProposal')}\" ng-click=\"handleUrlChange('writingAGoodProposal')\">5D. Writing A Good Proposal</span></li>\n          </ul>\n          <span><a ui-sref=\"graduation\" class=\"course__nav-panel_graduation\">Graduation</a></span>\n        </div>\n        <div ng-click=\"scrollTo('down')\" style=\"bottom: 0\" class=\"course__nav-panel__arrow-wrapper\">\n          <div class=\"course__nav-panel__bottom-arrow\"></div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <test-drive-popup ng-if=\"showTestDrivePopup\" on-close=\"togglePopup()\" />\n\n  <div ng-if=\"!hideLogo\" class=\"header-box wrapper\">\n    <a class=\"header-logo\" ui-sref=\"site.dashboard\" ng-include src=\"'/assets/images/minto_logo_white.svg'\"></a>\n    <div ng-transclude class=\"unit-info\"></div>\n  </div>\n</header>\n"

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(97);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./courseHeader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./courseHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit-header{min-height:205px;position:relative}.unit-header .course-nav-bar{position:fixed;padding:45px 0;width:115px;top:0;bottom:0;z-index:100}.unit-header .header-box{max-width:1070px}.unit-header .header-logo{float:left;width:124px;height:99px;margin:64px 60px 20px 74px}.unit-header .unit-info{padding:44px 0 0}.unit-header .unit-info .unit-name{font-size:45px;letter-spacing:1.6px;margin-bottom:35px}.unit-header .unit-info .unit-title{display:block;margin-top:7px;color:#fff;line-height:50px}.unit-header .course__nav{display:flex;position:absolute;padding:45px 0;width:116px;top:0;left:-120px;bottom:0;z-index:100;transition-duration:1s}.unit-header .course__nav-panel{margin-left:9px;height:85%;background-color:#293449;position:absolute;left:107px}.unit-header .course__nav-panel__arrow-wrapper{border:2px solid #fff;padding:5px 0;cursor:pointer;position:absolute;width:100%}.unit-header .course__nav-panel__bottom-arrow,.unit-header .course__nav-panel__top-arrow{height:0;width:0;margin:0 auto}.unit-header .course__nav-panel__top-arrow{border-bottom:17px solid #fff;border-right:17px solid transparent;border-left:17px solid transparent}.unit-header .course__nav-panel__bottom-arrow{border-top:17px solid #fff;border-right:17px solid transparent;border-left:17px solid transparent}.unit-header .course__nav-panel_graduation{color:#fff;text-decoration:none;margin-bottom:16px;display:block}.unit-header .course__nav-panel__sections-wrapper{overflow-y:scroll;padding:1em 10px 0;margin-bottom:31px;margin-top:31px;max-height:-webkit-fill-available}.unit-header .course__nav-panel__sections-wrapper::-webkit-scrollbar{width:0!important}.unit-header .course__nav-panel__sections-wrapper span{color:#fff;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";width:max-content;white-space:nowrap}.unit-header .course__nav-panel__sections-wrapper ul{list-style:none;margin-block-start:7px;padding-inline-start:20px}.unit-header .course__nav-panel__sections-wrapper ul li span{width:max-content;white-space:nowrap;text-decoration:none;color:#fff;font-size:13px;cursor:pointer;font-family:Nexa-Bold,sans pro,\"serif\"}.unit-header .course__nav-panel__sections-wrapper .active{color:#2795be}.unit-header .course__nav.menu__open{background:#293449}.unit-header .course__nav-icon{background-image:url(/assets/images/burger.png);width:55px;height:35px;margin:0 auto;cursor:pointer;background-repeat:no-repeat;z-index:999;position:relative}.unit-header .course__nav.menu__open{z-index:102;left:0;transition-duration:1s}.unit-header .course__nav-body{margin-top:100px;display:flex;flex-direction:column;height:88%}.unit-header .course__nav-body a{height:25%;text-decoration:none;display:flex;align-items:flex-end;padding-left:10px;padding-bottom:5px;color:#fff;font-size:15px}.unit-header .course__nav-body__logout{width:50px;margin:90% auto 20px;cursor:pointer}.unit-header .course__nav-body .course__nav{position:fixed;padding:45px 0;width:115px;top:0;bottom:0;z-index:100}.unit-header .course__nav-body .course__na v.menu__open{background:#293449}.unit-header .course__nav-body .course__nav-icon{background-image:url(/assets/images/burger.png);width:55px;height:35px;margin:0 auto;cursor:pointer}.unit-header .course__nav-body .course__nav-body{margin-top:100px;display:flex;flex-direction:column;height:75%}.unit-header .course__nav-body .course__nav-body a{height:25%;text-decoration:none;display:flex;align-items:flex-end;padding-left:20px;padding-bottom:5px;color:#fff}.unit-header .course__nav-body .course__nav-body a:first-child{background:#00a99d}.unit-header .course__nav-body .course__nav-body a:nth-child(2){background:#00aeef}.unit-header .course__nav-body .course__nav-body a:nth-child(3){background:#0072bc}.unit-header .course__nav-body .course__nav-body a:nth-child(4){background:#0054a6}", ""]);
	
	// exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _paperPartial = __webpack_require__(99);
	
	var _paperPartial2 = _interopRequireDefault(_paperPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	        template: _paperPartial2.default
	    };
	};

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"memo-paper\" ng-transclude></div>\n"

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _plainTextPartial = __webpack_require__(101);
	
	var _plainTextPartial2 = _interopRequireDefault(_plainTextPartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return {
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	        template: _plainTextPartial2.default
	    };
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	module.exports = "<div ng-transclude></div>\n"

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _diagramCompletePartial = __webpack_require__(103);
	
	var _diagramCompletePartial2 = _interopRequireDefault(_diagramCompletePartial);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	
	    return {
	        scope: {
	            completeTitle: '<',
	            nextTitle: '<'
	        },
	        restrict: 'E',
	        replace: true,
	        transclude: true,
	        template: _diagramCompletePartial2.default
	    };
	};

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	module.exports = "<!-- Need to pass course and exercise number here to make proper id and classes (?) -->\n<div class=\"submit\">\n  <button class=\"submit-exercise-button\" ng-bind=\"completeTitle | translate\"></button>\n  <button class=\"next-exercise-button anchor\" ng-bind=\"nextTitle | translate\"></button>\n</div>"

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _unitFinishPartial = __webpack_require__(105);
	
	var _unitFinishPartial2 = _interopRequireDefault(_unitFinishPartial);
	
	var _unitFinish = __webpack_require__(106);
	
	var _unitFinish2 = _interopRequireDefault(_unitFinish);
	
	__webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unitFinish = {
	    bindings: {
	        congratulationMessage: '<',
	        finishSection: '<',
	        finalDescription: '<',
	        nextCourseButton: '<',
	        dashboardButton: '<',
	        nextCourse: '<',
	        nextCourseDisabled: '<',
	        showMessage: '<',
	        currentCourseLastDiagramId: '<',
	        onButtonClick: '&'
	    },
	    controllerAs: 'vm',
	    template: _unitFinishPartial2.default,
	    controller: _unitFinish2.default,
	    transclude: true
	};
	
	exports.default = unitFinish;

/***/ }),
/* 105 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit-wrapper unit-finish\">\n  <div class=\"finish\" id=\"final-section\">\n    <span class=\"congratulation-message\" ng-bind=\"vm.congratulationMessage | translate\">imposing-the-structure.congratulation-message</span>\n    <span class=\"finish-section\" ng-bind=\"vm.finishSection | translate\">imposing-the-structure.finish-section</span>\n    <span class=\"final-description\" ng-bind-html=\"vm.finalDescription | translate\">imposing-the-structure.final-description</span>\n  </div>\n  <ng-transclude></ng-transclude>\n  <ul>\n    <li>\n      <a ui-sref=\"{{ vm.nextCourse }}\"\n         ng-click=\"vm.onButtonClick()\"\n         ng-class=\"{'finish-button__disabled': vm.nextCourseDisabled}\"\n         class=\"finish-button\" ng-bind=\"vm.nextCourseButton | translate\">imposing-the-structure.next-course-button</a>\n    </li>\n    <li>\n      <a ui-sref=\"site.dashboard\" ng-click=\"vm.onButtonClick()\" class=\"finish-button\" ng-bind=\"vm.dashboardButton | translate\">imposing-the-structure.dashboard-button</a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unitFinish = function (_CourseController) {
	  unitFinish.$inject = ["courseService", "diagramService"];
	  (0, _inherits3.default)(unitFinish, _CourseController);
	
	  function unitFinish(courseService, diagramService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, unitFinish);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (unitFinish.__proto__ || (0, _getPrototypeOf2.default)(unitFinish)).call(this, courseService, diagramService));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1d1-5';
	    _this.submitBtn = 'diagram1d1-5-submit';
	    _this.nextBtn = 'diagram1d1-final-next';
	    _this.diagramNumber = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(unitFinish, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }, {
	    key: 'emitButtonClick',
	    value: function emitButtonClick() {
	      this;
	    }
	  }]);
	  return unitFinish;
	}(_course2.default);
	
	exports.default = unitFinish;

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _from = __webpack_require__(197);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _keys = __webpack_require__(206);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _extends2 = __webpack_require__(209);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(210);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _uiHelper = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CourseController = function () {
	    CourseController.$inject = ["courseService", "diagramService", "$translate"];
	    function CourseController(courseService, diagramService, $translate) {
	        'ngInject';
	
	        var $scope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	        (0, _classCallCheck3.default)(this, CourseController);
	        (0, _assign2.default)(this, { diagramService: diagramService, courseService: courseService, $translate: $translate, $scope: $scope });
	
	        // this.courseService.getDiagramContainer()
	        //   .then(data => {
	        //     this.diagramData = data[this.diagramId] || {attempts: 0};
	        //     // this.diagramData.complete = true;
	        //
	        //     if (this.diagramData.complete) {
	        //       this.autocomlete(true);
	        //     }
	        //
	        //   });
	        this.showAnswer = false;
	        this.introCounted = false;
	        this.unitStart = Date.now();
	        this.lastTimeStamp = this.unitStart;
	        this.submitTitle = 'submit';
	        this.isActivePyramidBuilderDemo = false;
	        this.hintCount = 0;
	        this.submitCount = 0;
	        // this.commonHintCount = 0
	        // this.commonSubmitCount = 0
	        this.complexExercises = {};
	        this.isCompleted = {};
	    }
	
	    (0, _createClass3.default)(CourseController, [{
	        key: 'sendStatistic',
	        value: function sendStatistic(data) {
	            var finishedTime = Date.now();
	            var exerciseNumber = data.diagram.replace(this.exerciseIdsStart, '');
	            var exercise = this.courseData.exercises.find(function (i) {
	                return i.name === exerciseNumber.split('_')[0];
	            });
	            if (exercise.isCompleted) {
	                return;
	            }
	            var isParts = exerciseNumber.includes('_');
	            // this.commonHintCount += data.hintsUsed
	            // this.commonSubmitCount += data.attempts
	            if (isParts) {
	                var generalExercise = this.complexExercises[exercise.id] || {};
	                generalExercise.attempts = (generalExercise.attempts ? generalExercise.attempts : 0) + data.attempts;
	                generalExercise.hintsUsed = (generalExercise.hintsUsed ? generalExercise.hintsUsed : 0) + data.hintsUsed;
	                generalExercise.rightAnswers = 1;
	                this.complexExercises[exercise.id] = generalExercise;
	
	                var exerciseParts = exerciseNumber.split('_')[1].split('-');
	                if (exerciseParts[0] === exerciseParts[1]) {
	                    var params = {
	                        statisticableId: exercise.id,
	                        statisticableType: 'Exercise',
	                        secondsSpent: Math.floor((finishedTime - this.lastTimeStamp) / 1000),
	                        completed: true,
	                        attempts: generalExercise.attempts,
	                        hintsUsed: generalExercise.hintsUsed,
	                        rightAnswers: 1
	                    };
	                    this.lastTimeStamp = finishedTime;
	                    this.courseService.sendUserStatistic(params);
	                    exercise.isCompleted = true;
	                    if (data.userAnswers) {
	                        var _params = {
	                            exerciseId: exercise.id,
	                            value: (0, _stringify2.default)(data.userAnswers)
	                        };
	                        this.courseService.sendUserAnswers(_params);
	                        exercise.userAnswers = data.userAnswers;
	                    }
	                }
	            } else {
	                var _params2 = {
	                    statisticableId: exercise.id,
	                    statisticableType: 'Exercise',
	                    secondsSpent: Math.floor((finishedTime - this.lastTimeStamp) / 1000),
	                    completed: true,
	                    attempts: data.attempts || 0,
	                    hintsUsed: data.hintsUsed || 0,
	                    rightAnswers: 1
	                };
	                this.lastTimeStamp = finishedTime;
	                this.courseService.sendUserStatistic(_params2);
	                exercise.isCompleted = true;
	                if (data.userAnswers) {
	                    var _params3 = {
	                        exerciseId: exercise.id,
	                        value: (0, _stringify2.default)(data.userAnswers)
	                    };
	                    this.courseService.sendUserAnswers(_params3);
	                    exercise.userAnswers = data.userAnswers;
	                } else {
	                    var _params4 = {
	                        exerciseId: exercise.id,
	                        value: (0, _stringify2.default)(data)
	                    };
	                    this.courseService.sendUserAnswers(_params4);
	                }
	            }
	        }
	    }, {
	        key: 'onFinishExercise',
	        value: function onFinishExercise(exId, userAnswer) {
	            if (exId === '0') return;
	            var exercise = this.courseData.exercises.find(function (item) {
	                return item.name === exId;
	            });
	            if (exercise.isCompleted) {
	                return;
	            }
	            var finishTime = Date.now();
	            var params = {
	                statisticableId: exercise.id,
	                statisticableType: 'Exercise',
	                secondsSpent: Math.floor((finishTime - this.lastTimeStamp) / 1000),
	                completed: true,
	                attempts: this.complexExercises[exId].attempts,
	                hintsUsed: this.complexExercises[exId].hintsUsed,
	                rightAnswers: 1
	            };
	            this.courseService.sendUserStatistic(params);
	            this.lastTimeStamp = finishTime;
	            exercise.isCompleted = true;
	
	            if (userAnswer) {
	                var _params5 = {
	                    exerciseId: exercise.id,
	                    value: (0, _stringify2.default)(userAnswer)
	                };
	                this.courseService.sendUserAnswers(_params5);
	                exercise.userAnswers = userAnswer;
	            } else if (this.complexExercises[exId].pyramidBuilderAnswer) {
	                var _params6 = {
	                    exerciseId: exercise.id,
	                    value: (0, _stringify2.default)((0, _extends3.default)({}, this.complexExercises[exId].pyramidBuilderAnswer, {
	                        fullwordingIntroduction: this.complexExercises[exId].fullwordingIntroduction
	                    }))
	                };
	                this.courseService.sendUserAnswers(_params6);
	                exercise.userAnswers = userAnswer;
	            }
	        }
	    }, {
	        key: 'savePyramidBuilderData',
	        value: function savePyramidBuilderData(data) {
	            if (this.isActivePyramidBuilderDemo) return;
	            this.enablePyramidBuilter = data.exerciseNumber;
	            this.pyramidData = data;
	        }
	    }, {
	        key: '$onDestory',
	        value: function $onDestory() {
	            $(window).off('scroll');
	        }
	    }, {
	        key: '$onInit',
	        value: function $onInit() {
	            var _this = this;
	
	            if (this.userExerciseAnswers && !this.isUnit) {
	                var interval = setInterval(function () {
	                    var model = _this.userExerciseAnswers[_this.clearDiagramId || _this.diagramId.split('-')[1]];
	
	                    if (model && (0, _keys2.default)(model).length) {
	                        console.log("model is", _this.clearDiagramId || _this.diagramId.split('-')[1], model);
	
	                        if (_this.deductiveSpecialModel) {
	                            console.log("deductive model");
	                            (0, _keys2.default)(model).forEach(function (key) {
	                                var element = $(document.querySelector('#' + _this.diagramId + ' #element_' + model[key]));
	
	                                element.addClass('element-list_drop');
	                                element.addClass('element-list_drop-slot_' + key);
	                                if (_this.correctElementStyled) {
	                                    (0, _keys2.default)(_this.correctElementStyled).forEach(function (key) {
	                                        element.css(key, _this.correctElementStyled[key]);
	                                    });
	                                }
	
	                                element.position({
	                                    my: 'center',
	                                    at: 'center',
	                                    of: $('#' + _this.diagramId + ' #slot_' + key),
	                                    using: function using(position) {
	                                        $(this).animate(position, 0, 'linear');
	                                    }
	                                });
	                            });
	                        } else if (_this.isSCQ) {
	                            _this.data.blocks.forEach(function (block) {
	                                block.userAnswer = model[block.modelName];
	                                block.model = block.answer;
	                            });
	                            (0, _assign2.default)(_this.model, model);
	                            _this.$scope.$apply();
	                            setTimeout(function () {
	                                _this.showPaperAnswer(_this.diagramId);
	                                if (_this.isUserAnswerBigger) {
	                                    _this.expandUserAnswer(_this.diagramId);
	                                }
	                                _this.$scope.$apply();
	                            }, 500);
	                        } else if (_this.isStepDiagram) {
	                            _this.currentStateNumber = parseInt(model.number.text);
	                            (0, _assign2.default)(_this, model);
	                            _this.changeState();
	                            _this.$scope.$apply();
	                        } else if (_this.fullWordingOfIntroduction) {
	                            _this.userAnswerInput = model.fullwordingIntroduction;
	                        } else {
	                            (0, _assign2.default)(_this.model, model);
	                            _this.$scope.$apply();
	                        }
	                        clearInterval(interval);
	                    }
	                }, 500);
	            }
	            if (this.finishedExercises) {
	                var _interval = setInterval(function () {
	                    if (_this.diagramComplete) {
	                        clearInterval(_interval);
	                        return;
	                    }
	
	                    _this.diagramComplete = _this.finishedExercises[_this.clearDiagramId || _this.diagramId.split('-')[1]];
	                    if (_this.diagramComplete) {
	                        _this.diagramCompleteOnce = true;
	                        _this.edit = true;
	                        _this.showAnswer = true;
	                        _this.submited = true;
	                        _this.showFixedAnswers = true;
	                        _this.paperAnswer = true;
	                        _this.firstPartCompleted = true;
	                        _this.secondPartCompleted = true;
	                        _this.scrollDone = true;
	                        _this.movePoints = true;
	                        _this.showMintoIntroduction = true;
	                        _this.buttonText = 'VIEW YOUR TEXT';
	                        _this.isStatic = true;
	                        clearInterval(_interval);
	                        if (_this.checkboxes) {
	                            (0, _assign2.default)(_this.userAnswers, _this.correctAnswers);
	                        } else if (_this.radioButtons) {
	                            _this.userAnswer = _this.correctAnswer;
	                        } else if (_this.radioButtonGroups) {
	                            _this.userAnswers = _.cloneDeep(_this.correctAnswers);
	                        } else if (_this.fixedAnswersDiagram) {
	                            var input = document.querySelector('#' + _this.diagramId + ' input[data-answer="true"]');
	                            if (input) {
	                                input.click();
	                            }
	                            $('#' + _this.diagramId + ' .element').each(function () {
	                                $(this).draggable('disable');
	                            });
	                            _this.autocomlete(true);
	                        } else if (_this.scqDiagram) {
	                            _this.data.answers.forEach(function (item) {
	                                var element = $(document.querySelector('#' + _this.diagramId + ' .simplest__structure-answer[data-index="' + item.index + '"]'));
	
	                                element.addClass('simplest__structure-answer--dropped');
	
	                                var target = $('#' + _this.diagramId + ' .simplest__structure-box-styles[data-index="' + item.index + '"]');
	                                element.css({ width: target.width(), height: target.height() });
	
	                                element.position({
	                                    my: 'center',
	                                    at: 'center',
	                                    of: $('#' + _this.diagramId + ' .simplest__structure-box-styles[data-index="' + item.index + '"]'),
	                                    using: function using(position) {
	                                        $(this).animate(position, 0, 'linear');
	                                    }
	                                });
	                            });
	                        } else if (_this.isFiveSection) {
	                            var parent = document.getElementById(_this.diagramId);
	                            _this.data.answers.forEach(function (item) {
	                                var elementWithoutJQ = parent.querySelector('.simplest__structure-answer[data-index="' + item.answer + '"]');
	                                var element = $(elementWithoutJQ);
	
	                                element.addClass('simplest__structure-answer--dropped');
	
	                                var target = $(parent.querySelector('.simplest__structure-box[data-index*="' + item.answer + '"]:not(.simplest__structure-box--filled)'));
	                                element.css({ width: target.width(), height: target.height() });
	                                target.addClass('simplest__structure-box--filled');
	
	                                element.position({
	                                    my: 'center',
	                                    at: 'center',
	                                    of: target,
	                                    using: function using(position) {
	                                        $(this).animate(position, 0, 'linear');
	                                    }
	                                });
	
	                                // const textBox = elementWithoutJQ.querySelector('.box-title')
	                                var lineHeight = (0, _uiHelper.getLineHeight)(elementWithoutJQ);
	                                var rowsAmount = parseInt(Number(element.outerHeight() - lineHeight - 10) / lineHeight, 10);
	
	                                var boxTextBeforeHidden = element.find('.simplest__box-text').outerHeight();
	
	                                // Logic for arrow tooltip in the box
	                                if (boxTextBeforeHidden < element.outerHeight() - lineHeight - 10) {
	                                    element.find('.simplest__box-text').css({ height: '', overflow: '' });
	                                    element.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	                                } else {
	                                    element.find('.simplest__box-text').css({ height: rowsAmount * lineHeight, overflow: 'hidden' });
	                                    element.find('.simplest__arrow-button').css({ display: 'flex', 'justify-content': 'flex-end' });
	                                }
	                            });
	                            setTimeout(function () {
	                                if (parent.querySelector('.ui-draggable')) {
	                                    _this.diagramService.disableSCQDiagram(_this.diagramId);
	                                }
	                            }, 1000);
	                        } else if (!_this.deductiveSpecialModel && !_this.fullWordingOfIntroduction) {
	                            _this.autocomlete(true);
	                        }
	                        _this.$scope.$apply();
	                    }
	                }, 500);
	            }
	            setTimeout(function () {
	                if (_this.fixedAnswersDiagram) {
	
	                    _this.movePoints = false;
	                    _this.scrollDone = false;
	                }
	                if (_this.isUnit) {
	                    if (!_this.courseService.coursesData) {
	                        _this.courseService.getAll().then(function () {
	                            _this.courseData = _this.courseService.getCourseData();
	                            _this.courseDataReceived();
	                        });
	                    } else {
	                        _this.courseData = _this.courseService.getCourseData();
	                        _this.courseDataReceived();
	                    }
	                }
	                if (!_this.isUnit && !_this.fixedAnswersDiagram) {
	                    return;
	                }
	                $(window).bind('scroll', function () {
	                    var screenHeight = $(window).innerHeight();
	                    if (!_this.scrollDone && _this.fixedAnswersDiagram) {
	                        var firstFixedAnswer = document.querySelector('#' + _this.diagramId + ' .drag-element');
	                        var firstFixedAnswerPosition = $(firstFixedAnswer).offset().top - screenHeight + $(firstFixedAnswer).innerHeight() / 2;
	                        if (window.scrollY >= firstFixedAnswerPosition) {
	                            _this.scrollDone = true;
	                            _this.movePoints = true;
	                            _this.$scope.$apply();
	                            setTimeout(function () {
	                                _this.showFixedAnswers = true;
	                                _this.$scope.$apply();
	                            }, 1000);
	                        }
	                    }
	                    if (_this.isUnit && !_this.introCounted && _this.courseData) {
	                        var firstExercisePosition = document.querySelector('#exercise-1');
	                        var yPosMax = screenHeight * 0.75;
	                        if (firstExercisePosition.getClientRects()[0].y <= yPosMax) {
	                            _this.lastTimeStamp = Date.now();
	                            _this.introCounted = true;
	                            _this.courseData.isCompleted = true;
	
	                            var params = {
	                                statisticableId: _this.courseData.id,
	                                statisticableType: 'UnitIntro',
	                                secondsSpent: Math.floor((_this.lastTimeStamp - _this.unitStart) / 1000),
	                                completed: true,
	                                attempts: 0,
	                                hintsUsed: 0,
	                                rightAnswers: 0
	                            };
	                            _this.courseService.sendUserStatistic(params);
	                        }
	                    }
	                });
	            }, 500);
	        }
	    }, {
	        key: 'onSectionFinish',
	        value: function onSectionFinish() {
	            // if (this.courseData.isCompleted) {
	            //   return
	            // }
	            // const params = {
	            //   statisticableId: this.courseData.unit_id,
	            //   statisticableType: 'Unit',
	            //   secondsSpent: Math.floor((Date.now() - this.unitStart) / 1000),
	            //   completed: true,
	            //   attempts: this.commonSubmitCount,
	            //   hintsUsed: this.commonHintCount,
	            //   rightAnswers: 0
	            // }
	            // this.courseService.sendUserStatistic(params)
	            this.courseData.isCompleted = true;
	        }
	    }, {
	        key: '$onDestroy',
	        value: function $onDestroy() {
	            $(window).unbind('scroll');
	        }
	    }, {
	        key: 'courseDataReceived',
	        value: function courseDataReceived() {
	            var _this2 = this;
	
	            var countCompleted = function countCompleted() {
	                _this2.courseData.exercises.forEach(function (i) {
	                    _this2.isCompleted[i.name] = i.isCompleted;
	                    if (_this2.exerciseUserAnswers) {
	                        _this2.exerciseUserAnswers[i.name] = i.userAnswers;
	                    }
	                    if (_this2.highlightWords) {
	                        _this2.highlightWords['ex' + i.name] = i.isCompleted;
	                    }
	                });
	            };
	
	            if (!this.introCounted) {
	                this.introCounted = this.courseData.isCompleted;
	            }
	            countCompleted();
	            this.$scope.$watch('courseData', countCompleted, true);
	            if (this.isUnitFive) {
	                if (this.isCompleted['1']) {
	                    this.exercise2Show = true;
	                    if (this.exerciseUserAnswers['1']) {
	                        this.defineScqAnswers('exercise2', {
	                            x: {
	                                scq: this.exerciseUserAnswers['1']
	                            }
	                        }, 'x', true);
	                    }
	                }
	                if (this.isCompleted['2']) {
	                    this.exercise4Show = true;
	                    if (this.exerciseUserAnswers['2']) {
	                        this.defineScqAnswers('exercise4', {
	                            x: {
	                                scq: this.exerciseUserAnswers['2']
	                            }
	                        }, 'x', true);
	                    }
	                }
	                if (this.isCompleted['3']) {
	                    this.exercise6Show = true;
	                    if (this.exerciseUserAnswers['3']) {
	                        this.defineScqAnswers('exercise6', {
	                            x: {
	                                scq: this.exerciseUserAnswers['3']
	                            }
	                        }, 'x', true);
	                    }
	                }
	                if (this.isCompleted['4']) {
	                    this.exercise8Show = true;
	                    if (this.exerciseUserAnswers['4']) {
	                        this.defineScqAnswers('exercise8', {
	                            x: {
	                                scq: this.exerciseUserAnswers['4']
	                            }
	                        }, 'x', true);
	                    }
	                }
	                this.$scope.$apply();
	            }
	        }
	    }, {
	        key: 'autocomlete',
	        value: function autocomlete(instant) {
	            var _this3 = this;
	
	            this.courseService.play('buttonClick');
	            this.onHold = true;
	            this.diagramService.autocomplete(this.diagramId, instant).then(function () {
	                _this3.onHold = false;
	                _this3.diagramComplete = true;
	                _this3.diagramCompleteOnce = true;
	                _this3.courseService.play('exerciseComplete');
	                _this3.finishExercise();
	            });
	        }
	    }, {
	        key: 'reset',
	        value: function reset() {
	            var _this4 = this;
	
	            this.onHold = true;
	            this.diagramService.reset(this.diagramId).then(function () {
	                _this4.onHold = false;
	                _this4.diagramComplete = false;
	            });
	        }
	    }, {
	        key: 'hint',
	        value: function hint() {
	            this.hintCount++;
	            this.courseService.play('buttonClick');
	            if (this.checkboxes) {
	                this.checkCheckBoxesStatus(true);
	            } else if (this.radioButtons) {
	                this.checkRadioButtons(this.diagramId);
	            } else if (this.radioButtonGroups) {
	                this.radioButtonsGroup(this.diagramId);
	            } else if (this.highlightOnlyIncorect) {
	                var isBoxesCompleted = this.diagramService.highlightOnlyIncorectDragbleBoxes(this.diagramId);
	                var isRadiosCompleted = this.diagramService.checkRadioButtons(this.diagramId);
	                if (isBoxesCompleted && isRadiosCompleted) {
	                    this.submit();
	                }
	            } else {
	                var _isBoxesCompleted = this.diagramService.checkBoxHint(this.diagramId);
	                var _isRadiosCompleted = this.diagramService.checkRadioButtons(this.diagramId);
	                if (_isBoxesCompleted && _isRadiosCompleted) {
	                    this.submit();
	                }
	            }
	        }
	    }, {
	        key: 'hideAnswer',
	        value: function hideAnswer() {
	            this.showAnswer = false;
	            if (this.greyAnswers) {
	                var elements = document.querySelectorAll('#' + this.diagramId + ' .element-list_drop');
	                $(elements).css('background-color', '#a7dec3');
	            }
	        }
	    }, {
	        key: 'submit',
	        value: function submit() {
	            this.submitCount++;
	            if (this.demo) {
	                this.autocomlete();
	            } else if (this.checkboxes) {
	                this.checkCheckBoxesStatus();
	            } else if (this.simplist) {
	                this.showSimplistAnswers();
	            } else if (this.inducivedeductive) {
	                this.checkInduciveDeductive();
	            } else if (this.radioButtons) {
	                this.checkRadioButtons();
	            } else if (this.reveal) {
	                this.showAnswers();
	            } else if (this.radioButtonGroups) {
	                this.radioButtonsGroup();
	            } else if (this.deductive) {
	                this.revealDeductive();
	            } else if (this.fixedAnswersDiagram) {
	                this.submitFixedAnswersDiagram();
	            } else {
	                var diagramComplete = this.diagramService.checkDiagramAnswers(this.diagramId);
	                if (diagramComplete) {
	                    this.diagramComplete = diagramComplete;
	                    this.courseService.play('buttonClick');
	                    this.courseService.play('exerciseComplete');
	                    this.showAnswer = true;
	                    this.diagramCompleteOnce = true;
	                    if (this.greyAnswers) {
	                        var elements = document.querySelectorAll('#' + this.diagramId + ' .element-list_drop');
	                        $(elements).css('background-color', '#7b7b7b');
	                    }
	                    this.finishExercise();
	                } else {
	                    this.submitTitle = 'resubmit';
	                    this.diagramHint = true;
	                    this.courseService.play('wrongAnswer');
	                }
	            }
	            // this.updateDiagramStatus();
	        }
	    }, {
	        key: 'checkInduciveDeductive',
	        value: function checkInduciveDeductive(diagramId) {
	            var inputChaked = document.querySelectorAll('#' + this.diagramId + ' input:checked')[0];
	
	            if (!inputChaked) {
	                this.courseService.play('wrongAnswer');
	                return;
	            }
	
	            var isDiagramComplete = this.diagramService.checkDiagramAnswers(this.diagramId);
	            var correctCheckbox = inputChaked.getAttribute('data-answer') == 'true';
	
	            if (correctCheckbox && isDiagramComplete) {
	                this.courseService.play('buttonClick');
	                this.courseService.play('exerciseComplete');
	                this.finishExercise();
	                this.diagramCompleteOnce = true;
	                this.diagramComplete = true;
	            } else {
	                this.diagramHint = true;
	                this.submitTitle = 'resubmit';
	                this.courseService.play('wrongAnswer');
	            }
	        }
	    }, {
	        key: 'finishExercise',
	        value: function finishExercise() {
	            var _this5 = this;
	
	            if (this.deductiveSpecialModel) {
	                this.model = {};
	                var elements = document.querySelectorAll('#' + this.diagramId + ' .element-list_drop');
	                elements.forEach(function (elem) {
	                    var slotItem = elem.className.split(' ').filter(function (className) {
	                        return className.startsWith('element-list_drop-slot_');
	                    })[0].replace('element-list_drop-slot_', '');
	                    _this5.model[slotItem] = elem.id.replace('element_', '');
	                });
	            }
	            this.onFinish({
	                $event: {
	                    diagram: this.diagramId,
	                    attempts: this.submitCount,
	                    hintsUsed: this.hintCount,
	                    rightAnswers: 1,
	                    userAnswers: this.model
	                }
	            });
	        }
	    }, {
	        key: 'next',
	        value: function next() {
	            this.nextClicked = true;
	            this.courseService.play('buttonClick');
	            var nextElement = null;
	            if ($('#' + this.diagramId).parents('.diagram').next('.unit-wrapper').length) {
	                nextElement = $('#' + this.diagramId).parents('.diagram').next('.unit-wrapper');
	            } else {
	                if ($('#' + this.diagramId).parents('.diagram').parents('.exercise').length) {
	                    nextElement = $('#' + this.diagramId).parents('.diagram').parents('.exercise').next();
	                } else {
	                    nextElement = $('#' + this.diagramId).parents('.diagram').next();
	                }
	            }
	
	            $('html, body').animate({
	                scrollTop: nextElement.offset().top
	            }, 300);
	        }
	    }, {
	        key: 'updateDiagramStatus',
	        value: function updateDiagramStatus() {
	            this.diagramData.diagramCompleteOnce = this.diagramCompleteOnce;
	            this.diagramData.diagramComplete = this.diagramComplete;
	            this.diagramData.attempts++;
	            // this.courseService.updateDiagramContainer(this.diagramId, this.diagramData);
	        }
	    }, {
	        key: 'checkCheckBoxesStatus',
	        value: function checkCheckBoxesStatus(hint) {
	            var _this6 = this;
	
	            this.diagramService.checkDiagramCheckboxesAnswers(this.userAnswers, this.correctAnswers).then(function (data) {
	                // console.log(data);
	                _this6.diagramComplete = data.complete;
	                _this6.checkBoxMistakes = data.mistake;
	                _this6.checkBoxCorrect = data.correct;
	
	                if (!_this6.diagramForm.$pristine) {
	                    _this6.diagramHint = true;
	                }
	
	                _this6.correctIndex = data.correctIndex;
	                _this6.incorrectIndex = data.incorrectIndex;
	
	                for (var k in _this6.checkBoxMistakes) {
	                    _this6.diagramForm[k].$setValidity('answear', false);
	                }
	
	                for (var _k in _this6.checkBoxCorrect) {
	                    _this6.diagramForm[_k].$setValidity('answear', true);
	                }
	
	                if (hint && !_this6.diagramComplete) {
	                    _this6.diagramService.checkBoxHint(_this6.diagramId, _this6.checkboxes, _this6.correctIndex, _this6.incorrectIndex, _this6.correctAnswers);
	                } else if (_this6.diagramComplete) {
	                    _this6.courseService.play('buttonClick');
	                    _this6.courseService.play('exerciseComplete');
	                    _this6.finishExercise();
	                } else {
	                    _this6.courseService.play('wrongAnswer');
	                }
	            }).catch(function (e) {
	                return console.log(e);
	            });
	        }
	    }, {
	        key: 'showSimplistAnswers',
	        value: function showSimplistAnswers() {
	            var _this7 = this;
	
	            this.courseService.play('buttonClick');
	            this.blocks.forEach(function (block) {
	                if (block.answer) {
	                    block.userAnswer = block.model;
	                    block.model = _this7.$translate.instant(block.answer);
	                }
	            });
	            this.diagramCompleteOnce = true;
	            this.diagramComplete = true;
	            this.finishExercise();
	        }
	    }, {
	        key: 'revealDeductive',
	        value: function revealDeductive() {
	            this.courseService.play('exerciseComplete');
	            this.diagramComplete = true;
	            this.showAnswer = true;
	            this.finishExercise();
	        }
	    }, {
	        key: 'gotoAnchor',
	        value: function gotoAnchor(hash) {
	            (0, _uiHelper.gotoAnchor)(hash);
	        }
	    }, {
	        key: 'introductionShowNextExercise',
	        value: function introductionShowNextExercise(nextExerciseLink, event, exNumber) {
	            var complexExercises = this.complexExercises[exNumber];
	            if (complexExercises) {
	                complexExercises.fullwordingIntroduction = event.fullwordingIntroduction;
	                this.onFinishExercise(exNumber);
	            }
	            this.gotoAnchor(nextExerciseLink);
	        }
	    }, {
	        key: 'showNextExercise',
	        value: function showNextExercise() {
	            var _this8 = this;
	
	            this[this.nextExercise + 'Show'] = true;
	
	            setTimeout(function () {
	                _this8.gotoAnchor(_this8.nextExerciseLink);
	            }, 500);
	        }
	    }, {
	        key: 'onSubmitScqDiagramDndFramework',
	        value: function onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
	            this.enablePyramidBuilter = 0;
	            this.isActivePyramidBuilderDemo = true;
	            this.pyramidData = pyramidData;
	
	            this.nextExercise = nextExercise;
	            this.nextExerciseLink = nextExerciseLink;
	        }
	    }, {
	        key: 'onClosePyramidBuilder',
	        value: function onClosePyramidBuilder(_ref) {
	            var store = _ref.store,
	                guid = _ref.guid,
	                key = _ref.key;
	
	            if (!this.isActivePyramidBuilderDemo) return;
	            this.isActivePyramidBuilderDemo = false;
	            this.nextExercise && this.defineScqAnswers(this.nextExercise, store, key);
	        }
	    }, {
	        key: 'defineScqAnswers',
	        value: function defineScqAnswers(exercise, store, key) {
	            var skitNext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	            this[exercise].blocks[0].answer = store[key].scq.s;
	            this[exercise].blocks[1].answer = store[key].scq.c;
	            this[exercise].blocks[2].answer = store[key].scq.q;
	            // working only in <scq-diagram /> for 5A
	            if (this[exercise].prefilledAnswer) {
	                this[exercise].blocks[0].model = store[key].scq.s;
	                this[exercise].blocks[1].model = store[key].scq.c;
	                this[exercise].blocks[2].model = store[key].scq.q;
	            }
	            switch (true) {
	                case Boolean(store[key].scq['s-header']):
	                    this[exercise].blocks[0].note = store[key].scq['s-header'];
	                case Boolean(store[key].scq['c-header']):
	                    this[exercise].blocks[1].note = store[key].scq['c-header'];
	                case Boolean(store[key].scq['q-header']):
	                    this[exercise].blocks[2].note = store[key].scq['q-header'];
	            }
	            this[exercise] = (0, _assign2.default)({}, this[exercise]);
	
	            !skitNext && this.showNextExercise();
	        }
	    }, {
	        key: 'checkRadioButtons',
	        value: function checkRadioButtons(hint) {
	            if (this.userAnswer === this.correctAnswer) {
	                this.diagramComplete = true;
	            } else {
	                this.diagramHint = true;
	            }
	
	            if (hint && !this.diagramComplete) this.diagramService.radioButtonsHint(hint, this.userAnswer, this.correctAnswer);
	
	            if (this.diagramComplete) {
	                this.courseService.play('buttonClick');
	                this.courseService.play('exerciseComplete');
	                this.finishExercise();
	            } else if (!hint) {
	                this.courseService.play('wrongAnswer');
	            }
	        }
	    }, {
	        key: 'radioButtonsGroup',
	        value: function radioButtonsGroup(hint) {
	            if (this.userAnswers[0] === this.correctAnswers[0] && this.userAnswers[1] === this.correctAnswers[1]) {
	                this.diagramComplete = true;
	            } else {
	                this.diagramHint = true;
	            }
	
	            if (hint && !this.diagramComplete) this.diagramService.radioButtonsGroupHint(hint, this.userAnswers, this.correctAnswers, 'checkboxes-task-' + this.diagramNumber);
	
	            if (this.diagramComplete) {
	                this.courseService.play('buttonClick');
	                this.courseService.play('exerciseComplete');
	                this.finishExercise();
	            } else if (!hint) {
	                this.courseService.play('wrongAnswer');
	            }
	        }
	    }, {
	        key: 'onFocusPreFill',
	        value: function onFocusPreFill() {
	            var _this9 = this;
	
	            this.edit = true;
	            setTimeout(function () {
	                var element = document.querySelector('#' + _this9.diagramId + ' .pre-filed');
	                element = $(element);
	                element.focus();
	            }, 200);
	        }
	    }, {
	        key: 'onBlurPreFill',
	        value: function onBlurPreFill() {
	            if (this.defaultPrefiled === this.prefiledData || this.defaultPrefiled.substring(0, this.defaultPrefiled.length - 1) === this.prefiledData) {
	                this.edit = false;
	            }
	        }
	    }, {
	        key: 'showAnswers',
	        value: function showAnswers() {
	            this.diagramComplete = true;
	            this.showAnswer = true;
	            if (!this.firstPartCompleted) {
	                this.firstPartCompleted = true;
	            } else {
	                this.secondPartCompleted = true;
	            }
	            this.courseService.play('buttonClick');
	            if (this.secondPartCompleted || !this.twoRows) {
	                this.courseService.play('exerciseComplete');
	                this.finishExercise();
	            }
	            if (this.greyAnswers) {
	                var elements = document.querySelectorAll('#' + this.diagramId + ' .element-list_drop');
	                $(elements).css('background-color', '#7b7b7b');
	            }
	        }
	    }, {
	        key: 'submitFixedAnswersDiagram',
	        value: function submitFixedAnswersDiagram() {
	            var diagramComplete = this.diagramService.checkFixedAnswersDiagram(this.diagramId);
	            var reasoning = (0, _from2.default)(document.querySelectorAll('#' + this.diagramId + ' input'));
	            var rightReasoning = reasoning.some(function (input) {
	                return input.dataset.answer === 'true' && input.checked;
	            });
	            if (diagramComplete && rightReasoning) {
	                this.diagramComplete = diagramComplete;
	                this.courseService.play('buttonClick');
	                this.courseService.play('exerciseComplete');
	                this.showAnswer = true;
	                this.diagramCompleteOnce = true;
	                this.finishExercise();
	            } else {
	                this.submitTitle = 'resubmit';
	                this.diagramHint = true;
	                this.courseService.play('wrongAnswer');
	            }
	        }
	    }]);
	    return CourseController;
	}();
	
	exports.default = CourseController;

/***/ }),
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.gotoAnchor = gotoAnchor;
	exports.getLineHeight = getLineHeight;
	exports.guid = guid;
	function gotoAnchor(hash) {
	  var element = $("#" + hash);
	
	  if (!element) {
	
	    return;
	  }
	
	  $('html, body').animate({
	    scrollTop: element.offset().top
	  }, 500);
	}
	
	function getLineHeight(element) {
	  var tempElement = document.createElement(element.nodeName);
	  tempElement.setAttribute("style", "margin:0px;padding:0px;font-family:" + element.style.fontFamily + ";font-size:" + element.style.fontSize);
	  tempElement.innerHTML = "test";
	  tempElement = element.parentNode.appendChild(tempElement);
	  var lineHeight = tempElement.clientHeight;
	  tempElement.parentNode.removeChild(tempElement);
	  return lineHeight;
	}
	
	function guid() {
	  var s4 = function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  };
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(214);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unitFinish.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./unitFinish.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit-finish{color:#050e61}@keyframes swing{15%{transform:translateX(9px)}30%{transform:translateX(-9px)}40%{transform:translateX(6px)}50%{transform:translateX(-6px)}65%{transform:translateX(3px)}to{transform:translateX(0)}}.unit-finish .swing:hover{animation:swing .6s ease;animation-iteration-count:1}.unit-finish #final-section:hover{transition:opacity 2s ease-in}.unit-finish .finish{padding:100px 0}.unit-finish .congratulation-message,.unit-finish .final-description,.unit-finish .finish-section{display:block;text-align:center}.unit-finish .congratulation-message{font-size:51px;letter-spacing:7px;line-height:60px;text-transform:uppercase}.unit-finish .finish-section{font-size:35px;letter-spacing:1px}.unit-finish .final-description{font-size:22px;margin-top:33px;line-height:28px}.unit-finish ul{display:flex;width:610px;margin:90px auto 40px;justify-content:space-around;list-style:none}.unit-finish ul .finish-button{display:block;text-decoration:none;text-transform:uppercase;color:#fff;min-width:190px;text-align:center;font-size:17px;padding:15px 13px 11px;border-radius:12px;transition:background .3s ease}.unit-finish ul .finish-button__disabled{opacity:.5;pointer-events:none}", ""]);
	
	// exports


/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = ["audioService", function (audioService) {
	    'ngInject';
	
	    return {
	        restrict: 'A',
	        scope: {
	            words: '<',
	            select: '<'
	        },
	        template: '<div><span ng-repeat="word in splitWords track by $index" ng-click="highlight($event)">{{word}}</span></div>',
	        link: function link($scope, $element) {
	            $scope.splitWords = $scope.words.split(' ');
	            $scope.highlight = function (event) {
	                if (!$scope.select) {
	
	                    return;
	                }
	                audioService.play('buttonClick');
	                angular.element(event.target).toggleClass('highlight__answer');
	            };
	        }
	    };
	}];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _courseVideoPartial = __webpack_require__(217);
	
	var _courseVideoPartial2 = _interopRequireDefault(_courseVideoPartial);
	
	var _courseVideo = __webpack_require__(218);
	
	var _courseVideo2 = _interopRequireDefault(_courseVideo);
	
	__webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var courseVideo = {
	  bindings: {
	    lectureTitle: '<',
	    modifier: '<',
	    videoLink: '<'
	  },
	  controllerAs: 'vm',
	  template: _courseVideoPartial2.default,
	  controller: _courseVideo2.default,
	  transclude: true
	};
	
	exports.default = courseVideo;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = "<section id=\"{{vm.unitVideoId}}\" class=\"unit-video\" >\n  <div class=\"unit-wrapper\">\n    <h2 class=\"unit-section-title\" ng-bind=\"vm.lectureTitle | translate\"></h2>\n    <ng-template ng-if=\"vm.consoleIsClosed\">\n      <video playsinline id=\"video-js\"\n             class=\"video-js\">\n        <source ng-src=\"{{vm.lectureUrl}}\" type=\"video/mp4\">\n      </video>\n      <p class=\"watermark watermark-top-left\" ng-bind=\"vm.watermarkText\"></p>\n      <p class=\"watermark watermark-top-right\" ng-bind=\"vm.watermarkText\"></p>\n      <p class=\"watermark watermark-bottom-left\" ng-bind=\"vm.watermarkText\"></p>\n      <p class=\"watermark watermark-bottom-right\" ng-bind=\"vm.watermarkText\"></p>\n    </ng-template>\n    <p class=\"unit-video__forbid-video\"\n       ng-if=\"!vm.consoleIsClosed\">This video can't be watched while a console is opened, close console to see a video</p>\n  </div>\n</section>\n"

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _devtoolsDetector = __webpack_require__(219);
	
	var _video = __webpack_require__(220);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _environment = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CourseVideo = function () {
	  CourseVideo.$inject = ["$state", "authService", "$scope", "courseVideoService"];
	  function CourseVideo($state, authService, $scope, courseVideoService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CourseVideo);
	    (0, _assign2.default)(this, { $state: $state, authService: authService, $scope: $scope, courseVideoService: courseVideoService });
	    this.consoleIsClosed = true;
	    this.unitVideoId = 'unit-video';
	  }
	
	  (0, _createClass3.default)(CourseVideo, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      if (this.modifier) {
	        this.unitVideoId += this.modifier;
	      }
	      this.lectureUrl = this.videoLink || this.courseVideoService.getFileURL(this.modifier);
	      this.drawVideoPlayer();
	
	      if (!_environment.environment.debug) {
	        (0, _devtoolsDetector.addListener)(function (isOpened) {
	          _this.consoleIsClosed = !isOpened;
	          if (_this.consoleIsClosed) {
	            _this.drawVideoPlayer();
	          }
	          _this.$scope.$apply();
	        });
	        (0, _devtoolsDetector.lanuch)();
	      }
	    }
	  }, {
	    key: 'drawVideoPlayer',
	    value: function drawVideoPlayer() {
	      var _this2 = this;
	
	      this.lectureUrl = this.videoLink || this.courseVideoService.getFileURL(this.modifier);
	      var enablePlayer = setInterval(function () {
	        var videoPlayer = document.querySelector('#' + _this2.unitVideoId + ' #video-js');
	        if (videoPlayer && _this2.consoleIsClosed) {
	          clearInterval(enablePlayer);
	          _this2.createVideoPlayer(videoPlayer);
	          setTimeout(function () {
	            var videoHeight = $('#' + _this2.unitVideoId + ' video').height();
	            $('#' + _this2.unitVideoId + ' #video-js').css({ height: videoHeight + 'px' });
	          }, 1000);
	        }
	      });
	    }
	  }, {
	    key: 'createVideoPlayer',
	    value: function createVideoPlayer(videoPlayer) {
	      var options = {
	        controls: true,
	        controlBar: {
	          fullscreenToggle: false,
	          pictureInPictureToggle: false
	        }
	      };
	      var player = (0, _video2.default)(videoPlayer, options);
	      videoPlayer.addEventListener('contextmenu', function (e) {
	        e.preventDefault();
	      });
	      // disable full screen mode
	      player.on("fullscreenchange", function () {
	        if (player.isFullscreen()) {
	          player.exitFullscreen();
	        }
	      });
	      //
	      this.watermarkText = '\xA9 video for ' + this.authService.userData.firstName + ' ' + this.authService.userData.lastName;
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      if (!_environment.environment.debug) stop();
	    }
	  }]);
	  return CourseVideo;
	}();
	
	exports.default = CourseVideo;

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var environment = exports.environment = {
	    tokenName: 'authToken',
	    debug: true,
	    production: false,
	    userData: 'userData',
	    api: "https://api.barbaraminto.com/v1",
	    //api: "http://localhost:5002/v1",
	    videosUrl: "/videos/"
	    //videosUrl: 'https://course.barbaraminto.com/assets/videos/'
	};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(273);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./courseVideo.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./courseVideo.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	exports.i(__webpack_require__(274), "");
	
	// module
	exports.push([module.id, ".unit-video{background:#fff;width:100%}.unit-video .unit-wrapper{min-height:400px;position:relative}.unit-video #video-js_html5_api{display:block!important}.unit-video__forbid-video{text-align:center;margin-top:100px}.unit-video video[src$=\".mp4\"]{display:none}.unit-video .unit-section-title{line-height:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit-video .vjs-big-play-button{top:calc(50% - 86px / 2);left:calc(50% - 74px / 2)}.unit-video .vjs-tech{outline:none!important;height:auto}.unit-video .video-js{width:100%;height:520px}.unit-video .watermark{font-weight:700;color:#fff;width:fit-content;position:absolute;opacity:.35;font-size:9px}.unit-video .watermark-top-left,.unit-video .watermark-top-right{top:150px}.unit-video .watermark-top-left{left:9%}.unit-video .watermark-top-right{right:9%}.unit-video .watermark-bottom-left,.unit-video .watermark-bottom-right{bottom:100px}.unit-video .watermark-bottom-left{left:9%}.unit-video .watermark-bottom-right{right:9%}", ""]);
	
	// exports


/***/ }),
/* 274 */,
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	runFunc.$inject = ["$translate", "$cookies", "$templateCache"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var angular = _interopRequireWildcard(_angular);
	
	__webpack_require__(9);
	
	__webpack_require__(276);
	
	__webpack_require__(277);
	
	__webpack_require__(279);
	
	__webpack_require__(90);
	
	__webpack_require__(281);
	
	__webpack_require__(282);
	
	__webpack_require__(283);
	
	__webpack_require__(284);
	
	__webpack_require__(286);
	
	var _sticky = __webpack_require__(287);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	var _core = __webpack_require__(288);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _i18n = __webpack_require__(289);
	
	var _core3 = __webpack_require__(454);
	
	var _core4 = __webpack_require__(455);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var core = angular.module('minto.core', ['ui.router', 'pascalprecht.translate', 'ngCookies', 'ngSanitize', 'ngStorage', 'ui.bootstrap.tabs', 'cfp.hotkeys', 'rzModule', 'hl.sticky']);
	
	core.constant('local', function () {
	    var isLocal = document.location.hostname === 'localhost';
	    return isLocal;
	}());
	
	core.constant('APIEndpoint', (0, _core3.APIEndpoint)());
	core.constant('GlobalRedirects', (0, _core3.GlobalRedirects)());
	core.factory('interceptor', _core4.InterceptorsService);
	
	core.config(_core2.default);
	core.config(_i18n.localeConfig);
	core.run(runFunc);
	
	function runFunc($translate, $cookies, $templateCache) {
	    'ngInject';
	
	    (function ($translate, $cookies) {
	        $translate.use('en');
	        // if (angular.isUndefined($cookies.get('lang'))) {
	        //     $translate.use('en');
	        // } else {
	        //     $translate.use($cookies.get('lang'));
	        // }
	    })($translate, $cookies);
	
	    $templateCache.put('uib/template/tabs/tabset.html', '<div>\n                <ul class="tabs" ng-transclude></ul>\n                <div class="tab-content">\n                    <div class="content-item"\n                        ng-repeat="tab in tabset.tabs"\n                        ng-class="{active: tabset.active === tab.index}"\n                        uib-tab-content-transclude="tab">\n                    </div>\n                </div>\n            </div>');
	
	    $templateCache.put('uib/template/tabs/tab.html', '<li ng-class="[{active: active, disabled: disabled}, classes]" class="tab-item">\n                <a href ng-click="select($event)" class="nav-link" uib-tab-heading-transclude>{{heading}}</a>\n            </li>');
	}
	
	exports.default = core;

/***/ }),
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports) {

	/*
	 * angular-sticky-plugin
	 * https://github.com/harm-less/angular-sticky
	
	 * Version: 0.4.2 - 2017-11-01
	 * License: MIT
	 */
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var skicky = angular.module('hl.sticky', []).factory('mediaQuery', function () {
		return {
			matches: function matches(query) {
				return query && (matchMedia('(' + query + ')').matches || matchMedia(query).matches);
			}
		};
	}).factory('hlStickyStack', ["$document", "DefaultStickyStackName", function ($document, DefaultStickyStackName) {
	
		var documentEl = $document[0].documentElement;
	
		var stacks = {};
	
		function stickyStack(options) {
	
			options = options || {};
	
			var stackName = options.name || DefaultStickyStackName;
	
			// use existing sticky stack
			if (stacks[stackName]) {
				return stacks[stackName];
			}
	
			// should be above all Bootstrap's z-indexes (but just before the modals)
			var stickyZIndex = 1039;
			var stack = [];
	
			var $stack = {};
	
			$stack.options = options;
			$stack.stackName = stackName;
	
			$stack.add = function (id, sticky) {
				if (!angular.isString(id) || id === '') {
					id = $stack.length();
				}
				sticky.id = id;
				sticky.zIndex = stickyZIndex;
				stack.push(sticky);
	
				stickyZIndex -= 1;
				return sticky;
			};
			$stack.get = function (id) {
				for (var i = 0; i < stack.length; i++) {
					if (id == stack[i].id) {
						// jshint ignore:line
						return stack[i];
					}
				}
				return false;
			};
			$stack.index = function (id) {
				for (var i = 0; i < stack.length; i++) {
					if (id == stack[i].id) {
						// jshint ignore:line
						return i;
					}
				}
				return -1;
			};
			$stack.range = function (start, end) {
				return stack.slice(start, end);
			};
			$stack.all = function () {
				return stack;
			};
			$stack.keys = function () {
				var ids = [];
				for (var i = 0; i < stack.length; i++) {
					ids.push(stack[i].id);
				}
				return ids;
			};
			$stack.top = function () {
				return stack[stack.length - 1];
			};
			$stack.remove = function (id) {
				for (var i = 0; i < stack.length; i++) {
					if (id == stack[i].id) {
						// jshint ignore:line
						stickyZIndex += 1;
						return stack.splice(i, 1)[0];
					}
				}
				return false;
			};
			$stack.removeTop = function () {
				stickyZIndex += 1;
				return stack.splice(stack.length - 1, 1)[0];
			};
			$stack.length = function () {
				return stack.length;
			};
	
			$stack.height = function (anchor) {
				var height = {
					top: 0,
					bottom: 0
				};
				angular.forEach(stack, function (item) {
					height[item.anchor()] += item.computedHeight(anchor);
				});
				return height[anchor];
			};
			$stack.heightAt = function (anchor, at) {
				var atAdjusted = at - 1;
				var stick;
				var computedHeight;
				var height = {
					top: 0,
					bottom: 0
				};
				for (var i = 0; i < stack.length; i++) {
					stick = stack[i];
					// check if the sticky element sticks at the queried position minus 1 pixel if the position is at the same place
					if (stick.sticksAtPosition(anchor, atAdjusted)) {
						var stickyAnchor = stick.anchor();
						computedHeight = stick.computedHeight(anchor, atAdjusted - height[stickyAnchor]);
	
						// add the height of the sticky element to the total
						height[stickyAnchor] += computedHeight;
					}
				}
				return height[anchor];
			};
			$stack.heightCurrent = function (anchor) {
				return $stack.heightAt(anchor, window.pageYOffset || documentEl.scrollTop);
			};
	
			stacks[stackName] = $stack;
	
			return $stack;
		}
	
		return stickyStack;
	}]).factory('hlStickyElement', ["$document", "$log", "hlStickyStack", "throttle", "mediaQuery", function ($document, $log, hlStickyStack, throttle, mediaQuery) {
		return function (element, options) {
			options = options || {};
	
			var stickyLineTop;
			var stickyLineBottom;
			var placeholder;
	
			var _isSticking = false;
	
			// elements
			var bodyEl = $document[0].body;
			var nativeEl = element[0];
			var documentEl = $document[0].documentElement;
	
			// attributes
			var id = options.id || null;
			var stickyMediaQuery = angular.isDefined(options.mediaQuery) ? options.mediaQuery : false;
			var stickyClass = angular.isString(options.stickyClass) && options.stickyClass !== '' ? options.stickyClass : 'is-sticky';
			var usePlaceholder = angular.isDefined(options.usePlaceholder) ? options.usePlaceholder : true;
			var offsetTop = options.offsetTop ? parseInt(options.offsetTop) : 0;
			var offsetBottom = options.offsetBottom ? parseInt(options.offsetBottom) : 0;
			var anchor = typeof options.anchor === 'string' ? options.anchor.toLowerCase().trim() : 'top';
			var container = null;
			var stack = options.stack === false ? null : options.stack || hlStickyStack();
	
			var event = angular.isFunction(options.event) ? options.event : angular.noop;
			var globalOffset = {
				top: 0,
				bottom: 0
			};
	
			// initial style
			var initialCSS = {
				style: element.attr('style') || ''
			};
	
			// Methods
			//
			function stickyLinePositionTop() {
				if (_isSticking) {
					return stickyLineTop;
				}
				stickyLineTop = _getTopOffset(nativeEl) - offsetTop - _stackOffsetTop();
				return stickyLineTop;
			}
			function stickyLinePositionBottom() {
				if (_isSticking) {
					return stickyLineBottom;
				}
				stickyLineBottom = _getBottomOffset(nativeEl) + offsetBottom + _stackOffsetBottom();
				return stickyLineBottom;
			}
			function isEnabled() {
				return !angular.isDefined(options.enable) || options.enable;
			}
			function isSticky() {
				return isEnabled() && _isSticking || options.alwaysSticky;
			}
			function sticksAtPosition(anchor, scrolledDistance) {
				if (!matchesMediaQuery()) {
					return false;
				}
				switch (anchor) {
					case 'top':
						{
							return sticksAtPositionTop(scrolledDistance);
						}
					case 'bottom':
						{
							return sticksAtPositionBottom(scrolledDistance);
						}
					default:
						{
							$log.error('Unknown anchor "' + anchor + '"');
							break;
						}
				}
				return false;
			}
			function sticksAtPositionTop(scrolledDistance) {
				scrolledDistance = scrolledDistance !== undefined ? scrolledDistance : window.pageYOffset || bodyEl.scrollTop;
				var scrollTop = scrolledDistance - (documentEl.clientTop || 0);
				return scrollTop >= stickyLinePositionTop();
			}
			function sticksAtPositionBottom(scrolledDistance) {
				scrolledDistance = scrolledDistance !== undefined ? scrolledDistance : window.pageYOffset || bodyEl.scrollTop;
				var scrollBottom = scrolledDistance + window.innerHeight;
				return scrollBottom <= stickyLinePositionBottom();
			}
			function matchesMediaQuery() {
				return stickyMediaQuery === false || mediaQuery.matches(stickyMediaQuery);
			}
	
			function render() {
				var shouldStick = sticksAtPosition(anchor);
	
				if (angular.isDefined(options.enable) && !options.enable) {
					shouldStick = false;
				}
	
				if (angular.isDefined(options.alwaysSticky) && options.alwaysSticky) {
					shouldStick = true;
				}
	
				// Switch the sticky mode if the element crosses the sticky line
				// don't make the element sticky when it's already sticky
				if (shouldStick && !_isSticking) {
					stickElement();
					event({ event: 'stick' });
				}
				// don't unstick the element sticky when it isn't sticky already
				else if (!shouldStick && _isSticking) {
						unstickElement();
						event({ event: 'unstick' });
					}
	
				// stick after care
				if (_isSticking) {
					// update the top offset at an already sticking element
					if (anchor === 'top') {
						element.css('top', offsetTop + _stackOffset(anchor) - containerBoundsBottom() + 'px');
					} else if (anchor === 'bottom') {
						element.css('bottom', offsetBottom + _stackOffset(anchor) - containerBoundsTop() + 'px');
					}
					element.css('width', elementWidth() + 'px');
				}
			}
	
			function stickElement() {
				_isSticking = true;
	
				element.addClass(stickyClass);
	
				// create placeholder to avoid jump
				if (usePlaceholder) {
					placeholder = placeholder || angular.element('<div>');
					placeholder.css('height', elementHeight() + 'px');
					element.after(placeholder);
				}
	
				var rect = nativeEl.getBoundingClientRect();
				var css = {
					'width': elementWidth() + 'px',
					'position': 'fixed',
					'left': rect.left + 'px',
					'z-index': stack ? stack.get(id).zIndex - (globalOffset.zIndex || 0) : null
				};
	
				css['margin-' + anchor] = 0;
				element.css(css);
			}
			function unstickElement() {
				_isSticking = false;
	
				element.removeClass(stickyClass);
	
				// reset the original css we might have changed when the object was sticky
				element.attr('style', initialCSS.style);
	
				// if a placeholder was used, remove it from the DOM
				if (placeholder) {
					placeholder.remove();
				}
			}
	
			function elementWidth() {
				return nativeEl.offsetWidth;
			}
			function elementHeight() {
				return nativeEl.offsetHeight;
			}
	
			function _getTopOffset(element) {
				var pixels = 0;
				if (element && element.offsetParent) {
					do {
						pixels += element.offsetTop;
						element = element.offsetParent;
					} while (element);
				}
				return pixels;
			}
	
			function _getBottomOffset(element) {
				return _getTopOffset(element) + element.clientHeight;
			}
	
			function _stackOffset(anchor) {
				var extraOffset = 0;
	
				if (anchor === 'top' && globalOffset.top > 0) {
					extraOffset += globalOffset.top;
				}
				if (anchor === 'bottom' && globalOffset.bottom > 0) {
					extraOffset += globalOffset.bottom;
				}
				if (stack) {
					var stickIndex = stack.index(id);
					if (anchor === 'top') {
						if (stickIndex > 0) {
							// @todo the stack range calculation should be diverted to the stack
							stack.range(0, stickIndex).forEach(function (stick) {
								if (stick.isSticky()) {
									extraOffset += stick.computedHeight(anchor);
								}
							});
						}
					}
					if (anchor === 'bottom') {
						if (stickIndex !== stack.length() - 1) {
							// @todo the stack range calculation should be diverted to the stack
							stack.range(stickIndex + 1, stack.length()).forEach(function (stick) {
								if (stick.isSticky()) {
									extraOffset += stick.computedHeight(anchor);
								}
							});
						}
					}
				}
				return extraOffset;
			}
			function _stackOffsetTop() {
				return _stackOffset('top');
			}
			function _stackOffsetBottom() {
				return _stackOffset('bottom');
			}
	
			function computedHeight(anchor, scrolledDistance) {
				if (anchor === 'top') {
					return Math.max(0, elementHeight() - containerBoundsBottom(scrolledDistance) + offsetTop);
				} else if (anchor === 'bottom') {
					return Math.max(0, elementHeight() - containerBoundsTop(scrolledDistance) + offsetBottom);
				}
				return 0;
			}
	
			// @todo dffgdg
			function containerBoundsTop(scrolledDistance) {
				if (container === null) {
					container = options.container !== undefined ? angular.isString(options.container) ? angular.element(documentEl.querySelector('#' + options.container))[0] : options.container : false;
				}
				if (container) {
					var hasScrollDistance = !(scrolledDistance === null || scrolledDistance === undefined);
					var containerRect = container.getBoundingClientRect();
					var containerBottom = !hasScrollDistance ? containerRect.top - window.innerHeight + elementHeight() : _getTopOffset(container) + containerRect.height - scrolledDistance;
					return Math.max(0, containerBottom - (offsetTop + _stackOffset(anchor)));
				}
				return 0;
			}
			function containerBoundsBottom(scrolledDistance) {
				if (container === null) {
					container = options.container !== undefined ? angular.isString(options.container) ? angular.element(documentEl.querySelector('#' + options.container))[0] : options.container : false;
				}
				if (container) {
					var hasScrollDistance = !(scrolledDistance === null || scrolledDistance === undefined);
					var containerRect = container.getBoundingClientRect();
					var containerBottom = !hasScrollDistance ? containerRect.bottom : _getTopOffset(container) + containerRect.height - scrolledDistance;
					return Math.max(0, offsetTop + _stackOffset(anchor) + elementHeight() - containerBottom);
				}
				return 0;
			}
	
			var $api = {};
	
			if (stack) {
				// add element to the sticky stack and save the id
				var stackItem = stack.add(id, $api);
				id = stackItem.id;
			}
	
			$api.draw = function (drawOptions) {
				drawOptions = drawOptions || {};
				var offset = drawOptions.offset;
				if (offset) {
					// setting global offsets added to the local offsets of the sticky element
					globalOffset.top = offset.top || 0;
					globalOffset.bottom = offset.bottom || 0;
					globalOffset.zIndex = offset.zIndex;
				}
	
				// for resizing or other purposes that require a forced re-draw, we simply un-stick the element and re-stick it using the render method
				if (drawOptions.force === true) {
					unstickElement();
				}
				render();
			};
	
			$api.anchor = function () {
				return anchor;
			};
	
			$api.isSticky = isSticky;
			$api.isEnabled = isEnabled;
			$api.computedHeight = computedHeight;
			$api.sticksAtPosition = sticksAtPosition;
	
			$api.destroy = function () {
				unstickElement();
				if (stack) {
					stack.remove(id);
				}
			};
	
			return $api;
		};
	}]).constant('DefaultStickyStackName', 'default-stack').provider('hlStickyElementCollection', function () {
	
		var $$count = 0;
	
		var $stickyElement = {
			collections: {},
			defaults: {
				checkDelay: 250
			},
			elementsDefaults: {},
			$get: ["$rootScope", "$window", "$document", "$log", "DefaultStickyStackName", "hlStickyElement", "hlStickyStack", "throttle", function ($rootScope, $window, $document, $log, DefaultStickyStackName, hlStickyElement, hlStickyStack, throttle) {
	
				var windowEl = angular.element($window);
	
				var unbindViewContentLoaded;
				var unbindIncludeContentLoaded;
				var throttledResize;
	
				function init() {
					$$count++;
	
					// make sure we can initialize it only once
					if ($$count > 1) {
						return;
					}
	
					// bind events
					throttledResize = throttle(resize, $stickyElement.defaults.checkDelay, { leading: false });
					windowEl.on('resize', throttledResize);
					windowEl.on('scroll', drawEvent);
	
					unbindViewContentLoaded = $rootScope.$on('$viewContentLoaded', throttledResize);
					unbindIncludeContentLoaded = $rootScope.$on('$includeContentLoaded', throttledResize);
					throttledResize();
				}
	
				function destroy() {
					// check internal references counter
					$$count--;
					if ($$count > 0) {
						return;
					}
	
					// unbind events
					windowEl.off('resize', throttledResize);
					windowEl.off('scroll', drawEvent);
					unbindViewContentLoaded();
					unbindIncludeContentLoaded();
				}
	
				function drawEvent() {
					draw();
				}
				function resize() {
					draw({ force: true });
				}
				function draw(drawOptions) {
					angular.forEach($stickyElement.collections, function (collection) {
						collection.draw(drawOptions);
					});
				}
	
				function stickyElementFactory(options) {
	
					if (!options || !angular.isObject(options)) {
						$log.warn('Must supply an options object');
						options = {};
					}
					options = angular.extend({}, $stickyElement.elementsDefaults, options);
	
					var collectionName = options.name || DefaultStickyStackName;
	
					// use existing element collection
					if ($stickyElement.collections[collectionName]) {
						return $stickyElement.collections[collectionName];
					}
	
					var stickyStackFactory = hlStickyStack({
						name: collectionName
					});
	
					var trackedElements = [];
	
					var $sticky = {};
	
					$sticky.addElement = function (element, stickyOptions) {
						stickyOptions = stickyOptions || {};
						stickyOptions.stack = stickyStackFactory;
						var sticky = hlStickyElement(element, stickyOptions);
						trackedElements.push({
							stickyElement: sticky,
							element: element
						});
	
						return sticky;
					};
	
					$sticky.removeElement = function (element) {
	
						var toDelete;
						for (var i = trackedElements.length; i--;) {
							if (angular.isString(element) && '#' + trackedElements[i].element.id === element || trackedElements[i].element === element) {
								toDelete = i;
								break;
							}
						}
						var deletedElement = trackedElements.splice(toDelete, 1)[0];
						if (deletedElement) {
							deletedElement.stickyElement.destroy();
						}
	
						return deletedElement;
					};
	
					$sticky.draw = function (drawOptions) {
						var _drawOptions = {};
						if (options.parent) {
							var parentStack = hlStickyStack({
								name: options.parent
							});
							_drawOptions.offset = {
								top: parentStack.heightCurrent('top'),
								zIndex: parentStack.length()
							};
						}
						angular.extend(_drawOptions, drawOptions || {});
						angular.forEach(trackedElements, function (element) {
							element.stickyElement.draw(_drawOptions);
						});
					};
	
					$sticky.destroy = function () {
						angular.forEach(angular.copy(trackedElements), function (element) {
							$sticky.removeElement(element);
						});
						delete $stickyElement.collections[collectionName];
						destroy();
					};
	
					$sticky.trackedElements = function () {
						return trackedElements;
					};
	
					// use new element collection
					$stickyElement.collections[collectionName] = $sticky;
					init();
	
					return $sticky;
				}
				return stickyElementFactory;
			}]
		};
		return $stickyElement;
	}).directive('hlSticky', ["$log", "$window", "$document", "hlStickyElementCollection", function ($log, $window, $document, hlStickyElementCollection) {
		return {
			restrict: 'A',
			scope: {
				container: '@',
				anchor: '@',
				stickyClass: '@',
				mediaQuery: '@',
				collection: '@',
				collectionParent: '@',
				event: '&',
				enable: '=',
				alwaysSticky: '='
			},
			link: function link($scope, $element, $attrs) {
				$element.addClass('hl-sticky');
	
				var stickyElementCollection = hlStickyElementCollection({
					name: $scope.collection,
					parent: $scope.collectionParent
				});
				var options = {
					id: $attrs.hlSticky,
					event: function event(_event) {
						$scope.event({
							event: _event
						});
					}
				};
				angular.forEach(['anchor', 'container', 'stickyClass', 'mediaQuery', 'enable', 'alwaysSticky'], function (option) {
					if (angular.isDefined($scope[option])) {
						options[option] = $scope[option];
					}
				});
				angular.forEach(['usePlaceholder', 'offsetTop', 'offsetBottom'], function (option) {
					if (angular.isDefined($attrs[option])) {
						options[option] = $scope.$parent.$eval($attrs[option]);
					}
				});
				stickyElementCollection.addElement($element, options);
	
				// listeners
				$scope.$watch('enable', function (newValue, oldValue) {
					if (newValue !== oldValue) {
						options.enable = $scope.enable;
						stickyElementCollection.draw({ force: true });
					}
				});
				$scope.$watch('alwaysSticky', function (newValue, oldValue) {
					if (newValue !== oldValue) {
						options.alwaysSticky = $scope.alwaysSticky;
						stickyElementCollection.draw({ force: true });
					}
				});
				$scope.$on('$destroy', function onDestroy() {
					stickyElementCollection.removeElement($element);
					if (!stickyElementCollection.trackedElements().length) {
						stickyElementCollection.destroy();
					}
				});
			}
		};
	}]).factory('throttle', ["$timeout", function ($timeout) {
		return function (func, wait, options) {
			var timeout = null;
			options = options || {};
			return function () {
				var that = this;
				var args = arguments;
	
				if (!timeout) {
					if (options.leading !== false) {
						func.apply(that, args);
					}
					timeout = $timeout(function later() {
						timeout = null;
						if (options.trailing !== false) {
							func.apply(that, args);
						}
					}, wait, false);
				}
			};
		};
	}]);
	
	exports.default = skicky;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	
	routerConfiguration.$inject = ["$urlRouterProvider", "$stateProvider", "$httpProvider", "$locationProvider"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routerConfiguration;
	function routerConfiguration($urlRouterProvider, $stateProvider, $httpProvider, $locationProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('interceptor');
	
	  $locationProvider.html5Mode(false).hashPrefix('!');
	  // $httpProvider.defaults.cache = true;
	  $stateProvider.state('app', {
	    abstract: true,
	    views: {
	      '': {
	        template: '<ui-view></ui-view>'
	      }
	    }
	  }).state('auth', {
	    abstract: true,
	    views: {
	      '': {
	        template: '<ui-view></ui-view>'
	      },
	      footer: {
	        template: '<mo-footer></mo-footer>'
	      }
	    }
	  }).state('site', {
	    abstract: true,
	    views: {
	      '': {
	        template: '<ui-view></ui-view>'
	      },
	      footer: {
	        template: '<mo-footer></mo-footer>'
	      }
	    }
	  }).state('course', {
	    abstract: true,
	    views: {
	      '': {
	        template: '<ui-view autoscroll=\'true\'></ui-view>'
	      },
	      footer: {
	        template: '<mo-footer></mo-footer>'
	      }
	    }
	  });
	
	  $urlRouterProvider.otherwise('/');
	}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	localeConfig.$inject = ["$translateProvider"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.localeConfig = localeConfig;
	
	__webpack_require__(276);
	
	var _i18nEn = __webpack_require__(290);
	
	var _i18nEs = __webpack_require__(437);
	
	function localeConfig($translateProvider) {
	    'ngInject';
	
	    $translateProvider.translations('en', _i18nEn.i18nEN);
	    $translateProvider.translations('es', _i18nEs.i18nES);
	    // $translateProvider.useSanitizeValueStrategy(null);
	}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.i18nEN = undefined;
	
	var _en = __webpack_require__(291);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _en3 = __webpack_require__(292);
	
	var _en4 = _interopRequireDefault(_en3);
	
	var _en5 = __webpack_require__(293);
	
	var _en6 = _interopRequireDefault(_en5);
	
	var _en7 = __webpack_require__(294);
	
	var _en8 = _interopRequireDefault(_en7);
	
	var _en9 = __webpack_require__(295);
	
	var _en10 = _interopRequireDefault(_en9);
	
	var _en11 = __webpack_require__(296);
	
	var _en12 = _interopRequireDefault(_en11);
	
	var _en13 = __webpack_require__(297);
	
	var _en14 = _interopRequireDefault(_en13);
	
	var _en15 = __webpack_require__(298);
	
	var _en16 = _interopRequireDefault(_en15);
	
	var _en17 = __webpack_require__(299);
	
	var _en18 = _interopRequireDefault(_en17);
	
	var _en19 = __webpack_require__(300);
	
	var _en20 = _interopRequireDefault(_en19);
	
	var _en21 = __webpack_require__(301);
	
	var _en22 = _interopRequireDefault(_en21);
	
	var _en23 = __webpack_require__(302);
	
	var _en24 = _interopRequireDefault(_en23);
	
	var _en25 = __webpack_require__(303);
	
	var _en26 = _interopRequireDefault(_en25);
	
	var _en27 = __webpack_require__(304);
	
	var _en28 = _interopRequireDefault(_en27);
	
	var _en29 = __webpack_require__(305);
	
	var _en30 = _interopRequireDefault(_en29);
	
	var _en31 = __webpack_require__(306);
	
	var _en32 = _interopRequireDefault(_en31);
	
	var _en33 = __webpack_require__(307);
	
	var _en34 = _interopRequireDefault(_en33);
	
	var _en35 = __webpack_require__(308);
	
	var _en36 = _interopRequireDefault(_en35);
	
	var _en37 = __webpack_require__(309);
	
	var _en38 = _interopRequireDefault(_en37);
	
	var _en39 = __webpack_require__(310);
	
	var _en40 = _interopRequireDefault(_en39);
	
	var _en41 = __webpack_require__(311);
	
	var _en42 = _interopRequireDefault(_en41);
	
	var _en43 = __webpack_require__(312);
	
	var _en44 = _interopRequireDefault(_en43);
	
	var _en45 = __webpack_require__(313);
	
	var _en46 = _interopRequireDefault(_en45);
	
	var _en47 = __webpack_require__(314);
	
	var _en48 = _interopRequireDefault(_en47);
	
	var _en49 = __webpack_require__(315);
	
	var _en50 = _interopRequireDefault(_en49);
	
	var _en51 = __webpack_require__(316);
	
	var _en52 = _interopRequireDefault(_en51);
	
	var _en53 = __webpack_require__(317);
	
	var _en54 = _interopRequireDefault(_en53);
	
	var _en55 = __webpack_require__(318);
	
	var _en56 = _interopRequireDefault(_en55);
	
	var _en57 = __webpack_require__(319);
	
	var _en58 = _interopRequireDefault(_en57);
	
	var _en59 = __webpack_require__(320);
	
	var _en60 = _interopRequireDefault(_en59);
	
	var _en61 = __webpack_require__(321);
	
	var _en62 = _interopRequireDefault(_en61);
	
	var _en63 = __webpack_require__(322);
	
	var _en64 = _interopRequireDefault(_en63);
	
	var _en65 = __webpack_require__(323);
	
	var _en66 = _interopRequireDefault(_en65);
	
	var _en67 = __webpack_require__(324);
	
	var _en68 = _interopRequireDefault(_en67);
	
	var _en69 = __webpack_require__(325);
	
	var _en70 = _interopRequireDefault(_en69);
	
	var _en71 = __webpack_require__(326);
	
	var _en72 = _interopRequireDefault(_en71);
	
	var _en73 = __webpack_require__(327);
	
	var _en74 = _interopRequireDefault(_en73);
	
	var _en75 = __webpack_require__(328);
	
	var _en76 = _interopRequireDefault(_en75);
	
	var _en77 = __webpack_require__(329);
	
	var _en78 = _interopRequireDefault(_en77);
	
	var _en79 = __webpack_require__(330);
	
	var _en80 = _interopRequireDefault(_en79);
	
	var _en81 = __webpack_require__(331);
	
	var _en82 = _interopRequireDefault(_en81);
	
	var _en83 = __webpack_require__(332);
	
	var _en84 = _interopRequireDefault(_en83);
	
	var _en85 = __webpack_require__(333);
	
	var _en86 = _interopRequireDefault(_en85);
	
	var _en87 = __webpack_require__(334);
	
	var _en88 = _interopRequireDefault(_en87);
	
	var _en89 = __webpack_require__(335);
	
	var _en90 = _interopRequireDefault(_en89);
	
	var _en91 = __webpack_require__(336);
	
	var _en92 = _interopRequireDefault(_en91);
	
	var _en93 = __webpack_require__(337);
	
	var _en94 = _interopRequireDefault(_en93);
	
	var _en95 = __webpack_require__(338);
	
	var _en96 = _interopRequireDefault(_en95);
	
	var _en97 = __webpack_require__(339);
	
	var _en98 = _interopRequireDefault(_en97);
	
	var _en99 = __webpack_require__(340);
	
	var _en100 = _interopRequireDefault(_en99);
	
	var _en101 = __webpack_require__(341);
	
	var _en102 = _interopRequireDefault(_en101);
	
	var _en103 = __webpack_require__(342);
	
	var _en104 = _interopRequireDefault(_en103);
	
	var _en105 = __webpack_require__(343);
	
	var _en106 = _interopRequireDefault(_en105);
	
	var _en107 = __webpack_require__(344);
	
	var _en108 = _interopRequireDefault(_en107);
	
	var _en109 = __webpack_require__(345);
	
	var _en110 = _interopRequireDefault(_en109);
	
	var _en111 = __webpack_require__(346);
	
	var _en112 = _interopRequireDefault(_en111);
	
	var _en113 = __webpack_require__(347);
	
	var _en114 = _interopRequireDefault(_en113);
	
	var _en115 = __webpack_require__(348);
	
	var _en116 = _interopRequireDefault(_en115);
	
	var _en117 = __webpack_require__(349);
	
	var _en118 = _interopRequireDefault(_en117);
	
	var _en119 = __webpack_require__(350);
	
	var _en120 = _interopRequireDefault(_en119);
	
	var _en121 = __webpack_require__(351);
	
	var _en122 = _interopRequireDefault(_en121);
	
	var _en123 = __webpack_require__(352);
	
	var _en124 = _interopRequireDefault(_en123);
	
	var _en125 = __webpack_require__(353);
	
	var _en126 = _interopRequireDefault(_en125);
	
	var _en127 = __webpack_require__(354);
	
	var _en128 = _interopRequireDefault(_en127);
	
	var _en129 = __webpack_require__(355);
	
	var _en130 = _interopRequireDefault(_en129);
	
	var _en131 = __webpack_require__(356);
	
	var _en132 = _interopRequireDefault(_en131);
	
	var _en133 = __webpack_require__(357);
	
	var _en134 = _interopRequireDefault(_en133);
	
	var _en135 = __webpack_require__(358);
	
	var _en136 = _interopRequireDefault(_en135);
	
	var _en137 = __webpack_require__(359);
	
	var _en138 = _interopRequireDefault(_en137);
	
	var _en139 = __webpack_require__(360);
	
	var _en140 = _interopRequireDefault(_en139);
	
	var _en141 = __webpack_require__(361);
	
	var _en142 = _interopRequireDefault(_en141);
	
	var _en143 = __webpack_require__(362);
	
	var _en144 = _interopRequireDefault(_en143);
	
	var _en145 = __webpack_require__(363);
	
	var _en146 = _interopRequireDefault(_en145);
	
	var _en147 = __webpack_require__(364);
	
	var _en148 = _interopRequireDefault(_en147);
	
	var _en149 = __webpack_require__(365);
	
	var _en150 = _interopRequireDefault(_en149);
	
	var _en151 = __webpack_require__(366);
	
	var _en152 = _interopRequireDefault(_en151);
	
	var _en153 = __webpack_require__(367);
	
	var _en154 = _interopRequireDefault(_en153);
	
	var _en155 = __webpack_require__(368);
	
	var _en156 = _interopRequireDefault(_en155);
	
	var _en157 = __webpack_require__(369);
	
	var _en158 = _interopRequireDefault(_en157);
	
	var _en159 = __webpack_require__(370);
	
	var _en160 = _interopRequireDefault(_en159);
	
	var _en161 = __webpack_require__(371);
	
	var _en162 = _interopRequireDefault(_en161);
	
	var _en163 = __webpack_require__(372);
	
	var _en164 = _interopRequireDefault(_en163);
	
	var _en165 = __webpack_require__(373);
	
	var _en166 = _interopRequireDefault(_en165);
	
	var _en167 = __webpack_require__(374);
	
	var _en168 = _interopRequireDefault(_en167);
	
	var _en169 = __webpack_require__(375);
	
	var _en170 = _interopRequireDefault(_en169);
	
	var _en171 = __webpack_require__(376);
	
	var _en172 = _interopRequireDefault(_en171);
	
	var _en173 = __webpack_require__(377);
	
	var _en174 = _interopRequireDefault(_en173);
	
	var _en175 = __webpack_require__(378);
	
	var _en176 = _interopRequireDefault(_en175);
	
	var _en177 = __webpack_require__(379);
	
	var _en178 = _interopRequireDefault(_en177);
	
	var _en179 = __webpack_require__(380);
	
	var _en180 = _interopRequireDefault(_en179);
	
	var _en181 = __webpack_require__(381);
	
	var _en182 = _interopRequireDefault(_en181);
	
	var _en183 = __webpack_require__(382);
	
	var _en184 = _interopRequireDefault(_en183);
	
	var _en185 = __webpack_require__(383);
	
	var _en186 = _interopRequireDefault(_en185);
	
	var _en187 = __webpack_require__(384);
	
	var _en188 = _interopRequireDefault(_en187);
	
	var _en189 = __webpack_require__(385);
	
	var _en190 = _interopRequireDefault(_en189);
	
	var _en191 = __webpack_require__(386);
	
	var _en192 = _interopRequireDefault(_en191);
	
	var _en193 = __webpack_require__(387);
	
	var _en194 = _interopRequireDefault(_en193);
	
	var _en195 = __webpack_require__(388);
	
	var _en196 = _interopRequireDefault(_en195);
	
	var _en197 = __webpack_require__(389);
	
	var _en198 = _interopRequireDefault(_en197);
	
	var _en199 = __webpack_require__(390);
	
	var _en200 = _interopRequireDefault(_en199);
	
	var _en201 = __webpack_require__(391);
	
	var _en202 = _interopRequireDefault(_en201);
	
	var _en203 = __webpack_require__(392);
	
	var _en204 = _interopRequireDefault(_en203);
	
	var _en205 = __webpack_require__(393);
	
	var _en206 = _interopRequireDefault(_en205);
	
	var _en207 = __webpack_require__(394);
	
	var _en208 = _interopRequireDefault(_en207);
	
	var _en209 = __webpack_require__(395);
	
	var _en210 = _interopRequireDefault(_en209);
	
	var _en211 = __webpack_require__(396);
	
	var _en212 = _interopRequireDefault(_en211);
	
	var _en213 = __webpack_require__(397);
	
	var _en214 = _interopRequireDefault(_en213);
	
	var _en215 = __webpack_require__(398);
	
	var _en216 = _interopRequireDefault(_en215);
	
	var _en217 = __webpack_require__(399);
	
	var _en218 = _interopRequireDefault(_en217);
	
	var _en219 = __webpack_require__(400);
	
	var _en220 = _interopRequireDefault(_en219);
	
	var _en221 = __webpack_require__(401);
	
	var _en222 = _interopRequireDefault(_en221);
	
	var _en223 = __webpack_require__(402);
	
	var _en224 = _interopRequireDefault(_en223);
	
	var _en225 = __webpack_require__(403);
	
	var _en226 = _interopRequireDefault(_en225);
	
	var _en227 = __webpack_require__(404);
	
	var _en228 = _interopRequireDefault(_en227);
	
	var _en229 = __webpack_require__(405);
	
	var _en230 = _interopRequireDefault(_en229);
	
	var _en231 = __webpack_require__(406);
	
	var _en232 = _interopRequireDefault(_en231);
	
	var _en233 = __webpack_require__(407);
	
	var _en234 = _interopRequireDefault(_en233);
	
	var _en235 = __webpack_require__(408);
	
	var _en236 = _interopRequireDefault(_en235);
	
	var _en237 = __webpack_require__(409);
	
	var _en238 = _interopRequireDefault(_en237);
	
	var _en239 = __webpack_require__(410);
	
	var _en240 = _interopRequireDefault(_en239);
	
	var _en241 = __webpack_require__(411);
	
	var _en242 = _interopRequireDefault(_en241);
	
	var _en243 = __webpack_require__(412);
	
	var _en244 = _interopRequireDefault(_en243);
	
	var _en245 = __webpack_require__(413);
	
	var _en246 = _interopRequireDefault(_en245);
	
	var _en247 = __webpack_require__(414);
	
	var _en248 = _interopRequireDefault(_en247);
	
	var _en249 = __webpack_require__(415);
	
	var _en250 = _interopRequireDefault(_en249);
	
	var _en251 = __webpack_require__(416);
	
	var _en252 = _interopRequireDefault(_en251);
	
	var _en253 = __webpack_require__(417);
	
	var _en254 = _interopRequireDefault(_en253);
	
	var _en255 = __webpack_require__(418);
	
	var _en256 = _interopRequireDefault(_en255);
	
	var _en257 = __webpack_require__(419);
	
	var _en258 = _interopRequireDefault(_en257);
	
	var _en259 = __webpack_require__(420);
	
	var _en260 = _interopRequireDefault(_en259);
	
	var _en261 = __webpack_require__(421);
	
	var _en262 = _interopRequireDefault(_en261);
	
	var _en263 = __webpack_require__(422);
	
	var _en264 = _interopRequireDefault(_en263);
	
	var _en265 = __webpack_require__(423);
	
	var _en266 = _interopRequireDefault(_en265);
	
	var _en267 = __webpack_require__(424);
	
	var _en268 = _interopRequireDefault(_en267);
	
	var _en269 = __webpack_require__(425);
	
	var _en270 = _interopRequireDefault(_en269);
	
	var _en271 = __webpack_require__(426);
	
	var _en272 = _interopRequireDefault(_en271);
	
	var _en273 = __webpack_require__(427);
	
	var _en274 = _interopRequireDefault(_en273);
	
	var _en275 = __webpack_require__(428);
	
	var _en276 = _interopRequireDefault(_en275);
	
	var _en277 = __webpack_require__(429);
	
	var _en278 = _interopRequireDefault(_en277);
	
	var _en279 = __webpack_require__(430);
	
	var _en280 = _interopRequireDefault(_en279);
	
	var _en281 = __webpack_require__(431);
	
	var _en282 = _interopRequireDefault(_en281);
	
	var _en283 = __webpack_require__(432);
	
	var _en284 = _interopRequireDefault(_en283);
	
	var _en285 = __webpack_require__(433);
	
	var _en286 = _interopRequireDefault(_en285);
	
	var _en287 = __webpack_require__(434);
	
	var _en288 = _interopRequireDefault(_en287);
	
	var _en289 = __webpack_require__(435);
	
	var _en290 = _interopRequireDefault(_en289);
	
	var _en291 = __webpack_require__(436);
	
	var _en292 = _interopRequireDefault(_en291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Section 4 diagrams
	
	
	// Section 3 diagrams
	
	
	// Section 1 diagrams
	
	
	// Section 1
	var i18nEN = exports.i18nEN = angular.extend({}, _en2.default,
	
	// Common components and public pages
	_en32.default, _en36.default, _en34.default, _en4.default, _en6.default, _en8.default, _en10.default, _en12.default, _en14.default, _en16.default, _en18.default, _en20.default, _en22.default, _en24.default, _en26.default, _en28.default, _en30.default,
	
	// Section 1
	_en38.default, _en40.default, _en42.default, _en44.default,
	
	// Section 1 diagrams
	_en46.default, _en48.default, _en50.default, _en52.default, _en54.default, _en56.default, _en58.default, _en60.default, _en62.default, _en64.default, _en66.default, _en68.default, _en70.default, _en72.default, _en74.default, _en76.default, _en78.default,
	
	// Section 2
	_en80.default, _en82.default,
	
	// Section 2 diagrams
	_en84.default, _en86.default, _en88.default, _en90.default, _en92.default, _en94.default, _en96.default, _en98.default, _en100.default, _en102.default,
	
	// Section 3
	_en104.default, _en106.default, _en108.default, _en110.default, _en112.default, _en114.default, _en116.default, _en118.default, _en120.default,
	
	// Section 3 diagrams
	_en122.default, _en124.default, _en126.default, _en128.default, _en130.default, _en132.default, _en134.default, _en136.default, _en138.default, _en140.default, _en142.default, _en144.default, _en146.default, _en148.default, _en150.default, _en152.default, _en154.default, _en156.default, _en158.default, _en160.default, _en162.default, _en164.default, _en166.default, _en168.default, _en170.default, _en172.default, _en174.default, _en176.default, _en178.default, _en180.default, _en182.default, _en184.default, _en186.default, _en188.default, _en190.default, _en192.default, _en194.default, _en196.default, _en198.default, _en200.default, _en202.default, _en204.default, _en206.default, _en208.default, _en210.default, _en212.default, _en214.default,
	
	// Section 4
	_en216.default, _en224.default, _en218.default, _en220.default, _en222.default,
	
	// Section 4 diagrams
	
	_en226.default, _en228.default, _en230.default, _en232.default, _en234.default,
	
	// Section 5
	_en236.default, _en238.default, _en240.default, _en242.default,
	
	// Section 5 diagrams
	_en244.default, _en246.default, _en248.default, _en250.default, _en252.default, _en254.default, _en256.default, _en258.default, _en260.default, _en262.default, _en264.default, _en266.default, _en268.default, _en270.default, _en272.default, _en274.default, _en276.default, _en278.default, _en280.default, _en282.default, _en284.default, _en286.default, _en288.default,
	
	// Unit 6
	_en290.default, _en292.default);
	
	// Section 5 diagrams
	
	
	// Section 5
	
	
	// Section 4
	
	
	// Section 3
	
	
	// Section 2 diagrams
	
	
	// Section 2
	
	
	// Common components
	
	
	// Public pages

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'next': 'Next',
	    'complete': 'Complete',
	    'submit': 'Submit',
	    'resubmit': 'Resubmit',
	    'reset': 'Reset',
	    'correct': 'Correct',
	    'hint': 'Hint',
	    'simplest_structure': 'Simplest Structure'
	};

/***/ }),
/* 292 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	exports.default = {
					'barbara': {
									text: '<p>\n\t\t\t\t\tBarbara Minto holds an MBA from the Harvard Business School. Her Course reflects insights drawn from more than 30 years of\n\t\t\t\t\tconducting courses worldwide at major consulting firms and corporations. Indeed, the phrase \u201CTake this and make it Minto\u201D\n\t\t\t\t\tis common in many of these organizations and the Minto Pyramid Principle is considered the \u2018lingua franca\u2019 for serious-minded\n\t\t\t\t\tprofessionals, especially those who want to be listened to and earnestly wish to advance their careers.\n\t\t\t\t</p>\n\t\t\t\t<!-- <p>Barbara Minto\u2019s Wikipedia page.</p> -->'
					}
	};

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'concept': {
			'text': '<div class="content-caption-box">\n\t\t\t\t<h3 class="content-caption">The Minto Pyramid Principle\xAE Concept</h3>\n\t\t\t</div>\n\t\t\t<p class="content-text">The Minto Pyramid Principle is a technique to help you work out and organize your thinking before you attempt to communicate\n\t\t\t\tit.\n\t\t\t</p>\n\t\t\t<p class="content-text">It states that a clear piece of writing will always consist of groups of related ideas, each group summarized to form\n\t\t\t\tthe next level of a pyramid, rising to a single pyramid with a single point at the top. And that the relationships between\n\t\t\t\tideas at every level within that pyramid, both vertically and horizontally, will obey a set of strict logical rules.</p>\n\t\t\t<p class="content-text">Before you begin to write, therefore, you want to force your ideas to fit that pyramid form, and make sure they obey the\n\t\t\t\tlogical rules. Communicating your thinking then requires only that you guide your reader down the pyramid.</p>\n\t\t\t<p class="content-text">So far, so clear. The hard part is forcing your thinking to fit the pyramid form, particularly given that you rarely know\n\t\t\t\tprecisely what all your ideas are before you attempt to arrange them into related groupings. So the thinking process\n\t\t\t\tconsists of pulling the ideas out of your head and fitting them together in a pyramid.</p>\n\t\t\t<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate the ideas and to organize\n\t\t\t\tthem at the same time. Thus avoiding the need to write countless drafts before you settle on your message.</p>'
		}
	};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'online': {
	        'login': 'Log In',
	        'try_course': 'Try Course',
	        'testimonials': 'Testimonials',
	        'barbara_minto': 'Video',
	        'buy_course': 'Buy <br> Course',
	        'corporate_inquiry': 'Corporate Inquiry',
	        'text': '<img src="/assets/images/coming-soon.png" alt="coming-soon" title="coming-soon" />\n            <div class="content-caption-box">\n                <h3 class="content-caption">The 2021 online course: Fully rewritten, with all new technology</h3>\n            </div>\n            <p class="content-text">The completely new Minto Online Course is a pinnacle in digital learning, reflecting 30 years of teaching and\n                development. It is easily the world\u2019s most complete computer teaching system for business writing and thinking.\n            </p>'
	    }
	};

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'thank-you': {
	        'caption': 'Thank you for your purchase.',
	        'text': 'In the next few moments, you will receive and confirmation email.\n        <br/>If not, please <!-- take note of this reference: 000000\n        <br/>and --> contact us immediately.',
	        'main': 'Main page',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 296 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'payment-failure': {
	        'caption': 'Sorry, your payment did not go through.',
	        'text': 'No money has been deducted from your account.\n        <br/>Please try again using the form provided.\n        <br/>If you continue to encounter problems please contact us directly.',
	        'main': 'Main page',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'livecourse': {
	    'text': '<h3 class="content-heading">Barbara Minto holds an MBA from Harvard Business School. She personally conducts a world-renowned 2-day course for professional\n        people in how to use the Minto Pyramid Principle to shorten the time you spend writing.</h3>\n      <div class="content-caption-box">\n        <h3 class="content-caption">The Course</h3>\n      </div>\n      <p class="content-text">Organized for groups of 10-14 within a single company, the course shows how to use the pyramid rules to discover and clarify\n        the points you want to make. And it explains the value of the unique Situation-Complication-Question framework (SCQ Framework\n        tm) to identify the question your document is being written to answer. She also offers a shortened, 1-day version of\n        the basics as a refresher for people who already have some knowledge of the Minto Pyramid Principle.</p>\n      <div class="content-caption-box">\n        <h3 class="content-caption">The Content</h3>\n      </div>\n      <p class="content-text">The 2-day course is structured around the work of the people in the group. To this end, Barbara asks each person attending\n        to send her in advance a lengthy sample of his work. She then reads these, draws pictures of their structures, develops\n        new structures, and uses them as examples in the course.</p>\n      <p class="content-text">Both the 2-day and 1-day courses include an individual tutoring session with Barbara at the end of the formal sessions.\n        She meets personally with each person for 45-minutes to help him apply the pyramid-building process to something he is\n        about to write. It is this tutoring session that makes the technique "take". </p>\n      <p class="content-text">Barbara\u2019s courses are based on a similar course she developed and taught for several years at McKinsey & Company, Inc.,\n        the international management consulting firm. In addition to teaching McKinsey\u2019s consultants and many of its clients,\n        as well as all of the other major consulting firms, she has lectured at the Harvard, MIT, Stanford, Chicago, London and\n        Manchester business schools, and at the State University of New York.</p>\n      <p class="content-text">To find out more about Barbara\u2019s courses, e-mail inquiries@barbaraminto.com</p>\n\n      <img src="/assets/images/livecourse-img.png" alt="" class="content-img">'
	  }
	};

/***/ }),
/* 298 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'workbook': {
	        'text': '<div class="content-caption-box">\n                <h3 class="content-caption">The Minto Pyramid Principle\xAE Self-Study Course</h3>\n            </div>\n            <p class="content-text">\n                For people who prefer to study from a printed workbook, this course, developed in 1996, is still available for individuals.\n                <br> The video portion supplied in CD-ROM or DVD form, plus the book and workbook. This version is priced\n                at $1,500 plus postage and handling from New York.\n            </p>\n            <ul class="list__content-text">\n                <li>\n                    <p class="content-text">It consists of a 35-minute video overview of the concept plus a copy of the textbook, and an extensive\n                        workbook of exercises.\n                    </p>\n                </li>\n                <li>\n                    <p class="content-text">\n                        You can also for the moment access the highly successful internet version, with video and exercises interlinked. You will\n                        receive a free upgrade to the all-new online course when it becomes available later in the year.\n                        <br> - This original version is available for 4 months over the Internet at a cost of $1500.\n                        <br> - Once your order has entered our system, you will be contacted by minto.sales@comcast.net\n                        with Course Log-In Instructions. Upon registration you will also receive the copy of the textbook.\n                    </p>\n                </li>\n            </ul>\n            <p class="content-text">Note: The Internet version requires Internet Explorer. It will not function in Firefox or Safari.</p>'
	    }
	};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'summary': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">The Minto Pyramid Principle\xAE App</h3>\n      </div>\n      <p class="content-text">\n        You may also download an app that summarizes what Barbara teaches in her live course. Created as a quick reference for people\n        who have already had the course, it also serves as an easy way for you quickly to find the concepts that are explained\n        in the book.\n      </p>\n      <p class="content-text">\n        It requires cellular data connect or wifi, and can be found on Apple iTunes Stores for $14.99. An Android version is also\n        available from Googleplay.\n      </p>\n      <p class="content-text">\n        Please note that the summary provides only an insight into the thinking behind the Minto Pyramid Principle; it does not actually\n        teach how to apply it to your work. That, alas, takes deeper explanation and practice!\n      </p>'
	  }
	};

/***/ }),
/* 300 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'textbook': {
			'text': '<div class="content-caption-box">\n\t\t\t\t<h3 class="content-caption">The Minto Pyramid Principle\xAE Textbook</h3>\n\t\t\t</div>\n\t\t\t<p class="content-text"><dfn>The Minto Pyramid Principle:  Logic in Writing, Thinking and Problem Solving</dfn> (2010 edition) explains the technique\n\t\t\t\tfor helping you work out and organize your thinking before you attempt to communicate it. In 12 chapters and 3 appendices,\n\t\t\t\tit explains how the pyramid works, how to pull your thinking together to create a pyramid structure, and how to look\n\t\t\t\tcritically at the ideas you assemble so as to glean actual insights from them vs simply presenting them as lists of \u201Creasons\u201D\n\t\t\t\tor \u201Cissues\u201D.</p>\n\t\t\t<p class="content-text">The book also has a section on problem definition and problem analysis, useful in situations where you are writing to\n\t\t\t\tpresent the solution to a problem, or explaining how you will go about solving one</p>\n\t\t\t<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate your ideas and to organize\n\t\t\t\tthem at the same time. Thus avoiding the need to write countless drafts before you can figure out your message.</p>\n\t\t\t<p class="content-text">The book has become the standard text used by all of the major consulting firms worldwide, many organizations, and some\n\t\t\t\tgovernment offices. It is in fact the book that changed the consulting industry, and the phrase \u201CTake this and make it\n\t\t\t\tMinto\u201D is common in many companies. It has been translated into. . .Chinese, French, German, Japanese, Korean, Portuguese,\n\t\t\t\tand Viet Namese.</p>\n\t\t\t<p class="content-text">The cost of the book is $135 plus postage from New York. Bona fide students wishing to buy the book should e-mail Barbara\n\t\t\t\tMinto directly at barminto@aol.com to apply for a student discount.</p>\n\n\t\t\t<p class="proposal-heading content-text"><b>Note:</b> This book supersedes <dfn>The Pyramid Principle: Logic in Writing and Thinking</dfn> [1987, reissued in London\n\t\t\t\t2002], which consists of 9 chapters and 1 appendix.</p>'
		}
	};

/***/ }),
/* 301 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'contact': {
	        'caption': 'Please use the form to send a message or contact us through the relevant offices.',
	        'adress-1': '<h3 class="contact-adress__head">London Office (MAIN):</h3>\n                    <p class="contact-adress__info">Minto International, Inc.<br>19 Cadogan Place<br>London SW1X 9SA UK<br>Tel: +44 (0)207 235 6274\n                    <!--<br>email: enquiries@barbaraminto.com-->\n                    </p>',
	        'adress-2': '<h3 class="contact-adress__head">Virginia Office:</h3>\n                    <p class="contact-adress__info">\n                        Minto International, Inc.\n                        <br>215 Brooke Avenue. No. 609\n                        <br>Norfolk, VA 23510 USA\n                        <br>Tel: +1 757 425 4511\n                        <!--<br>email: inquiries@barbaraminto.com-->\n                    </p>'
	    }
	};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'press': {
	        'text': '<div class="content-caption-box">\n                <h3 class="content-caption">Press Inquiries</h3>\n            </div>\n            <h3 class="content-heading">Press contact and press pack download area</h3>\n            <p class="content-text">This area is reserved for press and news agencies who would like further information on the course, the Minto Foundation and materials to use in article and TV. Please <a ui-sref="site.contact">get in contact</a> for further information or comment.\n            </p>'
	    }
	};

/***/ }),
/* 303 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'tc': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">Terms and Conditions</h3>\n      </div>\n      <h4 class="content-text">Privacy and security statement</h4>\n      <p class="content-text">At Minto Books International, Inc. we respect the privacy of every individual who visits our website, communicates with us or purchases our products online. The information you give to us is used to process your order and to provide you with efficient service. We do not trade, rent or sell your details to any third parties. Should our intentions change it will be done only with your authorisation. We will always comply with any data protection legislation currently in force.<br>\n        <br>\n        This statement outlines the information Minto Books International, Inc. will collect from the website and how we will use that information. This statement also lets you know what to do if you want us to remove personal information about you collected or stored during previous visits to the website.\n      </p>\n      <h4 class="content-text">How we collect and use personal information</h4>\n      <p class="content-text">We follow strict security procedures in the collection, storage and disclosure of the information you have given us to prevent unauthorised access and misuse. <br>\n        <br>\n        We do not collect any personally identifying information from you unless you register on the website or purchase our products from the website. In doing, so you expressly consent to expressly consent to the terms and conditions of this statement. Upon receiving your express consent, we only collect such personally identifying information that we specifically need - for example, to send you a brochure, to fulfil an order or to provide account details. Upon receiving your express consent, we only collect such personally identifying information that we specifically need - for example, to send you a brochure, to fulfil an order or to provide account details. <br>\n        <br>\n        If you do not want us to collect any personally identifiable information from you, please do not provide us with any such information. We gather non-specific information on the numbers of visitors to certain areas of our website without asking for your consent to do so, so that website usage can be monitored to help us continually improve the design and layout of our website. <br>\n        <br>\n        If you do provide us with personal information, we may retain and use that information for the following purposes:\n      </p>\n      <ul class="list__content-text">\n        <li>\n          <p class="content-text">We may store and process the information to better understand your needs and how we can improve our products and services\n          </p>\n        </li>\n        <li>\n          <p class="content-text">We may retain information for invoicing and delivery purposes after you make a purchase of our products\n          </p>\n        </li>\n        <li>\n          <p class="content-text">We may retain information about your previous purchases in order to customise our website services for your future visits to the website.\n          </p>\n        </li>\n      </ul>\n      <p class="content-text">In addition, we may use your e-mail address to send you information about new products or special offers which we think may be of interest to you, to advise you of important changes to the website or for other marketing purposes. <br>\n        <br>\n        We may also disclose any information, including personally identifiable information, we deem necessary, in our sole discretion, to comply with any applicable law, regulation, legal process or governmental request. <br>\n        <br>\n        All of your personal information will be stored securely for the duration of your relationship with us and for 5 years thereafter. <br>\n        <br>\n        Personal information provided to us on our website may be transmitted over the Internet. Transfers of personal information may therefore take place, potentially, to any country in the world.\n      </p>\n      <h4 class="content-text">Delivery</h4>\n      <p class="content-text">We aim to despatch all orders within 2 to 7 days if the goods are in stock. In the unlikely event that the goods you order are \u201COut of Stock\u201D, we will contact you to inform you within those 7 days.\n      </p>\n      <h4 class="content-text">Cancellation</h4>\n      <p class="content-text">You can cancel an order and return any goods that may have already been despatched up to 7 days from receipt (see returns policy). Our terms and conditions do not affect your statutory rights.\n      </p>\n      <h4 class="content-text">Returns Policy</h4>\n      <p class="content-text">If you are not satisfied with the purchase of a book or a course (excluding the on-line course) you may return the product unused together with its packaging within 7-days of receipt for a full refund less of any postage costs. Please contact us <a ui-sref="site.contact">here</a> to find out how.\n      </p>'
	  }
	};

/***/ }),
/* 304 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'policies': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">Privacy Policy</h3>\n      </div>\n      <p class="content-text">\n        This privacy policy is for this website www.barbaraminto.com and served by Minto Books International, Inc. and governs the privacy of its users who choose to use it.\n        <br>\n        <br>\n        The policy sets out the different areas where user privacy is concerned and outlines the obligations & requirements of the users, the website and website owners. Furthermore the way this website processes, stores and protects user data and information will also be detailed within this policy.\n      </p>\n      <h4 class="content-text">The Website</h4>\n      <p class="content-text">\n        This website and its owners take a proactive approach to user privacy and ensure the necessary steps are taken to protect the privacy of its users throughout their visiting experience. This website complies to all UK national laws and requirements for user privacy.\n      </p>\n      <h4 class="content-text">Use of Cookies</h4>\n      <p class="content-text">This website uses cookies to better the users experience while visiting the website. Where applicable this website uses a cookie control system allowing the user on their first visit to the website to allow or disallow the use of cookies on their computer / device. This complies with recent legislation requirements for websites to obtain explicit consent from users before leaving behind or reading files such as cookies on a user\'s computer / device.<br>\n        <br>\n        Cookies are small files saved to the user\'s computers hard drive that track, save and store information about the user\'s interactions and usage of the website. This allows the website, through its server to provide the users with a tailored experience within this website.<br>\n        <br>\n        Users are advised that if they wish to deny the use and saving of cookies from this website on to their computers hard drive they should take necessary steps within their web browsers security settings to block all cookies from this website and its external serving vendors.<br>\n        <br>\n        This website uses tracking software to monitor its visitors to better understand how they use it. This software is provided by Google Analytics which uses cookies to track visitor usage. The software will save a cookie to your computers hard drive in order to track and monitor your engagement and usage of the website, but will not store, save or collect personal information. You can read Google\'s privacy policy here for further information <a href="http://www.google.com/privacy.html" target="_blank">http://www.google.com/privacy.html</a>.<br>\n        <br>\n        Other cookies may be stored to your computers hard drive by external vendors when this website uses referral programs, sponsored links or adverts. Such cookies are used for conversion and referral tracking and typically expire after 30 days, though some may take longer. No personal information is stored, saved or collected.\n      </p>\n      <h4 class="content-text">Contact & Communication</h4>\n      <p class="content-text">Users contacting this website and/or its owners do so at their own discretion and provide any such personal details requested at their own risk. Your personal information is kept private and stored securely until a time it is no longer required or has no use, as detailed in the Data Protection Act 1998. Every effort has been made to ensure a safe and secure form to email submission process but advise users using such form to email processes that they do so at their own risk.<br>\n        <br>\n        This website and its owners use any information submitted to provide you with further information about the products / services they offer or to assist you in answering any questions or queries you may have submitted. This includes using your details to subscribe you to any email newsletter program the website operates but only if this was made clear to you and your express permission was granted when submitting any form to email process. Or whereby you the consumer have previously purchased from or enquired about purchasing from the company a product or service that the email newsletter relates to. This is by no means an entire list of your user rights in regard to receiving email marketing material. Your details are not passed on to any third parties.\n      </p>\n      <h4 class="content-text">Email Newsletter</h4>\n      <p class="content-text">This website operates an email newsletter program, used to inform subscribers about products and services supplied by this website. Users can subscribe through an online automated process should they wish to do so but do so at their own discretion. Some subscriptions may be manually processed through prior written agreement with the user.<br>\n        <br>\n        Subscriptions are taken in compliance with UK Spam Laws detailed in the Privacy and Electronic Communications Regulations 2003. All personal details relating to subscriptions are held securely and in accordance with the Data Protection Act 1998. No personal details are passed on to third parties nor shared with companies / people outside of the company that operates this website. Under the Data Protection Act 1998 you may request a copy of personal information held about you by this website\'s email newsletter program. A small fee will be payable. If you would like a copy of the information held on you please write to the business address at the bottom of this policy.<br>\n        <br>\n        Email marketing campaigns published by this website or its owners may contain tracking facilities within the actual email. Subscriber activity is tracked and stored in a database for future analysis and evaluation. Such tracked activity may include; the opening of emails, forwarding of emails, the clicking of links within the email content, times, dates and frequency of activity [this is by no far a comprehensive list].<br>\n        <br>\n        This information is used to refine future email campaigns and supply the user with more relevant content based around their activity.<br>\n        <br>\n        In compliance with UK Spam Laws and the Privacy and Electronic Communications Regulations 2003 subscribers are given the opportunity to un-subscribe at any time through an automated system. This process is detailed at the footer of each email campaign. If an automated un-subscription system is unavailable clear instructions on how to un-subscribe will by detailed instead.\n      </p>\n      <h4 class="content-text">External Links</h4>\n      <p class="content-text">Although this website only looks to include quality, safe and relevant external links, users are advised adopt a policy of caution before clicking any external web links mentioned throughout this website. (External links are clickable text / banner / image links to other websites, similar to; Folded Book Art or Cottages in Pembrokeshire.)<br>\n        <br>\n        The owners of this website cannot guarantee or verify the contents of any externally linked website despite their best efforts. Users should therefore note they click on external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned.\n      </p>\n      <h4 class="content-text">Adverts and Sponsored Links</h4>\n      <p class="content-text">This website may contain sponsored links and adverts. These will typically be served through our advertising partners, to whom may have detailed privacy policies relating directly to the adverts they serve.<br>\n        <br>\n        Clicking on any such adverts will send you to the advertisers website through a referral program which may use cookies and will track the number of referrals sent from this website. This may include the use of cookies which may in turn be saved on your computers hard drive. Users should therefore note they click on sponsored external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned.\n      </p>\n      <h4 class="content-text">Social Media Platforms</h4>\n      <p class="content-text">Communication, engagement and actions taken through external social media platforms that this website and its owners participate on are custom to the terms and conditions as well as the privacy policies held with each social media platform respectively.<br>\n        <br>\n        Users are advised to use social media platforms wisely and communicate / engage upon them with due care and caution in regard to their own privacy and personal details. This website nor its owners will ever ask for personal or sensitive information through social media platforms and encourage users wishing to discuss sensitive details to contact them through primary communication channels such as by telephone or email.<br>\n        <br>\n        This website may use social sharing buttons which help share web content directly from web pages to the social media platform in question. Users are advised before using such social sharing buttons that they do so at their own discretion and note that the social media platform may track and save your request to share a web page respectively through your social media platform account.\n      </p>\n      <h4 class="content-text">Shortened Links in Social Media</h4>\n      <p class="content-text">This website and its owners through their social media platform accounts may share web links to relevant web pages. By default some social media platforms shorten lengthy urls [web addresses].<br>\n        <br>\n        Users are advised to take caution and good judgement before clicking any shortened urls published on social media platforms by this website and its owners. Despite the best efforts to ensure only genuine urls are published many social media platforms are prone to spam and hacking and therefore this website and its owners cannot be held liable for any damages or implications caused by visiting any shortened links.\n      </p>'
	  }
	};

/***/ }),
/* 305 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    course: {
	        unit: {
	            '2a': 'How the Ideas Fit Together',
	            '2b': '{{name}} - Creating a Question/Answer Dialogue'
	        }
	    },
	    dashboard: {
	        'currently-on-section': 'You are currently on section',
	        'progress': '{{name}}You have completed <span class="course-info__marked percentege">{{count}}%</span> of the course',
	        'logout': 'Logout'
	    }
	};

/***/ }),
/* 306 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'nav': {
	        'concept': 'Concept',
	        'live_course': 'Live Course',
	        'online_course': 'Online Course',
	        'workbook_course': 'Workbook Course',
	        'summary_app': 'Summary App',
	        'textbook': 'Minto Textbook',
	        'barbara_minto': 'Barbara Minto',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'header': {
	        'barbara_minto': 'Barbara Minto',
	        'concept': 'Pyramid Concept',
	        'contact': 'Contact',
	        'corporate_inquiry': 'Corporate Inquiry',
	        'liveMintoCourse': 'Live Minto Course',
	        'policies': 'Policies',
	        'summary': 'Barbara in your pocket',
	        'press': 'Press',
	        'T&Cs': 'T&Cs',
	        'textbook': 'Textbook',
	        'workbook': 'Original Workbook Course',
	        'login': 'Log In',
	        'buy': 'Buy the course',
	        'testimonials': 'Testimonials',
	        'online': 'Online Course',
	        'error404': 'Error 404',
	        'dashboard': '',
	        'thankYou': 'Thank You',
	        'paymentFailure': 'Payment Failure',
	        'userSettings': 'User Settings'
	    }
	};

/***/ }),
/* 308 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'footer': {
	        'logOut': 'Log Out',
	        'logIn': 'Log In',
	        'tc': 'T & C',
	        'share': 'Share',
	        'language': 'Language',
	        'policies': 'Policies',
	        'press': 'Press',
	        'error404': 'Error 404'
	    }
	};

/***/ }),
/* 309 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'imposing-the-structure': {
	    'course-name': 'Section 1A <span class="unit-title">Imposing the Structure<span>',
	    'course-name-pyramid': 'Imposing the Structure',
	    'course-video': {
	      'title': 'Section 1 THE BASIC PYRAMID <br>00:00 - 54:00 1A WHAT THE COURSE WILL DO <br>-: ex 1A imposing the structure',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      lectureTitle: '1A Lecture'
	    },
	    'unit-section-title': '1A Exercises',
	    'unit-exercise-description': {
	      'title': 'The first skill you want to develop is the ability to see the existing structure that underlies a piece of writing, particularly the writing of subordinates. You can then look at it critically, as the basis for developing a proper pyramid structure. Following are four typical documents plus their before-and-after structures. Then we show a clearer version of each with a blank pyramid. Can you fill in what the points in the pyramid should be?',
	      'exercise-1': 'Note to Mort (Demo)',
	      'exercise-2': 'Retail Price Data Survey',
	      'exercise-3': 'Electronic Filing',
	      'exercise-4': 'Perfect Team Size',
	      'bottom-info': 'You will also note that we have stated the essence of the points in each box, using the fewest possible words. This is a technique you will want to employ later, when you begin to build pyramids of your own.'
	    },
	    'exercise-one': {
	      'original-note-title': 'Original note',
	      'original-note': 'Mort<br>\n            <br>\n            John Collins telephoned to say that he can\u2019t make the meeting at 3:00. Hal Johnson says he doesn\u2019t mind making it later, or even tomorrow, but not before 10:30, and Don Clifford\u2019s secretary says that Clifford won\u2019t return from Frankfurt until tomorrow, late. The conference room is booked tomorrow, but free Thursday. Thursday at 11:00 looks to be a good time. Is that okay with you?',
	
	      'clearer-note-title': 'Clearer note',
	      'clearer-note': 'Mort<br>\n            <br>\n            Could we reschedule today\u2019s 3:00 meeting to Thursday at 11:00? This would be more convenient for Collins and Johnson, and would permit Clifford to be present. It is also the only other time this week that the conference room is free.',
	      'exercise-number': '1A - Exercise 1',
	      'exercise-title': 'Note to Mort (Demo)',
	      'task-title': 'Original structure',
	      'structured-blocks': {
	        'structured-block-1': 'JC-not today <br> HJ-tomorrow after <br> 10:30 <br> DC-not before Thursday',
	        'structured-block-2': 'Room not tomorrow <br> Room OK Thursday',
	        'structured-block-3': 'Is Thursday OK with you?'
	      }
	    },
	    'exercise-two': {
	      'original-note-title': 'Original memo',
	      'memo-paper-1': 'To:<br> From:\n                    <br> Subject: Retail Price Data Survey<br>\n                    <br> On April 23 we recommended two enhancements to the\n                    reporting characteristics of the Retail Price Data Survey. In addition to these suggestions we recommend\n                    that consideration be given to updating the stores actually being surveyed. At the present time we have\n                    a considerable number of non-keeper stores (including garages, grocery stores, etc.) being surveyed,\n                    which tend to distort the actual market price. Of the 705 Arc Oil stores being surveyed,\n                    only 243 or 34% are classified as \u201CA\u201D stores or long-range keepers. These are our high-volume stores,\n                    where competitiveness is most important and therefore, we feel the 34% being surveyed do not give us\n                    a true reading as to the actual price conditions in our key markets. In fact, we recommend that consideration\n                    be given to surveying only \u201CA\u201D type stores. Obviously, if we modify the Arc Oil surveyed stores, we will\n                    also have to modify the competitive stores to make them compatible. <br>\n                    <br> Finally, we recommend that the program\u2019s built-in 50-50 ratio for self-serve be modified to 70-30,\n                    which is more in line with current experience. <br>\n                    <br> Mort, the increasing importance of the RPDS makes it imperative that we take whatever steps necessary\n                    to ensure that the data surveyed is truly reflective of the marketplace. <br>\n                    <br> Your assistance will be appreciated.',
	      'exercise-number': '1A - Exercise 2',
	      'exercise-title': 'Retail Price Data Survey',
	      'task-title-leftcolumn': 'Clearer memo',
	      'memo-paper-2': 'To:<br> From:\n                    <br> Subject: Retail Price Data Survey <br>\n                    <br> As you know, the increasing importance of the RPDS makes it imperative that the data collected truly\n                    reflect the marketplace. To this end, we recommend that consideration be given to updating the stores\n                    actually being surveyed, as follows: <br>\n                    <br>\n                    <b>1. Survey only \u201CA\u201D type stores.</b> At the present time we have a considerable number of nonkeeper\n                    stores (including garages, grocery stores, etc.) being surveyed, which tends to distort the actual market\n                    price. Of the 705 Arc Oil stores being surveyed, only 243 or 34% are classified as \u201CA\u201D stores (or long-range\n                    keepers). These are our high-volume stores where competitiveness is most important. Surveying only 34%\n                    does not give us a true reading of the actual price conditions in our key markets.<br>\n                    <br>\n                    <b>2. Shift the competitive stores to match.</b> Obviously if we modify the Arc Oil surveyed stores,\n                    we will also have to modify competitive stores to make them compatible.<br>\n                    <br>\n                    <b>3. Change the self-serve ratio from 50-50 to 70-30.</b> This figure is more in line with current experience.<br>\n                    <br> Your assistance is very much appreciated.\n                    <br>\n                    <br>\n                    <br>\n                    <br>'
	    },
	    'exercise-three': {
	      'original-note-title': 'Original memo',
	      'memo-paper-1': '<b>ELECTRONIC FILING</b><br>\n                    <br> Despite its inherent benefits, there are questions about the practicality and cost-effectiveness\n                    of electronic filing. Perceived barriers to adoption are:<br>\n                    <br>\n                    <b>1.\t Organizational</b><br> a. No single point of responsibility for documents (information) as an\n                    organizational resource <br> b. Systematic sharing of files requires behavioral changes <br> c. There\n                    is no organizational awareness of the real costs associated with document handling <br> d. Electronic\n                    filing is an organizational concept, not just task automation<br>\n                    <br>\n                    <b>2.\t Information indexing need</b><br> a. Indexing standards are essential - \u201Cnew role.\u201D <br> b. People\n                    won\u2019t tolerate indexing as an add-on task, separate from document creation (or receipt, if it is e-mail)\n                    <br> c. Content analysis for indexing/retrieval is highly desired<br>\n                    <br>\n                    <b>3. \tTechnology</b><br> a. There has been insufficient penetration of personal workstation use\n                    <br> b. Technology inserted between individuals and files is potentially threatening<br>\n                    <br>\n                    <b>4.\t\tBenefits</b><br> a. Cost performance and functionality are not sufficient to meet identified needs\n                    <br> b. There is no compelling business need... and many subtle costs associated with electronic filing\n                    <br> c. Decision makers don\u2019t think filing is a problem <br>',
	      'exercise-number': '1A - Exercise 3',
	      'exercise-title': 'Electronic Filing',
	      'task-title-fullwidth': 'Original discussion agenda',
	      'task-title-leftcolumn': 'Clearer Agenda',
	      'memo-paper-2': 'ELECTRONIC FILING <br>\n                    <br> Businesses are unlikely to adopt electronic filing in the near future. <br>\n                    <br> 1. Decision makers don\u2019t think filing is a problem <br>\n                    <ul>\n                      <li>They have no awareness of the real cost</li>\n                      <li>There is no organizational way for them to become aware</li>\n                    </ul>\n                    <br> 2. Systems available are expensive and not very effective <br>\n                    <br> 3. Utilizing them would require enormous, costly behavioral change that people are unlikely to accept\n                    <br>\n                    <ul>\n                      <li>They will not want to be separated from their files</li>\n                      <li>They will not easily accept the need to share files</li>\n                      <li>They will not tolerate indexing as an add-on task</li>\n                    </ul>\n                    <br>\n                    <br>\n                    <br>'
	    },
	    'exercise-four': {
	      'exercise-number': '1A - Exercise 4',
	      'exercise-title': 'Perfect Team Size',
	      'task-title-fullwidth': 'Original newspaper article',
	      'memo-paper-1': 'WITH TEAMS, MANY HANDS DO NOT MAKE LIGHT WORK <br>\n                    <br> Numerous studies confirm that, when it comes to teams, four to six members is the best team size\n                    for most tasks, that no work team should have more than ten members, and that performance problems increase\n                    \u201Cexponentially as team size increases.\u201D These troubles arise because large teams place an often overwhelming\n                    \u201Ccognitive load\u201D on members. Most of us are able to mesh our efforts and maintain good personal relationships\n                    with, say, three or four teammates. But as a group expands, each member devotes more time to coordination\n                    of chores (and less time to actually doing the work), more handovers between members are required (creating\n                    opportunities for miscommunication and mistakes), and because each member must divide his or her attention\n                    among a longer list of colleagues, the team\u2019s social glue weakens (and destructive conflict soars).<br>',
	      'task-title-fullwidth-2': 'Clearer article',
	      'memo-paper-2': 'WITH TEAMS, MANY HANDS DO NOT MAKE LIGHT WORK <br>\n                    <br> Numerous studies confirm that four to six members is the best team size for most tasks, and that\n                    no work team should have more than 10 members. Performance problems inevitably increase with team size,\n                    as more time is required for organization and explanation, the time available to do the work decreases,\n                    and chances of destructive conflict grow. <br>\n                    <br> As a group expands, each member devotes more time to coordinating chores and to performing handovers\n                    to each other. There is thus less time to do the actual work, but many more opportunities for miscommunication\n                    and mistakes, so that they do the work less efficiently. And because each member must divide his or her\n                    personal attention among a longer list of colleagues, the team\u2019s social glue weakens, and the sense\n                    of enjoyment in being part of the group diminishes.\n                    <br>\n                    <br>'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 1A',
	    'final-description': 'You see that arranging ideas in a pyramid allows you to see the thinking more clearly',
	    'next-course-button': 'Proceed to 1B',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 310 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'cementing-the-rules': {
	    'course-name': 'Section 1C <span class="unit-title">Picking out the Points<span>',
	    'course-title': 'Picking out the Points',
	    'course-video': {
	      'title': 'Section 1 THE BASIC PYRAMID <br>07:39 - 21:01 1C THE TOP DOWN APPROACH <br>-: ex 1C Picking out the points',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '1C Lecture'
	    },
	    'unit-section-title': '<span>1C Exercises</span>',
	    'unit-exercise-description': '<p class="unit-exercise-description-text">\n        Once you have the structure of your thinking clear to yourself, you are ready to communicate it to the reader. In general, you will start at the top of the pyramid and work down each leg in turn. The structure serves as the outline governing the flow, but you have some liberty to dress it up with words that add emotion, interest, and even elegance to what you are saying. You can also change the order of the points. But the reader must still be able to see the structure in order to grasp your message.\n        </p>\n        <p>\n        Following are four examples of good pyramids that will give you practice in seeing structures embedded in prose.\n        </p>',
	    'exercise-description-bottom': 'I have highlighted the points made in each paragraph, and listed them separately. Please drag each point to fit its proper place in the pyramid.',
	    'exercise-one': {
	      'exercise-number': '1C - Exercise 1',
	      'exercise-title': 'Firestone’s Commitment',
	      'exercise-description': 'In terms of building expertise, Harvey Firestone’s <span class="marked">most important commitment was his initial move to Akron</span>, Ohio, in 1910. As the tire industry grew, an <span class="marked">ecosystem of supporting institutions </span>cropped up in America’s rubber capital, including a college that offered the nation’s first rubber chemistry course, technical testing firms, and the leading industry trade journal. The Portage Country Club, founded by two B. F. Goodrich Executives, provided the <span class="marked">social setting</span> where the founders, managers, researchers, and investors in tire companies congregated <span class="marked">to socialize and talk shop</span>. By committing to Akron, Firestone insured that he and his employees remained in the flow of technical and business information, which helped them stay <span class="marked">on the cutting edge of rubber technology</span>. Akron firms accounted for more than 80 percent of the major improvements in tire and rim design, and nearly two-thirds of innovation in raw materials and tire components through the early 1930s.',
	      'exercise-reference': 'The Upside of Turbulence: Seizing Opportunity in an Uncertain World <br> by Donald Sull, Harper Business, 2009'
	    },
	    'exercise-two': {
	      'exercise-number': '1C - Exercise 2',
	      'exercise-title': 'Property Rights',
	      'exercise-description': 'In Western countries, every parcel of land, every building, every piece of equipment, or store of inventories is <span class="marked">represented in a property document</span> that is the visible sign of a vast hidden process that <span class="marked">connects all these assets to the rest of the economy</span>. Thanks to this representational process, assets can lead an invisible, parallel life alongside their material existence. <span class="marked">They can be used as collateral for credit</span>. The single most important source of funds for new businesses in the United Sates is a mortgage on the entrepreneur’s house. These assets can also provide a link to the owner’s credit history, an accountable address for the collection of debts and taxes, the basis for the creation of reliable and universal public utilities, and a foundation for the creation of securities (like mortgage-backed bonds) that can then be rediscovered and sold in secondary markets. By this process the West <span class="marked">injects life into assets and makes them generate capital</span>.',
	      'exercise-reference': 'The Mystery of Capital:<br>Why capitalism triumphs in the West and Fails Everywhere Else<br>by Hernando de Soto, Basic Books, 2000'
	    },
	    'exercise-three': {
	      'exercise-number': '1C - Exercise 3',
	      'exercise-title': 'Size Of The Cosmos',
	      'exercise-description': 'Most eighteenth century ideas about the cosmos were small-scale. It was widely believed that the earth was a <span class="marked">few thousand years old at most</span> (Biblical calculations gave 6,000 years), and that the universe might stretch out a <span class="marked">few million miles “above” the earth</span>. The “fixed stars” revolved in an unchanging pattern, and their brightness or magnitude was probably a function of their size, rather than their distance. So a faint star was probably comparatively small, rather than comparatively far away – a perfectly reasonable assumption. <span class="marked">The physical closeness of the stars</span> and planets also explained their <span class="marked">astrological “influences”</span>). The universe was small, closely connected, largely unchanging (except for comets), and almost intimate.',
	      'exercise-reference': 'The Age of Wonder:<br>How the Romantic Generation Discovered the Beauty and Terror of Science<br>by Richard Holmes, Pantheon Books, 2008'
	    },
	    'exercise-four': {
	      'exercise-number': '1C - Exercise 4',
	      'exercise-title': 'Brands',
	      'exercise-description': 'Historically, the rise of brands was a response to an information-poor environment. When consumers had to rely on advertisements and their past experience with a company, brands served as proxies for quality; if a car was made by GM, or a ketchup by Heinz, you assumed that it was pretty good. It was hard to figure out if a <span class="marked">new product</span> from an unfamiliar company <span class="marked">was reliable</span> or not, so brand loyalty was a way of reducing risk. As recently as the 1980s, nearly four-fifths of American car buyers stayed loyal to a brand.',
	      'exercise-reference': 'Twilight of the Brands<br>by James Surowiecki, The New Yorker, February 17 & 24, 2014'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 1C',
	    'final-description': 'You know how to pick out the points in the structure as you read',
	    'next-course-button': 'Proceed to 1D',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'picking-out-the-points': {
	    'course-name': 'Section 1B <span class="unit-title">Cementing the Rules<span>',
	    'course-title': 'Cementing the Rules',
	    'course-video': {
	      'title': 'Section 1 THE BASIC PYRAMID <br>21:09 -26:16 1B THE PYRAMID RULES <br>-: ex 1B cementing the rules + ex 1D Grasping the message <br>',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '1B Lecture'
	    },
	    'unit-section-title': '<span>1B Exercises</span>',
	    'unit-exercise-description': '<p>\n      If ideas are to fit into a pyramid structure under a single thought, they must obey general rules that define how the ideas should relate. These rules apply regardless of the subject of the document or the nature of the ideas.\n      <ol class="ordered-list">\n      <li>Ideas at any level must be summaries of the ideas grouped below them</li>\n      <li>Ideas in each grouping must be logically the same</li>\n      <li>Ideas in each grouping must be in logical order</li>\n      </ol>\n      <ul class="unordered-list">\n        <li>Time order if they reflect a process</li>\n        <li>Structural order if they comment on an existing structure</li>\n        <li>Order of importance if they are the result of classifying</li>\n      </ul>\n      <br><p>Thus, before you begin to write, you can force your ideas into the pyramid form and test them against the rules. If any of the rules is broken, that signals your thinking is either invalid or incomplete, and you can repair the problem before you try to communicate.</p>\n\n      <p>Following are the four examples you looked at earlier. In each case, the Original example broke one or more of the Minto Pyramid rules, which the Clearer example corrected.  Can you identify which rules were broken in each case.</p>\n          <br>\n        </p>',
	    'menu-list': {
	      'exercise-1': 'Note to Mort',
	      'exercise-2': 'Retail Price Data Survey',
	      'exercise-3': 'Electronic Filing',
	      'exercise-4': 'Perfect Team Size'
	    },
	    'exercise-one': {
	      'exercise-number': '1B - Exercise 1',
	      'exercise-title': 'Note to Mort',
	      'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-1.jpg" alt="Original structure">',
	      'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-2.jpg" alt="Original structure">'
	    },
	    'exercise-two': {
	      'exercise-number': '1B - Exercise 2',
	      'exercise-title': 'Retail Price Data Survey',
	      'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-3.jpg" alt="Original structure">',
	      'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-4.jpg" alt="Original structure">'
	    },
	    'exercise-three': {
	      'exercise-number': '1B - Exercise 3',
	      'exercise-title': 'Electronic Filing',
	      'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-5.jpg" alt="Original structure">',
	      'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-6.jpg" alt="Original structure">'
	    },
	    'exercise-four': {
	      'exercise-number': '1B - Exercise 4',
	      'exercise-title': 'Perfect Team Size',
	      'exercise-structure-2': '<span class="task-title">Original structure</span><img src="/assets/images/structure-1c-7.jpg" alt="Original structure">',
	      'exercise-structure-1': '<span class="task-title">Clearer structure</span><img src="/assets/images/structure-1c-8.jpg" alt="Original structure">'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 1B',
	    'final-description': 'You know the rules that govern how ideas must relate in a pyramid',
	    'next-course-button': 'Proceed to 1C',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 312 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'grasping-the-message': {
	    'course-name': 'Section 1D <span class="unit-title">Grasping the Message<span>',
	    'videoTitleTop': '1D Lecture',
	    'course-title': 'Grasping the Message',
	    'unit-section-title': '<span>1D Exercises</span>',
	    'unit-exercise-description': '<p>\n          It is relatively easy to make sure that your ideas are logically the same and in logical order. More difficult is drawing a summary point from them. To give you practice in doing that, following are five short examples in which I have given you the support points in the pyramid and ask you to locate the main point that ties them together. You will be given a set of possible summary points and asked to pick the most appropriate one and type it into the box above.\n        </p>',
	    'menu-list': {
	      'exercise-1': 'Chatty Chickens',
	      'exercise-2': 'Enterprise Risk Management (ERM) Models',
	      'exercise-3': 'Understanding Long-Term Memory',
	      'exercise-4': 'The Jacobite Rebellion',
	      'exercise-5': 'A Better Way to Die'
	    },
	    'exercise-one': {
	      'exercise-number': '1D - Exercise 1',
	      'exercise-title': 'Chatty Chickens',
	      'exercise-pre-description': 'Researchers used digital audio-recording devices and high-resolution televisions to test the function of chicken sounds under controlled conditions.',
	      'exercise-description': 'This virtual reality led to a truly astonishing revelation: the sounds or movements an individual chicken makes convey specific information, and other chickens understand it. A chicken need not see an aerial predator, for instance, to behave as if one was there; it need only hear the warning call from another bird. The chickens’ calls are “functionally referential,” as behaviorists would say – meaning that they refer to specific objects and events broadly in the way that words used by people do. In a chicken hearing the calls, the sounds appear to create a mental picture of that particular object, prompting the bird to respond accordingly – whether to flee a predator or approach a food source. The virtual world also revealed that individual chickens tailor their messages for their audience. A rooster that sees a threat overhead, for example, would make an alarm call if he knows a female is nearby, but he would remain silent in the presence of a rival male. Females are equally selective, only sending up an alarm when they have chicks. <br><br>Taken together, these findings suggested that sounds did not simply reflect a bird’s internal state, such as “frightened” or “hungry.” Instead the chickens interpreted the significance of events and responded not by simple reflex, but with well-thought-out actions. Chickens, it seems, think before they act – a trait more typically associated with large-brained mammals than with birds.',
	      'exercise-reference': 'Scientific American, Brainy Birds, February 2014'
	    },
	    'exercise-two': {
	      'exercise-number': '1D - Exercise 2',
	      'exercise-title': 'Enterprise Risk Management (ERM) Models',
	      'exercise-pre-description': 'Here are two paragraphs by the same author from a book on Enterprise Risk Management. One is a straightforward ordering of ideas, the other less so, but both reflecting a clear structure. See if you can pick out the message in each case:',
	      'exercise-description': '<p>Most traditional ERM models are overly complex. ERM models are designed, built, modified, expanded, and maintained by modelers. And modelers, by their nature, are like thoroughbreds – they love to run. It’s as if they have all this pent-up capability and they are itching to unleash it. Modelers are tempted to go down a rabbit hole of ever-increasing expansion of the model’s level of detail, in a misguided belief that they are perfecting the model. However, this is counterproductive to the whole point of the exercise, which is to support decision making.</p><p style="height: 260px">In contrast, value-based ERM models are not overly complex: rather, they have an appropriate balance between robustness and practicality. The value-based approach is designed specifically for connecting risk management to business decision making. As a result, every aspect of the approach is tailored and trimmed to keep it sleek and practical with this single focus in mind, and the model itself is no exception.</p>'
	    },
	    'exercise-three': {
	      'exercise-number': '1D - Exercise 3',
	      'exercise-title': 'Understanding Long-Term Memory',
	      'exercise-description': 'It gradually became clear to psychologists that the next step in understanding long-term memory was to understand how it becomes firmly established, a process now called consolidation. For a memory to persist, the incoming information must be thoroughly and deeply processed. This is accomplished by attending to the information and associating it meaningfully and systematically with knowledge already well established in memory. The newly stored information is thus made more stable for long-term storage.<br><br>The idea of memory consolidation is supported by two types of clinical observation. First, it has been known since the end of the 19th century that head injuries and concussion can lead to a memory loss called retrograde amnesia. A boxer who is hit on the head and sustains a brain concussion in round 5 of a match will usually remember going to the event, but everything after that will be blank. Undoubtedly a number of events entered into his short-term memory just before the blow – the excitement of entering the rink, his opponent’s movements during the earlier four rounds, perhaps even the moving punch itself and the attempt to avoid it – but the blow to the brain occurred before any of those memory traces could be consolidated. <br><br>The second clinical observation is that a similar retrograde amnesia often occurs following an epileptic convulsion. People with epilepsy cannot remember events immediately preceding a seizure, even though the seizure has no effect on their memory of earlier events. This suggests that in its early phases memory storage is dynamic and sensitive to disruption.',
	      'exercise-reference': 'In Search of Memory: The Emergence of a New Science of Mind <br>by Eric R. Kandel. W. W. Norton 2006'
	    },
	    'exercise-four': {
	      'exercise-number': '1D - Exercise 4',
	      'exercise-title': 'The Jacobite Rebellion',
	      'exercise-description': 'What drew people to the Stuart cause? It certainly was not the diffident, lethargic figure of James Stuart – deemed James III of England and James VIII of Scotland by his supporters. What compelled sensible, law-abiding, and enlightened individuals to admire and sometimes even support a conspiracy to overthrow the existing government? In a word, nostalgia.<br><br>Jacobitism reflected a nostalgic yearning for a traditional social order in which everyone supposedly knew his or her pre-ordained place and stayed in it. It satisfied a deep utopian longing for the perfect society – except that it looked backwards, rather than ahead, for its model of perfection. <br><br>The average Jacobite wanted to return to a community that was stable and harmonious, two qualities that eighteenth century Britain notoriously seemed to lack. He extolled the virtues of a rural-based society and the authority of a traditional landowning class. He detested the new rising competitive capitalist society, with its getting and spending, its greedy merchants and vulgar upstarts, its contempt for the old rules, its creative destruction.<br><br>He cared deeply about “justice,” which in his mind meant inferiors willingly obeying their superiors: tenants obeying their landlords, the middle class obeying the nobility, the people obeying the king and the Church. In England and much of the Scottish Lowlands by 1745, this longing for the security of a stable, hierarchical social order was largely, even self-consciously, a matter of nostalgia for “a world we have lost.”',
	      'exercise-reference': 'How the Scots Invented the Modern World: The true story of how Western <br>Europe’s poorest nation created our world & everything in it<br>by Arthur Herman, Random House 2001'
	    },
	    'exercise-five': {
	      'exercise-number': '1D - Exercise 5',
	      'exercise-title': 'A Better Way To Die',
	      'exercise-description': 'To view the potency of narrative, consider the following statement: “The king died and the queen died.” Compare it to “The king died, and then the queen died of grief.” This exercise, presented by the novelist E. M. Forster, shows the distinction between mere succession of information and a plot. But notice the hitch here: although we added information to the second statement, we effectively reduced the dimension of the total. The second sentence is, in a way, much lighter to carry and easier to remember; we now have one single piece of information in place of two. As we can remember it with less effort, we can also sell it to others, that is, market it better as a packaged idea. This, in a nutshell, is the definition and the function of a narrative.',
	      'exercise-reference': 'The Black Swan: The Impact of the Highly Improbableby</br>Nassim Nicholas Taleb, The Random House Publishing Group, 2007'
	    },
	    'congratulation-message': 'WELL DONE',
	    'finish-section': 'You have completed Section 1D',
	    'final-description': 'You know how to grasp the essence of what you have just read,<br>making it easier to recall in the future',
	    'course-video': {
	      'title': 'Section 1 THE BASIC PYRAMID <br>21:09 -26:16 1C THE PYRAMID RULES <br>-: ex 1C cementing the rules + ex 1D Grasping the message <br>',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '1C Lecture'
	    },
	    'next-course-button': 'Proceed to section 2',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 313 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1a-diagram1': {
	        'diagram-task': 'Press Complete and watch the pyramid display the correct structure',
	        'element_1_1': 'Permits DC to attend',
	        'element_1_2': 'More convenient for JC and HJ',
	        'element_1_3': 'Reschedule today’s meeting to Thursday at 11:00',
	        'element_1_4': 'Room free',
	        'complete-title': 'Complete',
	        'next-title': 'Next',
	        'diagram-message': 'Try it yourself in the next 3 exercises'
	    }
	};

/***/ }),
/* 314 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1a-diagram2': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
	        'element_2_3': 'Shift competitive stores to match',
	        'element_2_2': 'Survey only A-type stores',
	        'element_2_1': 'Make sure the data reflect the marketplace',
	        'element_2_4': 'Change the self-serve ratio'
	    }
	};

/***/ }),
/* 315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1a-diagram3': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
	        'element_3_1': 'Businesses are unlikely to adopt electronic filing in the near future',
	        'element_3_2': 'Decision makers don’t think filing is a problem',
	        'element_3_3': 'Using them would require costly behavioral change',
	        'element_3_4': 'Systems available are expensive, not very effective'
	    }
	};

/***/ }),
/* 316 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1a-diagram4': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press Complete to see your answer',
	        'element_4_11': 'Increases chances of destructive conflict',
	        'element_4_1': 'Teams larger than 4-6 people do not work productively together',
	        'element_4_5': 'More people to organize',
	        'element_4_6': 'More handovers to explain',
	        'element_4_2': 'They have less time available to do the work',
	        'element_4_7': 'More opportunities for miscommunication',
	        'element_4_8': 'More likelihood of mistakes',
	        'element_4_3': 'They do it less efficiently',
	        'element_4_9': 'Can’t pay personal attention to each member',
	        'element_4_10': 'Weakens the team’s social glue',
	        'element_4_4': 'They take less pleasure in doing it'
	    }
	};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1b-diagram1': {
	        'diagram-task': 'Drag each point to its proper place in the pyramid',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'Ecosystem of supporting institutions',
	        'element_1_2': 'Place to socialize and talk shop',
	        'element_1_3': 'On the cutting edge of rubber technology'
	    }
	};

/***/ }),
/* 318 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1b-diagram2': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
	        'fixed-answer': 'The system of documenting property injects life into assets and makes them generate capital',
	        'element_2_1': 'Represents it as a document',
	        'element_2_2': 'Allows it to be used as collateral for credit',
	        'element_2_3': 'Connects it to the rest of the economy'
	    }
	};

/***/ }),
/* 319 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1b-diagram3': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
	        'fixed-answer': 'Eighteenth century people did not see the cosmos as an immense mystery',
	        'element_3_1': 'Only a few thousand years old<br><br>(young)',
	        'element_3_2': 'Stretching only a few million miles above<br><br>(small)',
	        'element_3_3': 'Stars physically close to the earth<br><br>(close by)',
	        'element_3_4': 'Influencing everyday life<br><br>(influential)'
	    }
	};

/***/ }),
/* 320 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1b-diagram4': {
	        'diagram-task': 'Arrange the points to fit the pyramid structure, then press the Submit button',
	        'fixed-answer': 'Brands conveyed knowledge in an information-poor environment.',
	        'element_4_1': 'Served as a general indicator of quality',
	        'element_4_2': 'Removed the risk from trying new products'
	    }
	};

/***/ }),
/* 321 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1c-diagram1': {
	        'diagram-task': 'Identify the problem with the original. Pick one or more answers',
	        'rule1': 'Rule 1 Idea above is not a summary of the ideas grouped below',
	        'rule2': 'Rule 2 Ideas in each grouping not of the same kind',
	        'rule3': 'Rule 3 Ideas in each group not in logical order',
	        'complete-title': 'submit',
	        'resubmit-title': 'resubmit',
	        'hint-title': 'hint'
	    }
	};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1c-diagram2': {
	        'diagram-task': 'Identify the problem with the original. Pick one or more answers',
	        'rule1': 'Rule 1 Idea above is not a summary of the ideas grouped below',
	        'rule2': 'Rule 2 Ideas in each grouping not of the same kind',
	        'rule3': 'Rule 3 Ideas in each group not in logical order'
	    }
	};

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1c-diagram3': {
	        'diagram-task': 'Identify the problem with the original. Pick one or more answers',
	        'rule1': 'Rule 1 Idea above is not a summary of the ideas grouped below',
	        'rule2': 'Rule 2 Ideas in each grouping not of the same kind',
	        'rule3': 'Rule 3 Ideas in each group not in logical order'
	    }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1c-diagram4': {
	        'diagram-task': 'Identify the problem with the original. Pick one or more answers',
	        'rule1': 'Rule 1 Idea above is not a summary of the ideas grouped below',
	        'rule2': 'Rule 2 Ideas in each grouping not of the same kind',
	        'rule3': 'Rule 3 Ideas in each group not in logical order'
	    }
	};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1d-diagram1': {
	        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
	        'diagram-description': '<li>Chickens convey specific information</li>\n                                <li>Chickens\u2019 calls refer to specific objects and events</li>\n                                <li>Chickens communicate well-thought-out messages</li>\n                                <li>Chickens use language the way that people use words</li>',
	        'fixed-answer1': 'Chickens communicate well-thought-out messages',
	        'fixed-answer2': 'Convey specific information',
	        'fixed-answer3': 'Are tailored to the audience',
	        'fixed-answer4': 'Reflect the significance of events',
	        'complete-title': 'Reveal',
	        'hide-title': 'Hide'
	    }
	};

/***/ }),
/* 326 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1d-diagram2': {
	        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
	        'diagram-description': '<li>Most traditional ERM models are overly complex</li>\n                                <li>Modelers have a pent-up capability they are itching to unleash</li>\n                                <li>Modelers are misguided in perfecting their models</li>\n                                <li>Traditional ERM models do not support decision making</li>',
	        'diagram-description2': '<li>Value-based models are not overly complex</li>\n                                <li>Value-based ERM models balance robustness and practicality</li>\n                                <li>Value-based models have a single focus</li>\n                                <li>Value-based models are designed to link risk management to business</li>',
	        'fixed-answer1': 'Traditional ERM models do not support decision making',
	        'fixed-answer2': 'Value-based ERM models balance robustness and practicality',
	        'fixed-answer3': 'Overly complex design',
	        'fixed-answer4': 'Overly detailed execution',
	        'fixed-answer5': 'Designed with a single focus in mind',
	        'fixed-answer6': 'Tailored to be sleek and practical',
	        'complete-title': 'Reveal',
	        'hide-title': 'Hide'
	    }
	};

/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1d-diagram3': {
	        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
	        'diagram-description': '<li>A memory becomes firmly established through a process called consolidation</li>\n          <li>In its early phases, memory storage is dynamic and sensitive to disruption</li>\n          <li>The idea of memory consolidation is supported by clinical observation</li>\n          <li>Injuries and concussion can lead to a memory loss called retro-grade amnesia</li>',
	        'fixed-answer1': 'In early phases, memory storage is dynamic and sensitive to disruption',
	        'fixed-answer2': 'For a memory to persist, it must be consolidated into long-term storage',
	        'fixed-answer3': 'But first the memory must be stabilized in the brain',
	        'fixed-answer4': 'Interrupting the stabilizing process causes the memory to disappear',
	        'fixed-answer5': 'Thoroughly and deeply processed',
	        'fixed-answer6': 'Linked to current knowledge',
	        'fixed-answer7': 'Boxer injury to head',
	        'fixed-answer8': 'Epileptic seizure'
	    }
	};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1d-diagram4': {
	        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
	        'diagram-description': '<li>Jacobitism satisfied a deep utopian longing for the perfect society</li>\n                                <li>Eighteenth-century Britain notoriously lacked stability</li>\n                                <li>The Jacobites detested the new rising competitive capitalize society and harmony</li>\n                                <li>Support for the Jacobite rebellion was driven by nostalgia for a lost world</li>',
	        'fixed-answer1': 'Support for the Jacobite rebellion was driven by nostalgia for a lost world',
	        'fixed-answer2': 'Wanted stability A rural-based community that was stable and harmonious',
	        'fixed-answer3': 'Wanted harmony Free from the new competitive capitalism',
	        'fixed-answer4': 'Wanted social order A hierarchy of pre-ordained places where inferiors obey superiors'
	    }
	};

/***/ }),
/* 329 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '1d-diagram5': {
	        'diagram-task': 'Type your answer in the white box.<br>Then click the ‘reveal’ button to see how it compares to the correct answer',
	        'diagram-description': '<li>Creating narratives is a powerful way to pass on information</li>\n                                <li>Listing facts imposes a heavy burden on memory</li>\n                                <li>Relating them as a plot turns them into a single piece of information</li>\n                                <li>The plot can be easily communicated to others</li>',
	        'fixed-answer1': 'Creating narratives is a powerful way to pass on information',
	        'fixed-answer2': 'Listing facts imposes a heavy burden on memory',
	        'fixed-answer3': 'Relating them as a plot turns them into a single piece of information',
	        'fixed-answer4': 'The plot can be easily communicated to others'
	    }
	};

/***/ }),
/* 330 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'ideas-fit-together': {
	    'course-title': 'How the Ideas Fit Together',
	    'course-name': 'Section 2A <span class="unit-title">How the Ideas Fit Together<span>',
	    'intro': 'So, not every sentence you write will be an idea, only some of them will. Please read the following piece “On Pigs as Pets” by G K Chesterton, and see if you can pick out the major ideas as you read. Given the author’s tendency to elaborate and digress at almost every opportunity, the major points will not be immediately easy to see. Nevertheless, there is a clear structure and considerable logic.<br/><br/>To make it easier for you to see it, I have arranged for the major ideas to reveal themselves as you scroll past them. When you finish, we will discuss how you identify major ideas vs the other sentences.',
	    'unit-section-title': '2A Excercises',
	    'exercise-number': '2A',
	    'exercise-title': 'On Pigs as Pets',
	    'exercise-description': '<p>A dream of my pure and aspiring boyhood has been realized in the following paragraph, which I quote exactly as it stands:\n          <br/><br/>\n          A complaint by the Epping Rural District Council against a spinster keeping a pig in her house has evoked the following reply: \u201CI received your letter, and felt very much cut up, as I am laying in the pig\u2019s room. I have not been able to stand up or get on my legs; when I can, I will get him in his own room, that was built for him. As to getting him off the premises, I shall do no such thing, as he is no nuisance to anyone. We have had to be in the pig\u2019s room now for three years. I am not going to get rid of my pet. We must all live together. I will move him as soon as God gives me strength to do so.\u201D\n          <br/><br/>\n          The Rev. T. C. Spurgin observed: \u201CThe lady will require a good deal of strength to move her pet, which weighs forty stone.\u201D It appears to me that the Rev. T. C. Spurgin ought, as a matter of chivalry, to assist the lady to move the pig, if it is indeed too heavy for her strength; no gentleman should permit a lady, who is already very much cut up, to lift forty stone of still animated and recalcitrant pork; he should himself escort the animal downstairs. It is an unusual situation, I admit. In the normal life of humanity the gentleman gives his arm to the lady, and not to the pig; and it is the pig who is very much cut up. But the situation seems to be exceptional in every way. It is all very well for the lady to say that the pig is no nuisance to anyone; as it seems that she has established herself in the pig\u2019s private suite of apartments, the question rather is whether it is a nuisance to the pig.\n          <br/><br/>\n          But indeed I do not think that this poor woman\u2019s fad is an inch more fantastic than many such oddities indulged in by rich and reputable people; and, as I say, I have from my boyhood entertained the dream. <span>I never could imagine why pigs should not be kept as pets.</span> To begin with, <span>pigs are very beautiful animals.</span> Those who think otherwise are those who do not look at anything with their own eyes, but only through other people\u2019s eyeglasses. The actual lines of a pig (I mean of a really fat pig) are among the loveliest and most luxuriant in nature; the pig has the same great curves, swift and yet heavy, which we see in rushing water or rolling cloud. Compared to him, the horse, for instance, is a bony, angular, and abrupt animal. I remember that Mr. H. G. Wells, in arguing for the relativity of things (a subject over which even the Greek philosophers went to sleep until Christianity woke them up), pointed out that, while a horse is uncommonly beautiful if seen in profile, he is excessively ugly if seen from the top of a dogcart, having a long, lean neck, and a body like a fiddle.\n          <br/><br/>\n          Now, there is no point of view from which <span>a really corpulent pig is</span> not <span>full of sumptuous and satisfying curves.</span> You can look down on a pig from the top of the most unnaturally lofty dogcart; you can (if not pressed for time) allow the pig to draw the dogcart; and I suppose a dogcart has as much to do with pigs as it has with dogs. You can examine the pig from the top of an omnibus, from the top of the Monument, from a balloon, or an airship and as long as he is visible, he will be beautiful. In short, he has that fuller, subtler, and more universal kind of shapeliness which the unthinking (gazing at pigs and distinguished journalists) mistake for a mere absence of shape. For fairness itself is a valuable quality. While it creates admiration in the onlookers, it <span>creates modesty in the possessor.</span> If there is anything on which I differ from the monastic institutions of the past, it is that they sometimes sought to achieve humility by means of emaciation. It may be that the thin monks were holy, but I am sure it was the fat monks who were humble. Falstaff said that to be fat is not to be hated; but it certainly is to be laughed at, and that is a more wholesome experience for the soul of man.\n          <br/><br/>\n          I do not urge that it is effective upon the soul of a pig, who, indeed seems somewhat indifferent to public opinion on this point. Nor do I mean that mere fatness is the only beauty of the pig. <span>The beauty of the best pigs lies in a certain sleepy perfection of contour which links them especially to the smooth strength of our south English land in which they live.</span> There are two other things in which one can see this perfect and piggish quality: one is in the silent and smooth swell of the Sussex downs, so enormous and yet so innocent. The other is in the sleek, strong limbs of those beech trees that grow so thick in their valleys. These three holy symbols, the pig, the beech tree, and the chalk down, <span>stand forever as expressing the one thing that England as England has to say</span> - that power is not inconsistent with kindness. Tears of regret come into my eyes when I remember that three lions or leopards, or whatever they are, sprawl in a fantastic, foreign way across the arms of England. We ought to have three pigs passant, gardant, or on gules. It breaks my heart to think that four commonplace lions are couched around the base of the Nelson Column. There ought to be four colossal Hampshire hogs to keep watch over so national a spot. Perhaps some of our sculptors will attack the conception; perhaps the lady\u2019s pig, which weighs forty stone and seems to be something of a domestic problem, might begin to earn its living as an artist\u2019s model.\n          <br/><br/>\n          Again, we do not know <span>what fascinating variations might happen in the pig if once the pig were a pet.</span> The dog has been domesticated - that is, destroyed.  Nobody now in London can form the faintest idea of what a dog would look like. You know a Dachshund in the street; you know a St. Bernard in the street; But if you saw a Dog in the street you would run from him screaming. For hundreds, if not thousands, of years no one has looked at the horribly hairy original thing called Dog. Why, then, should we be hopeless about the substantial and satisfying thing called Pig? <span>Types of Pig.</span> may also be differentiated; delicate shades of Pig may also be produced. A <span>monstrous pig as big as a pony</span> may perambulate the streets like a St. Bernard without attracting attention. An elegant and unnaturally attenuated pig may have all the appearance of a greyhound. There <span>may be little, frisky, fighting pigs like Irish or Scotch terriers; there may be little pathetic pigs like King Charles spaniels.</span> Artificial breeding might reproduce the awful original pig, tusks and all, the terror of the forests - something bigger, more mysterious and more bloody than the bloodhound. Those interested in hairdressing might amuse themselves by arranging the bristles like those of a poodle. Those fascinated by the Celtic mystery of the Western Highlands might see if they could train the bristles to be a veil or curtain for the eye, like those of a Skye terrier, that sensitive and invisible Celtic spirit. <span>With elaborate training one might have a sheep-pig instead of a sheep-dog, a lap-pig instead of a lap-dog.</span>\n          <br/><br/>\n          What is it that makes you look so incredulous?  Why do you still feel slightly superior to the poor lady who would not be parted from her pig?  Why do you not at once take the hog to your heart?  <span>Reason suggests his evident beauty.  Evolution suggests its probable improvement.</span>  Is it, perhaps, some instinct, some tradition..?  Well, apply that to women, children, animals, and we will argue again.\n        </p>',
	    'course-video': {
	      'title': 'Section 2: HOW THE IDEAS FIT TOGETHER<br>36:15 - 49:57 2A (at 37:25 pause to read - )',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '2A Lecture'
	    },
	    'menu-list': {
	      'exercise-1': 'On Pigs as Pets'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 2A',
	    'final-description': 'You know that an IDEA is a statement that raises a question in the reader’s mind',
	    'next-course-button': 'Proceed to 2B',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 331 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'creating-question-answer-dialog': {
	    'course-title': 'Creating a Question/<br/>Answer Dialogue',
	    'course-name': 'Section 2B <span class="unit-title">Creating a Question/<br/>Answer Dialogue<span>',
	    'course-video': {
	      'title': 'Section 2: HOW THE IDEAS FIT TOGETHER<br/>37:25 - 49:57 2B Vertcal relationships End Ex 2B<br/>Creating a Question/Answer Dialogue',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '2B Lecture'
	    },
	    'unit-section-title': '2B Exercises',
	    'intro': 'The ideas grouped below an idea at any level in the pyramid should always serve to answer the question raised in the reader\u2019s mind by the statement of that idea. An idea generally raises one of three questions:\n        <br/><br/>\n        <ul>\n          <li>How?</li>\n          <li>Why?</li>\n          <li>How do you know? (often about the results of research)</li>\n        </ul>\n        <br/>\n        Following are the final pyramids of the two groups of exercises you just did. This time can you identify the question that the main point raises and that the grouped ideas answer?\n        <br/><br/>',
	    'menu-list': {
	      'exercise-1': 'Firestone’s Commitment',
	      'exercise-2': 'Property Rights',
	      'exercise-3': 'Size of the Cosmos',
	      'exercise-4': 'Brands',
	      'exercise-5': 'A Better Way to Die',
	      'exercise-6': 'Chatty Chickens',
	      'exercise-7': 'Enterprise Risk Management (ERM) Models',
	      'exercise-8': 'Understanding Long-Term Memory',
	      'exercise-9': 'The Jacobite Rebellion' },
	    'exercise-1': {
	      'number': '2B - Exercise 1',
	      'title': 'Firestone’s Commitment',
	      'pre-description': '',
	      'description': '\n        In terms of building expertise, Harvey Firestone\u2019s most important commitment was his initial move to Akron, Ohio, in 1910. As the tire industry grew, an ecosystem of supporting institutions cropped up in America\u2019s rubber capital, including a college that offered the nation\u2019s first rubber chemistry course, technical testing firms, and the leading industry trade journal. The Portage Country Club, founded by two B. F. Goodrich Executives, provided the social setting where the founders, managers, researchers, and investors in tire companies congregated to socialize and talk shop. By committing to Akron, Firestone insured that he and his employees remained in the flow of technical and business information, which helped them stay on the cutting edge of rubber technology. Akron firms accounted for more than 80% of the major improvements in tire and rim design, and nearly two-thirds of innovation in raw materials and tire components through the early 1930s.\n      <br/><br/>',
	      'reference': 'The Upside of Turbulence: Seizing Opportunity in an Uncertain World<br/>by Donald Sull, Harper Business, 2009'
	    },
	    'exercise-2': {
	      'number': '2B - Exercise 2',
	      'title': 'Property Rights',
	      'pre-description': '',
	      'description': '\n        In Western countries, every parcel of land, every building, every piece of equipment, or store of inventories is represented in a property document that is the visible sign of a vast hidden process that connects all these assets to the rest of the economy. Thanks to this representational process, assets can lead an invisible, parallel life alongside their material existence. They can be used as collateral for credit. The single most important source of funds for new businesses in the United Sates is a mortgage on the entrepreneur\u2019s house.\n        These assets can also provide a link to the owner\u2019s credit history, an accountable address for the collection of debts and taxes, the basis for the creation of reliable and universal public utilities, and a foundation for the creation of securities (like mortgage-backed bonds) that can then be rediscovered and sold in secondary markets. By this process the West injects life into assets and makes them generate capital.\n      <br/><br/>',
	      'reference': 'The Mystery of Capital:<br/>Why Capitalism Triumphs in the West and Fails Everywhere Else<br/> by Hernando de Soto, Basic Books, 2000'
	    },
	    'exercise-3': {
	      'number': '2B - Exercise 3',
	      'title': 'Size of the Cosmos',
	      'pre-description': '',
	      'description': '\n        Most eighteenth century ideas about the cosmos were small-scale. It was widely believed that the earth was a few thousand years old at most (Biblical calculations gave 6,000 years), and that the universe might stretch out a few million miles \u201Cabove\u201D the earth. The \u201Cfixed stars\u201D revolved in an unchanging pattern, and their brightness or magnitude was probably a function of their size,\n        rather than their distance. So a faint star was probably comparatively small, rather than comparatively far away \u2013 a perfectly reasonable assumption. The physical closeness of the stars and planets also explained their astrological \u201Cinfluences.\u201D The universe was small, closely connected, largely unchanging (except for comets), and almost intimate.\n      <br/><br/>',
	      'reference': 'The Age of Wonder:<br/> How the Romantic Generation Discovered the Beauty and Terror of Science<br/>by Richard Holmes, Pantheon Books, 2008'
	    },
	    'exercise-4': {
	      'number': '2B - Exercise 4',
	      'title': 'Brands',
	      'pre-description': '',
	      'description': '\n        Historically, the rise of brands was a response to an information-poor environment. When consumers had to rely on advertisements and their past experience with a company, brands served as proxies for quality; if a car was made by GM, or a ketchup by Heinz, you assumed that\n        it was pretty good. It was hard to figure out if a new product from an unfamiliar company was reliable or not, so brand loyalty was a way of reducing risk. As recently as the 1980s, nearly four-fifths of American car buyers stayed loyal to a brand.\n      <br/><br/>',
	      'reference': 'Twilight of the Brands<br/>by James Surowiecki, The New Yorker, February 17 & 24, 2014'
	    },
	    'exercise-5': {
	      'number': '2B - Exercise 5',
	      'title': 'A Better Way to Die',
	      'pre-description': '',
	      'description': '\n        To view the potency of narrative, consider the following statement: \u201CThe king died and the queen died.\u201D Compare it to \u201CThe king died, and then the queen died of grief.\u201D This exercise, presented by the novelist E. M. Forster, shows the distinction between mere succession of information and a plot. But notice the hitch here: although we added information to the second statement, we effectively reduced the dimension of the total.\n        The second sentence is, in a way, much lighter to carry and easier to remember; we now have one single piece of information in place of two. As we can remember it with less effort, we can also sell it to others, that is, market it better as a packaged idea. This, in a nutshell, is the definition and the function of a narrative.\n      <br/><br/>',
	      'reference': 'The Black Swan: The Impact of the Highly Improbable<br/>by Nassim Nicholas Taleb, The Random House Publishing Group, 2007'
	    },
	    'exercise-6': {
	      'number': '2B - Exercise 6',
	      'title': 'Chatty Chickens',
	      'pre-description': 'Researchers used digital audio-recording devices and high-resolution televisions to test the function of chicken sounds under controlled conditions',
	      'description': '\n        This virtual reality led to a truly astonishing revelation: the sounds or movements an individual chicken makes convey specific information, and other chickens understand it. A chicken need not see an aerial predator, for instance, to behave as if one was there; it need only hear the warning call from another bird. The chickens\u2019 calls are \u201Cfunctionally referential,\u201D as behaviorists would say \u2013 meaning that they refer to specific objects and events broadly in the way that words used by people do. In a chicken hearing the calls, the sounds appear to create a mental picture of that particular object, prompting the bird to respond accordingly \u2013 whether to flee a predator or approach a food source.\n            The virtual world also revealed that individual chickens tailor their messages for their audience. A rooster that sees a threat overhead, for example, would make an alarm call if he knows a female is nearby, but he would remain silent in the presence of a rival male. Females are equally selective, sending up an alarm only when they have chicks.\n            <br/><br/>Taken together, these findings suggested that sounds did not simply reflect a bird\u2019s internal state, such as \u201Cfrightened\u201D or \u201Chungry.\u201D Instead the chickens interpreted the significance of events and responded not by simple reflex, but with well-thought-out actions. Chickens, it seems, think before they act \u2013 a trait more typically associated with large-brained mammals than with birds.\n      <br/><br/>',
	      'reference': 'Scientific American, Brainy Birds, February 2014'
	    },
	    'exercise-7': {
	      'number': '2B - Exercise 7',
	      'title': 'Enterprise Risk Management (ERM) Models',
	
	      'pre-description': '(Here are two paragraphs by the same author from a book on Enterprise Risk Management. One is a straightforward ordering of ideas, the other less so, but both reflect a clear structure. See if you can pick out the message in each case)',
	
	      'description': '\n        Most traditional ERM models are overly complex. ERM models are designed, built, modified, expanded, and maintained by modelers. And modelers, by their nature, are like thoroughbreds \u2013 they love to run. It\u2019s as if they have all this pent-up capability and they are itching to\n        unleash it. Modelers are tempted to go down a rabbit hole of ever-increasing expansion of the model\u2019s level of detail, in a misguided belief that they are perfecting the model. However, this is counterproductive to the whole point of the exercise, which is to support decision making.\n      <br/><br/>',
	      'description-2': '\n        In contrast, value-based ERM models are not overly complex: rather, they have an appropriate balance between robustness and practicality. The value-based approach is designed specifically for connecting risk\n        management to business decision making. As a result, every aspect of the approach is tailored and trimmed to keep it sleek and practical with this single focus in mind, and the model itself is no exception.\n      <br/><br/>',
	      'reference': ''
	    },
	    'exercise-8': {
	      'number': '2B - Exercise 8',
	      'title': 'Understanding Long-Term Memory',
	      'pre-description': '',
	      'description': '\n            It gradually became clear to psychologists that the next step in understanding long-term memory was to understand how it becomes firmly established, a process now called consolidation. For a memory to persist, the incoming information must be thoroughly and deeply processed. This is accomplished by attending to the information and associating it meaningfully and systematically with knowledge already well established in memory. The newly stored information is thus made more stable for long-term storage.\n            <br/><br/>The idea of memory consolidation is supported by two types of clinical observation. First, it has been known since the end of the 19th century that head injuries and concussion can lead to a memory loss called retrograde amnesia. A boxer who is hit on the head and sustains\n        a brain concussion in Round 5 of a match will usually remember going to the event, but everything after that will be blank. Undoubtedly a number of events entered into his short-term memory just before the blow \u2013 the excitement of entering the rink, his opponent\u2019s movements during the earlier four rounds, perhaps even the moving punch itself and the attempt to avoid it \u2013 but the blow to the brain occurred before any of those memory traces could be consolidated. The second clinical observation is that a similar retrograde amnesia often occurs following an epileptic convulsion. People with epilepsy cannot remember events immediately preceding a seizure, even though the seizure has no effect on their memory of earlier events. This suggests that in its early phases memory storage is dynamic and sensitive to disruption.\n      <br/><br/>',
	      'reference': 'In Search of Memory: The Emergence of a New Science of Mind<br/>by Eric R. Kandel. W. W. Norton 2006'
	    },
	    'exercise-9': {
	      'number': '2B - Exercise 9',
	      'title': 'The Jacobite Rebellion',
	      'pre-description': '',
	      'description': '\n            What drew people to the Stuart cause? It certainly was not the diffident, lethargic figure of James Stuart \u2013 deemed James III of England and James VIII of Scotland by his supporters. What compelled sensible, law-abiding, and enlightened individuals to admire and sometimes even support a conspiracy to overthrow the existing government? In a word, nostalgia.\n            <br/><br/>Jacobitism reflected a nostalgic yearning for a traditional social order in which everyone supposedly knew his or her pre-ordained place and stayed in it. It satisfied a deep utopian longing for the perfect society \u2013 except that it looked backwards, rather than ahead, for its model of perfection.\n            <br/><br/>The average Jacobite wanted to return to a community that was stable and harmonious, two qualities that eighteenth century Britain notoriously seemed to lack. He extolled the virtues of a rural-based society and the authority of a traditional landowning class. He detested the new rising competitive capitalist society, with its getting and spending, its greedy merchants and vulgar upstarts, its contempt for the old rules, its creative destruction.\n            <br/><br/>He cared deeply about \u201Cjustice,\u201D which in his mind meant inferiors willingly obeying their superiors: tenants obeying their landlords, the middle class obeying the nobility, the people obeying the King and the Church. In England and much of the Scottish Lowlands by 1745, this longing for the security of a stable, hierarchical social order was largely, even self-consciously, a matter of nostalgia for \u201Ca world we have lost.\u201D\n      <br/><br/>',
	      'reference': 'How the Scots |Invented the Modern World: The true storyof how<br/> Western Europe’s poorest nation created our world & everything in it<br/>by Arthur Herman, Random House 2001'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 2B',
	    'final-description': 'You know that the reader’s initial question begins a<br/>question / answer dialogue between the two of you',
	    'next-course-button': 'proceed to section 3',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 332 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram1': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Firestone’s most important commitment was his initial move to Akron',
	            'two': 'Ecosystem of supporting institutions',
	            'three': 'Place to socialize and talk shop',
	            'four': 'On the cutting edge of rubber technology'
	        }
	    }
	};

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram2': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'The system of documenting property injects life into assets and makes them generate capital',
	            'two': 'Represents it as a document',
	            'three': 'Allows it to be used as collateral for credit',
	            'four': 'Connects it to the rest of the economy'
	        }
	    }
	};

/***/ }),
/* 334 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram3': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Most eighteenth century ideas about the cosmos were small scale',
	            'two': '<span>It was only a few thousand years old</span> <span style="margin-bottom: 2px;">(Young)</span>',
	            'three': '<span>It stretched only a few million miles above</span> <span style="margin-bottom: 2px;">(Small)</span>',
	            'four': '<span>The stars were physically close to the earth</span> <span style="margin-bottom: 2px;">(Close)</span>',
	            'five': '<span>They influenced everyday life</span> <span style="margin-bottom: 2px;">(Influential)</span>'
	        }
	    }
	};

/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram4': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Brands conveyed knowledge in an information-poor environment',
	            'two': 'Served as a general indicator of quality',
	            'three': 'Removed the risk from trying new products'
	        }
	    }
	};

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram5': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Creating narratives is a powerful way to pass on information',
	            'two': 'Listing facts imposes a heavy burden on memory',
	            'three': 'Relating them as a plot turns them into a single piece of information',
	            'four': 'A plot can be easily communicated to others'
	        }
	    }
	};

/***/ }),
/* 337 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram6': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Chickens communicate well-thought-out messages ',
	            'two': 'Convey specific information',
	            'three': 'Tailor it to the audience',
	            'four': 'Reflect the significance of events'
	        }
	    }
	};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram7': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Traditional ERM models do not support decision making',
	            'two': 'Overly complex design',
	            'three': 'Overly detailed execution'
	        }
	    }
	};

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram8': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Value-Based ERM models balance robustness and practicality',
	            'two': 'Connect risk management to decision making',
	            'three': 'Tailor the approach to match'
	        }
	    }
	};

/***/ }),
/* 340 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram9': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'In early phases, memory storage is dynamic and sensitive to disruption',
	            'two': 'For a memory to persist, it must be entered into long-term storage',
	            'three': 'But first the memory must be stabilized in the brain',
	            'four': 'Interrupting the stabilizing process causes the memory to disappear'
	        }
	    }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    '2b-diagram10': {
	        'diagram-task': 'Identify the question that the main point raises, and the grouped ideas answer.',
	        'checkboxes': {
	            'title': 'Question:',
	            'checkbox-1': 'How?',
	            'checkbox-2': 'Why?',
	            'checkbox-3': 'How know?'
	        },
	        'elements': {
	            'one': 'Support for the Jacobite rebellion was driven by nostalgia for a lost world',
	            'two': '<u>Wanted stability</u><br>A rural-based community that was stable and harmonious',
	            'three': '<u>Wanted harmony</u><br>Free from the new competitive capitalism',
	            'four': '<u>Wanted social order</u><br>A hierarchy of preordained places where inferiors obey superiors'
	        }
	    }
	};

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'supporting-points': {
	    'course-title': 'Supporting the Points Introduction',
	    'course-name': 'Section 3 <span class="unit-title">Supporting the Points<br/>Introduction<span>',
	    'course-video': {
	      'title': 'Section 3 SUPPORTING THE POINTS<br/>50:10 - 56:51 3A DEDUCTIVE REASONING ex 3A-1idetifying deductive arguments +3A-2<br/> summarizing deductive arguments + 3A-3 finding deductive arguments embedded in<br/> prose',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '3 Lecture'
	    },
	    'exercise-descripton': '<p>As you now know, the point at the top of the pyramid will raise a question in the reader\u2019s mind, which you are obliged to answer logically on the line below. Your reasoning may be presented in only one of two ways: as a deductive argument or as an inductive grouping.</p>\n<br/><p>Here is how the two forms of reasoning differ:</p>\n<br/><br/>\n<div>\n  <div class="intro-side">\n    <h3>Deductive Resoning</h3>\n    <ul>\n    <li>The first point makes a statement</li>\n    <li>The second point comments on the first</li>\n    <li>The third point is the \u201Ctherefore\u201D point</li>\n    <li>The point above summarizes the grouping \n      by taking the last point, putting it above, \n      and adding a \u2018because\u2019 to cover the other \n      points</li>\n      </ul><br/><br/>\n    <h3>Inductive Resoning</h3>\n    <ul>\n    <li>Ideas are all of the same kind\n      (have the same subject or the same predicate)</li>\n    <li>They are all able to be described by the \n      same general plural noun (e.g., reasons, problems, steps)</li>\n    <li>The point above states the insight gleaned \n      by seeing the similarity in the ideas</li>\n      </ul><span></span>\n  </div>\n  <div class="intro-side"><img src="/assets/images/structure-3zero.png" alt="Original structure" /></div>\n</div>\n<br/><br/>\n<p><br/><br/>The rule of thumb is</p>\n<ul>\n<li><strong>In deduction - the second point comments on the first</strong></li>\n<li><strong>In induction - the points are separate but of the same kind</strong></li>\n</ul><br/>\n<p>Very few people have problems in working out their reasoning once they know which form they are using. Accordingly, the skill you need to develop is the ability to distinguish deduction from induction, and recognize the rules related to each. </p>\n<br/><p>Chapters 2 and 5 in the textbook \u201CThe Minto Pyramid Principle: Logic in Writing, Thinking and Problem Solving,\u201D explain the difference and the rules. The purpose of the exercises that follow is to give you practice in distinguishing between the two forms and recognizing their permissible variations.</p>\n<ul>\n<li>3A presents examples of how deductive arguments can look, both in structure and when developed in writing</li>\n<li>3B gives the same insights into inductive arguments</li>\n</ul>',
	    'next-course-button': 'Proceed to 3A-1',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'deductive-reasoning': {
	    'course-title': 'Deductive Reasoning',
	    'course-name': 'Section 3A-1 <span class="unit-title">Deductive Reasoning<span>',
	    'course-video': {
	      'title': 'Section 3 SUPPORTING THE POINTS<br/>50:10 - 56:51 3A DEDUCTIVE REASONING ex 3A-1idetifying deductive<br/> arguments +3A-2 summarizing deductive arguments + 3A-3 finding deductive<br/> arguments embedded in prose',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '3A-1 Lecture'
	    },
	    'unit-section-title': '3A-1 Exercises',
	    'exercise-title': 'Tracing the Deductive Argument',
	    'exercise-description-top': 'A deductive argument, as you have seen, generally contains three points, where the second point comments on the first, and the third is a “therefore” point. However, deductive arguments can vary from the pure, three-part syllogistic form to what are called chained arguments.',
	    'arguments-1-title': 'Deductive arguments can be simple. . .',
	    'arguments-2-title': 'or chained . . .',
	    'element-caption-statement': 'Statement',
	    'element-caption-comment': 'Comment on Statement',
	    'element-caption-therefore': 'Therefore',
	    'element-1': 'Puffy clouds contain huge amounts of water',
	    'element-2': 'Often do not drop the water, causing drought',
	    'element-3': 'Leads people to try to wring the water from the clouds',
	    'element-4': 'Clouds that could produce rain contain micron-size droplets of water kept aloft by updrafts',
	    'element-5': 'To escape the updrafts, droplets must coalesce into ice pellets',
	    'element-6': 'Can’t coalesce without dust particles to serve as nuclei',
	    'element-7': 'To get rain, we mimic the dust particles with water iodide',
	    'element-8': 'Global demand for senior executives, fewer rising 35-44 year olds, and gaps in corporate pipelines will create an unprecedented shortage for senior talent over the next decade',
	    'element-9': 'The resulting war for talent in a shrinking labor pool will make obsolete the current approach of seeking high performers with defined skills and competencies to fill specific roles',
	    'element-10': 'The focus will shift to spotting a candidate’s overall potential to grow into a role, and to promoting programs to help that development to occur',
	    'element-11': 'Changing the focus to spot high potential will require changes in the entire hiring and training process',
	    'element-12': 'Money’s value is directly proportional to the quantity in circulation compared to the quantity of goods available',
	    'element-13': 'Properly varying the quantity of money brings peace and order to the kingdom',
	    'element-14': 'The role of a Sovereign, therefore, is to increase or decrease the quantity of money, to meet the needs of the economy',
	    'element-15': 'Broadly speaking, capital is past labor that has been saved',
	    'element-16': 'As a repository of past labor, it enables the execution of present-day labor',
	    'exercise-description-bottom': 'You can always tell whether you are arguing deductively by looking at the <b>second point</b> in the grouping. If the <b>second point</b> comments on the first, you are by definition arguing deductively, and you must have a “therefore” point.',
	    'element-17': 'Therefore, capital and labor are to a significant extent indissociable',
	    'exercise-task': 'Please click to highlight the word or words in the second box of the following examples that comment on those in the first box.',
	    'exercise-task-10': 'Please click to highlight the word or words in the second and third boxes that comment on those in the first box for the following 3 examples.',
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 3A-1',
	    'final-description': 'You know how ideas can form a deductive chain of reasoning',
	    'next-course-button': 'proceed to section 3A-2',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'summarizing-deductive': {
	    'course-title': 'Deductive Reasoning',
	    'course-name': 'Section 3A-2 <span class="unit-title">Deductive Reasoning<span>',
	    'unit-section-title': '3A-2 Exercises',
	    'exercise-title': 'Summarizing a Deductive Argument',
	    'exercise-description-1': 'Deductive summaries should try to encompass all the parts of the deductive argument, not just repeat the “therefore” point. Because the resulting summary statement often serves as a base from which to develop the thinking further, either inductively or deductively, you want it to be as solid as possible, and also as interesting.',
	    'exercise-description-2': '<p>The technique for summarizing a deductive argument demands some creative thinking. You need to:</p>\n        <ul>\n          <li>Read the argument</li>\n          <li>State the bare bones of the final point in the box above (I have given you the opening words)</li>\n          <li>Add to it the essence of the first two points (often by thinking \u201Cbecause\u201D)</li>\n          <li>Rewrite to turn it into a pithier, more graceful statement</li>\n          <li>Press REVEAL and compare your answers</li>\n        </ul>\n        <p>The wordings you generate in the exercises that follow may differ from mine, but - so long as they say roughly the same thing \u2013 it does not mean they are wrong.</p>',
	    'exercise-description-3': '<p>I have put together a few examples on which you can practice summarizing deductive arguments. To help you focus, I have underlined the important words in each box on the key line and I have given you the first few words in the "bare bones\u201D rough summary box, complete this and fill in the simplified summary box above. Your answers may not match mine exactly, but you should get the gist. When you are happy with your answers click the \u201CReveal" button to show the school solution.\n    </p>',
	    'menu-list': {
	      'exercise-1': 'Digitization',
	      'exercise-2': 'Paying Taxes',
	      'exercise-3': 'Habits',
	      'exercise-4': 'Music for Students',
	      'exercise-5': 'Monetary Policy'
	    },
	    'exercise-1-number': '3A-2 - Exercise 1',
	    'exercise-1-title': 'Digitization',
	    'exercise-2-number': '3A-2 - Exercise 2',
	    'exercise-2-title': 'Paying Taxes',
	    'exercise-3-number': '3A-2 - Exercise 3',
	    'exercise-3-title': 'Habits',
	    'exercise-4-number': '3A-2 - Exercise 4',
	    'exercise-4-title': 'Music for Students',
	    'exercise-5-number': '3A-2 - Exercise 5',
	    'exercise-5-title': 'Monetary Policy',
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 3A-2',
	    'final-description': 'You now know how to draw a graceful and useful insight from a deductive argument',
	    'next-course-button': 'proceed to section 3A-3',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 345 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'unearthing-arguments': {
	    'course-title': 'Deductive Reasoning',
	    'course-name': 'Section 3A-3 <span class="unit-title">Deductive Reasoning<span>',
	    'unit-section-title': '3A-3 Exercises',
	    'exercise-title': 'Unearthing Embedded Arguments',
	    'exercise-intro': '<p>You are now familiar with the basic pattern of deductive reasoning.  But the arguments are generally embedded in prose, and are less easy to pick out than inductive ones.  So  a key skill is to be able to find the deductive argument when it is buried in words.  Following are a few good deductive arguments drawn from various recent publications.</p></p>',
	    'exercise-bottom': '<p>I have supplied the summary point of the argument in each excerpt, plus one of the points in the argument itself. I have also listed all of the statements made in each excerpt. Please pick out the points that make up the rest of the argument and arrange them in the appropriate place in the framework.</p>',
	    'menu-list': {
	      'exercise-1': 'Success Metrics',
	      'exercise-2': 'Predictive Analysis',
	      'exercise-3': 'Valuing Data',
	      'exercise-4': 'Success in the Future',
	      'exercise-5': 'Inequality in America',
	      'exercise-6': 'Policy Uncertainty'
	    },
	    'exercise-1': {
	      'number': '3A-3 - Exercise 1',
	      'title': 'Success Metrics',
	      'description': 'Our success metrics determine what we can and cannot invest in. We have allowed a minority to dictate those metrics to the majority over and over. The higher value placed on return on net assets, internal rate of return, and earnings per share over other metrics has led to innovations that squeeze costs and noncash assets. As a result, investing to create growth and jobs is a third-best option, behind efficiency innovations (first) and doing nothing (second).',
	      'reference': 'The Capitalist\u2019s Dilemma<br/>by Clayton Christenson, Harvard Business Review, June 2014'
	    },
	    'exercise-2': {
	      'number': '3A-3 - Exercise 2',
	      'title': 'Predictive Analysis',
	      'description': 'Predictive analysis is starting to be used widely in business. The underlying concept is that when things break down, they generally don’t do so all at once, but gradually over time. Armed with sensor data, correlational analysis and similar methods we can identify the specific patterns, the telltale signs, that typically crop up before something breaks – the whirring of a motor, excessive heat from an engine, and the like. From then on, one need only look for that pattern to know when something is amiss.',
	      'reference': 'Big Data: A Revolution that will Transform How we Live, Work and Think<br/>by Viktor Mayer\u2013Schonberger and Kenneth Cukier, John Murray 2013'
	    },
	    'exercise-3': {
	      'number': '3A-3 - Exercise 3',
	      'title': 'Valuing Data',
	      'description': 'Unlike material things – the food we eat, a candle that burns – data’s value does not diminish when it is used. It can be processed again and again. Information is what economists call a “nonrivalrous” good: one person’s use of it does not impede another’s. And information doesn’t wear out with use the way material goods do. More importantly, it can be harnessed for multiple purposes. Thus, data’s full worth is much greater than the income extracted from its first use, which may bring in only tiny amounts. Its true value needs to be considered in terms of all the possible ways it can be employed in the future. Innovative companies that learn to exploit their data effectively can reap potentially huge benefits.',
	      'reference': 'Big Data: A Revolution that will Transform How we Live, Work and Think<br/>by Viktor Mayer-Schonberger and Kenneth Cukier, John Murray 2013'
	    },
	    'exercise-4': {
	      'number': '3A-3 - Exercise 4',
	      'title': 'Success in the Future',
	      'description': 'Many investors practice a fake form of long-term thinking. Portfolio managers see the returns of the 20th century and project those far into the future. Tomorrow’s retirees are betting their fortunes on the success rates of yesterday’s companies. But the vast wealth registered by modern capital markets came from technological feats that cannot be repeated. If nobody takes the risk to invent products that produce new industries and new profits, then analyzing historical returns from the 20th century will be no better guide to our future than researching crop yields from the 10th century.  Without innovation, faith in the stock market is a kind of cargo cult*. <span class="">*Cargo cult: a religious movement of the SW Pacific, characterized by expectation of the return of spirits in ships or aircraft carrying goods that will provide for the needs of the followers</span>',
	      'reference': 'Our Dangerous Illusion of Technological Progress<br/>by Gary Kasparov and Peter Thiel, Financial Times, November 9, 2014'
	    },
	    'exercise-5': {
	      'number': '3A-3 - Exercise 5',
	      'title': 'Inequality in America',
	      'description': 'America is the only high-income country whose 25-34 year olds are no better educated than its 55-64 year olds. This is partly because other countries have caught up on the US, which pioneered mass college education. It is also because children from poor backgrounds are handicapped in completing college.\n      <br/>A report written by the chief US economist of Standard & Poor\u2019s notes that for the poorest households, college graduation rates increased by only about 4 percentage points between the generation born in the early 1960s and that born in the early 1980s. The graduation rate for the wealthiest households increased by almost 20 percentage points over the same period. Yet, without a college degree, the chances of upward mobility are now quite limited. As a result, children of prosperous families are likely to stay well off and children of poor families likely to remain poor.',
	      'reference': 'Why Inequality is Such a Drag on Economics<br/>by Martin Wolf, Financial Times, October 2, 2014'
	    },
	    'exercise-6': {
	      'number': '3A-3 - Exercise 6',
	      'title': 'Policy Uncertainty',
	      'description': 'Growing policy uncertainty is bad for business. A large body of research shows that when overall uncertainty increases, GDP falls. Companies invest less, trade less, and higher fewer people. Consumers spend less.\n      <br/>The effects are even more insidious than they seem at first. Uncertainty paralyzes, making businesses and consumers less sensitive to outside forces. In a high-uncertainty environment, government policies to reverse a recession aren\u2019t very effective \u2013 as they so notably weren\u2019t in the last recession.  And because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract \u2013 so resources don\u2019t get reallocated from the less productive to the more productive, shutting down the primary mechanism for increasing productivity.',
	      'reference': 'You can be sure that policy uncertainty is here to say<br/> by Geoff Colvin, writing in Forbes Magazine 2014'
	    },
	    'congratulation-message': 'WELL DONE',
	    'finish-section': 'You have completed Section 3A-3',
	    'final-description': 'You are now finished with the tedium of deductive arguments,<br/>and understand why you should avoid using them unless truly required',
	    'next-course-button': 'proceed to section 3B-1',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'inductiveReasoning': {
	    'course-title': 'Inductive Reasoning Finding General Plural Nouns',
	    'course-name': 'Section 3B-1 <span class="unit-title">Inductive Reasoning<br/>Finding General Plural Nouns<span>',
	    'course-video': {
	      'title': 'Section 3 SUPPORTING THE POINTS<br/>57:04 – 1’04:02 3B INDUCTIVE GROUPINGS :- ex 3B-1 finding general plural nouns+ 3B-2<br/> identifying inductive relationships+ 3B-3 distinguishing induction from deduction',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '3B-1 Lecture'
	    },
	    'unit-section-title': '3B-1 Exercises',
	    'exercise-intro': '<p>Having thoroughly learned the intricacies of deductive reasoning, you come now to inductive reasoning. Inductive reasoning brings together three or four (never more than five) similar ideas, either to support an existing idea or to let you infer a new idea, with a structure that looks like this:</p>\n    <img src="/assets/images/structure-3b1.png" alt="Original structure" />\n    <p>The grouped ideas will always be able to be described by a general plural noun, such as \u201Cproblems\u201D or \u201Cchanges\u201D or \u201Cconclusions.\u201D Generally speaking, general plural nouns fall into one of three categories \u2013 reasons, actions, or proofs \u2013 and generally answer a variation on one of three standard questions:</p>\n    <ul>\n    <li><u>Question</u></li>\n    <li>Why?</li>\n    <li>How?</li>\n    <li>How do you know?</li>\n    </ul>\n    <ul>\n    <li><u>General Plural Noun</u></li>\n    <li>Reasons</li>\n    <li>Steps</li>\n    <li>Proofs (or deductive reasoning)</li>\n    </ul>\n    <p>Being able to identify the general plural noun for a grouping is essential to helping you work out the points to be included in your pyramid. If you know the idea you want to support, identifying the general plural noun for the set of ideas needed to support it signals your mind to start searching for the appropriate points of support.</p>\n    <br/><p>The following set of exercises will help you think in terms of general plural nouns when reasoning inductively. Please identify the question raised by the main point, and general plural noun that describes the set of ideas that make up the answer. (I have done the first one, Bentham, to show you the pattern).</p>',
	    'menu-list': {
	      'exercise-1': 'Bentham',
	      'exercise-2': 'Information Systems',
	      'exercise-3': 'Pensions',
	      'exercise-4': 'Fifteenth Century France vs Italy',
	      'exercise-5': 'The End of Classical Sculpture',
	      'exercise-6': 'The Chaos Revolution',
	      'exercise-7': 'The Fall of Lehman'
	    },
	    'exercise-1': {
	      'number': '3B-1 - Exercise 1',
	      'title': 'Bentham (example)'
	
	    },
	    'exercise-2': {
	      'number': '3B-1 - Exercise 2',
	      'title': 'Information Systems'
	
	    },
	    'exercise-3': {
	      'number': '3B-1 - Exercise 3',
	      'title': 'Pensions'
	
	    },
	    'exercise-4': {
	      'number': '3B-1 - Exercise 4',
	      'title': 'Fifteenth Century France vs Italy'
	
	    },
	    'exercise-5': {
	      'number': '3B-1 - Exercise 5',
	      'title': 'The End of Classical Sculpture'
	    },
	    'exercise-6': {
	      'number': '3B-1 - Exercise 6',
	      'title': 'The Chaos Revolution'
	    },
	    'exercise-7': {
	      'number': '3B-1 - Exercise 7',
	      'title': 'The Fall of Lehman'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 3B-1',
	    'final-description': 'You see that groups of inductively related ideas can be described by<br/>a general plural noun',
	    'next-course-button': 'proceed to section 3B-2',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'identifyingInductivePoints': {
	    'course-title': 'Inductive Reasoning Identifying Inductive Points',
	    'course-name': 'Section 3B-2 <span class="unit-title">Inductive Reasoning<br/>Identifying Inductive Points<span>',
	    'unit-section-title': '3B-2 Exercises',
	    'exercise-intro': '<p>You should now see quite clearly how inductive ideas relate. But it is one thing to identify the question and the general plural noun when you have the structure in front of you, it is quite another to be able to pick out the inductive points when they are embedded in prose and enhanced by style. Let\u2019s strengthen your structure muscle a bit more by giving you the opportunity to do just that.</p>\n    <br/>\n    <p>Following are several excerpts from recent publications. In each case I give you the main point, the question, and the general plural noun. Please pick out the support points that match the general plural noun, and put them in the appropriate boxes in the blank pyramid frame.</p>\n    <br/>\n    <p>Before you start, however, think back to the last set of exercises you just did. You will see that in each case I have worded the points in the boxes in the <u>same grammatical form</u>.</p>\n    <br/>\n    <div class="boxes">\n      <div class="box">\n        <strong>Can cut costs</strong>\n        <span>- More strictly control...</span>\n        <span>- Streamline...</span>\n        <span>- Close...</span>\n        <span>- Restructure</span>\n      </div>\n      <div class="box">\n        <strong>Don\u2019t support operating needs</strong>\n        <span>- They utilize...</span>\n        <span>- They force...</span>\n        <span>- They ignore</span>\n      </div>\n      <div class="box">\n        <strong>Killed the pension market</strong>\n        <span>- Government killed...</span>\n        <span>- Accountants required...</span>\n        <span>- Market encouraged...</span>\n      </div>\n      <div class="box">\n        <strong>France more stable than Italy</strong>\n        <span>- Less subject to...</span>\n        <span>- Less able to...</span>\n        <span>- More unified for...</span>\n      </div>\n      <div class="box">\n        <strong>The Chaos Revolution</strong>\n        <span>- Fell between disciplines</span>\n        <span>- Defied easy explanation</span>\n        <span>- Required new world view</span>\n      </div>\n      <div class="box">\n        <strong>The Fall of Lehman</strong>\n        <span>- Bond spreads widened</span>\n        <span>- Fed quadrupled forex swaps</span>\n        <span>- Credit Swaps market vanished</span>\n        <span>- Business reined in investments</span>\n      </div>\n      <div class="clearfix"></div>\n    </div>\n    <br/><p>Keep this technique in mind as you pick out and word the points in each example. You will find that looking for ideas of the same kind as you read along makes the document more interesting, and thus easier to absorb.</p>',
	    'menu-list': {
	      'exercise-1': 'The Delusions of Entrepreneurs (i)',
	      'exercise-2': 'The Delusions of Entrepreneurs (ii)',
	      'exercise-3': 'Why the Brain Prefers Paper',
	      'exercise-4': 'How Might We Search for Life on Mars',
	      'exercise-5': 'The First Search'
	    },
	    'exercise-1': {
	      'number': '3B-2 - Exercise 1',
	      'title': 'The Delusions of Entrepreneurs (i)',
	      'description': 'When the term \u201Dentrepreneur\u201D was coined in the 18th century, it was defined as a \u201Cbearer of risk.\u201D Yet studies of entrepreneurs find that, in general, they\u2019re as risk-averse as everyone else. Only when it comes to starting a business are they daring. And that\u2019s because the fundamental characteristic of entrepreneurs isn\u2019t risk seeking, it\u2019s overconfidence.\n<br/><br/>A study in the Journal of Business Venturing found that entrepreneurs are overconfident about their ability to prevent bad outcomes. They\u2019re also overconfident about the prospects of their businesses. Another study in the same journal of some three thousand entrepreneurs found that 81% thought their businesses had at least a 70% chance of success, and a third thought there was no chance they would fail \u2013 numbers that bear no relation to reality. A recent paper called \u201CLiving Forever\u201D notes that entrepreneurs are more likely than other people to overestimate their life spans.'
	    },
	    'exercise-2': {
	      'number': '3B-2 - Exercise 2',
	      'title': 'The Delusions of Entrepreneurs (ii)',
	      'description': 'In the start-up world, endemic optimism is amplified by other factors. The ease of developing a product and getting seed money gives entrepreneurs a lot of positive feedback early on. The rise of \u201Caccelerators\u201D like Y Combinator \u2013 which provide funding and also mentoring and networking services (a kind of boot camp for entrepreneurs) \u2013 has made building a business seem less risky. On top of this, there\u2019s a widespread tendency to treat failure as a badge of honor: \u201CFail fast, fail often\u201D is a familiar mantra in Silicon Valley. There\u2019s now a regular FailCon, where people come to hear other entrepreneurs tell about the hard times they endured and about how starting a business and failing actually makes you more likely to succeed in the future. It\u2019s a comforting message, but the evidence suggests that past failure really just predicts future failure.'
	    },
	    'exercise-3': {
	      'number': '3B-2 - Exercise 3',
	      'title': 'Why the Brain Prefers Paper',
	      'description': 'Despite all the increasingly user-friendly and popular technology, most recent studies confirm earlier conclusions: paper still has advantages over screens as a reading medium. Studies indicate that digital devices prevent people from efficiently navigating long texts. They inhibit the reader from intuitively constructing mental maps of the texts, so that under-standing what it says takes longer. Compared with paper, screens also drain more of our mental resources while we are reading, making it a little harder to remember what we read when we are done.\n      Paper books also have more obvious topography than on-screen text.  Turning pages is like leaving one footprint after another on a trail - there is a rhythm to it and a visible record of how far one has travelled. The text is easy to navigate, so the reader always knows where he is in the book. And knowing that enables him to relax and become emotionally open to what the text is saying.',
	      'reference': 'Why the Brain Prefers Paper<br/>by Ferris Jabr, Scientific American, November 2013'
	    },
	    'exercise-4': {
	      'number': '3B-2 - Exercise 4',
	      'title': 'How Might We Search for Life on Mars',
	      'description': 'All of earth\u2019s organisms collectively contain many millions of different proteins. With so many to choose from, how do we pick the few hundred that a single immunoassay test could search for? The short answer is that we can\u2019t know for sure, but we can make educated guesses based on two strategies.\n      <br/><br/>First, we could search for proteins that would be useful or essential to survival on Mars. For example, we might search for enzymes that consume perchlorate, cold-adapted enzymes that would allow a microorganism to survive Mars\u2019s frigid temperatures, or enzymes that would repair damage to DNA caused by Mars\u2019s strong ionizing radiation. Second, we could target molecules that are ubiquitous throughout the microbial world, such as peptidoglycan, which is a universal component of all bacterial cell walls, or adenosine triphosphate (ATP), which is used by all living organisms on Earth to transport chemical energy for metabolic activity.\n      <br/><br/>Even if Mars\u2019s harsh environment has destroyed\nlarge molecules such as DNA and proteins, we might still find evidence for life in the debris. The key will be to search for patterns. Many types of molecules are chemically equivalent to one another, but have opposite \u201Cchirality\u201D - their bonds may twist to the left or the right. Life on Earth is dominated by left-handed amino acids.\nIf an experiment detects amino acids and finds a particular set that has a dominant left- or right-handed chirality, this would be compelling evidence for the presence of life. Interestingly, if that chirality were right-handed \u2013 the opposite of Earth proteins \u2013\nit would be evidence that the life-forms on Mars evolved independently from Earth life.',
	      'reference': 'How to Search for Life on Mars<br/>by Christopher P. McKay and Victor Porro Garcia,<br/>Scientific American, June 1, 2014, Volume 310, issue 6'
	    },
	    'exercise-5': {
	      'number': '3B-2 - Exercise 5',
	      'title': 'The First Search',
	      'description': 'The 1976 Viking Experiments looked for life using standard search techniques of the time. In the initial experiment, the lander took a scoop of Martian soil and added carbon compounds as food for any microorganisms that might be in the soil. If microbes did exist in the soil, we might expect them to consume the food and release carbon dioxide. In fact, the Viking missions did see this behavior. On its own, the test would seem to indicate that microorganisms were present in the Martian soil. When combined with the results of the other experiments, however, researchers could not be sure.\n      <br/><br/>The second experiment looked for evidence of photosynthesis but returned inconclusive results. A third experiment added water into a soil sample. If life were present, the moist soil might have produced carbon dioxide. Instead it produced oxygen. This was very strange, as no known soil on Earth does this. Scientists concluded that the oxygen came from a chemical reaction.\n      In the final experiment, the landers searched for organic compounds in the soil. Organics are carbon-containing compounds that form the building blocks of life. If any life existed on Mars, we would expect to find these compounds. Yet organics alone would not provide definitive evidence of life, because we also expect meteorites to continuously deposit organic compounds on Mars. Puzzlingly, the experiment found no evidence of organics whatsoever.\n      <br/><br/>Taken together, the findings left investigators stumped. Most scientists believed that chemical reactions were responsible for the results in the last two experiments, but chemistry could not quite explain the first. A small but vocal minority of Mars scientists held that the first experiment did, in fact, find evidence of life. But most everyone else concluded that Mars was barren.',
	      'reference': 'How to Search for Life on Mars<br/>by Christopher P. McKay and Victor Porro Garcia,<br/>Scientific American, June 1, 2014, Volume 310, issue 6'
	    },
	    'exercise-intro-2': '<p>Note on Summarizing Inductive Groupings.</p>\n<br/><p>Summarizing an inductive grouping is more difficult than summarizing a deductive line of reasoning, because here the act of summarizing is the act of completing the thinking. The essence of the activity is to look for insights in the similarities found in the way the sentences are worded.</p>\n<br/><p>All ideas are written as sentences, with a subject and a predicate. (The predicate is the verb and everything that follows it.) In inductive reasoning, the ideas go together if:</p>\n<br/><ul>\n        <li>The subjects are all the same and the predicates fall into the same category</li>\n        <li>The predicates are all the same and the subjects fall into the same category</li>\n        <li>Neither the subjects nor the predicates are the same, but the judgments implied by the sentences fall into the same category</li>\n</ul><br/>\n<p>We will deal with making sense of groupings of ideas, including summarizing them, in Section Six of the course.</p>',
	    'congratulation-message': 'WELL DONE',
	    'finish-section': 'You have completed Section 3B-2',
	    'final-description': 'You see how reading to identify the inductive points<br/>helps you grasp and absorb complex thinking',
	    'next-course-button': 'proceed to section 3B-3',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'inductionFromDeduction': {
	    'course-title': 'Distinguishing Induction From Deduction',
	    'course-name': 'Section 3B-3 <span class="unit-title">Distinguishing Induction<br/>From Deduction<span>',
	    'unit-section-title': '3B-3 Exercises',
	    'exercise-intro': '<p>Before we leave the ease of finding general plural nouns, I want to focus your attention on the question of whether to organize a document inductively or deductively. At the Key Line level you should always prefer the inductive to the deductive when you can, because as you have seen it is easier for the reader to grasp the ideas if they are laid out inductively.</p>\n    <br/>\n    <p>To do so you need to be able to tell easily the difference between the two types of reasoning. The best way for beginners to develop that skill quickly is to be forced to identify a variety of arguments. The following examples will give you plenty of practice. In each case, I given you the written excerpt and a part-filled picture of its pyramid: the Main Point and the beginning of the Key Line points. All you need to do is read each one, fill in the remaining points of the Key Line, and identify the form of reasoning.</p>\n    <br/>\n    <p>You are likely to find that the inductively structured excerpts are invariably easier to absorb than the deductive ones.</p>\n    <br/>',
	    'menu-list': {
	      'exercise-1': 'Engineers’ Dreams',
	      'exercise-2': 'The Rise of Capitalism',
	      'exercise-3': 'The Power of Prototyping',
	      'exercise-4': 'The Delusions of Entrepreneurs (iii)',
	      'exercise-5': 'What We Lost',
	      'exercise-6': 'The Need for Hierarchies',
	      'exercise-7': 'The Invention of Hay'
	    },
	    'exercise-1': {
	      'number': '3B-3 - Exercise 1',
	      'title': 'Engineers’ Dreams',
	      'description': 'It is possible to discern a persistent pattern in the rise and fall of engineering technologies. The pattern resembles in some ways the rise and fall of species in the evolution of plants and animals. A technology during its phase of rapid growth and spectacular success is usually small, quick and agile. As it grows mature it becomes settled and conservative, prevented by the inertia of size from reacting quickly to sudden shocks. When a technology has grown so big and sluggish that it can no longer bend\nwith the winds of change, it is ripe for extinction. Extinction may be long delayed or avoided in sheltered corners, but an overripe technology cannot regain its lost youth. New small and quick alternatives will be waiting to occupy the ecological niche left vacant by the decline of the old. This rhythm, which repeats itself in the evolution of species over periods of millions of years, seems to run about a hundred thousand times faster in the evolution of human technology.',
	      'reference': 'Freeman Dyson, Infinite in All Directions, Harper & Row 1988'
	    },
	    'exercise-2': {
	      'number': '3B-3 - Exercise 2',
	      'title': 'The Rise of Capitalism',
	      'description': 'During the course of the nineteenth century, the landed barons of the aristocracy were replaced by the robber barons of capitalism. This dramatic shift in decision-making power came about because of a technological shift in the factors that produced strategic economic advantage. In the agricultural era, land was the key factor in determining strategic advantage, and those who controlled the land (the aristocratic landowners) controlled the decision-making system. In contrast, in\nthe industrial era, the power source, initially the steam engine and later the internal combustion engine or the electric motor, was the key factor in determining strategic advantage. As a consequence, the capitalist who owned the power source was the economic general who made the important decisions. Capitalists supplanted aristocrats not because of a shift in ideology but because of a shift in technology.',
	      'reference': 'Lester C. Thurow, The 21st Century World Business, Volume II,<br/> Number 1 1996'
	    },
	    'exercise-3': {
	      'number': '3B-3 - Exercise 3',
	      'title': 'The Power of Prototyping',
	      'description': 'Although it seems riskier at first glance, the do it/fix it approach actually increases the chances of success even as it reduces the cost of failure. True, it rushes new processes into pilots before they are completely debugged. But building and trying pilot operations for real requires only a few person-months of effort and eliminates the need for much analysis and planning,\n      which can absorb person-years of effort before implementation even begins. In practice, the do it/fix it approach involves little risk, because the new systems are run in parallel with the old until they have fully proved themselves. Complete switch-over takes place only after executives are sure that the new work processes and systems will work better than the old.',
	      'reference': 'Do it, Then Fix it: The Power of Prototyping,<br/>by Derek L. Dean and Robert E. Dvorak, McKinsey Quarterly 1995, Number 4'
	    },
	    'exercise-4': {
	      'number': '3B-3 - Exercise 4',
	      'title': 'The Delusions of Entrepreneurs (iii)',
	      'description': 'You might suppose that entrepreneurs would be better off curbing their optimism. But we\u2019ve built a whole system on unrealistic expectations. Because we don\u2019t know how to identify good companies in advance, investors end up funding lots of them in the hope that a few will hit it big \u2013 the way that sea turtles hatch hundreds of eggs because so many of them die on the way down to the water. Overconfidence means that many more companies start up than will ever succeed. The economy has come to rely on this Darwinian process to drive innovation. The paradox is that, while it\u2019s unfortunate for individual companies, it\u2019s really beneficial for society. In the delusions of entrepreneurs are the seeds of technological progress.'
	    },
	    'exercise-5': {
	      'number': '3B-3 - Exercise 5',
	      'title': 'What We Lost',
	      'description': 'What the American economy lost between 1973 and 1993 was clear. First, we no longer had a vast, efficient marketplace and cheap natural resources to ourselves. American businesses and their employees were now for the first time subject to intense competition from new mass producers overseas. Second, conventional mass production and distribution, and their several considerable advantages, were in retreat domestically because of flexible production and fragmenting markets. Both of these factors served to reduce our capacity\n      utilization rates and raise the costs of doing business for mass producers, which needed high volume to stay competitive. Third, American business reduced capital investment markedly in the face of rising competition, uncertainty, and falling returns. The further result was fewer jobs and lower wages, which slowed overall economic growth still more by reducing the demand for goods and services, and in turn further dampened returns on capital investment.',
	      'reference': 'The End of Affluence: The Causes and Consequences of America\u2019s<br/>by Jefferey Madrick, Economic Dilemma, Random House 1995'
	    },
	    'exercise-6': {
	      'number': '3B-3 - Exercise 6',
	      'title': 'The Need for Hierarchies',
	      'description': 'When the Information Age\u2019s most enthusiastic apostles celebrate the breakdown of organizational hierarchy and authority, they neglect one critical factor: trust, and the shared ethical norms that underlie it. Communities depend on mutual trust, and will not arise spontaneously without it. Hierarchies are necessary because not all people within a community can be relied upon to live by tacit ethical rules alone. A small number may be actively asocial, seeking to undermine or exploit the group through fraud or simple mischievousness. A much larger number will tend to be free riders, willing to benefit from membership in the group while contributing as\n      little as possible to the common cause. Hierarchies are necessary because all people cannot be trusted at all times to live by internalized ethical rules and do their fair share. They must ultimately be coerced by explicit rules and sanctions in the event they do not live up to them. This is true in the economy as well as in society more broadly: large corporations have their origins in the fact that it is very costly to contract out for goods or services with people one does not know well or trust. Consequently, firms found it more economical to bring outside contractors into their own organization, where they could be supervised directly. ',
	      'reference': 'Trust: The Social Virtues & the Creation of Prosperity<br/>by Francis Fukuyama, The Free Press 1995'
	    },
	    'exercise-7': {
	      'number': '3B-3 - Exercise 7',
	      'title': 'The Invention of Hay',
	      'description': 'The technologies that have had the most profound effects on human life are usually simple. A good example of a simple technology with profound historical consequences is hay. Nobody knows who invented hay, the idea of cutting grass in the autumn and storing it in large enough quantities to keep horses and cows alive through the winter. All we know is that the technology of hay was unknown to the Roman Empire, but was known to every village of medieval Europe. The invention of hay was the decisive event that moved the center of gravity of urban\n      civilization from the Mediterranean basin to Northern and Western Europe. The Roman Empire did not need hay because in a Mediterranean climate the grass grows well enough in winter for animals to graze. North of the Alps, great cities dependent on horses and oxen for motive power could not exist without hay. So it was hay that allowed populations to grow and civilizations to flourish among the forests of Northern Europe. Hay moved the greatness of Rome to Paris and London, and later to Berlin and Moscow and New York.',
	      'reference': 'Infinite in All Directions,<br/>by Freeman Dyson, Harper & Row 1988'
	    },
	    'exercise-intro-2': '<p>You have now seen that inductive reasoning is much easier for the reader to absorb than is deductive. Consequently, you should prefer the inductive structure to the deductive, if you can, which is most of the time. Rule of thumb: Use deductive only when the argument for <u>any action at all</u> is more important to the reader than the individual actions themselves.</p>',
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 3B-3',
	    'final-description': 'You should now be easily able to tell whether you should choose inductive reasoning vs deductive.',
	    'next-course-button': 'proceed to section 3B-4',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'deductionToInduction': {
	    'course-title': 'Transforming Deduction to Induction',
	    'course-name': 'Section 3B-4 <span class="unit-title">Transforming Deduction<br/>to Induction<span>',
	    'course-video': {
	      'title': 'Section 3 SUPPORTING THE POINTS<br/>1’04.16 – 1’12:55 TRANSFORMING DEDUCTION TO INDUCTION -:<br/>3C Transforming deduction to induction',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '3B-4 Lecture'
	    },
	    'unit-section-title': '3B-4 Exercises',
	    'exercise-intro': '\n    <p>This structure presents the author\u2019s thinking as it came to him, rather than attempting to communicate the heart of the message. But as you can see, the same subjects are discussed in all three sections leading to the \u201Csteps,\u201D which are really the main points of the document. Once you see that, it is relatively easy to build your structure inductively around them, like this, with the information that supports each section underneath.</p>\n    <br/>\n    <img class="intro-img2" src="/assets/images/structure-3b4-2.png" alt="Original structure" />\n    <br/>\n    <p>Following are five opportunities for you to restructure a pyramid from deductive to inductive.</p>',
	    'deductive-form': '<u>Deductive form</u>',
	    'exercise-bottom': '<p>In each case I have given you the original deductive structure, a blank pyramid for restructuring the ideas inductively, and a list of the inductive ideas to place properly in the pyramid.</p>',
	    'menu-list': {
	      'exercise-1': 'Policy Uncertainty',
	      'exercise-2': 'Mind Tapes',
	      'exercise-3': 'Can you Teach an Old Dog New Tricks?',
	      'exercise-4': 'Euro Illusions',
	      'exercise-5': 'Banking on the State: the Philosopher’s Stone of Finance'
	    },
	    'exercise-1': {
	      'number': '3B-4 - Exercise 1',
	      'title': 'Policy Uncertainty',
	      'description': 'Policy uncertainty is bad for business. A large body of research shows that when overall uncertainty increases, GDP falls. Companies invest less, trade less, and hire fewer people. Consumers spend less.\n      <br/><br/>\n      The effects are even more insidious than they seem at first. <span class="js-ex1" ng-class="{\'highlight-word\': vm.highlightWords.ex1}">Uncertainty paralyzes, making businesses and consumers less sensitive to outside forces.</span> In a high-uncertainty environment, government policies to reverse a recession aren\u2019t very effective \u2013 as they so notably weren\u2019t in the last recession. And <span class="js-ex1" ng-class="{\'highlight-word\': vm.highlightWords.ex1}">because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract</span> \u2013 so <span class="js-ex1" ng-class="{\'highlight-word\': vm.highlightWords.ex1}">resources don\u2019t get reallocated from the less productive to the more productive,</span> shutting down the primary mechanism for increasing productivity.',
	      'reference': 'You can be sure that policy uncertainty is here to say<br/>by Geoff Colvin, writing in Forbes Magazine 2014'
	    },
	    'exercise-2': {
	      'number': '3B-4 - Exercise 2',
	      'title': 'Mind Tapes',
	      'description': 'Fascinating as the idea of mind tapes is, the supposition that such personality preservation might someday be possible is almost certainly wrong. The fundamental obstacle is that brains are not like computers, fresh from the factory and all alike. Even at birth human <span class="js-ex2" ng-class="{\'highlight-word\': vm.highlightWords.ex2}">brains are no doubt uniquely configured</span> \u2013 like fingerprints - and a lifetime of learning and experience can only enhance their idiosyncrasies. There are scant grounds then for\nhope that anything with the <span class="js-ex2" ng-class="{\'highlight-word\': vm.highlightWords.ex2}">hardware-independence of a program can be \u201Cread out\u201D of a brain</span> (at a periodic \u201Cmind taping\u201D session). There is even less hope that such a mind tape, even if it could be construed, <span class="js-ex2" ng-class="{\'highlight-word\': vm.highlightWords.ex2}">would be compatible with another brain\u2019s hardware.</span> Computers are designed to <span class="js-ex2" ng-class="{\'highlight-word\': vm.highlightWords.ex2}">be readily redesignable (at another level) by the insertion</span>, in one big lump or rush, of a new program; brains presumably are not.',
	      'reference': 'The Mind\u2019s Eye: Fantasies and Reflections on Self and Soul<br/>\nby Douglas R. Hofstadter and Daniel C. Dennett, Basic Books 2000',
	      'diagram': '\n        <p style="margin-left: -233px;" class="diagram-question">How do you know?</p>\n        <div class="diagram-box">\n          <p>The idea of mind taping to preserve personality is almost certainly wrong</p>\n        </div>\n        <div class="connector">\n          <svg class="svg-long-deductive-arrow">\n            <line x1="5" y1="5" x2="377" y2="117" />\n            <path d="M 0 0 L 13 15 L 19 0 Z" />\n          </svg>\n        </div>\n        <div class="diagram-slots">\n          <div class="diagram-box">\n            <p>Brains are uniquely configured</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>Don\u2019t have a tape that could record the uniqueness</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>Couldn\u2019t find hardware on which to read the recording</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>Can\u2019t insert the results into another brain</p>\n          </div>\n        </div>'
	    },
	    'exercise-3': {
	      'number': '3B-4 - Exercise 3',
	      'title': 'Can You Teach an Old Dog New Tricks?',
	      'description': '<span class="js-ex3" ng-class="{\'highlight-word\': vm.highlightWords.ex3}">After adolescence, our neural network brains are never again quite so flexible as when we were children.</span> Does this mean that it\u2019s impossible to learn something new \u2013 like psycotherapic change - while unlearning something old?\n      <br/><br/>There is a widespread <span class="js-ex3" ng-class="{\'highlight-word\': vm.highlightWords.ex3}">impression, usually tacit, that \u201Cchange\u201D means getting rid wholly of old patterns and replacing them wholly with new ones.</span> The operation of neural networks in the brain sheds light on this mistaken notion. In brief, you certainly can teach an old dog new tricks, but it is more difficult to do so, depending on what his old tricks are, and whether he is a dog willing to pick himself up and start all over again, and again, or not.\n      <br/><br/>Psychotherapeutic change is fundamentally little different from learning, chiefly because <span class="js-ex3" ng-class="{\'highlight-word\': vm.highlightWords.ex3}">it shares with learning the same kind of obstacles:  laziness, the quest for novelty, the desire for instant gratification, and especially the avoidance of failure.</span> We don\u2019t want to remember the famous men who had to fall to rise again, because it suggests that to meet our own challenges we might need to do the same.\n      <br/><br/>The <span class="js-ex3" ng-class="{\'highlight-word\': vm.highlightWords.ex3}">solution to the old-dog problem is practical and pedestrian: repetition, perseverance, courage, willingness to start all over again.</span> New patterns may be embedded in a fresh network relatively quickly. When a network is already converged to a specific set of patterns, it will require many more repetitions to \u201Coverlearn\u201D a new \u2013 especially a contradictory \u2013 pattern.',
	      'reference': 'The Quantum Brain:<br/>The Search for Freedom and the Next Generation of Man<br/>by Jeffrey Satinover, John Wiley & Sons 2001',
	      'diagram': '\n        <p style="margin-top: -178px;" class="diagram-question">Why?</p>\n        <div class="diagram-box">\n          <p>You can certainly teach an old dog new tricks, but it is more difficult</p>\n        </div>\n        <div class="connector">\n          <svg class="svg-long-deductive-arrow">\n            <line x1="5" y1="5" x2="377" y2="117" />\n            <path d="M 0 0 L 13 15 L 19 0 Z" />\n          </svg>\n        </div>\n        <div class="diagram-slots">\n          <div class="diagram-box">\n            <p>Post-adolescent brains are never quite so flexible as when we were children</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>Belief is that \u201Cchange\u201D requires getting rid of old patterns before adding new ones</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>Actually it only requires overcoming normal obstacles to learning (laziness, etc.)</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div class="diagram-box">\n            <p>The solution requires repetition perseverence, and courage</p>\n          </div>\n        </div>\n        <div class="connector">\n         <svg>\n          <line x1="679" y1="0" x2="250" y2="115" class="connector__line"/>\n          <line x1="679" y1="0" x2="460" y2="115" class="connector__line"/>\n          <line x1="675" y1="0" x2="675" y2="115" class="connector__line"/>\n        </svg>\n        </div>\n        <div style="justify-content: flex-end; width: 100%;" class="diagram-slots">\n          <div class="diagram-box">\n            <p>A willingness to start</p>\n          </div>\n          <div style="margin: 0 8px;" class="diagram-box">\n            <p>A willingness to work at it</p>\n          </div>\n          <div class="diagram-box">\n            <p>A willingness to keep going no matter what</p>\n          </div>\n        </div>'
	    },
	    'exercise-4': {
	      'number': '3B-4 - Exercise 4',
	      'title': 'Euro Illusions',
	      'description': 'There are contradictions built into Europe\u2019s economic system. In a single-currency system, policymakers lack the most powerful tool for helping individual economies adjust to setbacks \u2013 i.e., <span class="js-ex4" ng-class="{\'highlight-word\': vm.highlightWords.ex4}">interest rates set according to national conditions.</span> To succeed, a single-currency system needs <span class="js-ex4" ng-class="{\'highlight-word\': vm.highlightWords.ex4}">either large fiscal transfers</span> (so fiscal policy can do what monetary policy can\u2019t) <span class="js-ex4" ng-class="{\'highlight-word\': vm.highlightWords.ex4}">or highly integrated labor</span> markets (so the unemployed can move to stronger\n      markets to find work), and preferably both. The <span class="js-ex4" ng-class="{\'highlight-word\': vm.highlightWords.ex4}">euro area has neither,</span> and its governments even after an epic sovereign debt crisis, have no plans to do much about it. This leaves the EU\u2019s weakest economies <span class="js-ex4" ng-class="{\'highlight-word\': vm.highlightWords.ex4}">with no choice but to restore their prospects through the brutality of \u201Cinternal devaluation\u201D</span> \u2013 using high unemployment to force down labor costs. ',
	      'reference': 'Euro Illusions<br/>by Clive Crook, Bloomberg Business Week, May 2, 2014',
	      'note': '<p><u>Note</u></p><p>Fiscal policy - Increase/decrease taxes and spending to influence the economy.<br/>\n      Monetary policy - Raise/lower interest rates to control the money supply.</p>',
	      'diagram': '\n        <p style="margin-left: -233px; margin-top: -100px;" class="diagram-question">How do you know?</p>\n        <div class="diagram-box">\n          <p>Weaker economies inevitably suffer an epic sovereign debt crisis in a single currency market</p>\n        </div>\n        <div class="connector">\n          <svg class="svg-long-deductive-arrow">\n            <line x1="5" y1="5" x2="377" y2="117" />\n            <path d="M 0 0 L 13 15 L 19 0 Z" />\n          </svg>\n        </div>\n        <div class="diagram-slots">\n          <div style="height: 150px" class="diagram-box">\n            <p>In a single currency system, policy makers lack the ability to set interest rates according to national condition</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div style="height: 150px" class="diagram-box">\n            <p>To succeed, the system needs either large fiscal transfers (to add to the money supply) or integrated labour markets (to provide work for the unemployed)</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div style="height: 150px" class="diagram-box">\n            <p>The Euro area has neither tool, nor do its governments plan to do much about it</p>\n          </div>\n          <svg class="svg-deductive-arrow">\n            <line x1="50" y1="25" x2="0" y2="25" />\n            <path d="M 50 25 L 35 18 L 39 25 L 35 32 Z" />\n          </svg>\n          <div style="height: 150px" class="diagram-box">\n            <p>Leaves EU\u2019s weakest economies with no choice but internal devaluation - using high unemployment to force down labour costs</p>\n          </div>\n        </div>'
	    },
	    'exercise-5': {
	      'number': '3B-4 - Exercise 5',
	      'title': 'Banking on the State:<br/>The Philosopher’s Stone of Finance',
	      'description': 'By 1694 William of Orange had been on the English throne for 5 years, and his credit with potential lenders remained abysmal. But the late seventeenth century in England was an age of vigorous innovation in the fields of money and public finance. One proposal put forward was a plan for a bank that would fundamentally reorganize the funding of the king\u2019s debts. Investors would subscribe capital to the bank, and the bank would lend money to the government. <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">This Bank of England would in effect be a public-private partnership.</span> The <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">Bank\u2019s primary role would undoubtedly be to put the Sovereign\u2019s credit and finances on a surer footing.</span> Indeed, its design, governance, and management were to be delegated to the mercantile classes precisely in order to ensure confidence in its operations and credit control. But in return the Sovereign was to grant important privileges. Above all, <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">the Bank was to enjoy the right to issue banknotes</span> \u2013 a license to put into circulation paper currency representing its own liabilities, which could circulate as money. There was to be, quite literally, a quid pro quo.\n      <br/><br/>If they and the private money interest they represented would agree to fund the king on terms over which they, as the Directors of the new Bank, would have a statutory say, then the king would in turn allow them a statutory share in his most ancient and jealously guarded prerogative: the creation of money and the management of its standard. To be granted the privilege of note issue by the crown, which would anoint the liabilities of a private bank with the authority of the Sovereign, was the Philosopher\u2019s Stone of money. It was the endorsement that could\n      liberate private bank money from its parochial bounds. They would lend their credit to the Sovereign \u2013 he would lend his authority to their bank. What they would sow by agreeing to lend, they would reap a hundredfold in being allowed to create private money with the Sovereign\u2019s endorsement. Henceforth, the seigniorage would be shared.\n      <br/><br/>There were benefits to both parties. <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">The quid pro quo nourished a virtuous circle.</span> The state\u2019s blessing afforded <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">general circulation to the Bank\u2019s notes.</span> The commercial ownership and management of the bank <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">improved the state\u2019s creditworthiness.</span> Adam Smith delivered his verdict in 1776. \u201CThe stability of the Bank of England is equal to that of the British government.\u201D Without the state, the Bank would have lacked authority; without the Bank, the state would have lacked credit.\n      <br/><br/>This compromise is the direct ancestor of the monetary systems that dominate the world today: <span class="js-ex5" ng-class="{\'highlight-word\': vm.highlightWords.ex5}">systems in which the creation and management of money are almost entirely delegated to private banks, but in which sovereign money remains the \u201Cfinal settlement asset\u201D;</span> the only credit balance with which the banks on the penultimate tier of the pyramid can be certain of settling payments to one another or to the state. Likewise, cash remains strictly a token of a credit held against the sovereign, but the overwhelming majority of the money in circulation consists of credit balances on accounts at private banks. The fusion of Sovereign and private money born of the political compromise struck in 1694 remains the bedrock of the modern monetary world.',
	      'reference': 'Money: The Unauthorised Biography<br/>by Felix Martin, Bodley Head 2013',
	      'note': '<p><u>Note</u></p><p>On this one, I give you the structure of each paragraph, show you how the parts form the entire deductive argument, restructure it to be inductive, and ask you to fill in only the Key Line points of the new structure.</p>',
	      'diagram': '\n        <p style="margin-left: -233px; margin-top: -190px;" class="diagram-question">How know?</p>\n        <div style="width: 270px" class="diagram-box">\n          <p>Creation of the Bank of England in 1694 was the result of a compromise between the King and his bankers that is still the basis of modern banking</p>\n        </div>\n        <div class="connector">\n          <svg class="svg-long-deductive-arrow">\n            <line x1="5" y1="5" x2="377" y2="117" />\n            <path d="M 0 0 L 13 15 L 19 0 Z" />\n          </svg>\n        </div>\n        <div class="diagram-slots" style="width: 930px; justify-content: center">\n            <div style="height: 115px;" class="diagram-box">\n               <p>Bank of England was created as a public/private partnership between the King and his bankers</p>\n            </div>\n            <svg class="svg-deductive-arrow">\n              <line x1="157" y1="25" x2="0" y2="25" />\n              <path d="M 157 25 L 142 18 L 146 25 L 142 32 Z" />\n            </svg>\n            <div style="height: 115px;" class="diagram-box">\n              <p>Brought great benefits to both parties</p>\n            </div>\n            <svg class="svg-deductive-arrow">\n              <line x1="157" y1="25" x2="0" y2="25" />\n              <path d="M 157 25 L 142 18 L 146 25 L 142 32 Z" />\n            </svg>\n            <div style="height: 115px;" class="diagram-box">\n              <p>Was picked up worldwide as a good idea</p>\n            </div>\n        </div>\n        <svg class="svg">\n            <line x1="115" y1="0" x2="80" y2="110" />\n            <line x1="115" y1="0" x2="250" y2="110" />\n            <line x1="470" y1="0" x2="390" y2="110" />\n            <line x1="470" y1="0" x2="560" y2="110" />\n            <line x1="840" y1="0" x2="690" y2="110" />\n            <line x1="840" y1="0" x2="860" y2="110" />\n        </svg>\n        <div class="diagram-slots six-slots" style="width: 930px;">\n          <div class="diagram-box">\n            <p>King got access to credit and a stable currency</p>\n          </div>\n          <div class="diagram-box">\n            <p>Bankers got right to issue banknotes</p>\n          </div>\n          <div class="diagram-box">\n            <p>Bank\u2019s notes circulated generally</p>\n          </div>\n          <div class="diagram-box">\n            <p>State got improved credit-worthiness</p>\n          </div>\n          <div class="diagram-box">\n            <p>Cash remains strictly a token of a credit held against the State</p>\n          </div>\n          <div class="diagram-box">\n            <p>Money in circulation consists of credit balances on accounts in private banks</p>\n          </div>\n        </div>'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 3B',
	    'final-description': 'You know the technique for shifting a deductive argument to inductive form',
	    'next-course-button': 'proceed to section 3C',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'avoidingDeductiveArguments': {
	    'course-title': 'Avoiding Deductive Arguments',
	    'course-name': 'Section 3C <span class="unit-title">Avoiding Deductive Arguments<span>',
	    'course-video': {
	      'title': 'Section 3 SUPPORTING THE POINTS<br/>1’13:09 – 1’15:53 3D AVOIDING DEDUCTIVE ARGUMENTS.<br/>End Section (no exercise)',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '3C Lecture'
	    },
	    'congratulation-message': 'Congratulations',
	    'finish-section': 'You have completed all of Section 3 of the Course',
	    'final-description': 'You understand how to support your points both inductively and deductively,<br/>preferably inductively',
	    'next-course-button': 'proceed to section 4',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram1-3a1': {
	        'diagram-number': 'Example',
	        'elements': {
	            'one': 'Physical laws dictate that an <span>organism’s</span> every action is the result of previous events',
	            'two': '<span>Human beings are organisms</span>, and consequently subject to those laws',
	            'three': 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control'
	        }
	    }
	};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram2-3a1': {
	        'diagram-number': '2.',
	        'elements': {
	            'one': 'Neither boxers nor epileptics can remember events immediately before a blow or a seizure',
	            'two': 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
	            'three': 'Suggests people need time to consolidate short-term memories before entering them into long-term storage'
	        },
	        'submit-title': 'submit'
	    }
	};

/***/ }),
/* 353 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3-3a1': {
	        'diagram-number': '3.',
	        'elements': {
	            'one': 'Deepwater fish contain trimethylamine N-oxide (TMAO), which maintains the osmotic pressure needed to keep water from diffusing into their cells',
	            'two': 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
	            'three': 'Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote'
	        }
	    }
	};

/***/ }),
/* 354 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-3a1': {
	        'diagram-number': '4.',
	        'elements': {
	            'one': 'The western window is the only window that looks directly out on the moor',
	            'two': 'Barrymore was staring out of the western window',
	            'three': 'Therefore Barrymore must have been looking for something or someone on the moor'
	        }
	    }
	};

/***/ }),
/* 355 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram5-3a1': {
	        'diagram-number': '5.',
	        'elements': {
	            'one': 'Many different areas of the brain must work together to perform music',
	            'two': 'Active participation in music may stimulate development of those areas',
	            'three': 'The implication for early education in the arts is clear'
	        }
	    }
	};

/***/ }),
/* 356 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram6-3a1': {
	        'diagram-number': '6.',
	        'elements': {
	            'one': 'Early childhood teaching focuses on developing the “left brain” skills of reading, writing and ‘rithmatic',
	            'two': 'But scientists have recorded striking changes in the left-hemispheres of children who have had only a single year of violin ',
	            'three': 'Music may be every bit as important educationally as reading or writing'
	        }
	    }
	};

/***/ }),
/* 357 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram7-3a1': {
	        'diagram-number': '7.',
	        'elements': {
	            'one': 'Market-creating innovations demand capital to grow, but they do create a lot of jobs',
	            'two': 'Efficiency innovations – achieved by cutting the cost of a product or service – usually cut jobs ',
	            'three': 'If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them'
	        }
	    }
	};

/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram8-3a1': {
	        'diagram-number': '8.',
	        'elements': {
	            'one': 'Almost every gene of the genome is present in every cell of the body, though only some are turned on',
	            'two': 'Each cell type thus contains a unique mix of proteins – a subpopulation of all the proteins available to the cell',
	            'three': 'The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)'
	        }
	    }
	};

/***/ }),
/* 359 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram9-3a1': {
	        'diagram-number': '9.',
	        'elements': {
	            'one': 'Uncertainty in government policy paralyzes, making businesses and consumers less sensitive to outside forces',
	            'two': 'The paralysis results in productive firms being slow to expand, and unproductive firms slow to contract',
	            'three': 'Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity'
	        }
	    }
	};

/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram10-3a1': {
	        'diagram-number': '10.',
	        'elements': {
	            'one': 'Plant microbiologists see evidence that plants sense and respond to environmental variables',
	            'two': 'Suspect they have a sophisticated, brain-like information processing and signalling system to sense and respond',
	            'three': 'But without an actual brain, think their intelligence may be organized In a network, like insect colonies',
	            'four': 'Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains'
	        }
	    }
	};

/***/ }),
/* 361 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram11-3a1': {
	        'diagram-number': '11.',
	        'elements': {
	            'one': 'Clouds that could produce rain contain micron-size droplets of water, kept aloft by updrafts',
	            'two': 'To escape the updrafts, droplets must coalesce into ice pellets',
	            'three': 'The droplets can’t coalesce without dust particles to serve as nuclei',
	            'four': 'To get rain, we mimic the dust particles with silver iodide'
	        }
	    }
	};

/***/ }),
/* 362 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram12-3a1': {
	        'diagram-number': '12.',
	        'elements': {
	            'one': 'Global oil and gas markets are part of a dense network of economic linkages and connections',
	            'two': 'These connections generate tensions, particularly around trade and currencies',
	            'three': 'China’s growth will bring about a new balance in the market, generating new tensions',
	            'four': 'Important not to recast normal petro rivalry into a contest of nation states'
	        }
	    }
	};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram1-3a2': {
	        'diagram-task': 'Fill in the rough summary and the simplified summary',
	        'fixed-answer1': 'We need to look beyond GDP measures for a real picture of the economy',
	        'fixed-answer2': 'GDP gives a false picture of the economy because it ignores the value created by digitization',
	        'pre-fill': 'GDP gives a false picture of the economy because',
	
	        'fixed-answer3': '<u>New technologies</u> have always driven out old ones, usually by entering the market economy and <u>boosting GDP</u>',
	        'fixed-answer4': 'But <u>digitization</u> is distinctive in that much of the value it creates for consumers <u>never becomes part of</u> the economy that <u>GDP</u> measures',
	        'fixed-answer5': 'Thus the gap between what’s actually happening in the economy and what the statistics measure is wider than ever',
	
	        'complete-title': 'Reveal',
	        'hide-title': 'Hide',
	        'next-title': 'Next'
	    }
	};

/***/ }),
/* 364 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram2-3a2': {
	        'diagram-task': 'Fill in the rough summary and the simplified summary',
	
	        'fixed-answer1': 'Don’t knock paying taxes',
	        'fixed-answer2': 'Not paying proper taxes dooms state support for future radical innovations',
	        'pre-fill': 'Not paying proper taxes',
	
	        'fixed-answer3': 'Most <u>radical innovations need</u> early-stage, <u>high-risk investment</u>',
	        'fixed-answer4': 'The <u>State has been the early investor</u> in most of the recent big winners',
	        'fixed-answer5': 'Big winners who don’t pay proper taxes threaten future State investment',
	        'fixed-answer6': '- iPhone<br>- Internet<br>- GPS<br>- Touchscreen<br>- Siri'
	    }
	};

/***/ }),
/* 365 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3-3a2': {
	        'diagram-task': 'Fill in the rough summary and the simplified summary',
	
	        'fixed-answer1': 'Once formed, habits are stubborn',
	        'fixed-answer2': 'We indulge in habits because our brains encourage us to do so',
	        'pre-fill': 'We indulge in habits',
	
	        'fixed-answer3': 'The <u>brain</u> automatically evaluates whether an action rewards or punishes us, <u>positively weighting actions that reward</u>',
	        'fixed-answer4': 'It monitors the positive rewards, <u>shifting</u> them <u>from deliberate to habitual</u> over time',
	        'fixed-answer5': 'The habits then become so ingrained that we perform them even when we do not want to'
	    }
	};

/***/ }),
/* 366 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-3a2': {
	        'diagram-task': 'Fill in the rough summary and the simplified summary',
	
	        'fixed-answer1': 'Let’s not overlook early training in music',
	        'fixed-answer2': 'More early focus on music training in childhood may aid learning in other areas',
	        'pre-fill': 'More early focus on music',
	
	        'fixed-answer3': '<u>Early</u> childhood teaching <u>focuses on</u> developing the <u>"left-brain" skills</u> - reading, writing, and ‘rithmatic ',
	        'fixed-answer4': 'But active participation in <u>music stimulates</u> development in <u>those very areas</u>',
	        'fixed-answer5': 'Early focus on music may be every bit as important educationally as reading or writing'
	    }
	};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram5-3a2': {
	        'diagram-task': 'Fill in the rough summary and the simplified summary',
	
	        'fixed-answer1': 'The importance of good monetary policy is often overlooked',
	        'fixed-answer2': 'A Kingdom achieves peace and order by properly varying the quantity of money in circulation to match the needs of the economy',
	        'pre-fill': 'A Kingdom achieves peace',
	
	        'fixed-answer3': '<u>Money’s value</u> is directly <u>proportional to the quantity in circulation</u> compared to the quantity of goods available',
	        'fixed-answer4': '<u>Role of a Sovereign</u>, therefore, <u>is to increase or decrease the quantity of money,</u> to meet the needs of the economy',
	        'fixed-answer5': 'Properly varying the quantity brings peace and order to the Kingdom',
	        'fixed-answer6': 'Can cause deflation',
	        'fixed-answer7': 'Can cause inflation',
	        'fixed-answer8': 'Redistributes wealth',
	        'fixed-answer9': 'Regulates economic activity'
	    }
	};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-1': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'Our success metrics determine what we can and cannot invest in',
	            '2': 'We have allowed a minority to dictate those metrics',
	            '3': 'We place a higher value investments based primarily on their return on net assets, internal rate of return, and earnings per share over other metrics',
	            '4': 'As a result, investing to create growth and jobs is a third-best option, behind efficiency innovations (first) and doing nothing (second)'
	        },
	        'elements': {
	            'one': 'The metrics we use to measure success lead us to invest more in finding efficiencies than in creating growth',
	            'two': 'We place a higher value investments based primarily on their return on net assets, internal rate of return, and earnings per share over other metrics',
	            'three': 'Leads us to invest in innovations that squeeze costs and noncash assets',
	            'four': 'As a result, investing to create growth and jobs is a third-best option, behind efficiency innovations (first) and doing nothing (second)'
	        }
	    }
	};

/***/ }),
/* 369 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-2': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'Predictive analysis is starting to be used widely in business',
	            '2': 'When things break down, they generally don’t do so all at once, but gradually over time',
	            '3': 'Specific patterns typically crop up before something breaks',
	            '4': 'Telltale signs are the whirring of a motor, excessive heat from an engine, and the like'
	        },
	        'elements': {
	            'one': 'Predictive analysis looks for patterns rather than causes in solving problems',
	            'two': 'When things break down, they do so gradually over time',
	            'three': 'Armed with sensor data, correlational analysis and similar methods we can identify the specific patterns that typically crop up before something breaks',
	            'four': 'From then on, need only look for that pattern to know when something is amiss'
	        }
	    }
	};

/***/ }),
/* 370 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-3': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'Information doesn’t wear out with use the way material goods do',
	            '2': 'Data’s full worth is much greater than the income extracted from its first use',
	            '3': 'Data’s true value needs to be considered in terms of all the possible ways it can be employed in the future.',
	            '4': 'Innovative companies that learn to exploit their data effectively can reap potentially huge benefits.'
	        },
	        'elements': {
	            'one': 'Companies need to value data in terms of all the possible ways it can be employed in the future',
	            'two': 'Data is a “nonrivalrous” good – it can be processed over and over again, and harnessed for multiple purposes',
	            'three': 'Data’s full worth is much greater than the income extracted from its first use',
	            'four': 'Companies that learn to exploit their data effectively can reap potentially huge benefits.'
	        }
	    }
	};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-4': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'But the vast wealth registered by modern capital markets came from technological feats that cannot be repeated',
	            '2': 'Thus, investors should risk  backing products that produce new industries and new profits',
	            '3': 'Portfolio managers see the returns of the 20th century and project those far into the future'
	        },
	        'elements': {
	            'one': 'Without innovation, faith in the stock market is a kind of cargo cult',
	            'two': 'Portfolio managers see the returns of the 20th century and project those far into the future',
	            'three': 'Are betting their fortunes on the success rates of yesterday’s companies',
	            'four': 'But the vast wealth registered by modern capital markets came from technological feats that cannot be repeated',
	            'five': 'Thus, investors should risk backing products that produce new industries and new profits'
	        }
	    }
	};

/***/ }),
/* 372 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-5': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'America is the only high-income country whose 25-34 year olds are no better educated than its 55-64 year ',
	            '2': 'Children from poor backgrounds are handicapped in completing college and moving upwards',
	            '3': 'The increase in graduation rates for the wealthiest US households was 75% higher than the increase for the poorest',
	            '4': 'Yet without a college degree, the chances of upward mobility are now quite limited',
	            '5': 'As a result, children of prosperous families are likely to grow well off, and children of poor families likely to remain poor'
	        },
	        'elements': {
	            'one': 'Children from poor backgrounds are handicapped in completing college and moving upward',
	            'two': 'The increase in graduation rates for the wealthiest US households was 75% higher than the increase for the poorest',
	            'three': 'Yet without a college degree, the chances of upward mobility are now quite limited',
	            'four': 'As a result, children of prosperous families are likely to stay well off and children of poor families likely to remain poor'
	        }
	    }
	};

/***/ }),
/* 373 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3a3-6': {
	        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
	        'diagram-description': {
	            '1': 'Policy uncertainty is bad for business',
	            '2': 'When overall uncertainty increases, GDP falls: companies invest less, trade less, and hire fewer people; consumer spend less',
	            '3': 'Uncertainty in government policy paralyzes, making business and consumers less sensitive to outside force',
	            '4': 'Thus resources don\`t get reallocated, shutting down the primary mechanism for increasing productivity',
	            '5': 'Because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract',
	            '6': 'So resources don’t get reallocated from the less productive to the more productive, shutting down the primary mechanism for increasing productivity'
	        },
	        'elements': {
	            'one': 'Policy uncertainty is bad for business',
	            'two': 'Uncertainty in government policy paralyzes, making business and consumers less sensitive to outside forces',
	            'three': 'Because of the paralyzing effects, productive firms are slow to expand and unproductive firms are slow to contract',
	            'four': 'Thus resources don\`t get reallocated, shutting down the primary mechanism for increasing productivity'
	        }
	    }
	};

/***/ }),
/* 374 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-1': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why?',
	            'checkbox-2': 'How can it?',
	            'checkbox-3': 'How do you know it can?'
	        },
	        'elements': {
	            'one': 'Bentham can cut operating costs close to $1 million a year',
	            'two': 'More strictly control stock levels',
	            'three': 'Streamline central functional activities',
	            'four': 'Close the Melbourne wholesale news agency',
	            'five': 'Restructure headquarters to focus on store efficiency'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 375 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-2': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why do they?',
	            'checkbox-2': 'How do they?',
	            'checkbox-3': 'How do you know they do?'
	        },
	        'elements': {
	            'one': 'Companies often use their information systems to satisfy accounting rather than operating needs',
	            'two': 'They utilize comparisons irrelevant to operating decisions',
	            'three': 'They force fixed standards on variable operating activity',
	            'four': 'They ignore organizational realities in grouping data'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 376 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-3': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why did they?',
	            'checkbox-2': 'How did they?',
	            'checkbox-3': 'How do you know they did?'
	        },
	        'elements': {
	            'one': 'The government, the accountants, and the markets together killed pensions',
	            'two': 'Government stopped companies from weaseling out of pension promises ',
	            'three': 'Accountants required companies to record the cost of such pension promises',
	            'four': 'Market downturn encouraged companies to end pensions if they could'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 377 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-4': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why was it more stable?',
	            'checkbox-2': 'How was it more stable?',
	            'checkbox-3': 'How do you know it was more stable?'
	        },
	        'elements': {
	            'one': 'France exhibited a stability that was denied the independent city-states of Italy',
	            'two': 'Less subject to the fickleness of voters',
	            'three': 'More able to expand geographically',
	            'four': 'More unified for action'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-5': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why did it collapse?',
	            'checkbox-2': 'How did it collapse?',
	            'checkbox-3': 'How do you know it collapsed?'
	        },
	        'elements': {
	            'one': 'When the Greco-Roman world collapsed, so did the tradition of classical sculpture',
	            'two': 'Many of the subjects were unacceptably nude',
	            'three': 'Many of the nudes were pagan gods and goddesses',
	            'four': 'Envisioning a nude Christian god was unthinkable'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-6': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why?',
	            'checkbox-2': 'How?',
	            'checkbox-3': 'How do you know?'
	        },
	        'elements': {
	            'one': 'Those who recognized Chaos in the early days agonized how to shape their thoughts and findings into publishable form',
	            'two': 'The work fell between disciplines – too abstract for physicists, too experimental for mathematicians',
	            'three': 'The insights behind fractals and unpredictability were very difficult to explain clearly',
	            'four': 'The resistance from those required to reorganize their picture of the world was ferocious'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b1-7': {
	        'checkboxes': {
	            'title': 'Question:	',
	            'checkbox-1': 'Why was it?',
	            'checkbox-2': 'How was it?',
	            'checkbox-3': 'How do you know it was?'
	        },
	        'elements': {
	            'one': 'The fall of Lehman was the most destabilizing financial event since the bank runs of the 1930s Depression',
	            'two': 'Corporate bond spreads widened twice as much as after the 1929 crash',
	            'three': 'The Fed had to quadruple its foreign exchange swaps',
	            'four': 'The credit-backed securities market virtually vanished overnight',
	            'five': 'Businesses quickly began downsizing staff and reining in investments'
	        },
	        'checkboxes-bottom': {
	            'title': 'General Plural Noun',
	            'checkbox-1': 'Reasons',
	            'checkbox-2': 'Steps',
	            'checkbox-3': 'Proofs'
	        }
	    }
	};

/***/ }),
/* 381 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b2-1': {
	        'diagram-task': 'Q: How do you know they<br>are overconfident?',
	        'diagram-hint': 'Proofs',
	        'fixed-answer': 'The fundamental characteristic of entrepreneurs is not risk-taking, but overconfidence',
	        'element_1_1': 'Overconfident about their ability to prevent bad outcomes',
	        'element_1_2': 'Overconfident about the prospects of their businesses',
	        'element_1_3': 'Overconfident about their life spans',
	        'diagram-description-1': 'About ability to prevent bad outcomes',
	        'diagram-description-2': 'About prospects for their businesses',
	        'diagram-description-3': 'About chance of success',
	        'diagram-description-4': 'About chance of failure',
	        'diagram-description-5': 'About likely length of life'
	    }
	};

/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b2-2': {
	        'diagram-task': 'Q: How is it encouraged?',
	        'diagram-hint': 'Steps',
	        'diagram-hint2': '(Ways it is encouraged)',
	        'fixed-answer': 'In the start-up world, endemic optimism is encouraged',
	        'element_2_1': 'Early positive feedback',
	        'element_2_2': 'Rise of accelerator boot camps',
	        'element_2_3': 'Acceptance of failure as normal',
	        'diagram-description-1': 'Early positive feedback',
	        'diagram-description-2': 'Rise of accelerator bootcamps',
	        'diagram-description-3': 'Finding and mentoring network services',
	        'diagram-description-4': 'Acceptance of failure as normal',
	        'diagram-description-5': '“Fail fast, fail often” mantra',
	        'diagram-description-6': 'FailCons that tell about hard times'
	    }
	};

/***/ }),
/* 383 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b2-3': {
	        'diagram-task': 'Q: Why?',
	        'diagram-hint': 'Reasons',
	        'fixed-answer': 'Paper is still superior to screens as a medium for reading and understanding',
	        'element_3_1': 'Easier to create a coherent mental map of the text',
	        'element_3_2': 'Easier to become emotionally absorbed',
	        'element_3_3': 'Easier to remember what you read',
	        'element_3_4': 'Easier to tell where you are in the book',
	        'element_3_5': 'Easier to read and understand',
	        'element_3_6': 'Easier to navigate',
	        'complete-title': 'Reveal',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit',
	        'next-title': 'Next',
	        'hide-title': 'Hide',
	        'answer_3_1': 'Easier to create a coherent mental map of the text',
	        'answer_3_2': 'Easier to tell where you are in the book',
	        'answer_3_3': 'Easier to become emotionally absorbed',
	        'answer_3_4': 'Easier to remember what you read',
	        'answer_3_5': 'Easier to read and understand',
	        'answer_3_6': 'Easier to navigate'
	    }
	};

/***/ }),
/* 384 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b2-4': {
	        'diagram-task': 'Q: How look?',
	        'diagram-hint': 'Steps',
	        'fixed-answer': 'We can make educated guesses about how to look for life on Mars',
	        'element_4_1': 'Look for proteins essential for survival on Mars',
	        'element_4_2': 'Target ubiquitous molecules',
	        'element_4_3': 'Search for patterns in the debris',
	        'diagram-description-1': 'Search for proteins essential for survival on Mars',
	        'diagram-description-2': 'Search for enzymes that would survive Mars’s frigid temperatures',
	        'diagram-description-3': 'Look for enzymes that would survive Mars’s ionizing radiation',
	        'diagram-description-4': 'Target molecules ubiquitous throughout the microbial world',
	        'diagram-description-5': 'Look for a universal component of all bacterial cell walls',
	        'diagram-description-6': 'Look for evidence of life in the debris of large molecules',
	        'diagram-description-7': 'Look for patterns in the debris'
	    }
	};

/***/ }),
/* 385 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b2-5': {
	        'diagram-task': 'Why?',
	        'diagram-hint': 'Reasons',
	        'fixed-answer': 'The Viking Experiments looking for life on Mars concluded it was barren',
	        'element_5_1': 'Did not find microbes in the soil',
	        'element_5_2': 'Did not find evidence of photosynthesis',
	        'element_5_3': 'Did not find organic compounds of any kind',
	        'diagram-description-1': 'Added food to the soil',
	        'diagram-description-2': 'Did not find microbes in the soil',
	        'diagram-description-3': 'Did not find evidence of photosynthesis',
	        'diagram-description-4': 'Added water to a soil sample, expecting carbon dioxide',
	        'diagram-description-5': 'Got oxygen instead (not likely)',
	        'diagram-description-6': 'Looked for organic compounds in the soil',
	        'diagram-description-7': 'Did not find organic compounds of any kind'
	    }
	};

/***/ }),
/* 386 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-1': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'Mature, settled and conservative, unable to react quickly or respond to sudden shocks',
	        'element_1_2': 'The rise and fall pattern of engineering technologies resembles the rise and fall of species in evolution',
	        'element_1_3': 'Big and sluggish, unable to change, ripe for extinction',
	        'element_1_4': 'Small, quick and agile during rapid growth and spectacular success',
	        'element_1_5': 'Old and declining as new, small and quick alternatives move in to occupy the niche',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-2': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'In the agricultural era, land was the source of wealth, so the landed aristocracy naturally controlled the direction of society',
	        'element_1_2': 'Capitalists supplanted aristocrats not because of a shift in ideology but because of a shift in technology',
	        'element_1_3': 'In the industrial era, the new technologies of steam and electricity shifted the source of wealth, bestowing strategic advantage on their capitalist owners',
	        'element_1_4': 'In any era, the key decision makers will be those with a strategic economic advantage that affords them wealth',
	        'element_1_5': 'Thus, capitalists supplanted aristocrats as the key decision makers in society',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 388 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-3': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'Runs in parallel with old systems until fully proved',
	        'element_1_2': 'Do it/Fix It approach increases the chances of success while reducing the cost of failure',
	        'element_1_3': 'Eliminates need for much analysis and planning',
	        'element_1_4': 'Requires few person-months to build and try',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-4': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'The ones that do hit it big drive innovation for society as a whole',
	        'element_1_2': 'They can’t tell in advance what companies will succeed',
	        'element_1_3': 'Our economy relies on the unrealistic expectations of our entrepreneurs',
	        'element_1_4': 'They fund lots of companies, in the hope that a few will hit it big',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 390 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-5': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'American economy retreated between 1973 and 1993',
	        'element_1_2': 'Lost advantages of conventional mass production and distribution',
	        'element_1_3': 'Lost high rates of capital investment',
	        'element_1_4': 'Lost sole access to vast efficient marketplace and cheap natural resources',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 391 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-6': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'Not everybody can be trusted to obey tacit ethical rules ',
	        'element_1_2': 'Organizational hierarchies supply the rules and sanctions',
	        'element_1_3': 'We should not celebrate the breakdown of organizational hierarchy and authority',
	        'element_1_4': 'They must be coerced by explicit rules and sanctions ',
	        'element_1_5': 'Communities depend on mutual trust, and will not arise spontaneously without it',
	        'element_1_6': 'Some asocial',
	        'element_1_7': 'Some free riders',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b3-7': {
	        'diagram-task': 'Complete the pyramid and identify whether the argument on the Key Line level is Inductive or Deductive',
	        'fixed-answer': 'Firestone’s most important commitment was his initial move to Akron',
	        'element_1_1': 'Cities north of the Alps, dependent on horses and oxen for motive power, could not exist without hay',
	        'element_1_2': 'The invention of hay moved the center of urban civilization from the Mediterranean basin to Northern and Western Europe',
	        'element_1_3': 'In this way, hay moved the greatness of Rome to North and West',
	        'element_1_4': 'The Roman Empire fed their horses year round on grass, so did not need to make hay',
	        'element_1_5': 'Abundant hay allowed these Northern populations to grow and flourish',
	        'hint-title': 'Hint',
	        'resubmit-title': 'Resubmit'
	    }
	};

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b4-1': {
	        'diagram-task': 'Inductive',
	        'diagram-peak': 'Policy uncertainty is bad for business',
	        'diagram-hint': 'Why?',
	        'diagram-answers': {
	            '1': 'Causes GDP to fall',
	            '2': 'Companies invest less, trade less, hire fewer people',
	            '3': 'Consumers spend less',
	            '4': 'Paralyzes both government and business responses',
	            '5': 'Business less sensitive to outside forces',
	            '6': 'Firms slow to expand or contract',
	            '7': 'Harms productivity'
	        }
	    }
	};

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b4-2': {
	        'diagram-task': 'Inductive',
	        'diagram-peak': 'The idea of mind taping to preserve personality is almost certainly wrong',
	        'diagram-hint': 'Why?',
	        'diagram-answers': {
	            '1': 'Brains are not like computers',
	            '2': 'Brains are uniquely configured',
	            '3': 'Don’t have a tape that could record the uniqueness',
	            '4': 'Difficult to construct a tape for a “mind taping” session',
	            '5': 'Can’t find hardware on which to read the recording',
	            '6': 'The mind tape would not be compatible with another brain’s hardware',
	            '7': 'Can’t insert the results into another brain'
	        }
	    }
	};

/***/ }),
/* 395 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b4-3': {
	        'diagram-task': 'Inductive',
	        'diagram-peak': 'You can teach an old dog new tricks if he is willing and you are patient',
	        'diagram-hint': 'How do<br>you know?',
	        'diagram-answers': {
	            '1': 'Requires that he believe that change is possible (courage)',
	            '2': 'Requires that he be willing to do the work (repetitive)',
	            '3': 'Requires that he keep at it no matter what (perseverence)',
	            '4': 'Post-adolescent brains are never quite so flexible as when we were children',
	            '5': 'Requires over coming normal obstacles to learning'
	        }
	    }
	};

/***/ }),
/* 396 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b4-4': {
	        'diagram-task': 'Inductive',
	        'diagram-peak': 'Weaker economies facing a down-turn are forced to use high unemployment to restore their prospects',
	        'diagram-hint': 'Why is that the only way?',
	        'diagram-answers': {
	            '1': 'Can’t use taxation and spending to boost the economy',
	            '2': 'Can’t avoid using high unemployment to force down labor costs',
	            '3': 'Can’t raise or lower interest rates to control the money supply'
	        }
	    }
	};

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3b4-5': {
	        'diagram-task': 'Inductive',
	        'diagram-peak': 'Creation of the Bank of England in 1694 was the result of a political compromise that became the basis of the financial systems of the world today',
	        'diagram-hint': 'How did it work?',
	        'diagram-answers': {
	            '1': 'Bankers got the right to issue bank notes',
	            '2': 'Provided reliable money as it was needed for commerce and war',
	            '3': 'Ensured commercial management of the money over time',
	            '4': 'Cash remains strictly a token of a credit held against the state',
	            '5': 'Picked up worldwide as a good idea',
	            '6': 'Created an adaptable model for interaction between states and bankers elsewhere'
	        }
	        //       'diagram-description': {
	        //           '1': 'Provided reliable money as it was needed for commerce and war',
	        //           '2': 'Bankers got the right to issue bank notes',
	        //           '3': 'Ensured commercial management of the money over time',
	        //           '4': 'Cash remains strictly a token of a credit held against the state',
	        //           '5': 'Created an adaptable model for interaction between states and bankers elsewhere',
	        //           '6': 'Picked up worldwide as a good idea',
	        //       },
	    }
	};

/***/ }),
/* 398 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'practice-in-seeing': {
	    'course-title': 'Introductions - Reading to Get the Rhythm',
	    'course-name': '4A - Lecture',
	    'course-video': {
	      'title': 'Section 4 BUILDING A PYRAMID<br/>1’15:53 – 1’24:36 4A STRUCTURE OF THE INTRODUCTION. EX 4 intro A <br/> developing the introduction + 4A reading to get the rhythm +4B-2 more<br/> practice in finding SCQ',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '4A Lecture'
	    },
	    'unit-section-title': '4A Exercises',
	    'exercise-intro': '\n    <p>You now know that an introduction is meant to remind the reader of what he already knows about the subject of your document, prompting the question to which you wish to give the answer. And you will present that information in story form:</p>\n    <br/>\n    <ul>\n        <li>Situation (with which he is familiar), within which a</li>\n        <li>Complication developed (with which he is also familiar), that then triggered the</li>\n        <li>Question, to which your document is the answer</li>\n    </ul>\n    <br/>\n    <br/>\n    <p>In beginning to write, your tendency will be to spend time on the wording of your story, which can be time consuming and frequently leads in the wrong direction. To speed the process, try first to get the basic pattern of your story clear in your mind. In general, stories follow three basic patterns, leading to three relatively standard questions:</p>\n    <br/>\n    <div class="desc-table">\n      <div>\n        <p class="desc-table__title">WHAT SHOULD WE DO?</p>\n        <br/>\n        <p>Want to do X</p>\n        <p>Have problem</p>\n        <p>What do?</p>\n      </div>\n      <div>\n        <p class="desc-table__title">HOW SHOULD WE DO IT?</p>\n        <br/>\n        <p>Want to achieve X</p>\n        <p>Requires Y action</p>\n        <p>How do?</p>\n      </div>\n      <div>\n        <p class="desc-table__title">SHOULD WE DO IT?</p>\n        <br/>\n        <p>Want to do X</p>\n        <p>Will cause problem</p>\n        <p>Should we do it?</p>\n      </div>\n    </div>\n    <br/>\n    <br/>\n    <p>Knowing the kind of question your story is meant to raise in the reader\u2019s mind makes it easier for you to structure the story itself.</p>\n    <br/>\n    <br/>\n    <p>The next set of exercises is meant to help you recognize and reflect the basic patterns of introductory stories. In each case, I have stated the SCQs for you as they appear in the text. Your job is to look behind the words to the essence of what is being said, and fill in the parts of the basic story pattern it reflects, substituting Xs and Ys, etc. for specific nouns.</p>\n    <br/>\n    <br/>\n    <p>Then press Basic Structure to see if your answer matches mine.</p>\n    ',
	    'menu-list': {
	      'exercise-1': 'Black Holes',
	      'exercise-2': 'Entrepreneurs',
	      'exercise-3': 'The Optimal Office',
	      'exercise-4': 'Alpha’s Ability to Control Costs',
	      'exercise-5': 'The Role of the Board'
	    },
	    'exercise-1': {
	      'number': '4A - Exercise 1',
	      'title': 'Black Holes',
	      'description': 'One day the sun will fail. The fuel powering its nuclear fusion will run out, the sky will grow cold and, if Earth survives at all, humankind will be plunged into perpetual winter.<br/>\n<br/>To stay alive, our descendants will need to make alternative arrangements. They will first exhaust the resources of Earth, then the solar system, and eventually all the stars in all the galaxies in the visible universe. With nothing left to burn they will surely cast their gaze on the only remaining store of energy: black holes. Might they be able to harvest this energy and save civilization?',
	      'reference': 'Can We Mine a Black Hole?<br/>\nby Adam Brown, Scientific American, February 2015.<br/><br/><br/><br/>'
	    },
	    'exercise-2': {
	      'number': '4A - Exercise 2',
	      'title': 'Entrepreneurs',
	      'description': 'Two common notions shape our views about entrepreneurs, and neither is quite right. One of them imagines that they craft careful business plans and execute them skillfully. In fact, most new businesses don\u2019t adhere to a script. They adapt and modify as they go along, learning from feedback and trying new things.<br/><br/>\nThe other sees entrepreneurs as slightly wacky, possessed by extraordinary self-belief and willing to take a bet with very long odds. They exhibit common cognitive biases that are often associated with bad decisions, but are useful when it comes to starting a new business. This view, currently in vogue, isn\u2019t right either.<br/><br/>\nThe truth is less surprising but no less impressive. Successful entrepreneurs display a blend of seemingly contradictory skills. They combine careful analytical thinking \u2013 what we associate with the left brain \u2013 and a willingness to push boundaries \u2013 what we call the right stuff.',
	      'reference': 'Phil Rosenzweig writing in Wired, \u201CIdeas Bank\u201D, January 2014'
	    },
	    'exercise-3': {
	      'number': '4A - Exercise 3',
	      'title': 'The Optimal Office',
	      'description': 'Though the \u201Copen plan\u201D modern office, with its sea of desks, might look like the offspring of a newsroom or a trading floor, it can trace its heritage to 1960s Germany. There, two brothers who worked in their father\u2019s office-furniture business kicked off the B\xFCrolandschaft, or \u201Coffice landscape\u201D movement, which sought to boost communication and efficiency and de-emphasize status.<br/><br/>\nAs the idea took hold in North America in the decades that followed, employers switched from traditional offices with one or two people per room to large, wall-less spaces. By the turn of the century, roughly two-thirds of U.S. workers spent their days in open-plan offices.<br/><br/>\nBut as the layout became commonplace, problems emerged. A 2002 longitudinal study of Canadian oil-and-gas company employees who moved from a traditional office to an open one found that on every aspect measured, from feelings about the work environment to co-worker relationships to self-reported performance, employees were significantly less satisfied in the open office.'
	    },
	    'exercise-4': {
	      'number': '4A - Exercise 4',
	      'title': 'Alpha’s Ability to Control Costs',
	      'description': 'Increased oil prices due to the recent developments in the Middle East have brought about the likelihood of reduced earnings for Alpha. In an effort to mitigate the earnings decline, Alpha has indicated that it plans to reduce operating cost (versus its original forecast) by $10 billion during the current fiscal year. Since raw material and variable operating costs are not very controllable over the short term, and will most likely increase on higher oil prices, the cost reductions will have to come from the fixed cost area.'
	    },
	    'exercise-5': {
	      'number': '4A - Exercise 5',
	      'title': 'The Role of the Board',
	      'description': 'The new organization installed in October places full authority and responsibility for running the day-to-day activities of the two divisions squarely on the shoulders of the managers of those divisions. This move frees the Board to deal entirely with the broad matters of policy and planning that are its exclusive responsibility. However, the Board has for so long oriented itself to dealing with short-term operating problems that it is not presently in a position to focus its attention effectively on long range strategy development. Consequently, it must consider the changes needed to permit itself to do so.\n      <br/><br/>Specifically, we believe it should:\n      <ul>\n        <li>Relinquish responsibility for day-to-day operating matters to the Executive Committee</li>\n        <li>Broaden the composition to include outside members</li>\n        <li>Establish policies and procedures to formalize internal operation</li>\n      </ul>'
	    },
	    'exercise-5-title': 'Monetary Policy',
	    'congratulation-message': 'WELL DONE',
	    'finish-section': 'You have completed Section 4A',
	    'final-description': 'You recognize the rhythm of a good introduction',
	    'next-course-button': 'proceed to 4B-1',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 399 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'finding-readers-question': {
	    'course-title': 'Finding The Reader’s Question',
	    'course-name': 'Section 4B-1 <span class="unit-title">Finding The Reader’s Question<span>',
	    'course-video': {
	      'title': 'Section 4 BUILDING A PYRAMID<br/>1’24:58 – 1’32.42  4B-1 HOW TO DEVELOP AN INTRODUCTION   :<br/>- 4B-1  Determining The Readers Questions',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '4B-1 Lecture'
	    },
	    'unit-section-title': '4B-1 Exercises',
	    'exercise-intro-1': '\n      <p>Here is a summary of the process you just learned:</p>\n      <br/>\n      <ol>\n              <li><b>Identify the subject of the document</b></li>\n              <li><b>State the Question you are answering in the reader\u2019s mind about the subject</b></li>\n              <li><b>Trace how the Question arose</b></li>\n      </ol>\n      <ul>\n              <li>Make a statement about the subject that you are certain the reader will agree with you is true</li>\n              <li>Imagine the reader says \u201CYes, I know that, so what?\u201D</li>\n              <li>That should lead you to the Complication</li>\n              <li>The statement of the Complication should trigger the Question</li>\n              <li>The Question should demand the Answer</li>\n      </ul>\n      <p>Let\u2019s go through the process together, so you can see how it works.  We\u2019ll use the information from the introduction on Product Management that you read earlier to illustrate the process.</p>',
	    'menu-list': {
	      'exercise-1': 'Payoff from Product Management',
	      'exercise-2': 'The Rationalization Program',
	      'exercise-3': 'Drilling for Methane'
	    },
	    'exercise-1': {
	      'number': '4B-1 - Example 1',
	      'title': 'Payoff from Product Management',
	      'description': 'Product managers have taken well-earned bows for the success of many outstanding companies. They have received \u2014 and they deserve \u2014 the credit for steering many well-known products to market-share leadership and high profitability in the face of today\u2019s intense, competitive scramble. In many large, complex multiproduct corporations, the product manager has provided the vigorous product-by-product leadership that the top executives of a smaller, more tightly knit company give to its one basic product line. </br></br>\n      It comes as no surprise, then, to find a recent survey disclosing that three out of four companies in its sample are using this organizational concept. What is surprising, however, is the current surge of dissatisfaction with the way product managers and the product manager concept are working out. Do these complaints \u2014 and their number is increasing \u2014 lead to the conclusion that the product management concept is no longer practical. </br></br>\n      Certainly not, for the many instances where it is still working well demonstrate that it is not only a practical concept, but in many ways an indispensable one. It is because of the soundness of the concept that it works in so many cases. Where it fails, the fault, almost invariably, lies in how management has gone about applying \u2014 or misapplying \u2014 a basically sound management tool. </br></br>',
	      'reference': 'B. Charles Ames, Harvard Business Review, November/December 1963',
	      'afterword': 'You are no doubt eager to try it yourself. Let’s start with some simple exercises, where we give you the pyramid and explain the circumstances within which the document was written, and you work out the introduction. Following are two exercises of this type. The subject of each document is underlined. An explanation of the suggested introductory structure follows  each exercise.'
	    },
	    'exercise-2': {
	      'title': '4B-1 - Exercise 2<br/>The Rationalization Program',
	      'description': '\n      Following  is the pyramid for a document written for a large New Zealand bank, operating nationwide through a chain of 173 branches.  The Bank had decided to implement a Rationalization Program in each branch (which in English meant that they were going to cut their costs).  The Bank had identified 822 specific activities, procedures, and roles that they suspected could be eliminated or automated across the network, aiming for a $72m cut in total costs.\n      <br/><br/>\n      This was of course an immense job, and realizing that the Bank could not handle the work themselves, they had very wisely hired a group of 6 consultants to do the work for them.  The consulting team had begun work on July 1 and was to finish a year later on June 30, when their visas expired.\n      <br/><br/>\n      Working in teams of 2 people for each branch, the consulting team originally planned to complete the work for 3-4 branches each week.  It is now November, and the team has rationalized only 30 branches, with 143 remaining (17% of the work required in 41% of the time allotted.)  Unfortunately, the team constituted the entire manpower resources available to implement the remainder of the  program, and could not be added to or replaced.\n      <br/><br/>\n      It was now clear to them that they could not cover all the branches in the time remaining.  However, they did think of a way to save face and still achieve 93% of the cost savings expected.  Their plan was to recommend that from now on they focus only on high-benefit or low cost proposals.  Accordingly, the consulting team leader has written a memo to the Bank\u2019s CEO suggesting this change in approach.  What should the introduction say?\n      <br/><br/>\n      '
	    },
	    'exercise-3': {
	      'title': '4B-1 - Exercise 3<br/>Drilling for Methane',
	      'description': 'Methane is used to extend gasoline.  Several years ago finding methane was a high priority (and no doubt at some point will become so again).  This particular company had found a supply of methane in a remote part of Arizona or Colorado, but it was very deep in the ground, buried in an aquifer.  Given the pumping technology of the time, the methane was simply too expensive to pump up.\n      <br/><br/>However, some engineers have approached the company and assured them that the pumping problem need not really deter them.  \u201CThe methane is so deep,\u201C they said, \u201Cthat all you need to do is punch a hole in the aquifer, the pressure will be so great it will whoosh the methane up, and you will make all the money in the world.\u201D\n<br/><br/>Some more thoughtful person in the company has written a memo to his boss to explain to him that the suggested plans for drilling for methane would not be commercially feasible for the company.'
	    },
	
	    'congratulation-message': 'GOOD WORK',
	    'finish-section': 'You have completed Section 4B-1',
	    'final-description': 'You are well on your way to knowing how to<br/>work out the S C Q for a pyramid of ideas',
	    'next-course-button': 'proceed to section 4B-2',
	    'dashboard-button': 'Main menu'
	  }
	
	};

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'spotting-scq': {
	    'course-title': 'More practice in seeing the SCQ Structure',
	    'course-name': 'Section 4B-2 <span class="unit-title">More practice in seeing the SCQ Structure<span>',
	    'course-video': {
	      'title': 'Section 4 BUILDING A PYRAMID<br/>1’24:58 – 1’32.42  4B-1 HOW TO DEVELOP AN INTRODUCTION   :<br/>- 4B-1  Determining The Readers Questions',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': '4B-2 Lecture'
	    },
	    'unit-section-title': '<span>4B-2</span> Give a quick insight into the question you wish to answer in the reader’s mind',
	    'unit-intro-title': '4B-2 Exercises',
	    'exercise-intro': '\n    As you have seen, the secret to producing clear documents is to organize your material to answer a question that already exists in the reader\u2019s mind \u2013 or would exist or should exist if he thought for a minute about what he already knows.  And then to write the introduction so that it reminds him of his question.  You have also seen that the patterns of introduction for business documents tend to focus on one of three types of question, as shown below.<br><br>\n    <div class="documents-standard">\n        <span>Basic Pattern</span>\n        <span>Illustration</span>\n    </div>\n    <div class="documents-show-row">\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">What should we do?</span>\n            <div class="documents-show-element__scq">\n                <span>S = Want to do X</span>\n                <span>C = Have problem</span>\n                <span>Q = What do?</span>\n            </div>\n        </div>\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">The Role of the Board</span>\n            <div class="documents-show-element__scq">\n                <span>S = Board now free to deal entirely with broad matters of policy and planning</span>\n                <span>C = Not set up to do so?</span>\n                <span>Q = What do?</span>\n            </div>\n        </div>\n    </div>\n    <div class="documents-show-row">\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">Should we/can we do it?</span>\n            <div class="documents-show-element__scq">\n                <span>A = Will face a problem</span>\n                <span>C = Know the solution</span>\n                <span>Q = Can they implement it?</span>\n            </div>\n        </div>\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">Black Holes</span>\n            <div class="documents-show-element__scq">\n                <span>S = When the sun fails, humans will turn to the energy of the visible universe, and exhaust it</span>\n                <span>C = Only remaining store of energy will be black holes</span>\n                <span>Q = Will they be able to access one?</span>\n            </div>\n        </div>\n    </div>\n    <div class="documents-show-row">\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">How should we do it?</span>\n            <div class="documents-show-element__scq">\n                <span>S = Did X to achieve Y</span>\n                <span>C = Doesn\u2019t work</span>\n                <span>Q = How fix?</span>\n            </div>\n        </div>\n        <div class="documents-show-element">\n            <span class="documents-show-element__title">The Optimal Office</span>\n            <div class="documents-show-element__scq">\n                <span>S = Open plan office sought to boost communication and efficiency</span>\n                <span>C = Employees disliked it one very aspect measured</span>\n                <span>Q = How fix?</span>\n            </div>\n        </div>\n    </div>\n    <br/>\n    Here is a shorter summary of the basic patterns, which I will ask you to identify in the exercises that follow.\n    <br/><br/>\n\n    <div class="complication-question">\n        <div class="complication-question__row">\n            <div class="complication-question__element">\n                <span class="complication-question__title">complication</span>\n            </div>\n            <div class="complication-question__element">\n                <span class="complication-question__title">question</span>\n            </div>\n        </div>\n        <div class="complication-question__row">\n            <div class="complication-question__element">\n                <span>A. A problem occurred/could occur</span>\n            </div>\n            <div class="complication-question__element">\n                <span>Can we solve it?</span>\n                <span>What action should we take to solve it?</span>\n            </div>\n        </div>\n        <div class="complication-question__row">\n            <div class="complication-question__element">\n                <span>B. An action is/could be required</span>\n                <span>An action taken has not worked</span>\n            </div>\n            <div class="complication-question__element">\n                <span>How should we do it?</span>\n                <span>How should we have done it?</span>\n            </div>\n        </div>\n        <div class="complication-question__row">\n            <div class="complication-question__element">\n                <span>C. An action has been suggested</span>\n                <span>A suggested action must meet certain criteria</span>\n                <span>A logical conclusion has been/could be drawn</span>\n            </div>\n            <div class="complication-question__element">\n                <span>Is it the right action?</span>\n                <span>Does it meet the criteria?</span>\n                <span>Is it the right conclusion?</span>\n            </div>\n        </div>\n        <div class="complication-question__row">\n            <div class="complication-question__element">\n                <span>D. Alternative actions are possible</span>\n            </div>\n            <div class="complication-question__element">\n                <span>Which action makes most sense?</span>\n            </div>\n        </div>\n    </div>\n    <br/><br/>\n    In each case, you will need to read an introductory paragraph plus my statement of the essence of what it says.  Then I show the simplest statement of its corresponding Situation-Complication and Question, and ask you to place them to their proper position in the introduction.\n    <br/><br/>\n    The exercises are meant to demonstrate how forcing yourself to see the bare bones of the introduction can:\n    <br/>\n    ',
	    'menu-list': {
	      'exercise-1': 'Whom Can You Trust?',
	      'exercise-2': 'What we had?',
	      'exercise-3': 'Entrepreneurs',
	      'exercise-4': 'Creativity as Theft',
	      'exercise-5': 'Is Your Budget Stuck on Last Year’s Numbers?',
	      'exercise-6': 'Going Slow to Go Fast',
	      'exercise-7': 'Marketing Myopia',
	      'exercise-8': 'Who Killed Pensions?',
	      'exercise-9': 'Epic Fails of the Start-up World',
	      'exercise-10': 'The TV Decline',
	      'exercise-11': 'Honour on the Campus',
	      'exercise-12': 'A Survey of IFA Attitudes',
	      'first-part': 'Give a quick insight into the question you wish to answer in the reader’s mind',
	      'second-part': 'Alert you to any problems in your SCQ structure',
	      'third-part': 'Help you avoid Why? questions',
	      'fourth-part': 'Final Practice'
	    },
	    'exercise-1': {
	      'number': '4B-2 - Exercise 1',
	      'title': 'Whom Can You Trust?',
	      'description': '\n      Imagine that you\u2019re negotiating a multiyear deal to provide outsourcing services to a large company.  The client tells you that her firm wants to sign on for a certain level of services, but she\u2019d like you to be willing to deliver more on the fly, trusting that you\u2019ll be able to work out terms for the additional resources as the need arises.  Should you agree?\n      Or imagine that a potential business partner wants to buy $12 million worth of services from you, but can spend only $10 million because of temporary budget constraints.  He dangles the prospect of long-term revenue opportunities in exchange for the discount, but says he can\u2019t commit to anything yet.  Should you give him the deal?\n      <br><br>\n      Situations such as these present dilemmas for any manager.  The answers aren\u2019t obvious.  If you choose to trust new clients, contractors, or collaborators, you make yourself vulnerable:  your outcomes, financial and otherwise, now depend on their fidelity.  But if you insist on verifying each claim and accounting for every detail before a deal is signed, you\u2019ll slow the process and increase costs, potentially putting yourself at a disadvantage.\n      Success in business unquestionably requires some willingness to cooperate with and have faith in others.  The question is, how much faith and in whom.\n      ',
	      'reference': 'David de Steno, Harvard Business Review, <br>March 2014'
	    },
	    'exercise-2': {
	      'number': '4B-2 - Exercise 9',
	      'title': 'Epic Fails of the Start-up World',
	      'description': '\n      We live in an age of the start-up.  It\u2019s never been easier to build a product and start a company.  And, thanks to the boom in angel investing and crowdfunding, it\u2019s never been easier for start-ups to raise money.  The analytics firm CB Insights logged more than seventeen hundred seed-investment deals in the U.S. tech industry in 2012, more than three times the number from three years earlier.\n      <br><br>\n      But there\u2019s a catch.  Starting a company may be easier, but making a success isn\u2019t.  Competition is fierce, profits are scarce, and venture capitalists aren\u2019t generous when it comes to later stages of financing.  The life of a new company is often brutish and short.\n      <br><br>\n      The fact that most new businesses fail is hardly a secret.  So why are so many people gambling on ventures that are likely to end badly?\n      ',
	      'reference': 'James Surowiecki writing on The Financial Page in The New Yorker, <br>May 19, 2014'
	    },
	    'unit-section-title-2': '<span>4B-2</span> Alert you to any problems in your SCQ structure',
	    'unit-section-title-3': '<span>4B-2</span>  Help you avoid Why? questions',
	    'unit-section-title-4': '<span>4B-2</span> Final Practice',
	    'exercise-3': {
	      'intro': '\n      Now that you see the general pattern, try yourself to pick out the S-C-Qs in the following introductions, and identify the underlying structures.<br><br>',
	      'intro-list': {
	        'left': '\n        <b>3. Who Killed Pensions?</b><br>\n        <b>4. What We Had?</b><br>\n        <b>5. Marketing Myopia</b><br>\n        <b>6. The TV Decline</b><br>\n        <b>7. Honor on the Campus</b><br>\n        ',
	        'right': '\n        <b>(including the answer in the question)</b><br>\n        <b>(questioning received opinion)</b><br>\n        <b>(implying parts of the introduction)</b><br>\n        <b>(implying parts of the introduction)</b><br>\n        <b>(asking an unexpected question)</b>\n        '
	      },
	      'number': '4B-2 - Exercise 8',
	      'title': 'Who killed Pensions?',
	      'subtitle': '(Including the answer in the question)',
	      'description': '\n      Who killed pensions? Can they be resurrected? <br>\n      A few decades ago, pensions were almost taken for granted by both public and private employees. They promised that people who worked a specified number of years for one employer would receive a certain amount each month, for life, after they retired. That amount was usually based on their income in the years before retirement. Today, pensions are almost dead in corporate America \u2014 at least for new employees. They live on in government jobs, sometimes protected by state constitutions. But Detroit\u2019s bankruptcy has put its benefits in doubt after a judge said federal law could override the state Constitution. And given that some states and municipalities appear to have promised more than they can conceivably afford, it seems likely that some of those promises will be broken and that courts will find ways to allow that.\n      '
	    },
	    'exercise-4': {
	      'number': '4B-2 - Exercise 2',
	      'title': 'What We Had?',
	      'subtitle': '(Questioning receiving opinion)',
	      'description': '\n      Carefully gathered data show that by the mid-1700s, the average income of American colonists measured in terms of purchasing power had already exceeded the average income earned in England. Better diets even made Americans healthier than their Old World counterparts. Revolutionary soldiers, for example, stood three to four inches taller than their British adversaries. Our optimistic, confident sense of ourselves developed in these privileged circumstances, and, as we have seen, American income, though volatile, kept growing rapidly.<br>\n      Abundant land on the frontier, natural resources, a thriving domestic trade, and agricultural exports supported in part by slave labor accounted for this unusual prosperity in our early years. But ingrained in most of us, I think, is the oversimplified idea that our exceptional growth since the Civil War has been almost entirely the consequence of the scientific, engineering and technological breakthroughs of the nineteenth century, coupled perhaps with our enterprising attitude and a largely unregulated market economy.<br>\n      America had in fact no particular edge over other industrial nations in these areas.\n      '
	    },
	    'exercise-5': {
	      'number': '4B-2 - Exercise 7',
	      'title': 'Marketing Myopia',
	      'subtitle': '(Implying parts of the introduction)',
	      'description': 'Every major industry was once a growth industry. But some that are now riding a wave of growth enthusiasm are very much in the shadow of decline. Others which are thought of as seasoned growth industries have actually stopped growing. In every case the reason growth is threatened, slowed, or stopped is not because the market is saturated. It is because there has been a failure of management.'
	    },
	    'exercise-6': {
	      'number': '4B-2 - Exercise 10',
	      'title': 'The TV Decline',
	      'subtitle': '(Implying parts of the introduction)',
	      'description': 'Something is happening to America. Television viewing is going down. Nielsen said viewing was off by 6.4 percent in the daytime and 3.1 percent at night. We\u2019re talking about millions of people now, and the big question is: Where have these people gone, and what are they doing if they aren\u2019t watching television?'
	    },
	    'exercise-7': {
	      'number': '4B-2 - Exercise 11',
	      'title': 'Honor on the Campus',
	      'subtitle': '(Asking an unexpected question)',
	      'description': 'The news from Cambridge, Massachusetts, is that 83 percent of all the undergraduates at MIT cheated at least once in their college careers.  More than two-thirds confessed to plagiarism, and half admitted stealing other people\u2019s ideas.  What puzzled me about the survey was not that 83 percent cheated \u2013 but 17 percent didn\u2019t.  I went to the campus to talk to the non-cheaters.'
	    },
	    'exercise-8': {
	      'number': '4B-2 - Exercise 5',
	      'title': 'Is Your Budget Stuck in Last Year’s Numbers?',
	      'subtitle': '(Failing to identify the problem, making the solution part of the introduction)',
	      'description': '\n      For many CFOs budget meetings are a long, exhausting process.  The presenters show you their plans, you probably challenge every number, explore every assumption. In the end you may raise their targets a little.  But the budget each unit will have to deliver next year \u2013 you have to admit \u2013 will not be not very different from the one proposed at the beginning, which in turn is not very different from the latest forecast for this year.\n      <br><br>\n      What happened? The short answer is, you\u2019ve been anchored.  Anchoring is a well-known psychological bias whereby one piece of information sticks in your mind and influences your interpretation of subsequent information, even if you\u2019re unaware of it.  Studies have shown that even obviously irrelevant numbers can influence estimates.\n      <br><br>\n      In one study, respondents were asked to estimate the age of Mahatma Gandhi at death. Before they had to answer, half of them were asked if Gandhi was younger or older than 5 when he died; the other half if he was younger or older than 140.  Both questions are ridiculous, and their answers obvious and irrelevant..  Yet the first group, on average, gave estimates of Gandhi\u2019s age at death that were 20 years younger than the second group. If we can be \u201Canchored\u201D by such obviously irrelevant inputs,  getting stuck in the same budget numbers from year to year is almost unavoidable.\n      <br><br>\n      Many management techniques attempt to overcome this challenge. Zero-based budgeting is one such technique, but it is a time-consuming approach that cannot be used systematically. Another is to ask the \u201CWhat would it take?\u201D question.  For example, \u201CWhat would it take to double that rate of growth or achieve the same results with half the resources?\u201D This is a useful technique to force a rethink of assumptions, if used sparingly. But if it becomes a routine that presenters expect, they will only harden their justifications (not to mention that repeatedly asking abstract, annoying questions will make you look disconnected from reality).\n      <br><br>\n      So what works? An anchor is such a powerful influence that only another anchor can overcome it. Re-anchoring combats the anchor of history and convention with another anchor, grounded in a different set of facts.\n      ',
	      'reference': 'Dan Lovallo and Olivier Sibony  <br> Harvard Business Review, March 2012'
	
	    },
	    'exercise-9': {
	      'number': '4B-2 - Exercise 4',
	      'title': 'Creativity as Theft',
	      'subtitle': '(Using anecdotal information to generate the question)',
	      'description': '\n      Once, while travelling in the Australian outback, I met an aboriginal man called Sammy who showed me how his tribe made a hafted knife by using a natural sap or pitch to glue sharp pieces of stone to a wooden handle.  I noticed that the way he attached these blades to the handle didn\u2019t seem likely to produce a strong bond, so through an interpreter I asked him why he didn\u2019t do it differently.  He stared at me for a moment and then replied that his tribe had always done it his way.\n      <br><br>\n      I don\u2019t suggest that I had a better alternative, or that I had spotted a flaw in a piece of cultural technology that Sammy\u2019s tribe might have used for millennia.  There was probably a good reason why his tribe produced the tool as they did.  My point is that Sammy didn\u2019t seem to know what that reason was (or he simply couldn\u2019t be bothered to tell this interloper a tribal secret).\n      <br><br>\n      There is no reason to think that Sammy is unusual or different.  You are surrounded by objects such as smartphones and microwaves that you don\u2019t know how to make, much less understand how they work.  It is even more stark than this.  In his 1958 essay \u201CI, Pencil,\u201D Leonard Read wrote:  \u201CNot a single person on the face of this Earth knows how to make me.\u201D  And it is true:  to make a pencil you\u2019ll need to know about mining, refining and shaping graphite, and the same for the wood, rubber and metal.  And even then you haven\u2019t made the pencil.\n      <br><br>\n      The sobering truth is that far from being highly creative and innovative, most of us are just glorified \u201Ckaraoke singers\u201D in most aspects of our lives, using things others have made.  So how then has our species acquired its technological innovations, progressing from simple hand axes to the iPads and smartphones of today?\n      ',
	      'reference': 'Creativity, like Evolution, is Merely a Series of Thefts<br>by Mark Pagel,  WIRED, 2014.'
	    },
	    'exercise-10': {
	      'number': '4B-2 - Exercise 6',
	      'title': 'Going Slow to Go Fast',
	      'subtitle': '(Making the solution part of the introduction)',
	      'description': '\n      Product life cycles continue to shrink in \u201Cfast\u201D industries like fashion and personal computers, where new products roll out the door every few months. Even \u201Cslow\u201D industries like steel have quickened their pace. Speed is of the essence \u2014 but so are quality and cost. Companies in all sectors know they must deliver on all three dimensions simultaneously.  Yet world-class product development is still by far the exception. Even the most disciplined and creative product development processes can be plagued by schedule slippages, \u201Cfirefighting,\u201D and inferior quality. Often, the problem is a failure to consider product development as a dynamic whole. <b>Managers try to improve performance by breaking the process apart.</b>\n      <br><br>\n      But isolated improvement efforts can have a negative effect on performance when they are implemented without regard to the <b>multiple relationships that drive the product development process.</b>  Setting aggressive commercialization schedules, for example, often has just the opposite effect of what was intended: namely, longer delays with lower quality. And many other cherished management beliefs, such as \u201Clean and mean\u201D staffing, can also inadvertently contribute to product development problems.  What\u2019s needed instead is an integrated, holistic approach that captures product development as a complex system.\n\n      ',
	      'reference': 'Creativity, like Evolution, is Merely a Series of Thefts<br>by Mark Pagel,  WIRED, 2014.'
	    },
	    'exercise-11': {
	      'number': '4B-2 - Exercise 3',
	      'title': 'Entrepreneurs',
	      'description': 'Two common notions shape our views about entrepreneurs, and neither is quite right.  One of them imagines that they craft careful business plans and execute them skillfully.  In fact, most new businesses don\u2019t adhere to a script.  They adapt and modify as they go along, learning from feedback and trying new things.\n        <br/>\n        The other sees entrepreneurs as slightly wacky, possessed by extraordinary self-belief and willing to take a bet with very long odds.  They exhibit common cognitive biases that are often associated with bad decisions, but are useful when it comes to starting a new business.  This view, currently in vogue, isn\u2019t right either.\n        <br>\n        The truth is less surprising but no less impressive.  Successful entrepreneurs display a blend of seemingly contradictory skills.  They combine careful analytical thinking \u2013 what we associate with the left brain \u2013 and a willingness to push boundaries \u2013 what we call \u201Cthe right stuff.\u201D'
	    },
	    'paper-header': '\n            <div>\n              <p>TO:</p>\n              <p>FROM:</p>\n            </div>\n            <div>\n              <p>DATE:</p>\n              <p>SUBJECT: A Survey of IFA Attitudes and Views</p>\n            </div>',
	    'exercise-12': {
	      'number': '4B-2 - Exercise 12',
	      'title': 'A Survey of IFA Attitudes and Views',
	      'description': '<p>Assume you have a client (AMP) who wants to buy a life and pensions provider called Thynne, as a means of entering the life and pensions market. Since Thynne is not well thought of in the market, and consequently not doing well, AMP has the opportunity to acquire the company at a low price, with the thought of turning it around. Turning it around would require getting it recommended by the body of Independent Financial Advisors, who currently ignore it. Your client has asked you to conduct research to find out:</p>\n      <ul class="bullet-list">\n        <li>How Independent Financial Advisors select life and pensions providers</li>\n        <li>Which companies they prefer</li>\n        <li>Their views on developments at Thynne and other mutuals</li>\n        <li>Their attitudes towards potential acquirers</li>\n      </ul>\n      <p>Here is the report you have written. You will see at once that the author has simply organized the results of  his research, without writing a proper introduction.</p>\n      <br/>\n      <p>Scrolling down, you will see the actual pyramid, with an abbreviated statement of the Situation, Complication, and Question.  We would like you to do two things:</p>\n      <ol class="not-bold-list">\n        <li>Write the basic simple structure for the Situation, Complication, and Question.</li>\n        <li>When you are finished, take a stab at writing the full introduction in prose.  Then compare it to the School Solution.</li>\n      </ol>',
	      'memo-title': 'Subject: Survey of IFA Attitudes and Views',
	      'memo-description': '<p>We conducted 33 interviews with 27 firms. Our findings are as follows:</p>\n      <ol>\n        <li>The channel is becoming more professional, with smaller IFAs joining networks and  employing quite rigorous selection methods. IFA criteria for selecting a provider are:<br/>\n          <div class="memo-wrapper">\n            <div class="memo-column">\n              <ul class="bullet-list">\n                <li>Financial strength</li>\n                <li>Investment performance</li>\n                <li>Charging structure</li>\n              </ul>\n            </div>\n          </div>\n        </li>\n        <li>IFAs see Thynne as an average performer, with inadequate capital:\n          <ul class="bullet-list">\n            <li>Investment performance is poor</li>\n            <li>Products lack innovation, range not appealing</li>\n            <li>Brand lacks clear message</li>\n            <li>Sales force desperate for business</li>\n            <li>Inconsistency in service</li>\n          </ul>\n        </li>\n        <li>Most IFAs have little or no knowledge of AMP, don\u2019t care who owns Thynne as long as they are financially strong.</li>\n        <li>AMP needs to adopt a strategy whereby it addresses the internal problems of Thynne, while looking to bolster its own and Thynne\u2019s standing with the community:\n          <ul class="bullet-list">\n            <li>Restore faith in Thynne\u2019s financial stability and investment performance\n              <ul class="bullet-list level2">\n                <li>Communicate clearly about the capital support being provided</li>\n                <li>Highlight the strong fund management</li>\n              </ul>\n            </li>\n            <li>Resolve Thynne\u2019s serious service and administrative problems</li>\n            <li>Address both Thynne\u2019s and AMP\u2019s image in the marketplace\n              <ul class="bullet-list level2">\n                <li>Underline AMP\u2019s size, strength, commitment to the UK market</li>\n                <li>Describe its intentions/aspirations for Thynne</li>\n              </ul>\n            </li>\n            <li>Successfully cultivate IFAs to restore Thynne to their panels\n              <ul class="bullet-list level2">\n                <li>Stress the commitment of both AMP and Thynne to the channel</li>\n              </ul>\n            </li>\n          </ul>\n        </li>\n      </ol>'
	    },
	    'congratulation-message': 'well done again',
	    'finish-section': 'You have completed Section 4B-2',
	    'final-description': 'You know how to see the structure beneath the wording of an introduction',
	    'next-course-button': 'proceed to section 4C-1',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 401 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	            value: true
	});
	exports.default = {
	            'applying-scq-process': {
	                        'course-title': 'Applying S C Q Process',
	                        'course-name': 'Section 4C - 1 <span class="unit-title">Applying S C Q Process<span>',
	                        'course-video': {
	                                    'title': '\n            Section 4 BUILDING A PYRAMID<br>\n            1\u201937:17 \u2013 1\u201938:06 4D APPLYING THE SCQ PROCESS (MASTER CLASS) :- <br>\n            ex 4D master class in applying SCQ - 1\u201938:26 \u2013 1\u201947:11 <br>\n             Applying SCQ practice exercises\n            ',
	                                    'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1'
	                        },
	                        'unit-title': '4C-1 Lecture',
	                        'exercise-intro': 'Before I turn you loose to apply the SCQ process to your own work, let me take you through a detailed example of the way I do the thinking when I am working out the structure of an introduction. You do not have to look at the video now, because it is very detailed, but if you find yourself later running into problems in applying SCQ, you may find it useful to watch it.',
	                        'exercise-1': {
	                                    'number': '4C-1 - Example',
	                                    'title': 'Field Sales Force Meeting',
	                                    'description': '\n            This is an explanation of the background to the following memorandum, meant to go to the field sales force of a soft drinks company called Frosted Cola. Let us suppose that you work for the Vice President of Sales of Frosted Cola. You have been working on the new Space Management Program, designed to make optimum use of shelf space in supermarket chains. The Program is meant to help Frosted Cola gain more space in chains where its share of space is below its share of market - SO called problem chains.<br><br>\n            You and the VP have designed a slide show explaining the new Space Management Program, which you have presented to the major chain headquarters groups. You now want to train the Field Sales Force District Managers to design and give the same kind of presentation to the problem chains in their 12 districts. You have announced that you will do this training at the August 25th Field Sales Meeting.<br><br>\n            <ul class="exercise-list">\n              <li>-\tYou will ask each of the 12 Field Sales people to select one problem chain in his district, and then send you market share and shelf space data on several of its stores</li>\n              <li>-\tYou will use the data to prepare a tailored version of the presentation for each district</li>\n              <li>-\tAt the Field Sales Meeting you will teach them to design and give similar presentations to other Chains in their areas</li>\n              <li>-\tThey will go back and present the meeting version to their selected chain</li>\n              <li>-\tThey will then work with the bottler body to select, research, and present their findings in similar presentations to other key local chains</li>\n            </ul>\n            <br>\n            It is now June and you need the chains identified by July 11, and the data on each returned by August 15, if you are to be able to put together a presentation tailored for each district. The VP has asked you to draft a memo to go to the Field Sales Force explaining the kind of chain to pick, the data needed, and how it should be organized. You have prepared the attached draft, and have asked for his comments on it.<br><br>\n            ',
	                                    demo: '\n            <p class="grey__paper-title--small">Subject: August Field Sales Meeting</p>\n\n\n            <p>In preparation for the Field Sales Meeting during the week of August 25, we are requesting each region to profile a problem\n              chain. The objective is to produce at the end of our meetings one presentation per region to seal the new Space Management\n              Program. Our objective is also to familiarize the entire Field Sales staff in techniques to sell a proven presentation\n              format utilizing the Shelf Space Study, Share of Market Study, and Nielsen data to local chain headquarters, with the consent\n              and mutual working relationship of the bottler body.</p>\n\n            <p class="grey__paper-title">DEFINING A PROBLEM CHAIN</p>\n\n            <p>On the initial thrust, we do not want to go after the A&Ps, Safeways, Albertsons, etc. of the world, but the locally important\n              chains. These are chains in a market where the headquarters are located and where they are important to the local bottlers\n              - i.e., chains like White Stores in Knoxville, Tennessee, with a share of all commodity dollar volume of 16.6% with 39\n              stores; Dahl\u2019s Food Markets out of Des Moines, Iowa, with 9 stores and 29.1% of the food store volume; and Rousauers -\n              Spokane, Washington, with 29 stores and 20.1% of the ACV.</p>\n\n            <p>While these are not national chains, they are very important to the markets they are in. In fact, they are the leading chains\n              in these markets. We do not know if there are problems in the above chains, but these have been used as an example of the\n              type of chain stores we are looking for when you select your problem chain. In addition, the following criteria should\n              also be followed in selecting a chain:</p>\n\n            <ul class="grey-paper__list">\n              <li>- A chain where our share of space is below our share of market</li>\n              <li>- A chain where the stores are not completely vertically stacked</li>\n              <li>- A chain where the bottler is aware of a problem and is willing to assist the field sales force in conducting the research required</li>\n            </ul>\n            <p>When you have selected your problem chain, please send me the name on the enclosed form no later than July 11.</p>\n\n            <p class="grey__paper-title">RESEARCH - DETAIL AND INSTRUCTIONS ARE ENCLOSED</p>\n\n            <ul class="grey-paper__list">\n              <li>- Work with the key bottler to conduct a Shelf Space study in 9 to 10 stores. If the chain has only a few stores (4 to 8), do all the stores</li>\n              <li>- Conduct a Share of Market study in 3 or 4 of these stores</li>\n              <li>- Compile A. C. Nielsen data on the major market or franchise, if available, including share of market in detail, plus distribution and out-of-stock</li>\n              <li>- Obtain the local bottler\u2019s yearly sales to this chain</li>\n            </ul>\n\n            <p>We will need the above data by August 15, summarized as explained in the enclosed instructions. As a result of our August\n              meeting, we will have assembled 12 presentations (one for each region) which will then be presented to the chain (with\n              the bottler\u2019s approval). In addition, the field sales force working with the bottler body can then start the process of\n              selecting, researching, and presenting their findings to other key local chains.</p>\n            '
	                        },
	                        'unit-section-title': '4C-1 Example',
	                        'patterns-1': {
	                                    'title': 'Common Patterns Of Introduction In Business Documents',
	                                    'thead-1': 'What should we do?',
	                                    'thead-2': 'How should/do/will we do it?',
	                                    'thead-3': 'Should we do it?',
	                                    'thead-4': 'Why did it happen?',
	                                    'tcell-1-1': '1. Resolve simple problem<br/>\nS = Face X situation<br/>\nC = Do not like what you have <br/>\nQ = What should we do?<br/>',
	                                    'tcell-1-2': '2. Choose among alternative solutions<br/>\nS = We want to do X<br/>\nC = We have three choices of how <br/>\nQ = Which is the best?<br/>\n ',
	                                    'tcell-2-1': '3. Directive<br/>\nS = We want to do X<br/>\nC = Need your help to do it <br/>\nQ = How do I help?<br/>\n ',
	                                    'tcell-2-2': '4. Tell how to do something new<br/>\nS = Must do X activity <br/>\nC = Not set up to do it<br/>\nQ = How do we get set up?<br/>\n ',
	                                    'tcell-2-3': '5. Tell how to do something properly<br/>\nS = We presently have system X <br/>\nC = It does not work properly<br/>\nQ = How make it work properly?<br/>\n ',
	                                    'tcell-2-4': '6. Recommend strategy <br/>\nS = Cannot do X as planned <br/>\nC = Must take Y action<br/>\nQ = How?<br/>',
	                                    'tcell-2-5': '7. Explain causes of an effect <br/>\nS = Experiencing small change in X <br/>\nC = Will cause big change in Y<br/>\nQ = How specifically will Y change?<br/>',
	                                    'tcell-3-1': '8. Prove the need for action<br/>\nS = Thinking about doing X<br/>\nC = Don\u2019t want to do unless Y is the case<br/>\nQ = Is Y the case?<br/>',
	                                    'tcell-3-2': '9. Question the wisdom of an action <br/>\nS = New proposal has been made C = Resembles the old proposal<br/>\nQ = Does it make sense?<br/>',
	                                    'tcell-3-3': '10. Seek approval to spend money<br/>\nS = We have a problem<br/>\nC = We have a solution, but it needs $ to implement<br/>\nQ = Should we approve the spending?<br/>',
	                                    'tcell-4-1': '11. Explain an occurrence (A)<br/>\nS = For years there was only X C = Then suddenly everywhere<br/>\nwe got Y<br/>\nQ = Why did that happen?<br/>',
	                                    'tcell-4-2': '12. Explain an occurrence (B)<br/>\nS = X% did A<br/>\nC = Y% did not do A <br/>\nQ = Why not?<br/>'
	                        },
	                        'patterns-2': {
	                                    'title': 'Common Patterns Of Introduction In Consulting Documents',
	                                    'thead-1': 'Should we do what is proposed?',
	                                    'thead-2': 'What should we do?',
	                                    'thead-3': 'How should/do we do something?',
	                                    'tcell-1-1': '1. Is it the right action?<br/>\nS = Have situation/problem<br/>\nC = Plan action<br/>\nQ = Is it the right action?<br/>\n ',
	                                    'tcell-1-2': '2. Will there be a problem?<br/>\nS = Had problem, have solution<br/>\nC = Afraid there may be problem implementing it<br/>\nQ = Will there be a problem?<br/>\n ',
	                                    'tcell-1-3': '3. Does solution work?<br/>\nS = Had problem, have solution<br/> C = Tested solution<br/>\nQ = Is it OK?\n ',
	                                    'tcell-1-4': '4. Will solution achieve objective?<br/>\nS = Planning action<br/>\nC = Don\u2019t want to do unless achieve Y<br/> Q = Will it achieve Y?\n ',
	                                    'tcell-1-5': '5. Letter of proposal (B)<br/>\nS = You have a problem<br/>\nC = You want consulting help to solve it<br/>\nQ = Are we the consultant you should hire?\n ',
	                                    'tcell-2-1': '1. How solve problem?<br/>\nS = Did/want to do X/have situation<br/>\nC = Didn\u2019t work/can\u2019t do/have problem<br/> Q = How proceed?\n ',
	                                    'tcell-2-2': '2. How get desired action?<br/>S = Have problem<br/>\nC = Want solution that does X<br/>\nQ = What do to get that solution?\n ',
	                                    'tcell-2-3': '3. Alternatives <br/>\nS = Want to do X<br/>\nC = Have alternative ways of doing it<br/> Q = Which is best?<br/>\n ',
	                                    'tcell-2-4': '4. Audit <br/>\nS = Now follow X process to achieve Y<br/>\nC = Did audit to see if any changes needed<br/> Q = Any changes needed?<br/>\n',
	                                    'tcell-2-5': '5. Progress Review No. 1<br/>\nS = LOP said we would do X to solve problem<br/> C = Have now done it<br/>\nQ = What did you find?\n',
	                                    'tcell-3-1': '1. How do needed action?<br/>\nS = Must do X to solve problem<br/> C = To do X must do Y<br/>\nQ = How do I do Y?\n',
	                                    'tcell-3-2': '2. How implement solution?<br/>\nS = You have a problem & you have a solution<br/>\nC = Not sure how to implement the solution<br/> Q = How implement the solution?\n',
	                                    'tcell-3-3': '3. How did you do that?<br/>\nS = We had a problem<br/>\nC = We solved it by doing X<br/> Q = How did you do X?\n',
	                                    'tcell-3-4': '4. How does it work?<br/>\nS = Have/had objective<br/>\nC = Installing system/process to accomplish<br/> Q = How does it work?\n',
	                                    'tcell-3-5': '5. Letter of Proposal (A)<br/>\nS = You have a problem<br/>\nC = You want consulting help to solve it<br/>\nQ = How will you help us solve our problem?\n'
	                        },
	                        'congratulation-message': 'GOOD GOING',
	                        'finish-section': 'You have completed Section 4C-1',
	                        'final-description': 'You know the basic patterns of most common introductions',
	                        'next-course-button': 'proceed to section 4C-2',
	                        'dashboard-button': 'Main menu'
	            }
	};

/***/ }),
/* 402 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'practice-in-seeing-3': {
	    'course-title': '4C-2 Lecture',
	    'course-name': '4C-Part 2 Lecture <span class="unit-title">Practice In Seeing 2<span>',
	    'unit-section-title': '4C-2 <br> Optional Exercises in Applying SCQ',
	    'video-title': '\n      Section 4 BUILDING A PYRAMID<br>\n      1\u201937:17 \u2013 1\u201938:06 4D APPLYING THE SCQ PROCESS (MASTER CLASS) :- <br>\n      ex 4D master class in applying SCQ - 1\u201938:26 \u2013 1\u201947:11 <br>\n      Applying SCQ practice exercises<br>\n    ',
	    'exercise-intro': '\n    <p>You should now be fairly proficient in working out your thinking via the introduction in relatively simple documents. But you might find it useful to have a bit more practice.</p>\n    <br/>\n    <p>Here are several common, everyday kinds of business memos. Each memorandum contains information from which the pyramid shown with it was developed. The introduction has been left blank, but I have supplied the basic S C Q pattern into which it falls. Can you type in roughly what the Situation and Complication should say in each example?</p>\n    <br/>',
	    'menu-list': {
	      'exercise-1': 'Purchasing at Orlando',
	      'exercise-2': 'Data Center Relocation',
	      'exercise-3': 'PAGAM Property Disposal',
	      'exercise-4': 'Domestic Bank’s Systems Strategy'
	    },
	    'exercise-1': {
	      'number': '4C-2 - Exercise 1',
	      'title': 'Purchasing at Orlando',
	      'description': 'Orlando is a large manufacturing company with several divisions. Presume you have been asked by the chief operating officer how to go about making sure that they do business only with qualified suppliers. Orlando has no centralized purchasing function, nor has it ever developed a formal supplier evaluation or qualification process consistently used throughout the organization. Each division makes its own decisions on who should supply its particular products and services, to the tune of $600 million every year. The amount covers a wide variety of materials from hundreds of different suppliers, selected by people at all levels in the company.\n<br/><br/>The chief operating officer believes that many suppliers have come to the point where they consider selling to Orlando to be their right, rather than a hard won privilege. He believes the company needs a formalized and integrated process of supplier evaluation, qualification, and development that will support the achievement of Orlando\u2019s procurement strategies.\n<br/><br/>You have developed the appropriate process, and are ready to write a memo from COO to go to the rest of the organization. You have worked out the pyramid shown below. Type in roughly what the Situation and Complication should say.'
	    },
	    'exercise-2': {
	      'number': '4C-2 - Exercise 2',
	      'title': 'Data Center Relocation - First Commerce Bank',
	      'description': 'First Commerce Bank, located in New York City, has a Data Center in Princeton, New Jersey. First Commerce is taking aggressive steps to grow, having set its sights on becoming a Global Bank. There is considerable cost involved in going after all this growth, and the Bank appears to have decided that one way to save a bit would be to close the Princeton Data Center and move the IT activities to its offices at 101 Park Avenue. The move fits in with a general desire to centralize activities, in the interest of efficiency. FCB hired a consulting firm (The St. Hobart\u2019s Group) to put together its relocation plan, which estimates that the cost to move would be no more than $33-45 million. The estimate is based on both FCB\u2019s requirements and similar Data Relocation scenarios.\n      <br/><br/>The Data Center team in NJ is, of course, appalled at this thinking, and believes the Bank is making a series of wrong assumptions. It has put together a list of these assumptions and the considerations the company is overlooking.\n      ',
	      'note': '',
	      'description-2': 'The team has decided to write to management and point out that their thinking may be based on three false assumptions, as shown on the following pyramid.'
	    },
	    'exercise-3': {
	      'number': '4C-2 - Exercise 3',
	      'title': 'PAGAM Property Disposal',
	      'description': '\n        <span>\n            <span class="memo-paper__header">\n                <p>TO:</p>\n                <p>DATE:</p>\n            </span>\n            <span class="memo-paper__header">\n                <p>FROM:</p>\n                <p>SUBJECT: Accounting treatment for PAGAM Property Disposal</p>\n            </span>\n        </span>\n        <br>\n        <p><b>Background</b></p>\n        <br>\n        <p>PAGAM manages 40 acres of property in Oklahoma. PAGAM is requesting approval to clean up environmental hazards\n          and raze buildings that are now defunct. The buildings were assumed by PAGAM due to a debtor (Langley Trust)\n          defaulting on a note of $2,655,000. The buildings were recorded at the fair market value of $2,655,000.</p>\n        <br>\n        <p><b>Issues</b></p>\n        <p>Whether to expense or capitalize the costs of environmental cleanup. Regarding the disposal of the property that\n          PAGAM owns, several issues need to be decided:</p>\n        <ol>\n          <li>Environmental preparation is legally mandatory due to the asbestos within the building.</li>\n          <li>We will most likely take a loss on the sale of the property. The building was recorded at fair market value,\n            but property values in Oklahoma have decreased over the years we have owned the property. No adjustments\n            have ever been made regarding revaluing the land (do not think it can be \u2014 see Journal of Accountancy). </li>\n          <li>Therefore, with regards to capitalizing vs. expensing the cost of environmental preparation of the land before\n            selling it, I believe the appropriate accountability would be to expense the costs.</li>\n        </ol>\n        <br>\n        <p><b>Premise: 90-8: Capitalization of Costs to Treat Environmental Contamination</b></p>\n        <br>\n        <p>\n          The costs that may be capitalized must meet the following criteria:\n          <ul class="bullet-list">\n            <li>The costs are incurred in preparing for sale that property currently held for sale</li>\n            <li>The costs are to improve the safety of property owned by the company</li>\n            <li>The costs mitigate of preventing environmental contamination</li>\n          </ul>\n          Per Example No. 8: Air in Office Building Contaminated with Asbestos Fibers. The building is environmentally hazardous with\n          regards to factory/office workers. Conclusion: Capitalization of cost to remove asbestos.\n        </p>\n        <br>\n        <p><b>Materiality</b></p>\n        <br>\n        <p>The cost of the preparation to sell the building is approximately $350,000. The cost is material to the total financial\n          position of the company (PAGAM). Therefore, capitalizing the preparation costs is advisable.</p>'
	    },
	    'exercise-4': {
	      'number': '4C-2 - Exercise 4',
	      'title': 'Domestic Bank’s Systems Strategy',
	      'description': '\n      This introduction to a discussion of an Australian domestic bank\u2019s Systems Strategy contains information from which the pyramid\n      shown below was developed.\n      <div class="memo-paper">\n      <div>\n        <span>\n            <span class="memo-paper__header">\n                <p>TO:</p>\n                <p>DATE:</p>\n            </span>\n            <span class="memo-paper__header">\n                <p>FROM:</p>\n                <p>SUBJECT: Domestic Bank\u2019s Systems Strategy</p>\n            </span>\n        </span>\n        <br>\n        <p><b>1.1\tOBJECTIVE</b></p>\n        <br>\n        <p>A key objective of the Domestic Bank\u2019s Systems Strategy is to build flexible and integrated systems supporting\n          customer service, cost reduction and the provision of timely and accurate management information. This will be\n          achieved through a properly managed and coordinated effort that:</p>\n        <p>\n          <ul class="bullet-list">\n            <li>builds on the Bank\u2019s existing investment in technology</li>\n            <li>uses best of breed products to obtain the best business benefits</li>\n            <li>balances flexibility and efficiency in relation to business objectives</li>\n          </ul>\n          <br>\n        </p>\n        <p>In establishing this strategy it is necessary to address the question:</p>\n        <p>\n        <br>\n          <ul>\n            Why is the use of best of breed products better than the complete rebuilding or replacement of all core  systems with a\n            single, technically integrated, comprehensive solution?\n          </ul>\n        </p>\n        <br>\n        <p><b>1.2 THIS PAPER </b></p>\n        <br>\n        <p>\n          This paper sets out the answer to this question, through:\n          <br>\n          <ul class="bullet-list">\n            <li>an explanation of each approach, single integrated solution and best of breed</li>\n            <li>the advantages and disadvantages of each approach</li>\n            <li>the reasons why best of breed is the correct strategy</li>\n            <li>the major implementation issues</li>\n          </ul>\n        </p>\n        </div>\n      </div>\n      ',
	      'description-2': '\n      <br/><br/>\n      <p><b>Three Ways Of Showing The Results Of Analyzing Alternatives, Assuming Alternatives A, B, C:</b></p>\n      <br>\n      <p><b>1. Structure around the criteria</b></p>\n      <br>\n      <img class="image__center" src="/assets/images/4c-2-1.png" alt="">\n      <br>\n      <p><b>2. Limit comparison to a single criterion</b></p>\n      <br>\n      <img class="image__center" src="/assets/images/4c-2-2.png" alt="">\n      <br>\n      <p><b>3. Structure around the alternatives themselves</b></p>\n      <br>\n      <img class="image__center" src="/assets/images/4c-2-3.png" alt="">\n      '
	    },
	    'congratulation-message': 'well done A THIRD TIME',
	    'finish-section': 'You have completed Section 4C-2',
	    'final-description': 'You know even better how to see the structure<br/> beneath the wording of an introduction',
	    'next-course-button': 'proceed to section 5A',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-1-1': {
	        's': 'S = When the sun fails, humans will turn to the energy of the visible universe.',
	        's-a': 'S = X will happen',
	        'c': 'C = When they exhaust that, the only remaining store of energy will be in black holes',
	        'c-a': 'C = Will require Y action',
	        'q': 'Q = Might they be able to harvest this energy and save civilization?',
	        'q-a': 'Q = Can they do it?',
	        'a': 'A = Yes, if they had a space elevator, but that defies the laws of physics',
	        'a-a': 'A= (Yes, if. . .)'
	    }
	};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-1-2': {
	        's': 'S = Believe entrepreneurs succeed either because they plan carefully or bet long odds',
	        's-a': 'S = Believe Xs succeed because of A or B',
	        'c': ' C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
	        'c-a': 'C = But Xs do neither A nor B',
	        'q': 'Q = How do they succeed?',
	        'q-a': 'Q = How do Xs succeed?',
	        'a': 'A = They blend two contradictory skills: careful analytical thinking and a willingness to push boundaries.',
	        'a-a': 'A = They blend contradictory skills'
	    }
	};

/***/ }),
/* 405 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-1-3': {
	        's': 'S = Open plan office sought to boost communication and efficiency, deemphasize status',
	        's-a': 'S = Did A to get B',
	        'c': 'C = Study showed that employees disliked it on every aspect measured',
	        'c-a': 'C = Caused Problem',
	        'q': 'Q = (How respond?)',
	        'q-a': 'Q= How fix?',
	        'a': 'A = Restored privacy'
	    }
	};

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-1-4': {
	        's': 'S = Hoped to offset unexpected earnings decline with additional $10b cut in operating costs.',
	        's-a': 'S = Planned X to deal with Y problem',
	        'c': 'C = But related short-term increases in operating costs also likely, meaning must instead look for savings in fixed costs (difficult to get at)',
	        'c-a': 'C = Won’t work, have to do Z instead (diffcult)',
	        'q': 'Q = (Can we realistically expect to cut $10b from our fixed costs?',
	        'q-a': 'Q = Can we?',
	        'a': 'A = Yes'
	    }
	};

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4-1-5': {
	        's': 'S =The Board is now free to do planning',
	        's-a': 'S = Ready to act',
	        'c': 'C = It is not set up to do planning',
	        'c-a': 'C = Not set up to act',
	        'q': 'Q = How do we get set up?',
	        'q-a': 'Q = What do?'
	    }
	};

/***/ }),
/* 408 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'define-a-problem': {
	        'course-title': 'How To Define A Problem',
	        'course-name': 'Section 5A <span class="unit-title">How To Define A Problem<span>',
	        'course-video': {
	            'title': 'Section 5 DEFINING THE PROBLEM<br/>1’47:35 – 1’58:08 5A OVERVIEW OF A PROCESS :<br/>- Ex 5A step by step process in action',
	            'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	            'lecture-title': '5A Lecture'
	        },
	        'unit-section-title': '5A Exercises',
	        'intro': '<p>As I just said, once you have defined the problem structure, it is dead easy to write your own introduction. You simply read from left to right and down, and the last thing you come to that is known by the reader, is always the Complication in your story.\n</p>\n<br/>\n<p class="diagram-title">THE PROBLEM DEFINITION FRAMEWORK</p>\n<br/><br/>\n<div class="desc-diagram-wrapper">\n    <div style="max-width: 340px;" class="desc-diagram-wrapper__content-block">\n        <p style="margin-left: 15px;">Opening Scene</p>\n        <div class="block">\n            Describe the arena within which the problem takes place\n        </div>\n    </div>\n    <div class="arrowAnim">\n      <div class="arrowSliding">\n        <div class="arrow"></div>\n      </div>\n      <div class="arrowSliding delay1">\n        <div class="arrow"></div>\n      </div>\n      <div class="arrowSliding delay2">\n        <div class="arrow"></div>\n      </div>\n      <div class="arrowSliding delay3">\n        <div class="arrow"></div>\n      </div>\n    </div>\n<!--    <svg style="z-index: 2; margin-top: 8px;" width="150" height="150">-->\n<!--       <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->\n<!--    </svg>-->\n    <div class="desc-diagram-wrapper__block">\n        <div style="display: flex; justify-content: center">\n            <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">\n                <p style="text-align: center">R1</p>\n                <div class="block">\n                    What will happen with the current trajectory?\n                </div>\n            </div>\n                <div class="arrowAnim">\n                  <div class="arrowSliding">\n                    <div class="arrow"></div>\n                  </div>\n                  <div class="arrowSliding delay1">\n                    <div class="arrow"></div>\n                  </div>\n                  <div class="arrowSliding delay2">\n                    <div class="arrow"></div>\n                  </div>\n                  <div class="arrowSliding delay3">\n                    <div class="arrow"></div>\n                  </div>\n                </div>\n<!--            <svg style="z-index: 2; width: 150px;margin: 8px -12px 0;">-->\n<!--               <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->\n<!--            </svg>-->\n            <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">\n                <p style="text-align: center">R2</p>\n                <div style="height: 80%" class="block">\n                    What do you want instead?\n                </div>\n            </div>\n        </div>\n        <svg>\n            <line x1="80" y1="0" x2="215" y2="100" />\n            <line x1="355" y1="0" x2="215" y2="100" />\n        </svg>\n        <div class="arrowAnim arrowAnim-third">\n          <div class="arrowSliding">\n            <div class="arrow"></div>\n          </div>\n          <div class="arrowSliding delay1">\n            <div class="arrow"></div>\n          </div>\n          <div class="arrowSliding delay2">\n            <div class="arrow"></div>\n          </div>\n          <div class="arrowSliding delay3">\n            <div class="arrow"></div>\n          </div>\n        </div>\n<!--        <svg style="z-index: 2;-->\n<!--            max-width: 150px;-->\n<!--            margin-top: 160px;-->\n<!--            margin-left: 95px;-->\n<!--            position: absolute;-->\n<!--            transform: rotate(142deg)">-->\n<!--           <path class="desc-diagram-wrapper__block__path" d="M 1 60 L 90 60 L 90 45 L 135 65 L 90 85 L 90 70 L 1 70 Z"></path>-->\n<!--        </svg>-->\n        <div style="max-width: 194px;" class="desc-diagram-wrapper__content-block">\n            <p style="text-align: center">SOLUTION</p>\n            <div class="block">\n                How will you get from R1 to R2?\n            </div>\n        </div>\n    </div>\n</div>\n<br/><br/>\n<br/><br/>\n<p>To help you get used to this new framework, let us take you step by step through the process for defining the problems for two different levels of complexity.</p>',
	        'menu-list': {
	            'exercise-1': 'Purchasing at Orlando',
	            'exercise-2': 'The Rationalization Program'
	        },
	        'exercise-description': 'Step-by-Step Process for Defining a Problem',
	        'exercise-1': {
	            'title': '5A - Example 1.<br/>Purchasing at Orlando',
	            'text-1': '<p style="margin: 25px 0">Let’s look at how you would use it to define the problem in the Orlando exercise you worked through in the previous section (4C-2).</p>',
	            'blue-paper': '<p>Orlando is a large company with several divisions. You have been told by your new vice president that he wants to make sure from now on the company does business only with qualified suppliers.</p>\n    <br/>\n    <p><strong>1. Orlando has no centralized purchasing function,</strong> nor has it ever developed a formal supplier evaluation or qualification process that consistently applies throughout the organization.  Each division makes its own decisions on who should supply its particular products and services, to a total of $600 million every year.  This $600 million covers a wide variety of materials, from hundreds of different suppliers, selected by people with widely differing backgrounds.</p>\n    <br/>\n    <p><strong>2. The vice president believes that many of its suppliers have come to the point where they consider selling to Orlando to be their right,</strong> rather than a hard won privilege. \u201CWe want to do business only with competent suppliers who are interested in keeping our business,\u201D he said. \u201COtherwise, we risk paying much more for things than necessary, while getting less than outstanding service.\u201D</p>\n    <br/>\n    <p><strong>3. He believes the company needs a standard process for evaluating, qualifying, and developing suppliers,</strong> so that he can be sure the company gets the highest quality products and services at the lowest reasonable price.</p>',
	            'text-2': '<p>You remember that you came up with this pyramid and basic introduction.</p><br/>\n        <div class="desc-scq-diagram">\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S =</p>\n                </div>\n                <div class="scq-block">\n                    <p>C =</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q =</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>Source products and services only from qualified suppliers</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="325" y2="100"/>\n                    <line x1="450" y1="0" x2="575" y2="100"/>\n                    <line x1="450" y1="0" x2="810" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>Identify the qualified suppliers available to you</p>\n                </div>\n                <div class="scq-block">\n                    <p>Determine a means of choosing between them</p>\n                </div>\n                <div class="scq-block">\n                    <p>Evaluate performance against clear criteria</p>\n                </div>\n                <div class="scq-block">\n                    <p>Periodically review need for new suppliers</p>\n                </div>\n                </div>\n            </div>\n        </div>\n        <br/><br/>\n    <p>But first you have to write an introduction that defines for the rest of the organization the problem that requires them to adopt this new process.</p>',
	            'text-3': '<p style="margin-top: 20px"><strong>Let me take you through the problem definition process.</strong></p>',
	            'text-4': '<p>Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write.</p>'
	        },
	        'intro-2': '<p>All it takes is a little practice for you to get used to this very useful technique. Let’s try another one, following the same process of pushing the buttons to fill in the form. You will recall the Data Center Relocation memo.</p>',
	
	        'exercise-2': {
	            'title': '5A - Example 2.<br/>The Rationalization Program',
	            'text-1': '<p>WHAT YOU KNOW</p><br/><p>You will recall that a New Zeland bank had hired a team of 6 consultants to find $72m worth of cost savings throughout their 173 branch network. It had identified 822 separate projects across the branch network to be completed in 12 months. The team began work in July, planning to end in June when their visas ran out.It is now late November, and they have completed only 30 branches \u2013 i.e., they have spent 41% of the time allotted to do 17% of the work required. There is no chance of adding additional manpower or extending the product time.</p>\n       <br/>\n       <p>As with the Orlando example, you want to begin by visualizing the Situation. What do we know about what is going on now with our work.</p>\n       <ul>\n         <li>- We know we need to complete 822 projects</li>\n         <li>- We know we have done only 30 branches out of 173</li>\n         <li>- We will never achieve the $72m savings by the end of the product</li>\n         <li>- We cannot extend the time, nor expand the team</li>\n         <li>- We think we might be able nonetheless to achieve a big percentage of the cost savings in the remaining time</li>\n       </ul>',
	            'text-2': 'In the final step shown in the Minto Framework should look like this:'
	        },
	        'congratulation-message': 'excellent',
	        'finish-section': 'You have completed Section 5A',
	        'final-description': 'You understand how the Problem Definition Framework<br/>presents a map for structuring an introduction',
	        'next-course-button': 'proceed to section 5B',
	        'dashboard-button': 'Main menu'
	    }
	};

/***/ }),
/* 409 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'practice-defining-problem': {
	        'course-title': 'Practice in Defining Problems',
	        'course-name': 'Section 5B <span class="unit-title">Practice in Defining Problems<span>',
	        'course-video': {
	            'title': 'Section 5 DEFINING THE PROBLEM<br/>1’58:28 – 2’05:31 5B VISUALIZING THE PROBLEM :<br/>-ex 5B laying out the parts of the problem',
	            'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	            'lecture-title': '5B Lecture'
	        },
	        'unit-section-title': '5B Exercises',
	        'intro': '<p>Key to defining any problem is sorting out the various causes from the various effects that cling together when you try to describe it. And in most business problem situations, there are multiple causes and multiple effects that need to be sorted out and arranged logically before you see it clearly. Filling in the <strong>Problem Definition Framework</strong> is the simplest approach to do it that I know, because it is set up to make the problem instantly clear and easy to explain.</p>\n    <br/>\n<p>Here are three simple exercises to give you practice in sorting out the parts of a problem. I will give you the facts for each and lay out the Opening Scene. I will also list all the other elements of the structure, to make it easy for you to place them where they belong in the framework. These exercises are meant to help you feel at ease with the new framework and vocabulary, and to demonstrate how easily they translate into an SCQ introduction.</p>\n<br/>\n<p>In the next section you will practice on more complex problems, identifying more of the problem definition elements, before transforming them into SCQ introductions.</p>\n<br/>',
	        'menu-list': {
	            'exercise-1': 'The Sales Force Effectiveness Paradox',
	            'exercise-2': 'Analysis of Technology Alternatives',
	            'exercise-3': 'Advantage Survey – Results and Action Plan'
	        },
	        'exercise-1': {
	            'number': '5B - Exercise 1',
	            'title': 'The Sales Force Effectiveness Paradox',
	            'text-1': '<p>Here is the opening paragraph of a long magazine article on making better use of sales force selling time in large manufacturing companies. It presents insights drawn from interviewing 25 CEOs of billion-dollar distributors who staff and manage large field sales forces. The introduction gives a good clear outline of the problem that the remainder of the article goes on to discuss more fully.</p>\n      <br/>\n      <p><strong>Please:</strong></p>\n      <ol>\n        <li>Read the article</li>\n        <li>Look at the Problem Definition Framework</li>\n        <li>Find the list of problem elements</li>\n        <li>Drag each element to its proper slot in the framework</li>\n        <li>See how they fit into the SCQ introduction to the pyramid for the full article</li>\n      </ol>',
	            'blue-paper': '<h5><span>The Sales Force Effectiveness Paradox</span><br/><span>Why Sales Forces Still Produce 80% of their<br/>value from 20% of their activities.</span></h5>\n    <br/>\n    <p class="cite">\u201CWe have put a huge amount of investment into technology and enablers for the sales force, yet the sales productivity number is the same now as it was\xA0ten years ago.\u201D</p>\n    <p class="reference">- CEO, $Bn Disributor</p>\n    <br/>\n    <p>In our recent interviews with 25 CEOs of billion dollar distributors, we\u2019ve heard a consistent theme: that sales force effectiveness is one of their highest priority issues, and that they are frustrated. Many have made substantial investments in a broad range of sales enablers such as sales force\xA0automation platforms, solution selling, challenger training, or in some cases large-scale ERP re-platforming programs.</p>\n    <br/>\n    <p>Yet an inconvenient truth remains... few companies have managed to ignite a profitable sales growth engine. Indeed, many CEOs tell us that their sales productivity metrics have remained largely unchanged for years. Furthermore, now more than ever, they see the need for real improvement to offset slow market growth and to out-sell their competitors, including new online players.</p>\n    <br/>\n    <p>In this paper, we talk about what\u2019s behind this frustration and what to do about it. We\u2019ll focus in our examples on the mass of mid-size customers that can make up 50\u201380%+ of a distributor\u2019s revenue, since it is in that part of the business that this challenge is most acute. However, many of\xA0the same principles apply to\xA0larger \u201Cnational accounts\u201D or \u201Cstrategic partnerships.\u201D</p>',
	            'text-2': '<span>Here is the structure of the document you will write. Now let\u2019s lay out the problem that will be the basis of your introduction.</span>\n      <br/><br/>\n      <div class="desc-scq-diagram">\n            <div class="desc-scq-diagram__title">\n                <p>The Sales Force Effectiveness Paradox</p>\n            </div>\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S =</p>\n                </div>\n                <div class="scq-block">\n                    <p>C =</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q =</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>Distributors need to re-shape their sales forces\u2019 day-to-day activities to match each customer\u2019s lifetime value</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="325" y2="100"/>\n                    <line x1="450" y1="0" x2="575" y2="100"/>\n                    <line x1="450" y1="0" x2="810" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>Identify what specific customers and markets you want your sales growth to come from</p>\n                </div>\n                <div class="scq-block">\n                    <p>Judge the structural potency of your proposition to th ose sources vs compe-titors\u2019 offerings</p>\n                </div>\n                <div class="scq-block">\n                    <p>Allocate sales capacity to match the lifetime value of the opportunity</p>\n                </div>\n                <div class="scq-block">\n                    <p>Provide bespoke \u201Cby the field for the field\u201D tools</p>\n                </div>\n                </div>\n            </div>\n        </div>\n        <br/><br/>'
	        },
	        'intro-2': '<h6 class="intro__title">Full wording of the introduction</h6>\n    <br/>\n    \n    <div class="intro__introduction">\n    <p>As every distributor knows, increasing sales force productivity is the key to market growth and profitability. Consequently, they invest substantial amounts in sales enablers promising to improve that productivity. Nevertheless, to quote one CEO of a $Bn distributor, \u201CThe Sales productivity number is the same now as it was 10 years ago.\u201D\n<br/><br/>\nBut given slow market growth and the advent of online sellers, increased productivity is more important than ever. This is particularly true with mid-size customers, who make up 50-80% of a distributor\u2019s revenue.\n<br/><br/>\nWe have been examining this problem, in interviews with 25 CEOs of billion dollar distributors. We have focused on trying to pinpont the reasons for low productivity, to identify what can be done to ignite a sales growth engine within the sales force. We believe the secret to increasing that productivity lies in determing each customer\u2019s lifetime value, and reshaping the sales force\u2019s day-to-day activities to match.</p>\n    </div>',
	        'exercise-2': {
	            'number': '5B - Exercise 2',
	            'title': 'Analysis of Technology Alternatives',
	            'text-1': '<p>Assume that you work for a Bank, and are responsible for running its current CIF and deposit systems. (CIF stands for the Bank\u2019s Customer Information File number, which enables it to view customers\u2019 accounts by their total bank relationship in addition to account type). You need to write a memorandum recommending that the Bank outsource the running of these two systems. However, you know that management has stated categorically that it does not want to outsource these systems.</p>',
	            'blue-paper': '<h5>Here is what you know</h5>\n        <div class="separator"></div>\n    <br/>\n    <p>At the moment the CIF and Deposit systems run on Unisys Clearpath mainframes, at a cost of $12 million/year. The hardware is becoming obsolete, and the systems have a life of only 3-4 more years. Management agrees that the Bank must change its approach to technology delivery or risk becoming competitively disadvantaged in the marketplace.</p>\n    <br/>\n    <p>The bank has three options: upgrade, migrate to a new system, or outsource.. Management has said it would rather not outsource, in the belief that an outside firm would not be able to maintain the high level of data protection service the Bank desires. You have been asked to look into the other two alternatives and recommend the Bank\u2019s strategy.</p>\n    <br/>\n    <p>Unfortunately, you have concluded that neither upgrading nor migrating makes much sense for them, but outsourcing does. Accordingly, you have decided to bite the bullet and recommend outsourcing for the following reasons:</p>\n    <ul class="bullet-list">\n      <li>Upgrading will not address the present system\u2019s deficiencies</li>\n      <li>Migrating to a turn-key system would be high cost, without solving all of the problems</li>\n      <li>Outsourcing provides a better product at a cost much lower than the present $12m</li>\n      <li>Two highly rated vendors are available to do the job</li>\n    </ul>',
	            'text-2': '<span>Here is the structure of the document you will write. Now let\u2019s lay out the problem that will be the basis of your introduction.</span>\n      <br/><br/><div class="desc-scq-diagram">\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S =</p>\n                </div>\n                <div class="scq-block">\n                    <p>C =</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q =</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>We should think seriously about negotiating to develop an outsourcing relationship</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="325" y2="100"/>\n                    <line x1="450" y1="0" x2="575" y2="100"/>\n                    <line x1="450" y1="0" x2="810" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>Upgrading will not address the present system\'s deficiencies</p>\n                </div>\n                <div class="scq-block">\n                    <p>Migrating to a new system would be high cost, without solving all of the problems</p>\n                </div>\n                <div class="scq-block">\n                    <p>Outsourcing provides a better product at a cost much lower than the present $12m</p>\n                </div>\n                <div class="scq-block">\n                    <p>Two highly rated vendors are available to do the job</p>\n                </div>\n                </div>\n            </div>\n        </div>',
	            'intro-2': '<h6 class="intro__title">Full wording of the introduction</h6>\n    <br/>\n    <div class="intro__introduction">\n        <p>We currently process our customer information on Unisys Clearpath Dorado HW purchased 2 years ago, but is now becoming obsolete. The engineers tell us they will cease supporting it in 3-4 years. We must decide our strategy for the future.</p>\n        <br/>\n        <p>We have essentially three options: we can upgrade to another Unisys system, migrate to a new system, or outsource the activity. Management has indicated that it does not wish to outsource. You have asked me to recommend the appropriate alternative.</p>\n        <br/>\n        <p>Despite the reluctance to outsource, I recommend that we think seriously about negotiating to develop a strong outsourcing relationship.</p>\n        <ul>\n            <li>Upgrading will not address the present systems deficiencies</li>\n            <li>Migrating to a new system would be high cost, without solving all of the problems</li>\n            <li>Outsourcing provides a better product at a cost much lower than the current $12m expense</li>\n        </ul>\n        <p>If you approve, we have located two highly rated vendors to consider for the job.</p>\n    </div>\n    <br/><br/>'
	        },
	        'exercise-3': {
	            'number': '5B - Exercise 3',
	            'title': 'Advantage Survey Results and Action Plan',
	            'text-1': '<p>S&G Wholesale Grocers is a large east coast US wholesale grocery packaging and distribution company. S&G owns a subsidiary supermarket chain called Winters, which has just been the subject of an annual survey of its performance by a company called Advantage International. Advantage has annually since 2007 surveyed the performance of grocers and distributors throughout the country, to rate them against each other. Its most recent survey questioned 47 manufacturers about Winters and its 6 major competitors.</p>\n                <br/><br/>\n                <p>Over the last 3 years, S&G had been the leading performer against the others, so it was not happy to learn that it ranked only #2 in overall performance against its competitors.</p>',
	            'text-2': '<br/><br/><p>Assume you have been charged with putting together a presentation to assure management that vigorous action is being taken to maintain S&G\'s #2 overall position, and work to approach #1. Here is the structure of the document you will write. Now let\u2019s lay out the problem that will be the basis of your introduction.</p>\n      <br/><br/>\n      <div class="desc-scq-diagram">\n            <div style="max-width: 340px" class="desc-scq-diagram__title">\n                <p>SUGGESTED STRUCTURE 2014 ADVANTAGE SURVEY RESULTS AND ACTION PLAN</p>\n            </div>\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S =</p>\n                </div>\n                <div class="scq-block">\n                    <p>C =</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q =</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>They will be focusing on how to make it easier for customers and mfrs. to do business with S&G at every level</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="325" y2="100"/>\n                    <line x1="450" y1="0" x2="575" y2="100"/>\n                    <line x1="450" y1="0" x2="810" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>Eliminating the specific areas of discontent in our Procurement, Merchandising, and Bill Paying processes</p>\n                </div>\n                <div class="scq-block">\n                    <p>Making clear to all users the process for decision-making and points of contact in each area</p>\n                </div>\n                <div class="scq-block">\n                    <p>Defining the Category Management work that C&S offers, and selling our successes to the stores</p>\n                </div>\n                <div class="scq-block">\n                    <p>Tying our merchandising programs directly to customer performance</p>\n                </div>\n                </div>\n                \n                <div class="scq-diagram-body scq-diagram-body__list">\n                    <ul>\n                        <li>Strategic Partnership Program</li>\n                        <li>Vendor program value proposition</li>\n                        <li>Improve our current communication practices</li>\n                        <li>National merchandising program</li>\n                    </ul>\n                    <ul>\n                        <li>Protocol for decision making within procurement</li>\n                        <li>Key Contact List for program manufacturers</li>\n                        <li>Engagement of non-procurement key contacts</li>\n                    </ul>\n                    <ul>\n                        <li>Clearly define and communic. the category mgt. work that C&S undertakes</li>\n                        <li>Sell our successes</li>\n                    </ul>\n                    <ul>\n                        <li>Drive volume through the merchandising vehicles</li>\n                        <li>Merchandising programs that are tied to customer performance</li>\n                        <li>Continue to develop the national merchandising programs</li>\n                    </ul>\n                </div>\n            </div>\n        </div>'
	        },
	        'intro-3': '<h6 class="intro__title">Full wording of the introduction</h6>\n    <br/>\n    <div class="intro__introduction">\n        <p>Have taken part in Advantage International\u2019s annual survey of the Grocery industry. Results for 2014 are now in, and find that \u2013 while we remain #2 in overall performance - we have fallen well behind in each of the other measures (see chart).</p>\n        <br/>\n        <p>Have identified the likely causes of the low ratings, and set up teams to determine the steps we need to take to regain our #2 position in all areas, and will work to approach #1.</p>\n        <br/>\n        <p>The teams will</p>\n        <ul>\n            <li>Improve working relationships with manufacturers</li>\n            <li>Ensure S&G points of contact are communicated to the vendor/broker community</li>\n            <li>Provide effective category management and marketing solutions to both customers and manufacturers</li>\n            <li>Tie our merchandising programs directly to customer performance</li>\n        </ul>\n    </div>\n    <br/><br/>',
	        'congratulation-message': 'CONGRATULATIONS',
	        'finish-section': 'You have completed Section 5B',
	        'final-description': 'You have first-hand experience in working out the<br/>parts of a problem within a structured framework',
	        'next-course-button': 'proceed to section 5C',
	        'dashboard-button': 'Main menu'
	    }
	};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'practice-defining-problem-2': {
	        'course-title': 'Defining More Complex Problems',
	        'course-name': 'Section 5C <span class="unit-title">Defining More Complex Problems<span>',
	        'course-video': {
	            'title': 'Section 5 Defining More Complex Problems<br/>1’58:28 – 2’05:31 5B VISUALIZING THE PROBLEM :<br/>- ex 5B laying out the parts of the problem',
	            'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	            'lecture-title': '5C Lecture'
	        },
	        'unit-section-title': '5C Exercises',
	        'intro': '<p>Here are three exercises involving more complex, real-world problems on which to practice your newly acquired skill in filling in the Problem Definition Framework. Again, in each case, I give you the facts relating to the problem and three of the five elements of the definition. I then ask you to identify the remaining elements by re-reading the facts supplied. To assist you, I have color-coded the relevant information, which you can find by hovering your mouse over the texts. Once, identified, your job is to place them properly in the framework, and then turn them into an SCQ introduction to match the related pyramid.</p>\n<br/>',
	        'menu-list': {
	            'exercise-1': 'Location-Based Learning Strategy',
	            'exercise-2': 'Group Health Care Plans',
	            'exercise-3': 'Houston SEI&M - ISG',
	            'exercise-4': 'Spirit Business Systems'
	        },
	        'exercise-1': {
	            'title': '5C - Exercise 1 <br/>Location-Based Learning Strategy',
	            'text-1': '<p>Turner Industries, Inc. is a large, diversified, very successful mass-market media corporation catering to children of all ages, and famous for its chain of Kids Place stores. It has lately had its eye on the Location-Based Learning industry, where the use of standardized tests in schools has led to a growing trend for parents to seek private-pay educational services. Currently their only location-based learning alternatives are:</p>\n                 <br/>\n                 <ul>\n                    <li>Remediation Learning Centers, which provide private-paid remediation/enrichment offerings</li>\n                    <li>Tutoring Centers, which provide self-directed educational instruction and homework help</li>\n                 </ul>\n                 <br/>\n                 <p>You have been asked to research Location-Based Learning market and determine whether a \u201CTurner Learning Studios\u201D could profitably enter the market.  Following are the notes from your research, and your recommended strategy.</p>\n      ',
	            'blue-paper-title': 'KEY FINDINGS IN LOCATION-BASED<br>LEARNING CENTER MARKET',
	            'blue-paper': '<p><b>Current offerings represent a $12million market</b></p>\n      <ul>\n        <li>Remediation Learning Centers, which provide private-pay remediation/enrichment offerings ($2 million)</li>\n        <li>Tutoring Centers, which provide self-directed educational instruction and homework help ($10 million)</li>\n      </ul>\n      <p>They address the traditional Turner customer: Ages 5-17, grades K-12.</p>\n      <ul>\n        <li>Remediation segment dominated by 4-5 national brands</li>\n        <li>Tutoring segment is highly fragmented, no dominant player</li>\n      </ul>\n      <p>Each market presents a challenge to entry.</p>\n      <ol>\n        <li>Remediation segment is only $2m, unattractive to operate in\n            <ul style="list-style-type: disc">\n                <li>Kids don\u2019t like it</li>\n                <li>Requires state/regional compliance</li>\n                <li>Is becoming franchise-based</li>\n                <li>Has limited scalability</li>\n            </ul>\n        </li>\n        <li>Tutoring segmentis $10b in size\n            <ul style="list-style-type: disc">\n                <li>But it is 90% fragmented, with no dominant player</li>\n                <li>Is very narrowly focused</li>\n            </ul>\n        </li>\n      </ol>\n      <p>There is a clear offering gap in the enrichment segment of the K-5 space, and in programs focusing on Arts and Sciences.</p>\n      <div style="display: flex;">\n        <p style="margin: 0 5px;">-</p>\n        <p>To take advantage of the gaps, Turner would have to differentiate its offering from other traditional Remediation Learning Centers, and find a way to celebrate learning and exploration.</p>\n      </div>',
	            'text-3': 'Please drag and drop the elements of the problem definition into their correct positions in the framework',
	            'proposed-strategy-title': 'LEARNING CENTER STUDIOS PROPOSED STRATEGY',
	            'proposed-strategy': '\n        <p>Turner location-based learning (\u201CTurner Learning Studios\u201D) will offer a new and innovative hybrid, fee-based model through the combination of tightly controlled <b>\u201Cbrick and mortar\u201D centers</b> and an <b>online enrichment curriculum.</b></p>\n        <ul>\n          <li>\n            Students can enroll in the Turner Learning Studios for a monthly fee, which includes unlimited visits to the center and access to the online enrichment curriculum\n          </li>\n          <li>\n            TLS will provide a unique experience for students to experience <b>hands-on enrichment</b> models in Arts and Science, directed by Center facilitators\n            <ul>\n              <li>Explore a store showcase, and launch 3-5 Turner Learning Studios in key metropolitan areas</li>\n              <li>Create an explorative atmosphere, similar to a science museum, whereby students can engage with various stations</li>\n            </ul>\n          </li>\n          <li>\n            TLS will offer continuation of the center-based experience through an extended <b>online enrichment</b> curriculum\n            <ul>\n              <li>The monthly fee will permit access to Turner learning curriculum online</li>\n              <li>Also to an independent  extension of the learning enrichment inside the centers</li>\n            </ul>\n          </li>\n          <li>\n            TLS should use the existing Kids Place stores as the locations\n            <ul>\n              <li>The stores are an ideal marketing platform</li>\n              <li>Flagship stores ideal for offering learning products\n                <ul>\n                    <li>Will convert a small portion into learning pods that enable sampling</li>\n                    <li>Will market directly to kids K-5 who are TLS customers</li>\n                </ul>\n              </li>\n            </ul>\n          </li>\n          <li>\n            TLS marketing presence will help strengthen overall Turner brand\n          </li>\n        </ul>',
	            'intro-1': '<h3 class="intro__title">Full wording of the introduction</h3>\n    <br/>\n    <br/>\n    <div class="intro__introduction">\n            <p>As part of our growth strategy, we have been looking closely at the Location-Based Learning market. Greater use of standardized tests has led a growing number of parents to seek private-pay educational services for their children. Generally of two types: Remediation Learning Centers ($2m) that provide private-pay remediation/enrichment offerings, and Tutoring Centers ($10m) that provide self-directed educational instruction and homework help. Addresses same market Turner does: ages 5-17, grades K- 5.</p><br/>\n            <p>Neither segment individually is very attractive, but together they do offer a $12m market that addresses the same market Turner does (ages 5-17, grades K-5). And neither has a dominant player. Research indicates, further, that there is a clear gap in the offerings of both segments that Turner might fill, if it made commercial sense to do so.</p><br/>\n    <p>Further analysis indicates that it could make commercial sense. Turner would have to differentiate its offering from those of the traditional Remediation Learning Center, and extend it to the Turner learning curriculum online.</p>\n    </div>'
	        },
	        'exercise-2': {
	            'title': '5C - Exercise 2<br/>Cascade Group Health Care Plans',
	            'text-1': '<p>Assume you are a partner in Eastwood Consulting firm, and have just finished discussing a possible consulting engagement with a new client, Cascade Group Health Care Plans. You have jotted the following notes to yourself, and need to put together a formal proposal to them. But first you need to define their problem more succinctly, so that you can determine your approach to it.</p>',
	            'text-2': '<strong>Here is the structure of the document you will write. Now let\u2019s lay out the problem that will be the basis of your introduction.</strong>\n      <br/><br/>\n      <p class="structure"><img src="/assets/images/structure-5b-3.png" alt="Original structure"></p>',
	            'blue-block': '<h3>NOTE ON NEW ENGAGEMENT</h3>\n<br/>\n<p><u>The Client</u></p>\n<br/>\n<p>\nThis engagement will be conducted on behalf of Cascade Group Health Care Plans, covering the health care plans of five states:\n<ul style="list-style: none; padding-left: 20px">\n    <li>Health Care of Arizona</li>\n    <li>Health Care of California</li>\n    <li>Health Care of Iowa and South Dakota</li>\n    <li>Health Care of Massachusetts</li>\n</ul>\nThe Cascade Group hopes that Eastwood can design a core information system based on the Groups\u2019 common business needs, and also identify opportunities for collaboration and migration options.\n</p>\n<br/>\n<p><u>The Objectives</u></p>\n<br/>\n<p>\nThe stated objectives of this initiative are\n<ul style="padding-left: 20px">\n    <li>To help the participating Plans develop a shared vision for future core systems\n\tthat meets common future business requirements</li>\n    <li>To assess options for transformation of the current systems environment</li>\n    <li>To identify opportunities to collaborate on various initiatives that help achieve the vision</li>\n</ul>\n</p>\n\n<p>\nWithin these overall objectives, Eastwood has said we would address a series of \u201Cspecific issues\u201D:\n<ul style="padding-left: 20px">\n    <li>Identify commonalities among the Plans in terms of business direction,\n\tcustomer needs, products and services</li>\n    <li>Identify common business processes that require IT support</li>\n    <li>Identify common IT functionality requirements</li>\n    <li>Describe the applications required to provide this functionality</li>\n    <li>Perform a gap analysis</li>\n    <li>Identify what can be supported by current systems</li>\n    <li>Identify what must be acquired or built</li>\n    <li>Describe and assess options that close the gap</li>\n</ul>\n</p>\n<p><u>Going-in Facts</u></p>\n<ol style="padding-left: 0px">\n    <li><b>Business Direction.</b> Each Plan\u2019s market characteristics and strategies differ, but\n\t  share common elements.</li>\n    <li><b>Market characteristics.</b> The healthcare market is rapidly changing. The role played by the Cascade Group is moving beyond the traditional insurer role to that\n\t  of managing medical costs, delivering care by owning provider organisations,\n\t  and developing, packaging, marketing, and selling \u201Chealthcare products.\u201D</li>\n    <li><b>Information technology challenges.</b> Plans complain about system\n\t  inflexibility, lack of easy access to useful information across the extended\n\t  business environment, high level of complexity of current legacy-based systems\n\t  and proprietary languages, and the high cost of operating in the current IT\n\t  environment. They need a fundamentally new architecture that is flexible, open,\n\t  user-friendly, modular, and accessible to users across the extended enterprise.</li>\n    <li><b>Architecture migration.</b> Need to migrate from the monolithic, legacy systems\n\t  and architectures to flexible, open, modular systems and a communication\n\t  environment that supports an extended, virtual enterprise.</li>\n</ol>',
	            'intro-2': '<h3 class="intro__title">Full wording of the introduction</h3>\n    <br/>\n    <div class="intro__introduction">\n    <p>Cascade Group\u2019s offices across the country are equipped with IT systems chosen and installed individually by each office. Over the last 10-15 years each office has complained that the systems are inflexible in structure and complex to operate. They are also very high cost compared to more modern vintages, and provide little relevant market information.</p>\n<br/>\n<p>This problem has become serious, given continuing changes in the health care market and the Plans\u2019 needs to respond to the differing demands of their local state customers. Research into the cost of replacing all four of the systems indicates the cost would be unacceptably high.</p>\n<br/>\n<p>However, the plans do have many commonalities in terms of processes and functionalities, even though individual needs differ widely in other ways. The most economical approach would be for Cascade to develop a single core system for the Group and adapt it to meet the local needs of each market. Cascade has asked Eastwood to determine whether a single system is possible, and if so what it should look like and how it could be implemented.</p>\n<br/>\n<p>(Can Eastwood develop a single system to be used economically all four Cascade offices?)</p>\n</div>'
	        },
	        'exercise-3': {
	            'title': '5C - Exercise 3<br/>Houston’s Information Systems Group',
	            'text-1': '\n      <div class="desc-scq-diagram">\n            <div class="desc-scq-diagram__title">\n                <p>HOUSTON SEI&M - ISG</p>\n            </div>\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S = Planning to enter external market</p>\n                </div>\n                <div class="scq-block">\n                    <p>C = Tough to be successful without strategy</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q = What should strategy be?</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>ISG\u2019s strategy should be to move in slowly, and expand as its strengths grow</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="325" y2="100"/>\n                    <line x1="450" y1="0" x2="575" y2="100"/>\n                    <line x1="450" y1="0" x2="810" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>Start as niche provider of systems, management & maintenance in non-DOD markets</p>\n                </div>\n                <div class="scq-block">\n                    <p>Enter via an enabling acquisition </p>\n                </div>\n                <div class="scq-block">\n                    <p>Develop a strong market-oriented organization</p>\n                </div>\n                <div class="scq-block">\n                    <p>Migrate from niche provider to broader market coverage</p>\n                </div>\n                </div>\n            </div>\n        </div>\n        <br/>\n        <p>But first you have to structure the introduction to the strategy plan the consultants will send to ISG. Here is the information you have available to you.</p>\n        <br/>\n        <p style="font-size: 25px"><b>WHAT YOU KNOW</b></p>\n        <br/>\n        <div style="border: 2px solid #000000">\n            <ol>\n                <li style="margin-bottom: 15px;">The external SEI&M market is $3.5-5 billion, growing 10-15% a year.  Two segments:  federal and commercial\n                    <ul style="list-style-type: disc">\n                        <li>Federal is 70% Department of Defense</li>\n                        <li>Commercial is full of small contractors</li>\n                    </ul>\n                </li>\n                <li style="margin-bottom: 15px;">It is a very tough market\n                    <ul style="list-style-type: disc">\n                        <li>Highly competitive</li>\n                        <li>Providers tend to build on their strengths, often compete in more than one area</li>\n                        <li>Key success factors differ for each segment, many niches within segments</li>\n                    </ul>\n                </li>\n                <li>ISG wants a workable strategy that will enable it to be successful</li>\n            </ol>\n        </div>\n',
	            'blue-paper-title': 'HOUSTON SEI&M - ISG',
	            'blue-paper': '<p>SG is the internal Information Systems Group of Houston SEI&M, a large corporation operating in the Systems Engineering, Integration, and Management market.  It provides Houston with professional services and integrated office automation systems covering:</p>\n      <ul>\n        <li>Needs analysis</li>\n        <li>Systems design and development</li>\n        <li>Installation and integration</li>\n        <li>Systems management and maintenance</li>\n      </ul>\n      <p>In addition to the team\u2019s technical expertise in these areas, it has good project management skills.</p>\n      <br/>\n      <p>Houston\u2019s need for these services is slowing, and the team is in danger of being broken up.  Accordingly, it is looking to offer its highly honed services externally, to the market at large.  All it needs is the right strategy in what is really a tough market with myriad ways to set up shop.</p>\n      <br/>\n      <p>Imagine that you head the consulting team that has been called in to work with ISG.  You have concluded IS Group has a good idea here, and have determined what their strategy should be.  You are ready to write to recommend it.  You know you want to structure the document around the steps in the strategy, as shown on below.</p>\n      ',
	            'intro-3': '<h3 class="intro__title">Full wording of the introduction</h3>\n    <br/>\n    <br/>\n    <div class="intro__introduction">\n            <p>Information Systems Group is planning to leave Houston and enter the external Systems Engineering and Management market. Having honed your skills over the last 20 years, and understanding the demands of the market, you are in an excellent position to compete with current incumbents in providing expert systems design and development. Nevertheless, making a success will not come easily.</p>\n            <br>\n            <p>The market itself is dominated by the Department of Defense, which does favor dealing with local suppliers. And while most business is conducted through purchase orders, DOD imposes stringent rules for submitting those proposals. A thorough understanding of these processes is essential. The rest of the market is also highly competitive, consisting of a variety of segments catering to specialized niches with widely differing success factors. The key to success is identifying the right niche for ISG\u2019s particular strengths. To that end, the Group needs a workable strategy.</p>\n            <br>\n            <p>(What strategy do you recommend?)</p>\n    </div>'
	        },
	        'exercise-4': {
	            'title': '5C - Exercise 4<br/>Spirit Business Systems',
	            'text-1': '<p>Following is the Executive Summary of a proposal to Spirit Business Systems plus the additional facts you would need to know if you were writing the proposal from scratch. It is structured in the classic consulting firm way, but with an effort to give a sense of the point each section is trying to make:</p>\n      <br/>\n      <ul>\n        <li>Our Proposition</li>\n        <li>Our Qualifications \u2013 World Class Capabilities</li>\n        <li>The Process \u2013 Seamless teaming</li>\n        <li>The Value to Spirit</li>\n      </ul>\n      <br/>\n      <p>Nevertheless, it does not clearly explain the problem to which Eastwood is offering a solution. And, as it turns out, it is a double-layer problem. But first, here are the facts you need to know about Sprit to be able to understand the proposal.</p>',
	            'blue-paper': '<h5><ins>Facts about Spirit</ins></h5>\n        <ul class="spirit-facts-blue-paper">\n            <li>The entity we are talking to is Spirit Fulfillment Division\n                <p><span class="span-marginX">-</span>It currently has two Systems Development facilities, Dallas and Kansas City</p>\n                <p><span class="span-marginX">-</span>The two facilities design new products and services, and maintain the Information Systems for the company as a whole</p></li>\n            <li>The SLD work force has grown from 1300 to 1700 people over the last 2 years, mostly using outside contractors\n                <p><span class="span-marginX">-</span>Demand for services is projected to reach 1 million hours a year over each of the next 5 years</p>\n                <p><span class="span-marginX">-</span>That will require another 500 people a year to meet that demand</p>\n                <p><span class="span-marginX">-</span>No way the two facilities can absorb that many people without a major reduction in productivity</p>\n            </li>\n            <li>SLD wants to handle the growing work load efficiently\n                <p><span class="span-marginX">-</span>It needs to build a separate facility to house the new entrants</p>\n                <p><span class="span-marginX">-</span>It wants building the facility to cause minimum disruption to day-to-day work</p>\n                <p><span class="span-marginX">-</span>It wants the addition to operations of the new plant to be seamless</p>\n            </li>\n            <li>SLD does not have the resources to build, staff, nor manage a new facility\n                <p><span class="span-marginX">-</span>It is looking to hire an outside company to build, staff, and manage the project</p>\n            </li>\n        </ul>\n    ',
	            'text-2': '"And here are the first two sections of the proposal that was written based on these facts. You can see that it is somewhat awkwardly structured around headings rather than around the approach the consultant will take to solve the problem, with "Our Qualifications" coming before the explanation of the work<br/><br/>\n                 Tsk Tsk.<br/><br/>',
	            'blue-paper-additional-header': '<h5 class="blue-paper-2-header"><b>What You Know</b></h5>',
	            'blue-paper-2': '\n        <div class="blue-paper-header" style="top: 114px;">\n            <div>\n            <p style="margin-left: 24px;">Spirit Business Systems</p>\n            <p id="date-to-change" style="margin-left: 65px;"></p>\n            </div>\n            <div style="margin-top: 19px;">\n            <p style="margin-left: 47px;">Eastwood Consulting</p>\n            <p style="margin-left: 86px;">Executive summary</p>\n            </div>\n        </div>\n<!--        <p><span class="blue-paper-2__summary">Executive Summary</span></p>-->\n        <div>\n<!--            <br/>-->\n            <p>Eastwood is pleased to have this opportunity to architect, build, manage and operate a world-class \u201CBusiness Systems Development Center\u201D for Spirit. The \u201CSpirit Solutions Center\u201D we propose will provide Spirit with the systems development expertise, enabling technologies, telephone industry knowledge objects, technical resources and business management expertise that are crucial to the rapid development and implementation of critical, new business applications.</p>\n            <br/>\n            <p>As Spirit\u2019s leading professional services firm, we fully appreciate and applaud the emphasis Spirit is placing on this challenge. And together with our alliance partners, we are uniquely positioned to provide the resources, personnel and expertise needed to create and operate a world-class development center \u2013 a center that will dramatically propel Spirit forward and allow it to achieve both its short and its long-term strategic and operational business objectives.</p>\n            <br/>\n            <p>Eastwood is confident that we can make the Spirit Solutions Center the benchmark against which comparable centers will be measured. Our confidence stems from the caliber of the team we are proposing \u2013 a team that has been responsible for successfully building and operating similar world class centers for ourselves and for our clients. As such, we bring with us the deep knowledge that results from the fusion of best practices and hands-on experience. We know that we can immediately add value to Spirit \u2013 yielding superior speed and productivity \u2013 at a fraction of the risk normally associated with such an undertaking.</p>\n            <br/>\n            <p>Our proposition is as follows:</p>\n        </div>\n        <br/>\n        <p><span class="blue-paper-2__summary">Our Proposition \u2013 The Spirit Solutions Center</span></p>\n        <div>\n            <br/>\n            <p>Working together with Spirit, the Team will architect, build, staff and operate a \u201Cworld class\u201D business systems solution center for Spirit. The Spirit Solutions Center will provide Spirit with the superior capabilities required to conceptualize, design, program and implement advanced business system applications, as well as enhance legacy systems. The Spirit Solutions Center will have the capacity to generate one million hours of annual systems development work.</p>\n        </div>\n        <br/>\n        <p style="position: relative; z-index: 3;"><span class="blue-paper-2__summary">Our Qualifications \u2013 World-Class Capabilities</span></p>',
	            'text-3': '\n      <div class="desc-scq-diagram">\n            <div style="max-width: 340px" class="desc-scq-diagram__title">\n                <p>SUGGESTED STRUCTURE<br/>PROPOSAL TO SPIRIT</p>\n            </div>\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S = </p>\n                </div>\n                <div class="scq-block">\n                    <p>C = Want up and running in 6 months with minimum disruption to existing operations</p>\n                </div>\n                <div class="scq-block">\n                    <p>Q = (Can you help us to do that?)</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div style="max-width: 250px;" class="scq-block">\n                    <p>Eastwood has the qualities neces-sary to deliver and manage an outstanding new systems development facility for Spirit </p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="85" y2="100"/>\n                    <line x1="450" y1="0" x2="450" y2="100"/>\n                    <line x1="450" y1="0" x2="805" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                <div class="scq-block">\n                    <p>We have a clear vision of the finished facility that Spirit needs</p>\n                </div>\n                <div class="scq-block">\n                    <p>We will bring together the necessary levels of expertise to get the job done</p>\n                </div>\n                <div class="scq-block">\n                    <p>We can move expeditiously to bring the whole project to life</p>\n                </div>\n                </div>\n\n\n            </div>\n        </div>'
	        },
	        'intro-4': '\n        <p>Spririt\u2019s Systems Development Center has grown over the last 2 years, from 1300 to 1700 people. Spirit is planning to grow even more to meet a projected demand of 1 million hours a year for each of the next 5 years. Meeting that demand will require adding another 500 people. Neither Dallas nor Kansas City facility can absorb that many new hires and still be productive.</p>\n        <p>Consequently, Spirit has decided to build a separate unit to house the new entrants.  It wants to make certain that the new unit will be up and running efficiently within 6 months, with minimum disruption to existing operations.  Spirt has decided to hire an outside company to build, staff, and manage the facility.</p>\n        <p>(Are you the one to help us do that?)</p>',
	        'wording-introduction-paper': {
	            'desc': 'Now that you know the essence of what your proposal will say, and given the examples you have seen of good introductions, why not try to write out the full introduction yourself this time. You can then compare it to my version.',
	            'revealIntroduction': 'VIEW SCHOOL SOLUTION',
	            'header': 'Eastwood consulting and the company in this exercise'
	        },
	        'congratulation-message': 'CONGRATULATIONS',
	        'finish-section': 'You have completed Section 5C',
	        'final-description': 'You are fully able both to structure the definition of a problem<br/> and to convert it into a proper SCQ introduction',
	        'next-course-button': 'proceed to section 5D',
	        'dashboard-button': 'Main menu'
	    }
	};

/***/ }),
/* 411 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'writing-proposals-plans': {
	        'course-title': 'Writing A Good Proposal',
	        'course-name': 'Section 5D <span class="unit-title">Writing A Good Proposal<span>',
	        'course-video': {
	            'title': 'Section 5 DEFINING THE PROBLEM<br/>1’58:28 – 2’05:31 5B VISUALIZING THE PROBLEM :<br/>- ex 5B laying out the parts of the problem',
	            'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	            'lecture-title': '5D Lecture'
	        },
	        'unit-section-title': '5D Exercises',
	        'intro': '<p>The problem definition is particularly useful for writing consulting proposals and other kinds of project plans, where being able to define the problem clearly and succinctly is essential. In structuring what you are going to say, the key things you want to cover are:</p>\n<br/>',
	        'key-list': {
	            'key-1': 'Your understanding of the problem the client is facing (Situation-R1-R2)',
	            'key-2': 'Your approach to dealing with it (Steps) or',
	            'key-3': 'Your explanation of why the client should choose you (Reasons)'
	        },
	        'first-image': '<img src="/assets/images/intro-5d-1.png" alt="Solve the problem">',
	        'second-image': '<img src="/assets/images/intro-5d-2.png" alt="Skill and competence">',
	        'intro-second-text': '<p>You sell consulting work first by presenting a crystal clear explanation of your understanding of their problem, and then by convincing them of your absolute competence to solve it. The trick is to give lots of examples when you explain what you will do in each step, with sample charts and graphs. In this way you make obvious both your experience and your qualifications to do the work successfully.</p>',
	        'intro-third-text': '<p>In the exercises that follow, I have in each case given you the raw material of the problem, the elements of the problem definition, and the pyramid for the restructured document. I ask you in turn to complete the problem definition and transform it into a full SCQ introduction.</p>',
	        'menu-list': {
	            'exercise-1': 'Risk management study - benchmark advantage',
	            'exercise-2': 'PCI Energy Services Group site closure conversion inter-project synchronization',
	            'exercise-3': 'Slade Pharmaceuticals request for a proposal from a consulting firm'
	        },
	        'exercise-1': {
	            'title': '5D - Exercise 1<br/>Risk management study - benchmark advantage',
	            'text-1': '<p>A frequent trap many writers fall into is presenting a solution to a problem in great detail, before ever explaining to the reader what the problem is they are promising to solve.  Here is a typical example of that error, in a letter from a major Credit Card company (Charge-It) to the CEOs of the various banks that distribute its cards.</p>\n                <br/>\n                <p>The purpose of the letter, apparently, is to interest the Banks in participating in a pilot test of a new Risk Management Benchmarking Service it plans to launch.  Charge-It proposes to conduct a survey of how the banks manage credit risk, so that it can establish useful benchmarks and predict trends in credit risk for them.</p>',
	            'blue-paper': '\n        <p><span class="blue-paper-2__summary">Dear Mr. (Bank President)</span></p>\n        <br/>\n        <div>\n            <br/>\n            <p>The Risk Management Study is developed in response to issuers\u2019 requests for a meaningful perspective of the key underpinnings of their risk management practices.  Issuers identified the need for a risk management benchmarking service that would be updated periodically, with analytical insights into developing credit risk trends.</p>\n            <br/>\n            <p>Charge-It is planning on conducting a pilot version of the Risk Management Study amongst US based issuers with the intent of introducing to issuers the value and benefits of Charge-Its\u2019 benchmarking offering.  Additionally, the pilot will also allow issuers to provide feedback on the content and direction of the ongoing version.   An annual Steering Committee meeting comprising the participating issuers will be established to serve as a forum for issuers to provide study input and address mutual risk management challenges.</p>\n            <ul style="list-style-type: disc; font-family: \'Times New Roman\',sans-serif; line-height: 25px; font-weight: bold">\n                <li style="font-family: inherit">What are the Objectives of the Risk Management Study?</li>\n                <li style="font-family: inherit">What is covered in the Risk Management Study?</li>\n                <li style="font-family: inherit">How is the Study different from other existing offerings?</li>\n                <li style="font-family: inherit">What can Participants learn/gain?</li>\n                <li style="font-family: inherit">What is required to participate?</li>\n                <li style="font-family: inherit">What can  you expect to receive from the Pilot?</li>\n            </ul>\n        </div>',
	            'text-2': '<p>Assume you are the person required to rewrite this letter to persuade the Banks to participate in the study.</p>\n        <br/><br/>\n        <p>Here are the stated objectives of the Study....</p>\n        <ul>\n            <li>To provide risk performance benchmarks with a macro economic perspective on risk management practices</li>\n            <li>To provide an assessment or forecast on the direction of credit risk trends based upon macroeconomic factors</li>\n            <li>To identify best practices and their potential impact on overall  business and organizational performance</li>\n            <li>To serve as a decision support tool through modeling and scoring for risk managers in shaping credit risk policy and impacting market strategy</li>\n        </ul>\n        <p>...and here is the structure of the full letter:</p>\n        <br/><br/>\n        <div class="desc-scq-diagram diagram-with-scq-text">\n            <div style="max-width: 340px" class="desc-scq-diagram__title">\n                <p>PRESENT STRUCTURE<br/>RISK MANAGEMENT STUDY<br/>BENCHMARK ADVANTAGE</p>\n            </div>\n            <div class="scq-text">\n                <div style="height: 90px;" class="scq-block">\n                    <p>S = Issuers want better perspective on the underpinnings of their RM practices, with periodic updates, and analytical insights into developing credit risk trends.</p>\n                </div>\n                <div style="height: 107px" class="scq-block">\n                    <p>C = CI planning to conduct pilot version in US to show value, provide feedback on content and direction of ongoing version. Will also have annual Steering Committee meeting as forum for issuers.</p>\n                </div>\n                <div style="height: 66px;" class="scq-block">\n                    <p>Q = </p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div style="width: 166px" class="scq-block"></div>\n                <svg>\n                    <line x1="450" y1="0" x2="65" y2="100"/>\n                    <line x1="450" y1="0" x2="260" y2="100"/>\n                    <line x1="450" y1="0" x2="450" y2="100"/>\n                    <line x1="450" y1="0" x2="640" y2="100"/>\n                    <line x1="450" y1="0" x2="830" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                  <div class="scq-block">\n                      <p>Objectives of the RM Study</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>How is this study different?</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>What can participants learn/gain?</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>What is required to participate?</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>What can you expect to receive?</p>\n                  </div>\n                </div>\n        </div>\n        <br/><br/>\n        <p>And here is the structure of your letter:</p>\n        <br/><br/>\n        <div class="desc-scq-diagram second-diagram">\n            <div class="scq-text">\n                <div class="scq-block">\n                    <p>S = </p>\n                </div>\n                <div class="scq-block">\n                    <p>C = </p>\n                </div>\n                <div class="scq-block">\n                    <p>Q = </p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div class="scq-block">\n                    <p>Believe you would find it useful to participate in the pilot Risk Management Study</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="65" y2="100"/>\n                    <line x1="450" y1="0" x2="260" y2="100"/>\n                    <line x1="450" y1="0" x2="450" y2="100"/>\n                    <line x1="450" y1="0" x2="640" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                  <div class="scq-block">\n                      <p>Will cover useful information</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Will produce a customized confidential report</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Will be updated periodically with analytical insights into developing credit risk trends.</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Will be subject to annual Steering Committee review on utility/relevance of benchmarks</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Next steps \u2013 to enroll</p>\n                  </div>\n                </div>\n\n                <div style="justify-content: flex-start" class="scq-diagram-body scq-diagram-body__list">\n                    <ul>\n                        <li>Assessment/forecast on direction of CR trends</li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n        <br/>\n        <p>Now define the problem in the usual way.</p>\n        ',
	            'intro-2': '\n        <p>Dear Mr. (Bank President),</p>\n        <p>As you know, a major task facing card issuers like yourself is managing portfolio risk in the face of changing economic conditions.  Current risk management benchmarking services do enable you to compare your past performance to that of other banks, but they provide only a rear-view- mirror look at recent performance.  There is no projection of trends in, nor insights into, cardholder risk profiles, and no indication of where changes in strategy are called for.  </p>\n        <p>We see a need among our issuers for a service that will anticipate risk and offer protection against it.  To that end,, Charge-It is developing a Risk Management Benchmarking study that will give meaningful perspective on current risk management practices, with analytical insights into credit risk trends.  We are launching a pilot version of this service at the beginning of April.  We hope we can convince you to participate in this pilot study.</p>\n        <ul>\n          <li>It will cover useful information</li>\n          <li>It will produce a customized confidential report on each bank\u2019s situation</li>\n          <li>It will be  pdated periodically, with analytical insights into developing credit risk rends</li>\n          <li>It will be subject to an annual Steering Committee review on the utlity and relevance of the benchmarks used</li>\n        </ul>\n        '
	        },
	        'exercise-2': {
	            'title': '5D - Exercise 2<br/>PCI Energy Services Group site closure conversion inter-project synchronization',
	            'text-1': '<p>You\u2019re really getting good at this process now, aren\u2019t you?  Let\u2019s try one where you do the actual work on a consulting proposal prepared for the PCI Energy Services Group, a subsidiary of Westinghouse Electric Company.  It is about aligning the implementation plans for 5 separate projects.  Here is what you need to know to understand the problem.</p>',
	            'blue-paper': '<p>Westinghouse Electric Company has just sold its fossil fuel Power Generation Business (both equipment manufacturing and power generation) to Siemens Power Corp.  They will together form the Siemens Westinghouse Power Corporation (SWPC), to be located in Orlando, Florida.</p>\n                     <br/>\n                     <ul class="ex3-blue-paper-1 first-list">\n                        <li>The deal physically included only 3 of Westinghouse\u2019s 7 equipment manufacturing plants (Charlotte, North Carolina, Fort Wayne, Alabama; and Winston-Salem, North Carolina)</li>\n                        <li>The other 4 plants (Milwaukee, Wisconsin; Hobart, Indiana; Glassport, Pennsylvania; and St. Catherines, Ontario, Canada) will be shut down, their Business Operations transferred to other sites within SWPC, and their Information Systems assimilated into those sites</li>\n                     </ul>\n                     <br/>\n                     <p>PCI Energy Services Group will define the structure of the Manufacturing Network required to support the integrated equipment manufacturing operations of the new SWPC\u2019s 3 plants.  The PCI Program Manager is particularly concerned to ensure that the transferred Westinghouse Business Operations can immediately access the plants\u2019 current  Information Systems at their new sites, either directly or via the receiving site\u2019s existing information system.  Accordingly, he wants to be certain that the data conversion activities necessitated by the transfer are planned and completed well in advance of the rollout of the Manufacturing Network.</p>\n                     <br/>\n                     <p><strong>However, there are a number of other projects in train for the new SWPC at the same time as the Network rollout, which also require data conversion:</strong></p>\n                     <br/>\n                     <ul class="ex3-blue-paper-1">\n                        <li><strong>A Global Manufacturing SAP solution</strong></li>\n                        <li><strong>An Engineering Solution</strong></li>\n                        <li><strong>A new IT Infrastructure Development</strong></li>\n                        <li><strong>A new eProcurement program</strong></li>\n                     </ul>\n                     <br/>\n                     <p>To reduce duplication of effort and possible delays, the NW transfer data conversion work needs to align with the implementation plans of these 4 projects, and they in turn need to coincide where feasible with the NW transfer and rollout tasks.</p>\n                     <br/>\n                     <p>The PCI Program Manager believes pulling that off will be a tough job. It means not only managing the data conversion activities for the 4 new projects, but also coordinating with their managers and implementation teams, as well as with the designated \u201CLocal Responsible Persons\u201D at each of the NW production receiving sites.  He needs help in organizing the 5 projects and their managers and teams to work together.</p>',
	            'text-2': '<p>Following is their proposal and a picture of the bottom of the pyramid to communicate it.</p>',
	            'blue-paper-2': '<br/><br/><h5 style="text-align: center; line-height: 1.2;">MILWAUKEE, HOBART, GLASSPORT AND ST. CATHERINES<br/>SITE CLOSURE CONVERSION INTER PROJECT SYNCHRONIZATION</h5>\n                       <br/>\n                       <p><strong>Project Objectives</strong></p>\n                       <br/>\n                       <p>To provide program management guidance and consultation on the IT and other activities required to ensure that the Business Operations transferred from the Milwaukee, Hobart, Glassport and St. Catherines sites can operate at the Siemens Westinghouse Power Corporation (SWPC) sites to which they are moved.</p>\n                       <br/>\n                       <p><strong>Problem Definition</strong></p>\n                       <br/>\n                       <p>The PCI Team is defining the structure of the Manufacturing Network that will be required to support the integrated Power Generation Equipment manufacturing operations following the merger of the Fossil Fuel Divisions of Siemens and Westinghouse.</p>\n                       <br/>\n                       <p>The creation of the Manufacturing Network will result in the re-alignment of the manufacturing capabilities at the production sites.  The first phase of the realignment is the closure of the Milwaukee, Hobart, Glassport and St.  Catherines sites.  The business operations previously undertaken at these sites are to be transferred to other sites within SWPC.  The Information Systems that support the transferred Business Operations will require to be accessible via -  or the data structures assimilated into - the Business Information Systems of the site receiving the Business Operation.</p>\n                       <br/>\n                       <p>Concurrent with the rollout of the Manufacturing Network, a planned Global Manufacturing SAP solution, Engineering Solution, IT Infrastructure Development, and eProcurement are being implemented.  The data conversion activities necessitated by the transfer of Business Operations will require alignment with these planned implementations to coincide, where feasible, with the transfer and rollout tasks to reduce duplication of conversion effort.</p>\n                       <br/>\n                       <p><strong>Project Scope</strong></p>\n                       <br/>\n                       <p>We can help the PCI Team ensure that the Business Operations transferred from the Milwaukee, Hobart, Glassport and St. Catherines sites can continue to operate at the Siemens Westinghouse Power Corporation (SWPC) sites to which they are moved, without duplication or delay.  To that end, you need a \u201CLocal Responsible Person\u201D on each site.  We suggest appointing an additional person to coordinate activities with the Site Closure Program Manager, the managers at the receiving sites, and the various implementation teams.  He will need to:</p>\n                       <br/>\n                       <ul class=""  style="font-family: \'Source Sans Pro\',\'sans pro\', Arial, serif; line-height: 25px">\n                        <li style="font-family: inherit; list-style-type: disc;list-style-position: outside;">Review the Site Closure and Conversion IT, Manufacturing Network, Global Manufacturing SAP Solution, Engineering Solutions, IT Infrastructure Development, and the eProcurement implementation plans, to <strong>identify interdependency of tasks</strong> and resources across projects.</li>\n                        <li style="font-family: inherit; list-style-type: disc;list-style-position: outside;">Work with the Implementation Teams to <strong>mitigate the duplication of data conversion activities</strong></li>\n                        <li style="font-family: inherit; list-style-type: disc;list-style-position: outside;"><strong>Identify and manage</strong> cross-project <strong>resource constraints</strong>/dependencies, and align implementation dates</li>\n                        <li style="font-family: inherit; list-style-type: disc;list-style-position: outside;">Create a program <strong>plan</strong> containing <strong>the critical milestones</strong> identified in the above activities</li>\n                        <li style="font-family: inherit; list-style-type: disc;list-style-position: outside;"><strong>Report on the progress</strong> and achievement of the program to the PCI IT, record issues, risks, manage issue resolutions and define countermeasures.</li>\n                       </ul>\n      '
	        },
	        'intro-2': '<p>As part of the new Siemens Westinghouse Power Corp (SWPC) merger, Siemens will take over 3 of Westinghouse\u2019s 7 equipment manufacturing plants, closing the other 4 and transferring their business operations to sites in the new SWPC Network.</p>\n        <p>PCI Energy Systems Group will define the structure of the new SWPC Network, and realign the capabilities at each production site.  PCI must also make certain to complete data conversion activities for the Information Systems of the transferred Westinghouse plants.  SWPC wants them up and running immediately before rollout, so that business operations can proceed without delay.</p>\n        <p>Concurrently, however, PCI is implementing four other major programs for SWPC, each of which also requires data conversion. PCI must therefore align its planned Westinghouse data conversion activities with these four major programs. They will also want them to coincide, where feasible, with the transfer and rollout tasks of the four programs, to reduce likely duplication of the conversion effort.</p>\n        <p>The necessity of working on these four other programs creates an unacceptable risk that PCI\u2019s work on the Westinghouse IS data conversions will not be in place to receive the transfer of Westinghouse\u2019s business operations.  This is unacceptable to SWPC.</p>\n        <p>How eliminate the risk?</p>',
	
	        'exercise-3': {
	            'title': '5D - Exercise 3<br/>Slade Pharmaceuticals request for a proposal from a consulting firm',
	            'text-1': '<p>Requests for a consulting firm to give you a proposal (RFP) require a good introduction and structure the same as any other document communicating your thinking.  You have to be careful to tell the receiving firm enough to make sure they understand the circumstances in which your  need for their services arose, and make clear what you expect to get back from them.  That means you have a double task, in that you need both to</p>\n      <br/>\n      <ul>\n        <li>Lay out your own understanding of your problem</li>\n        <li>Visualize what you want their end product to look like</li>\n      </ul>\n      <br/>\n      <p>Alas, it is rare that an RFP accomplishes both objectives.  The following request for a proposal for a marketing study on opportunities in the pharmaceutical market  in China is a case in point. It  is structured around a list of seven \u201Cissues.\u201D But  in explaining each issue, it reveals other things about which Slade is concerned that hint at a set of assumptions about what has to go right for them to be able to put forward a business case for going into China.  In other words, they do not really know what they want the consulting firm to give them.</p>\n      <br/>\n      <p>When you as a consulting firm receive an RFP like this, you need to decipher it for them, so that you can reply appropriately.  That means going straight to the Problem Definition Framework to lay out their understanding of their problem, considering everything they say in the document.  Once you have worked that out, it is easy to send them a compelling reply.</p>',
	            'blue-paper': '<p>We are a mid-size international health care company headquartered in Poznan, Poland., with sales $5.97b and 7,300 employees worldwide. We are eager to grow in China, both through internally and externally sourced products.  Our sales and marketing organization is targeting a significiant growth in number of people to support .  However, during recent discussions with our Chinese affiliate about differently sourced opportunities, we have found it difficult to develop a compelling business case with or without allocating selling expenses.</p>\n                     <br/>\n                     <p>The same sort of opportunities have proven much easier to build an attractive case for  in other emerging market.  Thus, Slade would like to understand better if this is a truly inherent characteristic of the Chinese pharmaceutical market,  Or are there ways - best practice learning - to improve profitability and performance in China?</p>\n                     <br/>\n                     <p style="font-family: \'Times New Roman\'">From  recent discussions with the Chinese affiliate, the following issues have been creating a challenge for us in developing a profitable business case:</p>\n                     <ol class="ex3-blue-paper-1 first-list" style="font-family: \'Times New Roman\'; line-height: 25px">\n                        <li style="font-family: inherit">What is the future growth in the Chinese market volume, especially considering new healthcare reforms and the growth of the Chinese middle-class?</li>\n                        <li style="font-family: inherit">How fast can a new product get a wide market access given the different provinces, hospitals, tender systems, listings and reimbursement systems (uptake curve)</li>\n                        <li style="font-family: inherit">What is the future pricing environment in China, making a clear distinction between innovative products and branded generics, and also considering the ambitious health care targets of the Chinese government?\n                            <ul style="list-style-type: lower-alpha; font-family: inherit" class="ex3-blue-paper-1">\n                                <li style="font-family: inherit">How would the prices in China compare to other markets, both mature and developing? </li>\n                                <li style="font-family: inherit">How are the prices in comparison today?</li>\n                            </ul>\n                        </li>\n                        <li style="font-family: inherit">How strongly is IP protecting you from generic competition and how fast would generics normally enter the market and what impact would they have on originator sales?</li>\n                        <li style="font-family: inherit">What is driving the relatively high marketing and sales expenditure as a percentage of sales?</li>\n                        <li style="font-family: inherit">Would China also have a normal investment cycle with large investments during the first 3-5 years, later being able to lower investments and focus mainly on current prescribers?</li>\n                        <li style="font-family: inherit">Are there other factors driving the marketing expenses (non-selling expenses) in China?</li>\n                     </ol>\n                     <br/>\n                     <p style="font-family: \'Times New Roman\'">Slade Pharmaceutical would like to have an external validation of the issues highlighted above (and explained in detail in the attached page), as well as  potential future developments and best practice from a Chinese-based expert in pharmaceutical sales and marketing.</p>',
	            'blue-paper-2': '<br/><br/><h5 style="text-align: center; line-height: 1.2;">ISSUES IN DEVELOPING A PROFITABLE<br/>BUSINESS CASE IN CHINA</h5>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Future growth of pharmaceutical market volume</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">By the health care reform ambitions of Chinese government, and the fast economic growth in China, also the pharmaceutical growth is expected to grow fast in the future.  Given the relative lack of blockbuster products in the Chinese market, this will be an important driver  for a pharmaceutical company\u2019s ability to develop large products in the market.  How fast will this growth materialize and how will the future market segments develop into clusters of customers with different ability to pay (low middle-class might be a large group, but only able to pay for low priced generics)?</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Wide market access</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">Based on discussions with the Slade affiliate and the resulting business case, it seems like it takes a very long time to get access to the larger Chinese market based on facts like many provinces, drug listings only open to entry at certain time intervals, A-, B-, C-classified hospitals, different distributors, etc.  These factors result in a very slow market uptake in the overall market.  We would like to understand these health care based factors better, and would also be looking for potential ways to resolve this slow market penetration and uptake.</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Future pricing environment</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">Recent developments in the Chinese market have shown tendencies to restrictive tender processes and listings, giving only few products access to provinces and hospitals.  The selection criteria seem to be almost exclusively based on price, with the result of very low prices making some companies avoiding these tenders altogether.  What are the future trends in the Chinese market to be able to get a profitable price?  Will this be different between branded generic drugs, me-too drugs or truly innovative products?  How is and how will the prices in China compare to prices for the same products in other markets?  Will there be Western-style cost-containment introduced in China going forward?</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Strength of IP protection</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">In China you often see early generic entrants competing with the originator product.  What is the strength of the IP protection in China, and are there other protective mechanisms like data exclusivity?  Will today look different from the future, and will it be different depending on filing dates and innovativeness  Once generic competition enters the Chinese market \u2013 what impact would they normally have on originator sales?</p>\n                       <br/>\n                       <p><strong>High marketing and sales expenditure</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">A hurdle for developing profitable business cases in China has proven to be the large marketing and sales expenditure as a percentage of net sales.  There is a clear trend that as sales grow so will marketing and sales expenditure in an almost fixed way, resulting in a fixed high percentage of net sales in M&S expenditure, clearly challenging the profitability.  We would like to better understand this pattern, and how it relates to the segmentation and targeting process in the market for the sales force.</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Investment cycle in China</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">Closely related to the point above, we would like to better understand how the normal investment cycle looks like in China as we have seen an unusual pattern of continuously increasing sales and marketing costs.  In most developed markets, we tend to see a high investment level in the early years to penetrate the market, followed by a lower investment phase with a focus on key current customers.  Why is not this the case in the Chinese market today, and could this pattern be improved by a more professional targeting work?</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Other factors driving the high sales and marketing investments</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">We would like to understand if there are other factors specific to the Chinese market that drive the high sales and marketing spend, like for example a wide prescriber base with low concentration of high prescribers?</p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'"><strong>Content of proposal</strong></p>\n                       <br/>\n                       <p style="font-family: \'Times New Roman\'">Based on your proposal we would like to understand the following:</p>\n                       <ul class="exercise-4-blue-paper-list" style="font-family: \'Times New Roman\'">\n                        <li style="font-family: inherit">Deliverables</li>\n                        <li style="font-family: inherit">Timelines</li>\n                        <li style="font-family: inherit">Cost</li>\n                       </ul>\n                       <br/>\n      ',
	            'text-3': 'If you have any questions, you are more than welcome to call and get answers to any questions you might have in relation to this RFP.\n      <div style="margin-top: 30px;" class="desc-scq-diagram diagram-with-scq-text">\n            <div style="max-width: 365px" class="desc-scq-diagram__title">\n                <p>PRESENT STRUCTURE<br/>REQUEST FOR PROPOSAL FOR<br/>MARKETING STUDY IN CHINA</p>\n            </div>\n            <div class="scq-text">\n                <div style="height: 90px;" class="scq-block">\n                    <p>S = Want to grow in China.  Difficult to develop compelling business case, whether to allocate selling expenses or not.</p>\n                </div>\n                <div class="scq-block">\n                    <p>C = Not so in other emerging markets.</p>\n                </div>\n                <div style="height: 73px;" class="scq-block">\n                    <p>Q = Is this inherent characteristic of Chinese pharma market? How improve profitability and performance in China?</p>\n                </div>\n            </div>\n            <div class="scq-diagram">\n                <div style="max-width: 260px;" class="scq-block">\n                    <p>Want external validation of issues, potential future dev., best practice from Chinese-based expert in pharma sales and marketing</p>\n                </div>\n                <svg>\n                    <line x1="450" y1="0" x2="65" y2="100"/>\n                    <line x1="450" y1="0" x2="260" y2="100"/>\n                    <line x1="450" y1="0" x2="450" y2="100"/>\n                    <line x1="450" y1="0" x2="640" y2="100"/>\n                    <line x1="450" y1="0" x2="830" y2="100"/>\n                </svg>\n                <div class="scq-diagram-body">\n                  <div class="scq-block">\n                      <p>Issues creating a challenge</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Future growth of pharma market volume</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Future pricing environment</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>High marketing & sales expen-diture</p>\n                  </div>\n                  <div class="scq-block">\n                      <p>Content of proposal</p>\n                  </div>\n                </div>\n            </div>\n        </div>'
	        },
	        'intro-3': '\n      <p style="margin: 0 auto">SLADE PHARMACEUTICALS<br/>REQUEST FOR PROPOSAL<br/>MARKETING IN CHINA</p>\n      <p>Slade is a global pharmaceutical company, with operations in countries throughout the world.  We are thinking about entering the Chinese pharmaceutical market.</p>\n      <p>When we decide to set up operations in an emerging market, we do a thorough analysis of the market and the demand for our products, add prepare a business case accordingly.  We generally assume that our marketing and sales costs will be a relatively high percentage of sales in the first 3-5 years, reducing after the market is developed and we are able to focus mainly on supplying prescribers.</p>\n      <p>In making plans to enter China, however, we are finding it difficult to prepare a compelling business case.  A major hurdle has been large marketing and sales expenditure as a percentage of net sales, and a trend for them to grow in an almost fixed way, as sales grow.  And even ignoring selling expenses, the numbers for nonselling costs are extremely high.</p>\n      <p>Slade would like to understand better if these high costs are a truly inherent characteristic of the Chinese pharmaceutical market, and whether there are ways (e.g., best practice learning) to improve profitability and performance in that market.  We would like to have external validation of the issues concerning us from a Chinese-based expert in pharmaceutical sales and marketing, as well as an insight into the potential future development of, and best practice in, the Chinese health care market.</p>\n      <p>(What do you want us to do for you?)</p>\n    ',
	        'congratulation-message': 'CONGRATULATIONS',
	        'finish-section': 'You have completed Section 5D',
	        'final-description': 'You know how to use the Problem Definition Framework<br/>to help you structure a clear and compelling consulting proposal',
	        'next-course-button': 'proceed to graduation',
	        'dashboard-button': 'Main menu',
	        'wording-introduction-paper': {
	            'desc': 'Now that you know the essence of what your proposal will say, and given the examples you have seen of good introductions, why not try to write out the full introduction yourself this time. You can then compare it to my version.',
	            'revealIntroduction': 'VIEW SCHOOL SOLUTION',
	            'header': 'Eastwood consulting and the company in this exercise'
	        }
	    }
	};

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram1-5a-5': {
	        'diagram-task': 'Click the step buttons from step 1 to step 7',
	        'step-1': 'STEP 1',
	        'step-2': 'STEP 2',
	        'step-3': 'STEP 3',
	        'step-4': 'STEP 4',
	        'step-5': 'STEP 5',
	        'step-6': 'STEP 6',
	        'step-7': 'STEP 7',
	        'step-task': 'STEP 5 State how you will get from R1 to R2 (if you know it)',
	        'situation': {
	            'title': 'SITUATION',
	            'text': '<ul>\n                <li>Spends $600m every year on products/services</li>\n                <li>Buys from hundreds of suppliers</li>\n                <li>Many diverse procurement decisions</li>\n                <li>Made by many different people with diverse backgrounds</li>\n                <li>No formal supplier evaluation/qualification process</li>\n            </ul>'
	        }
	    }
	};

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram2-5a-5': {
	        'diagram-task': 'Using the same process as in the Orlando example, push the buttons to fill out the Problem Definition Framework. It is a bit more complex than the Orlando example, because it is a double layer problem. But stop at Step 5 to read my comment.',
	        'step-1': 'STEP 1',
	        'step-2': 'STEP 2',
	        'step-3': 'STEP 3',
	        'step-4': 'STEP 4',
	        'step-5': 'STEP 5',
	        'step-6': 'STEP 6',
	        'step-7': 'STEP 7',
	        'step-task': 'STEP 5 State how you will get from R1 to R2 (if you know it)',
	        'situation': {
	            'title': 'SITUATION',
	            'text': '<ul>\n                <li>Spends $600m every year on products/services</li>\n                <li>Buys from hundreds of suppliers</li>\n                <li>Many diverse procurement decisions</li>\n                <li>Made by many different people with diverse backgrounds</li>\n                <li>No formal supplier evaluation/qualification process</li>\n            </ul>'
	        }
	    }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3': {}
	};

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram1': {
	    'title': '<span>THE SALES FORCE EFFECTIVENESS PARADOX - PROBLEM</span>\n        <br/><br/>\n        Please drag and drop the elements of the problem definition into their correct positions in the framework',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': '$Bn DISTRIBUTORS',
	    'left-box': 'SALES FORCE',
	    'right-box': 'SALES ENABLERS',
	    'bottom-box-points': '\n      <ul>\n        <li>Strategic Partners</li>\n        <li>National Accounts</li>\n        <li style="position: relative; width: max-content;">Mid-size Accounts<br/>(80% of revenue here)</li>\n      </ul>\n      <ul>\n        <li>Automatic Platforms</li>\n        <li>Solution Sellling</li>\n        <li>Challenger Training</li>\n        <li>Large-scale ERP</li>\n        <li>Replatforming programs</li>\n      </ul>\n      ',
	    'situation-desc-short': 'DISTURBING EVENT',
	    'situation-desc': 'Distributors make substantial investments in Sales<br/>Enablers to improve productivity of Sales Forces'
	  }
	};

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4': {}
	};

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram3': {
	    'title': '<span>Analysis of Technology Alternatives</span>\n                <br/><br/>Please drag and drop the elements of the problem definition into their correct positions in the framework',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': 'Bank operations',
	    'situation-second-row': 'Unisys Clearpath Dorado mainframe',
	    'left-box': 'CIF System',
	    'right-box': 'Deposits System',
	    'bottom-box-points': '\n      <p>Maintains high level customer information and processing services</p>\n      <p> - Costs $12 million/year</p>\n      ',
	    'situation-desc': 'DISTURBING EVENT'
	  }
	};

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4': {}
	};

/***/ }),
/* 419 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram5': {
	    'title': 'Please drag and drop the elements of the problem definition into their correct positions in the framework. There may be more than one element for each position',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': 'WINTER WHOLESALE GROCERS',
	    'top-box-desc-top': 'Supermarkets',
	    'top-box-desc-bottom': 'Independents',
	    'top-box-points': '\n      <ul>\n        <li>Order Goods</li>\n        <li>Place on Shelves</li>\n      </ul>',
	    'left-box': 'Buy for Manufacturers',
	    'middle-box': 'Store in Warehouse',
	    'right-box': 'Deliver to retail customers',
	    'bottom-box-points': '\n      <ul>\n        <li>Avoid\n            <ul>\n                <li>Being out of stock</li>\n                <li>Having excess inv.</li>\n            </ul>\n        </li>\n        <li>Procurement</li>\n        <li>Merchandising</li>\n      </ul>\n      <ul style="padding-left: 28px;">\n        <li>Receive truckload of pallets</li>\n        <li>Break pallets into cases, shelve</li>\n        <li>Receive order\n            <ul style="position: relative; width: max-content;">\n                <li>Select & load onto pallet jacks</li>\n                <li>Take to outbound shipping</li>\n                <li>Shrink wrap and load</li>\n            </ul>\n        </li>\n        <li style="position: relative; width: max-content;">Ship customized case to retailer</li>\n      </ul>\n      <ul style="position: relative; left: 6px;">\n        <li>On Time</li>\n        <li style="width: 99px;">Without errors</li>\n      </ul>\n      ',
	    'situation-desc': 'DISTURBING EVENT'
	  }
	};

/***/ }),
/* 420 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram6': {}
	};

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram1-5c': {
	    'title': 'Please fill in the rest of the problem definition on the form that follows. I have supplied the Disturbing Event to get you going',
	    'exercise-title': 'LOCATION BASED LEARNING STRATEGY',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': 'LEARNING CENTERS',
	    'left-box': 'REMEDIATION',
	    'middle-box': 'TUTORING',
	    'right-box': 'TUTORING<br/>(virtual or in person)',
	    'bottom-box-points': '\n      <ul>\n        <li>5-3 years, grades K-8</li>\n        <li>Hourly fee + long-term programs</li>\n        <li>4-5 national brands dominate</li>\n        <li>$2b market</li>\n      </ul>\n      <ul>\n        <li>5-7 years, grades K-12</li>\n        <li>Hourly or monthly for unlimited tutoring</li>\n        <li>90% fragmented</li>\n      </ul>\n      <ul>\n        <li>5-7 years, grades K12</li>\n        <li>Hourly or monthly for unlimited tutoring</li>\n        <li>80% fragmented</li>\n      </ul>\n      ',
	    'bottom-box-points-summarize': '$10b addressable market',
	    'situation-desc': 'DISTURBING EVENT',
	    'situation-desc-points': '\n        <ul style="max-width: max-content">\n            <li>Growing trend for parents to seek private-pay education to help children compete</li>\n            <li>4-5 national brands dominate Remediation Learnng Center market</li>\n            <li>Tutoring Center market 90% fragmented, no dominant player</li>\n            <li>Address same ages as Turner:  5-17 years old, grades K-12</li>\n        </ul>',
	    'structure-box': '\n        <p>See offering gaps in</p>\n        <ul>\n            <li>Enrichment segment of K-5 space (ages 5-10)</li>\n            <li>Programs focusing on Arts & Sciences</li>\n        </ul>'
	  }
	};

/***/ }),
/* 422 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram2': {}
	};

/***/ }),
/* 423 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram3-5c': {
	    'title': 'Please drag and drop the elements of the problem definition into their correct positions in the framework',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': 'Cascade Group',
	    'first-box': 'AZ',
	    'second-box': 'CA',
	    'third-box': 'IA & SD',
	    'fourth-box': 'MA',
	    'situation-desc': 'DISTURBING EVENT',
	    'bottom-box-points': '\n        <ul>\n            <li>10-15 years old, single-layered, transaction orientated, monolithic</li>\n            <li>Subject to numerous complaints by users</li>\n        </ul>',
	    'desc-text': 'All plans do roughly the same thing, but with some local differences',
	    'desc-text-2': 'Each plan has its own IT system. All are',
	    answers: {
	      'r1-top': '\n        <p>Systems can\u2019t cope:</p>\n        <ul>\n            <li>- Inflexible structure</li>\n            <li>- Narrow access to info across the system</li>\n            <li>- Complex to use</li>\n            <li>- High cost to operate</li>\n        </ul>',
	      'r2-top': '\n        <p>Systems that can cope:</p>\n        <ul>\n            <li>- Flexible, open, user friendly, modular</li>\n            <li>- Accessible to all users across the system</li>\n        </ul>',
	      'solution-bottom': '<p>Design a common core architecture around which each Plan can design its system to suit the characteristics of its market?</p>'
	    }
	  }
	
	  // export default {
	  //     'diagram3-5c': {
	  //       'title': `Please drag and drop the elements of the problem definition into their correct positions in the framework.
	  //       There may be more than one element for each position<br/>
	  //       Once completed, the pyramid builder will be provided for you to complete the next part of this exercise`,
	  //       'structure-answers-title': `Elements of the problem definition`
	  //     }
	  // }
	
	};

/***/ }),
/* 424 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4': {}
	};

/***/ }),
/* 425 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram5-5c': {
	    'title': 'Please drag and drop the elements of the problem definition into their correct positions in the framework',
	    'exercise-title': 'HOUSTON INFORMATION SYSTEMS GROUP - PROBLEM',
	    'structure-answers-title': 'Elements of the problem definition',
	    'situation-title': 'situation',
	    'diagram-header': 'ISG',
	    'left-box': 'Systems design/ development',
	    'middle-box': 'NW design/ development',
	    'right-box': 'Systems integration',
	    'bottom-box-points': '\n      <ul>\n        <li>Has good project management skills, technical expertise</li>\n      </ul>\n      ',
	    'situation-desc': 'DISTURBING EVENT'
	  }
	};

/***/ }),
/* 426 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram6': {}
	};

/***/ }),
/* 427 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram7-5c': {
	    'title': 'Please drag and drop the elements of the problem definition into their correct positions in the framework. There may be more than one element for each position',
	    'structure-answers-title': 'Elements of the problem definition',
	    'answers': {
	      'r1-bottom': 'Don\'t have resources to build, staff, manage new facility',
	      'r2-bottom': 'Seamless addition to operations',
	      'r2-bottom-2': 'Minimum disruption',
	      'solution-bottom': 'Hire an outside company to build, staff, and manage the project'
	    },
	    'exercise-title': 'PROPOSAL TO SPIRIT – PROBLEM'
	  }
	};

/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram2': {}
	};

/***/ }),
/* 429 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'diagram1-5d': {
	    'structure-answers-title': 'Elements of the problem definition',
	    'exercise-title': 'RISK MANAGEMENT STUDY – BENCHMARK ADVANTAGE - PROBLEM',
	    'situation-title': 'situation',
	    'diagram-header': 'Bank Credit Card Issuers',
	    'bottom-box-points': '\n      <ul>\n        <li>\n            Must deal with\n            <ul>\n                <li>Delinquences</li>\n                <li>Charge-offs</li>\n                <li>Bankruptcies</li>\n                <li>Credit utilization</li>\n            </ul>\n        </li>\n      </ul>\n      <ul style="max-width: 187px">\n        <li>\n            Affected by changes in\n            <ul>\n                <li>Unemployment rates</li>\n                <li>Debt to personal income ratios</li>\n                <li>Other economic influencers of risk</li>\n            </ul>\n        </li>\n      </ul>\n      ',
	    'situation-desc': 'Attempt to manage portfolio risk in the face of economic change<br/> - Rely on benchmarking studies for insights',
	    'disturbing-event': 'DISTURBING EVENT'
	  }
	};

/***/ }),
/* 430 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram4': {}
	};

/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram3-5d': {
	        'exercise-title': 'PCI ENERGY SERVICES GROUP \u2013 PROBLEM',
	        'structure-answers-title': 'Elements of the problem definition',
	        'situation-title': 'situation',
	        'diagram-header-1': 'Westinghouse Fossil Fuels',
	        'diagram-header-2': 'Siemens Power Corp.',
	        'middle-left-box': 'PCI Energy',
	        'middle-right-box': '7 Power Gen. Eqpt. Mfg. Sites',
	        'bottom-box': 'Siemens Westinghouse Power Corp. Orlando, Florida',
	        'bottom-box-list': '\n        <ul>\n            <li>NC-1</li>\n            <li>NC-2</li>\n            <li>AL</li>\n        </ul>\n        <ul>\n            <li>WI</li>\n            <li>IN</li>\n            <li>PA</li>\n            <li>Ont.</li>\n        </ul>\n      ',
	        'disturbing-event': 'DISTURBING EVENT',
	        'situation-desc': '\n        <br/>\n        W & S are merging Fossil Fuels Divisions, will integrate their manufacturing operations\n        <br/>\n        - Adding 3 W plants physically to the SWPC Network\n        <br/>\n        - Closing the other 4 W plants, transferring their business ops. and IS systems to other sites in the SWPC Network\n        <ul>\n            <li>Must align each IS to the IS of the receiving plant</li>\n        </ul>\n        <br/>\n        <br/>\n        PCI is defining the structure of the SWPC Network required to support the integrated mfg. operations\n        <br/>\n        - Will realign the mfg. capabilities at each production site\n        <br/>\n        - Will make certain that IS data conversion activities for the transferred plants are completed well in advance of the rollout of its business operations\n        <ul>\n            <li>Info Systems in Orlando must be up and running smoothly, without delay, before transfer the of the bus. operations of the 4 closing plants</li>\n        </ul>\n        '
	    }
	};

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram6': {}
	};

/***/ }),
/* 433 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram5-5d': {
	        'exercise-title': 'REQUEST FOR PROPOSAL FOR MARKETING STUDY IN CHINA \u2013 PROBLEM',
	        'structure-answers-title': 'Elements of the problem definition',
	        'situation-title': 'situation',
	        'diagram-header': 'Slade Sales & Marketing',
	        'first-box': 'ID Target Market',
	        'second-box': 'Set Prod Specs',
	        'third-box': 'Set up Distr',
	        'fourth-box': 'Market the prod.',
	        'fifth-box': 'Sell',
	        'text-1': 'Have general pattern for entering emerging market',
	        'disturbing-event': 'DISTURBING EVENT',
	        'situation-desc': '\n        A successful business case assumes\n        <br/>\n        - Growth of the market, given HC reforms\n        <ul>\n            <li>Room for a blockbuster product</li>\n            <li>Dev. of market into clusters of customers</li>\n        </ul>\n        - Middle class as target market\n        <br/>\n        - Fast uptake of product in provinces, hospitals\n        <ul>\n            <li>Fair tender systems, listings, reimbursements</li>\n        </ul>\n        - Pricing comparable to other markets\n        <br/>\n        - Protection of IP from generic products\n        <br/>\n        - Marketing & Sales costs to decrease after first 3-5 years\n        <ul>\n            <li>No other factors driving marketing expenses</li>\n        </ul>\n        ',
	        'box-desc': '\n        <ul>\n            <li>- Mkt growth</li>\n            <li>- Mkt segm.</li>\n            <li>- Pur process</li>\n        </ul>\n        <ul>\n            <li>- Price</li>\n            <li>- Brand name</li>\n            <li>- Pkg.</li>\n        </ul>\n        <ul>\n            <li>- Reg., ch.</li>\n            <li>- Sales force</li>\n            <li>- Trade terms</li>\n        </ul>\n        <ul>\n            <li>- Awareness</li>\n            <li>- Trial</li>\n        </ul>\n        <ul>\n            <li>- IP</li>\n            <li>- Generics</li>\n        </ul>\n        ',
	        'separator': '\n        <div class="separator-top">\n            <p>Costs lower</p>\n            <p>Main focus</p>\n        </div>\n        <p>Costs high here</p>\n      '
	    }
	};

/***/ }),
/* 434 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'diagram8': {}
	};

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  '6lecture': {
	    'course-title': 'Introduction - Looking Critically At Groupings',
	    'course-name': 'Section 6 <span class="unit-title">Introduction - <br> Looking Critically At Groupings<span>',
	    'course-video': {
	      'title': '',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': ''
	    },
	    'congratulation-message': 'excellent',
	    'finish-section': 'You have completed Section 5A',
	    'final-description': 'You understand how the Problem Definition Framework<br/>presents a map for structuring an introduction',
	    'next-course-button': 'proceed to 6A',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 436 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'identifyingLogicaOrder': {
	    'course-title': 'Identifying Logical Order',
	    'course-name': 'Section 6a <span class="unit-title">Identifying Logical Order<span>',
	    'course-video': {
	      'title': '',
	      'src': 'https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1',
	      'lecture-title': ''
	    },
	    exercises: {
	      title: '6A Exercises',
	      description: '',
	      exercises16: 'Exercise 1-6'
	    },
	    'congratulation-message': 'THANK YOU',
	    'finish-section': 'You have completed Section 6A',
	    'final-description': 'You can easily identify the logical order of a set of ideas',
	    'next-course-button': 'proceed to 6b',
	    'dashboard-button': 'Main menu'
	  }
	};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.i18nES = undefined;
	
	var _es = __webpack_require__(438);
	
	var _es2 = _interopRequireDefault(_es);
	
	var _es3 = __webpack_require__(439);
	
	var _es4 = _interopRequireDefault(_es3);
	
	var _es5 = __webpack_require__(440);
	
	var _es6 = _interopRequireDefault(_es5);
	
	var _es7 = __webpack_require__(441);
	
	var _es8 = _interopRequireDefault(_es7);
	
	var _es9 = __webpack_require__(442);
	
	var _es10 = _interopRequireDefault(_es9);
	
	var _es11 = __webpack_require__(443);
	
	var _es12 = _interopRequireDefault(_es11);
	
	var _es13 = __webpack_require__(444);
	
	var _es14 = _interopRequireDefault(_es13);
	
	var _es15 = __webpack_require__(445);
	
	var _es16 = _interopRequireDefault(_es15);
	
	var _es17 = __webpack_require__(446);
	
	var _es18 = _interopRequireDefault(_es17);
	
	var _es19 = __webpack_require__(447);
	
	var _es20 = _interopRequireDefault(_es19);
	
	var _es21 = __webpack_require__(448);
	
	var _es22 = _interopRequireDefault(_es21);
	
	var _es23 = __webpack_require__(449);
	
	var _es24 = _interopRequireDefault(_es23);
	
	var _es25 = __webpack_require__(450);
	
	var _es26 = _interopRequireDefault(_es25);
	
	var _es27 = __webpack_require__(451);
	
	var _es28 = _interopRequireDefault(_es27);
	
	var _es29 = __webpack_require__(452);
	
	var _es30 = _interopRequireDefault(_es29);
	
	var _es31 = __webpack_require__(453);
	
	var _es32 = _interopRequireDefault(_es31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Public pages
	var i18nES = exports.i18nES = angular.extend({},
	
	// Common components and public pages
	_es28.default, _es32.default, _es30.default, _es2.default, _es4.default, _es6.default, _es8.default, _es10.default, _es12.default, _es14.default, _es16.default, _es18.default, _es20.default, _es22.default, _es24.default, _es26.default);
	
	// Common components

/***/ }),
/* 438 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
					value: true
	});
	exports.default = {
					'barbara': {
									text: '<p>\n\t\t\t\t\tBarbara Minto holds an MBA from the Harvard Business School. Her Course reflects insights drawn from more than 30 years of\n\t\t\t\t\tconducting courses worldwide at major consulting firms and corporations. Indeed, the phrase \u201CTake this and make it Minto\u201D\n\t\t\t\t\tis common in many of these organizations and the Minto Pyramid Principle is considered the \u2018lingua franca\u2019 for serious-minded\n\t\t\t\t\tprofessionals, especially those who want to be listened to and earnestly wish to advance their careers.\n\t\t\t\t</p>\n\t\t\t\t<!-- <p>Barbara Minto\u2019s Wikipedia page.</p> -->'
					}
	};

/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'concept': {
			'text': '<div class="content-caption-box">\n\t\t\t\t<h3 class="content-caption">The Minto Pyramid Principle\xAE Concept</h3>\n\t\t\t</div>\n\t\t\t<p class="content-text">The Minto Pyramid Principle is a technique to help you work out and organize your thinking before you attempt to communicate\n\t\t\t\tit.\n\t\t\t</p>\n\t\t\t<p class="content-text">It states that a clear piece of writing will always consist of groups of related ideas, each group summarized to form\n\t\t\t\tthe next level of a pyramid, rising to a single pyramid with a single point at the top. And that the relationships between\n\t\t\t\tideas at every level within that pyramid, both vertically and horizontally, will obey a set of strict logical rules.</p>\n\t\t\t<p class="content-text">Before you begin to write, therefore, you want to force your ideas to fit that pyramid form, and make sure they obey the\n\t\t\t\tlogical rules. Communicating your thinking then requires only that you guide your reader down the pyramid.</p>\n\t\t\t<p class="content-text">So far, so clear. The hard part is forcing your thinking to fit the pyramid form, particularly given that you rarely know\n\t\t\t\tprecisely what all your ideas are before you attempt to arrange them into related groupings. So the thinking process\n\t\t\t\tconsists of pulling the ideas out of your head and fitting them together in a pyramid.</p>\n\t\t\t<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate the ideas and to organize\n\t\t\t\tthem at the same time. Thus avoiding the need to write countless drafts before you settle on your message.</p>'
		}
	};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'online': {
	        'login': 'Log In',
	        'try_course': 'Try Course',
	        'testimonials': 'Testimonials',
	        'barbara_minto': 'Video',
	        'buy_course': 'Buy <br> Course',
	        'corporate_inquiry': 'Corporate Inquiry',
	        'text': '<img src="/assets/images/coming-soon.png" alt="coming-soon" title="coming-soon" />\n            <div class="content-caption-box">\n                <h3 class="content-caption">The 2021 online course: Fully rewritten, with all new technology</h3>\n            </div>\n            <p class="content-text">The completely new Minto Online Course is a pinnacle in digital learning, reflecting 30 years of teaching and\n                development. It is easily the world\u2019s most complete computer teaching system for business writing and thinking.\n            </p>'
	    }
	};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'thank-you': {
	        'caption': 'Thank you for your purchase.',
	        'text': 'In the next few moments, you will receive and confirmation email.\n        <br/>If not, please <!-- take note of this reference: 000000\n        <br/>and --> contact us immediately.',
	        'main': 'Main page',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'payment-failure': {
	        'caption': 'Sorry, your payment did not go through.',
	        'text': 'No money has been deducted from your account.\n        <br/>Please try again using the form provided.\n        <br/>If you continue to encounter problems please contact us directly.',
	        'main': 'Main page',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'livecourse': {
	    'text': '<h3 class="content-heading">Barbara Minto holds an MBA from Harvard Business School. She personally conducts a world-renowned 2-day course for professional\n        people in how to use the Minto Pyramid Principle to shorten the time you spend writing.</h3>\n      <div class="content-caption-box">\n        <h3 class="content-caption">The Course</h3>\n      </div>\n      <p class="content-text">Organized for groups of 10-14 within a single company, the course shows how to use the pyramid rules to discover and clarify\n        the points you want to make. And it explains the value of the unique Situation-Complication-Question framework (SCQ Framework\n        tm) to identify the question your document is being written to answer. She also offers a shortened, 1-day version of\n        the basics as a refresher for people who already have some knowledge of the Minto Pyramid Principle.</p>\n      <div class="content-caption-box">\n        <h3 class="content-caption">The Content</h3>\n      </div>\n      <p class="content-text">The 2-day course is structured around the work of the people in the group. To this end, Barbara asks each person attending\n        to send her in advance a lengthy sample of his work. She then reads these, draws pictures of their structures, develops\n        new structures, and uses them as examples in the course.</p>\n      <p class="content-text">Both the 2-day and 1-day courses include an individual tutoring session with Barbara at the end of the formal sessions.\n        She meets personally with each person for 45-minutes to help him apply the pyramid-building process to something he is\n        about to write. It is this tutoring session that makes the technique "take". </p>\n      <p class="content-text">Barbara\u2019s courses are based on a similar course she developed and taught for several years at McKinsey & Company, Inc.,\n        the international management consulting firm. In addition to teaching McKinsey\u2019s consultants and many of its clients,\n        as well as all of the other major consulting firms, she has lectured at the Harvard, MIT, Stanford, Chicago, London and\n        Manchester business schools, and at the State University of New York.</p>\n      <p class="content-text">To find out more about Barbara\u2019s courses, e-mail inquiries@barbaraminto.com</p>\n\n      <img src="/assets/images/livecourse-img.png" alt="" class="content-img">'
	  }
	};

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'workbook': {
	        'text': '<div class="content-caption-box">\n                <h3 class="content-caption">The Minto Pyramid Principle\xAE Self-Study Course</h3>\n            </div>\n            <p class="content-text">\n                For people who prefer to study from a printed workbook, this course, developed in 1996, is still available for individuals.\n                <br> The video portion supplied in CD-ROM or DVD form, plus the book and workbook. This version is priced\n                at $1,500 plus postage and handling from New York.\n            </p>\n            <ul class="list__content-text">\n                <li>\n                    <p class="content-text">It consists of a 35-minute video overview of the concept plus a copy of the textbook, and an extensive\n                        workbook of exercises.\n                    </p>\n                </li>\n                <li>\n                    <p class="content-text">\n                        You can also for the moment access the highly successful internet version, with video and exercises interlinked. You will\n                        receive a free upgrade to the all-new online course when it becomes available later in the year.\n                        <br> - This original version is available for 4 months over the Internet at a cost of $1500.\n                        <br> - Once your order has entered our system, you will be contacted by minto.sales@comcast.net\n                        with Course Log-In Instructions. Upon registration you will also receive the copy of the textbook.\n                    </p>\n                </li>\n            </ul>\n            <p class="content-text">Note: The Internet version requires Internet Explorer. It will not function in Firefox or Safari.</p>'
	    }
	};

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'summary': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">The Minto Pyramid Principle\xAE App</h3>\n      </div>\n      <p class="content-text">\n        You may also download an app that summarizes what Barbara teaches in her live course. Created as a quick reference for people\n        who have already had the course, it also serves as an easy way for you quickly to find the concepts that are explained\n        in the book.\n      </p>\n      <p class="content-text">\n        It requires cellular data connect or wifi, and can be found on Apple iTunes Stores for $14.99. An Android version is also\n        available from Googleplay.\n      </p>\n      <p class="content-text">\n        Please note that the summary provides only an insight into the thinking behind the Minto Pyramid Principle; it does not actually\n        teach how to apply it to your work. That, alas, takes deeper explanation and practice!\n      </p>'
	  }
	};

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		'textbook': {
			'text': '<div class="content-caption-box">\n\t\t\t\t<h3 class="content-caption">The Minto Pyramid Principle\xAE Textbook</h3>\n\t\t\t</div>\n\t\t\t<p class="content-text"><dfn>The Minto Pyramid Principle:  Logic in Writing, Thinking and Problem Solving</dfn> (2010 edition) explains the technique\n\t\t\t\tfor helping you work out and organize your thinking before you attempt to communicate it. In 12 chapters and 3 appendices,\n\t\t\t\tit explains how the pyramid works, how to pull your thinking together to create a pyramid structure, and how to look\n\t\t\t\tcritically at the ideas you assemble so as to glean actual insights from them vs simply presenting them as lists of \u201Creasons\u201D\n\t\t\t\tor \u201Cissues\u201D.</p>\n\t\t\t<p class="content-text">The book also has a section on problem definition and problem analysis, useful in situations where you are writing to\n\t\t\t\tpresent the solution to a problem, or explaining how you will go about solving one</p>\n\t\t\t<p class="content-text">The genius of the Minto Pyramid Principle is that it helps you work efficiently both to formulate your ideas and to organize\n\t\t\t\tthem at the same time. Thus avoiding the need to write countless drafts before you can figure out your message.</p>\n\t\t\t<p class="content-text">The book has become the standard text used by all of the major consulting firms worldwide, many organizations, and some\n\t\t\t\tgovernment offices. It is in fact the book that changed the consulting industry, and the phrase \u201CTake this and make it\n\t\t\t\tMinto\u201D is common in many companies. It has been translated into. . .Chinese, French, German, Japanese, Korean, Portuguese,\n\t\t\t\tand Viet Namese.</p>\n\t\t\t<p class="content-text">The cost of the book is $135 plus postage from New York. Bona fide students wishing to buy the book should e-mail Barbara\n\t\t\t\tMinto directly at barminto@aol.com to apply for a student discount.</p>\n\n\t\t\t<p class="proposal-heading content-text"><b>Note:</b> This book supersedes <dfn>The Pyramid Principle: Logic in Writing and Thinking</dfn> [1987, reissued in London\n\t\t\t\t2002], which consists of 9 chapters and 1 appendix.</p>'
		}
	};

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'contact': {
	        'caption': 'Please use the form to send a message or contact us through the relevant offices.',
	        'adress-1': '<h3 class="contact-adress__head">London Office (MAIN):</h3>\n                    <p class="contact-adress__info">Minto International, Inc.<br>19 Cadogan Place<br>London SW1X 9SA UK<br>Tel: +44 (0)207 235 6274\n                    <!--<br>email: enquiries@barbaraminto.com-->\n                    </p>',
	        'adress-2': '<h3 class="contact-adress__head">Virginia Office:</h3>\n                    <p class="contact-adress__info">\n                        Minto International, Inc.\n                        <br>215 Brooke Avenue. No. 609\n                        <br>Norfolk, VA 23510 USA\n                        <br>Tel: +1 757 425 4511\n                        <!--<br>email: inquiries@barbaraminto.com-->\n                    </p>'
	    }
	};

/***/ }),
/* 448 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'press': {
	        'text': '<div class="content-caption-box">\n                <h3 class="content-caption">Press Inquiries</h3>\n            </div>\n            <h3 class="content-heading">Press contact and press pack download area</h3>\n            <p class="content-text">This area is reserved for press and news agencies who would like further information on the course, the Minto Foundation and materials to use in article and TV. Please <a ui-sref="site.contact">get in contact</a> for further information or comment.\n            </p>'
	    }
	};

/***/ }),
/* 449 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'tc': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">Terms and Conditions</h3>\n      </div>\n      <h4 class="content-text">Privacy and security statement</h4>\n      <p class="content-text">At Minto Books International, Inc. we respect the privacy of every individual who visits our website, communicates with us or purchases our products online. The information you give to us is used to process your order and to provide you with efficient service. We do not trade, rent or sell your details to any third parties. Should our intentions change it will be done only with your authorisation. We will always comply with any data protection legislation currently in force.<br>\n        <br>\n        This statement outlines the information Minto Books International, Inc. will collect from the website and how we will use that information. This statement also lets you know what to do if you want us to remove personal information about you collected or stored during previous visits to the website.\n      </p>\n      <h4 class="content-text">How we collect and use personal information</h4>\n      <p class="content-text">We follow strict security procedures in the collection, storage and disclosure of the information you have given us to prevent unauthorised access and misuse. <br>\n        <br>\n        We do not collect any personally identifying information from you unless you register on the website or purchase our products from the website. In doing, so you expressly consent to expressly consent to the terms and conditions of this statement. Upon receiving your express consent, we only collect such personally identifying information that we specifically need - for example, to send you a brochure, to fulfil an order or to provide account details. Upon receiving your express consent, we only collect such personally identifying information that we specifically need - for example, to send you a brochure, to fulfil an order or to provide account details. <br>\n        <br>\n        If you do not want us to collect any personally identifiable information from you, please do not provide us with any such information. We gather non-specific information on the numbers of visitors to certain areas of our website without asking for your consent to do so, so that website usage can be monitored to help us continually improve the design and layout of our website. <br>\n        <br>\n        If you do provide us with personal information, we may retain and use that information for the following purposes:\n      </p>\n      <ul class="list__content-text">\n        <li>\n          <p class="content-text">We may store and process the information to better understand your needs and how we can improve our products and services\n          </p>\n        </li>\n        <li>\n          <p class="content-text">We may retain information for invoicing and delivery purposes after you make a purchase of our products\n          </p>\n        </li>\n        <li>\n          <p class="content-text">We may retain information about your previous purchases in order to customise our website services for your future visits to the website.\n          </p>\n        </li>\n      </ul>\n      <p class="content-text">In addition, we may use your e-mail address to send you information about new products or special offers which we think may be of interest to you, to advise you of important changes to the website or for other marketing purposes. <br>\n        <br>\n        We may also disclose any information, including personally identifiable information, we deem necessary, in our sole discretion, to comply with any applicable law, regulation, legal process or governmental request. <br>\n        <br>\n        All of your personal information will be stored securely for the duration of your relationship with us and for 5 years thereafter. <br>\n        <br>\n        Personal information provided to us on our website may be transmitted over the Internet. Transfers of personal information may therefore take place, potentially, to any country in the world.\n      </p>\n      <h4 class="content-text">Delivery</h4>\n      <p class="content-text">We aim to despatch all orders within 2 to 7 days if the goods are in stock. In the unlikely event that the goods you order are \u201COut of Stock\u201D, we will contact you to inform you within those 7 days.\n      </p>\n      <h4 class="content-text">Cancellation</h4>\n      <p class="content-text">You can cancel an order and return any goods that may have already been despatched up to 7 days from receipt (see returns policy). Our terms and conditions do not affect your statutory rights.\n      </p>\n      <h4 class="content-text">Returns Policy</h4>\n      <p class="content-text">If you are not satisfied with the purchase of a book or a course (excluding the on-line course) you may return the product unused together with its packaging within 7-days of receipt for a full refund less of any postage costs. Please contact us <a ui-sref="site.contact">here</a> to find out how.\n      </p>'
	  }
	};

/***/ }),
/* 450 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  'policies': {
	    'text': '<div class="content-caption-box">\n        <h3 class="content-caption">Privacy Policy</h3>\n      </div>\n      <p class="content-text">\n        This privacy policy is for this website www.barbaraminto.com and served by Minto Books International, Inc. and governs the privacy of its users who choose to use it.\n        <br>\n        <br>\n        The policy sets out the different areas where user privacy is concerned and outlines the obligations & requirements of the users, the website and website owners. Furthermore the way this website processes, stores and protects user data and information will also be detailed within this policy.\n      </p>\n      <h4 class="content-text">The Website</h4>\n      <p class="content-text">\n        This website and its owners take a proactive approach to user privacy and ensure the necessary steps are taken to protect the privacy of its users throughout their visiting experience. This website complies to all UK national laws and requirements for user privacy.\n      </p>\n      <h4 class="content-text">Use of Cookies</h4>\n      <p class="content-text">This website uses cookies to better the users experience while visiting the website. Where applicable this website uses a cookie control system allowing the user on their first visit to the website to allow or disallow the use of cookies on their computer / device. This complies with recent legislation requirements for websites to obtain explicit consent from users before leaving behind or reading files such as cookies on a user\'s computer / device.<br>\n        <br>\n        Cookies are small files saved to the user\'s computers hard drive that track, save and store information about the user\'s interactions and usage of the website. This allows the website, through its server to provide the users with a tailored experience within this website.<br>\n        <br>\n        Users are advised that if they wish to deny the use and saving of cookies from this website on to their computers hard drive they should take necessary steps within their web browsers security settings to block all cookies from this website and its external serving vendors.<br>\n        <br>\n        This website uses tracking software to monitor its visitors to better understand how they use it. This software is provided by Google Analytics which uses cookies to track visitor usage. The software will save a cookie to your computers hard drive in order to track and monitor your engagement and usage of the website, but will not store, save or collect personal information. You can read Google\'s privacy policy here for further information <a href="http://www.google.com/privacy.html" target="_blank">http://www.google.com/privacy.html</a>.<br>\n        <br>\n        Other cookies may be stored to your computers hard drive by external vendors when this website uses referral programs, sponsored links or adverts. Such cookies are used for conversion and referral tracking and typically expire after 30 days, though some may take longer. No personal information is stored, saved or collected.\n      </p>\n      <h4 class="content-text">Contact & Communication</h4>\n      <p class="content-text">Users contacting this website and/or its owners do so at their own discretion and provide any such personal details requested at their own risk. Your personal information is kept private and stored securely until a time it is no longer required or has no use, as detailed in the Data Protection Act 1998. Every effort has been made to ensure a safe and secure form to email submission process but advise users using such form to email processes that they do so at their own risk.<br>\n        <br>\n        This website and its owners use any information submitted to provide you with further information about the products / services they offer or to assist you in answering any questions or queries you may have submitted. This includes using your details to subscribe you to any email newsletter program the website operates but only if this was made clear to you and your express permission was granted when submitting any form to email process. Or whereby you the consumer have previously purchased from or enquired about purchasing from the company a product or service that the email newsletter relates to. This is by no means an entire list of your user rights in regard to receiving email marketing material. Your details are not passed on to any third parties.\n      </p>\n      <h4 class="content-text">Email Newsletter</h4>\n      <p class="content-text">This website operates an email newsletter program, used to inform subscribers about products and services supplied by this website. Users can subscribe through an online automated process should they wish to do so but do so at their own discretion. Some subscriptions may be manually processed through prior written agreement with the user.<br>\n        <br>\n        Subscriptions are taken in compliance with UK Spam Laws detailed in the Privacy and Electronic Communications Regulations 2003. All personal details relating to subscriptions are held securely and in accordance with the Data Protection Act 1998. No personal details are passed on to third parties nor shared with companies / people outside of the company that operates this website. Under the Data Protection Act 1998 you may request a copy of personal information held about you by this website\'s email newsletter program. A small fee will be payable. If you would like a copy of the information held on you please write to the business address at the bottom of this policy.<br>\n        <br>\n        Email marketing campaigns published by this website or its owners may contain tracking facilities within the actual email. Subscriber activity is tracked and stored in a database for future analysis and evaluation. Such tracked activity may include; the opening of emails, forwarding of emails, the clicking of links within the email content, times, dates and frequency of activity [this is by no far a comprehensive list].<br>\n        <br>\n        This information is used to refine future email campaigns and supply the user with more relevant content based around their activity.<br>\n        <br>\n        In compliance with UK Spam Laws and the Privacy and Electronic Communications Regulations 2003 subscribers are given the opportunity to un-subscribe at any time through an automated system. This process is detailed at the footer of each email campaign. If an automated un-subscription system is unavailable clear instructions on how to un-subscribe will by detailed instead.\n      </p>\n      <h4 class="content-text">External Links</h4>\n      <p class="content-text">Although this website only looks to include quality, safe and relevant external links, users are advised adopt a policy of caution before clicking any external web links mentioned throughout this website. (External links are clickable text / banner / image links to other websites, similar to; Folded Book Art or Cottages in Pembrokeshire.)<br>\n        <br>\n        The owners of this website cannot guarantee or verify the contents of any externally linked website despite their best efforts. Users should therefore note they click on external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned.\n      </p>\n      <h4 class="content-text">Adverts and Sponsored Links</h4>\n      <p class="content-text">This website may contain sponsored links and adverts. These will typically be served through our advertising partners, to whom may have detailed privacy policies relating directly to the adverts they serve.<br>\n        <br>\n        Clicking on any such adverts will send you to the advertisers website through a referral program which may use cookies and will track the number of referrals sent from this website. This may include the use of cookies which may in turn be saved on your computers hard drive. Users should therefore note they click on sponsored external links at their own risk and this website and its owners cannot be held liable for any damages or implications caused by visiting any external links mentioned.\n      </p>\n      <h4 class="content-text">Social Media Platforms</h4>\n      <p class="content-text">Communication, engagement and actions taken through external social media platforms that this website and its owners participate on are custom to the terms and conditions as well as the privacy policies held with each social media platform respectively.<br>\n        <br>\n        Users are advised to use social media platforms wisely and communicate / engage upon them with due care and caution in regard to their own privacy and personal details. This website nor its owners will ever ask for personal or sensitive information through social media platforms and encourage users wishing to discuss sensitive details to contact them through primary communication channels such as by telephone or email.<br>\n        <br>\n        This website may use social sharing buttons which help share web content directly from web pages to the social media platform in question. Users are advised before using such social sharing buttons that they do so at their own discretion and note that the social media platform may track and save your request to share a web page respectively through your social media platform account.\n      </p>\n      <h4 class="content-text">Shortened Links in Social Media</h4>\n      <p class="content-text">This website and its owners through their social media platform accounts may share web links to relevant web pages. By default some social media platforms shorten lengthy urls [web addresses].<br>\n        <br>\n        Users are advised to take caution and good judgement before clicking any shortened urls published on social media platforms by this website and its owners. Despite the best efforts to ensure only genuine urls are published many social media platforms are prone to spam and hacking and therefore this website and its owners cannot be held liable for any damages or implications caused by visiting any shortened links.\n      </p>'
	  }
	};

/***/ }),
/* 451 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'nav': {
	        'concept': 'Concept',
	        'live_course': 'Live Course',
	        'online_course': 'Online Course',
	        'workbook_course': 'Workbook Course',
	        'summary_app': 'Summary App',
	        'textbook': 'Minto Textbook',
	        'barbara_minto': 'Barbara Minto',
	        'contact': 'Contact'
	    }
	};

/***/ }),
/* 452 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'header': {
	        'barbara_minto': 'Barbara Minto',
	        'concept': 'Pyramid Concept',
	        'contact': 'Contact',
	        'corporate_inquiry': 'Corporate Inquiry',
	        'liveMintoCourse': 'Live Minto Course',
	        'policies': 'Policies',
	        'summary': 'Barbara in your pocket',
	        'press': 'Press',
	        'T&Cs': 'T&Cs',
	        'textbook': 'Textbook',
	        'workbook': 'Original Workbook Course',
	        'login': 'Log In',
	        'buy': 'Buy the course',
	        'testimonials': 'Testimonials',
	        'online': 'Online Course',
	        'error404': 'Error 404',
	        'dashboard': '',
	        'thankYou': 'Thank You',
	        'paymentFailure': 'Payment Failure'
	    }
	};

/***/ }),
/* 453 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    'footer': {
	        'logOut': 'Log Out',
	        'logIn': 'Log',
	        'tc': 'T & C',
	        'share': 'Compartir',
	        'language': 'Language',
	        'policies': 'Policies',
	        'press': 'Press',
	        'error404': 'Error 404'
	    }
	};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.APIEndpoint = APIEndpoint;
	exports.GlobalRedirects = GlobalRedirects;
	function APIEndpoint() {
	    var endpoind = 'http://localhost:5001/v1';
	    // const endpoind = 'https://minto-codeconcept.tk';
	    //const endpoind = 'https://api-barbaraminto.i2mdev.com';
	    return endpoind;
	};
	
	function GlobalRedirects() {
	    var rules = {
	        AFTER_LOGIN: 'site.dashboard',
	        AFTER_LOGOUT: 'auth.login',
	        LOGIN: 'auth.login'
	    };
	    return rules;
	};

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	InterceptorsService.$inject = ["$cookies", "APIEndpoint"];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.InterceptorsService = InterceptorsService;
	function InterceptorsService($cookies, APIEndpoint) {
	    'ngInject';
	
	    var interceptors = {
	        request: function request(config) {
	            var token = $cookies.get('authToken');
	
	            // Add token
	            // and API endpoint to request
	            if (config.url.indexOf('http') === -1 && config.url.indexOf('api') > 0) {
	                if (token) {
	                    config.headers['Auth-Token'] = token;
	                }
	                config.url = '' + APIEndpoint + config.url;
	            }
	
	            return config;
	        }
	    };
	
	    return interceptors;
	}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _api = __webpack_require__(457);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _auth = __webpack_require__(458);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _course = __webpack_require__(460);
	
	var _course2 = _interopRequireDefault(_course);
	
	var _helper = __webpack_require__(492);
	
	var _helper2 = _interopRequireDefault(_helper);
	
	var _diagram = __webpack_require__(493);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _audio = __webpack_require__(494);
	
	var _audio2 = _interopRequireDefault(_audio);
	
	var _pyramidBuilder = __webpack_require__(495);
	
	var _pyramidBuilder2 = _interopRequireDefault(_pyramidBuilder);
	
	var _user = __webpack_require__(496);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _courseVideo = __webpack_require__(497);
	
	var _courseVideo2 = _interopRequireDefault(_courseVideo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var services = _angular2.default.module('minto.services', []);
	
	services.service('apiService', _api2.default);
	services.service('courseService', _course2.default);
	services.service('authService', _auth2.default);
	services.service('helperService', _helper2.default);
	services.service('diagramService', _diagram2.default);
	services.service('audioService', _audio2.default);
	services.service('pyramidBuilderService', _pyramidBuilder2.default);
	services.service('userService', _user2.default);
	services.service('courseVideoService', _courseVideo2.default);
	
	exports.default = services;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(209);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApiService = function () {
	    ApiService.$inject = ["$http", "$q", "$cookies"];
	    function ApiService($http, $q, $cookies) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, ApiService);
	        (0, _assign2.default)(this, { $http: $http, $q: $q, $cookies: $cookies });
	
	        this.data = {};
	    }
	
	    (0, _createClass3.default)(ApiService, [{
	        key: 'get',
	        value: function get(params) {
	            var _this = this;
	
	            return this.$http.get(params.url, (0, _extends3.default)({
	                headers: {
	                    'Authorization': 'Bearer ' + this.token
	                }
	            }, params.config)).then(function (response) {
	                _this.storeData(params.name, response.data);
	
	                if (response && response.data && response.data.value) return response.data.value;
	
	                return response.data;
	            }).catch(function (error) {
	                if (error.status == 401) _this.clearUserData();
	
	                console.log(error);
	                error;
	            });
	        }
	    }, {
	        key: 'put',
	        value: function put(params) {
	            var _this2 = this;
	
	            return this.$http.put(params.url, params.data, (0, _extends3.default)({
	                headers: {
	                    'Authorization': 'Bearer ' + this.token
	                }
	            }, params.config)).then(function (response) {
	                _this2.storeData(params.name, response.data);
	                return response.data;
	            }).catch(function (error) {
	                if (error.status == 401) _this2.clearUserData();
	
	                console.log(error);
	                error;
	            });
	        }
	    }, {
	        key: 'patch',
	        value: function patch(params) {
	            var _this3 = this;
	
	            return this.$http.patch(params.url, params.data, (0, _extends3.default)({
	                headers: {
	                    'Authorization': 'Bearer ' + this.token
	                }
	            }, params.config)).then(function (response) {
	                _this3.storeData(params.name, response.data);
	                return response.data;
	            }).catch(function (error) {
	                if (error.status == 401) _this3.clearUserData();
	
	                console.log(error);
	                error;
	            });
	        }
	    }, {
	        key: 'post',
	        value: function post(params) {
	            var _this4 = this;
	
	            return this.$http.post(params.url, params.data, (0, _extends3.default)({
	                headers: {
	                    'Authorization': 'Bearer ' + this.token
	                }
	            }, params.config)).then(function (response) {
	                _this4.storeData(params.name, response.data);
	                return response.data;
	            }).catch(function (error) {
	                if (error.status == 401) _this4.clearUserData();
	
	                console.log(error);
	                error;
	            });
	        }
	    }, {
	        key: 'storeData',
	        value: function storeData(k, v) {
	            this.data[k] = v;
	        }
	    }, {
	        key: 'getData',
	        value: function getData() {
	            return this.data;
	        }
	    }, {
	        key: 'clearUserData',
	        value: function clearUserData() {
	            this.$cookies.remove(_environment.environment.userData);
	        }
	    }, {
	        key: 'token',
	        get: function get() {
	            if (!this.userData) return null;
	
	            return this.userData.token;
	        }
	    }, {
	        key: 'userData',
	        get: function get() {
	            var dataOut = this.$cookies.get(_environment.environment.userData);
	
	            if (!dataOut) return null;
	
	            var userData = JSON.parse(dataOut);
	            return userData;
	        }
	    }]);
	    return ApiService;
	}();
	
	exports.default = ApiService;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(210);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(459);
	
	var _environment = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuthService = function () {
	    AuthService.$inject = ["apiService", "$q", "$cookies", "$state", "GlobalRedirects", "userService", "$rootScope"];
	    (0, _createClass3.default)(AuthService, [{
	        key: 'userId',
	        get: function get() {
	            if (!this.userData) return null;
	
	            return this.userData.id;
	        }
	    }, {
	        key: 'token',
	        get: function get() {
	            if (!this.userData) return null;
	
	            return this.userData.token;
	        }
	    }, {
	        key: 'userData',
	        get: function get() {
	            var dataOut = this.$cookies.get(_environment.environment.userData);
	
	            if (null == dataOut) return null;
	
	            var userData = JSON.parse(dataOut);
	            return userData;
	        }
	    }, {
	        key: 'authenticated',
	        get: function get() {
	            return this.userData != null;
	        }
	    }]);
	
	    function AuthService(apiService, $q, $cookies, $state, GlobalRedirects, userService, $rootScope) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, AuthService);
	        this.user = null;
	        (0, _assign2.default)(this, { apiService: apiService, $q: $q, $cookies: $cookies, $state: $state, GlobalRedirects: GlobalRedirects, userService: userService, $rootScope: $rootScope });
	    }
	
	    /**
	     * Use this for protect pages
	     * from non login users
	     */
	
	
	    (0, _createClass3.default)(AuthService, [{
	        key: 'protectRoute',
	        value: function protectRoute() {
	            return this.$q.resolve(this.authenticated);
	        }
	    }, {
	        key: 'login',
	        value: function login(data) {
	            var _this = this;
	
	            return this.apiService.post({
	                url: _constants.Constants.authenticationUrl,
	                name: 'login',
	                data: data
	            }).then(function (data) {
	                _this.storeUserData(data);
	                return data;
	            }).catch(function (error) {
	                console.log(error);
	                return _this.$q.resolve(false);
	            });
	        }
	    }, {
	        key: 'getUser',
	        value: function getUser(token, update) {
	            return this.userData;
	        }
	    }, {
	        key: 'register',
	        value: function register(data) {
	            return this.apiService.post({
	                url: _constants.Constants.registrationsUrl,
	                name: 'register',
	                data: data
	            });
	        }
	    }, {
	        key: 'storeUserData',
	        value: function storeUserData(data) {
	            this.$cookies.put(_environment.environment.userData, (0, _stringify2.default)(data));
	            this.$rootScope.userEmail = data.email;
	            this.userService.storeUserData(data);
	        }
	    }, {
	        key: 'logOut',
	        value: function logOut() {
	            this.$cookies.remove(_environment.environment.userData);
	            this.$state.go(this.GlobalRedirects.AFTER_LOGOUT);
	        }
	    }]);
	    return AuthService;
	}();
	
	exports.default = AuthService;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Constants = undefined;
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _environment = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Constants = exports.Constants = function Constants() {
	  (0, _classCallCheck3.default)(this, Constants);
	};
	
	Constants.authenticationUrl = _environment.environment.api + '/authenticate';
	Constants.usersUrl = _environment.environment.api + '/users';
	Constants.usersResetPasswordUrl = _environment.environment.api + '/users/resetpassword';
	Constants.coursesUrl = _environment.environment.api + '/courses?$expand=sections($expand=units($expand=exercises))';
	Constants.progressesUrl = _environment.environment.api + '/progresses';
	Constants.statisticsUrl = _environment.environment.api + '/statistics';
	Constants.exerciseAnswersUrl = _environment.environment.api + '/exerciseanswers';
	Constants.diagramContainersUrl = _environment.environment.api + '/diagramcontainers';
	
	Constants.progressUrl = function (id) {
	  return Constants.progressesUrl + '/' + id;
	};
	
	Constants.exercisesUrl = _environment.environment.api + '/exercises';
	Constants.registrationsUrl = _environment.environment.api + '/registrations';
	Constants.videos = {
	  testDriveUrl: _environment.environment.videosUrl + '/TestDrive.mp4',
	  course: {
	    // 1
	    imposingTheStructure: 'Lecture 1A_Imposing the Structure_11.08.20.mp4',
	    pickingOutThePoints: 'Lecture 1B_Cementing the Rules_11.08.20.mp4',
	    cementingTheRules: 'Lecture 1C_Picking Out the Points_12.08.20.mp4',
	    graspingTheMessage_1: 'Lecture 1D - Grasping the Message_13.08.20.mp4',
	    graspingTheMessage_2: 'Lecture 1D-2_Finding the Summary Point_27.08.20.mp4',
	    // 2
	    ideasFitTogether_1: 'Lecture 2A_How the Ideas Fit Together_31.08.20.mp4',
	    ideasFitTogether_2: 'Lecture 2A - 2_Identify First Idea_07.09.20.mp4',
	    creatingQuestion: 'Lecture 2B_Creating a Question Answer Dialogue_12.09.20.mp4',
	    // 3
	    deductiveReasoning: 'Lecture 3A - 1_ Deductive Arguments_12.09.20.mp4',
	    inductiveReasoning: 'Lecture 3B - 1_ Inductive Reasoning_13.09.20.mp4',
	    deductionToInduction: 'Lecture 3B - 4_Transforming Deduction to Induction_14.09.20.mp4',
	    avoidingDeductiveArguments: 'Lecture 3C_Avoiding Deductive Arguments_14.09.20.mp4',
	    // 4
	    practiceInSeeing: 'Lecture 4A_Introductions - Reading to Get the Rhythm_16.09.20.mp4',
	    findingReadersQuestion: 'Lecture 4B - 1_Seeing the SCQ Structure_22.09.20.mp4',
	    spottingSCQ: 'Lecture 4B-2_Finding the Reader_s Question_22.09.20.mp4',
	    applyingSCQProcess: 'Lecture 4C-1_Applying the SCQ Process_23.09.20.mp4',
	    practiceInSeeing3: 'Lecture 4C-2_Field_Sales_Meeting_22.11.20.mp4',
	    // 5
	    defineProblem: 'Lecture 5A_How to Define a Problem_27.09.20.mp4',
	    practiceDefiningProblem: 'Lecture 5B_Defining the Problem_27.09.20.mp4',
	    definingMoreComplexProblems: 'Lecture 5C_Converting an Introduction_27.09.20.mp4',
	    writingAGoodProposal: 'Lecture 5D_Writing Proposals and Project Plans_29.09.20.mp4'
	  }
	};

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(210);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _extends2 = __webpack_require__(209);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(206);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(156);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _regenerator = __webpack_require__(461);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _toConsumableArray2 = __webpack_require__(464);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _promise = __webpack_require__(465);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _slicedToArray2 = __webpack_require__(482);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _asyncToGenerator2 = __webpack_require__(489);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _lodash = __webpack_require__(490);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _constants = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var routeNames = {
	    // 1
	    'course.imposingTheStructure': '1a',
	    'course.cementingTheRules': '1c',
	    'course.pickingOutThePoints': '1b',
	    'course.graspingTheMessage': '1d',
	    // 2
	    'course.ideasFitTogether': '2a',
	    'course.creatingQuestion': '2b',
	    // 3
	    'course.deductiveReasoning': '3a1',
	    'course.summarizingDeductive': '3a2',
	    'course.unearthingEmbeddedArguments': '3a3',
	    'course.inductiveReasoning': '3b1',
	    'course.identifyingInductivePoints': '3b2',
	    'course.inductionFromDeduction': '3b3',
	    'course.deductionToInduction': '3b4',
	    'course.avoidingDeductiveArguments': '3c',
	    // 'course.supportingPoints': '3zero',
	    // 4
	    'course.practiceInSeeing': '4a',
	    'course.findingReadersQuestion': '4b1',
	    'course.spottingSCQ': '4b2',
	    'course.applyingSCQProcess': '4c1',
	    'course.practiceInSeeing3': '4c2',
	    // 5
	    'course.defineProblem': '5a',
	    'course.practiceDefiningProblem': '5b',
	    'course.definingMoreComplexProblems': '5c',
	    'course.writingAGoodProposal': '5d'
	};
	
	var CourseService = function () {
	    CourseService.$inject = ["apiService", "$q", "audioService", "authService", "$state"];
	    function CourseService(apiService, $q, audioService, authService, $state) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, CourseService);
	        (0, _assign2.default)(this, { apiService: apiService, $q: $q, audioService: audioService, authService: authService, $state: $state, routeNames: routeNames });
	
	        this.user = null;
	        this.coursesData = null;
	    }
	
	    (0, _createClass3.default)(CourseService, [{
	        key: 'play',
	        value: function play(effect) {
	            this.audioService.play(effect);
	        }
	    }, {
	        key: 'getCourseData',
	        value: function getCourseData() {
	            var _this = this;
	
	            var currentRoute = this.$state.current.name;
	            var courseId = 0;
	
	            var getCourseInfo = function getCourseInfo(id, routeName) {
	                var course = _this.coursesData.find(function (i) {
	                    return i.id === id;
	                });
	                if (!course) {
	                    return null;
	                }
	                var unitName = _this.routeNames[routeName];
	                return course.units.find(function (i) {
	                    return i.name === unitName;
	                }) || null;
	            };
	            if (['course.imposingTheStructure', 'course.pickingOutThePoints', 'course.cementingTheRules', 'course.graspingTheMessage'].includes(currentRoute)) {
	                courseId = 24;
	            } else if (['course.ideasFitTogether', 'course.creatingQuestion'].includes(currentRoute)) {
	                courseId = 25;
	            } else if (['course.deductiveReasoning', 'course.summarizingDeductive', 'course.unearthingEmbeddedArguments', 'course.inductiveReasoning', 'course.identifyingInductivePoints', 'course.inductionFromDeduction', 'course.deductionToInduction', 'course.avoidingDeductiveArguments'].includes(currentRoute)) {
	                courseId = 26;
	            } else if (['course.practiceInSeeing', 'course.findingReadersQuestion', 'course.spottingSCQ', 'course.applyingSCQProcess', 'course.practiceInSeeing3'].includes(currentRoute)) {
	                courseId = 27;
	            } else if (['course.defineProblem', 'course.practiceDefiningProblem', 'course.definingMoreComplexProblems', 'course.writingAGoodProposal'].includes(currentRoute)) {
	                courseId = 28;
	            }
	            return getCourseInfo(courseId, this.$state.current.name);
	        }
	    }, {
	        key: 'getAll',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	                var _ref2, _ref3, courses, userAnswers, courseData, exercises;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                _context.next = 2;
	                                return _promise2.default.all([this.apiService.get({
	                                    url: _constants.Constants.coursesUrl,
	                                    name: 'courses'
	                                }), this.apiService.get({
	                                    url: _constants.Constants.exerciseAnswersUrl + '?&$filter=userId eq ' + this.authService.userId,
	                                    name: 'exercise_answers'
	                                })]);
	
	                            case 2:
	                                _ref2 = _context.sent;
	                                _ref3 = (0, _slicedToArray3.default)(_ref2, 2);
	                                courses = _ref3[0];
	                                userAnswers = _ref3[1];
	                                courseData = courses[0].sections;
	
	                                this.coursesData = courseData;
	                                exercises = courseData.reduce(function (arr, item) {
	                                    return [].concat((0, _toConsumableArray3.default)(arr), (0, _toConsumableArray3.default)(item.units.reduce(function (arr, item) {
	                                        return [].concat((0, _toConsumableArray3.default)(arr), (0, _toConsumableArray3.default)(_lodash2.default.get(item, 'exercises', [])));
	                                    }, [])));
	                                }, []);
	
	                                userAnswers.forEach(function (i) {
	                                    var exercise = exercises.find(function (item) {
	                                        return item.id === i.exerciseId;
	                                    });
	
	                                    if (!exercise) return;
	
	                                    exercise.isCompleted = true;
	                                    exercise.userAnswers = JSON.parse(i.value);
	                                });
	                                return _context.abrupt('return', courses);
	
	                            case 11:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function getAll() {
	                return _ref.apply(this, arguments);
	            }
	
	            return getAll;
	        }()
	    }, {
	        key: 'buildFormData',
	        value: function buildFormData(formData, data, parentKey) {
	            var _this2 = this;
	
	            if (data && (typeof data === 'undefined' ? 'undefined' : (0, _typeof3.default)(data)) === 'object' && !(data instanceof Date) && !(data instanceof File)) {
	                (0, _keys2.default)(data).forEach(function (key) {
	                    _this2.buildFormData(formData, data[key], parentKey ? parentKey + '[' + key + ']' : key);
	                });
	            } else {
	                var value = data == null ? '' : data;
	
	                formData.append(parentKey, value);
	            }
	        }
	    }, {
	        key: 'jsonToFormData',
	        value: function jsonToFormData(data) {
	            var formData = new FormData();
	
	            this.buildFormData(formData, data);
	
	            return formData;
	        }
	    }, {
	        key: 'sendUserStatistic',
	        value: function () {
	            var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dataIn) {
	                var data, response;
	                return _regenerator2.default.wrap(function _callee2$(_context2) {
	                    while (1) {
	                        switch (_context2.prev = _context2.next) {
	                            case 0:
	                                data = (0, _extends3.default)({}, dataIn, { userId: this.authService.userId });
	
	                                console.log("sendUserStatistic", data);
	                                _context2.next = 4;
	                                return this.apiService.post({
	                                    url: _constants.Constants.statisticsUrl,
	                                    name: 'statistics',
	                                    data: data
	                                });
	
	                            case 4:
	                                response = _context2.sent;
	                                return _context2.abrupt('return', response);
	
	                            case 6:
	                            case 'end':
	                                return _context2.stop();
	                        }
	                    }
	                }, _callee2, this);
	            }));
	
	            function sendUserStatistic(_x) {
	                return _ref4.apply(this, arguments);
	            }
	
	            return sendUserStatistic;
	        }()
	    }, {
	        key: 'sendUserAnswers',
	        value: function () {
	            var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dataIn) {
	                var data, response;
	                return _regenerator2.default.wrap(function _callee3$(_context3) {
	                    while (1) {
	                        switch (_context3.prev = _context3.next) {
	                            case 0:
	                                data = (0, _extends3.default)({}, dataIn, { userId: this.authService.userId });
	
	                                console.log("sendUserAnswers", data);
	                                _context3.next = 4;
	                                return this.apiService.post({
	                                    url: _constants.Constants.exerciseAnswersUrl,
	                                    name: 'exercise_answers',
	                                    data: data
	                                });
	
	                            case 4:
	                                response = _context3.sent;
	                                return _context3.abrupt('return', response);
	
	                            case 6:
	                            case 'end':
	                                return _context3.stop();
	                        }
	                    }
	                }, _callee3, this);
	            }));
	
	            function sendUserAnswers(_x2) {
	                return _ref5.apply(this, arguments);
	            }
	
	            return sendUserAnswers;
	        }()
	    }, {
	        key: 'getProgress',
	        value: function getProgress() {
	            var _this3 = this;
	
	            return this.apiService.get({
	                url: _constants.Constants.progressesUrl,
	                name: 'courseProgress'
	            }).then(function (data) {
	                _this3.progresses = data;
	                return data;
	            });
	        }
	
	        // Unused code
	        // updateProgress ( id )
	        // {
	        //     return this.apiService.put( {
	        //         url: Constants.progressUrl( id ),
	        //         name: 'courseProgress'
	        //     } )
	        //         .then( data =>
	        //         {
	        //             this.progresses = data;
	        //         } );
	        // }
	
	        //Unused code
	        // postStatistic ( params )
	        // {
	        //     // console.log(params)
	        // }
	
	    }, {
	        key: 'getDiagramContainer',
	        value: function getDiagramContainer() {
	            var _this4 = this;
	
	            return this.apiService.get({
	                url: _constants.Constants.diagramContainersUrl,
	                name: 'diagramContainers'
	            }).then(function (data) {
	                if (!data.info) {
	                    data.info = '{}';
	                }
	                JSON.parse(data.info);
	                _this4.diagramContainer = {};
	
	                return _this4.diagramContainer;
	            });
	        }
	    }, {
	        key: 'updateDiagramContainer',
	        value: function updateDiagramContainer(id, data) {
	            this.diagramContainer[id] = data;
	            return this.apiService.put({
	                data: { 'diagram_container[info]': (0, _stringify2.default)(this.diagramContainer) },
	                url: _constants.Constants.diagramContainersUrl,
	                name: 'diagramContainers'
	            }).then(function (data) {
	                // this.diagramContainer = JSON.parse(data.info);
	            }).catch(function (data) {
	                console.log(data);
	            });
	        }
	    }]);
	    return CourseService;
	}();
	
	exports.default = CourseService;

/***/ }),
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelperService = function () {
	  HelperService.$inject = ["authService", "$translate", "apiService", "$cookies", "$q"];
	  function HelperService(authService, $translate, apiService, $cookies, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HelperService);
	    (0, _assign2.default)(this, { authService: authService, $translate: $translate, apiService: apiService, $cookies: $cookies, $q: $q });
	  }
	
	  (0, _createClass3.default)(HelperService, [{
	    key: 'initIntercom',
	    value: function initIntercom() {
	      // this.authService.getUser()
	      //   .then(data => {
	      //     window.Intercom("boot", {
	      //       app_id: "xhwiyx1c",
	      //       name: data.first_name,
	      //       email: data.email,
	      //       hide_default_launcher: hideFlag
	      //     });
	      //   });
	
	      var hideFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    }
	  }, {
	    key: 'shutdownIntercom',
	    value: function shutdownIntercom() {
	      var hideFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      window.Intercom("shutdown");
	    }
	  }, {
	    key: 'getCurrentLang',
	    value: function getCurrentLang() {
	      var lang = void 0;
	      if (angular.isUndefined(this.$cookies.get('lang'))) {
	        lang = 'en';
	      } else {
	        lang = this.$cookies.get('lang');
	      }
	      return this.$q.resolve(lang);
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage(key) {
	      this.$cookies.put('lang', key);
	      this.$translate.use(key);
	    }
	  }, {
	    key: 'sendEmail',
	    value: function sendEmail(data) {
	      return this.apiService.post({
	        url: '/api/v1/emails',
	        data: data
	      });
	    }
	  }]);
	  return HelperService;
	}();
	
	exports.default = HelperService;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _from = __webpack_require__(197);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _uiHelper = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var bool = true;
	
	var DiagramService = function () {
	    DiagramService.$inject = ["$q", "$localStorage", "$timeout", "audioService", "$interval"];
	    function DiagramService($q, $localStorage, $timeout, audioService, $interval) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, DiagramService);
	        this.slotBoxes = {};
	
	        (0, _assign2.default)(this, { $q: $q, $timeout: $timeout, audioService: audioService, $interval: $interval });
	    }
	
	    (0, _createClass3.default)(DiagramService, [{
	        key: 'init',
	        value: function init(diagramId, submitBtn, nextBtn, diagramNumber) {
	            var demo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	            var _ref = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
	                _ref$slotsQuery = _ref.slotsQuery,
	                slotsQuery = _ref$slotsQuery === undefined ? 'div:not(.fixed-answer, .empty-draggable-box, .element-arr, .long-arr, .long-arr-part1, .long-arr-part2, .long-arr-part1 .empty-box)' : _ref$slotsQuery;
	
	            this.initDiagram(diagramId, diagramNumber, demo, { slotsQuery: slotsQuery });
	        }
	    }, {
	        key: 'initDraggableList',
	        value: function initDraggableList(diagramId, submitBtn, nextBtn, diagramNumber) {
	            var demo = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	            var _ref2 = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {},
	                _ref2$slotsQuery = _ref2.slotsQuery,
	                slotsQuery = _ref2$slotsQuery === undefined ? 'div:not(.fixed-answer, .empty-draggable-box, .element-arr, .long-arr, .long-arr-part1, .long-arr-part2, .long-arr-part1 .empty-box)' : _ref2$slotsQuery;
	
	            this.draggableList(diagramId, diagramNumber, demo, { slotsQuery: slotsQuery });
	        }
	    }, {
	        key: 'initDiagram',
	        value: function initDiagram(diagramId, diagramNumber, demo, _ref3) {
	            var slotsQuery = _ref3.slotsQuery;
	
	            var self = this;
	
	            $('#' + diagramId + ' .element').each(function (i) {
	                $(this).data('number', $(this).attr('id').replace('element_' + diagramNumber + '_', '')).draggable({
	                    containment: '#' + diagramId,
	                    cursor: 'hand',
	                    scroll: false,
	                    disabled: demo,
	                    revert: function revert(event, ui) {
	                        $(this).data("uiDraggable").originalPosition = {
	                            top: 0,
	                            left: 0
	                        };
	                        return !event;
	                    }
	                });
	                this.setAttribute('data-index', Math.floor(Math.random() * (10000 - 0)));
	            });
	
	            $('#' + diagramId + ' #slots').find(slotsQuery).each(function () {
	                $(this).data('number', $(this).attr('id').replace('slot_' + diagramNumber + '_', '')).droppable({
	                    hoverClass: 'hovered',
	                    drop: function drop(event, ui) {
	                        self.audioService.play('tab');
	                        ui.draggable.removeClass('ui-draggable-dragging');
	
	                        var slotNumber = $(this).data('number');
	                        var elementNumber = ui.draggable.data('number');
	                        var currentElement = ui.draggable[0];
	                        var answer = $(ui.draggable[0]);
	                        var oldElement = this.classList.value.split(' ').find(function (item) {
	                            return item.indexOf('answer--') > -1;
	                        });
	
	                        if (slotNumber == elementNumber) {
	                            currentElement.setAttribute('data-answer', 'correct');
	                        } else {
	                            currentElement.setAttribute('data-answer', 'wrong');
	                        }
	
	                        if (oldElement) {
	                            var index = oldElement.split('--')[1];
	                            var elemetn = $($('td').find('.element[data-index="' + index + '"]')[0]);
	
	                            elemetn.animate({
	                                top: '3px',
	                                left: '0px'
	                            });
	                            $(this).removeClass(oldElement);
	                        }
	
	                        answer.data('index') == $(this).data('index') ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');
	
	                        $(this).addClass('answer--' + answer.data('index'));
	
	                        var ansverPosition = function ansverPosition() {
	                            ui.draggable.position({
	                                of: $(this),
	                                my: 'center',
	                                at: 'center'
	                            });
	                        };
	                        setTimeout($.proxy(ansverPosition, $(this)), 300);
	                    },
	
	                    out: function out(event, ui) {
	                        var answer = $(ui.draggable[0]);
	                        var container = $(this);
	                        var index = answer.data('index');
	                        var currentElement = ui.draggable[0];
	
	                        currentElement.setAttribute('data-answer', '');
	                        currentElement.classList.remove('correct', 'wrong');
	
	                        $(this).removeClass(ui.draggable[0].id);
	
	                        if (container.hasClass('answer--' + index)) {
	                            container.removeClass('answer--' + $(ui.draggable[0]).data('index'));
	                            container.removeClass('answer__incorrect');
	                            container.removeClass('answer__correct');
	                        }
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'clearScrollHandler',
	        value: function clearScrollHandler() {
	            this.$interval.cancel(this.interval);
	        }
	    }, {
	        key: 'initSCQDiagram',
	        value: function initSCQDiagram(id, dragginOutside, first) {
	            var _this = this;
	
	            if (first) {
	                this.interval = this.$interval(function () {
	                    var position = window.scrollY;
	                    if (_this.scrollUp) {
	                        window.scrollTo(0, position - 10);
	                    } else if (_this.scrollDown) {
	                        window.scrollTo(0, position + 10);
	                    }
	                }, 30);
	            }
	
	            var self = this;
	            var draggableOptions = {
	                cursor: 'hand',
	                scroll: false,
	                revert: function revert(event, ui) {
	                    $(this).data("uiDraggable").originalPosition = {
	                        top: 0,
	                        left: 0
	                    };
	                    return !event;
	                },
	                drag: function drag(event, ui) {
	                    // handle 4b2 exercises
	                    if (window.location.href.includes('4b2')) {
	                        try {
	                            var dragbleSize = parseInt(event.target.style.height.replace('px', '')) * 1.3 + 'px';
	                            var parentMaxSize = event.target.parentElement.offsetHeight + 'px';
	                            if (_this.dragbleSize) {
	                                event.target.parentElement.style.height = _this.parentMaxSize;
	                                event.target.style.height = _this.dragbleSize;
	                            } else {
	                                _this.dragbleSize = dragbleSize;
	                                _this.parentMaxSize = parentMaxSize;
	                                event.target.parentElement.style.height = parentMaxSize;
	                                event.target.style.height = dragbleSize;
	                            }
	                        } catch (e) {}
	                    }
	                    var screen = $(window).innerHeight();
	                    if (event.screenY >= screen * 0.9) {
	                        _this.scrollUp = false;
	                        _this.scrollDown = true;
	                    } else if (event.screenY <= screen * 0.3) {
	                        _this.scrollUp = true;
	                        _this.scrollDown = false;
	                    } else {
	                        _this.scrollUp = false;
	                        _this.scrollDown = false;
	                    }
	                },
	                stop: function stop(event, ui) {
	                    if (window.location.href.includes('4b2') && !$(event.target).hasClass('simplest__structure-answer--dropped')) {
	                        event.target.style.height = '100%';
	                    }
	                    _this.scrollUp = false;
	                    _this.scrollDown = false;
	                }
	            };
	
	            if (!dragginOutside) {
	                draggableOptions.containment = '#' + id;
	            }
	
	            $('#' + id + ' .simplest__structure-answer').each(function (i, element) {
	                return $(element).draggable(draggableOptions);
	            });
	
	            $('#' + id + ' .simplest__structure-box').each(function (i, element) {
	                $(this).droppable({
	                    hoverClass: 'hovered',
	                    drop: function drop(event, ui) {
	                        var _this2 = this;
	
	                        self.audioService.play('tab');
	
	                        var answer = $(ui.draggable[0]);
	                        var parentWrapper = $(ui.draggable[0]).parent();
	                        var oldElement = this.classList.value.split(' ').find(function (item) {
	                            return item.indexOf('answer--') > -1;
	                        });
	
	                        answer.addClass('simplest__structure-answer--dropped');
	                        parentWrapper.css({ height: parentWrapper.outerHeight(true) });
	                        answer.css({ width: $(this).width(), height: $(this).height() });
	
	                        var lineHeight = (0, _uiHelper.getLineHeight)(answer['0']);
	                        var rowsAmount = parseInt(Number(answer.outerHeight() - lineHeight - 10) / lineHeight, 10);
	
	                        var boxTextBeforeHidden = answer.find('.simplest__box-text').outerHeight();
	
	                        // Logic for arrow tooltip in the box
	                        if (boxTextBeforeHidden < answer.outerHeight() - lineHeight - 10) {
	                            answer.find('.simplest__box-text').css({ height: '', overflow: '' });
	                            answer.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	                        } else {
	                            answer.find('.simplest__box-text').css({ height: rowsAmount * lineHeight, overflow: 'hidden' });
	                            answer.find('.simplest__arrow-button').css({ display: 'flex', 'justify-content': 'flex-end' });
	                        }
	
	                        if (oldElement) {
	                            var index = oldElement.charAt(oldElement.length - 1);
	                            var elemetn = $('.simplest__structure-answer[data-index="' + index + '"]');
	                            elemetn.find('.simplest__box-text').css({ height: '', overflow: '' });
	                            elemetn.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	                            elemetn.css({
	                                width: 'auto',
	                                height: 'auto'
	                            });
	                            elemetn.animate({
	                                top: '0px',
	                                left: '0px',
	                                width: 'auto',
	                                height: 'auto'
	                            });
	                            elemetn.removeClass('simplest__structure-answer--dropped');
	                            $(this).removeClass(oldElement);
	                        }
	
	                        answer.position({
	                            of: $(this),
	                            my: 'center',
	                            at: 'center'
	                        });
	
	                        var resizeEvent = function resizeEvent() {
	                            answer.css({ width: $(_this2).width(), height: $(_this2).height() });
	                            answer.position({
	                                of: $(_this2),
	                                my: 'center',
	                                at: 'center'
	                            });
	                        };
	
	                        var resizeFunc;
	                        $(window).resize(function () {
	                            clearTimeout(resizeFunc);
	                            resizeFunc = setTimeout(resizeEvent, 100);
	                        });
	
	                        window.visualViewport.addEventListener('resize', function () {
	                            answer.css({ width: $(_this2).width(), height: $(_this2).height() });
	                            answer.position({
	                                of: $(_this2),
	                                my: 'center',
	                                at: 'center'
	                            });
	
	                            // Logic for arrow tooltip in the box
	                            answer.find('.simplest__box-text').css({ height: '', overflow: '' });
	                            answer.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	
	                            if (ui.draggable[0].scrollHeight <= answer.outerHeight()) {
	                                answer.find('.simplest__box-text').css({ height: '', overflow: '' });
	                                answer.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	                            } else {
	                                answer.find('.simplest__box-text').css({ height: rowsAmount * lineHeight, overflow: 'hidden' });
	                                answer.find('.simplest__arrow-button').css({ display: 'flex', 'justify-content': 'flex-end' });
	                            }
	                        });
	
	                        $(this).removeClass('answer__incorrect');
	                        $(this).removeClass('answer__correct');
	                        var isDataArray = Array.isArray($(this).data('index'));
	                        if (isDataArray) {
	                            var values = $(this).data('index');
	                            var correctAnswer = answer.data('index');
	                            var isValueExist = values.find(function (element) {
	                                return element === Number(correctAnswer);
	                            });
	                            isValueExist ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');
	                        } else {
	                            answer.data('index') == $(this).data('index') ? $(this).addClass('answer__correct') : $(this).addClass('answer__incorrect');
	                        }
	
	                        $(this).addClass('answer--' + answer.data('index'));
	                    },
	                    out: function out(event, ui) {
	                        var answer = $(ui.draggable[0]);
	                        var container = $(this);
	                        var index = answer.data('index');
	                        if (container.hasClass('answer--' + index)) {
	                            answer.removeClass('simplest__structure-answer--dropped');
	                            answer.css({ width: '', height: '' });
	                            answer.find('.simplest__box-text').css({ height: '', overflow: '' });
	                            answer.find('.simplest__arrow-button').css({ display: 'none', 'justify-content': '' });
	                            container.removeClass('answer--' + $(ui.draggable[0]).data('index'));
	                            container.removeClass('answer__incorrect');
	                            container.removeClass('answer__correct');
	                        }
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'draggableList',
	        value: function draggableList(diagramId, diagramNumber, demo, _ref4) {
	            var slotsQuery = _ref4.slotsQuery;
	
	            var self = this;
	
	            $('#' + diagramId + ' .list-element').each(function () {
	                $(this).data('number', $(this).attr('id').replace('element_' + diagramNumber + '_', '')).draggable({
	                    containment: '#' + diagramId,
	                    cursor: "hand", cursorAt: { top: 0, left: 150 },
	                    scroll: false,
	                    disabled: demo,
	                    revert: function revert(event, ui) {
	                        var answer = $(this);
	                        answer.removeClass('element-list_drop');
	                        answer.data("uiDraggable").originalPosition = {
	                            top: 0,
	                            left: 0
	                        };
	                        return !event;
	                    },
	                    drag: function drag(event, ui) {
	                        ui.helper.removeClass('element-list_drop');
	                        ui.helper.removeClass(function (index, className) {
	                            return (className.match(/(^|\s)element-list_drop\S+/g) || []).join(' ');
	                        });
	                    }
	                });
	            });
	
	            $('#' + diagramId + ' #slots').find(slotsQuery).each(function () {
	                $(this).data('number', $(this).attr('id').replace('slot_' + diagramNumber + '_', '')).droppable({
	                    hoverClass: 'hovered',
	                    drop: function drop(event, ui) {
	                        self.audioService.play('tab');
	                        ui.draggable.removeClass('ui-draggable-dragging');
	
	                        var ansverPosition = function ansverPosition() {
	                            var oldElement = $('.element-list_drop-' + event.target.id);
	                            if (oldElement.length) {
	                                oldElement.animate({
	                                    top: '0px',
	                                    left: '0px',
	                                    width: 'auto',
	                                    height: 'auto'
	                                });
	                                oldElement.removeClass('element-list_drop');
	                                oldElement.removeClass('element-list_drop-' + event.target.id);
	                            }
	                            ui.draggable.addClass('element-list_drop');
	                            ui.draggable.addClass('element-list_drop-' + event.target.id);
	                            ui.draggable.position({
	                                of: $(this),
	                                my: 'center',
	                                at: 'center'
	                            });
	                        };
	                        setTimeout($.proxy(ansverPosition, $(this)), 0);
	                    },
	
	                    out: function out(event, ui) {
	                        ui.draggable.removeClass('element-list_drop-' + event.target.id);
	                        ui.draggable.removeClass('element-list_drop');
	                        $(this).removeClass(ui.draggable[0].id);
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'disableSCQDiagram',
	        value: function disableSCQDiagram(id) {
	            $('#' + id + ' .simplest__structure-answer').each(function () {
	                $(this).draggable('disable');
	            });
	        }
	    }, {
	        key: 'removeOldClass',
	        value: function removeOldClass(element) {
	            element.classList.remove('correct', 'wrong');
	        }
	    }, {
	        key: 'checkDiagramAnswers',
	        value: function checkDiagramAnswers(diagramId) {
	            var _this3 = this;
	
	            var elements = document.querySelectorAll('#' + diagramId + ' .element');
	            elements.forEach(function (element) {
	                _this3.removeOldClass(element);
	                if (element.getAttribute('data-answer') == 'correct') {
	                    var selector = '#' + diagramId + ' [data-answer="correct"]';
	                    $(selector).css('border-color', 'white');
	                    setTimeout(function () {
	                        return $(selector).css('border-color', 'transparent');
	                    }, 200);
	                }
	            });
	
	            var correctAnswersCounter = document.querySelectorAll('#' + diagramId + ' [data-answer="correct"]').length;
	
	            if (correctAnswersCounter === elements.length) {
	                $('#' + diagramId + ' .element').each(function () {
	                    $(this).draggable('disable');
	                });
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }, {
	        key: 'checkRadioButtons',
	        value: function checkRadioButtons(diagramId) {
	            var elements = document.querySelectorAll('#' + diagramId + ' input');
	            var invalidInput = void 0;
	            (0, _from2.default)(elements).forEach(function (input) {
	                if (input.dataset.answer !== 'true' && input.checked) {
	                    invalidInput = input;
	                }
	            });
	            if (invalidInput) {
	                var elementBorder = document.querySelector('#' + diagramId + ' label[for="' + invalidInput.id + '"].radio-button');
	                $(elementBorder).css('border-color', 'red');
	                setTimeout(function () {
	                    $(elementBorder).attr('style', '');
	                }, 200);
	            } else {
	                return true;
	            }
	        }
	    }, {
	        key: 'checkDiagramCheckboxesAnswers',
	        value: function checkDiagramCheckboxesAnswers(userAnswers, correctAnswers) {
	            var progress = {
	                complete: true,
	                mistake: {},
	                correct: {},
	                correctIndex: [],
	                incorrectIndex: []
	            };
	
	            for (var k in correctAnswers) {
	                var index = parseInt(k.match(/\d+/)[0]) - 1;
	                if (correctAnswers[k] !== userAnswers[k]) {
	                    if (!correctAnswers[k]) {
	                        progress.incorrectIndex.push(index);
	                    }
	
	                    progress.complete = false;
	                    progress.mistake[k] = false;
	                } else if (correctAnswers[k] === true && userAnswers[k] === true) {
	                    progress.correctIndex.push(index);
	                    progress.correct[k] = true;
	                }
	            }
	            return this.$q.resolve(progress);
	        }
	    }, {
	        key: 'checkBoxHint',
	        value: function checkBoxHint(diagramId, checkbox, correctIndex, incorrectIndex, correctAnswers) {
	            var _this4 = this;
	
	            if (checkbox) {
	                var checkboxes = $('#' + diagramId + ' .checkbox');
	                if (incorrectIndex.length && !correctIndex.length) {
	                    incorrectIndex.forEach(function (i) {
	                        _this4.highlightCheckbox(checkboxes, i);
	                    });
	                    for (var i in correctAnswers) {
	                        if (correctAnswers[i]) {
	                            var index = parseInt(i.match(/\d+/)[0]) - 1;
	                            this.highlightCheckbox(checkboxes, index);
	                        }
	                    }
	                } else if (correctIndex.length && incorrectIndex.length) {
	                    incorrectIndex.forEach(function (i) {
	                        _this4.highlightCheckbox(checkboxes, i);
	                    });
	                } else if (correctIndex.length && !incorrectIndex.length) {
	                    for (var _i in correctAnswers) {
	                        if (correctAnswers[_i]) {
	                            var _index = parseInt(_i.match(/\d+/)[0]) - 1;
	                            if (correctIndex.indexOf(_index) === -1) {
	                                this.highlightCheckbox(checkboxes, _index);
	                            }
	                        }
	                    }
	                }
	            } else {
	                var selector = '#' + diagramId + ' .element:not([data-answer="correct"])';
	                var jQueryNodes = $(selector);
	                if (!jQueryNodes.length) {
	                    return true;
	                }
	                jQueryNodes.css('border-color', 'red');
	                setTimeout(function () {
	                    return jQueryNodes.css('border-color', 'transparent');
	                }, 200);
	            }
	        }
	    }, {
	        key: 'highlightOnlyIncorectDragbleBoxes',
	        value: function highlightOnlyIncorectDragbleBoxes(diagramId) {
	            var elements = document.querySelectorAll('#' + diagramId + ' .element[data-answer="wrong"]');
	            if (!elements.length) {
	                return true;
	            }
	            elements.forEach(function (element) {
	                var $element = $(element);
	                if ($element.css('left') !== '0px') {
	                    $element.css('border-color', 'red');
	                    setTimeout(function () {
	                        return $element.css('border-color', 'transparent');
	                    }, 200);
	                }
	            });
	        }
	    }, {
	        key: 'highlightCheckbox',
	        value: function highlightCheckbox(array, i) {
	            var checkbox = $(array[i]);
	            checkbox.addClass('checkbox__hint');
	            setTimeout(function () {
	                return checkbox.removeClass('checkbox__hint');
	            }, 200);
	        }
	    }, {
	        key: 'addAnswers',
	        value: function addAnswers(el, ui) {
	            var slotNumber = $(el).data('number');
	            var elementNumber = ui.draggable.data('number');
	            var currentElement = ui.draggable[0];
	
	            if (slotNumber == elementNumber) {
	                currentElement.setAttribute('data-answer', 'correct');
	            } else {
	                currentElement.setAttribute('data-answer', 'wrong');
	            };
	        }
	    }, {
	        key: 'updateElements',
	        value: function updateElements(el, ui) {
	            var currentElement = ui.draggable[0];
	            if ($(el).is('[class*="element"]')) {
	                var oldElementClass = $(el).attr('class').split(' ').pop();
	                var oldElement = $('#' + oldElementClass)[0];
	                if (oldElement != currentElement) {
	                    $(oldElement).animate({
	                        top: "4px",
	                        left: "8px"
	                    });
	                    $(el).removeClass(oldElementClass);
	                    $(el).addClass(currentElement.id);
	                }
	            } else {
	                $(el).addClass(currentElement.id);
	            }
	        }
	    }, {
	        key: 'reset',
	        value: function reset(diagramId) {
	            var self = this;
	            var promiseArray = [];
	            $('#' + diagramId + ' .element').each(function (index) {
	                var element = $(this);
	
	                promiseArray.push(self.$timeout(function () {
	                    element.animate({
	                        top: 0,
	                        left: 0
	                    }, function () {
	                        $(this).removeClass('correct wrong').draggable('enable').removeAttr('data-answer');
	                    });
	                }, 1000 * index));
	            });
	            return this.$q.all(promiseArray);
	        }
	    }, {
	        key: 'autocomplete',
	        value: function autocomplete(diagramId, instant) {
	            var timeFrame = instant ? 0 : 1000;
	            var self = this;
	            var blocks = $('#' + diagramId + ' .element');
	            var promiseArray = [];
	            blocks.each(function (index) {
	                var itemNumber = $(this).data('item');
	                var element = $(this);
	
	                promiseArray.push(self.$timeout(function () {
	                    element.position({
	                        my: 'center',
	                        at: 'center',
	                        of: $('.slot[data-item="' + itemNumber + '"]'),
	                        using: function using(position) {
	                            $(this).animate(position, 'slow', 'linear', function () {
	                                $(this).addClass('correct');
	                            });
	                        }
	                    });
	                }, timeFrame * index));
	            });
	
	            return this.$q.all(promiseArray);
	        }
	    }, {
	        key: 'guid',
	        value: function guid() {
	            var s4 = function s4() {
	                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	            };
	            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	        }
	    }, {
	        key: 'radioButtonsHint',
	        value: function radioButtonsHint(diagramId, userAnswer, correctAnswer) {
	            var radioButtons = $('#' + diagramId + ' .checkbox');
	            (0, _from2.default)(radioButtons).forEach(function (radioButton) {
	                var input = $(radioButton).find('input').val();
	                if (input === correctAnswer) {
	                    var label = $(radioButton).find('label');
	                    label.css('border', '3px solid red');
	                    setTimeout(function () {
	                        return label.removeAttr('style');
	                    }, 200);
	                }
	            });
	        }
	    }, {
	        key: 'radioButtonsGroupHint',
	        value: function radioButtonsGroupHint(diagramId, userAnswer, correctAnswer, number) {
	            var radioButtons = $('#' + diagramId + ' #' + number + ' .checkbox');
	            var radioButtonsTask = $('#' + diagramId + ' .checkboxes-task-item .checkbox');
	            this.highlightLabel(radioButtons, userAnswer[0], correctAnswer[0]);
	            this.highlightLabel(radioButtonsTask, userAnswer[1], correctAnswer[1]);
	        }
	    }, {
	        key: 'highlightLabel',
	        value: function highlightLabel(inputs, userAnswer, correctAnswer) {
	            (0, _from2.default)(inputs).forEach(function (radioButton) {
	                var input = $(radioButton).find('input').val();
	                if (userAnswer !== correctAnswer && (input == userAnswer || input == correctAnswer)) {
	                    var label = $(radioButton).find('label');
	                    label.css('border', '3px solid red');
	                    setTimeout(function () {
	                        return label.removeAttr('style');
	                    }, 200);
	                }
	            });
	        }
	    }, {
	        key: 'checkFixedAnswersDiagram',
	        value: function checkFixedAnswersDiagram(diagramId) {
	            var _this5 = this;
	
	            var elements = document.querySelectorAll('#' + diagramId + ' .drag-element');
	            elements.forEach(function (element) {
	                _this5.removeOldClass(element);
	                if (element.getAttribute('data-answer') == 'correct') {
	                    var selector = '#' + diagramId + ' [data-answer="correct"]';
	                    $(selector).css('border-color', 'white');
	                    setTimeout(function () {
	                        return $(selector).css('border-color', 'transparent');
	                    }, 200);
	                }
	            });
	
	            var correctAnswersCounter = document.querySelectorAll('#' + diagramId + ' [data-answer="correct"]').length;
	
	            if (correctAnswersCounter === elements.length) {
	                $('#' + diagramId + ' .element').each(function () {
	                    $(this).draggable('disable');
	                });
	                return true;
	            } else {
	                return false;
	            }
	        }
	    }]);
	    return DiagramService;
	}();
	
	exports.default = DiagramService;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AudioService = function () {
	  function AudioService() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, AudioService);
	    this.effects = {
	      buttonClick: new Audio('/assets/mp3/buttonClick.mp3'),
	      checkboxClick: new Audio('/assets/mp3/checkboxClick.mp3'),
	      exerciseComplete: new Audio('/assets/mp3/success.m4a'),
	      tab: new Audio('/assets/mp3/tab.m4a'),
	      wrongAnswer: new Audio('/assets/mp3/wrong-answer.wav')
	    };
	  }
	
	  (0, _createClass3.default)(AudioService, [{
	    key: 'play',
	    value: function play(effect) {
	      try {
	        this.effects[effect].play();
	      } catch (e) {
	        console.log('Error while plaing effect for ' + effect, e);
	      };
	    }
	  }]);
	  return AudioService;
	}();
	
	exports.default = AudioService;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(209);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PyramidBuilderService = function () {
	  PyramidBuilderService.$inject = ["apiService", "$q", "$state"];
	  function PyramidBuilderService(apiService, $q, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, PyramidBuilderService);
	    (0, _assign2.default)(this, { apiService: apiService, $q: $q, $state: $state });
	
	    this.store = {};
	    this.inited = false;
	  }
	
	  (0, _createClass3.default)(PyramidBuilderService, [{
	    key: 'init',
	    value: function init(title, scale) {
	      var _this = this;
	
	      if (this.inited) {
	        var key = this.generateKey(title);
	        if (!this.store[key]) {
	          this.createPyramid(key, title, scale);
	        } else {
	          this.store[key].key = key;
	        }
	        return this.$q.resolve(this.store[key]);
	      } else {
	        return this.apiService.get({ url: '/api/v1/pyramids' }).then(function (data) {
	          if (data.status === 403) {
	            _this.$state.go('auth.login');
	            return;
	          }
	          _this.inited = true;
	          _this.store = data.value;
	          _this.opacity = data.opacity;
	
	          var key = _this.generateKey(title);
	          if (!_this.store[key]) {
	            _this.createPyramid(key, title, scale);
	          }
	          return (0, _extends3.default)({}, _this.store[key], { key: key });
	        }).catch(function (error) {
	          console.log(error);
	        });
	      }
	    }
	  }, {
	    key: 'save',
	    value: function save(opacity) {
	      return this.apiService.patch({
	        url: '/api/v1/pyramids',
	        data: {
	          pyramid: {
	            value: this.store
	          }
	        }
	      }).then(function (data) {});
	    }
	  }, {
	    key: 'createPyramid',
	    value: function createPyramid(key, title, scale) {
	      this.store[key] = this.newPyramid(key, title, scale);
	    }
	  }, {
	    key: 'newPyramid',
	    value: function newPyramid(key, title, scale) {
	      var zoom = {
	        k: scale,
	        x: 60,
	        y: 10
	      };
	
	      if (scale.k) zoom = scale;
	
	      return {
	        title: title,
	        key: key,
	        guid: this.guid(),
	        pyramid: {
	          active: true,
	          question: {
	            active: false
	          },
	          zoom: zoom,
	          number: 0,
	          scheme: [{
	            model: null,
	            children: [{
	              model: null,
	              children: []
	            }, {
	              model: null,
	              children: []
	            }, {
	              model: null,
	              children: []
	            }]
	          }]
	        },
	        scq: {
	          active: false
	        },
	        problemDefinition: {
	          active: false,
	          secondLayer: {
	            active: false
	          }
	        }
	      };
	    }
	
	    // updatePyramidSchemeByAmount(parentScheme, amount = 1, maxChildrenPerRow = 4) {
	    //     if (parentScheme.children.length > amount) {
	    //         for (let j = parentScheme.children.length - 1; j >= amount; j--) {
	    //             parentScheme.children.splice(j, 1);
	    //         }
	    //     } else {
	    //         for (let j = 0; j < amount; j++) {
	    //             if (!parentScheme.children[j]) {
	    //                 parentScheme.children.push({
	    //                     model: null,
	    //                     children: []
	    //                 });
	    //             }
	    //         }
	    //     }
	    //     return parentScheme;
	    // }
	
	    // generatePyramidSchemeByAmount(parentScheme, amount = 1, maxChildrenPerRow = 4) {
	    //     const maxRows = Math.ceil(amount / maxChildrenPerRow);
	    //
	    //     let scheme = [{
	    //         model: null,
	    //         children: []
	    //     }];
	    //
	    //     for (let i = 0, children = scheme[0].children; i < maxRows; i++) {
	    //         let restAmount = amount - maxChildrenPerRow * i;
	    //         let maxCells = restAmount > maxChildrenPerRow
	    //             ? maxChildrenPerRow
	    //             : Math.abs(restAmount) - 1;
	    //
	    //         for (let j = 0; j < maxCells; j++) {
	    //             children[j] = {
	    //                 model: null,
	    //                 children: []
	    //             };
	    //         }
	    //
	    //         //let midIndex = Math.floor(children.length * 0.5);
	    //
	    //         //if (!children[midIndex]) break;
	    //
	    //         children = children[0].children;
	    //     }
	    //
	    //     return scheme;
	    // }
	
	  }, {
	    key: 'deletePyramid',
	    value: function deletePyramid(key) {
	      delete this.store[key];
	    }
	  }, {
	    key: 'generateKey',
	    value: function generateKey(title) {
	      return title.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
	        if (p2) return p2.toUpperCase();
	        return p1.toLowerCase();
	      });
	    }
	  }, {
	    key: 'guid',
	    value: function guid() {
	      function s4() {
	        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	      }
	      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	    }
	  }]);
	  return PyramidBuilderService;
	}();
	
	exports.default = PyramidBuilderService;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserService = function () {
	  UserService.$inject = ["apiService", "$q"];
	  function UserService(apiService, $q) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserService);
	    (0, _assign2.default)(this, {
	      apiService: apiService,
	      $q: $q
	    });
	
	    this.user = null;
	  }
	
	  (0, _createClass3.default)(UserService, [{
	    key: 'storeUserData',
	    value: function storeUserData(data) {
	      this.user = data;
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(oldPassword, newPassword, confirmPassword) {
	
	      return this.apiService.post({
	        url: _constants.Constants.usersResetPasswordUrl,
	        data: {
	          userName: this.user.userName,
	          oldPassword: oldPassword,
	          newPassword: newPassword,
	          confirmPassword: confirmPassword
	        }
	      }).then(function (res) {
	        if (res.data.status !== 200) {
	          return {
	            error: true,
	            data: res.data.errors
	          };
	        } else {
	          return {
	            error: false,
	            data: res.data
	          };
	        }
	      }).catch(function (error) {
	        console.log(error);
	      });
	    }
	  }, {
	    key: 'resetPasswordMessage',
	    value: function resetPasswordMessage() {
	      console.log('re');
	    }
	  }]);
	  return UserService;
	}();
	
	exports.default = UserService;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _environment = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultFileNames = {
	  // 1
	  'course.imposingTheStructure': 'Lecture 1A_Imposing the Structure_11.08.20.mp4',
	  'course.pickingOutThePoints': 'Lecture 1B_Cementing the Rules_11.08.20.mp4',
	  'course.cementingTheRules': 'Lecture 1C_Picking Out the Points_12.08.20.mp4',
	  'course.graspingTheMessage_1': 'Lecture 1D - Grasping the Message_13.08.20.mp4',
	  'course.graspingTheMessage_2': 'Lecture 1D-2_Finding the Summary Point_27.08.20.mp4',
	  // 2
	  'course.ideasFitTogether_1': 'Lecture 2A_How the Ideas Fit Together_31.08.20.mp4',
	  'course.ideasFitTogether_2': 'Lecture 2A - 2_Identify First Idea_07.09.20.mp4',
	  'course.creatingQuestion': 'Lecture 2B_Creating a Question Answer Dialogue_12.09.20.mp4',
	  // 3
	  'course.deductiveReasoning': 'Lecture 3A - 1_ Deductive Arguments_12.09.20.mp4',
	  'course.inductiveReasoning': 'Lecture 3B - 1_ Inductive Reasoning_13.09.20.mp4',
	  'course.deductionToInduction': 'Lecture 3B - 4_Transforming Deduction to Induction_14.09.20.mp4',
	  'course.avoidingDeductiveArguments': 'Lecture 3C_Avoiding Deductive Arguments_14.09.20.mp4',
	  // 4
	  'course.practiceInSeeing': 'Lecture 4A_Introductions - Reading to Get the Rhythm_16.09.20.mp4',
	  'course.findingReadersQuestion': 'Lecture 4B - 1_Seeing the SCQ Structure_22.09.20.mp4',
	  'course.spottingSCQ': 'Lecture 4B-2_Finding the Reader_s Question_22.09.20.mp4',
	  'course.applyingSCQProcess': 'Lecture 4C-1_Applying the SCQ Process_23.09.20.mp4',
	  'course.practiceInSeeing3': 'Lecture 4C-2_Field_Sales_Meeting_22.11.20.mp4',
	  // 5
	  'course.defineProblem': 'Lecture 5A_How to Define a Problem_27.09.20.mp4',
	  'course.practiceDefiningProblem': 'Lecture 5B_Defining the Problem_27.09.20.mp4',
	  'course.definingMoreComplexProblems': 'Lecture 5C_Converting an Introduction_27.09.20.mp4',
	  'course.writingAGoodProposal': 'Lecture 5D_Writing Proposals and Project Plans_29.09.20.mp4'
	};
	
	var CourseVideoService = function () {
	  CourseVideoService.$inject = ["$state"];
	  function CourseVideoService($state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CourseVideoService);
	    (0, _assign2.default)(this, { $state: $state, s3Url: _environment.environment.videosUrl, fileNames: defaultFileNames });
	  }
	
	  (0, _createClass3.default)(CourseVideoService, [{
	    key: 'getFileURL',
	    value: function getFileURL() {
	      var modifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	      var currentUrl = this.$state.current.name + modifier;
	      var fileName = this.fileNames[currentUrl] || 'oceans.mp4';
	      return _environment.environment.videosUrl + fileName;
	    }
	  }]);
	  return CourseVideoService;
	}();
	
	exports.default = CourseVideoService;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _dashboard = __webpack_require__(499);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _graduation = __webpack_require__(506);
	
	var _graduation2 = _interopRequireDefault(_graduation);
	
	var _cms = __webpack_require__(512);
	
	var _cms2 = _interopRequireDefault(_cms);
	
	var _concept = __webpack_require__(518);
	
	var _concept2 = _interopRequireDefault(_concept);
	
	var _livecourse = __webpack_require__(522);
	
	var _livecourse2 = _interopRequireDefault(_livecourse);
	
	var _textbook = __webpack_require__(526);
	
	var _textbook2 = _interopRequireDefault(_textbook);
	
	var _summary = __webpack_require__(530);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _barbara = __webpack_require__(534);
	
	var _barbara2 = _interopRequireDefault(_barbara);
	
	var _homepage = __webpack_require__(538);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _contact = __webpack_require__(542);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _press = __webpack_require__(546);
	
	var _press2 = _interopRequireDefault(_press);
	
	var _tc = __webpack_require__(550);
	
	var _tc2 = _interopRequireDefault(_tc);
	
	var _policies = __webpack_require__(554);
	
	var _policies2 = _interopRequireDefault(_policies);
	
	var _workbook = __webpack_require__(558);
	
	var _workbook2 = _interopRequireDefault(_workbook);
	
	var _buy = __webpack_require__(562);
	
	var _buy2 = _interopRequireDefault(_buy);
	
	var _testimonials = __webpack_require__(568);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _onlineCourse = __webpack_require__(572);
	
	var _onlineCourse2 = _interopRequireDefault(_onlineCourse);
	
	var _corporateInquiry = __webpack_require__(576);
	
	var _corporateInquiry2 = _interopRequireDefault(_corporateInquiry);
	
	var _error = __webpack_require__(580);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _thankYou = __webpack_require__(584);
	
	var _thankYou2 = _interopRequireDefault(_thankYou);
	
	var _paymentFailure = __webpack_require__(590);
	
	var _paymentFailure2 = _interopRequireDefault(_paymentFailure);
	
	var _login = __webpack_require__(596);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _register = __webpack_require__(600);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _help = __webpack_require__(604);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _userSettings = __webpack_require__(610);
	
	var _userSettings2 = _interopRequireDefault(_userSettings);
	
	var _angularjsToaster = __webpack_require__(616);
	
	var _angularjsToaster2 = _interopRequireDefault(_angularjsToaster);
	
	var _angularAnimate = __webpack_require__(618);
	
	var _angularAnimate2 = _interopRequireDefault(_angularAnimate);
	
	var _imposingTheStructure = __webpack_require__(620);
	
	var _imposingTheStructure2 = _interopRequireDefault(_imposingTheStructure);
	
	var _cementingTheRules = __webpack_require__(626);
	
	var _cementingTheRules2 = _interopRequireDefault(_cementingTheRules);
	
	var _pickingOutThePoints = __webpack_require__(632);
	
	var _pickingOutThePoints2 = _interopRequireDefault(_pickingOutThePoints);
	
	var _graspingTheMessage = __webpack_require__(638);
	
	var _graspingTheMessage2 = _interopRequireDefault(_graspingTheMessage);
	
	var _ideasFitTogether = __webpack_require__(644);
	
	var _ideasFitTogether2 = _interopRequireDefault(_ideasFitTogether);
	
	var _creatingQuestion = __webpack_require__(650);
	
	var _creatingQuestion2 = _interopRequireDefault(_creatingQuestion);
	
	var _supportingPoints = __webpack_require__(656);
	
	var _supportingPoints2 = _interopRequireDefault(_supportingPoints);
	
	var _deductiveReasoning = __webpack_require__(662);
	
	var _deductiveReasoning2 = _interopRequireDefault(_deductiveReasoning);
	
	var _summarizingDeductive = __webpack_require__(680);
	
	var _summarizingDeductive2 = _interopRequireDefault(_summarizingDeductive);
	
	var _unearthingEmbeddedArguments = __webpack_require__(686);
	
	var _unearthingEmbeddedArguments2 = _interopRequireDefault(_unearthingEmbeddedArguments);
	
	var _inductiveReasoning = __webpack_require__(692);
	
	var _inductiveReasoning2 = _interopRequireDefault(_inductiveReasoning);
	
	var _identifyingInductivePoints = __webpack_require__(698);
	
	var _identifyingInductivePoints2 = _interopRequireDefault(_identifyingInductivePoints);
	
	var _inductionFromDeduction = __webpack_require__(704);
	
	var _inductionFromDeduction2 = _interopRequireDefault(_inductionFromDeduction);
	
	var _deductionToInduction = __webpack_require__(710);
	
	var _deductionToInduction2 = _interopRequireDefault(_deductionToInduction);
	
	var _avoidingDeductiveArguments = __webpack_require__(716);
	
	var _avoidingDeductiveArguments2 = _interopRequireDefault(_avoidingDeductiveArguments);
	
	var _practiceInSeeing = __webpack_require__(722);
	
	var _practiceInSeeing2 = _interopRequireDefault(_practiceInSeeing);
	
	var _findingReadersQuestion = __webpack_require__(733);
	
	var _findingReadersQuestion2 = _interopRequireDefault(_findingReadersQuestion);
	
	var _spottingSCQ = __webpack_require__(742);
	
	var _spottingSCQ2 = _interopRequireDefault(_spottingSCQ);
	
	var _applyingSCQProcess = __webpack_require__(760);
	
	var _applyingSCQProcess2 = _interopRequireDefault(_applyingSCQProcess);
	
	var _practiceInSeeing3 = __webpack_require__(767);
	
	var _practiceInSeeing4 = _interopRequireDefault(_practiceInSeeing3);
	
	var _defineProblem = __webpack_require__(777);
	
	var _defineProblem2 = _interopRequireDefault(_defineProblem);
	
	var _practiceDefiningProblem = __webpack_require__(790);
	
	var _practiceDefiningProblem2 = _interopRequireDefault(_practiceDefiningProblem);
	
	var _practiceDefiningProblem3 = __webpack_require__(803);
	
	var _practiceDefiningProblem4 = _interopRequireDefault(_practiceDefiningProblem3);
	
	var _writingProposalsPlans = __webpack_require__(817);
	
	var _writingProposalsPlans2 = _interopRequireDefault(_writingProposalsPlans);
	
	var _unit = __webpack_require__(829);
	
	var _unit2 = _interopRequireDefault(_unit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Section 4
	var _module = _angular2.default.module('minto.modules', [_dashboard2.default, _graduation2.default, _cms2.default, _concept2.default, _livecourse2.default, _summary2.default, _textbook2.default, _barbara2.default, _homepage2.default, _contact2.default, _press2.default, _tc2.default, _policies2.default, _workbook2.default, _register2.default, _login2.default, _buy2.default, _testimonials2.default, _onlineCourse2.default, _corporateInquiry2.default, _error2.default, _thankYou2.default, _paymentFailure2.default, _userSettings2.default, _angularjsToaster2.default, _angularAnimate2.default, _help2.default,
	
	// Section 1 units:
	_imposingTheStructure2.default, _cementingTheRules2.default, _pickingOutThePoints2.default, _graspingTheMessage2.default,
	
	// Section 2 units:
	_ideasFitTogether2.default, _creatingQuestion2.default,
	
	// Section 3 units:
	_supportingPoints2.default, _deductiveReasoning2.default, _summarizingDeductive2.default, _unearthingEmbeddedArguments2.default, _inductiveReasoning2.default, _identifyingInductivePoints2.default, _inductionFromDeduction2.default, _deductionToInduction2.default, _avoidingDeductiveArguments2.default,
	
	// Section 4 units:
	_practiceInSeeing2.default, _practiceInSeeing4.default, _findingReadersQuestion2.default, _spottingSCQ2.default, _applyingSCQProcess2.default,
	
	// Section 5 units:
	_defineProblem2.default, _practiceDefiningProblem2.default, _practiceDefiningProblem4.default, _writingProposalsPlans2.default]
	
	// unit6
	
	).config(['$animateProvider', function ($animateProvider) {
	    $animateProvider.classNameFilter(/angular-ngAnimate/);
	}]).name;
	
	// Section 5
	
	
	// Section 3
	
	
	// Section 2
	
	
	//Section 1
	exports.default = _module;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _dashboard = __webpack_require__(500);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardModule = _angular2.default.module('dashboard', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.dashboard', {
	    url: '/dashboard',
	    component: 'dashboard',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('dashboard', _dashboard2.default).name;
	
	exports.default = dashboardModule;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _dashboard = __webpack_require__(501);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dashboard3 = __webpack_require__(502);
	
	var _dashboard4 = _interopRequireDefault(_dashboard3);
	
	__webpack_require__(503);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dashboardComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _dashboard2.default,
	  controller: _dashboard4.default
	};
	
	exports.default = dashboardComponent;

/***/ }),
/* 501 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"dashboard\">\n  <mo-header></mo-header>\n  <!--<div class=\"loading\" ng-show=\"vm.loading\"></div>-->\n  <main class=\"content wrapper\" ng-show=\"!vm.loading\">\n\n    <div class=\"dashboard-header\">\n      <div style=\"width: 100%\">\n        <div style=\"display: flex; justify-content: space-between\">\n          <span ng-if=\"vm.isJustRegistered\" class=\"welcome-message\"> Welcome{{vm.userFirstName}}! </span>\n          <span ng-if=\"!vm.isJustRegistered\" class=\"welcome-message\"> Welcome back, {{vm.user.firstName}}! </span>\n          <span ng-click=\"vm.logout()\" style=\"cursor: pointer\" translate>dashboard.logout</span>\n        </div>\n        <!--\t\t\t\t<div class=\"course-info\">-->\n        <!--\t\t\t\t\t<div class=\"course-info__text\">-->\n        <!--\t\t\t\t\t\t<span translate>dashboard.currently-on-section</span>-->\n        <!--\t\t\t\t\t\t<span class='course-info__marked' ng-bind=\"vm.activeUnitTitle\"></span>-->\n        <!--\t\t\t\t\t</div>-->\n        <!--\t\t\t\t\t<span class=\"course-info__text\" ng-bind-html=\"vm.progress\"></span>-->\n        <!--\t\t\t\t</div>-->\n      </div>\n      <div class=\"dashboard-header-btnbox\">\n        <div class=\"dashboard-header-btnbox__msg\">\n          Messages\n          <span class=\"dashboard-header-btnbox__msg-label\">3</span>\n        </div>\n        <div class=\"dashboard-header-btnbox__resume\">Resume ></div>\n      </div>\n    </div>\n\n    <nav class=\"dashboard-menu\">\n      <a ng-click=\"vm.showIntroductionPopup = true\">Introduction</a>\n      <a ng-click=\"vm.showTestDrivePopup = true\">Test Drive</a>\n    </nav>\n\n    <section class=\"sections-list\">\n      <div class=\"sections-list__row\">\n        <div class=\"section-preview the-basic-pyramid\" ng-class=\"{ completed: section.completed }\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number \">1</div>\n            <div class=\"section-preview__title \">Understanding The Basic Pyramid</div>\n          </div>\n          <div class=\"section-preview__units\">\n\n            <p class=\"section-title\">{{vm.sectionTitle}}</p>\n\n            <ul class=\"section-units-list\">\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.imposingTheStructure\" ng-mouseenter=\"vm.unitMouseEnter('Imposing The Structure')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Imposing The Structure'}\"\n                  class=\"section-unit__link section-unit__link-width\">1A</a>\n              </li>\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.pickingOutThePoints\" ng-mouseenter=\"vm.unitMouseEnter('Cementing The Rules')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Cementing The Rules'}\"\n                  class=\"section-unit__link section-unit__link-width\">1B</a>\n              </li>\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.cementingTheRules\" ng-mouseenter=\"vm.unitMouseEnter('Picking Out The Points')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Picking Out The Points'}\"\n                  class=\"section-unit__link section-unit__link-width\">1C</a>\n              </li>\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.graspingTheMessage\" ng-mouseenter=\"vm.unitMouseEnter('Grasping The Message')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Grasping The Message'}\"\n                  class=\"section-unit__link section-unit__link-width\">1D</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <!-- end ngRepeat: section in vm.course.sections -->\n        <div class=\"section-preview how-the-ideas-fit-together\" ng-class=\"{ completed: section.completed }\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number \">2</div>\n            <div class=\"section-preview__title \">How the Ideas Fit Together</div>\n          </div>\n          <div class=\"section-preview__units\">\n\n            <p class=\"section-title\">{{vm.sectionTitle}}</p>\n\n            <ul class=\"section-units-list\">\n\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.ideasFitTogether\" ng-mouseenter=\"vm.unitMouseEnter('Ideas Fit Together')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Ideas Fit Together'}\"\n                  class=\"section-unit__link section-unit__link-width\">2A</a>\n              </li>\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.creatingQuestion\" ng-mouseenter=\"vm.unitMouseEnter('Creating Question')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Creating Question'}\"\n                  class=\"section-unit__link section-unit__link-width\">2B</a>\n              </li>\n\n            </ul>\n          </div>\n        </div>\n        <div class=\"section-preview reasoning-groupings\" ng-class=\"{ completed: section.completed }\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number \">3</div>\n            <div class=\"section-preview__title \">Supporting the Points</div>\n          </div>\n          <div class=\"section-preview__units\">\n\n            <p class=\"section-title\">{{vm.sectionTitle}}</p>\n\n            <ul class=\"section-units-list\">\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.deductiveReasoning\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Deductive Reasoning')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Deductive Reasoning'}\">3A1</a>\n                <a ui-sref=\"course.summarizingDeductive\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Summarizing Deductive')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Summarizing Deductive'}\">3A2</a>\n                <a ui-sref=\"course.unearthingEmbeddedArguments\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Unearthing Embedded Arguments')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Unearthing Embedded Arguments'}\">3A3</a>\n              </li>\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.inductiveReasoning\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Inductive Reasoning, Finding General Plural Nouns')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Inductive Reasoning, Finding General Plural Nouns'}\">3B1</a>\n                <a ui-sref=\"course.identifyingInductivePoints\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Identifying Inductive Points')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Identifying Inductive Points'}\">3B2</a>\n                <a ui-sref=\"course.inductionFromDeduction\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Induction From Deduction')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Induction From Deduction'}\">3B3</a>\n                <a ui-sref=\"course.deductionToInduction\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Deduction To Induction')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Deduction To Induction'}\">3B4</a>\n              </li>\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.avoidingDeductiveArguments\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Avoiding Deductive Arguments')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Avoiding Deductive Arguments'}\">3C</a>\n              </li>\n\n            </ul>\n          </div>\n        </div>\n      </div>\n      <div class=\"sections-list__row\">\n        <!-- end ngRepeat: section in vm.course.sections -->\n        <div class=\"section-preview how-to-write-an-introduction\" ng-class=\"{ completed: section.completed }\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number \">4</div>\n            <div class=\"section-preview__title \">Developing Introductions</div>\n          </div>\n          <div class=\"section-preview__units\">\n\n            <p class=\"section-title\">{{vm.sectionTitle}}</p>\n\n            <ul class=\"section-units-list\">\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.practiceInSeeing\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Practice In Seeing')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Practice In Seeing'}\">4A</a>\n              </li>\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.findingReadersQuestion\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Finding Readers Question')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Finding Readers Question'}\">4B1</a>\n                <a ui-sref=\"course.spottingSCQ\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Spotting SCQ')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Spotting SCQ'}\">4B2</a>\n              </li>\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.applyingSCQProcess\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Applying SCQ Process')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Applying SCQ Process'}\">4C1</a>\n                <a ui-sref=\"course.practiceInSeeing3\" class=\"section-unit__link \"\n                  ng-mouseenter=\"vm.unitMouseEnter('Practice In Seeing 2')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Practice In Seeing 2'}\">4C2</a>\n              </li>\n\n            </ul>\n          </div>\n        </div>\n        <!-- end ngRepeat: section in vm.course.sections -->\n        <div class=\"section-preview how-to-define-a-problem\" ng-class=\"{ completed: section.completed }\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number \">5</div>\n            <div class=\"section-preview__title \">Defining the problem</div>\n          </div>\n          <div class=\"section-preview__units\">\n\n            <p class=\"section-title\">{{vm.sectionTitle}}</p>\n\n            <ul class=\"section-units-list\">\n\n\n              <li class=\" section-units-list__item\">\n                <a ui-sref=\"course.defineProblem\" class=\"section-unit__link section-unit__link-width\"\n                  ng-mouseenter=\"vm.unitMouseEnter('Define Problem')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Define Problem'}\">5A</a>\n              </li>\n              <li>\n                <a ui-sref=\"course.practiceDefiningProblem\" class=\"section-unit__link section-unit__link-width\"\n                  ng-mouseenter=\"vm.unitMouseEnter('Practice Defining Problem')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Practice Defining Problem'}\">5B</a>\n              </li>\n              <li>\n                <a ui-sref=\"course.definingMoreComplexProblems\" class=\"section-unit__link section-unit__link-width\"\n                  ng-mouseenter=\"vm.unitMouseEnter('Defining More Complex Problems')\"\n                  ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Defining More Complex Problems'}\">5C</a>\n              </li>\n              <li>\n                <a ui-sref=\"course.writingAGoodProposal\" class=\"section-unit__link section-unit__link-width\"\n                  ng-mouseenter=\"vm.unitMouseEnter('Writing A Good Proposal')\" ng-mouseleave=\"vm.unitMouseLeave()\"\n                  ng-class=\"{inactive: vm.showUnit && vm.showUnit !== 'Writing A Good Proposal'}\">5D</a>\n              </li>\n            </ul>\n          </div>\n        </div>\n        <!-- end ngRepeat: section in vm.course.sections -->\n        <a ui-sref=\"graduation\" class=\"section-preview graduation-section\">\n          <div class=\"section-preview__view-number\">\n            <div class=\"section-preview__number\">G</div>\n            <div class=\"section-preview__title\">Graduation</div>\n          </div>\n        </a>\n      </div>\n      <!--\t\t\t end ngRepeat: section in vm.course.sections -->\n      <!--\t\t\t<div class=\"section-preview how-to-group-and-summarize-ideas\" ng-class=\"{ completed: section.completed }\">-->\n      <!--\t\t\t\t<div class=\"section-preview__view-number\">-->\n      <!--\t\t\t\t\t<div class=\"section-preview__number \">6</div>-->\n      <!--\t\t\t\t\t<div class=\"section-preview__title \">How to Group and Summarize Ideas</div>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t\t<div class=\"section-preview__units\">-->\n      <!--\t\t\t\t\t<ul class=\"section-units-list\">-->\n\n\n      <!--            <li class=\" section-units-list__item\" ng-repeat=\"course in vm.course.sections[5].units\">-->\n      <!--              <a ui-sref=\"course.{{course.camelize_title}}\" ng-init=\"hover = false\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"-->\n      <!--                 class=\"section-unit__link\" ng-class=\"{active : vm.activeUnit.name === unit.name}\"-->\n      <!--              >{{ hover ? course.title : course.name.toUpperCase()}}</a>-->\n\n      <!--\t\t\t\t\t</ul>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t</div>-->\n      <!--\t\t\t end ngRepeat: section in vm.course.sections -->\n      <!--\t\t\t<div class=\"section-preview tackling-common-documents\" ng-class=\"{ completed: section.completed }\">-->\n      <!--\t\t\t\t<div class=\"section-preview__view-number\">-->\n      <!--\t\t\t\t\t<div class=\"section-preview__number \">7</div>-->\n      <!--\t\t\t\t\t<div class=\"section-preview__title \">Tackling Common Documents</div>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t\t<div class=\"section-preview__units\">-->\n      <!--\t\t\t\t\t<ul class=\"section-units-list\">-->\n\n\n      <!--            <li class=\" section-units-list__item\" ng-repeat=\"course in vm.course.sections[6].units\">-->\n      <!--              <a ui-sref=\"course.{{course.camelize_title}}\" ng-init=\"hover = false\" ng-mouseenter=\"hover = true\" ng-mouseleave=\"hover = false\"-->\n      <!--                 class=\"section-unit__link\" ng-class=\"{active : vm.activeUnit.name === unit.name}\"-->\n      <!--              >{{ hover ? course.title : course.name.toUpperCase()}}</a>-->\n\n      <!--\t\t\t\t\t</ul>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t</div>-->\n      <!--\t\t\t end ngRepeat: section in vm.course.sections -->\n      <!--\t\t\t<div class=\"section-preview final-summary\" ng-class=\"{ completed: section.completed }\">-->\n      <!--\t\t\t\t<div class=\"section-preview__view-number\">-->\n      <!--\t\t\t\t\t<div class=\"section-preview__number \">8</div>-->\n      <!--\t\t\t\t\t<div class=\"section-preview__title \">Final Summary</div>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t\t<div class=\"section-preview__units\">-->\n      <!--\t\t\t\t\t<ul class=\"section-units-list\">-->\n\n      <!--\t\t\t\t\t</ul>-->\n      <!--\t\t\t\t</div>-->\n      <!--\t\t\t</div>-->\n      <!--\t\t\t end ngRepeat: section in vm.course.sections -->\n    </section>\n\n    <introduction-popup ng-if=\"vm.showIntroductionPopup\" on-close=\"vm.onClosePopup($event)\" />\n    <test-drive-popup ng-if=\"vm.showTestDrivePopup\" on-close=\"vm.onClosePopup($event)\" />\n\n  </main>\n</div>"

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DashboardController = function () {
	  DashboardController.$inject = ["$translate", "$state", "$q", "authService", "courseService", "helperService"];
	  function DashboardController($translate, $state, $q, authService, courseService, helperService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, DashboardController);
	    this.sectionTitle = '';
	    this.showUnit = '';
	
	    (0, _assign2.default)(this, {
	      $translate: $translate,
	      $state: $state,
	      $q: $q,
	      authService: authService,
	      courseService: courseService,
	      helperService: helperService
	    });
	
	    this.loading = true;
	    this.showIntroductionPopup = false;
	    this.showTestDrivePopup = false;
	  }
	
	  (0, _createClass3.default)(DashboardController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.isJustRegistered = this.$state.isJustRegistered || false;
	      this.userFirstName = ', ' + this.$state.userFirstName || '';
	      this.user = this.authService.getUser();
	      this.getCourses();
	    }
	  }, {
	    key: 'onClosePopup',
	    value: function onClosePopup(_ref) {
	      var name = _ref.name;
	
	      switch (name) {
	        case 'introduction-popup':
	          this.showIntroductionPopup = false;
	          break;
	        case 'test-drive-popup':
	          this.showTestDrivePopup = false;
	      }
	    }
	  }, {
	    key: 'getCourses',
	    value: function getCourses() {
	      var _this = this;
	
	      this.$q.all([this.courseService.getAll(), this.courseService.getProgress()]).then(function (data) {
	        _this.course = data[0][0];
	        _this.userProgress = data[1];
	        // this.calculateProgress();
	        _this.loading = false;
	      });
	    }
	  }, {
	    key: 'calculateProgress',
	    value: function calculateProgress() {
	      var _this2 = this;
	
	      var totalCount = 0;
	      var compleated = 0;
	
	      this.course.sections.forEach(function (section) {
	        totalCount += section.units.length;
	        section.units.forEach(function (unit, i) {
	
	          if (unit.completed) {
	            compleated++;
	          }
	
	          if (i > 0 && section.units[i - 1].id === _this2.userProgress.unit_id) {
	            _this2.activeUnit = unit;
	          }
	        }, 0);
	      });
	
	      if (!this.activeUnit) {
	        this.activeUnit = this.course.sections[0];
	      }
	
	      var count = Math.ceil(compleated * 100 / totalCount);
	      this.progress = this.$translate.instant('dashboard.progress', { count: count });
	      // this.activeUnitTitle = this.$translate.instant(`course.unit.${this.activeUnit.name}`, { name: this.activeUnit.name.title });
	      this.activeUnitTitle = this.activeUnit.name;
	    }
	  }, {
	    key: 'unitMouseEnter',
	    value: function unitMouseEnter(unitTitle) {
	      this.sectionTitle = unitTitle;
	      this.showUnit = unitTitle;
	    }
	  }, {
	    key: 'unitMouseLeave',
	    value: function unitMouseLeave() {
	      this.sectionTitle = '';
	      this.showUnit = '';
	    }
	  }, {
	    key: 'logout',
	    value: function logout() {
	      this.authService.logOut();
	    }
	  }]);
	  return DashboardController;
	}();
	
	exports.default = DashboardController;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(504);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./dashboard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".dashboard{background-color:#f7f7f7;min-height:100vh}.dashboard .header{background:url(/assets/images/dashboard_bg.jpg);background-position:50%;background-repeat:no-repeat;background-size:cover;margin-bottom:0}.dashboard .content.wrapper{padding:42px 0 40px;color:#050e61;max-width:730px}.dashboard .welcome-message{font-size:1.9rem}.dashboard .course-info{margin-top:10px;letter-spacing:.5px}.dashboard .course-info__text{display:block;font-family:Nexa-Light,sans pro,\"serif\";margin-top:.2rem;font-size:.9rem;line-height:1.1rem}.dashboard .course-info__text .course-info__marked{font-family:Nexa-Bold,sans pro,\"serif\"}.dashboard .course-info__text .course-info__marked.percentege{font-size:1.5rem}.dashboard .inactive{color:hsla(0,0%,100%,.6)!important}.dashboard .dashboard-header{display:flex;justify-content:space-between}.dashboard .dashboard-header .dashboard-header-btnbox{font-size:0;display:none}.dashboard .dashboard-header .dashboard-header-btnbox .dashboard-header-btnbox__msg,.dashboard .dashboard-header .dashboard-header-btnbox .dashboard-header-btnbox__resume{width:185px;height:50px;display:inline-block;background-color:#fff;text-align:center;font-family:Nexa-light;font-size:20px;line-height:50px;cursor:pointer}.dashboard .dashboard-header .dashboard-header-btnbox .dashboard-header-btnbox__msg{margin-right:25px;position:relative}.dashboard .dashboard-header .dashboard-header-btnbox .dashboard-header-btnbox__msg-label{padding:2px 7px;position:absolute;right:0;top:-10px;transform:translateX(50%);color:#fff;font-size:17px;line-height:20px;background-color:#fc0d1c;border-radius:100px;border:2px solid #fff}.dashboard .dashboard-menu{border-bottom:2px solid #050e61;font-family:Nexa-Light,sans pro,\"serif\";margin-top:70px;margin-bottom:40px;display:flex;font-size:1.2rem;justify-content:space-between}.dashboard .dashboard-menu a{text-decoration:none;cursor:pointer;text-align:center;width:25%;padding:6px 0}.dashboard .dashboard-menu a:hover{font-family:Nexa-Bold,sans pro,\"serif\"}.dashboard .sections-list{margin:0 -10px;padding:42px 10px 10px}.dashboard .sections-list__row{display:flex;justify-content:space-between}.dashboard .section-preview{position:relative;display:block;height:170px;width:33%;margin:9px 7px}.dashboard .section-preview:hover .section-preview__units{display:block}.dashboard .section-preview:hover .section-units-list{padding:50px 30px 0 20px;text-decoration:none}.dashboard .section-preview:hover .section-units-list__item{display:block}.dashboard .section-preview:hover .section-unit__link{display:inline-block;text-decoration:none}.dashboard .section-preview:hover .section-unit__link-width{width:100%}.dashboard .section-preview:hover .ng-hide{display:inline-block!important;opacity:0}.dashboard .section-preview:hover .section-preview__view-number{display:none}.dashboard .section-preview:nth-child(n+6){filter:grayscale(150%) saturate(30%);pointer-events:none}.dashboard .section-preview:nth-child(n+6) *{color:#aaa}.dashboard .section-preview .section-preview__view-number{color:#fff;padding:25px}.dashboard .section-preview .section-preview__view-number .section-preview__number{font-size:98px;line-height:84px}.dashboard .section-preview .section-preview__view-number .section-preview__title{font-size:20px}.dashboard .section-preview .section-preview__units{display:none}.dashboard .section-preview .section-preview__units .section-title{position:absolute;color:#fff;font-size:16px;font-family:Nexa-Bold,sans pro,\"serif\";left:20px;line-height:20px;margin-right:14px}.dashboard .section-preview .section-preview__units a{color:#fff}.dashboard .section-preview.the-basic-pyramid{background:url(\"/assets/images/section-preview-1.jpg\");background-size:100% 100%}.dashboard .section-preview.how-the-ideas-fit-together{background:url(\"/assets/images/section-preview-2.jpg\");background-size:100% 100%}.dashboard .section-preview.reasoning-groupings{background:url(\"/assets/images/section-preview-3.jpg\");background-size:100% 100%}.dashboard .section-preview.how-to-write-an-introduction{background:url(\"/assets/images/section-preview-4.jpg\");background-size:100% 100%}.dashboard .section-preview.how-to-define-a-problem{background:url(\"/assets/images/section-preview-5.jpg\");background-size:100% 100%}.dashboard .section-preview.how-to-group-and-summarize-ideas{background:url(\"/assets/images/section-preview-6.jpg\");background-size:100% 100%}.dashboard .section-preview.tackling-common-documents{background:url(\"/assets/images/section-preview-7.jpg\");background-size:100% 100%}.dashboard .section-preview.final-summary{background:url(\"/assets/images/section-preview-8.jpg\");background-size:100% 100%}.dashboard .section-preview.graduation-section{background:url(\"/assets/images/section-preview-graduation.png\");background-size:100% 100%;text-decoration:none;color:#fff}.dashboard .section-preview.graduation-section a{text-decoration:none;color:#fff}.dashboard .section-preview.graduation-section:hover .section-preview__view-number{display:block!important}.dashboard .section-preview.completed:after{content:url(\"/assets/images/accomplish-tick.png\");position:absolute;display:block;transform:scale(.8);bottom:-2px;right:-15px}", ""]);
	
	// exports


/***/ }),
/* 505 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	var authenticate = exports.authenticate = ["authService", "$timeout", "$state", "GlobalRedirects", function authenticate(authService, $timeout, $state, GlobalRedirects) {
	    "ngInject";
	
	    return authService.protectRoute().then(function (data) {
	        if (!data) {
	            $timeout(function () {
	                return $state.go(GlobalRedirects.LOGIN);
	            }, 0);
	        }
	    });
	}];
	
	var logout = exports.logout = ["authService", "$timeout", "$state", "GlobalRedirects", function logout(authService, $timeout, $state, GlobalRedirects) {
	    "ngInject";
	
	    return authService.logOut().then(function (data) {
	        if (data) {
	            $timeout(function () {
	                return $state.go(GlobalRedirects.AFTER_LOGOUT);
	            }, 0);
	            return false;
	        }
	    });
	}];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _graduation = __webpack_require__(507);
	
	var _graduation2 = _interopRequireDefault(_graduation);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graduationModule = _angular2.default.module('graduation', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('graduation', {
	    url: '/graduation',
	    component: 'graduation',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('graduation', _graduation2.default).name;
	
	exports.default = graduationModule;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _graduation = __webpack_require__(508);
	
	var _graduation2 = _interopRequireDefault(_graduation);
	
	var _graduation3 = __webpack_require__(509);
	
	var _graduation4 = _interopRequireDefault(_graduation3);
	
	__webpack_require__(510);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graduationComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _graduation2.default,
	  controller: _graduation4.default
	};
	
	exports.default = graduationComponent;

/***/ }),
/* 508 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"graduation\">\n  <div class=\"graduation__header\">\n    <div class=\"graduation__header-text-wrapper\">\n      <div class=\"graduation__header-logo\"></div>\n      <div class=\"graduation__header-text\">Graduation</div>\n    </div>\n  </div>\n  <toaster-container></toaster-container>\n\n  <div class=\"graduation__content\">\n    <div class=\"graduation__content-cong\">CONGRATULATIONS!</div>\n    <div class=\"graduation__content-main graduation__content-user\">{{ vm.userName }}</div>\n    <div class=\"graduation__content-main\">\n      You have completed the<br><span>Minto Pyramid Principle</span><br>online course\n    </div>\n  </div>\n\n  <div class=\"graduation__buttons\">\n    <button ng-click=\"vm.downloadCertificate()\" class=\"graduation__buttons-certificate\">Download certificate</button>\n    <a ui-sref=\"site.dashboard\" class=\"graduation__buttons-menu\">Main Menu</a>\n  </div>\n\n  <div class=\"graduation__footer\">\n  </div>\n</div>\n"

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _regenerator = __webpack_require__(461);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(489);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var GraduationController = function () {
	    GraduationController.$inject = ["apiService", "toaster", "authService"];
	    function GraduationController(apiService, toaster, authService) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, GraduationController);
	        (0, _assign2.default)(this, { apiService: apiService, toaster: toaster, authService: authService });
	    }
	
	    (0, _createClass3.default)(GraduationController, [{
	        key: '$onInit',
	        value: function $onInit() {
	            var user = this.authService.getUser();
	            this.userName = user.firstName + ' ' + user.lastName;
	        }
	    }, {
	        key: 'downloadCertificate',
	        value: function () {
	            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	                var userId, response, newResponse, el, _el;
	
	                return _regenerator2.default.wrap(function _callee$(_context) {
	                    while (1) {
	                        switch (_context.prev = _context.next) {
	                            case 0:
	                                userId = this.apiService.getData().user.id;
	                                _context.next = 3;
	                                return this.apiService.get({
	                                    url: '/api/v1/students/' + userId + '/certificates',
	                                    name: 'certificate'
	                                });
	
	                            case 3:
	                                response = _context.sent;
	
	                                if (response.certificate_url) {
	                                    _context.next = 11;
	                                    break;
	                                }
	
	                                _context.next = 7;
	                                return this.apiService.post({
	                                    url: '/api/v1/students/' + userId + '/certificates',
	                                    name: 'certificate'
	                                });
	
	                            case 7:
	                                newResponse = _context.sent;
	
	                                if (newResponse.certificate_url) {
	                                    el = document.createElement('a');
	
	                                    el.href = newResponse.certificate_url;
	                                    el.target = '_blank';
	                                    el.click();
	                                } else {
	                                    this.toaster.pop('error', "Certificate creation failed", 'You have to finish your course first', 4000, 'trustedHtml');
	                                }
	                                _context.next = 15;
	                                break;
	
	                            case 11:
	                                _el = document.createElement('a');
	
	                                _el.href = response.certificate_url;
	                                _el.target = '_blank';
	                                _el.click();
	
	                            case 15:
	                            case 'end':
	                                return _context.stop();
	                        }
	                    }
	                }, _callee, this);
	            }));
	
	            function downloadCertificate() {
	                return _ref.apply(this, arguments);
	            }
	
	            return downloadCertificate;
	        }()
	    }]);
	    return GraduationController;
	}();
	
	exports.default = GraduationController;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(511);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./graduation.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./graduation.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".graduation__header{height:205px;width:100%;background-image:url(/assets/images/graduation-background.png);display:flex;align-items:flex-end}.graduation__header,.graduation__header-logo{background-repeat:no-repeat;background-size:cover}.graduation__header-logo{background-image:url(/assets/images/minto_logo_white.svg);width:124px;height:99px;margin-right:75px}.graduation__header-text-wrapper{max-width:1070px;margin:auto;width:-webkit-fill-available;display:flex;align-items:center}.graduation__header-text{font-family:Nexa-Bold,sans pro,\"serif\";font-weight:700;color:#fff;font-size:45px;line-height:50px}.graduation__content{margin:204px auto 90px;border-top:3px solid #760f61;border-bottom:3px solid #760f61;padding:100px 0;width:-webkit-fill-available;max-width:925px;display:flex;flex-direction:column;align-items:center}.graduation__content-cong{font-family:Nexa-Bold,sans pro,\"serif\";font-size:51px;letter-spacing:7px;line-height:60px;font-weight:700;color:#050e61}.graduation__content-user{font-size:35px!important;margin-top:0!important;letter-spacing:1px!important}.graduation__content-main{color:#050e61;font-family:Nexa-Bold,sans pro,\"serif\";font-size:30px;line-height:36px;text-align:center;letter-spacing:normal;margin-top:33px;font-weight:700}.graduation__content-main span{font-weight:700;text-transform:uppercase}.graduation__buttons{width:-webkit-fill-available;display:flex;justify-content:center}.graduation__buttons-certificate,.graduation__buttons-menu{font-family:Nexa-Bold,sans pro,\"serif\";cursor:pointer;font-weight:700;font-size:17px;line-height:17px;color:#fff;border-radius:15px;background-color:#760f61;padding-bottom:11px;padding-top:15px;text-transform:uppercase;margin-bottom:90px}.graduation__buttons-certificate{padding-left:13px;padding-right:13px;margin-right:13px}.graduation__buttons-menu{padding-left:32px;text-decoration:none;padding-right:32px}.graduation__footer{height:123px;width:100%;background-image:url(/assets/images/graduation-background.png);background-repeat:no-repeat;background-size:cover;background-position-y:99%}", ""]);
	
	// exports


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _cms = __webpack_require__(513);
	
	var _cms2 = _interopRequireDefault(_cms);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cmsModule = _angular2.default.module('cms', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('app.cms', {
	    url: '/admin/cms',
	    component: 'cms'
	  });
	}]).component('cms', _cms2.default).name;
	
	exports.default = cmsModule;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cms = __webpack_require__(514);
	
	var _cms2 = _interopRequireDefault(_cms);
	
	var _cms3 = __webpack_require__(515);
	
	var _cms4 = _interopRequireDefault(_cms3);
	
	__webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cmsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _cms2.default,
	  controller: _cms4.default
	};
	
	exports.default = cmsComponent;

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	module.exports = "\n\n"

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CmsController = function CmsController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, CmsController);
	};
	
	exports.default = CmsController;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(517);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cms.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./cms.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _concept = __webpack_require__(519);
	
	var _concept2 = _interopRequireDefault(_concept);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var conceptModule = _angular2.default.module('concept', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.concept', {
	    url: '/concept',
	    component: 'concept'
	  });
	}]).component('concept', _concept2.default).name;
	
	exports.default = conceptModule;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _concept = __webpack_require__(520);
	
	var _concept2 = _interopRequireDefault(_concept);
	
	var _concept3 = __webpack_require__(521);
	
	var _concept4 = _interopRequireDefault(_concept3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './concept.scss';
	
	var conceptComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _concept2.default,
	  controller: _concept4.default
	};
	
	exports.default = conceptComponent;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\n\t<mo-header title=\"concept\"></mo-header>\n\n\t<main class=\"content wrapper\">\n\n\t\t<mo-nav sticky=\"true\"></mo-nav>\n\n\t\t<section class=\"content-box\" ng-bind-html=\"'concept.text' | translate\"></section>\n\n\t</main>\n\n\n</div>"

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ConceptController = function ConceptController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, ConceptController);
	};
	
	exports.default = ConceptController;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _livecourse = __webpack_require__(523);
	
	var _livecourse2 = _interopRequireDefault(_livecourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var livecourseModule = _angular2.default.module('livecourse', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.live_course', {
	    url: '/live-course',
	    component: 'livecourse'
	  });
	}]).component('livecourse', _livecourse2.default).name;
	
	exports.default = livecourseModule;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _livecourse = __webpack_require__(524);
	
	var _livecourse2 = _interopRequireDefault(_livecourse);
	
	var _livecourse3 = __webpack_require__(525);
	
	var _livecourse4 = _interopRequireDefault(_livecourse3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './livecourse.scss';
	
	var livecourseComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _livecourse2.default,
	  controller: _livecourse4.default
	};
	
	exports.default = livecourseComponent;

/***/ }),
/* 524 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"live-minto-course container\">\n\n  <mo-header title=\"liveMintoCourse\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <mo-nav></mo-nav>\n    <section class=\"content-box\" translate>livecourse.text</section>\n  </main>\n\n</div>\n"

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LivecourseController = function LivecourseController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, LivecourseController);
	};
	
	exports.default = LivecourseController;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _textbook = __webpack_require__(527);
	
	var _textbook2 = _interopRequireDefault(_textbook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textbookModule = _angular2.default.module('textbook', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.textbook', {
	    url: '/textbook',
	    component: 'textbook'
	  });
	}]).component('textbook', _textbook2.default).name;
	
	exports.default = textbookModule;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _textbook = __webpack_require__(528);
	
	var _textbook2 = _interopRequireDefault(_textbook);
	
	var _textbook3 = __webpack_require__(529);
	
	var _textbook4 = _interopRequireDefault(_textbook3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var textbookComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _textbook2.default,
	  controller: _textbook4.default
	};
	
	exports.default = textbookComponent;

/***/ }),
/* 528 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container minto-textbook\">\n\n\t<mo-header title=\"textbook\"></mo-header>\n\n\t<main class=\"content wrapper\">\n\n\t\t<mo-nav sticky=\"true\"></mo-nav>\n\n\t\t<section class=\"content-box\">\n\t\t\t<div class=\"inner-text\" ng-bind-html=\"'textbook.text' | translate\"></div>\n\t\t\t<section class=\"proposals\">\n\t\t\t\t<div class=\"proposal\">\n\t\t\t\t\t<img src=\"/assets/images/minto-textbook-logo.jpg\" alt=\"\" class=\"proposal-logo\">\n\t\t\t\t\t<form action=\"https://www.paypal.com/cgi-bin/webscr\" method=\"post\">\n\t\t\t\t\t\t<input type=\"hidden\" name=\"cmd\" value=\"_s-xclick\">\n\t\t\t\t\t\t<input type=\"hidden\" name=\"hosted_button_id\" value=\"PTJ4TLS36VYU6\">\n\t\t\t\t\t\t<input type=\"submit\" class=\"m__button\" value=\"Buy now\" name=\"submit\" alt=\"PayPal - The safer, easier way to pay online!\">\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"proposal\">\n\t\t\t\t\t<img src=\"/assets/images/minto-textbook-logo-es.jpg\" alt=\"\" class=\"proposal-logo\">\n\t\t\t\t\t<form action=\"https://www.paypal.com/cgi-bin/webscr\" method=\"post\">\n\t\t\t\t\t\t<input type=\"hidden\" name=\"cmd\" value=\"_s-xclick\">\n\t\t\t\t\t\t<input type=\"hidden\" name=\"hosted_button_id\" value=\"LGH5MQ5A7L4QN\">\n\t\t\t\t\t\t<input type=\"submit\" class=\"m__button\" value=\"Buy now\" name=\"submit\" alt=\"PayPal - The safer, easier way to pay online!\">\n\t\t\t\t\t</form>\n\t\t\t\t</div>\n\t\t\t\t<p class=\"proposal-heading proposal-heading--minto-textbook\">An edition in Spanish is also available for $100 plus postage from New York.</p>\n\t\t\t</section>\n\n\t\t</section>\n\n\t</main>\n\n</div>"

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TextbookController = function TextbookController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, TextbookController);
	};
	
	exports.default = TextbookController;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _summary = __webpack_require__(531);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryModule = _angular2.default.module('summary', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.summary_app', {
	    url: '/summary-app',
	    component: 'summary'
	  });
	}]).component('summary', _summary2.default).name;
	
	exports.default = summaryModule;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _summary = __webpack_require__(532);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _summary3 = __webpack_require__(533);
	
	var _summary4 = _interopRequireDefault(_summary3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summaryComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _summary2.default,
	  controller: _summary4.default
	};
	
	exports.default = summaryComponent;

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container summary-app\">\n\n  <mo-header title=\"summary\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <mo-nav sticky=\"true\"></mo-nav>\n\n    <section class=\"content-box\">\n      <div class=\"inner-text\" ng-bind-html=\"'summary.text' | translate\"></div>\n      <section class=\"proposals\">\n        <div class=\"proposal\">\n          <p class=\"proposal-heading\">Apple.</p>\n          <a class=\"proposal-applogo\" ng-include target=\"_blank\" href=\"https://itunes.apple.com/us/app/minto/id538500088?mt=8\"  src=\"'/assets/images/minto_logo_white.svg'\"></a>\n\n        </div>  \n        <div class=\"proposal\">\n          <p class=\"proposal-heading\">Android.</p>\n          <a class=\"proposal-applogo\" ng-include target=\"_blank\" href=\"https://play.google.com/store/apps/details?id=com.barbaraminto.mobile\" src=\"'/assets/images/minto_logo_white.svg'\"></a>\n        </div>\n      </section>\n    </section>\n\n  </main>\n\n</div>"

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummaryController = function SummaryController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, SummaryController);
	};
	
	exports.default = SummaryController;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _barbara = __webpack_require__(535);
	
	var _barbara2 = _interopRequireDefault(_barbara);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barbaraModule = _angular2.default.module('barbara', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.barbara_minto', {
	    url: '/about-barbara',
	    component: 'barbara'
	  });
	}]).component('barbara', _barbara2.default).name;
	
	exports.default = barbaraModule;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _barbara = __webpack_require__(536);
	
	var _barbara2 = _interopRequireDefault(_barbara);
	
	var _barbara3 = __webpack_require__(537);
	
	var _barbara4 = _interopRequireDefault(_barbara3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var barbaraComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _barbara2.default,
	  controller: _barbara4.default
	};
	
	exports.default = barbaraComponent;

/***/ }),
/* 536 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container about-barbara\">\n\n  <mo-header title=\"barbara_minto\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <mo-nav></mo-nav>\n\n    <section class=\"content-box\">\n      <img src=\"/assets/images/barbara_minto2.jpg\" alt=\"Barbara Minto\" class=\"barbara-image\">\n      <div class=\"barbara-about\" ng-bind-html=\"'barbara.text' | translate\"></div>\n    </section>\n    <img src=\"/assets/images/barbarasignature.png\" alt=\"Barbara Minto\" class=\"barbara-image\">\n\n  </main>\n\n</div>"

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BarbaraController = function BarbaraController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, BarbaraController);
	};
	
	exports.default = BarbaraController;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _homepage = __webpack_require__(539);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homepageModule = _angular2.default.module('homepage', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.homepage', {
	    url: '/',
	    component: 'homepage'
	  });
	}]).component('homepage', _homepage2.default).name;
	
	exports.default = homepageModule;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _homepage = __webpack_require__(540);
	
	var _homepage2 = _interopRequireDefault(_homepage);
	
	var _homepage3 = __webpack_require__(541);
	
	var _homepage4 = _interopRequireDefault(_homepage3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var homepageComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _homepage2.default,
	  controller: _homepage4.default
	};
	
	exports.default = homepageComponent;

/***/ }),
/* 540 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container homepage\">\n\n  <mo-header></mo-header>\n\n  <main class=\"content wrapper\">\n    <section class=\"content-box\">\n      <h1 class=\"content-caption\">Welcome</h1>\n      <p class=\"content-text\">The Minto Pyramid Principle is the world famous system for putting your thinking clearly in writing</p>\n    </section>\n\n    <section class=\"homepage-boxes\">\n\n\n        <a class=\"homepage-box\" ui-sref=\"site.concept\">\n          <p class=\"homepage-box__text\">Concept</p>\n        </a>\n        <a class=\"homepage-box\" ui-sref=\"site.online_course\">\n          <p class=\"homepage-box__text\">Online Course</p>\n        </a>\n        <a class=\"homepage-box\" ui-sref=\"site.summary_app\">\n          <p class=\"homepage-box__text\">Summary App</p>\n        </a>\n\n\n\n\n        <a class=\"homepage-box\" ui-sref=\"site.live_course\">\n          <p class=\"homepage-box__text\">Live Course</p>\n        </a>\n        <a class=\"homepage-box\" ui-sref=\"site.textbook\">\n          <p class=\"homepage-box__text\">Textbook</p>\n        </a>\n\n        <div class=\"homepage-box__littleboxes\">\n          <a class=\"homepage-box__littlebox\" ui-sref=\"site.barbara_minto\">\n            <p class=\"homepage-box__text homepage-box__text--littlebox\">Barbara Minto</p>\n          </a>\n          <a class=\"homepage-box__littlebox\" ui-sref=\"site.contact\">\n            <p class=\"homepage-box__text homepage-box__text--littlebox\">Contact</p>\n          </a>\n        </div>\n\n\n\n    </section>\n  </main>\n\n</div>\n"

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HomepageController = function () {
	  HomepageController.$inject = ["helperService"];
	  function HomepageController(helperService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HomepageController);
	    (0, _assign2.default)(this, { helperService: helperService });
	  }
	
	  (0, _createClass3.default)(HomepageController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.helperService.shutdownIntercom();
	    }
	  }]);
	  return HomepageController;
	}();
	
	exports.default = HomepageController;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _contact = __webpack_require__(543);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactModule = _angular2.default.module('contact', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.contact', {
	    url: '/contact',
	    component: 'contact'
	  });
	}]).component('contact', _contact2.default).name;
	
	exports.default = contactModule;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contact = __webpack_require__(544);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _contact3 = __webpack_require__(545);
	
	var _contact4 = _interopRequireDefault(_contact3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _contact2.default,
	  controller: _contact4.default
	};
	
	exports.default = contactComponent;

/***/ }),
/* 544 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container contact\">\n\n    <mo-header title=\"contact\"></mo-header>\n\n    <main class=\"content wrapper\">\n\n        <mo-nav></mo-nav>\n        <div class=\"contact-section-wrapper\">\n            <section class=\"contact-section\">\n                <div class=\"content-caption-box\">\n                    <h3 class=\"content-caption\" translate>contact.caption</h3>\n                </div>\n                <!--andrei@terentyev.net-->\n                <form ng-submit=\"vm.sendForm()\">\n                    <div class=\"contacts-input-box bg__white\">\n                        <div class=\"field-wrap field-wrap_email\">\n                            <input name=\"name\" placeholder=\"Name:\" type=\"text\" ng-model=\"vm.name\" required autocomplete=\"off\" />\n                        </div>\n                        <div class=\"field-wrap field-wrap_email\">\n                            <input name=\"email\" placeholder=\"Email:\" type=\"email\" ng-model=\"vm.email\" required autocomplete=\"off\" />\n                        </div>\n                        <div class=\"field-wrap field-wrap_pass\">\n                            <input name=\"subject\" placeholder=\"Subject:\" type=\"text\" ng-model=\"vm.subject\" required autocomplete=\"off\" />\n                        </div>\n                        <div class=\"field-wrap field-wrap--after\">\n                            <textarea class=\"input-message__fild\" name=\"message\" id=\"message\" ng-model=\"vm.message\" placeholder=\"Message:\"></textarea>\n                            <div class=\"textarea__send\">\n                                <button class=\"textarea__send__link\" type=\"submit\">Send <span>></span></button>\n                            </div>\n                        </div>\n                    </div>\n                </form>\n            </section>\n\n            <section class=\"contact-adresses\">\n                <div class=\"contact-adress\" translate>contact.adress-1</div>\n                <div class=\"contact-adress contact-adress--position\" translate>contact.adress-2</div>\n            </section>\n        </div>\n    </main>\n\n\n</div>"

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactController = function () {
	  ContactController.$inject = ["helperService"];
	  function ContactController(helperService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ContactController);
	    (0, _assign2.default)(this, { helperService: helperService });
	  }
	
	  (0, _createClass3.default)(ContactController, [{
	    key: 'sendForm',
	    value: function sendForm() {
	      var email = '\nUser name: ' + this.name + '\nUser email: ' + this.email + '\nSubject: ' + this.subject + '\nMessage: ' + this.message + '\n    ';
	      this.helperService.sendEmail({
	        recipient_email: this.email,
	        subject: this.subject,
	        message: email
	      }).then(function (data) {
	        console.log(1);
	      });
	    }
	  }]);
	  return ContactController;
	}();
	
	exports.default = ContactController;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _press = __webpack_require__(547);
	
	var _press2 = _interopRequireDefault(_press);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pressModule = _angular2.default.module('press', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.press', {
	    url: '/press',
	    component: 'press'
	  });
	}]).component('press', _press2.default).name;
	
	exports.default = pressModule;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _press = __webpack_require__(548);
	
	var _press2 = _interopRequireDefault(_press);
	
	var _press3 = __webpack_require__(549);
	
	var _press4 = _interopRequireDefault(_press3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pressComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _press2.default,
	  controller: _press4.default
	};
	
	exports.default = pressComponent;

/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container press\">\n\n    <mo-header title=\"press\"></mo-header>\n\n    <main class=\"content wrapper\">\n        <aside class=\"right-aside\">\n            <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n        </aside>\n\n        <section class=\"content-box\" ng-bind-html=\"'press.text' | translate\"></section>\n\n    </main>\n\n</div>\n"

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PressController = function PressController() {
	  (0, _classCallCheck3.default)(this, PressController);
	};
	
	exports.default = PressController;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _tc = __webpack_require__(551);
	
	var _tc2 = _interopRequireDefault(_tc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tcModule = _angular2.default.module('tc', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.tc', {
	    url: '/t&c',
	    component: 'tc'
	  });
	}]).component('tc', _tc2.default).name;
	
	exports.default = tcModule;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tc = __webpack_require__(552);
	
	var _tc2 = _interopRequireDefault(_tc);
	
	var _tc3 = __webpack_require__(553);
	
	var _tc4 = _interopRequireDefault(_tc3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var tcComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _tc2.default,
	  controller: _tc4.default
	};
	
	exports.default = tcComponent;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container TCs\">\n\n  <mo-header title=\"T&Cs\"></mo-header>\n\n  <main class=\"content wrapper\">\n    <aside class=\"right-aside\">\n      <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n    </aside>\n\n    <section class=\"content-box\" ng-bind-html=\"'tc.text' | translate\"></section>\n\n  </main>\n\n</div>\n"

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TcController = function TcController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, TcController);
	};
	
	exports.default = TcController;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _policies = __webpack_require__(555);
	
	var _policies2 = _interopRequireDefault(_policies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var policiesModule = _angular2.default.module('policies', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.policies', {
	    url: '/policies',
	    component: 'policies'
	  });
	}]).component('policies', _policies2.default).name;
	
	exports.default = policiesModule;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _policies = __webpack_require__(556);
	
	var _policies2 = _interopRequireDefault(_policies);
	
	var _policies3 = __webpack_require__(557);
	
	var _policies4 = _interopRequireDefault(_policies3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var policiesComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _policies2.default,
	  controller: _policies4.default
	};
	
	exports.default = policiesComponent;

/***/ }),
/* 556 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container policies\">\n  <mo-header title=\"policies\"></mo-header>\n  <main class=\"content wrapper\">\n    <aside class=\"right-aside\">\n      <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n    </aside>\n    <section class=\"content-box\" ng-bind-html=\"'policies.text' | translate\"></section>\n  </main>\n</div>\n"

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PoliciesController = function PoliciesController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, PoliciesController);
	};
	
	exports.default = PoliciesController;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _workbook = __webpack_require__(559);
	
	var _workbook2 = _interopRequireDefault(_workbook);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workbookModule = _angular2.default.module('workbook', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state('site.workbook_course', {
	        url: '/workbook-course',
	        component: 'workbook'
	    });
	}]).component('workbook', _workbook2.default).name;
	
	exports.default = workbookModule;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _workbook = __webpack_require__(560);
	
	var _workbook2 = _interopRequireDefault(_workbook);
	
	var _workbook3 = __webpack_require__(561);
	
	var _workbook4 = _interopRequireDefault(_workbook3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var workbookComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _workbook2.default,
	  controller: _workbook4.default
	};
	
	exports.default = workbookComponent;

/***/ }),
/* 560 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container workbook__course\">\n\n    <mo-header title=\"workbook\"></mo-header>\n\n    <main class=\"content wrapper\">\n\n        <mo-nav sticky=\"true\"></mo-nav>\n\n        <section class=\"content-box\">\n            <div class=\"inner-text\" ng-bind-html=\"'workbook.text' | translate\"></div>\n            <section class=\"proposals\">\n                <div class=\"proposal\">\n                    <img src=\"/assets/images/mintopyramidcourse.jpg\" alt=\"\" class=\"proposal-logo\">\n                    <!-- start - paypal button -->\n                    <form action=\"https://www.paypal.com/cgi-bin/webscr\" method=\"post\">\n                        <input type=\"hidden\" name=\"cmd\" value=\"_s-xclick\">\n                        <input type=\"hidden\" name=\"hosted_button_id\" value=\"R6R54YH9WHHPA\">\n                        <input type=\"submit\" class=\"m__button\" value=\"Buy now\" name=\"submit\" alt=\"PayPal - The safer, easier way to pay online!\">\n                    </form>\n                    <!-- end - paypal button -->\n                </div>\n            </section>\n        </section>\n\n    </main>\n\n</div>"

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WorkbookController = function WorkbookController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, WorkbookController);
	};
	
	exports.default = WorkbookController;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _buy = __webpack_require__(563);
	
	var _buy2 = _interopRequireDefault(_buy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buyModule = _angular2.default.module('buy', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state('site.buy_course', {
	        url: '/L95BE[a<eg',
	        component: 'buy'
	    });
	}]).component('buy', _buy2.default).name;
	
	exports.default = buyModule;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _buy = __webpack_require__(564);
	
	var _buy2 = _interopRequireDefault(_buy);
	
	var _buy3 = __webpack_require__(565);
	
	var _buy4 = _interopRequireDefault(_buy3);
	
	__webpack_require__(566);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buyComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _buy2.default,
	  controller: _buy4.default
	};
	
	exports.default = buyComponent;

/***/ }),
/* 564 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"buy-the-course\" class=\"container buy-the-course\">\n\n\t<mo-header title=\"buy\"></mo-header>\n  <toaster-container></toaster-container>\n\n\t<main class=\"content wrapper\">\n\n\t\t<section class=\"underheader wrapper\">\n\t\t\t<a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n\n\t\t\t<h3 class=\"content-heading\">Thank you for choosing to purchase\n\t\t\t\t<br>the Minto Pyramid Principle online course.</h3>\n\t\t\t<p class=\"content-text\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt\n\t\t\t\tut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit\n\t\t\t\tlobortis nisl ut</p>\n\t\t</section>\n\n\t\t<section class=\"payment-section\">\n\t\t\t<form name=\"vm.registration\">\n\t\t\t\t<!-- <label class=\"field_file\">\n          <input type=\"file\" /> Add\n          <br>Photo Profile\n        </label> -->\n\t\t\t\t<div class=\"contacts-input-box bg__white\">\n\t\t\t\t\t<div class=\"field-wrap field-wrap_email\">\n\t\t\t\t\t\t<label>First name:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.firstName\" placeholder=\"\" type=\"text\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"field-wrap field-wrap_email\">\n\t\t\t\t\t\t<label>Last name:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.lastName\" type=\"text\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"field-wrap field-wrap_email\">\n\t\t\t\t\t\t<label>Job Title:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.job\" type=\"text\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"field-wrap field-wrap_pass\">\n\t\t\t\t\t\t<label>Company:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.company\" type=\"text\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- <div class=\"field-wrap field-wrap_address\">\n            <textarea placeholder=\"Billing address:\" type=\"\" required autocomplete=\"off\"></textarea>\n          </div> -->\n\t\t\t\t\t<div class=\"field-wrap field-wrap_pass\">\n\t\t\t\t\t\t<label>Email:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.email\" type=\"email\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"field-wrap field-wrap_pass\">\n\t\t\t\t\t\t<label>Password:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.password\" type=\"password\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"field-wrap field-wrap--last field-wrap_pass\">\n\t\t\t\t\t\t<label>Password confirmation:*</label>\n\t\t\t\t\t\t<input ng-model=\"vm.registration.passwordConfirmation\" type=\"password\" required autocomplete=\"off\" />\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>\n\n\t\t\t<div class=\"payment-boxes\">\n\t\t\t\t<!-- <div class=\"payment-box1\">\n          <h3 class=\"content-heading content-heading--payment-num\">Number of courses:</h3>\n          <div class=\"counter-box\">\n            <p class=\"counter-value\"></p>\n          </div>\n          <br>\n          <h3 class=\"content-heading content-heading--payment-sum\">Total payable:</h3>\n          <div class=\"payment-value-box\">\n            <p class=\"payment-value__count\">£ 750.00</p>\n          </div>\n        </div> -->\n\n\t\t\t\t<div class=\"payment-mode-box\">\n\t\t\t\t\t<div class=\"payment-boxes__errors\">\n\t\t\t\t\t\t<div ng-if=\"vm.loading\">Loading...</div>\n\t\t\t\t\t\t<div class=\"payment-boxes__error\" ng-repeat=\"error in vm.errors\" ng-bind=\"error\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- <a href=\"\" class=\"payment-button\">Confirm & Pay</a> -->\n\t\t\t\t\t<button ng-disabled=\"{{vm.registration.$invalid}}\" ng-click=\"vm.submit()\" class=\"payment-button\">Sign Up</button>\n\n\t\t\t\t\t<!-- <a href=\"\" class=\"payment-mode payment-mode--first\">\n            <img src=\"/assets/images/buy-the-course_visa.png\" alt=\"\" class=\"payment-mode__img\">\n          </a>\n          <a href=\"\" class=\"payment-mode\">\n            <img src=\"/assets/images/buy-the-course_mastercard.png\" alt=\"\" class=\"payment-mode__img\">\n          </a>\n          <a href=\"\" class=\"payment-mode\">\n            <img src=\"/assets/images/buy-the-course_paypal.png\" alt=\"\" class=\"payment-mode__img\">\n          </a>\n          <a href=\"\" class=\"payment-mode\">\n            <img src=\"/assets/images/buy-the-course_americanexpress.png\" alt=\"\" class=\"payment-mode__img\">\n          </a> -->\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</section>\n\n\t</main>\n\n</div>\n"

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BuyController = function () {
	    BuyController.$inject = ["authService", "$state", "$cookies", "$q", "GlobalRedirects", "toaster"];
	    function BuyController(authService, $state, $cookies, $q, GlobalRedirects, toaster) {
	        'ngInject';
	
	        (0, _classCallCheck3.default)(this, BuyController);
	        (0, _assign2.default)(this, { authService: authService, $state: $state, $cookies: $cookies, $q: $q, GlobalRedirects: GlobalRedirects, toaster: toaster });
	        this.registration = {};
	        this.errors = [];
	        this.loading = false;
	    }
	
	    (0, _createClass3.default)(BuyController, [{
	        key: 'submit',
	        value: function submit() {
	            var _this = this;
	
	            if (this.registration.$invalid) {
	                this.toaster.pop('error', "Registration failed", 'Some fields are invalid', 4000, 'trustedHtml');
	                var elements = document.querySelectorAll('#buy-the-course .ng-untouched');
	                if (!elements || !elements.length) {
	                    return;
	                }
	                var $elements = $(elements);
	                $elements.removeClass('ng-untouched');
	                $elements.addClass('ng-touched');
	                return;
	            }
	            this.errors = [];
	            this.loading = true;
	            this.authService.register({
	                user: {
	                    'firstName': this.registration.firstName,
	                    'lastName': this.registration.lastName,
	                    'email': this.registration.email,
	                    'password': this.registration.password,
	                    'passwordConfirmation': this.registration.passwordConfirmation
	                }
	            }).then(function (data) {
	                if (data.errors) {
	                    _this.errors = data.errors;
	                    _this.loading = false;
	                } else {
	                    _this.authService.login({
	                        user: {
	                            'email': _this.registration.email,
	                            'password': _this.registration.password
	                        }
	                    }).then(function (data) {
	                        _this.$state.isJustRegistered = true;
	                        _this.$state.userFirstName = _this.registration.firstName;
	                        _this.$state.go(_this.GlobalRedirects.AFTER_LOGIN);
	                    });
	                }
	            }).catch(function (error) {
	                _this.loading = false;
	                console.log(error);
	            });
	        }
	    }]);
	    return BuyController;
	}();
	
	exports.default = BuyController;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(567);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./buy.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./buy.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#buy-the-course input.ng-touched.ng-invalid{border-color:red!important}", ""]);
	
	// exports


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _testimonials = __webpack_require__(569);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var testimonialsModule = _angular2.default.module('testimonials', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.testimonials', {
	    url: '/testimonials',
	    component: 'testimonials'
	  });
	}]).component('testimonials', _testimonials2.default).name;
	
	exports.default = testimonialsModule;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _testimonials = __webpack_require__(570);
	
	var _testimonials2 = _interopRequireDefault(_testimonials);
	
	var _testimonials3 = __webpack_require__(571);
	
	var _testimonials4 = _interopRequireDefault(_testimonials3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var testimonialsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _testimonials2.default,
	  controller: _testimonials4.default
	};
	
	exports.default = testimonialsComponent;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container testimonials\">\n\n  <mo-header title=\"testimonials\"></mo-header>\n\n  <main class=\"content wrapper\">\n    <aside class=\"right-aside\">\n      <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n      <a ui-sref=\"site.buy_course\" class=\"m__button\">Buy Now</a>\n    </aside>\n\n    <section class=\"content-box\">\n      <div class=\"content-caption-box\">\n        <h3 class=\"content-caption\">What people say about the Minto Pyramid Course</h3>\n      </div>\n      <h3 class=\"content-heading\">Sarah Jones</h3>\n      <h3 class=\"content-subheading\">Completed the course in 2016</h3>\n      <p class=\"content-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae aliquet urna, rutrum facilisis lacus. Fusce non\n        augue hendrerit, porttitor turpis ut, faucibus libero. Cras tristique dolor vitae elementum ornare. Nam imperdiet\n        sagittis ex. Suspendisse rhoncus faucibus viverra. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi\n        nec est velit. Integer commodo purus at congue hendrerit. Ut tincidunt nunc cursus, finibus erat eu, interdum eros.\n        Suspendisse bibendum, mi sed vulputate varius, sem leo fringilla justo, vitae finibus neque ligula scelerisque orci.\n        Integer pharetra vel sem sed facilisis. Integer condimentum pulvinar quam non aliquet. Vestibulum sit amet maximus\n        sem. Praesent non nulla consequat, rutrum leo ac, auctor enim. Etiam ac pretium erat. Integer eu felis nec quam bibendum\n        mattis in eu metus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vitae aliquet urna, rutrum\n        facilisis lacus. Fusce non augue hendrerit, porttitor turpis ut, faucibus libero. Cras tristique dolor vitae elementum\n        ornare. Nam imperdiet sagittis ex.\n      </p>\n    </section>\n\n  </main>\n\n</div>\n"

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestimonialsController = function TestimonialsController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, TestimonialsController);
	  this.background = 'https://cs7059.vk.me/c604518/v604518254/3a85a/30gmpkOKxf8.jpg';
	  this.text = [["Reschedule todays meeting to Thursday at 11:00"], ["More convenient for JC and HJ", "Permits DC to attend", "Room free"]];
	  this.answers = [[0, 1], [0, 2], [0, 3]];
	  this.completed = true;
	  this.section = 1;
	  this.exercise = 1;
	};
	
	exports.default = TestimonialsController;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _onlineCourse = __webpack_require__(573);
	
	var _onlineCourse2 = _interopRequireDefault(_onlineCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlineCourseModule = _angular2.default.module('onlineCourse', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state('site.online_course', {
	        url: '/online-course',
	        component: 'onlineCourse'
	    });
	}]).component('onlineCourse', _onlineCourse2.default).name;
	
	exports.default = onlineCourseModule;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _onlineCourse = __webpack_require__(574);
	
	var _onlineCourse2 = _interopRequireDefault(_onlineCourse);
	
	var _onlineCourse3 = __webpack_require__(575);
	
	var _onlineCourse4 = _interopRequireDefault(_onlineCourse3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './livecourse.scss';
	
	var onlineCourseComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _onlineCourse2.default,
	  controller: _onlineCourse4.default
	};
	
	exports.default = onlineCourseComponent;

/***/ }),
/* 574 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container online-course\">\n\n    <mo-header title=\"online\"></mo-header>\n\n    <main class=\"content wrapper\">\n\n        <mo-nav sticky=\"true\"></mo-nav>\n\n        <section class=\"content-box\">\n            <div class=\"content-box inner-text\" ng-bind-html=\"'online.text' | translate\"></div>\n            <div class=\"online__course-menu\">\n              <a class=\"online__course-menu-item {{item.value}} {{item.column}}\" ng-bind-html=\"'online.' + item.value | translate \" class=\"menu-item\" ng-repeat=\"item in vm.menu | filter: { value: '!barbara_minto' }\"\n                    ui-sref=\"{{item.link}}\">\n                </a>\n              <label class=\"online__course-menu-item {{vm.barbara.value}} {{vm.barbara.column}}\" ng-bind-html=\"'online.' + vm.barbara.value | translate \" for=\"public-video\" onclick=\"toggleVideo();\"></label>\n            </div>\n            <input type='checkbox' id='public-video' class='modal-video-trigger'/>\n            <div class='video-block' id='video-block'>\n              <div class='video-wrapper'>\n                <label class='close-button' for='public-video' onclick=\"toggleVideo('hide');\">×</label>\n                <iframe width='915px' height='515px'\n                  src=\"https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1\" frameborder=\"0\" allowfullscreen>\n                </iframe>\n              </div>\n            </div>\n        </section>\n    </main>\n</div>\n<script>\n  function toggleVideo(state) {\n  // if state == 'hide', hide. Else: show video\n  var div = document.getElementById(\"video-block\");\n  var iframe = div.getElementsByTagName(\"iframe\")[0].contentWindow;\n  div.style.display = state == 'hide' ? 'none' : '';\n  func = state == 'hide' ? 'pauseVideo' : 'playVideo';\n  iframe.postMessage('{\"event\":\"command\",\"func\":\"' + func + '\",\"args\":\"\"}','*');\n}\n</script>\n"

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var onlineCourseController = function onlineCourseController() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, onlineCourseController);
	    this.menu = [{
	        link: 'auth.login',
	        value: 'login',
	        column: 'column-1'
	    }, {
	        link: 'site.try_course',
	        value: 'try_course',
	        column: 'column-2'
	    }, {
	        link: 'site.testimonials',
	        value: 'testimonials',
	        column: 'column-3'
	    }, {
	        link: 'site.barbara_minto',
	        value: 'barbara_minto',
	        column: 'column-1'
	    }, {
	        link: 'site.buy_course',
	        value: 'buy_course',
	        column: 'column-2'
	    }, {
	        link: 'site.corporate-inquiry',
	        value: 'corporate_inquiry',
	        column: 'column-3'
	    }];
	
	    this.barbara = this.menu[3];
	};
	
	exports.default = onlineCourseController;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _corporateInquiry = __webpack_require__(577);
	
	var _corporateInquiry2 = _interopRequireDefault(_corporateInquiry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var corporateInquiryModule = _angular2.default.module('corporateInquiry', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state('site.corporate-inquiry', {
	        url: '/corporate-inquiry',
	        component: 'corporateInquiry'
	    });
	}]).component('corporateInquiry', _corporateInquiry2.default).name;
	
	exports.default = corporateInquiryModule;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _corporateInquiry = __webpack_require__(578);
	
	var _corporateInquiry2 = _interopRequireDefault(_corporateInquiry);
	
	var _corporateInquiry3 = __webpack_require__(579);
	
	var _corporateInquiry4 = _interopRequireDefault(_corporateInquiry3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var corporateInquiryComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _corporateInquiry2.default,
	  controller: _corporateInquiry4.default
	};
	
	exports.default = corporateInquiryComponent;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container corporate-inquiry\">\n\n    <mo-header title=\"corporate_inquiry\"></mo-header>\n\n    <main class=\"content wrapper\">\n\n        <aside class=\"right-aside\">\n            <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n        </aside>\n\n        <section class=\"content-box\">\n            <div class=\"content-caption-box\">\n                <h3 class=\"content-caption\">Use this form to get in contact about buying online courses for your organisation</h3>\n            </div>\n\n            <form action=\"/\" method=\"post\">\n                <div class=\"contacts-input-box bg__white\">\n                    <div class=\"field-wrap field-wrap_email\">\n                        <input placeholder=\"Name/Company:\" type=\"email\" required autocomplete=\"off\" />\n                    </div>\n                    <div class=\"field-wrap field-wrap_email\">\n                        <input placeholder=\"Email:\" type=\"email\" required autocomplete=\"off\" />\n                    </div>\n                    <div class=\"field-wrap field-wrap_pass\">\n                        <input placeholder=\"Numbers of students:\" type=\"password\" required autocomplete=\"off\" />\n                    </div>\n                    <div class=\"field-wrap field-wrap--after\">\n                        <textarea class=\"input-message__fild\" name=\"message\" id=\"message\" tabindex=\"4\" placeholder=\"Message:\"></textarea>\n                        <div class=\"textarea__send\">\n                            <a class=\"textarea__send__link\" href=\"\">Send</a>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </section>\n\n        <section class=\"contact-adresses\">\n            <div class=\"contact-adress\">\n                <h3 class=\"contact-adress__head\">London Office (MAIN):</h3>\n                <p class=\"contact-adress__info\">Minto International, Inc.\n                    <br>19 Cadogan Place\n                    <br>London SW1X 9SA UK\n                    <br>Tel: +44 (0)207 235 6274\n                <!--<br>email: inquiries@barbaraminto.com-->\n                </p>\n            </div>\n\n            <div class=\"contact-adress contact-adress--position\">\n                <h3 class=\"contact-adress__head\">Virginia Office:</h3>\n                <p class=\"contact-adress__info\">\n                    Minto International, Inc.\n                    <br>215 Brooke Avenue. No. 609\n                    <br>Norfolk, VA 23510 USA\n                    <br>Tel: +1 757 425 4511\n                    <!--<br>email: enquiries@barbaraminto.com-->\n                </p>\n            </div>\n        </section>\n    </main>\n\n</div>\n"

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CorporateInquiryController = function CorporateInquiryController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, CorporateInquiryController);
	};
	
	exports.default = CorporateInquiryController;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _error = __webpack_require__(581);
	
	var _error2 = _interopRequireDefault(_error);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var error404Module = _angular2.default.module('error404', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.error404', {
	    url: '/error404',
	    component: 'error404'
	  });
	}]).component('error404', _error2.default).name;
	
	exports.default = error404Module;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _error = __webpack_require__(582);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _error3 = __webpack_require__(583);
	
	var _error4 = _interopRequireDefault(_error3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var error404Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _error2.default,
	  controller: _error4.default
	};
	
	exports.default = error404Component;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container error404\">\n\n    <mo-header title=\"error404\"></mo-header>\n\n    <main class=\"content wrapper\">\n        <aside class=\"right-aside\">\n            <a href=\"\" onclick=\"history.go(-1);\" class=\"back__button\">Back</a>\n        </aside>\n\n        <section class=\"content-box\">\n            <div class=\"content-caption-box\">\n                <div class=\"error-callout\">\n                    <h3 class=\"error-text\">Doesn't look like anything to me...</h3>\n                </div>\n                <div class=\"error-callout-clear\">\n                </div>\n            <!--    <div class=\"rectangle-speech-border\">\n                     <p>test text</p>\n                </div>\n                -->\n            </div>\n\n\n        </section>\n\n    </main>\n\n</div>\n"

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Error404Controller = function Error404Controller() {
	  (0, _classCallCheck3.default)(this, Error404Controller);
	};
	
	exports.default = Error404Controller;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _thankYou = __webpack_require__(585);
	
	var _thankYou2 = _interopRequireDefault(_thankYou);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thankYouModule = _angular2.default.module('thankYou', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.thankYou', {
	    url: '/thank-you',
	    component: 'thankYou'
	  });
	}]).component('thankYou', _thankYou2.default).name;
	
	exports.default = thankYouModule;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _thankYou = __webpack_require__(586);
	
	var _thankYou2 = _interopRequireDefault(_thankYou);
	
	var _thankYou3 = __webpack_require__(587);
	
	var _thankYou4 = _interopRequireDefault(_thankYou3);
	
	__webpack_require__(588);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var thankYouComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _thankYou2.default,
	  controller: _thankYou4.default
	};
	
	exports.default = thankYouComponent;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container thank-you\">\n\n    <mo-header title=\"thankYou\"></mo-header>\n\n    <main class=\"content wrapper\">\n        <section class=\"content-box\">\n            <h3 class=\"content-heading\" translate>thank-you.caption</h3>\n            <p class=\"content-text\" translate>thank-you.text</p>\n            <p class=\"content-text\">\n                <a href=\"/\"><button translate>thank-you.main</button></a>\n                <a ui-sref=\"site.contact\"><button translate>thank-you.contact</button></a>\n            </p>\n        </section>\n\n    </main>\n\n</div>\n"

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ThankYouController = function ThankYouController() {
	  (0, _classCallCheck3.default)(this, ThankYouController);
	};
	
	exports.default = ThankYouController;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(589);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./thankYou.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./thankYou.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".thank-you .header{background-image:url(\"/assets/images/thank-you-bg.jpg\")}.thank-you h3.content-heading,.thank-you p.content-text{color:#1e2978}.thank-you .content-text{padding:50px 0 0 120px}.thank-you button{font-family:Nexa-Bold,sans pro,\"serif\";background-color:#020c7e;font-size:16px;color:#fff;padding:10px 30px 6px;margin-right:40px;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _paymentFailure = __webpack_require__(591);
	
	var _paymentFailure2 = _interopRequireDefault(_paymentFailure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentFailureModule = _angular2.default.module('paymentFailure', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.paymentFailure', {
	    url: '/payment-failure',
	    component: 'paymentFailure'
	  });
	}]).component('paymentFailure', _paymentFailure2.default).name;
	
	exports.default = paymentFailureModule;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _paymentFailure = __webpack_require__(592);
	
	var _paymentFailure2 = _interopRequireDefault(_paymentFailure);
	
	var _paymentFailure3 = __webpack_require__(593);
	
	var _paymentFailure4 = _interopRequireDefault(_paymentFailure3);
	
	__webpack_require__(594);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var paymentFailureComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _paymentFailure2.default,
	  controller: _paymentFailure4.default
	};
	
	exports.default = paymentFailureComponent;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container payment-failure\">\n\n    <mo-header title=\"paymentFailure\"></mo-header>\n\n    <main class=\"content wrapper\">\n        <section class=\"content-box\">\n            <h3 class=\"content-heading\" translate>payment-failure.caption</h3>\n            <p class=\"content-text\" translate>payment-failure.text</p>\n            <p class=\"content-text\">\n                <a href=\"/\"><button translate>payment-failure.main</button></a>\n                <a ui-sref=\"site.contact\"><button translate>payment-failure.contact</button></a>\n            </p>\n        </section>\n\n    </main>\n\n</div>\n"

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PaymentFailureController = function PaymentFailureController() {
	  (0, _classCallCheck3.default)(this, PaymentFailureController);
	};
	
	exports.default = PaymentFailureController;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(595);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentFailure.scss", function() {
				var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/index.js!./paymentFailure.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".payment-failure .header{background-image:url(\"/assets/images/thank-you-bg.jpg\")}.payment-failure h3.content-heading,.payment-failure p.content-text{color:#1e2978}.payment-failure .content-text{padding:50px 0 0 120px}.payment-failure button{font-family:Nexa-Bold,sans pro,\"serif\";background-color:#020c7e;font-size:16px;color:#fff;padding:10px 30px 6px;margin-right:40px;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _ngstorage = __webpack_require__(90);
	
	var _ngstorage2 = _interopRequireDefault(_ngstorage);
	
	var _login = __webpack_require__(597);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginModule = _angular2.default.module('login', [_angularjs2.default, 'ngStorage']).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('auth.login', {
	    url: '/login?message',
	    component: 'login',
	    resolve: { authenticate: _core.authenticate }
	  }).state('auth.logout', {
	    url: '/logout',
	    resolve: { logout: _core.logout }
	  });
	}]).component('login', _login2.default).name;
	
	exports.default = loginModule;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _login = __webpack_require__(598);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _login3 = __webpack_require__(599);
	
	var _login4 = _interopRequireDefault(_login3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loginComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _login2.default,
	  controller: _login4.default
	};
	
	exports.default = loginComponent;

/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"login\">\n  ​\n  <mo-header title=\"login\"></mo-header>\n  <toaster-container></toaster-container>\n  ​\n  <main class=\"content wrapper\">\n    ​\n    <section class=\"login-box\">\n      <p class=\"login__title\">Login</p>\n      ​\n      <div class=\"login__box\">\n        <div class=\"login__links\">\n          <img src=\"/assets/images/logo_login.png\" alt=\"Login logo\">\n<!--          <a tabindex=\"-1\" class=\"login__sign-up\" ui-sref=\"site.buy_course\" href=\"#!/buy-course\">Sign up</a>-->\n          <a tabindex=\"-1\" class=\"login__sign-up\">Sign up</a>\n          <span class=\"login__separator\">|</span>\n          <a tabindex=\"-1\" class=\"login__login_link\" href=\"\">Login</a>\n          ​\n        </div>\n        <form class=\"login__form\" novalidate name=\"vm.loginForm\">\n            <div class=\"form-div\">\n              <label class=\"form-div__label\">Email</label>\n              <input ng-model=\"vm.user.email\" class=\"form-div__input\" tabindex=\"1\" placeholder=\"Enter your email\" type=\"email\" required/>\n              <p class=\"form-div__error\" ng-class=\"{hide: vm.loginForm.$$controls[0].$valid || vm.loginForm.$$controls[0].$untouched}\">Enter correct email</p>\n              <a href=\"https://api-barbaraminto.i2mdev.com/users/password/new\" tabindex=\"4\" class=\"form-div__link\">Forgot your password?</a>\n            </div>\n            <div class=\"form-div\">\n              <label class=\"form-div__label\">Password</label>\n              <input ng-model=\"vm.user.password\" tabindex=\"2\" class=\"form-div__input\" placeholder=\"Enter your password\" type=\"password\" required ng-minlength=\"6\"/>\n              <p class=\"form-div__error\" ng-class=\"{hide: vm.loginForm.$$controls[1].$valid || vm.loginForm.$$controls[1].$untouched}\">Enter correct password</p>\n              <button type=\"submit\" tabindex=\"3\" ng-click=\"vm.login()\" class=\"form-div__link form-div__login\">Log In</button>\n            </div>\n        </form>\n        <div class=\"login__underline\"></div>\n      </div>\n    </section>\n  </main>\n  ​\n</div>\n"

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LoginController = function () {
	    LoginController.$inject = ["authService", "$state", "$cookies", "$q", "GlobalRedirects", "toaster"];
	    function LoginController(authService, $state, $cookies, $q, GlobalRedirects, toaster) {
	        'ngInject';
	
	        // this.user = {
	        //     email: 'superadmin@minto.com',
	        //     password: 'super_admin'
	        // };
	
	        (0, _classCallCheck3.default)(this, LoginController);
	        (0, _assign2.default)(this, { authService: authService, $state: $state, $cookies: $cookies, $q: $q, GlobalRedirects: GlobalRedirects, toaster: toaster });
	    }
	
	    (0, _createClass3.default)(LoginController, [{
	        key: 'login',
	        value: function login() {
	            var _this = this;
	
	            this.loginError = false;
	            if (this.loginForm.$valid) {
	                this.authService.login({ userName: this.user.email, password: this.user.password }).then(function (data) {
	                    if (!data) {
	                        _this.toaster.pop('error', "Authentication failed", 'Invalid Email or Password', 4000, 'trustedHtml');
	                        // this.$q.reject();
	                        throw 'Invalid Email or Password';
	                    }
	                }).then(function (data) {
	                    _this.$state.go(_this.GlobalRedirects.AFTER_LOGIN);
	                }).catch(function (error) {
	                    _this.loginError = true;
	                });
	            } else {
	                switch (true) {
	                    case !this.user:
	                        {
	                            this.loginForm.$$controls[0].$untouched = false;
	                            this.loginForm.$$controls[1].$untouched = false;
	                            break;
	                        }
	                    case !this.user.email:
	                        {
	                            this.loginForm.$$controls[0].$untouched = false;
	                        }
	                    case !this.user.password:
	                        {
	                            this.loginForm.$$controls[1].$untouched = false;
	                        }
	                }
	            }
	        }
	    }]);
	    return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _register = __webpack_require__(601);
	
	var _register2 = _interopRequireDefault(_register);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerModule = _angular2.default.module('register', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	    "ngInject";
	
	    $stateProvider.state('auth.register', {
	        url: '/register',
	        component: 'register'
	    });
	}]).component('register', _register2.default).name;
	
	exports.default = registerModule;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _register = __webpack_require__(602);
	
	var _register2 = _interopRequireDefault(_register);
	
	var _register3 = __webpack_require__(603);
	
	var _register4 = _interopRequireDefault(_register3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var registerComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _register2.default,
	  controller: _register4.default
	};
	
	exports.default = registerComponent;

/***/ }),
/* 602 */
/***/ (function(module, exports) {

	module.exports = "\n\n"

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RegisterController = function RegisterController() {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, RegisterController);
	};
	
	exports.default = RegisterController;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _help = __webpack_require__(605);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpModule = _angular2.default.module('help', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.help', {
	    url: '/help?section-id=:sectionId?prev-route=:prevRoute',
	    component: 'help',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('help', _help2.default).name;
	
	exports.default = helpModule;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _help = __webpack_require__(606);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _help3 = __webpack_require__(607);
	
	var _help4 = _interopRequireDefault(_help3);
	
	__webpack_require__(608);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _help2.default,
	  controller: _help4.default
	};
	
	exports.default = helpComponent;

/***/ }),
/* 606 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"help unit-5\">\n  <mo-header></mo-header>\n  <course-header hide-logo=\"true\"></course-header>\n\t<!--<div class=\"loading\" ng-show=\"vm.loading\"></div>-->\n  <main class=\"content wrapper\" ng-show=\"!vm.loading\">\n\n    <svg class=\"help__back-button\" viewBox=\"0 0 219.151 219.151\" ng-click=\"vm.goToPrevRoute()\" ng-class=\"{'help__back-button-disabled': !vm.prevRoute}\">\n      <g>\n        <path\n          d=\"M109.576,219.151c60.419,0,109.573-49.156,109.573-109.576C219.149,49.156,169.995,0,109.576,0S0.002,49.156,0.002,109.575   C0.002,169.995,49.157,219.151,109.576,219.151z M109.576,15c52.148,0,94.573,42.426,94.574,94.575   c0,52.149-42.425,94.575-94.574,94.576c-52.148-0.001-94.573-42.427-94.573-94.577C15.003,57.427,57.428,15,109.576,15z\"/>\n        <path\n          d=\"M94.861,156.507c2.929,2.928,7.678,2.927,10.606,0c2.93-2.93,2.93-7.678-0.001-10.608l-28.82-28.819l83.457-0.008   c4.142-0.001,7.499-3.358,7.499-7.502c-0.001-4.142-3.358-7.498-7.5-7.498l-83.46,0.008l28.827-28.825   c2.929-2.929,2.929-7.679,0-10.607c-1.465-1.464-3.384-2.197-5.304-2.197c-1.919,0-3.838,0.733-5.303,2.196l-41.629,41.628   c-1.407,1.406-2.197,3.313-2.197,5.303c0.001,1.99,0.791,3.896,2.198,5.305L94.861,156.507z\"/>\n      </g>\n    </svg>\n\n    <style>\n      p.section {\n        margin-top: 20px;\n        font-size: 160%\n      }\n\n      p.exercise {\n        margin-top: 10px;\n        margin-left: 30px;\n        font-size: 120%\n      }\n\n      p.text {\n        margin-bottom: 30px;\n        margin-left: 60px;\n      }\n    </style>\n\n\t\t<p class=\"section\" id=\"imposing-the-structure\">1A. Imposing The Structure</p>\n      <p class=\"exercise\">Exercise 1. Note to Mort (Demo)</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Retail Price Data Survey</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n       <p class=\"exercise\">Exercise 3. Electronic Filing</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Perfect Team Size</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"cementing-the-rules\">1B. Cementing The Rules</p>\n      <p class=\"exercise\">Exercise 1. Note to Mort</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Retail Price Data Survey</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n       <p class=\"exercise\">Exercise 3. Electronic Filing</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Perfect Team Size</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"picking-out-the-points\">1C. Picking Out The Points</p>\n      <p class=\"exercise\">Exercise 1. Firestone’s Commitment</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Property Rights</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Size Of The Cosmos</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Brands</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"grasping-the-message\">1D. Grasping The Message</p>\n      <p class=\"exercise\">Exercise 1. Chatty Chickens</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Enterprise Risk Management (ERM) Models</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Understanding Long-Term Memory</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. The Jacobite Rebellion</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. A Better Way To Die</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"ideas-fit-together\">2A. Ideas Fit Together</p>\n      <p class=\"exercise\">Exercise 1. On Pigs as Pets</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"creating-question\">2B. Creating Question</p>\n      <p class=\"exercise\">Exercise 1. Firestone’s Commitment</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Property Rights</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Size of the Cosmos</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Brands</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. A Better Way To Die</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 6. Chatty Chickens</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 7. Enterprise Risk Management (ERM) Models</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 8. Understanding Long-Term Memory</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 9. The Jacobite Rebellion</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"deductive-reasoning\">3A1. Deductive Reasoning</p>\n      <p class=\"exercise\">Tracing the Deductive Argument</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"summarizing-deductive\">3A2. Summarizing Deductive</p>\n      <p class=\"exercise\">Exercise 1. Digitization</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Paying Taxes</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Habits</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Music for Students</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. Monetary Policy</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"unearthing-embedded-arguments\">3A3. Unearthing Embedded Arguments</p>\n      <p class=\"exercise\">Exercise 1. Success Metrics</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Predictive Analysis</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Valuing Data</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Success in the Future</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. Inequality in America</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 6. Policy Uncertainty</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"inductive-reasoning\">3B1. Inductive Reasoning</p>\n      <p class=\"exercise\">Exercise 1. Bentham (example)</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Information Systems</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Pensions</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Fifteenth Century France vs Italy</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. The End of Classical Sculpture</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 6. The Chaos Revolution</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 7. The Fall of Lehman</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"identifying-inductive-points\">3B2. Identifying Inductive Points</p>\n      <p class=\"exercise\">Exercise 1. The Delusions of Entrepreneurs (i)</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. The Delusions of Entrepreneurs (ii)</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Why the Brain Prefers Paper</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. How Might We Search for Life on Mars</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. The First Search</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"induction-from-deduction\">3B3. Induction From Deduction</p>\n      <p class=\"exercise\">Exercise 1. Engineers’ Dreams</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. The Rise of Capitalism</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. The Power of Prototyping</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. The Delusions of Entrepreneurs (iii)</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. What We Lost</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 6. The Need for Hierarchies</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 7. The Invention of Hay</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"deduction-to-induction\">3B4. Deduction To Induction</p>\n      <p class=\"exercise\">Exercise 1. Policy Uncertainty</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Mind Tapes</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Can You Teach an Old Dog New Tricks?</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Euro Illusions</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. Banking on the State: The Philosopher’s Stone of Finance</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"avoiding-deductive-arguments\">3C. Avoiding Deductive Arguments</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"practice-in-seeing\">4A. Practice In Seeing</p>\n      <p class=\"exercise\">Exercise 1. Black Holes</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Entrepreneurs</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. The Optimal Office</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Alpha’s Ability to Control Costs</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. The Role of the Board</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"finding-readers-question\">4B1. Finding Readers Question</p>\n      <p class=\"exercise\">Exercise 1. Payoff from Product Management</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. The Rationalization Program</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Drilling for Methane</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"spotting-scq\">4B2. Spotting SCQ</p>\n      <p class=\"exercise\">Exercise 1. Whom Can You Trust?</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. What we had?</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Entrepreneurs</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Creativity as Theft</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 5. Is Your Budget Stuck on Last Year’s Numbers?</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 6. Going Slow to Go Fast</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 7. Marketing Myopia</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 8. Who Killed Pensions?</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 9. Epic Fails of the Start-up World</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 10. The TV Decline</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 11. Honour on the Campus</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 12. A Survey of IFA Attitudes</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"applying-scq-process\">4C1. Applying SCQ Process</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"practice-in-seeing-3\">4C2. Practice In Seeing 2</p>\n      <p class=\"exercise\">Exercise 1. Purchasing at Orlando</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Data Center Relocation - First Commerce Bank</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. PAGAM Property Disposal</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Domestic Bank’s Systems Strategy</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"define-problem\">5A. Define Problem</p>\n      <p class=\"exercise\">Exercise 1. Purchasing at Orlando</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. The Rationalization Program</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"practice-defining-problem\">5B. Practice Defining Problem</p>\n      <p class=\"exercise\">Exercise 1. The Sales Force Effectiveness Paradox</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Analysis of Technology Alternatives</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Advantage Survey Results and Action Plan</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"defining-more-complex-problems\">5C. Defining More Complex Problems</p>\n      <p class=\"exercise\">Exercise 1. Location-Based Learning Strategy</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. Cascade Group Health Care Plans</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Houston’s Information Systems Group</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 4. Spirit Business Systems</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\t\t<p class=\"section\" id=\"writing-a-good-proposal\">5D. Writing A Good Proposal</p>\n      <p class=\"exercise\">Exercise 1. Risk management study - benchmark advantage</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 2. PCI Energy Services Group site closure conversion inter-project synchronization</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n      <p class=\"exercise\">Exercise 3. Slade Pharmaceuticals request for a proposal from a consulting firm</p>\n        <p class=\"text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut tellus turpis, molestie et sagittis eu, faucibus et dui. Donec nulla orci, mattis id massa id, vestibulum sollicitudin arcu. Phasellus vestibulum bibendum ligula ut posuere. Proin pellentesque massa purus, a vehicula metus vestibulum eu. Nam vehicula mollis hendrerit.)</p>\n\n\n\t</main>\n</div>\n"

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HelpController = function () {
	  HelpController.$inject = ["$stateParams", "$state"];
	  function HelpController($stateParams, $state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HelpController);
	    (0, _assign2.default)(this, { $stateParams: $stateParams, $state: $state });
	  }
	
	  (0, _createClass3.default)(HelpController, [{
	    key: "$onInit",
	    value: function $onInit() {
	      if (this.$stateParams.sectionId) {
	        document.getElementById(this.$stateParams.sectionId).scrollIntoView({
	          behavior: "smooth"
	        });
	      }
	      if (this.$stateParams.prevRoute) {
	        this.prevRoute = this.$stateParams.prevRoute;
	      }
	    }
	  }, {
	    key: "goToPrevRoute",
	    value: function goToPrevRoute() {
	      if (this.prevRoute) {
	        this.$state.go(this.prevRoute);
	      }
	    }
	  }]);
	  return HelpController;
	}();
	
	exports.default = HelpController;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(609);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./help.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./help.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".help .unit-header{min-height:0}.help__back-button{height:100px;width:100px;position:absolute;top:26px;margin-left:860px;fill:#fff;cursor:pointer}.help__back-button-disabled{opacity:.3;pointer-events:none;cursor:default}", ""]);
	
	// exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _userSettings = __webpack_require__(611);
	
	var _userSettings2 = _interopRequireDefault(_userSettings);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userSettingsModule = _angular2.default.module('userSettings', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('site.userSettings', {
	    url: '/settings',
	    component: 'userSettings',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('userSettings', _userSettings2.default).name;
	
	exports.default = userSettingsModule;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userSettings = __webpack_require__(612);
	
	var _userSettings2 = _interopRequireDefault(_userSettings);
	
	var _userSettings3 = __webpack_require__(613);
	
	var _userSettings4 = _interopRequireDefault(_userSettings3);
	
	__webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var userSettings = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _userSettings2.default,
	  controller: _userSettings4.default
	};
	
	exports.default = userSettings;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"user-settings\">\n\n  <mo-header title=\"userSettings\"></mo-header>\n\n  <main class=\"content wrapper\">\n\n    <section class=\"login-box\">\n\n      <form class=\"contacts-input-box\" novalidate name=\"vm.loginForm\">\n\n        <div class=\"contacts-input-wrap\">\n          <div class=\"field-wrap field-wrap_password\">\n            <input ng-model=\"vm.oldPassword\" class=\"login-pass-fild\" placeholder=\"Current password\" type=\"password\"\n              required />\n          </div>\n\n          <div class=\"field-wrap field-wrap_password\">\n            <input ng-model=\"vm.newPassword\" class=\"login-pass-fild\" placeholder=\"New password\" type=\"password\"\n              required />\n          </div>\n\n          <div class=\"field-wrap field-wrap_password\">\n            <input ng-model=\"vm.confirmNewPassword\" class=\"login-pass-fild\" placeholder=\"Confirm new password\" type=\"password\"\n              required />\n          </div>\n        </div>\n\n        <button type=\"submit\" class=\"m__button\" ng-click=\"vm.submit()\">Change password</button>\n        <div class=\"input__error\" ng-repeat=\"error in vm.response.data\" ng-if=\"vm.response\">\n          {{ error }}\n        </div>\n\n      </form>\n\n    </section>\n  </main>\n\n</div>"

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UserSettings = function () {
	  UserSettings.$inject = ["$translate", "$q", "authService", "courseService", "helperService", "userService"];
	  function UserSettings($translate, $q, authService, courseService, helperService, userService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, UserSettings);
	    (0, _assign2.default)(this, {
	      $translate: $translate,
	      $q: $q,
	      authService: authService,
	      courseService: courseService,
	      helperService: helperService,
	      userService: userService
	    });
	  }
	
	  (0, _createClass3.default)(UserSettings, [{
	    key: 'submit',
	    value: function submit() {
	      var _this = this;
	
	      this.response = null;
	
	      var oldPassword = this.oldPassword;
	      var newPassword = this.newPassword;
	      var confirmNewPassword = this.confirmNewPassword;
	
	      this.userService.resetPassword(oldPassword, newPassword, confirmNewPassword).then(function (data) {
	        _this.response = data;
	      });
	    }
	  }]);
	  return UserSettings;
	}();
	
	exports.default = UserSettings;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(615);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./userSettings.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./userSettings.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".user-settings .input__error{margin-bottom:10px;color:#fff}.user-settings .content{display:flex;justify-content:center;align-items:center}.user-settings .container{padding-bottom:0}.user-settings .header{background:url(/assets/images/login-alt-header_bg.png);margin-bottom:65px}.user-settings .CoverImage{background-position:50%;background-repeat:no-repeat;background-size:cover;max-width:100%}.user-settings .contacts-input-box{min-width:615px;margin:0 auto;padding:45px 60px 0;text-align:center}.user-settings .contacts-input-box .m__button{margin-bottom:20px}.user-settings .contacts-input-wrap{width:100%}.user-settings input::-webkit-input-placeholder{color:#050e61;opacity:1}.user-settings .field-wrap{margin-bottom:6px;font-size:21px;color:#050e61}.user-settings .login-pass-fild,.user-settings .login-username-fild{padding:10px 10px 5px}.user-settings .field-wrap.field-wrap_password{margin-bottom:25px}.login-box{width:100%;margin-bottom:60px;padding-bottom:81px;background-size:cover;background-repeat:no-repeat}.login__check{cursor:pointer;width:20px;left:140px}.login__check:not(checked){position:absolute;opacity:0;z-index:2;height:21px;width:21px}.login__check:not(checked)+.login__inner{position:relative;left:140px}.login__check:not(checked)+.login__inner:before{content:\"\";position:absolute;top:4px;width:15px;height:15px;background-color:#fff}.login__check:not(checked)+.login__inner:after{content:\"\";position:absolute;top:8px;left:4px;width:7px;height:7px;opacity:0;border-radius:150%;background-color:#050e61;transition:all .2s}.login__check:checked+.login__inner:after{opacity:1}.login input{border:none}.login-help__text1{font-size:14px;color:#fff;padding:0 0 20px 162px}.login-help__text2{margin-left:45px}.login-help__signup{display:flex;margin-bottom:50px;justify-content:space-around;width:300px;margin:0 auto}.login-help__signup__text{color:#fff;margin-right:25px}", ""]);
	
	// exports


/***/ }),
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _imposingTheStructure = __webpack_require__(621);
	
	var _imposingTheStructure2 = _interopRequireDefault(_imposingTheStructure);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imposingTheStructureModule = _angular2.default.module('imposingTheStructure', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.imposingTheStructure', {
	    url: '/courses/1/1a/imposing-the-structure',
	    component: 'imposingTheStructure',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('imposingTheStructure', _imposingTheStructure2.default).name;
	
	exports.default = imposingTheStructureModule;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _imposingTheStructure = __webpack_require__(622);
	
	var _imposingTheStructure2 = _interopRequireDefault(_imposingTheStructure);
	
	var _imposingTheStructure3 = __webpack_require__(623);
	
	var _imposingTheStructure4 = _interopRequireDefault(_imposingTheStructure3);
	
	__webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var imposingTheStructureComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _imposingTheStructure2.default,
	  controller: _imposingTheStructure4.default
	};
	
	exports.default = imposingTheStructureComponent;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-1 unit1a\">\n\n  <course-header>\n    <h1 class=\"unit-name\" translate>imposing-the-structure.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>imposing-the-structure.unit-section-title</span>\n  </h2>\n\n  <section class=\"unit-exercises\">\n    <div class=\"unit-wrapper\">\n      <div class=\"unit-exercise-description\">\n        <p translate>imposing-the-structure.unit-exercise-description.title</p>\n        <ol>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">imposing-the-structure.unit-exercise-description.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">imposing-the-structure.unit-exercise-description.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">imposing-the-structure.unit-exercise-description.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">imposing-the-structure.unit-exercise-description.exercise-4</a></li>\n        </ol>\n        <p translate>imposing-the-structure.unit-exercise-description.bottom-info</p>\n      </div>\n      <div class=\"exercise exercise-1a1 clearfix\" id=\"exercise-1\">\n        <span class=\"exercise-number\" translate>imposing-the-structure.exercise-one.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>imposing-the-structure.exercise-one.exercise-title</h3>\n        <span class=\"task-title\" translate>imposing-the-structure.exercise-one.original-note-title</span>\n\n        <notes class=\"floated\">\n          <div translate>imposing-the-structure.exercise-one.original-note</div>\n        </notes>\n\n        <span class=\"task-title structured\" translate>imposing-the-structure.exercise-one.task-title</span>\n        <ul class=\"structured-blocks\">\n          <li translate>imposing-the-structure.exercise-one.structured-blocks.structured-block-1</li>\n          <li translate>imposing-the-structure.exercise-one.structured-blocks.structured-block-2</li>\n          <li translate>imposing-the-structure.exercise-one.structured-blocks.structured-block-3</li>\n        </ul>\n\n        <span class=\"task-title\" translate>imposing-the-structure.exercise-one.clearer-note-title</span>\n\n        <notes>\n          <div translate>imposing-the-structure.exercise-one.clearer-note</div>\n        </notes>\n\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-A-1-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-A-1-ex-1>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise exercise-1a2 clearfix\" id=\"exercise-2\">\n        <span class=\"exercise-number\" translate>imposing-the-structure.exercise-two.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>imposing-the-structure.exercise-two.exercise-title</h3>\n        <span class=\"task-title\" translate>imposing-the-structure.exercise-two.original-note-title</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-two.memo-paper-1</div>\n        </paper>\n\n        <div class=\"structure\">\n          <span class=\"task-title\" translate>imposing-the-structure.exercise-one.task-title</span>\n          <img src=\"/assets/images/structure-1a-1.jpg\" alt=\"Original structure\">\n        </div>\n        <span class=\"task-title-leftcolumn\" translate>imposing-the-structure.exercise-two.task-title-leftcolumn</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-two.memo-paper-2</div>\n        </paper>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-A-1-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-A-1-ex-2>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise exercise-1a3 clearfix\" id=\"exercise-3\">\n        <span class=\"exercise-number\" translate>imposing-the-structure.exercise-three.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>imposing-the-structure.exercise-three.exercise-title</h3>\n        <span class=\"task-title-fullwidth\" translate>imposing-the-structure.exercise-three.task-title-fullwidth</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-three.memo-paper-1</div>\n        </paper>\n\n        <div class=\"structure\">\n          <span class=\"task-title\" translate>imposing-the-structure.exercise-one.task-title</span>\n          <img src=\"/assets/images/structure-1a-2.jpg\" alt=\"Original structure\">\n        </div>\n        <span class=\"task-title-leftcolumn\" translate>imposing-the-structure.exercise-three.task-title-leftcolumn</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-three.memo-paper-2</div>\n        </paper>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-A-1-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-A-1-ex-3>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise exercise-1a4 clearfix\" id=\"exercise-4\">\n        <span class=\"exercise-number\" translate>imposing-the-structure.exercise-four.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>imposing-the-structure.exercise-four.exercise-title</h3>\n        <span class=\"task-title-fullwidth\" translate>imposing-the-structure.exercise-four.task-title-fullwidth</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-four.memo-paper-1</div>\n        </paper>\n\n        <div class=\"structure\">\n          <span class=\"task-title\" translate>imposing-the-structure.exercise-one.task-title</span>\n          <img src=\"/assets/images/structure-1a-3.png\" alt=\"Original structure\">\n        </div>\n        <span class=\"task-title-leftcolumn\" translate>imposing-the-structure.exercise-four.task-title-fullwidth-2</span>\n\n        <paper>\n          <div translate>imposing-the-structure.exercise-four.memo-paper-2</div>\n        </paper>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper wide\">\n        <modiagram-1-1-A-1-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-A-1-ex-4>\n      </div>\n    </div>\n    <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'imposing-the-structure.congratulation-message'\"\n                 finish-section=\"'imposing-the-structure.finish-section'\"\n                 final-description=\"'imposing-the-structure.final-description'\"\n                 next-course-button=\"'imposing-the-structure.next-course-button'\"\n                 dashboard-button=\"'imposing-the-structure.dashboard-button'\"\n                 next-course=\"'course.pickingOutThePoints'\"\n                 course-finish=\"\"></unit-finish>\n  </section>\n\n<!--  <pyramid-builder section-title=\"{{ 'imposing-the-structure.course-name-pyramid' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImposingTheStructureController = function (_CourseController) {
	  ImposingTheStructureController.$inject = ["courseService", "helperService", "$sce", "$anchorScroll", "$location", "$scope"];
	  (0, _inherits3.default)(ImposingTheStructureController, _CourseController);
	
	  function ImposingTheStructureController(courseService, helperService, $sce, $anchorScroll, $location, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ImposingTheStructureController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ImposingTheStructureController.__proto__ || (0, _getPrototypeOf2.default)(ImposingTheStructureController)).call(this, courseService, helperService, $sce, $scope, $anchorScroll, $location));
	
	    (0, _assign2.default)(_this, { courseService: courseService, helperService: helperService, $sce: $sce, $anchorScroll: $anchorScroll, $location: $location });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322179700');
	    _this.videoId = '708c551f38b343128c1e0910b9dde267';
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram1a1-';
	    return _this;
	  }
	
	  return ImposingTheStructureController;
	}(_course2.default);
	
	exports.default = ImposingTheStructureController;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(625);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./imposingTheStructure.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./imposingTheStructure.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1a .submit{float:none!important}.unit1a .diagram-message{font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;color:#050e61;display:inline-block}.unit1a .unit-exercises .unit-wrapper{padding:75px 80px 100px}.unit1a .unit-lecture .unit-wrapper{padding:60px 80px 75px}.unit1a .unit-lecture .unit-wrapper .unit-section-title{line-height:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit1a .unit-exercises,.unit1a .unit-lecture{background:#fff}.unit1a .unit-exercises .unit-exercise-description,.unit1a .unit-lecture .unit-exercise-description{padding-bottom:35px;border-bottom:3px solid #fc922c}.unit1a .unit-exercises .unit-exercise-description ol,.unit1a .unit-exercises .unit-exercise-description p,.unit1a .unit-lecture .unit-exercise-description ol,.unit1a .unit-lecture .unit-exercise-description p{font-family:Source Sans Pro,Arial,sans-serif;font-size:18px;line-height:28px}.unit1a .unit-exercises .unit-exercise-description ol,.unit1a .unit-lecture .unit-exercise-description ol{margin:23px 28px;font-weight:700}.unit1a .unit-exercises .unit-exercise-description ol .anchor,.unit1a .unit-lecture .unit-exercise-description ol .anchor{color:#000;text-decoration:none}.unit1a .unit-exercises .unit-exercise-description ol .anchor:hover,.unit1a .unit-lecture .unit-exercise-description ol .anchor:hover{text-decoration:underline}.unit1a .unit-exercises .exercise,.unit1a .unit-lecture .exercise{padding:0}.unit1a .unit-exercises .exercise .exercise-number,.unit1a .unit-lecture .exercise .exercise-number{font-size:51px;line-height:68px;color:#050e61}.unit1a .unit-exercises .exercise .exercise-title,.unit1a .unit-lecture .exercise .exercise-title{font-size:48px;line-height:60px;margin-top:0;font-weight:600;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.unit1a .unit-exercises .exercise .task-title,.unit1a .unit-exercises .exercise .task-title-fullwidth,.unit1a .unit-exercises .exercise .task-title-leftcolumn,.unit1a .unit-lecture .exercise .task-title,.unit1a .unit-lecture .exercise .task-title-fullwidth,.unit1a .unit-lecture .exercise .task-title-leftcolumn{display:inline-block;font-size:22px;color:#050e61}.unit1a .unit-exercises .exercise .structure,.unit1a .unit-lecture .exercise .structure{text-align:left}.unit1a .unit-exercises .exercise .structure .task-title,.unit1a .unit-lecture .exercise .structure .task-title{margin-bottom:0}.unit1a .unit-exercises .exercise .task-title,.unit1a .unit-lecture .exercise .task-title{margin-top:60px;margin-bottom:30px}.unit1a .unit-exercises .exercise .task-title-fullwidth,.unit1a .unit-lecture .exercise .task-title-fullwidth{margin-top:50px;margin-bottom:20px}.unit1a .unit-exercises .exercise .task-title-leftcolumn,.unit1a .unit-lecture .exercise .task-title-leftcolumn{margin-top:70px;margin-bottom:30px}.unit1a .unit-exercises .diagram,.unit1a .unit-lecture .diagram{background:linear-gradient(180deg,rgba(4,69,123,.6),rgba(4,69,123,.3) 60%,rgba(4,69,123,0) 75%),url(\"/assets/images/section-1-bg.png\");filter:saturate(140%);min-height:620px;background-repeat:no-repeat;background-size:cover}.unit1a .unit-exercises .diagram .unit-wrapper,.unit1a .unit-lecture .diagram .unit-wrapper{padding:44px 80px 45px}.unit1a .unit-exercises .exercise-1a1{padding-top:90px;position:relative}.unit1a .unit-exercises .exercise-1a1 .task-title{display:block;margin-bottom:0}.unit1a .unit-exercises .exercise-1a1 .memo-note.floated{position:absolute;top:200px;right:0}@media (max-width:1000px){.unit1a .unit-exercises .exercise-1a1 .memo-note.floated{float:none;position:relative}}.unit1a .unit-exercises .exercise-1a1 .structured{margin-top:360px}.unit1a .unit-exercises .exercise-1a1 .structured-blocks{margin:20px 0 0;padding-left:0;padding-bottom:48px;list-style:none;border-bottom:3px solid #000;font-size:13px;font-family:Arial;line-height:17.6px;position:relative;z-index:1}.unit1a .unit-exercises .exercise-1a1 .structured-blocks li{display:inline-block;padding:5px;min-height:85px;width:160px;border-radius:15px;margin-right:25px;border:3px solid #000;color:#050e61;vertical-align:top}.unit1a .unit-exercises .exercise-1a1 .structured-blocks+.task-title{float:left}.unit1a .unit-exercises .exercise-1a3 .memo-paper:first-of-type{margin-top:0}.unit1a .unit-exercises .exercise-1a2 .memo-paper,.unit1a .unit-exercises .exercise-1a3 .memo-paper,.unit1a .unit-exercises .exercise-1a4 .memo-paper{width:100%;margin-top:0;float:right}.unit1a .unit-exercises .exercise-1a2 .structure,.unit1a .unit-exercises .exercise-1a3 .structure,.unit1a .unit-exercises .exercise-1a4 .structure{clear:both;padding:1px 0 55px;border-bottom:3px solid #000}.unit1a .unit-exercises .exercise-1a2 .structure img,.unit1a .unit-exercises .exercise-1a3 .structure img,.unit1a .unit-exercises .exercise-1a4 .structure img{display:block;max-width:100%;margin:0 auto}.unit1a .unit-video .video{background-image:url(https://i.vimeocdn.com/video/710443063.webp?mw=1200&mh=675&q=70)}.unit1a .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61}.unit1a .diagram-task{float:left;width:60%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;color:#050e61;padding-bottom:33px;padding-left:5px}.unit1a .submit{margin-top:30px;margin-right:10%}.unit1a .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#fc922c;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.unit1a .slots{margin:0 auto}.unit1a #slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit1a #slots td{font-size:0}.unit1a .separator{position:relative;height:88px}.unit1a .separator svg{position:absolute;top:-2px;left:0;z-index:0}.unit1a #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit1a #elements td{padding:10px}.unit1a .slots td{padding:0 10px;font-size:0}.unit1a #slots div{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #fff;border-radius:15px;margin:0 0 0 10px;background:none;transition:all .2s ease}.unit1a #elements div:first-child,.unit1a #slots div:first-child{margin-left:0}.unit1a #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit1a .element{width:167px;height:86px;color:#050e61;transition:transform .3s,box-shadow .3s,border .3s,background .3s;overflow:auto}.unit1a .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}.unit1a .wrong{box-shadow:0 0 5px 2px red}.unit1a .correct{border:2px solid #fff;border-color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _cementingTheRules = __webpack_require__(627);
	
	var _cementingTheRules2 = _interopRequireDefault(_cementingTheRules);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cementingTheRulesModule = _angular2.default.module('cementingTheRules', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.cementingTheRules', {
	    url: '/courses/1/1c/picking-out-the-points',
	    component: 'cementingTheRules',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('cementingTheRules', _cementingTheRules2.default).name;
	
	exports.default = cementingTheRulesModule;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cementingTheRules = __webpack_require__(628);
	
	var _cementingTheRules2 = _interopRequireDefault(_cementingTheRules);
	
	var _cementingTheRules3 = __webpack_require__(629);
	
	var _cementingTheRules4 = _interopRequireDefault(_cementingTheRules3);
	
	__webpack_require__(630);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cementingTheRulesComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _cementingTheRules2.default,
	  controller: _cementingTheRules4.default
	};
	
	exports.default = cementingTheRulesComponent;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-1 unit1b\">\n\n  <course-header>\n    <h1 class=\"unit-name\" translate>cementing-the-rules.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\" translate>cementing-the-rules.unit-section-title</h2>\n\n  <section class=\"unit-exercises\">\n    <div class=\"unit-wrapper\">\n      <div class=\"unit-exercise-description\">\n        <plain-text>\n          <div translate>cementing-the-rules.unit-exercise-description</div>\n          <ol>\n            <li><a class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">Firestone's Commitment</a></li>\n            <li><a class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">Property Rights</a></li>\n            <li><a class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">Size Of The Cosmos</a></li>\n            <li><a class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">Brands</a></li>\n          </ol>\n          <p translate>cementing-the-rules.exercise-description-bottom</p>\n        </plain-text>\n      </div>\n      <div class=\"exercise\" id=\"exercise-1\">\n        <span class=\"exercise-number\" translate>cementing-the-rules.exercise-one.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>cementing-the-rules.exercise-one.exercise-title</h3>\n        <p class=\"exercise-description\" translate>cementing-the-rules.exercise-one.exercise-description</p>\n        <span class=\"exercise-reference clearfix\" translate>cementing-the-rules.exercise-one.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-B-1-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-B-1-ex-1>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-2\">\n        <span class=\"exercise-number\" translate>cementing-the-rules.exercise-two.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>cementing-the-rules.exercise-two.exercise-title</h3>\n        <p class=\"exercise-description\" translate>cementing-the-rules.exercise-two.exercise-description</p>\n        <span class=\"exercise-reference\" translate>cementing-the-rules.exercise-two.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-B-1-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-B-1-ex-2>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-3\">\n        <span class=\"exercise-number\" translate>cementing-the-rules.exercise-three.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>cementing-the-rules.exercise-three.exercise-title</h3>\n        <p class=\"exercise-description\" translate>cementing-the-rules.exercise-three.exercise-description</p>\n        <span class=\"exercise-reference\" translate>cementing-the-rules.exercise-three.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-B-1-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-B-1-ex-3>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-4\">\n        <span class=\"exercise-number\" translate>cementing-the-rules.exercise-four.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>cementing-the-rules.exercise-four.exercise-title</h3>\n        <p class=\"exercise-description\" translate>cementing-the-rules.exercise-four.exercise-description</p>\n        <span class=\"exercise-reference\" translate>cementing-the-rules.exercise-four.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-B-1-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-B-1-ex-4>\n      </div>\n    </div>\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'cementing-the-rules.congratulation-message'\"\n      finish-section=\"'cementing-the-rules.finish-section'\"\n      final-description=\"'cementing-the-rules.final-description'\"\n      next-course-button=\"'cementing-the-rules.next-course-button'\"\n      dashboard-button=\"'cementing-the-rules.dashboard-button'\"\n      next-course=\"'course.graspingTheMessage'\"\n    ></unit-finish>\n  </section>\n\n<!--  <pyramid-builder section-title=\"{{ 'cementing-the-rules.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var cementingTheRulesController = function (_CourseController) {
	  cementingTheRulesController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(cementingTheRulesController, _CourseController);
	
	  function cementingTheRulesController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, cementingTheRulesController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (cementingTheRulesController.__proto__ || (0, _getPrototypeOf2.default)(cementingTheRulesController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { courseService: courseService, helperService: helperService, $sce: $sce });
	    _this.videoId = '9b7aff544d364121859adacf858a3e31';
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207185');
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram1b1-';
	    return _this;
	  }
	
	  return cementingTheRulesController;
	}(_course2.default);
	
	exports.default = cementingTheRulesController;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(631);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cementingTheRules.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./cementingTheRules.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram1b1-2 #slots div[id],#diagram1b1-2 .element{height:92px}.unit1b .unit-exercises .unit-wrapper{padding:75px 80px 50px}.unit1b .unit-lecture .unit-wrapper{padding:60px 80px 75px}.unit1b .unit-lecture .unit-wrapper .unit-section-title{line-height:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit1b .unit-exercises,.unit1b .unit-lecture{background:#fff}.unit1b .unit-exercises .unit-exercise-description,.unit1b .unit-lecture .unit-exercise-description{padding-bottom:35px;border-bottom:3px solid #fc922c;margin-bottom:50px}.unit1b .unit-exercises .unit-exercise-description ol,.unit1b .unit-exercises .unit-exercise-description p,.unit1b .unit-lecture .unit-exercise-description ol,.unit1b .unit-lecture .unit-exercise-description p{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;line-height:28px}.unit1b .unit-exercises .unit-exercise-description ol,.unit1b .unit-lecture .unit-exercise-description ol{margin:23px 28px;font-weight:700}.unit1b .unit-exercises .unit-exercise-description ol .anchor,.unit1b .unit-lecture .unit-exercise-description ol .anchor{color:#000;text-decoration:none}.unit1b .unit-exercises .unit-exercise-description ol .anchor:hover,.unit1b .unit-lecture .unit-exercise-description ol .anchor:hover{text-decoration:underline}.unit1b .unit-exercises .unit-exercise-description-text,.unit1b .unit-lecture .unit-exercise-description-text{margin-bottom:20px}.unit1b .unit-exercises .exercise,.unit1b .unit-lecture .exercise{padding:0}.unit1b .unit-exercises .exercise .exercise-number,.unit1b .unit-lecture .exercise .exercise-number{font-size:51px;line-height:68px;color:#050e61}.unit1b .unit-exercises .exercise .exercise-title,.unit1b .unit-lecture .exercise .exercise-title{font-size:48px;line-height:60px;font-weight:600;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.unit1b .unit-exercises .exercise .exercise-description,.unit1b .unit-lecture .exercise .exercise-description{column-count:2;column-gap:30px;margin-top:30px;font-size:18px}.unit1b .unit-exercises .exercise .exercise-description .marked,.unit1b .unit-lecture .exercise .exercise-description .marked{color:#fc922c}.unit1b .unit-exercises .exercise .exercise-reference,.unit1b .unit-lecture .exercise .exercise-reference{margin-top:42px;text-align:right;font-size:15px;line-height:18px}.unit1b .unit-exercises .exercise .exercise-reference:after,.unit1b .unit-lecture .exercise .exercise-reference:after{content:\"\";clear:both}.unit1b .unit-exercises .diagram,.unit1b .unit-lecture .diagram{background:linear-gradient(180deg,rgba(4,69,123,.6),rgba(4,69,123,.3) 60%,rgba(4,69,123,0) 75%),url(\"/assets/images/section-1-bg.png\");min-height:620px;background-repeat:no-repeat;background-size:cover}.unit1b .unit-exercises .diagram .unit-wrapper,.unit1b .unit-lecture .diagram .unit-wrapper{padding:44px 80px 45px}.unit1b .unit-finish{padding:70px 50px 80px;background:#fff}.unit1b .unit-finish .finish{padding:75px 0;border-top:3px solid #fc922c;border-bottom:3px solid #fc922c;color:#050e61}.unit1b .unit-finish .congratulation-message,.unit1b .unit-finish .final-description,.unit1b .unit-finish .finish-section{display:block;text-align:center}.unit1b .unit-finish .congratulation-message{font-size:51px;letter-spacing:7px;line-height:60px}.unit1b .unit-finish .finish-section{font-size:35px;letter-spacing:1px}.unit1b .unit-finish .final-description{font-size:22px;margin-top:33px}.unit1b .unit-finish ul{display:flex;width:610px;margin:90px auto 0;justify-content:space-around;list-style:none}.unit1b .unit-finish ul .finish-button{display:block;text-decoration:none;text-transform:uppercase;color:#fff;background:#fc922c;width:190px;text-align:center;font-size:17px;padding:13px;border-radius:12px;transition:background .3s ease}.unit1b .unit-finish ul .finish-button:hover{background:#f27803}.unit1b .unit-video .video{background-image:url(https://i.vimeocdn.com/video/710443012.webp?mw=1200&mh=675&q=70)}.unit1b .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61}.unit1b .diagram-task{float:left;width:60%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:33px;padding-left:5px}.unit1b .submit{float:none;margin-top:30px;margin-right:10%}.unit1b .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#fc922c;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.unit1b .slots{margin:0 auto}.unit1b #slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit1b #slots td{font-size:0}.unit1b .separator{position:relative;height:88px}.unit1b .separator svg{position:absolute;top:-2px;left:0;z-index:0}.unit1b #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit1b #elements td{padding:10px}.unit1b .slots td{padding:0 10px;font-size:0}.unit1b #slots div[id]{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #fff;border-radius:15px;margin:0 0 0 10px;background:none;transition:all .2s ease}.unit1b #slots div:first-child{margin-left:0}.unit1b #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit1b #slots .fixed-answer,.unit1b .element{overflow:auto}.unit1b .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}", ""]);
	
	// exports


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _pickingOutThePoints = __webpack_require__(633);
	
	var _pickingOutThePoints2 = _interopRequireDefault(_pickingOutThePoints);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pickingOutThePointsModule = _angular2.default.module('pickingOutThePoints', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.pickingOutThePoints', {
	    url: '/courses/1/1b/cementing-the-rules',
	    component: 'pickingOutThePoints',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('pickingOutThePoints', _pickingOutThePoints2.default).name;
	
	exports.default = pickingOutThePointsModule;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pickingOutThePoints = __webpack_require__(634);
	
	var _pickingOutThePoints2 = _interopRequireDefault(_pickingOutThePoints);
	
	var _pickingOutThePoints3 = __webpack_require__(635);
	
	var _pickingOutThePoints4 = _interopRequireDefault(_pickingOutThePoints3);
	
	__webpack_require__(636);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pickingOutThePointsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _pickingOutThePoints2.default,
	  controller: _pickingOutThePoints4.default
	};
	
	exports.default = pickingOutThePointsComponent;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-1 unit1c\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>picking-out-the-points.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>picking-out-the-points.unit-section-title</span>\n  </h2>\n\n  <section class=\"unit-exercises\">\n    <div class=\"unit-wrapper\">\n      <div class=\"unit-exercise-description\">\n        <plain-text>\n          <div translate>picking-out-the-points.unit-exercise-description</div>\n          <ol>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">picking-out-the-points.menu-list.exercise-1</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">picking-out-the-points.menu-list.exercise-2</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">picking-out-the-points.menu-list.exercise-3</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">picking-out-the-points.menu-list.exercise-4</a></li>\n          </ol>\n        </plain-text>\n      </div>\n      <div class=\"exercise\" id=\"exercise-1\">\n        <span class=\"exercise-number\" translate>picking-out-the-points.exercise-one.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>picking-out-the-points.exercise-one.exercise-title</h3>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-one.exercise-structure-1</div>\n        <hr>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-one.exercise-structure-2</div>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-C-1-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-C-1-ex-1>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-2\">\n        <span class=\"exercise-number\" translate>picking-out-the-points.exercise-two.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>picking-out-the-points.exercise-two.exercise-title</h3>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-two.exercise-structure-1</div>\n        <hr>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-two.exercise-structure-2</div>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-C-1-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-C-1-ex-2>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-3\">\n        <span class=\"exercise-number\" translate>picking-out-the-points.exercise-three.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>picking-out-the-points.exercise-three.exercise-title</h3>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-three.exercise-structure-1</div>\n        <hr>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-three.exercise-structure-2</div>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-C-1-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-C-1-ex-3>\n      </div>\n    </div>\n    <div class=\"unit-wrapper wide\">\n      <div class=\"exercise\" id=\"exercise-4\">\n        <span class=\"exercise-number\" translate>picking-out-the-points.exercise-four.exercise-number</span>\n        <h3 class=\"exercise-title\" translate>picking-out-the-points.exercise-four.exercise-title</h3>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-four.exercise-structure-1</div>\n        <hr>\n        <div class=\"structure\" translate>picking-out-the-points.exercise-four.exercise-structure-2</div>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-C-1-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-C-1-ex-4>\n      </div>\n    </div>\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'picking-out-the-points.congratulation-message'\"\n      finish-section=\"'picking-out-the-points.finish-section'\"\n      final-description=\"'picking-out-the-points.final-description'\"\n      next-course-button=\"'picking-out-the-points.next-course-button'\"\n      dashboard-button=\"'picking-out-the-points.dashboard-button'\"\n      next-course=\"'course.cementingTheRules'\"\n    ></unit-finish>\n  </section>\n\n<!--  <pyramid-builder section-title=\"{{ 'picking-out-the-points.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n\n<script>\n$(document).ready(function(){\n  $(\".anchor\").on('click', function(event) {\n    if (this.hash !== \"\") {\n      event.preventDefault();\n\n      var hash = this.hash;\n\n      $('html, body').animate({\n        scrollTop: $(hash).offset().top\n      }, 800, function(){\n\n        window.location.hash = hash;\n      });\n    }\n  });\n});\n\nfunction toggleVideo(state) {\n  // if state == 'hide', hide. Else: show video\n  var div = document.getElementById(\"video-block\");\n  var iframe = div.getElementsByTagName(\"iframe\")[0].contentWindow;\n  div.style.display = state == 'hide' ? 'none' : '';\n  func = state == 'hide' ? 'pauseVideo' : 'playVideo';\n  iframe.postMessage('{\"event\":\"command\",\"func\":\"' + func + '\",\"args\":\"\"}','*');\n}\n</script>\n"

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pickingOutThePointsController = function (_CourseController) {
	  pickingOutThePointsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(pickingOutThePointsController, _CourseController);
	
	  function pickingOutThePointsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, pickingOutThePointsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (pickingOutThePointsController.__proto__ || (0, _getPrototypeOf2.default)(pickingOutThePointsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { courseService: courseService, helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207191');
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram1c1-';
	    return _this;
	  }
	
	  return pickingOutThePointsController;
	}(_course2.default);
	
	exports.default = pickingOutThePointsController;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(637);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./pickingOutThePoints.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./pickingOutThePoints.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1c .unit-exercises .unit-wrapper{padding:75px 80px 30px}.unit1c .unit-lecture .unit-wrapper{padding:60px 80px 75px}.unit1c .unit-lecture .unit-wrapper .unit-section-title{line-height:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit1c .unit-exercises,.unit1c .unit-lecture{background:#fff}.unit1c .unit-exercises .unit-exercise-description,.unit1c .unit-lecture .unit-exercise-description{padding-bottom:35px;border-bottom:3px solid #fc922c;margin-bottom:35px}.unit1c .unit-exercises .unit-exercise-description ol,.unit1c .unit-exercises .unit-exercise-description p,.unit1c .unit-lecture .unit-exercise-description ol,.unit1c .unit-lecture .unit-exercise-description p{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;line-height:28px}.unit1c .unit-exercises .unit-exercise-description ol,.unit1c .unit-lecture .unit-exercise-description ol{margin:23px 28px;font-weight:700}.unit1c .unit-exercises .unit-exercise-description ol .anchor,.unit1c .unit-lecture .unit-exercise-description ol .anchor{color:#000;text-decoration:none}.unit1c .unit-exercises .unit-exercise-description ol .anchor:hover,.unit1c .unit-lecture .unit-exercise-description ol .anchor:hover{text-decoration:underline}.unit1c .unit-exercises .unit-exercise-description ol.ordered-list,.unit1c .unit-lecture .unit-exercise-description ol.ordered-list{margin:20px 0 0;font-weight:inherit}.unit1c .unit-exercises .unit-exercise-description ol.ordered-list .anchor,.unit1c .unit-lecture .unit-exercise-description ol.ordered-list .anchor{color:#000;text-decoration:none}.unit1c .unit-exercises .unit-exercise-description ol.ordered-list .anchor:hover,.unit1c .unit-lecture .unit-exercise-description ol.ordered-list .anchor:hover{text-decoration:none}.unit1c .unit-exercises .unit-exercise-description ul.unordered-list,.unit1c .unit-lecture .unit-exercise-description ul.unordered-list{margin:10px 20px 0;font-weight:inherit;font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;line-height:28px}.unit1c .unit-exercises .unit-exercise-description ul.unordered-list .anchor,.unit1c .unit-lecture .unit-exercise-description ul.unordered-list .anchor{color:#000;text-decoration:none}.unit1c .unit-exercises .unit-exercise-description ul.unordered-list .anchor:hover,.unit1c .unit-lecture .unit-exercise-description ul.unordered-list .anchor:hover{text-decoration:none}.unit1c .unit-exercises .exercise,.unit1c .unit-lecture .exercise{padding:0}.unit1c .unit-exercises .exercise .exercise-number,.unit1c .unit-lecture .exercise .exercise-number{font-size:51px;line-height:68px;color:#050e61}.unit1c .unit-exercises .exercise .exercise-title,.unit1c .unit-lecture .exercise .exercise-title{font-size:48px;line-height:60px;font-weight:600;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.unit1c .unit-exercises .exercise .task-title,.unit1c .unit-lecture .exercise .task-title{display:inline-block;font-size:22px;color:#050e61;margin-top:25px;margin-bottom:30px}.unit1c .unit-exercises .diagram,.unit1c .unit-lecture .diagram{background:linear-gradient(180deg,rgba(4,69,123,.6),rgba(4,69,123,.3) 30%,rgba(4,69,123,0) 60%),url(\"/assets/images/section-1-bg.png\");filter:brightness(120%) saturate(80%);min-height:360px;background-repeat:no-repeat;background-size:cover;background-position:0 bottom}.unit1c .unit-exercises .diagram .unit-wrapper,.unit1c .unit-lecture .diagram .unit-wrapper{padding:44px 80px 35px}.unit1c .unit-exercises .structure{clear:both;padding:1px 0 0;position:relative;text-align:right}.unit1c .unit-exercises .structure img{display:inline-block;margin-top:10px;max-width:100%}.unit1c .unit-exercises .structure .task-title{position:absolute;top:10px;left:0;z-index:10}.unit1c .unit-exercises hr{height:3px;background:#000}", ""]);
	
	// exports


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _graspingTheMessage = __webpack_require__(639);
	
	var _graspingTheMessage2 = _interopRequireDefault(_graspingTheMessage);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graspingTheMessageModule = _angular2.default.module('graspingTheMessage', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.graspingTheMessage', {
	    url: '/courses/1/1d/grasping-the-message',
	    component: 'graspingTheMessage',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('graspingTheMessage', _graspingTheMessage2.default).name;
	
	exports.default = graspingTheMessageModule;

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _graspingTheMessage = __webpack_require__(640);
	
	var _graspingTheMessage2 = _interopRequireDefault(_graspingTheMessage);
	
	var _graspingTheMessage3 = __webpack_require__(641);
	
	var _graspingTheMessage4 = _interopRequireDefault(_graspingTheMessage3);
	
	__webpack_require__(642);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graspingTheMessageComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _graspingTheMessage2.default,
	  controller: _graspingTheMessage4.default
	};
	
	exports.default = graspingTheMessageComponent;

/***/ }),
/* 640 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-1 unit1d\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>grasping-the-message.course-name</h1>\n  </course-header>\n  <course-video lecture-title=\"'grasping-the-message.videoTitleTop'\" modifier=\"'_1'\" />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>grasping-the-message.unit-section-title</span>\n  </h2>\n\n  <section class=\"unit-exercises\">\n    <div class=\"unit-wrapper\">\n      <div class=\"unit-exercise-description\">\n        <plain-text>\n          <div translate>grasping-the-message.unit-exercise-description</div>\n          <ol>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">grasping-the-message.menu-list.exercise-1</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">grasping-the-message.menu-list.exercise-2</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">grasping-the-message.menu-list.exercise-3</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">grasping-the-message.menu-list.exercise-4</a></li>\n            <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">grasping-the-message.menu-list.exercise-5</a></li>\n          </ol>\n        </plain-text>\n      </div>\n      <div class=\"exercise\" id=\"exercise-1\">\n        <span class=\"exercise-number\" translate>grasping-the-message.exercise-one.exercise-number</span>\n        <span class=\"exercise-title\" translate>grasping-the-message.exercise-one.exercise-title</span>\n        <p class=\"exercise-pre-description\" translate>grasping-the-message.exercise-one.exercise-pre-description</p>\n        <p class=\"exercise-description\" translate>grasping-the-message.exercise-one.exercise-description</p>\n        <span class=\"exercise-reference\" translate>grasping-the-message.exercise-one.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-D-1-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-D-1-ex-1>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-2\">\n        <span class=\"exercise-number\" translate>grasping-the-message.exercise-two.exercise-number</span>\n        <span class=\"exercise-title\" translate>grasping-the-message.exercise-two.exercise-title</span>\n        <p class=\"exercise-pre-description\" translate>grasping-the-message.exercise-two.exercise-pre-description</p>\n        <p class=\"exercise-description\" translate>grasping-the-message.exercise-two.exercise-description</p>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"diagram_ex-2\">\n        <modiagram-1-1-D-1-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-D-1-ex-2>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-3\">\n        <span class=\"exercise-number\" translate>grasping-the-message.exercise-three.exercise-number</span>\n        <span class=\"exercise-title\" translate>grasping-the-message.exercise-three.exercise-title</span>\n        <p class=\"exercise-description\" translate>grasping-the-message.exercise-three.exercise-description</p>\n        <span class=\"exercise-reference\" translate>grasping-the-message.exercise-three.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-D-1-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-D-1-ex-3>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-4\">\n        <span class=\"exercise-number\" translate>grasping-the-message.exercise-four.exercise-number</span>\n        <span class=\"exercise-title\" translate>grasping-the-message.exercise-four.exercise-title</span>\n        <p class=\"exercise-description\" translate>grasping-the-message.exercise-four.exercise-description</p>\n        <span class=\"exercise-reference\" translate>grasping-the-message.exercise-four.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-D-1-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-D-1-ex-4>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <div class=\"exercise\" id=\"exercise-5\">\n        <span class=\"exercise-number\" translate>grasping-the-message.exercise-five.exercise-number</span>\n        <span class=\"exercise-title\" translate>grasping-the-message.exercise-five.exercise-title</span>\n        <p class=\"exercise-description\" translate>grasping-the-message.exercise-five.exercise-description</p>\n        <span class=\"exercise-reference\" translate>grasping-the-message.exercise-five.exercise-reference</span>\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-1-1-D-1-ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-1-1-D-1-ex-5>\n      </div>\n    </div>\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      current-course-last-diagram-id=\"'exercise-5'\"\n      last-course-finish=\"vm.lastSectionFinish\"\n      congratulation-message=\"'grasping-the-message.congratulation-message'\"\n      finish-section=\"'grasping-the-message.finish-section'\"\n      final-description=\"'grasping-the-message.final-description'\"\n      next-course-button=\"'grasping-the-message.next-course-button'\"\n      dashboard-button=\"'grasping-the-message.dashboard-button'\"\n      next-course=\"'course.ideasFitTogether'\">\n      <course-video modifier=\"'_2'\" />\n    </unit-finish>\n  </section>\n\n<!--  <pyramid-builder section-title=\"{{ 'grasping-the-message.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n\n<script>\n  $(document).ready(function(){\n    $(\".anchor\").on('click', function(event) {\n      if (this.hash !== \"\") {\n        event.preventDefault();\n\n        var hash = this.hash;\n\n        $('html, body').animate({\n          scrollTop: $(hash).offset().top\n        }, 800, function(){\n\n          window.location.hash = hash;\n        });\n      }\n    });\n  });\n\n  function toggleVideo(state) {\n    // if state == 'hide', hide. Else: show video\n    var div = document.getElementById(\"video-block\");\n    var iframe = div.getElementsByTagName(\"iframe\")[0].contentWindow;\n    div.style.display = state == 'hide' ? 'none' : '';\n    func = state == 'hide' ? 'pauseVideo' : 'playVideo';\n    iframe.postMessage('{\"event\":\"command\",\"func\":\"' + func + '\",\"args\":\"\"}','*');\n  }\n</script>\n"

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var graspingTheMessageController = function (_CourseController) {
	  graspingTheMessageController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(graspingTheMessageController, _CourseController);
	
	  function graspingTheMessageController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, graspingTheMessageController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (graspingTheMessageController.__proto__ || (0, _getPrototypeOf2.default)(graspingTheMessageController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { courseService: courseService, helperService: helperService, $sce: $sce });
	    _this.videoUrl1 = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207200');
	    _this.videoUrl2 = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207207');
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram1d1-';
	    return _this;
	  }
	
	  return graspingTheMessageController;
	}(_course2.default);
	
	exports.default = graspingTheMessageController;

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(643);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./graspingTheMessage.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./graspingTheMessage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1d .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#fff}.unit1d .hint-static{top:0!important;right:auto!important;left:calc(50% - 185px / 2)}.unit1d .diagram-task{float:left;width:100%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;font-size:20px;padding-bottom:70px;padding-left:5px;margin-left:-50px}.unit1d .submit{margin-top:30px;margin-right:10%}.unit1d .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#fc922c;border-radius:10px;padding:5px 10px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.unit1d .slots{margin:0 auto}.unit1d #slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit1d #slots td{font-size:0}.unit1d .separator{position:relative;height:88px}.unit1d .separator svg{position:absolute;top:-2px;left:0;z-index:2}.unit1d #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit1d #elements td{padding:10px}.unit1d .slots td{padding:0 10px;font-size:0}.unit1d #slots .answer-field,.unit1d #slots div[id]{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #fff;border-radius:15px;margin:0 0 0 10px;background:none;transition:all .2s ease}.unit1d #slots .answer-field{margin-left:0;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\"!important;color:#050e61;line-height:16px}.unit1d #slots .answer-field:hover+.hint{transform:translateX(-5px);opacity:0!important}.unit1d #elements div:first-child,.unit1d #slots div:first-child{margin-left:0}.unit1d #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit1d #slots .fixed-answer,.unit1d .element{display:inline-block;width:165px;height:84px;padding:4px 8px;border-radius:13px;border:2px solid #fc922c;margin:0 0 0 10px;background:#fc922c;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s}.unit1d #slots .fixed-answer[data-answer],.unit1d .element[data-answer]{transform:scale(1) translate(-8px,-4px)}.unit1d #slots .fixed-answer{position:relative;z-index:3}.unit1d #slots .hint{position:absolute;top:-15px;right:90px;transition:all .4s;opacity:1;z-index:3}.unit1d .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}.unit1d .wrong{box-shadow:0 0 5px 2px red}.unit1d .correct{border:2px solid #fff}.unit1d .unit-finish ul{margin:0 auto 40px}.unit1d .unit-exercises .unit-wrapper{padding:75px 80px 120px}.unit1d .unit-exercises .unit-wrapper:last-child{padding:75px 80px 50px}.unit1d .unit-lecture{height:80px}.unit1d .unit-lecture .unit-wrapper{padding:60px 80px 75px}.unit1d .unit-lecture .unit-wrapper .unit-section-title{line-height:50px;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.unit1d .unit-exercises,.unit1d .unit-lecture{background:#fff}.unit1d .unit-exercises .unit-exercise-description,.unit1d .unit-lecture .unit-exercise-description{padding-bottom:35px;border-bottom:3px solid #fc922c;margin-bottom:50px}.unit1d .unit-exercises .unit-exercise-description ol,.unit1d .unit-exercises .unit-exercise-description p,.unit1d .unit-lecture .unit-exercise-description ol,.unit1d .unit-lecture .unit-exercise-description p{font-family:Source Sans Pro,Arial,sans-serif;font-size:18px;line-height:28px}.unit1d .unit-exercises .unit-exercise-description ol,.unit1d .unit-lecture .unit-exercise-description ol{margin:23px 28px;font-weight:700}.unit1d .unit-exercises .unit-exercise-description ol .anchor,.unit1d .unit-lecture .unit-exercise-description ol .anchor{color:#000;text-decoration:none}.unit1d .unit-exercises .unit-exercise-description ol .anchor:hover,.unit1d .unit-lecture .unit-exercise-description ol .anchor:hover{text-decoration:underline}.unit1d .unit-exercises .exercise,.unit1d .unit-lecture .exercise{padding:0}.unit1d .unit-exercises .exercise .exercise-number,.unit1d .unit-lecture .exercise .exercise-number{font-size:51px;line-height:68px;color:#050e61}.unit1d .unit-exercises .exercise .exercise-title,.unit1d .unit-lecture .exercise .exercise-title{font-size:48px;line-height:60px;font-weight:600;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61}.unit1d .unit-exercises .exercise .exercise-pre-description,.unit1d .unit-lecture .exercise .exercise-pre-description{font-size:14px}.unit1d .unit-exercises .exercise .exercise-description,.unit1d .unit-lecture .exercise .exercise-description{column-count:2;column-gap:30px;margin-top:30px;font-size:18px}.unit1d .unit-exercises .exercise .exercise-description .marked,.unit1d .unit-lecture .exercise .exercise-description .marked{color:#fc922c}.unit1d .unit-exercises .exercise .exercise-reference,.unit1d .unit-lecture .exercise .exercise-reference{float:right;margin-top:42px;text-align:right;font-size:15px;line-height:18px}.unit1d .unit-exercises .exercise .exercise-reference:after,.unit1d .unit-lecture .exercise .exercise-reference:after{content:\"\";clear:both}.unit1d .unit-exercises .diagram,.unit1d .unit-lecture .diagram{background:linear-gradient(180deg,rgba(4,69,123,.6),rgba(4,69,123,.3) 60%,rgba(4,69,123,0) 75%),url(\"/assets/images/section-1-bg.png\");min-height:550px;background-repeat:no-repeat;background-position:50%;background-size:cover}.unit1d .unit-exercises .diagram .unit-wrapper,.unit1d .unit-lecture .diagram .unit-wrapper{padding:44px 80px 45px}.unit1d .unit-exercises .diagram .diagram_ex-2,.unit1d .unit-lecture .diagram .diagram_ex-2{padding-right:0;padding-left:0}.unit1d .unit-exercises .diagram .diagram-description,.unit1d .unit-lecture .diagram .diagram-description{position:absolute;top:100px;left:-50px;padding-left:0;font-size:14px;line-height:18px;max-width:376px;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";color:#050e61;counter-reset:my-desc-counter;list-style:none}.unit1d .unit-exercises .diagram .diagram-description li:before,.unit1d .unit-lecture .diagram .diagram-description li:before{display:inline-block;text-align:center;width:18px;padding-right:4px;content:counter(my-desc-counter);counter-increment:my-desc-counter}", ""]);
	
	// exports


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _ideasFitTogether = __webpack_require__(645);
	
	var _ideasFitTogether2 = _interopRequireDefault(_ideasFitTogether);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ideasFitTogetherModule = _angular2.default.module('ideasFitTogether', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.ideasFitTogether', {
	    url: '/courses/2/2a/ideas-fit-together',
	    component: 'ideasFitTogether',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('ideasFitTogether', _ideasFitTogether2.default).name;
	
	exports.default = ideasFitTogetherModule;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ideasFitTogether = __webpack_require__(646);
	
	var _ideasFitTogether2 = _interopRequireDefault(_ideasFitTogether);
	
	var _ideasFitTogether3 = __webpack_require__(647);
	
	var _ideasFitTogether4 = _interopRequireDefault(_ideasFitTogether3);
	
	__webpack_require__(648);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ideasFitTogetherComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _ideasFitTogether2.default,
	  controller: _ideasFitTogether4.default
	};
	
	exports.default = ideasFitTogetherComponent;

/***/ }),
/* 646 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-2 unit2a\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>ideas-fit-together.course-name</h1>\n  </course-header>\n\n  <course-video lecture-title=\"'ideas-fit-together.course-video.lecture-title'\" modifier=\"'_1'\"/>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper remove-margin\">\n      <plain-text>\n        <div translate>ideas-fit-together.intro</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">ideas-fit-together.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">ideas-fit-together.menu-list.exercise-2</a></li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>ideas-fit-together.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\" id=\"exercise-1\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>ideas-fit-together.exercise-number</span>\n      <h3 class=\"exercise-title\" translate>ideas-fit-together.exercise-title</h3>\n      <plain-text>\n        <div ng-class=\"{'highlight-answer': vm.middleOfPage}\" translate>ideas-fit-together.exercise-description</div>\n      </plain-text>\n\n      <div class=\"structure\">\n        <img src=\"/assets/images/structure-2b.png\" alt=\"Original structure\"/>\n      </div>\n    </div>\n  </section>\n\n  <course-video modifier=\"'_2'\"/>\n\n  <section class=\"exercise\" id=\"exercise-2\">\n<!--    <div class=\"unit-wrapper remove-margin\">-->\n<!--      <span class=\"exercise-title\" translate>ideas-fit-together.reading-exercise-title</span>-->\n<!--      <p class=\"exercise-description\" translate>ideas-fit-together.reading-exercise-descripton</p>-->\n<!--    </div>-->\n    <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\" 'ideas-fit-together.congratulation-message'\"\n                 finish-section=\" 'ideas-fit-together.finish-section' \"\n                 final-description=\" 'ideas-fit-together.final-description' \"\n                 next-course-button=\" 'ideas-fit-together.next-course-button' \"\n                 dashboard-button=\" 'ideas-fit-together.dashboard-button' \"\n                 next-course=\"'course.creatingQuestion'\"></unit-finish>\n  </section>\n\n\n<!--  <pyramid-builder section-title=\"{{ 'ideas-fit-together.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IdeasFitTogetherController = function (_CourseController) {
	  IdeasFitTogetherController.$inject = ["courseService", "helperService", "$sce", "$document", "$window", "$scope"];
	  (0, _inherits3.default)(IdeasFitTogetherController, _CourseController);
	
	  function IdeasFitTogetherController(courseService, helperService, $sce, $document, $window, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, IdeasFitTogetherController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (IdeasFitTogetherController.__proto__ || (0, _getPrototypeOf2.default)(IdeasFitTogetherController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce, $document: $document, $window: $window, $scope: $scope });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207530');
	    // this.helperService.initIntercom();
	    _this.$window.onscroll = function () {
	      if (_this.$window.scrollY >= _this.$document.innerHeight() / 3) {
	        _this.middleOfPage = true;
	        _this.$scope.$apply();
	      }
	    };
	    _this.isUnit = true;
	    _this.introCounted = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(IdeasFitTogetherController, [{
	    key: 'onSectionFinish',
	    value: function onSectionFinish() {
	      if (this.courseData.is_completed) {
	        return;
	      }
	      var params = {
	        statisticableId: this.courseData.intro_id,
	        statisticableType: 'UnitIntro',
	        secondsSpent: Math.floor((Date.now() - this.unitStart) / 1000),
	        completed: true,
	        attempts: 0,
	        hintsUsed: 0,
	        rightAnswers: 0
	      };
	      this.courseService.sendUserStatistic(params);
	      this.courseData.is_completed = true;
	    }
	  }]);
	  return IdeasFitTogetherController;
	}(_course2.default);
	
	exports.default = IdeasFitTogetherController;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(649);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./ideasFitTogether.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./ideasFitTogether.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit2a .structure{margin:20px -50px 0}.unit2a .highlight-answer p span{color:#be390a}", ""]);
	
	// exports


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _creatingQuestion = __webpack_require__(651);
	
	var _creatingQuestion2 = _interopRequireDefault(_creatingQuestion);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creatingQuestionModule = _angular2.default.module('creatingQuestion', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.creatingQuestion', {
	    url: '/courses/2/2b/creating-question-answer-dialog',
	    component: 'creatingQuestion',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('creatingQuestion', _creatingQuestion2.default).name;
	
	exports.default = creatingQuestionModule;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _creatingQuestion = __webpack_require__(652);
	
	var _creatingQuestion2 = _interopRequireDefault(_creatingQuestion);
	
	var _creatingQuestion3 = __webpack_require__(653);
	
	var _creatingQuestion4 = _interopRequireDefault(_creatingQuestion3);
	
	__webpack_require__(654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creatingQuestionComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _creatingQuestion2.default,
	  controller: _creatingQuestion4.default
	};
	
	exports.default = creatingQuestionComponent;

/***/ }),
/* 652 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-2 unit2b\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>creating-question-answer-dialog.course-name</h1>\n  </course-header>\n\n  <course-video lecture-title=\"'creating-question-answer-dialog.course-video.lecture-title'\" />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>creating-question-answer-dialog.unit-section-title</span>\n  </h2>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>creating-question-answer-dialog.intro</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">creating-question-answer-dialog.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">creating-question-answer-dialog.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">creating-question-answer-dialog.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">creating-question-answer-dialog.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">creating-question-answer-dialog.menu-list.exercise-5</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">creating-question-answer-dialog.menu-list.exercise-6</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-7')\">creating-question-answer-dialog.menu-list.exercise-7</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-8')\">creating-question-answer-dialog.menu-list.exercise-8</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-9')\">creating-question-answer-dialog.menu-list.exercise-9</a></li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-1\">\n    <div class=\"unit-wrapper remove-margin\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-1.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-1.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-1.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-1.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-1>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-2\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-2.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-2.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-2.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-2.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-2>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-3\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-3.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-3.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-3.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-3.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-3>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-4\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-4.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-4.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-4.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-4.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-4>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-5\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-5.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-5.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-5.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-5.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-5>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-6\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-6.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-6.title</span>\n      <p class=\"exercise-pre-description\" translate>creating-question-answer-dialog.exercise-6.pre-description</p>\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-6.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-6.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-6 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-6>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-7\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-7.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-7.title</span>\n      <p class=\"exercise-pre-description\" translate>creating-question-answer-dialog.exercise-7.pre-description</p>\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-7.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-7.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-7 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-7>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper\">\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-7.description-2</p>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-7-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-7-2>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-8\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-8.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-8.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-8.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-8.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-8 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-8>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-9\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-number\" translate>creating-question-answer-dialog.exercise-9.number</span>\n      <span class=\"exercise-title\" translate>creating-question-answer-dialog.exercise-9.title</span>\n      <!--<p class=\"exercise-pre-description\" translate></p>-->\n      <p class=\"double-column\" translate>creating-question-answer-dialog.exercise-9.description</p>\n      <span class=\"exercise-reference\" translate>creating-question-answer-dialog.exercise-9.reference</span>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-2-2-B-1-ex-9 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-2-2-B-1-ex-9>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'creating-question-answer-dialog.congratulation-message'\" finish-section=\"'creating-question-answer-dialog.finish-section'\"\n      final-description=\"'creating-question-answer-dialog.final-description'\" next-course-button=\"'creating-question-answer-dialog.next-course-button'\"\n      dashboard-button=\"'creating-question-answer-dialog.dashboard-button'\" next-course=\"'course.deductiveReasoning'\"></unit-finish>\n  </section>\n<!--  <pyramid-builder section-title=\"{{ 'creating-question-answer-dialog.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _uiHelper = __webpack_require__(212);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var creatingQuestionController = function (_CourseController) {
	  creatingQuestionController.$inject = ["helperService", "$sce", "courseService", "$scope"];
	  (0, _inherits3.default)(creatingQuestionController, _CourseController);
	
	  function creatingQuestionController(helperService, $sce, courseService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, creatingQuestionController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (creatingQuestionController.__proto__ || (0, _getPrototypeOf2.default)(creatingQuestionController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce, gotoAnchor: _uiHelper.gotoAnchor, courseService: courseService });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207538');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram2b1-';
	    return _this;
	  }
	
	  return creatingQuestionController;
	}(_course2.default);
	
	exports.default = creatingQuestionController;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(655);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./creatingQuestion.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./creatingQuestion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit2b .exercise .exercise-pre-description{margin-bottom:30px}.unit2b .intro ol{font-weight:700}.unit2b .intro .unit-wrapper div ol{padding-bottom:50px;border-bottom:3px solid #a7dec3}.unit2b .question{color:#fff;position:absolute;left:353px;top:221px;font-size:28px;font-family:Nexa-Bold,sans pro,\"serif\"}.unit2b .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61;position:relative}.unit2b .diagram-task{float:left;width:100%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:130px;padding-left:5px}.unit2b .checkboxes-task{position:absolute;padding:0;top:80px}.unit2b .checkboxes-task .question-title{font-size:45px;line-height:68px;color:#050e61;display:block}.unit2b .checkboxes-task .checkbox-description{cursor:pointer;display:block;margin-left:40px;text-align:left;color:#050e61;font-size:1.2rem}.unit2b .checkboxes-task .checkbox{position:relative;height:5px}.unit2b .checkboxes-task .checkbox input+label{position:absolute;top:4px;display:block;height:22px;width:22px;border:3px solid #fff;border-radius:9px;box-shadow:0 0 3px rgba(0,0,0,.5);z-index:2;cursor:pointer}.unit2b .checkboxes-task .checkbox input+label:after{content:\"\";position:absolute;display:block;top:0;left:0;box-shadow:inset 0 0 3px 0 #000;height:16px;width:16px;border:none;border-radius:9px;background:#fff;z-index:1;opacity:0;transition:opacity .2s}.unit2b .checkboxes-task .checkbox input:disabled+label{cursor:default}.unit2b .checkboxes-task input[type=checkbox]{opacity:0}.unit2b .checkboxes-task input[type=checkbox]:checked+label:after{opacity:1}.unit2b .checkboxes-task input[type=radio]{opacity:0}.unit2b .checkboxes-task input[type=radio]:checked+label:after,.unit2b .checkboxes-task input[type=radio]:hover+label:after{opacity:1}.unit2b .submit{width:100%;padding-left:10%}.unit2b .submit .hint-exercise-button{opacity:1;transition:opacity 2s ease-in}.unit2b .submit .next-exercise-button,.unit2b .submit .submit-exercise-button{float:right}.unit2b .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.unit2b .slots{margin:0 auto}.unit2b #slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit2b #slots td{font-size:0}.unit2b .separator{position:relative;height:88px}.unit2b .separator svg{position:absolute;top:-2px;left:0;z-index:2;overflow:visible}.unit2b #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit2b #elements td{padding:10px}.unit2b .slots td{padding:0 10px;font-size:0}.unit2b #slots div{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #a7dec3;border-radius:15px;margin:0 0 0 10px;background:#a7dec3;transition:all .2s ease}.unit2b #elements div:first-child,.unit2b #slots div:first-child{margin-left:0}.unit2b #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit2b .element{display:inline-block;width:167px;height:86px;padding:4px 8px;border-radius:13px;border:2px solid #a7dec3;margin:0 0 0 10px;background:#a7dec3;font-size:14px;line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s}.unit2b .element[data-answer]{transform:scale(1) translate(-8px,-4px)}.unit2b .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}.unit2b .wrong{box-shadow:0 0 5px 2px red}.unit2b .correct{border:2px solid #fff}", ""]);
	
	// exports


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _supportingPoints = __webpack_require__(657);
	
	var _supportingPoints2 = _interopRequireDefault(_supportingPoints);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportingPointsModule = _angular2.default.module('supportingPoints', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.supportingPoints', {
	    url: '/courses/3/3zero/supporting-points',
	    component: 'supportingPoints',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('supportingPoints', _supportingPoints2.default).name;
	
	exports.default = supportingPointsModule;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _supportingPoints = __webpack_require__(658);
	
	var _supportingPoints2 = _interopRequireDefault(_supportingPoints);
	
	var _supportingPoints3 = __webpack_require__(659);
	
	var _supportingPoints4 = _interopRequireDefault(_supportingPoints3);
	
	__webpack_require__(660);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var supportingPointsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _supportingPoints2.default,
	  controller: _supportingPoints4.default
	};
	
	exports.default = supportingPointsComponent;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3-zero\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>supporting-points.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>supporting-points.exercise-descripton</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"unit-finish\">\n    <div class=\"unit-wrapper\">\n      <div class=\"finish\"></div>\n      <ul>\n        <li><a ui-sref=\"site.dashboard\" class=\"finish-button\" translate>supporting-points.next-course-button</a></li>\n        <li><a ui-sref=\"site.dashboard\" class=\"finish-button\" translate>supporting-points.dashboard-button</a></li>\n      </ul>\n    </div>\n  </section>\n<!--  <pyramid-builder section-title=\"{{ 'supporting-points.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SupportingPointsController = function SupportingPointsController(helperService, $sce, courseService) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, SupportingPointsController);
	  (0, _assign2.default)(this, { helperService: helperService, $sce: $sce, courseService: courseService });
	  this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	  // this.helperService.initIntercom();
	  this.isUnit = true;
	};
	SupportingPointsController.$inject = ["helperService", "$sce", "courseService"];
	
	exports.default = SupportingPointsController;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(661);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./supportingPoints.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./supportingPoints.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit3-zero .finish{border-bottom:none;padding:0}.unit3-zero .intro .intro-side{float:left}.unit3-zero .intro .intro-side:first-child{width:38%}.unit3-zero .intro .intro-side:last-child{width:62%;padding-left:40px}.unit3-zero .intro p{clear:both}.unit3-zero .intro ul:not(:last-child){padding-left:17px}.unit3-zero .intro ul:not(:last-child) li{margin-bottom:8px}.unit3-zero .intro strong{font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _deductiveReasoning = __webpack_require__(663);
	
	var _deductiveReasoning2 = _interopRequireDefault(_deductiveReasoning);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deductiveReasoningModule = _angular2.default.module('deductiveReasoning', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.deductiveReasoning', {
	    url: '/courses/3/3a1/deductive-reasoning',
	    component: 'deductiveReasoning',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('deductiveReasoning', _deductiveReasoning2.default).name;
	
	exports.default = deductiveReasoningModule;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deductiveReasoning = __webpack_require__(664);
	
	var _deductiveReasoning2 = _interopRequireDefault(_deductiveReasoning);
	
	var _deductiveReasoning3 = __webpack_require__(665);
	
	var _deductiveReasoning4 = _interopRequireDefault(_deductiveReasoning3);
	
	__webpack_require__(678);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deductiveReasoningComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _deductiveReasoning2.default,
	  controller: _deductiveReasoning4.default
	};
	
	exports.default = deductiveReasoningComponent;

/***/ }),
/* 664 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3a-1\">\n\t<course-header>\n\t\t<h1 class=\"unit-name\" translate>deductive-reasoning.course-name</h1>\n\t</course-header>\n\n\t<course-video />\n\n\t<h2 class=\"unit-section-title background\">\n\t\t<span translate>deductive-reasoning.unit-section-title</span>\n\t</h2>\n\n\t<section>\n\t\t<div class=\"unit-wrapper\">\n\t\t\t<span class=\"exercise-title\" translate>deductive-reasoning.exercise-title</span>\n\t\t\t<p translate>deductive-reasoning.exercise-description-top</p>\n\t\t\t<div class=\"arguments-1\">\n\t\t\t\t<div class=\"arguments-title\" translate>deductive-reasoning.arguments-1-title</div>\n\t\t\t\t<div class=\"arguments-chain\">\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-1</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-statement</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-2</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-comment</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-3</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"arguments-2\">\n\t\t\t\t<div class=\"arguments-title\" translate>deductive-reasoning.arguments-2-title</div>\n\t\t\t\t<div class=\"arguments-chain\">\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-4</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-statement</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-5</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-comment</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-6</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-comment</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-7</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arguments-chain\">\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-8</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-statement</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-9</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-comment</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-10</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-11</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arguments-chain\">\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-12</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-statement</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-13</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-14</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"arguments-chain\">\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-15</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-statement</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-16</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-comment</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"element-placeholder\">\n\t\t\t\t\t\t<div class=\"element\" translate>deductive-reasoning.element-17</div>\n\t\t\t\t\t\t<div class=\"element-caption\" translate>deductive-reasoning.element-caption-therefore</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n      </div>\n\t\t\t<p translate>deductive-reasoning.exercise-description-bottom</p>\n\t\t\t<p class=\"exercise-task\">\n\t\t\t\t<span translate>deductive-reasoning.exercise-task</span>\n\t\t\t</p>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise1\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\" id=\"exercise-1\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise2\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise3\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise4\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise5\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise6\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise7\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise8\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise9\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n    <p class=\"unit-wrapper exercise-task\">\n      <span translate>deductive-reasoning.exercise-task-10</span>\n    </p>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise10\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise11\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"unit-wrapper remove-margin\">\n\t\t\t<div class=\"divider\"></div>\n\t\t</div>\n\n\t\t<div class=\"diagram\">\n\t\t\t<div class=\"unit-wrapper\">\n\t\t\t\t<highlight-diagram data=\"vm.exercise12\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></highlight-diagram>\n\t\t\t</div>\n\t\t</div>\n\n<!--    <section class=\"exercise\">-->\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                     congratulation-message=\"'deductive-reasoning.congratulation-message'\" finish-section=\"'deductive-reasoning.finish-section'\"\n       final-description=\"'deductive-reasoning.final-description'\" next-course-button=\"'deductive-reasoning.next-course-button'\"\n       dashboard-button=\"'deductive-reasoning.dashboard-button'\" next-course=\"'course.summarizingDeductive'\"></unit-finish>\n<!--    </section>-->\n  </section>\n\n\n<!--\t <pyramid-builder section-title=\"{{ 'deductive-reasoning.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(666);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(667);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(668);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(669);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(670);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(671);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	var _exercise13 = __webpack_require__(672);
	
	var _exercise14 = _interopRequireDefault(_exercise13);
	
	var _exercise15 = __webpack_require__(673);
	
	var _exercise16 = _interopRequireDefault(_exercise15);
	
	var _exercise17 = __webpack_require__(674);
	
	var _exercise18 = _interopRequireDefault(_exercise17);
	
	var _exercise19 = __webpack_require__(675);
	
	var _exercise20 = _interopRequireDefault(_exercise19);
	
	var _exercise21 = __webpack_require__(676);
	
	var _exercise22 = _interopRequireDefault(_exercise21);
	
	var _exercise23 = __webpack_require__(677);
	
	var _exercise24 = _interopRequireDefault(_exercise23);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnearthingEmbeddedArgumentsController = function (_CourseController) {
	  UnearthingEmbeddedArgumentsController.$inject = ["helperService", "$sce", "courseService", "$scope"];
	  (0, _inherits3.default)(UnearthingEmbeddedArgumentsController, _CourseController);
	
	  function UnearthingEmbeddedArgumentsController(helperService, $sce, courseService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UnearthingEmbeddedArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnearthingEmbeddedArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(UnearthingEmbeddedArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { courseService: courseService, helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322207695');
	
	    _this.lang = 'en';
	    _this.exercise1 = _exercise2.default[_this.lang];
	    _this.exercise2 = _exercise4.default[_this.lang];
	    _this.exercise3 = _exercise6.default[_this.lang];
	    _this.exercise4 = _exercise8.default[_this.lang];
	    _this.exercise5 = _exercise10.default[_this.lang];
	    _this.exercise6 = _exercise12.default[_this.lang];
	    _this.exercise7 = _exercise14.default[_this.lang];
	    _this.exercise8 = _exercise16.default[_this.lang];
	    _this.exercise9 = _exercise18.default[_this.lang];
	    _this.exercise10 = _exercise20.default[_this.lang];
	    _this.exercise11 = _exercise22.default[_this.lang];
	    _this.exercise12 = _exercise24.default[_this.lang];
	    _this.isUnit = true;
	    _this.exerciseIdsStart = '';
	    return _this;
	  }
	
	  return UnearthingEmbeddedArgumentsController;
	}(_course2.default);
	
	exports.default = UnearthingEmbeddedArgumentsController;

/***/ }),
/* 666 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        title: 'Example',
	        number: 1,
	        diagramId: 0,
	        answer: '',
	        example: true,
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'Physical laws dictate that an organism’s every action is the result of previous events',
	                answer: 'Physical laws dictate that an <span class="highlight__answer highlight__answer_example">organism’s</span> every action is the result of previous events'
	            }
	        }, {
	            task: {
	                question: 'Human beings are organisms, and consequently subject to those laws',
	                answer: 'Human beings are <span class="highlight__answer highlight__answer_example">organisms</span>, and consequently subject to those laws'
	            }
	        }, {
	            task: {
	                question: 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control',
	                answer: 'Thus, human behaviour must result from a complete sequence of causes and effects that is completely out of our control'
	            }
	        }]
	    }
	};

/***/ }),
/* 667 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 2,
	        diagramId: 1,
	        answers: 'Neither boxers nor epileptics can remember both can remember',
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'Neither boxers nor epileptics can remember events immediately before a blow or a seizure',
	                answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Neither boxers nor epileptics can remember</span> events immediately before a blow or a seizure</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'But both can remember much earlier events',
	                answer: '<span class="correct-answer-box">But <span class="highlight__answer highlight__answer_correct">both can remember</span> much earlier events</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Suggests people need time to consolidate short-term memories before entering them into long-term storage',
	                answer: '<span class="correct-answer-box">Suggests people need time to consolidate short-term memories before entering them into long-term storage</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 668 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 3,
	        diagramId: 2,
	        answers: 'fish contain trimethylamine N-oxide (TMAO), TMAO stops working',
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'Deepwater fish contain trimethylamine N-oxide (TMAO), which maintains the osmotic pressure needed to keep water from diffusing into their cells',
	                answer: '<span class="correct-answer-box">Deepwater <span class="highlight__answer highlight__answer_correct">fish contain trimethylamine N-oxide (TMAO),</span> which maintains the osmotic pressure needed to keep water from diffusing into their cells</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'However, TMAO stops working below 7,000 meters, presumably dooming any fish swimming deeper to “drown”',
	                answer: '<span class="correct-answer-box">However, <span class="highlight__answer highlight__answer_correct">TMAO stops working</span> below 7,000 meters, presumably dooming any fish swimming deeper to “drown”</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote',
	                answer: '<span class="correct-answer-box">Thus the chances of photographing fish in the Hadad trenches (between 8,000 and 10,000 meters) are remote</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 669 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 4,
	        diagramId: 3,
	        answers: 'western window western window',
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'The western window is the only window that looks directly out on the moor',
	                answer: '<span class="correct-answer-box">The <span class="highlight__answer highlight__answer_correct">western window</span> is the only window that looks directly out on the moor</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'Barrymore was staring out of the western window',
	                answer: '<span class="correct-answer-box">Barrymore was staring out of the <span class="highlight__answer highlight__answer_correct">western window</span></span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Therefore Barrymore must have been looking for something or someone on the moor',
	                answer: '<span class="correct-answer-box">Therefore Barrymore must have been looking for something or someone on the moor</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 670 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        answers: 'areas of the brain stimulate development of those areas',
	        interactiveBoxNumber: [1],
	        number: 5,
	        diagramId: 4,
	        blocks: [{
	            task: {
	                question: 'Many different areas of the brain must work together to perform music',
	                answer: '<span class="correct-answer-box">Many different <span class="highlight__answer highlight__answer_correct">areas of the brain</span> must work together to perform music</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'Active participation in music may stimulate development of those areas',
	                answer: '<span class="correct-answer-box">Active participation in music may <span class="highlight__answer highlight__answer_correct">stimulate development of those areas</span></span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'The implication for early education in the arts is clear',
	                answer: '<span class="correct-answer-box">The implication for early education in the arts is clear</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 671 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        answers: '"left brain” skills left-hemispheres',
	        interactiveBoxNumber: [1],
	        number: 6,
	        diagramId: 5,
	        blocks: [{
	            task: {
	                question: 'Early childhood teaching focuses on developing the “left brain” skills of reading, writing and ‘rithmatic',
	                answer: '<span class="correct-answer-box">Early childhood teaching focuses on developing the <span class="highlight__answer highlight__answer_correct highlight__answer_correct_6">"left brain” skills</span> of reading, writing and ‘rithmatic</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'But scientists have recorded striking changes in the left-hemispheres of children who have had only a single year of violin',
	                answer: '<span class="correct-answer-box">But scientists have recorded striking changes in the <span class="highlight__answer highlight__answer_correct highlight__answer_correct_6">left-hemispheres</span> of children who have had only a single year of violin</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Music may be every bit as important educationally as reading or writing',
	                answer: '<span class="correct-answer-box">Music may be every bit as important educationally as reading or writing</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 672 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        answers: 'create a lot of jobs cut jobs',
	        interactiveBoxNumber: [1],
	        number: 7,
	        diagramId: 6,
	        blocks: [{
	            task: {
	                question: 'Market-creating innovations demand capital to grow, but they do create a lot of jobs',
	                answer: '<span class="correct-answer-box correct-answer-box_7">Market-creating innovations demand capital to grow, but they do <span class="highlight__answer highlight__answer_correct">create a lot of jobs</span></span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'Efficiency innovations – achieved by cutting the cost of a product or service – usually cut jobs',
	                answer: '<span class="correct-answer-box correct-answer-box_7">Efficiency innovations – achieved by cutting the cost of a product or service – usually <span class="highlight__answer highlight__answer_correct">cut jobs</span></span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them',
	                answer: '<span class="correct-answer-box">If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 673 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 8,
	        diagramId: 7,
	        answers: 'every gene is present in every cell Each cell type contains',
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'Almost every gene of the genome is present in every cell of the body, though only some are turned on',
	                answer: '<span class="correct-answer-box correct-answer-box_8">Almost <span class="highlight__answer highlight__answer_correct">every gene</span> of the genome <span class="highlight__answer highlight__answer_correct">is present in every cell</span> of the body, though only some are turned on</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'Each cell type thus contains a unique mix of proteins – a subpopulation of all the proteins available to the cell',
	                answer: '<span class="correct-answer-box correct-answer-box_8"><span class="highlight__answer highlight__answer_correct">Each cell type</span> thus <span class="highlight__answer highlight__answer_correct">contains</span> a unique mix of proteins – a subpopulation of all the proteins available to the cell</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)',
	                answer: '<span class="correct-answer-box correct-answer-box_8">The mix limits the cell to performing only its specific biological function (a liver cell is a liver cell, and a brain cell is a brain cell)</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 9,
	        diagramId: 8,
	        answers: 'Uncertainty paralyzes paralysis results in',
	        interactiveBoxNumber: [1],
	        blocks: [{
	            task: {
	                question: 'Uncertainty in government policy paralyzes, making businesses and consumers less sensitive to outside forces',
	                answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Uncertainty</span> in government policy <span class="highlight__answer highlight__answer_correct">paralyzes</span>, making businesses and consumers less sensitive to outside forces</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'The paralysis results in productive firms being slow to expand, and unproductive firms slow to contract',
	                answer: '<span class="correct-answer-box">The <span class="highlight__answer highlight__answer_correct">paralysis results in</span> productive firms being slow to expand, and unproductive firms slow to contract</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity',
	                answer: '<span class="correct-answer-box">Thus resources don’t get reallocated, shutting down the primary mechanism for increasing productivity</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 675 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 10,
	        diagramId: 9,
	        answers: 'plants sense and respond to Suspect brain-like processing',
	        interactiveBoxNumber: [1, 2],
	        blocks: [{
	            task: {
	                question: 'Plant microbiologists see evidence that plants sense and respond to environmental variables',
	                answer: '<span class="correct-answer-box">Plant microbiologists see evidence that <span class="highlight__answer highlight__answer_correct">plants sense and respond to</span> environmental variables</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'Suspect they have a sophisticated, brain-like information processing and signalling system to sense and respond',
	                answer: '<span class="correct-answer-box"><span class="highlight__answer highlight__answer_correct">Suspect</span> they have a sophisticated, <br><span class="highlight__answer highlight__answer_correct">brain-like</span> information <span class="highlight__answer highlight__answer_correct">processing</span> and signalling system to sense and respond</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'But without an actual brain, think their intelligence may be organized In a network, like insect colonies',
	                answer: '<span class="correct-answer-box">But without an actual brain, think their <span class="highlight__answer highlight__answer_correct">intelligence may be organized In a network</span>, like insect colonies</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains',
	                answer: '<span class="correct-answer-box">Thus they are researching how networks can inspire brainy behaviour in the absence of actual brains</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 676 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 11,
	        diagramId: 10,
	        answers: 'clouds contain droplets droplets must coalesce droplets can’t coalesce',
	        interactiveBoxNumber: [1, 2],
	        blocks: [{
	            task: {
	                question: 'Clouds that could produce rain contain micron-size droplets of water, kept aloft by updrafts',
	                answer: '<span class="correct-answer-box correct-answer-box_11">Clouds that could produce rain contain micron-size <span class="highlight__answer highlight__answer_correct">clouds contain droplets</span> of water, kept aloft by updrafts</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'To escape the updrafts, droplets must coalesce into ice pellets',
	                answer: '<span class="correct-answer-box correct-answer-box_11">To escape the updrafts, <span class="highlight__answer highlight__answer_correct">droplets must coalesce</span> into ice pellets</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'The droplets can’t coalesce without dust particles to serve as nuclei',
	                answer: '<span class="correct-answer-box correct-answer-box_11">The <span class="highlight__answer highlight__answer_correct">droplets can’t coalesce</span> without dust particles to serve as nuclei</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'To get rain, we mimic the dust particles with silver iodide',
	                answer: '<span class="correct-answer-box correct-answer-box_11">To get rain, we mimic the dust particles with silver iodide</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 677 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        number: 12,
	        diagramId: 11,
	        answers: 'economic linkages connections generate tensions, new tensions',
	        interactiveBoxNumber: [1, 2],
	        blocks: [{
	            task: {
	                question: 'Global oil and gas markets are part of a dense network of economic linkages and connections',
	                answer: '<span class="correct-answer-box">Global oil and gas markets are part of a dense network of <span class="highlight__answer highlight__answer_correct">economic linkages</span> and connections</span>'
	            },
	            example: true
	        }, {
	            task: {
	                question: 'These connections generate tensions, particularly around trade and currencies',
	                answer: '<span class="correct-answer-box">These <span class="highlight__answer highlight__answer_correct">connections generate tensions,</span> particularly around trade and currencies</span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'China’s growth will bring about a new balance in the market, generating new tensions',
	                answer: '<span class="correct-answer-box">China’s growth will bring about a new balance in the market, generating <span class="highlight__answer highlight__answer_correct">new tensions</span></span>'
	            },
	            selectAvailable: true
	        }, {
	            task: {
	                question: 'Important not to recast normal petro rivalry into a contest of nation states',
	                answer: '<span class="correct-answer-box">Important not to recast normal petro rivalry into a contest of nation states</span>'
	            }
	        }]
	    }
	};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(679);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./deductiveReasoning.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./deductiveReasoning.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit3a-1 .element{display:inline-block;width:167px;height:86px;padding:4px 8px;border-radius:13px;margin:0 0 0 10px;font-size:14px;line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s}.unit3a-1 .element[data-answer]{transform:scale(1) translate(-8px,-4px)}.unit3a-1 .arguments-1{padding-bottom:40px}.unit3a-1 .arguments-2{margin-bottom:20px}.unit3a-1 .arguments-2 .arguments-chain{margin-bottom:30px}.unit3a-1 .arguments-2 .arguments-chain:nth-child(3) .element{height:167px}.unit3a-1 .arguments-2 .arguments-chain:nth-child(4) .element{height:106px}.unit3a-1 .arguments-title{font-family:Source Sans Pro,sans pro,Arial,serif;font-weight:700;margin:30px 0 50px}.unit3a-1 .element-placeholder{margin-right:20px;color:#050e61}.unit3a-1 .arguments-chain{display:flex}.unit3a-1 .element{border:2px solid #a7dec3;background:#a7dec3;margin:0;cursor:default}.unit3a-1 .element-caption{text-align:center;font-size:12px;line-height:30px}.unit3a-1 .exercise-task{border-top:3px solid #a7dec3;padding-top:40px;margin-top:50px}.unit3a-1 .exercise-task span{width:50%;color:#050e61;display:inline-block;font-family:Nexa-Bold,sans pro,\"serif\";letter-spacing:1px;line-height:24px}.unit3a-1 .diagram{min-height:300px;background-position-y:-200px}.unit3a-1 .divider{border-top:3px solid #a7dec3;border-bottom:0;margin-bottom:10px;padding-bottom:0}.unit3a-1 .submit{float:none}.unit3a-1 .submit button{border:2px solid #fff;color:#fff}", ""]);
	
	// exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _summarizingDeductive = __webpack_require__(681);
	
	var _summarizingDeductive2 = _interopRequireDefault(_summarizingDeductive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var authenticate = function authenticate(authService) {
	  "ngInject";
	
	  return authService.protectRoute();
	};
	authenticate.$inject = ["authService"];
	
	var summarizingDeductiveModule = _angular2.default.module('summarizingDeductive', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.summarizingDeductive', {
	    url: '/courses/3/3a2/summarizing-deductive',
	    component: 'summarizingDeductive'
	    // resolve: { authenticate }
	  });
	}]).component('summarizingDeductive', _summarizingDeductive2.default).name;
	
	exports.default = summarizingDeductiveModule;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _summarizingDeductive = __webpack_require__(682);
	
	var _summarizingDeductive2 = _interopRequireDefault(_summarizingDeductive);
	
	var _summarizingDeductive3 = __webpack_require__(683);
	
	var _summarizingDeductive4 = _interopRequireDefault(_summarizingDeductive3);
	
	__webpack_require__(684);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var summarizingDeductiveComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _summarizingDeductive2.default,
	  controller: _summarizingDeductive4.default
	};
	
	exports.default = summarizingDeductiveComponent;

/***/ }),
/* 682 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3a-2\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>summarizing-deductive.course-name</h1>\n  </course-header>\n\n  <section class=\"exercise\"></section>\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>summarizing-deductive.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <span class=\"exercise-title\" translate>summarizing-deductive.exercise-title</span>\n      <p translate>summarizing-deductive.exercise-description-1</p>\n      <div class=\"structure\">\n        <img src=\"/assets/images/structure-3a2-1.png\" alt=\"Original structure\">\n      </div>\n      <p translate>summarizing-deductive.exercise-description-2</p>\n      <div class=\"structure\">\n        <img src=\"/assets/images/structure-3a2-2-new.png\" alt=\"Original structure\">\n      </div>\n      <p translate>summarizing-deductive.exercise-description-3</p>\n      <ol class=\"anchors-menu\">\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">summarizing-deductive.menu-list.exercise-1</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">summarizing-deductive.menu-list.exercise-2</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">summarizing-deductive.menu-list.exercise-3</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">summarizing-deductive.menu-list.exercise-4</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">summarizing-deductive.menu-list.exercise-5</a></li>\n      </ol>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>summarizing-deductive.exercise-1-number</p>\n      <p class=\"exercise-title\" translate>summarizing-deductive.exercise-1-title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-2-ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-2-ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>summarizing-deductive.exercise-2-number</p>\n      <p class=\"exercise-title\" translate>summarizing-deductive.exercise-2-title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-2-ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-2-ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>summarizing-deductive.exercise-3-number</p>\n      <p class=\"exercise-title\" translate>summarizing-deductive.exercise-3-title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-2-ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-2-ex-3>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>summarizing-deductive.exercise-4-number</p>\n      <p class=\"exercise-title\" translate>summarizing-deductive.exercise-4-title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-2-ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-2-ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>summarizing-deductive.exercise-5-number</p>\n      <p class=\"exercise-title\" translate>summarizing-deductive.exercise-5-title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-2-ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-2-ex-5>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                   congratulation-message=\"'summarizing-deductive.congratulation-message'\" finish-section=\"'summarizing-deductive.finish-section'\"\n        final-description=\"'summarizing-deductive.final-description'\" next-course-button=\"'summarizing-deductive.next-course-button'\"\n        dashboard-button=\"'summarizing-deductive.dashboard-button'\" next-course=\"'course.unearthingEmbeddedArguments'\"></unit-finish>\n    </div>\n  </section>\n<!--  <pyramid-builder section-title=\"{{ 'summarizing-deductive.course-name' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SummarizingDeductiveController = function (_CourseController) {
	  SummarizingDeductiveController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(SummarizingDeductiveController, _CourseController);
	
	  function SummarizingDeductiveController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SummarizingDeductiveController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SummarizingDeductiveController.__proto__ || (0, _getPrototypeOf2.default)(SummarizingDeductiveController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    // this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3a2-';
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  return SummarizingDeductiveController;
	}(_course2.default);
	
	exports.default = SummarizingDeductiveController;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./summarizingDeductive.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./summarizingDeductive.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit3a-2 .unit-header+.exercise{padding-bottom:150px}.unit3a-2 .structure{padding:20px 0}.unit3a-2 ol{font-weight:700;border-bottom:3px solid #a7dec3;padding-bottom:45px;margin:20px 0 0}.unit3a-2 .exercise-title{margin-top:0;margin-bottom:50px;font-size:53px}.unit3a-2 .exercise-title:not(:first-child){margin-bottom:0}.unit3a-2 .exercise-number{margin-top:25px;font-weight:700}.unit3a-2 #slots .fixed-answer-bg{background-color:rgba(167,222,195,.4)!important}.unit3a-2 #slots .fixed-answer-bg:focus,.unit3a-2 #slots .fixed-answer-bg:hover{background-color:#a7dec3!important}.unit3a-2 #slots .fixed-answer,.unit3a-2 .element{border:2px solid #fff;background:transparent;height:90px}.unit3a-2 #slots .answer-field:focus,.unit3a-2 #slots .answer-field:hover,.unit3a-2 #slots .fixed-answer:hover{background-color:#a7dec3}.unit3a-2 #slots .answer-field{text-align:left;cursor:text}.unit3a-2 #slots .answer-field::placeholder{font-style:italic;color:#fff}.unit3a-2 #slots .answer-field span{font-style:italic}.unit3a-2 .separator svg{z-index:0}", ""]);
	
	// exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _unearthingEmbeddedArguments = __webpack_require__(687);
	
	var _unearthingEmbeddedArguments2 = _interopRequireDefault(_unearthingEmbeddedArguments);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unearthingEmbeddedArgumentsModule = _angular2.default.module('unearthingEmbeddedArguments', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.unearthingEmbeddedArguments', {
	    url: '/courses/3/3a3/unearthing-embedded-arguments',
	    component: 'unearthingEmbeddedArguments',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('unearthingEmbeddedArguments', _unearthingEmbeddedArguments2.default).name;
	
	exports.default = unearthingEmbeddedArgumentsModule;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _unearthingEmbeddedArguments = __webpack_require__(688);
	
	var _unearthingEmbeddedArguments2 = _interopRequireDefault(_unearthingEmbeddedArguments);
	
	var _unearthingEmbeddedArguments3 = __webpack_require__(689);
	
	var _unearthingEmbeddedArguments4 = _interopRequireDefault(_unearthingEmbeddedArguments3);
	
	__webpack_require__(690);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unearthingEmbeddedArgumentsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _unearthingEmbeddedArguments2.default,
	  controller: _unearthingEmbeddedArguments4.default
	};
	
	exports.default = unearthingEmbeddedArgumentsComponent;

/***/ }),
/* 688 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3a-3\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>unearthing-arguments.course-name</h1>\n  </course-header>\n\n  <section class=\"exercise\"></section>\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>unearthing-arguments.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <span class=\"exercise-title\" translate>unearthing-arguments.exercise-title</span>\n        <p translate>unearthing-arguments.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">unearthing-arguments.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">unearthing-arguments.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">unearthing-arguments.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">unearthing-arguments.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">unearthing-arguments.menu-list.exercise-5</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">unearthing-arguments.menu-list.exercise-6</a></li>\n        </ol>\n        <p translate>unearthing-arguments.exercise-bottom</p>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-1.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-1.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-1 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-2.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-2.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-2 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-3.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-3.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-3.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-3 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-3>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-4.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-4.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-4 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-5.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-5.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-5.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-5 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-5>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-6\">\n      <p class=\"exercise-number\" translate>unearthing-arguments.exercise-6.number</p>\n      <p class=\"exercise-title\" translate>unearthing-arguments.exercise-6.title</p>\n      <p class=\"exercise-description\" translate>unearthing-arguments.exercise-6.description</p>\n      <p class=\"exercise-reference\" translate>unearthing-arguments.exercise-6.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-A-3-Ex-6 on-finish=\"vm.sendStatistic($event)\"  finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-A-3-Ex-6>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                   congratulation-message=\"'unearthing-arguments.congratulation-message'\" finish-section=\"'unearthing-arguments.finish-section'\"\n        final-description=\"'unearthing-arguments.final-description'\" next-course-button=\"'unearthing-arguments.next-course-button'\"\n        dashboard-button=\"'unearthing-arguments.dashboard-button'\" next-course=\"'course.inductiveReasoning'\"></unit-finish>\n    </div>\n  </section>\n\n<!--    <pyramid-builder section-title=\"{{ 'unearthing-arguments.course-title' | translate }}\">-->\n<!--    </pyramid-builder>-->\n</div>\n"

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UnearthingEmbeddedController = function (_CourseController) {
	  UnearthingEmbeddedController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(UnearthingEmbeddedController, _CourseController);
	
	  function UnearthingEmbeddedController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, UnearthingEmbeddedController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (UnearthingEmbeddedController.__proto__ || (0, _getPrototypeOf2.default)(UnearthingEmbeddedController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3a3-';
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  return UnearthingEmbeddedController;
	}(_course2.default);
	
	exports.default = UnearthingEmbeddedController;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(691);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./unearthingEmbeddedArguments.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./unearthingEmbeddedArguments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a3-1 #slots div[id],#diagram3a3-1 .element-list_drop,#diagram3a3-1 .fixed-answer{height:140px!important}#diagram3a3-2 #slots div[id],#diagram3a3-2 .element-list_drop,#diagram3a3-2 .fixed-answer{height:160px!important}#diagram3a3-3 #slots div[id],#diagram3a3-3 .element-list_drop,#diagram3a3-3 .fixed-answer{height:125px!important}#diagram3a3-4 #slots div[id],#diagram3a3-4 .element-list_drop,#diagram3a3-4 .fixed-answer{height:140px!important}#diagram3a3-5 #slots div[id],#diagram3a3-5 .element-list_drop,#diagram3a3-5 .fixed-answer{width:170px!important;height:170px!important}.unit3a-3 .diagram{background-size:2700px;background-position-x:-500px}.unit3a-3 .diagram:nth-child(n+3):nth-child(-n+5){background-position-y:-200px}.unit3a-3 .long-arr .long-arr-part1.long-arr-part1_short{width:205px;transform:rotate(25deg);left:85px}.unit3a-3 .unit-header+.exercise{padding-bottom:150px}.unit3a-3 .intro{padding-bottom:100px;border-bottom:3px solid #a7dec3}.unit3a-3 .intro ol{font-weight:700}.unit3a-3 .exercise-description span{display:inline-block;margin-top:20px;font-size:14px;line-height:18px}.unit3a-3 .unit-wrapper{max-width:1225px;padding:44px 70px 45px}.unit3a-3 .unit-diagram{text-align:left}.unit3a-3 .unit-diagram-descriptionbox{width:320px;display:inline-block;vertical-align:top}.unit3a-3 .unit-diagram-descriptionbox ol{max-height:237px}.unit3a-3 .unit-diagram-descriptionbox .list-element.element-list_drop{width:165px!important;height:84px!important;padding:4px 8px;margin:0 0 0 10px;position:absolute;top:100%;z-index:1;background:#a7dec3;border-radius:13px;border:2px solid #fff;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s;overflow:auto!important;cursor:move;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:16px;text-align:left}.unit3a-3 .unit-diagram-descriptionbox .ui-draggable-dragging{position:absolute;z-index:5}.unit3a-3 .unit-diagram-box{display:inline-block;text-align:center;width:760px}.unit3a-3 #elements td{padding:10px 15px}.unit3a-3 .submit{float:none;position:static;margin-right:-120px;margin-top:120px}.unit3a-3 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit3a-3 #slots{padding:0}.unit3a-3 .slots td{position:relative;padding:0 14px}.unit3a-3 .slots tr .separator{top:0}.unit3a-3 .separator.separator_2parts{left:-275px}.unit3a-3 .slots-addbox{position:absolute;left:-100px}.unit3a-3 .elements-box{margin-top:120px}.unit3a-3 #slots .hint{border:2px solid #fff;background:#a7dec3;overflow:auto;min-height:84px;position:absolute;top:60px;right:-10px;transition:all .4s;opacity:1;z-index:3}", ""]);
	
	// exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _inductiveReasoning = __webpack_require__(693);
	
	var _inductiveReasoning2 = _interopRequireDefault(_inductiveReasoning);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inductiveReasoningModule = _angular2.default.module('inductiveReasoning', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.inductiveReasoning', {
	    url: '/courses/3/3b1/inductive-reasoning',
	    component: 'inductiveReasoning',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('inductiveReasoning', _inductiveReasoning2.default).name;
	
	exports.default = inductiveReasoningModule;

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inductiveReasoning = __webpack_require__(694);
	
	var _inductiveReasoning2 = _interopRequireDefault(_inductiveReasoning);
	
	var _inductiveReasoning3 = __webpack_require__(695);
	
	var _inductiveReasoning4 = _interopRequireDefault(_inductiveReasoning3);
	
	__webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inductiveReasoningComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _inductiveReasoning2.default,
	  controller: _inductiveReasoning4.default
	};
	
	exports.default = inductiveReasoningComponent;

/***/ }),
/* 694 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3b-1\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>inductiveReasoning.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>inductiveReasoning.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <p translate>inductiveReasoning.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">inductiveReasoning.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">inductiveReasoning.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">inductiveReasoning.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">inductiveReasoning.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">inductiveReasoning.menu-list.exercise-5</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">inductiveReasoning.menu-list.exercise-6</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-7')\">inductiveReasoning.menu-list.exercise-7</a></li>\n        </ol>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-1.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-2.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-3.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-3>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-4.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-5.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-5>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-6\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-6.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-6.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-6 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-6>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-7\">\n      <p class=\"exercise-number\" translate>inductiveReasoning.exercise-7.number</p>\n      <p class=\"exercise-title\" translate>inductiveReasoning.exercise-7.title</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-1-Ex-7 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-1-Ex-7>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper\">\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                   congratulation-message=\"'inductiveReasoning.congratulation-message'\" finish-section=\"'inductiveReasoning.finish-section'\"\n        final-description=\"'inductiveReasoning.final-description'\" next-course-button=\"'inductiveReasoning.next-course-button'\"\n        dashboard-button=\"'inductiveReasoning.dashboard-button'\" next-course=\"'course.identifyingInductivePoints'\"></unit-finish>\n    </div>\n  </section>\n\n<!--  <pyramid-builder section-title=\"{{ 'inductiveReasoning.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InductiveReasoningController = function (_CourseController) {
	  InductiveReasoningController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(InductiveReasoningController, _CourseController);
	
	  function InductiveReasoningController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, InductiveReasoningController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InductiveReasoningController.__proto__ || (0, _getPrototypeOf2.default)(InductiveReasoningController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764363');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3b1-';
	    return _this;
	  }
	
	  return InductiveReasoningController;
	}(_course2.default);
	
	exports.default = InductiveReasoningController;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(697);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./inductiveReasoning.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./inductiveReasoning.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b1-2 .fixed-answer,#diagram3b1-4 .fixed-answer,#diagram3b1-5 .fixed-answer{height:92px!important}#diagram3b1-6 .fixed-answer,#diagram3b1-7 .fixed-answer{height:110px!important}.unit3b-1 .intro{padding-bottom:50px;border-bottom:3px solid #a7dec3}.unit3b-1 .intro img{margin:20px auto;display:block}.unit3b-1 .intro ol{font-weight:700}.unit3b-1 .intro ul{float:left;list-style:none;margin:20px;font-weight:700}.unit3b-1 .intro p{clear:both}.unit3b-1 .exercise-number_example,.unit3b-1 .exercise-title_example{color:#000}.unit3b-1 .exercise .exercise-wrapper{padding-bottom:0;padding-top:50px}.unit3b-1 .diagram{margin-bottom:15px}.unit3b-1 .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61;position:relative}.unit3b-1 .diagram-task{float:left;width:100%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:130px;padding-left:5px}.unit3b-1 .checkboxes-task{position:absolute;padding:0;left:0}.unit3b-1 .checkboxes-task .question-title{font-size:36px;line-height:68px;color:#050e61;display:block}.unit3b-1 .checkboxes-task .checkbox-description{cursor:pointer;display:block;margin-left:40px;text-align:left;color:#050e61;font-size:1.2rem}.unit3b-1 .checkboxes-task .checkbox{position:relative;height:5px}.unit3b-1 .checkboxes-task .checkbox input+label{position:absolute;top:4px;display:block;height:22px;width:22px;border:3px solid #fff;border-radius:9px;box-shadow:0 0 3px rgba(0,0,0,.5);z-index:2;cursor:pointer}.unit3b-1 .checkboxes-task .checkbox input+label:after{content:\"\";position:absolute;display:block;top:0;left:0;box-shadow:inset 0 0 3px 0 #000;height:16px;width:16px;border:none;border-radius:9px;background:#fff;z-index:1;opacity:0;transition:opacity .2s}.unit3b-1 .checkboxes-task .checkbox input:disabled+label{cursor:default}.unit3b-1 .checkboxes-task input[type=checkbox]{opacity:0}.unit3b-1 .checkboxes-task input[type=checkbox]:checked+label:after{opacity:1}.unit3b-1 .checkboxes-task input[type=radio]{opacity:0}.unit3b-1 .checkboxes-task input[type=radio]:checked+label:after,.unit3b-1 .checkboxes-task input[type=radio]:hover+label:after{opacity:1}.unit3b-1 .checkboxes-task-item{display:inline-block;margin-right:75px}.unit3b-1 .slots{margin:0 auto}.unit3b-1 #slots{width:auto;height:auto;padding:74px 20px 65px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit3b-1 #slots td{font-size:0}.unit3b-1 .separator{position:relative;height:88px}.unit3b-1 .separator svg{position:absolute;top:-2px;left:0;z-index:2}.unit3b-1 #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit3b-1 #elements td{padding:10px}.unit3b-1 .slots td{padding:0 11px;font-size:0}.unit3b-1 #slots div{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #a7dec3;border-radius:15px;margin:0 0 0 10px;background:#a7dec3;transition:all .2s ease;overflow:auto}.unit3b-1 #elements div:first-child,.unit3b-1 #slots div:first-child{margin-left:0}.unit3b-1 #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit3b-1 .element{display:inline-block;width:167px;height:86px;padding:4px 8px;border-radius:13px;border:2px solid #a7dec3;margin:0 0 0 10px;background:#a7dec3;font-size:14px;line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s}.unit3b-1 .element[data-answer]{transform:scale(1) translate(-8px,-4px)}.unit3b-1 .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}.unit3b-1 .wrong{box-shadow:0 0 5px 2px red}.unit3b-1 .correct{border:2px solid #fff}.unit3b-1 .submit button{display:inline-block;margin:35px 10px 0;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:6px 10px 2px;color:#fff;cursor:pointer;outline:none;text-decoration:none}", ""]);
	
	// exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _identifyingInductivePoints = __webpack_require__(699);
	
	var _identifyingInductivePoints2 = _interopRequireDefault(_identifyingInductivePoints);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identifyingInductivePointsModule = _angular2.default.module('identifyingInductivePoints', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.identifyingInductivePoints', {
	    url: '/courses/3/3b2/identifying-inductive-points',
	    component: 'identifyingInductivePoints',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('identifyingInductivePoints', _identifyingInductivePoints2.default).name;
	
	exports.default = identifyingInductivePointsModule;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _identifyingInductivePoints = __webpack_require__(700);
	
	var _identifyingInductivePoints2 = _interopRequireDefault(_identifyingInductivePoints);
	
	var _identifyingInductivePoints3 = __webpack_require__(701);
	
	var _identifyingInductivePoints4 = _interopRequireDefault(_identifyingInductivePoints3);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identifyingInductivePointsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _identifyingInductivePoints2.default,
	  controller: _identifyingInductivePoints4.default
	};
	
	exports.default = identifyingInductivePointsComponent;

/***/ }),
/* 700 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3b-2\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>identifyingInductivePoints.course-name</h1>\n  </course-header>\n\n  <section class=\"exercise\"></section>\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>identifyingInductivePoints.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <p class=\"intro\" translate>identifyingInductivePoints.exercise-intro</p>\n      <ol class=\"anchors-menu\">\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">identifyingInductivePoints.menu-list.exercise-1</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">identifyingInductivePoints.menu-list.exercise-2</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">identifyingInductivePoints.menu-list.exercise-3</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">identifyingInductivePoints.menu-list.exercise-4</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">identifyingInductivePoints.menu-list.exercise-5</a></li>\n      </ol>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>identifyingInductivePoints.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>identifyingInductivePoints.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>identifyingInductivePoints.exercise-1.description</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper exercise-1\">\n        <modiagram-3-3-B-2-Ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-2-Ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>identifyingInductivePoints.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>identifyingInductivePoints.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>identifyingInductivePoints.exercise-2.description</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper exercise-2\">\n        <modiagram-3-3-B-2-Ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-2-Ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>identifyingInductivePoints.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>identifyingInductivePoints.exercise-3.title</p>\n      <p class=\"exercise-description double-column\" translate>identifyingInductivePoints.exercise-3.description</p>\n      <p class=\"exercise-reference\" translate>identifyingInductivePoints.exercise-3.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper exercise-3\">\n        <modiagram-3-3-B-2-Ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-2-Ex-3>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>identifyingInductivePoints.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>identifyingInductivePoints.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>identifyingInductivePoints.exercise-4.description</p>\n      <p class=\"exercise-reference\" translate>identifyingInductivePoints.exercise-4.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper exercise-4\">\n        <modiagram-3-3-B-2-Ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-2-Ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>identifyingInductivePoints.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>identifyingInductivePoints.exercise-5.title</p>\n      <p class=\"exercise-description\" translate>identifyingInductivePoints.exercise-5.description</p>\n      <p class=\"exercise-reference\" translate>identifyingInductivePoints.exercise-5.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper exercise-5\">\n        <modiagram-3-3-B-2-Ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-2-Ex-5>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper\">\n      <p class=\"intro\" translate>identifyingInductivePoints.exercise-intro-2</p>\n    </div>\n    <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'identifyingInductivePoints.congratulation-message'\" finish-section=\"'identifyingInductivePoints.finish-section'\"\n      final-description=\"'identifyingInductivePoints.final-description'\" next-course-button=\"'identifyingInductivePoints.next-course-button'\"\n      dashboard-button=\"'identifyingInductivePoints.dashboard-button'\" next-course=\"'course.inductionFromDeduction'\"></unit-finish>\n  </section>\n\n\n<!--  <pyramid-builder section-title=\"{{ 'identifyingInductivePoints.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IdentifyingInductivePointsController = function (_CourseController) {
	  IdentifyingInductivePointsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(IdentifyingInductivePointsController, _CourseController);
	
	  function IdentifyingInductivePointsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, IdentifyingInductivePointsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (IdentifyingInductivePointsController.__proto__ || (0, _getPrototypeOf2.default)(IdentifyingInductivePointsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3b2-';
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  return IdentifyingInductivePointsController;
	}(_course2.default);
	
	exports.default = IdentifyingInductivePointsController;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(703);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./identifyingInductivePoints.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./identifyingInductivePoints.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b2-1 .fixed-answer,#diagram3b2-5 .fixed-answer{height:92px!important}.unit-wrapper.exercise-1,.unit-wrapper.exercise-2,.unit-wrapper.exercise-3,.unit-wrapper.exercise-4,.unit-wrapper.exercise-5{display:flex;justify-content:center;max-width:none}.unit-wrapper .slots td.exercise-1,.unit-wrapper .slots td.exercise-2,.unit-wrapper .slots td.exercise-4,.unit-wrapper .slots td.exercise-5{position:relative;padding:0 14px}.unit-wrapper .diagram3b2-1,.unit-wrapper .diagram3b2-2,.unit-wrapper .diagram3b2-4,.unit-wrapper .diagram3b2-5{display:flex}.unit-wrapper .diagram3b2-1__description-box,.unit-wrapper .diagram3b2-2__description-box,.unit-wrapper .diagram3b2-4__description-box,.unit-wrapper .diagram3b2-5__description-box{margin-right:90px;min-height:351px;min-width:320px}.unit-wrapper .diagram3b2-1__separator,.unit-wrapper .diagram3b2-2__separator,.unit-wrapper .diagram3b2-4__separator,.unit-wrapper .diagram3b2-5__separator{position:absolute;top:106px;left:34px}.unit-wrapper .diagram3b2-1 .long-arr,.unit-wrapper .diagram3b2-2 .long-arr,.unit-wrapper .diagram3b2-4 .long-arr,.unit-wrapper .diagram3b2-5 .long-arr{width:182px;left:-101px;transform:rotate(26deg);top:-92px}.unit-wrapper .diagram3b2-1 .long-arr__long-arr-part1,.unit-wrapper .diagram3b2-2 .long-arr__long-arr-part1,.unit-wrapper .diagram3b2-4 .long-arr__long-arr-part1,.unit-wrapper .diagram3b2-5 .long-arr__long-arr-part1{transform:none;width:195px}.unit-wrapper .diagram3b2-1 .long-arr__long-arr-part2,.unit-wrapper .diagram3b2-2 .long-arr__long-arr-part2,.unit-wrapper .diagram3b2-4 .long-arr__long-arr-part2,.unit-wrapper .diagram3b2-5 .long-arr__long-arr-part2{transform:none;top:39px}.unit3b-2 .unit-header+.exercise{padding-bottom:150px}.unit3b-2 .intro{padding-bottom:30px}.unit3b-2 .submit{margin-top:60px}.unit3b-2 .boxes .box{border:3px solid #878787;float:left;width:32%;margin-left:1.3%;margin-bottom:15px;height:165px;padding:5px 10px;line-height:22px}.unit3b-2 .boxes .box:first-child,.unit3b-2 .boxes .box:nth-child(4){margin-left:0}.unit3b-2 .boxes .box strong{margin-bottom:10px;display:block}.unit3b-2 .boxes .box span{display:block}.unit3b-2 .unit-wrapper:last-child .intro{border-bottom:none}.unit3b-2 .unit-wrapper:last-child .intro p:first-child{font-family:Nexa-Bold,sans pro,\"serif\";font-size:26px;color:#050e61}.unit3b-2 .diagram-wrapper{display:flex}.unit3b-2 .diagram-wrapper__description-box{margin-right:90px;min-height:351px;min-width:320px}.unit3b-2 .diagram-hint.diagram-hint_diagramm3b2,.unit3b-2 .diagram-task.diagram-task_diagramm3b2{float:none;position:absolute;top:50px;left:125px;width:auto;padding:0;text-align:center;text-shadow:none;font-weight:700}.unit3b-2 .diagram-hint.diagram-hint_diagramm3b2{top:255px;left:100px;text-align:left}.unit3b-2 .diagram-hint.diagram-hint_diagramm3b2.exercise-4{left:-30px}.unit3b-2 .diagram-task.diagram-task_diagramm3b2.diagram-task_diagramm3b2_3{top:70px;left:225px}.unit3b-2 .diagram-hint.diagram-hint_diagramm3b2.diagram-hint_diagramm3b2_3{top:260px;left:-50px}.unit3b-2 .diagram-task.diagram-task_diagramm3b2.diagram-task_diagramm3b2_4{top:70px;left:220px}.unit3b-2 .diagram-task.diagram-task_diagramm3b2.diagram-task_diagramm3b2_4.exercise-4{left:100px}.unit3b-2 .diagram-task.diagram-task_diagramm3b2.diagram-task_diagramm3b2_5{top:70px;left:280px}.unit3b-2 .slots td.exercise-3,.unit3b-2 .slots td.exercise-4{position:relative;padding:0 14px}", ""]);
	
	// exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _inductionFromDeduction = __webpack_require__(705);
	
	var _inductionFromDeduction2 = _interopRequireDefault(_inductionFromDeduction);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inductionFromDeductionModule = _angular2.default.module('inductionFromDeduction', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.inductionFromDeduction', {
	    url: '/courses/3/3b3/induction-from-deduction',
	    component: 'inductionFromDeduction',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('inductionFromDeduction', _inductionFromDeduction2.default).name;
	
	exports.default = inductionFromDeductionModule;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inductionFromDeduction = __webpack_require__(706);
	
	var _inductionFromDeduction2 = _interopRequireDefault(_inductionFromDeduction);
	
	var _inductionFromDeduction3 = __webpack_require__(707);
	
	var _inductionFromDeduction4 = _interopRequireDefault(_inductionFromDeduction3);
	
	__webpack_require__(708);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var inductionFromDeductionComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _inductionFromDeduction2.default,
	  controller: _inductionFromDeduction4.default
	};
	
	exports.default = inductionFromDeductionComponent;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"unit3b-3\" class=\"unit unit-3 unit3b-3\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>inductionFromDeduction.course-name</h1>\n  </course-header>\n\n  <section class=\"exercise\"></section>\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>inductionFromDeduction.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <p translate>inductionFromDeduction.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">inductionFromDeduction.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">inductionFromDeduction.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">inductionFromDeduction.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">inductionFromDeduction.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">inductionFromDeduction.menu-list.exercise-5</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">inductionFromDeduction.menu-list.exercise-6</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-7')\">inductionFromDeduction.menu-list.exercise-7</a></li>\n        </ol>\n      </div>\n    </div>\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number exercise-number_first\" translate>inductionFromDeduction.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-1.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-1.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-2.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-2.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-3.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-3.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-3.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-3>\n      </div>\n    </div>\n\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-4.description</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-5.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-5.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-5.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-5>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-6\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-6.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-6.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-6.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-6.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-6 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-6>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-7\">\n      <p class=\"exercise-number\" translate>inductionFromDeduction.exercise-7.number</p>\n      <p class=\"exercise-title\" translate>inductionFromDeduction.exercise-7.title</p>\n      <p class=\"exercise-description\" translate>inductionFromDeduction.exercise-7.description</p>\n      <p class=\"exercise-reference\" translate>inductionFromDeduction.exercise-7.reference</p>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <modiagram-3-3-B-3-Ex-7 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-3-3-B-3-Ex-7>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper\">\n      <p class=\"intro\" translate>inductionFromDeduction.exercise-intro-2</p>\n    </div>\n    <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'inductionFromDeduction.congratulation-message'\" finish-section=\"'inductionFromDeduction.finish-section'\"\n      final-description=\"'inductionFromDeduction.final-description'\" next-course-button=\"'inductionFromDeduction.next-course-button'\"\n      dashboard-button=\"'inductionFromDeduction.dashboard-button'\" next-course=\"'course.deductionToInduction'\"></unit-finish>\n  </section>\n\n\n<!--    <pyramid-builder section-title=\"{{ 'inductionFromDeduction.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var InductionFromDeductionPointsController = function (_CourseController) {
	  InductionFromDeductionPointsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(InductionFromDeductionPointsController, _CourseController);
	
	  function InductionFromDeductionPointsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, InductionFromDeductionPointsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (InductionFromDeductionPointsController.__proto__ || (0, _getPrototypeOf2.default)(InductionFromDeductionPointsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3b3-';
	    return _this;
	  }
	
	  return InductionFromDeductionPointsController;
	}(_course2.default);
	
	exports.default = InductionFromDeductionPointsController;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(709);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./inductionFromDeduction.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./inductionFromDeduction.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#unit3b-3 .correct{border:none!important}#diagram3b3-1 .slots td #slot_1_1,#diagram3b3-2 .slots td #slot_1_1,#diagram3b3-3 .slots td #slot_1_1,#diagram3b3-6 .slots td #slot_1_1,#diagram3b3-7 .slots td #slot_1_1{margin-bottom:0}#diagram3b3-1 #slot_1_2,#diagram3b3-1 #slot_2_2,#diagram3b3-1 #slot_3_2,#diagram3b3-1 #slot_6_3,#diagram3b3-1 #slot_7_2,#diagram3b3-2 #slot_1_2,#diagram3b3-2 #slot_2_2,#diagram3b3-2 #slot_3_2,#diagram3b3-2 #slot_6_3,#diagram3b3-2 #slot_7_2,#diagram3b3-3 #slot_1_2,#diagram3b3-3 #slot_2_2,#diagram3b3-3 #slot_3_2,#diagram3b3-3 #slot_6_3,#diagram3b3-3 #slot_7_2,#diagram3b3-6 #slot_1_2,#diagram3b3-6 #slot_2_2,#diagram3b3-6 #slot_3_2,#diagram3b3-6 #slot_6_3,#diagram3b3-6 #slot_7_2,#diagram3b3-7 #slot_1_2,#diagram3b3-7 #slot_2_2,#diagram3b3-7 #slot_3_2,#diagram3b3-7 #slot_6_3,#diagram3b3-7 #slot_7_2{margin-bottom:87px}#diagram3b3-1 .section3b3-form,#diagram3b3-2 .section3b3-form,#diagram3b3-3 .section3b3-form,#diagram3b3-6 .section3b3-form,#diagram3b3-7 .section3b3-form{margin-top:70px}#diagram3b3-1 .element,#diagram3b3-2 .element,#diagram3b3-3 .element,#diagram3b3-6 .element,#diagram3b3-7 .element{z-index:2}.unit3b-3#unit3b-3 .unit-header+.exercise{padding-bottom:150px}.unit3b-3#unit3b-3 .unit-wrapper:first-child .intro{padding-bottom:30px;border-bottom:3px solid #a7dec3}.unit3b-3#unit3b-3 #slots .answer-field,.unit3b-3#unit3b-3 #slots div[id]{background:#a7dec3;overflow:auto}.unit3b-3#unit3b-3 #slots #element_1_1{margin-bottom:87px}.unit3b-3#unit3b-3 .fixed-answer{border:none;padding:4px 8px;z-index:1;overflow:hidden!important}.unit3b-3#unit3b-3 .hide-answer{color:#050e6100;background-color:rgba(167,222,195,0)!important;box-shadow:none;z-index:1;border:3px solid #fff}.unit3b-3#unit3b-3 .hide-answer:hover{cursor:default;transform:none;box-shadow:none!important}.unit3b-3#unit3b-3 .element:not(.drag-element){transition-duration:1s}.unit3b-3#unit3b-3 #elements td{min-width:185px;min-height:84px}.unit3b-3#unit3b-3 #elements td div{z-index:3}.unit3b-3#unit3b-3 .slot{z-index:1}", ""]);
	
	// exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _deductionToInduction = __webpack_require__(711);
	
	var _deductionToInduction2 = _interopRequireDefault(_deductionToInduction);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deductionToInductionModule = _angular2.default.module('deductionToInduction', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.deductionToInduction', {
	    url: '/courses/3/3b4/deduction-to-induction',
	    component: 'deductionToInduction',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('deductionToInduction', _deductionToInduction2.default).name;
	
	exports.default = deductionToInductionModule;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _deductionToInduction = __webpack_require__(712);
	
	var _deductionToInduction2 = _interopRequireDefault(_deductionToInduction);
	
	var _deductionToInduction3 = __webpack_require__(713);
	
	var _deductionToInduction4 = _interopRequireDefault(_deductionToInduction3);
	
	__webpack_require__(714);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var deductionToInductionComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _deductionToInduction2.default,
	  controller: _deductionToInduction4.default
	};
	
	exports.default = deductionToInductionComponent;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3b-4\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>deductionToInduction.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>deductionToInduction.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <p>Most of your original reasoning will be worked out deductively, so that the temptation to write it that way will be very great, as in this example on changing a company’s structure.  </p>\n        <br/>\n        <magnifier-component\n          un-show-percent=\"0.80\"\n          image-source=\"'/assets/images/structure-3b4-1.png'\"\n          result-magnifier-styles=\"{top: '-30px', right: '-175px'}\">\n        </magnifier-component>\n        <p translate>deductionToInduction.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">deductionToInduction.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">deductionToInduction.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">deductionToInduction.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">deductionToInduction.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">deductionToInduction.menu-list.exercise-5</a></li>\n        </ol>\n        <p translate>deductionToInduction.exercise-bottom</p>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>deductionToInduction.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>deductionToInduction.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>deductionToInduction.exercise-1.description</p>\n      <p class=\"exercise-reference\" translate>deductionToInduction.exercise-1.reference</p>\n      <p class=\"deductive-form\" translate>deductionToInduction.deductive-form</p>\n      <div class=\"structure\">\n        <img class=\"img1\" src=\"/assets/images/structure-3b4-ex1.png\" alt=\"Original structure\" />\n      </div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper unit-wrapper_wide-diagramm\">\n        <modiagram-3-3-B-4-Ex-1 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-4-Ex-1>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>deductionToInduction.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>deductionToInduction.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>deductionToInduction.exercise-2.description</p>\n      <p class=\"exercise-reference\" translate>deductionToInduction.exercise-2.reference</p>\n      <p class=\"deductive-form\" translate>deductionToInduction.deductive-form</p>\n<!--      <div class=\"structure\">-->\n<!--        <img class=\"img2\" src=\"/assets/images/structure-3b4-ex2.png\" alt=\"Original structure\" />-->\n<!--      </div>-->\n      <div class=\"exercise-diagram show-diagram\" translate>deductionToInduction.exercise-2.diagram</div>\n\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper unit-wrapper_wide-diagramm\">\n        <modiagram-3-3-B-4-Ex-2 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-4-Ex-2>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>deductionToInduction.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>deductionToInduction.exercise-3.title</p>\n      <p class=\"exercise-description\" translate>deductionToInduction.exercise-3.description</p>\n      <p class=\"exercise-reference\" translate>deductionToInduction.exercise-3.reference</p>\n      <p class=\"deductive-form\" translate>deductionToInduction.deductive-form</p>\n<!--      <div class=\"structure\">-->\n<!--        <img class=\"img3\" src=\"/assets/images/structure-3b4-ex3.png\" alt=\"Original structure\" />-->\n<!--      </div>-->\n      <div class=\"exercise-diagram show-diagram\" translate>deductionToInduction.exercise-3.diagram</div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper unit-wrapper_wide-diagramm\">\n        <modiagram-3-3-B-4-Ex-3 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-4-Ex-3>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>deductionToInduction.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>deductionToInduction.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>deductionToInduction.exercise-4.description</p>\n      <p class=\"exercise-reference\" translate>deductionToInduction.exercise-4.reference</p>\n      <div class=\"boxed-note\">\n        <p class=\"exercise-note\" translate>deductionToInduction.exercise-4.note</p>\n      </div>\n      <p class=\"deductive-form\" translate>deductionToInduction.deductive-form</p>\n<!--      <div class=\"structure\">-->\n<!--        <img class=\"img4\" src=\"/assets/images/structure-3b4-ex4.png\" alt=\"Original structure\" />-->\n<!--      </div>-->\n      <div class=\"exercise-diagram show-diagram\" translate>deductionToInduction.exercise-4.diagram</div>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper unit-wrapper_wide-diagramm\">\n        <modiagram-3-3-B-4-Ex-4 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-4-Ex-4>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>deductionToInduction.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>deductionToInduction.exercise-5.title</p>\n      <p class=\"exercise-description\" translate>deductionToInduction.exercise-5.description</p>\n      <p class=\"exercise-reference\" translate>deductionToInduction.exercise-5.reference</p>\n      <p class=\"exercise-note\" translate>deductionToInduction.exercise-5.note</p>\n      <p class=\"deductive-form\" translate>deductionToInduction.deductive-form</p>\n      <div class=\"exercise-diagram show-diagram\" translate>deductionToInduction.exercise-5.diagram</div>\n    </div>\n<!--    <div class=\"unit-wrapper\">-->\n<!--      <magnifier-component-->\n<!--        un-show-percent=\"0\"-->\n<!--        image-source=\"'/assets/images/structure-3b4-ex5.png'\"-->\n<!--        result-magnifier-styles=\"{top: '-30px', right: '-175px'}\">-->\n<!--      </magnifier-component>-->\n<!--    </div>-->\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper unit-wrapper_wide-diagramm\">\n        <modiagram-3-3-B-4-Ex-5 on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></modiagram-3-3-B-4-Ex-5>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                   congratulation-message=\"'deductionToInduction.congratulation-message'\" finish-section=\"'deductionToInduction.finish-section'\"\n        final-description=\"'deductionToInduction.final-description'\" next-course-button=\"'deductionToInduction.next-course-button'\"\n        dashboard-button=\"'deductionToInduction.dashboard-button'\" next-course=\"'course.avoidingDeductiveArguments'\"></unit-finish>\n    </div>\n  </section>\n\n\n<!--  <pyramid-builder section-title=\"{{ 'deductionToInduction.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeductionToInductionPointsController = function (_CourseController) {
	  DeductionToInductionPointsController.$inject = ["courseService", "helperService", "$sce", "$window", "$scope", "$compile"];
	  (0, _inherits3.default)(DeductionToInductionPointsController, _CourseController);
	
	  function DeductionToInductionPointsController(courseService, helperService, $sce, $window, $scope, $compile) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DeductionToInductionPointsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DeductionToInductionPointsController.__proto__ || (0, _getPrototypeOf2.default)(DeductionToInductionPointsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce, $window: $window, $scope: $scope, $compile: $compile });
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3b4-';
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764369');
	    _this.exerciseUserAnswers = {};
	    // this.helperService.initIntercom();
	
	    _this.highlightWords = {
	      ex1: false,
	      ex2: false,
	      ex3: false,
	      ex4: false,
	      ex5: false
	    };
	
	    setTimeout(function () {
	      var offsetFromTop = {
	        ex1: _this.getOffsetFromTop('js-ex1'),
	        ex2: _this.getOffsetFromTop('js-ex2'),
	        ex3: _this.getOffsetFromTop('js-ex3'),
	        ex4: _this.getOffsetFromTop('js-ex4'),
	        ex5: _this.getOffsetFromTop('js-ex5')
	      };
	
	      for (var key in offsetFromTop) {
	        var exerciseDescription = angular.element('.js-' + key);
	
	        _this.$compile(exerciseDescription)(_this.$scope);
	      }
	
	      var halfOfUserWindowHeight = _this.$window.innerHeight / 2;
	
	      _this.$window.onscroll = function () {
	        var pagePosition = _this.$window.scrollY + halfOfUserWindowHeight;
	
	        for (var _key in offsetFromTop) {
	          if (!_this.highlightWords[_key] && pagePosition >= offsetFromTop[_key]) {
	            _this.highlightWords[_key] = true;
	          }
	        }
	
	        _this.$scope.$apply();
	      };
	    }, 300);
	    return _this;
	  }
	
	  (0, _createClass3.default)(DeductionToInductionPointsController, [{
	    key: 'getOffsetFromTop',
	    value: function getOffsetFromTop(elementClass) {
	      var element = document.querySelector('.' + elementClass);
	
	      return $(element).offset().top;
	    }
	  }]);
	  return DeductionToInductionPointsController;
	}(_course2.default);
	
	exports.default = DeductionToInductionPointsController;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(715);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./deductionToInduction.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./deductionToInduction.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-4 #slots div[id],#diagram3b4-4 .element-list_drop,#diagram3b4-4 .fixed-answer,#diagram3b4-5 #slots div[id],#diagram3b4-5 .element-list_drop,#diagram3b4-5 .fixed-answer{height:110px!important}.unit3b-4 .diagram{background-size:100% 170%}.unit3b-4 .intro-img2,.unit3b-4 .structure img{margin:10px auto;display:block}.unit3b-4 .unit-header+.exercise{padding-bottom:150px}.unit3b-4 .intro{padding-bottom:100px;border-bottom:3px solid #a7dec3}.unit3b-4 .intro ol{font-weight:700}.unit3b-4 .exercise-description span{margin-top:20px;font-size:14px;line-height:18px}.unit3b-4 .exercise-description span:not(.highlight-word){display:inline-block}.unit3b-4 .highlight-word,.unit3b-4 .js-ex1,.unit3b-4 .js-ex2,.unit3b-4 .js-ex3,.unit3b-4 .js-ex4,.unit3b-4 .js-ex5{margin-top:0!important;line-height:28px!important;font-size:18px!important}.unit3b-4 .show-diagram .diagram-box{margin:0}.unit3b-4 .show-diagram .connector{height:114px;margin-left:355px;margin-top:-3px}.unit3b-4 .show-diagram .connector__line{stroke:#000;stroke-width:3px}.unit3b-4 .show-diagram .svg-deductive-arrow{width:50px;height:50px}.unit3b-4 .show-diagram .svg-deductive-arrow line,.unit3b-4 .show-diagram .svg-deductive-arrow path{stroke-width:3px;stroke:#000;fill:#000}.unit3b-4 .show-diagram .svg-long-deductive-arrow{width:377px;height:117px}.unit3b-4 .show-diagram .svg-long-deductive-arrow line,.unit3b-4 .show-diagram .svg-long-deductive-arrow path{stroke-width:3px;stroke:#000;fill:#000}.unit3b-4 #exercise-5 .svg{height:100px;width:950px}.unit3b-4 #exercise-5 .svg line{stroke:#000;stroke-width:3px}.unit3b-4 #exercise-5 .six-slots .diagram-box{width:150px;height:115px}.unit3b-4 #exercise-5 .svg-deductive-arrow{width:157px}.unit3b-4 .slot-with-arrow{display:flex;align-items:center}.unit3b-4 .slot-with-arrow img{height:fit-content}.unit3b-4 .deductive-form{margin-top:20px}.unit3b-4 .unit-wrapper_wide-diagramm{max-width:1440px;padding:44px 70px 45px}.unit3b-4 .unit-diagram{text-align:center}.unit3b-4 .unit-diagram-descriptionbox{max-width:320px;min-width:320px;position:absolute;right:5%;z-index:3;top:15%}.unit3b-4 .unit-diagram-descriptionbox ol{max-height:237px}.unit3b-4 .unit-diagram-descriptionbox .list-element.element-list_drop{width:165px!important;height:84px!important;width:165px;height:84px;padding:4px 8px;margin:0 0 0 10px;position:absolute;top:100%;z-index:1;background:#a7dec3;border-radius:13px;border:2px solid #fff;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s;overflow:auto!important;cursor:move;font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";line-height:16px}.unit3b-4 .unit-diagram-descriptionbox .ui-draggable-dragging{position:absolute;z-index:5}.unit3b-4 .unit-diagram-box{display:inline-block;text-align:center;margin-left:-70px}.unit3b-4 #elements td{padding:10px 15px}.unit3b-4 .submit{float:none;position:static;margin-right:-30px;margin-top:100px}.unit3b-4 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:6px 10px 2px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit3b-4 #slots{padding:0}.unit3b-4 #slots .hint{border:2px solid #fff;background:#a7dec3;overflow:auto;min-height:84px;position:absolute;top:60px;right:-10px;transition:all .4s;opacity:1;z-index:3}.unit3b-4 .slots td{position:relative;padding:0 15px}.unit3b-4 .slots tr .separator{top:0}.unit3b-4 .slots-addbox{position:absolute;left:-100px}.unit3b-4 .separator.separator_2parts{left:-275px}.unit3b-4 .elements-box{margin-top:120px}", ""]);
	
	// exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _avoidingDeductiveArguments = __webpack_require__(717);
	
	var _avoidingDeductiveArguments2 = _interopRequireDefault(_avoidingDeductiveArguments);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avoidingDeductiveArgumentsModule = _angular2.default.module('avoidingDeductiveArguments', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.avoidingDeductiveArguments', {
	    url: '/courses/3/3c/avoiding-deductive-arguments',
	    component: 'avoidingDeductiveArguments',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('avoidingDeductiveArguments', _avoidingDeductiveArguments2.default).name;
	
	exports.default = avoidingDeductiveArgumentsModule;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _avoidingDeductiveArguments = __webpack_require__(718);
	
	var _avoidingDeductiveArguments2 = _interopRequireDefault(_avoidingDeductiveArguments);
	
	var _avoidingDeductiveArguments3 = __webpack_require__(719);
	
	var _avoidingDeductiveArguments4 = _interopRequireDefault(_avoidingDeductiveArguments3);
	
	__webpack_require__(720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var avoidingDeductiveArgumentsComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _avoidingDeductiveArguments2.default,
	  controller: _avoidingDeductiveArguments4.default
	};
	
	exports.default = avoidingDeductiveArgumentsComponent;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-3 unit3c\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>avoidingDeductiveArguments.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'avoidingDeductiveArguments.congratulation-message'\" finish-section=\"'avoidingDeductiveArguments.finish-section'\"\n    final-description=\"'avoidingDeductiveArguments.final-description'\" next-course-button=\"'avoidingDeductiveArguments.next-course-button'\"\n    dashboard-button=\"'avoidingDeductiveArguments.dashboard-button'\" next-course=\"'course.practiceInSeeing'\"></unit-finish>\n\n<!--    <pyramid-builder section-title=\"{{ 'avoidingDeductiveArguments.course-title' | translate }}\"></pyramid-builder>-->\n</div>\n"

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvoidingDeductiveArgumentsController = function (_CourseController) {
	  AvoidingDeductiveArgumentsController.$inject = ["helperService", "$sce", "courseService", "$scope"];
	  (0, _inherits3.default)(AvoidingDeductiveArgumentsController, _CourseController);
	
	  function AvoidingDeductiveArgumentsController(helperService, $sce, courseService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, AvoidingDeductiveArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (AvoidingDeductiveArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(AvoidingDeductiveArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce, courseService: courseService });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764375');
	    // this.helperService.initIntercom();
	    _this.isUnit = true;
	    _this.introCounted = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(AvoidingDeductiveArgumentsController, [{
	    key: "onSectionFinish",
	    value: function onSectionFinish() {
	      if (this.courseData.is_completed) {
	        return;
	      }
	      var params = {
	        statisticableId: this.courseData.intro_id,
	        statisticableType: 'UnitIntro',
	        seconds_spent: Math.floor((Date.now() - this.unitStart) / 1000),
	        completed: true,
	        attempts: 0,
	        hintsUsed: 0,
	        rightAnswers: 0
	      };
	      this.courseService.sendUserStatistic(params);
	      this.courseData.is_completed = true;
	    }
	  }]);
	  return AvoidingDeductiveArgumentsController;
	}(_course2.default);
	
	exports.default = AvoidingDeductiveArgumentsController;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(721);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./avoidingDeductiveArguments.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./avoidingDeductiveArguments.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _practiceInSeeing = __webpack_require__(723);
	
	var _practiceInSeeing2 = _interopRequireDefault(_practiceInSeeing);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceInSeeingModule = _angular2.default.module('practiceInSeeing', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.practiceInSeeing', {
	    url: '/courses/4/4a/practice-seeing-scq',
	    component: 'practiceInSeeing',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('practiceInSeeing', _practiceInSeeing2.default).name;
	
	exports.default = practiceInSeeingModule;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _practiceInSeeing = __webpack_require__(724);
	
	var _practiceInSeeing2 = _interopRequireDefault(_practiceInSeeing);
	
	var _practiceInSeeing3 = __webpack_require__(725);
	
	var _practiceInSeeing4 = _interopRequireDefault(_practiceInSeeing3);
	
	__webpack_require__(731);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceInSeeingComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _practiceInSeeing2.default,
	  controller: _practiceInSeeing4.default
	};
	
	exports.default = practiceInSeeingComponent;

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-4 unit4a-1\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>practice-in-seeing.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>practice-in-seeing.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <p translate>practice-in-seeing.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">practice-in-seeing.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">practice-in-seeing.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">practice-in-seeing.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">practice-in-seeing.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">practice-in-seeing.menu-list.exercise-5</a></li>\n        </ol>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>practice-in-seeing.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing.exercise-1.description</p>\n      <p class=\"exercise-reference\" translate>practice-in-seeing.exercise-1.reference</p>\n    </div>\n\n    <div class=\"diagram simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise1\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>practice-in-seeing.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing.exercise-2.description</p>\n      <p class=\"exercise-reference\" translate>practice-in-seeing.exercise-2.reference</p>\n    </div>\n\n    <div class=\"diagram simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise2\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>practice-in-seeing.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing.exercise-3.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing.exercise-3.description</p>\n    </div>\n\n    <div class=\"diagram simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise3\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>practice-in-seeing.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing.exercise-4.description</p>\n    </div>\n\n    <div class=\"diagram simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise4\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>practice-in-seeing.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing.exercise-5.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing.exercise-5.description</p>\n    </div>\n\n    <div class=\"diagram simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise5\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n    <div class=\"unit-wrapper\">\n      <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                   congratulation-message=\"'practice-in-seeing.congratulation-message'\"\n        finish-section=\"'practice-in-seeing.finish-section'\"\n        final-description=\"'practice-in-seeing.final-description'\" next-course-button=\"'practice-in-seeing.next-course-button'\"\n        dashboard-button=\"'practice-in-seeing.dashboard-button'\" next-course=\"'course.findingReadersQuestion'\"></unit-finish>\n    </div>\n  </section>\n\n    <pyramid-builder section-title=\"{{ 'practice-in-seeing.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(726);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(727);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(728);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(729);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(730);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PracticeInSeeingArgumentsController = function (_CourseController) {
	  PracticeInSeeingArgumentsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(PracticeInSeeingArgumentsController, _CourseController);
	
	  function PracticeInSeeingArgumentsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PracticeInSeeingArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PracticeInSeeingArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(PracticeInSeeingArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/325082496');
	    // this.helperService.initIntercom();
	    _this.videoId = '05447a99fa0643508fae2ad9010add4d';
	
	    _this.exercise1 = _exercise2.default['en'];
	    _this.exercise2 = _exercise4.default['en'];
	    _this.exercise3 = _exercise6.default['en'];
	    _this.exercise4 = _exercise8.default['en'];
	    _this.exercise5 = _exercise10.default['en'];
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram3b4-';
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  return PracticeInSeeingArgumentsController;
	}(_course2.default);
	
	exports.default = PracticeInSeeingArgumentsController;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram3b4-1',
	        blocks: [{
	            task: 'S = When the sun fails, humans will turn to the energy of the visible universe.',
	            answer: 'If X happens, will do Y',
	            title: "S = ",
	            modelName: 's'
	        }, {
	            task: 'C = When they exhaust that, the only remaining store of energy will be in black holes',
	            answer: 'After Y, only Z left',
	            title: "C = ",
	            modelName: 'c'
	        }, {
	            task: 'Q = Might they be able to harvest this energy and save civilization?',
	            answer: 'Will Z work?',
	            title: "Q = ",
	            modelName: 'q'
	        }, {
	            task: 'A = Yes, if they had a space elevator, but that defies the laws of physics',
	            answer: 'Yes, if…',
	            title: "A = ",
	            modelName: 'a'
	        }],
	        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
	        correctAnswers: 4
	    }
	};

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram3b4-2',
	        blocks: [{
	            task: 'S = Believe entrepreneurs succeed either because they plan carefully or bet long odds',
	            answer: 'Believe Xs succeed because they do Y or Z',
	            title: "S = ",
	            modelName: 's'
	        }, {
	            task: 'C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
	            answer: 'Actually do neither',
	            title: "C = ",
	            modelName: 'c'
	        }, {
	            task: 'Q = How do they succeed?',
	            answer: 'How succeed?',
	            title: "Q = ",
	            modelName: 'q'
	        }, {
	            task: 'A = They blend two contradictory skills: careful analytical thinking and a willingness to push boundaries.',
	            answer: 'Blend contradictory skills',
	            title: "A = ",
	            modelName: 'a'
	        }],
	        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
	        correctAnswers: 4
	    }
	};

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram3b4-3',
	        blocks: [{
	            task: 'S = Open plan office sought to boost communication and efficiency, deemphasize status',
	            answer: 'Did A to get B and C',
	            title: "S = ",
	            modelName: 's'
	        }, {
	            task: 'C = Study showed that employees disliked it on every aspect measured',
	            answer: 'Caused problems',
	            title: "C = ",
	            modelName: 'c'
	        }, {
	            task: 'Q = (How respond?)',
	            answer: '(How fix?)',
	            title: "Q = ",
	            modelName: 'q'
	        }, {
	            task: 'A = Restored privacy'
	        }],
	        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
	        correctAnswers: 3
	    }
	};

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram3b4-4',
	        blocks: [{
	            task: 'S = Hoped to offset unexpected earnings decline with additional $10b cut in operating costs.',
	            answer: 'Hoped to get X by doing Y',
	            title: "S = ",
	            modelName: 's'
	        }, {
	            task: 'C = But related short-term increases in operating costs also likely, meaning must instead look for savings in fixed costs (difficult to get at)',
	            answer: 'Won’t work, need Z instead',
	            title: "C = ",
	            modelName: 'c'
	        }, {
	            task: 'Q = (Can we realistically expect to cut $10b from our fixed costs?',
	            answer: 'Will it work?',
	            title: "Q = ",
	            modelName: 'q'
	        }, {
	            task: 'A = Yes'
	        }],
	        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
	        correctAnswers: 3
	    }
	};

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram3b4-5',
	        blocks: [{
	            task: 'S = The Board is now free to do planning',
	            answer: 'Free to do X.',
	            title: "S = ",
	            modelName: 's'
	        }, {
	            task: 'C = It is not set up to do planning',
	            answer: 'Not set up to do X',
	            title: "C = ",
	            modelName: 'c'
	        }, {
	            task: 'Q = How do we get set up?',
	            answer: 'How fix?',
	            title: "Q = ",
	            modelName: 'q'
	        }],
	        subtitle: 'Fill in the SCQ boxes substituting Xs and Ys, etc. for specific nouns. Then press "simplest structure" and compare your answers',
	        correctAnswers: 3
	    }
	};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(732);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceInSeeing.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceInSeeing.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit4a-1 .intro ul{margin:-2px 0}.unit4a-1 .intro ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4a-1 .simplest__structure-block{color:#050e61}.unit4a-1 .simplest__structure-box textarea{border-color:#050e61}.unit4a-1 .submit{position:static}.unit4a-1 .desc-table{display:flex;flex-direction:row;justify-content:space-between}.unit4a-1 .desc-table__title{margin-bottom:24px!important;font-size:24px;font-weight:700}.unit4a-1 .desc-table .double-title{margin-bottom:25px!important}.unit4a-1 .desc-table p{margin-bottom:13px}", ""]);
	
	// exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _findingReadersQuestion = __webpack_require__(734);
	
	var _findingReadersQuestion2 = _interopRequireDefault(_findingReadersQuestion);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findingReadersQuestionModule = _angular2.default.module('findingReadersQuestion', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.findingReadersQuestion', {
	    url: '/courses/4/4b1/finding-readers-question',
	    component: 'findingReadersQuestion',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('findingReadersQuestion', _findingReadersQuestion2.default).name;
	
	exports.default = findingReadersQuestionModule;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _findingReadersQuestion = __webpack_require__(735);
	
	var _findingReadersQuestion2 = _interopRequireDefault(_findingReadersQuestion);
	
	var _findingReadersQuestion3 = __webpack_require__(736);
	
	var _findingReadersQuestion4 = _interopRequireDefault(_findingReadersQuestion3);
	
	__webpack_require__(740);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var findingReadersQuestionComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _findingReadersQuestion2.default,
	  controller: _findingReadersQuestion4.default
	};
	
	exports.default = findingReadersQuestionComponent;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-4 unit4b\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>finding-readers-question.course-name</h1>\n  </course-header>\n\n  <!-- <course-video lecture-title=\" 'finding-readers-question.course-video.lecture-title' \" video-id=\"vm.videoId\" video-title=\" 'finding-readers-question.course-video.title' \"></course-video> -->\n  <course-video lecture-title=\" 'finding-readers-question.course-video.lecture-title' \" />\n\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>finding-readers-question.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <p class=\"intro intro-1\" translate>finding-readers-question.exercise-intro-1</p>\n      <ol class=\"anchors-menu\">\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">finding-readers-question.menu-list.exercise-1</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">finding-readers-question.menu-list.exercise-2</a></li>\n        <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">finding-readers-question.menu-list.exercise-3</a></li>\n      </ol>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>finding-readers-question.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>finding-readers-question.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>finding-readers-question.exercise-1.description</p>\n      <p class=\"exercise-reference\" translate>finding-readers-question.exercise-1.reference</p>\n      <!-- <div class=\"structure\">\n        <img src=\"/assets/images/structure-4b1-1.png\" alt=\"Original structure\">\n      </div> -->\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <step-diagram data=\"vm.payoffFromProductManagement\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></step-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\">\n      <div class=\"divider\"></div>\n      <p class=\"exercise-description margin-60\" translate>finding-readers-question.exercise-1.afterword</p>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-title\" translate>finding-readers-question.exercise-2.title</p>\n      <p class=\"exercise-description margin-60\" translate>finding-readers-question.exercise-2.description</p>\n<!--      <div class=\"structure\">-->\n<!--        <img src=\"/assets/images/structure-4b1-1-2.png\" alt=\"Original structure\">-->\n<!--      </div>-->\n      <!-- <div class=\"structure\">\n        <img src=\"/assets/images/structure-4b1-2.png\" alt=\"Original structure\">\n      </div> -->\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <step-diagram data=\"vm.theRationalizationProgram\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></step-diagram>\n      </div>\n    </div>\n\n    <div style=\"margin-top: 50px;\" class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-title\" translate>finding-readers-question.exercise-3.title</p>\n      <p class=\"exercise-description margin-60\" translate>finding-readers-question.exercise-3.description</p>\n<!--      <div class=\"structure\">-->\n<!--        <img src=\"/assets/images/structure-4b1-2-1.png\" alt=\"Original structure\">-->\n<!--      </div>-->\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <step-diagram data=\"vm.drillingForMethane\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></step-diagram>\n      </div>\n    </div>\n\n  </section>\n\n  <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'finding-readers-question.congratulation-message'\" finish-section=\"'finding-readers-question.finish-section'\"\n    final-description=\"'finding-readers-question.final-description'\" next-course-button=\"'finding-readers-question.next-course-button'\"\n    dashboard-button=\"'finding-readers-question.dashboard-button'\" next-course=\"'course.spottingSCQ'\"></unit-finish>\n    <pyramid-builder section-title=\"{{ 'finding-readers-question.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	var _drillingForMethane = __webpack_require__(737);
	
	var _drillingForMethane2 = _interopRequireDefault(_drillingForMethane);
	
	var _payoffFromProductManagement = __webpack_require__(738);
	
	var _payoffFromProductManagement2 = _interopRequireDefault(_payoffFromProductManagement);
	
	var _theRationalizationProgram = __webpack_require__(739);
	
	var _theRationalizationProgram2 = _interopRequireDefault(_theRationalizationProgram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FindingReadersQuestionArgumentsController = function (_CourseController) {
	  FindingReadersQuestionArgumentsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(FindingReadersQuestionArgumentsController, _CourseController);
	
	  function FindingReadersQuestionArgumentsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, FindingReadersQuestionArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FindingReadersQuestionArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(FindingReadersQuestionArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764692');
	
	    _this.videoId = '6645b442908c40ff9bfb451764117f08';
	
	    _this.lang = 'en';
	
	    _this.payoffFromProductManagement = _payoffFromProductManagement2.default[_this.lang];
	    _this.theRationalizationProgram = _theRationalizationProgram2.default[_this.lang];
	    _this.drillingForMethane = _drillingForMethane2.default[_this.lang];
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'exercise';
	    _this.exerciseUserAnswers = {};
	
	    return _this;
	  }
	
	  return FindingReadersQuestionArgumentsController;
	}(_course2.default);
	
	exports.default = FindingReadersQuestionArgumentsController;

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise3',
	    title: "Fill in the S,C,Q boxes on the right by following the process we just explained to work out the Question, plus the Situation and the Complication that would make the reader ask that Question.  I will guide you along",
	    tasks: [{
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '',
	        style: ''
	      },
	      title: {
	        text: '',
	        style: ''
	      },
	      pyramid: {
	        text: 'Drilling for methane',
	        style: { opacity: 1 }
	      },
	      s: {
	        text: '',
	        style: ''
	      },
	      c: {
	        text: '',
	        style: ''
	      },
	      q: {
	        text: '',
	        style: ''
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: '',
	        style: ''
	      },
	      showPyramidQuestionField: false,
	      isFirst: true,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '1',
	        delay: 0
	      },
	      title: {
	        text: 'Identify the Subject',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Drilling for methane will not be commercially feasible',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '2',
	        delay: 0
	      },
	      title: {
	        text: 'State reader’s question',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Drilling for methane will not be commercially feasible',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 500
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '3',
	        delay: 0
	      },
	      title: {
	        text: 'State the rough answer (if you know it)',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        showInput: false,
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '4',
	        delay: 0
	      },
	      title: {
	        text: 'Make a statement about the subject that the reader will agree with you is true.  (Note: Always begin any introduction by making a statement about the subject)',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="65"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 65 L 384 64 L 384 65"\n                        to="M 379 56 L 384 64 L 377 71"\n                        dur="0.5s" />\n                </path>\n\n                <line x1="0" y1="186" x2="0" y2="186" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted + 1s"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="186"\n                        begin="DOMNodeInserted + 1s"\n                        to="117"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 1.5s"\n                        fill="freeze"\n                        from="M 384 117 L 384 117 L 384 117"\n                        to="M 378 110 L 384 117 L 380 128"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'Imagine the reader says “Yes, I know that, so what?”',
	        delay: 0
	      },
	      s: {
	        showInput: true,
	        delay: 0
	      },
	      c: {
	        showInput: false,
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '5',
	        delay: 0
	      },
	      title: {
	        text: 'Imagine the reader says “Yes, I know that, so what?”',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="95" x2="0" y2="0" stroke="#050E61" stroke-width="3">\n                  <animate\n                      attributeName="x2"\n                      from="0"\n                      begin="DOMNodeInserted + 1s"\n                      to="394"\n                      dur="0.500s"\n                      fill="freeze"\n                  />\n                  <animate\n                      attributeName="y2"\n                      from="95"\n                      begin="DOMNodeInserted + 1s"\n                      to="160"\n                      dur="0.500s"\n                      fill="freeze"\n                  />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3">\n                  <animate\n                      attributeName="d"\n                      begin="DOMNodeInserted + 1.5s"\n                      fill="freeze"\n                      from="M 385 159 L 385 159 L 385 159"\n                      to="M 385 159 L 375 150 L 373 168"\n                      dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'That should lead you to the complication',
	        delay: 0
	      },
	      s: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      c: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      number: {
	        text: '6',
	        delay: 0
	      },
	      title: {
	        showInput: true,
	        text: 'The Question and the Answer should match, if not rewrite',
	        delay: 0,
	        rows: 3
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        headerAnswer: '',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>\n\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'Imagine the reader says “Yes, I know that, so what?”',
	        delay: 0
	      },
	      s: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      c: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false,
	        showPyramidQuestionField: false
	      },
	      showAditionalBox: false,
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '7',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Check your SCQ against ours',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        headerAnswer: 'is unlikely to be commercially feasible for us',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="x2"\n                from="0"\n                begin="DOMNodeInserted"\n                to="161"\n                dur="0.505s"\n                fill="freeze"\n              />\n              <animate\n                attributeName="y2"\n                from="20"\n                begin="DOMNodeInserted"\n                to="296"\n                dur="0.500s"\n                fill="freeze"\n              />\n            </line>\n            <path d="" stroke="#050E61" stroke-width="3" style="fill: #050E61">\n              <animate\n                attributeName="d"\n                begin="DOMNodeInserted + 0.5s"\n                fill="freeze"\n                from="M 158 293 L 158 293 L 158 293"\n                to="M 161 280 L 159 293 L 145 293"\n                dur="0.5s" />\n            </path>',
	      additionalInfoBox: {
	        text: 'What question does the Top box raise',
	        delay: 0
	      },
	      s: {
	        text: 'Thinking about drilling for methane',
	        delay: 0
	      },
	      c: {
	        text: 'Don’t want to do unless commercially feasible',
	        delay: 0
	      },
	      q: {
	        text: 'Is it commercially feasible?',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: false
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: true,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="75" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="y2"\n                from="75"\n                begin="DOMNodeInserted + 1s"\n                to="340"\n                dur="0.500s"\n                fill="freeze"\n              />\n            </line>\n\n            <path d="" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="d"\n                begin="DOMNodeInserted + 1.5s"\n                fill="freeze"\n                from="M 160 339 L 160 339 L 160 339"\n                to="M 168 330 L 160 339 L 152 330"\n                dur="0.5s" />\n            </path>',
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '8',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Check your answer',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        headerAnswer: 'is unlikely to be commercially feasible for us',
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: 'What question does the Top box raise',
	        delay: 0
	      },
	      s: {
	        text: 'Thinking about drilling for methane',
	        delay: 0
	      },
	      c: {
	        text: 'Don’t want to do unless commercially feasible',
	        delay: 0
	      },
	      q: {
	        text: 'Is it commercially feasible?',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: false,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3" />',
	      isBlinkingEffect: true,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '9',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        headerAnswer: 'is unlikely to be commercially feasible for us',
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'Thinking about drilling for methane',
	        delay: 0
	      },
	      c: {
	        text: 'Don’t want to do unless commercially feasible',
	        delay: 0
	      },
	      q: {
	        text: 'Is it commercially feasible?',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: true,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>',
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '10',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'Drilling for methane',
	        headerAnswer: 'is unlikely to be commercially feasible for us',
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: '',
	        delay: 0
	      },
	      s: {
	        text: 'Thinking about drilling for methane',
	        delay: 0
	      },
	      c: {
	        text: 'Don’t want to do unless commercially feasible',
	        delay: 0
	      },
	      q: {
	        text: 'Is it commercially feasible?',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: true,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: true,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>',
	      isBlinkingEffect: true,
	      showSoWhatText: true
	    }],
	    sTitle: "S = ",
	    cTitle: "C = ",
	    qTitle: "Q = ",
	    pyramidQuestionText: 'Why?',
	    showPaperStep: 9,
	    connectors: '\n                <svg width="924px" height="70px">\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="1s"\n                            to="105"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1.5"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="2s"\n                            to="820"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="2s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n                </svg>',
	    pyramidBlocks: '\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"\n                     style="opacity: 0; line-height: 15px;">Amounts of methane in the aquifer are small</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"\n                     style="opacity: 0; line-height: 15px;">Pressure is unlikely to be sufficient to push the methane up unaided</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n<!--                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7 && pyramidQuestion.length >= 3 || vm.currentStateNumber > vm.data.waitPyramidQuestionInputStep"-->\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7"\n                     style="opacity: 0; line-height: 15px;">We are unlikely to get environmental approval</p>\n                </div>\n      ',
	    additionalBoxText: {
	      s: 'Have a problem',
	      c: 'Have a solution',
	      q: 'How implement?'
	    },
	    hideStepsText: true,
	    correctPaperAnswer: '\n        <p class="correct-paper-answer__text">The report the engineers at X Company make compelling reading, and I can see that there is great excitement around the office in thinking about drilling the likely windfall from drilling for methane.</p>\n        <p class="correct-paper-answer__text">We do not want to go ahead, of course, unless we can be certain that the project will actually be commercially feasible.</p>\n    '
	    // waitPyramidQuestionInput: true
	  }
	};

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise1',
	    title: "Fill in the S,C,Q boxes on the right by following the process we just explained to work out the Question, plus the Situation and the Complication that would make the reader ask that Question. I will guide you along",
	    tasks: [{
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '',
	        style: ''
	      },
	      title: {
	        text: '',
	        style: ''
	      },
	      pyramid: {
	        text: '',
	        style: ''
	      },
	      s: {
	        text: '',
	        style: ''
	      },
	      c: {
	        text: '',
	        style: ''
	      },
	      q: {
	        text: '',
	        style: ''
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: '',
	        style: ''
	      },
	      isFirst: true,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '1',
	        delay: 0
	      },
	      title: {
	        text: 'State the subject',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Product Managment',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        delay: 0
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '2',
	        delay: 0
	      },
	      title: {
	        text: 'Decide the question',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Product Managment',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        text: 'How fix',
	        delay: 500
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '3',
	        delay: 0
	      },
	      title: {
	        text: 'State the rough answer (if you know it)',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Fix Product Managment like this',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        text: 'How fix',
	        delay: 0
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '4',
	        delay: 0
	      },
	      title: {
	        text: 'Make a statement about the subject that the reader will agree with you is true. (Note: Always begin any introduction by making a statement about the subject)',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Fix Product Managment like this',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="65"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 65 L 384 64 L 384 65"\n                        to="M 379 56 L 384 64 L 377 71"\n                        dur="0.5s" />\n                </path>\n                \n                <line x1="0" y1="186" x2="0" y2="186" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted + 1s"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="186"\n                        begin="DOMNodeInserted + 1s"\n                        to="117"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 1.5s"\n                        fill="freeze"\n                        from="M 384 117 L 384 117 L 384 117"\n                        to="M 378 110 L 384 117 L 380 128"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'Imagine the reader says “Yes, I know that, so what?” That should lead you to the Complication',
	        delay: 0
	      },
	      s: {
	        text: 'PM used to market individual products in large orgs.',
	        delay: 500
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        text: 'How fix',
	        delay: 0
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '5',
	        delay: 0
	      },
	      title: {
	        text: 'Word the Complication so that it triggers the question',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Fix Product Managment like this',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="156"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 154 L 384 154 L 384 154"\n                        to="M 382 142 L 384 154 L 376 159"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'PM used to market individual products in large orgs.',
	        delay: 0
	      },
	      c: {
	        text: 'Not working, bad product',
	        delay: 500
	      },
	      q: {
	        text: 'How fix',
	        delay: 0
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      showAditionalBox: false,
	      isBlinkingEffect: true
	    }, {
	      number: {
	        text: '6',
	        delay: 0
	      },
	      title: {
	        text: 'State the Question',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Fix Product Managment like this',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'PM used to market individual products in large orgs.',
	        delay: 0
	      },
	      c: {
	        text: 'Not working, bad product',
	        delay: 0
	      },
	      q: {
	        text: 'Is it bad?',
	        delay: 500
	      },
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      showAditionalBox: true,
	      isBlinkingEffect: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '7',
	        delay: 0
	      },
	      title: {
	        text: 'State the Answer',
	        delay: 0
	      },
	      pyramid: {
	        text: 'No, it is a sound concept, just misapplied',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3" \n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'PM used to market individual products in large orgs.',
	        delay: 0
	      },
	      c: {
	        text: 'Not working, bad product',
	        delay: 0
	      },
	      q: {
	        text: 'Is it bad?',
	        delay: 0
	      },
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      showAditionalBox: true,
	      rightArrows: '\n          ',
	      isBlinkingEffect: true
	    }, {
	      endText: {
	        text: 'Now go try it for yourself in the two exercises that follow',
	        delay: 5700
	      },
	      number: {
	        text: '8',
	        delay: 0
	      },
	      title: {
	        text: 'The Answer will trigger a new Question.',
	        delay: 0
	      },
	      pyramid: {
	        text: 'Successful Product Management reflects a continuing focus on strategy',
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'Product Managers have for years enabled large orgs to steer individual products to profitability',
	        delay: 0
	      },
	      c: {
	        text: 'Lately, hearing PM no longer relevant, no longer working well',
	        delay: 0
	      },
	      q: {
	        text: 'How fix?',
	        delay: 0
	      },
	      hideInfoBox: true,
	      isFirst: false,
	      isLast: true,
	      pyramidQuestion: true,
	      showAditionalBox: true,
	      showPyramid: true,
	      pyramidDelay: 1700,
	      rightArrows: '\n            <line x1="160" y1="19" x2="160" y2="19" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="y2"\n                from="19"\n                begin="DOMNodeInserted + 1s"\n                to="340"\n                dur="0.500s"\n                fill="freeze"\n              />\n            </line>\n\n            <path d="" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="d"\n                begin="DOMNodeInserted + 1.5s"\n                fill="freeze"\n                from="M 160 339 L 160 339 L 160 339"\n                to="M 168 330 L 160 339 L 152 330"\n                dur="0.5s" />\n            </path>',
	      isBlinkingEffect: true
	    }],
	    sTitle: "S = ",
	    cTitle: "C = ",
	    qTitle: "Q = ",
	    additionalBoxText: {
	      s: 'Do X to achieve Y',
	      c: 'Not working because of Z',
	      q: 'Is Z true?'
	    },
	    pyramidQuestionText: ' How?',
	    connectors: '\n                <svg width="924px" height="70px">\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="1s"\n                            to="105"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="1.5s"\n                            to="340"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1.5s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="2s"\n                            to="580"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="2s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="2.5s"\n                            to="820"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="2.5s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n                </svg>',
	    pyramidBlocks: '\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text" style="opacity: 1">Assign clear accountability for strategy</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text" style="opacity: 1">Gather evidence for stated direction</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text" style="opacity: 1">Involve management in crafting the final strategy</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text" style="opacity: 1">Present a clear roadmap for achieving it</p>\n                </div>\n      '
	  }
	};

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise2',
	    title: "Fill in the S,C,Q boxes on the right by following the process we just explained to work out the Question, plus the Situation and the Complication that would make the reader ask that Question.  I will guide you along",
	    tasks: [{
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '',
	        style: ''
	      },
	      title: {
	        text: '',
	        style: ''
	      },
	      pyramid: {
	        text: 'The Rationalization Program',
	        style: { opacity: 1 }
	      },
	      s: {
	        text: '',
	        style: ''
	      },
	      c: {
	        text: '',
	        style: ''
	      },
	      q: {
	        text: '',
	        style: ''
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: '',
	        style: ''
	      },
	      showPyramidQuestionField: false,
	      isFirst: true,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: false,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '1',
	        delay: 0
	      },
	      title: {
	        text: 'Identify the Subject',
	        delay: 0
	      },
	      pyramid: {
	        text: 'The Rationalization Program',
	        delay: 500
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '2',
	        delay: 0
	      },
	      title: {
	        text: 'State reader’s question',
	        delay: 0
	      },
	      pyramid: {
	        text: 'The Rationalization Program',
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 500
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '3',
	        delay: 0
	      },
	      title: {
	        text: 'State the rough answer (if you know it)',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        delay: 0
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '4',
	        delay: 0
	      },
	      title: {
	        text: 'Make a statement about the subject that the reader will agree with you is true.  (Note: Always begin any introduction by making a statement about the subject)',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="65"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 65 L 384 64 L 384 65"\n                        to="M 379 56 L 384 64 L 377 71"\n                        dur="0.5s" />\n                </path>\n\n                <line x1="0" y1="186" x2="0" y2="186" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted + 1s"\n                        to="394"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="186"\n                        begin="DOMNodeInserted + 1s"\n                        to="117"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 1.5s"\n                        fill="freeze"\n                        from="M 384 117 L 384 117 L 384 117"\n                        to="M 378 110 L 384 117 L 380 128"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'Imagine the reader says “Yes, I know that, so what?”',
	        delay: 0
	      },
	      s: {
	        showInput: true,
	        delay: 500
	      },
	      c: {
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: true,
	      showSoWhatText: false
	    }, {
	      number: {
	        text: '5',
	        delay: 0
	      },
	      title: {
	        text: 'Imagine the reader says “Yes, I know that, so what?”',
	        delay: 0
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        delay: 0
	      },
	      arrows: '\n                <line x1="0" y1="95" x2="0" y2="0" stroke="#050E61" stroke-width="3">\n                  <animate\n                      attributeName="x2"\n                      from="0"\n                      begin="DOMNodeInserted + 1s"\n                      to="394"\n                      dur="0.500s"\n                      fill="freeze"\n                  />\n                  <animate\n                      attributeName="y2"\n                      from="95"\n                      begin="DOMNodeInserted + 1s"\n                      to="160"\n                      dur="0.500s"\n                      fill="freeze"\n                  />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3">\n                  <animate\n                      attributeName="d"\n                      begin="DOMNodeInserted + 1.5s"\n                      fill="freeze"\n                      from="M 385 159 L 385 159 L 385 159"\n                      to="M 385 159 L 375 150 L 373 168"\n                      dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: 'That should lead you to the complication',
	        delay: 0
	      },
	      s: {
	        showInput: true,
	        text: '',
	        delay: 500
	      },
	      c: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      number: {
	        text: '6',
	        delay: 0
	      },
	      title: {
	        showInput: true,
	        text: 'The Question and the Answer should match, if not rewrite',
	        delay: 0,
	        rows: 3
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        headerAnswer: '',
	        hideText: false,
	        delay: 0
	      },
	      arrows: '<line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="412"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="250"\n                        dur="0.5s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 384 236 L 384 236 L 384 236"\n                        to="M 383 223 L 384 236 L 376 241"\n                        dur="0.5s" />\n                </path>\n\n                <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n                    <animate\n                        attributeName="x2"\n                        from="0"\n                        begin="DOMNodeInserted"\n                        to="161"\n                        dur="0.505s"\n                        fill="freeze"\n                    />\n                    <animate\n                        attributeName="y2"\n                        from="20"\n                        begin="DOMNodeInserted"\n                        to="296"\n                        dur="0.500s"\n                        fill="freeze"\n                    />\n                </line>\n                <path d="" stroke="#050E61" stroke-width="3"\n                style="fill: #050E61">\n                    <animate\n                        attributeName="d"\n                        begin="DOMNodeInserted + 0.5s"\n                        fill="freeze"\n                        from="M 158 293 L 158 293 L 158 293"\n                        to="M 161 280 L 159 293 L 145 293"\n                        dur="0.5s" />\n                </path>',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        showInput: true,
	        text: '',
	        delay: 500
	      },
	      c: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      q: {
	        showInput: true,
	        text: '',
	        delay: 0
	      },
	      checkAnswer: {
	        s: false,
	        c: false,
	        q: false
	      },
	      showAditionalBox: false,
	      showPyramidQuestionField: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: false,
	      showPyramid: true,
	      pyramidDelay: 0,
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '7',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Check your SCQ against ours',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        headerAnswer: 'To cut the Rationalization Program to manageable size, we should implement only high benefit proposals',
	        hideText: true,
	        delay: 0
	      },
	      arrows: '\n            <line x1="0" y1="20" x2="0" y2="20" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="x2"\n                from="0"\n                begin="DOMNodeInserted"\n                to="161"\n                dur="0.505s"\n                fill="freeze"\n              />\n              <animate\n                attributeName="y2"\n                from="20"\n                begin="DOMNodeInserted"\n                to="296"\n                dur="0.500s"\n                fill="freeze"\n              />\n            </line>\n            <path d="" stroke="#050E61" stroke-width="3" style="fill: #050E61">\n              <animate\n                attributeName="d"\n                begin="DOMNodeInserted + 0.5s"\n                fill="freeze"\n                from="M 158 293 L 158 293 L 158 293"\n                to="M 161 280 L 159 293 L 145 293"\n                dur="0.5s" />\n            </path>',
	      additionalInfoBox: {
	        text: 'What question does the Top box raise',
	        delay: 0
	      },
	      s: {
	        text: 'Working on RP for 5 months, did 30 out of 173 branches. 7 months left to do the rest',
	        delay: 0
	      },
	      c: {
	        text: 'Need to use time to achiever maximum savings possible.',
	        delay: 0
	      },
	      q: {
	        text: 'How',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: false
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: true,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="75" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="y2"\n                from="75"\n                begin="DOMNodeInserted + 1s"\n                to="340"\n                dur="0.500s"\n                fill="freeze"\n              />\n            </line>\n\n            <path d="" stroke="#050E61" stroke-width="3">\n              <animate\n                attributeName="d"\n                begin="DOMNodeInserted + 1.5s"\n                fill="freeze"\n                from="M 160 339 L 160 339 L 160 339"\n                to="M 168 330 L 160 339 L 152 330"\n                dur="0.5s" />\n            </path>',
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '8',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Check your answer',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        headerAnswer: 'To cut the Rationalization Program to manageable size, we should implement only high benefit proposals',
	        hideText: true,
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: 'What question does the Top box raise',
	        delay: 0
	      },
	      s: {
	        text: 'Working on RP for 5 months, did 30 out of 173 branches. 7 months left to do the rest',
	        delay: 0
	      },
	      c: {
	        text: 'Need to use time to achiever maximum savings possible.',
	        delay: 0
	      },
	      q: {
	        text: 'How',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: false,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>',
	      isBlinkingEffect: true,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '9',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution.',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        headerAnswer: 'To cut the Rationalization Program to manageable size, we should implement only high benefit proposals',
	        hideText: true,
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'Working on RP for 5 months, did 30 out of 173 branches. 7 months left to do the rest',
	        delay: 0
	      },
	      c: {
	        text: 'Need to use time to achiever maximum savings possible.',
	        delay: 0
	      },
	      q: {
	        text: 'How',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: false,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: true,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>',
	      isBlinkingEffect: false,
	      showSoWhatText: true
	    }, {
	      endText: {
	        text: '',
	        delay: 0
	      },
	      number: {
	        text: '10',
	        delay: 0
	      },
	      title: {
	        showInput: false,
	        text: 'Please write the introduction out in prose, as if you were preparing to send the document yourself. When finished, click Next to compare it to the “school solution.',
	        delay: 0,
	        rows: 2
	      },
	      pyramid: {
	        showInput: true,
	        text: 'The Rationalization Program',
	        headerAnswer: 'To cut the Rationalization Program to manageable size, we should implement only high benefit proposals',
	        hideText: true,
	        delay: 0
	      },
	      arrows: '',
	      additionalInfoBox: {
	        text: ''
	      },
	      s: {
	        text: 'Working on RP for 5 months, did 30 out of 173 branches. 7 months left to do the rest',
	        delay: 0
	      },
	      c: {
	        text: 'Need to use time to achiever maximum savings possible.',
	        delay: 0
	      },
	      q: {
	        text: 'How',
	        delay: 0
	      },
	      checkAnswer: {
	        s: true,
	        c: true,
	        q: true,
	        showPyramidQuestionField: true
	      },
	      showAditionalBox: true,
	      showPyramidQuestionField: false,
	      hideInfoBox: false,
	      isFirst: false,
	      isLast: true,
	      pyramidQuestion: true,
	      showPyramid: true,
	      pyramidDelay: 0,
	      showDocument: true,
	      rightArrows: '\n            <line x1="160" y1="75" x2="160" y2="340" stroke="#050E61" stroke-width="3" />\n            <path d="M 168 330 L 160 339 L 152 330" stroke="#050E61" stroke-width="3"></path>',
	      isBlinkingEffect: true,
	      showSoWhatText: true
	    }],
	    sTitle: "S = ",
	    cTitle: "C = ",
	    qTitle: "Q = ",
	    pyramidQuestionText: ' How?',
	    showPaperStep: 9,
	    connectors: '\n                <svg width="924px" height="70px">\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="1s"\n                            to="105"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="1.5"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n\n                    <line x1="465" y1="0" x2="465" y2="0" stroke="#fff" stroke-width="3">\n                        <animate\n                            attributeName="x2"\n                            from="465"\n                            begin="2s"\n                            to="820"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                        <animate\n                            attributeName="y2"\n                            from="0"\n                            begin="2s"\n                            to="70"\n                            dur="1s"\n                            fill="freeze"\n                        />\n                    </line>\n                </svg>',
	    pyramidBlocks: '\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7" style="opacity: 0; line-height: 15px;">Adhere to the June deadline for those projects in the present backlog that required low capital expenditure</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7" style="opacity: 0; line-height: 15px;">Rigorously reappraise the remaining projects in the backlog to eliminate those that will yield low benefits</p>\n                </div>\n                <div class="pyramid-box pyramid-body"\n                     ng-class="{\'show-pyramid-body\': vm.showPyramid}">\n                    <p class="text show-pyramid-text" ng-if="vm.currentStateNumber >= 7" style="opacity: 0; line-height: 15px;">Set realistic deadlines for completing the second group of projects</p>\n                </div>\n      ',
	    additionalBoxText: {
	      s: 'Have a problem',
	      c: 'Have a solution',
	      q: 'How implement?'
	    },
	    hideStepsText: true,
	    correctPaperAnswer: '\n        <p class="correct-paper-answer__text">As part of the Bank\u2019s Rationalization Program, we have been working for the last 5 months on identifying cost savings in each of your 173 b ranches. Unfortunately, we have thus far been able to complete our work in only 30 of the branches, with 7 months remaining to tackle the rest.</p>\n        <p class="correct-paper-answer__text">If we are to achieve anywhere near the $72m in savings expected, we clearly need to change our approach. We are planning to shift our focus from covering the individual branches to achieving as much of the savings available throughout as possible.</p>\n    '
	  }
	};

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(741);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./findingReadersQuestion.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./findingReadersQuestion.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit4b .exercise .exercise-number_3{padding-top:50px}.unit4b .intro-1 ul{padding-left:80px}.unit4b .intro-1 p:last-child{border-bottom:3px solid #000;padding-bottom:45px;margin-bottom:45px}.unit4b .exercise-title{font-size:42px}.unit4b .intro-3 ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4b .intro-3 p:first-child{text-decoration:underline;font-weight:700;font-size:24px}.unit4b .intro-2 p:first-child{font-weight:700;font-size:24px}.unit4b .intro-2 p:first-child+p{margin-top:10px}", ""]);
	
	// exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _spottingSCQ = __webpack_require__(743);
	
	var _spottingSCQ2 = _interopRequireDefault(_spottingSCQ);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spottingSCQModule = _angular2.default.module('spottingSCQ', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.spottingSCQ', {
	    url: '/courses/4/4b2/spotting-scq-structure',
	    component: 'spottingSCQ'
	    // resolve: { authenticate }
	  });
	}]).component('spottingSCQ', _spottingSCQ2.default).name;
	
	exports.default = spottingSCQModule;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _spottingSCQ = __webpack_require__(744);
	
	var _spottingSCQ2 = _interopRequireDefault(_spottingSCQ);
	
	var _spottingSCQ3 = __webpack_require__(745);
	
	var _spottingSCQ4 = _interopRequireDefault(_spottingSCQ3);
	
	__webpack_require__(758);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var spottingSCQComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _spottingSCQ2.default,
	  controller: _spottingSCQ4.default
	};
	
	exports.default = spottingSCQComponent;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-4 unit4b-2\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>spotting-scq.course-name</h1>\n  </course-header>\n\n  <!-- <course-video lecture-title=\" 'finding-readers-question.course-video.lecture-title' \" video-id=\"vm.videoId\" video-title=\" 'finding-readers-question.course-video.title' \"></course-video> -->\n  <course-video lecture-title=\" 'spotting-scq.course-video.lecture-title' \" />\n\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>spotting-scq.unit-intro-title</span>\n  </h2>\n\n  <div class=\"unit-wrapper\">\n    <p class=\"intro\" translate>spotting-scq.exercise-intro</p>\n    <ol class=\"exercise-menu\">\n      <li>\n        <span translate>spotting-scq.menu-list.first-part</span>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">spotting-scq.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">spotting-scq.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">spotting-scq.menu-list.exercise-3</a></li>\n        </ol>\n      </li>\n      <li>\n        <span translate>spotting-scq.menu-list.second-part</span>\n        <ol start=\"4\" class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">spotting-scq.menu-list.exercise-4</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">spotting-scq.menu-list.exercise-5</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">spotting-scq.menu-list.exercise-6</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-7')\">spotting-scq.menu-list.exercise-7</a></li>\n        </ol>\n      </li>\n      <li>\n        <span translate>spotting-scq.menu-list.third-part</span>\n        <ol start=\"8\" class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-8')\">spotting-scq.menu-list.exercise-8</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-9')\">spotting-scq.menu-list.exercise-9</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-10')\">spotting-scq.menu-list.exercise-10</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-11')\">spotting-scq.menu-list.exercise-11</a></li>\n        </ol>\n      </li>\n      <li>\n        <span translate>spotting-scq.menu-list.fourth-part</span>\n        <ol start=\"12\" class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-12')\">spotting-scq.menu-list.exercise-12</a></li>\n        </ol>\n      </li>\n    </ol>\n\n<!--    <ol class=\"anchors-menu\">-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">spotting-scq.menu-list.exercise-1</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">spotting-scq.menu-list.exercise-2</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">spotting-scq.menu-list.exercise-3</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">spotting-scq.menu-list.exercise-4</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-5')\">spotting-scq.menu-list.exercise-5</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-6')\">spotting-scq.menu-list.exercise-6</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-7')\">spotting-scq.menu-list.exercise-7</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-8')\">spotting-scq.menu-list.exercise-8</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-9')\">spotting-scq.menu-list.exercise-9</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-10')\">spotting-scq.menu-list.exercise-10</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-11')\">spotting-scq.menu-list.exercise-11</a></li>-->\n<!--      <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-12')\">spotting-scq.menu-list.exercise-12</a></li>-->\n<!--    </ol>-->\n  </div>\n\n  <h2 class=\"background\">\n    <div class=\"unit4__subtitle\" translate>spotting-scq.unit-section-title</div>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <!-- <p class=\"intro\" translate>spotting-scq.exercise-intro</p> -->\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-1.description</p>\n      <div class=\"exercise-reference\" translate>spotting-scq.exercise-1.reference</div>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise1\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-4.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-4.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-4.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise4\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-11.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-11.title</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-11.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise11\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <h2 class=\"background\">\n    <div class=\"unit4__subtitle\" translate>spotting-scq.unit-section-title-2</div>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\"></div>\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-9.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-9.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-9.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-9.description</p>\n      <div class=\"exercise-reference\" translate>spotting-scq.exercise-9.reference</div>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise9\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-5\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-8.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-8.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-8.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-8.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise8\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-6\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-10.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-10.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-10.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-10.description</p>\n      <div class=\"exercise-reference\" translate>spotting-scq.exercise-10.reference</div>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise10\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-7\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-5.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-5.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-5.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-5.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise5\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <h2 class=\"background\">\n    <div class=\"unit4__subtitle\" translate>spotting-scq.unit-section-title-3</div>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\"></div>\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-8\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-3.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-3.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-3.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise3\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-9\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-2.description</p>\n      <div class=\"exercise-reference\" translate>spotting-scq.exercise-2.reference</div>\n    </div>\n\n    <div class=\"diagram margin-60\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise2\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-10\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-6.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-6.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-6.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-6.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise6\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-11\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-7.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-7.title</p>\n      <p class=\"exercise-subtitle\" translate>spotting-scq.exercise-7.subtitle</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-7.description</p>\n    </div>\n\n    <div class=\"diagram margin-60 simplest_structure\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram-dnd data=\"vm.exercise7\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\"></scq-diagram-dnd>\n      </div>\n    </div>\n  </section>\n\n  <h2 class=\"background\">\n    <div class=\"unit4__subtitle\" translate>spotting-scq.unit-section-title-4</div>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\"></div>\n    <div class=\"unit-wrapper exercise-wrapper exercise-wrapper_topoffset\" id=\"exercise-12\">\n      <p class=\"exercise-number\" translate>spotting-scq.exercise-12.number</p>\n      <p class=\"exercise-title\" translate>spotting-scq.exercise-12.title</p>\n      <p class=\"exercise-description\" translate>spotting-scq.exercise-12.description</p>\n      <div class=\"memo-paper\">\n        <div>\n          <div class=\"paper-header\" translate=\"\">spotting-scq.paper-header</div>\n          <div class=\"horizontal-line\"></div>\n          <div class=\"memo-paper-title\" translate>spotting-scq.exercise-12.memo-title</div>\n          <div class=\"memo-paper-description\" translate>spotting-scq.exercise-12.memo-description</div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise12\" on-finish=\"vm.sendStatistic($event)\" finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n  </section>\n    <div class=\"unit-wrapper\" style=\"max-width: initial\">\n      <unit-finish\n        on-button-click=\"vm.onSectionFinish()\"\n        congratulation-message=\"'spotting-scq.congratulation-message'\"\n        finish-section=\"'spotting-scq.finish-section'\"\n        final-description=\"'spotting-scq.final-description'\"\n        next-course-button=\"'spotting-scq.next-course-button'\"\n        dashboard-button=\"'spotting-scq.dashboard-button'\"\n        next-course=\"'course.applyingSCQProcess'\">\n      </unit-finish>\n    </div>\n    <pyramid-builder section-title=\"{{ 'spotting-scq.course-title' | translate }}\"></pyramid-builder>\n  </section>\n</div>\n"

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(746);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(747);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(748);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(749);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(750);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(751);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	var _exercise13 = __webpack_require__(752);
	
	var _exercise14 = _interopRequireDefault(_exercise13);
	
	var _exercise15 = __webpack_require__(753);
	
	var _exercise16 = _interopRequireDefault(_exercise15);
	
	var _exercise17 = __webpack_require__(754);
	
	var _exercise18 = _interopRequireDefault(_exercise17);
	
	var _exercise19 = __webpack_require__(755);
	
	var _exercise20 = _interopRequireDefault(_exercise19);
	
	var _exercise21 = __webpack_require__(756);
	
	var _exercise22 = _interopRequireDefault(_exercise21);
	
	var _exercise23 = __webpack_require__(757);
	
	var _exercise24 = _interopRequireDefault(_exercise23);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SpottingSCQArgumentsController = function (_CourseController) {
	  SpottingSCQArgumentsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(SpottingSCQArgumentsController, _CourseController);
	
	  function SpottingSCQArgumentsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, SpottingSCQArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (SpottingSCQArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(SpottingSCQArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	    // this.helperService.initIntercom();
	
	    _this.exercise1 = _exercise2.default['en'];
	    _this.exercise2 = _exercise4.default['en'];
	    _this.exercise3 = _exercise6.default['en'];
	    _this.exercise4 = _exercise8.default['en'];
	    _this.exercise5 = _exercise10.default['en'];
	    _this.exercise6 = _exercise12.default['en'];
	    _this.exercise7 = _exercise14.default['en'];
	    _this.exercise8 = _exercise16.default['en'];
	    _this.exercise9 = _exercise18.default['en'];
	    _this.exercise10 = _exercise20.default['en'];
	    _this.exercise11 = _exercise22.default['en'];
	    _this.exercise12 = _exercise24.default['en'];
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram4b2-';
	    _this.exerciseUserAnswers = {};
	
	    return _this;
	  }
	
	  return SpottingSCQArgumentsController;
	}(_course2.default);
	
	exports.default = SpottingSCQArgumentsController;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-1',
	        blocks: [{
	            index: '1',
	            task: 'S = Often face business dilemmas that require trusting someone else’s world',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = Success requires some willingness to cooperate with/have faith in others',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = How much faith, and with whom?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '2',
	            title: 'Know the solution'
	        }, {
	            index: '3',
	            title: 'How implement?'
	        }, {
	            index: '1',
	            title: 'Have a problem'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3
	    }
	};

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-2',
	        blocks: [{
	            index: '1',
	            task: 'S = Easier than before to build a product and start a company',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = Making the company a success is less easy – most new businesses fail',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = Why do so many people gamble on ventures that are likely to end badly?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '1',
	            title: 'Hundreds starting X'
	        }, {
	            index: '3',
	            title: 'Why do a start-up?'
	        }, {
	            index: '2',
	            title: 'Most fail'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'Trying to answer Why? as a question leading to the top point is a real trap you should try to avoid.  Although it make sense here as part of the story, the author is not writing to explain why they do it.  He will likely  have investigated, analyzed, and summarized the reasons why, as a basis for drawing a conclusion about how they justify it to themselves.  So the question is really something like “How do they justify it to themselves”, and the answer would be something like “They convince themselves it will not happen to them”.  The reader’s question is then how, and the document is structured around the ways they convince themselves.  You would never simply list the reasons for an occurrence without stating the insight into motivation behind it - and possibilities for behavioral change -  you can draw from them'
	    }
	};

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-3',
	        blocks: [{
	            index: '1',
	            task: 'S = A few decades ago pensions were taken for granted by all',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = Today pensions are almost dead in corporate America',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = Who killed them?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '2',
	            title: 'Not any more'
	        }, {
	            index: '3',
	            title: 'Why not?'
	        }, {
	            index: '1',
	            title: 'X used to be common'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'This one is interesting, in that it includes the Answer in the Question, hints at the structure of the document with a second question, and puts both at the beginning for more dramatic effect. You can of course change the order of an introduction’s parts and still be clear, so long as you maintain their structural relationship. And while this approach may make for a strong introduction, it leaves you limited in enabling you to talk about a solution to the problem.'
	    }
	};

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-4',
	        blocks: [{
	            index: '1',
	            task: 'S = American prosperity said to be explained by new technology and enterprising attitudes',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = In fact, had no particular edge over other industrial nations',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = Why did they prosper?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '2',
	            title: 'Not true'
	        }, {
	            index: '3',
	            title: 'How achieve X?'
	        }, {
	            index: '1',
	            title: 'Say achieved X because of Y'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'This is another perfectly permissible form, where you state how things were historically, then state the usual explanation for things having been that way. The question then is whether the original insight is true or not. It is an extremely efficient way to educate a reader to current thinking on a subject while at the same time setting him up to be ready to hear why the thinking is wrong.'
	    }
	};

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-5',
	        blocks: [{
	            index: '1',
	            task: 'S = Many major industries have stopped growing or are in decline',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = (Assumption is that growth is threatened because market is saturated)',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = (Is that a correct assumption?)',
	            title: "Q = "
	        }, {
	            index: '4',
	            task: 'A = No, it is because there has been a failure of management',
	            title: "A = No",
	            disabled: true
	        }],
	        answers: [{
	            index: '2',
	            title: '(Assume Y is the cause)'
	        }, {
	            index: '3',
	            title: '(Is Y the cause?) '
	        }, {
	            index: '1',
	            title: 'X happening'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'Note on Marketing Myopia: Here both the Complication and the Question are unstated, as they are implied by the Answer. It is a clever and effective way to get more quickly to the main point.\n               But unless you are a real expert in your subject, you would be wise to avoid it.<br/>\n               HELP YOU AVOID WHY? QUESTIONS<br/>\n               You will from time to time feel tempted to write an introduction that leads to a Why? question, as below.<br/>\n                <div class="scq__note-reverse">\n                <div>\n                    <span style="font-weight: bold">Why did it happen?</span>\n                    <span style="font-weight: bold">Tower of Babel</span>\n                </div>\n                <div>\n                    <span style="width: 35%">A = Attempted X</span>\n                    <span style="width: 65%">S = Tower of Babel was man\u2019s first major engineering failure</span>\n                </div>\n                <div>\n                    <span style="width: 35%">C = Didn\u2019t work</span>\n                    <span style="width: 65%">C =  But project appears to have had all the major prerequisites for success</span>\n                </div>\n                <div>\n                    <span style="width: 35%">Q = Why not?</span>\n                    <span style="width: 65%">Q = Why did it fail?</span>\n                </div>\n            </div>\n            As I mentioned in the last video, I do not like to have Why? as a question in a business document.  In general business documents should have a bias toward action, as that tends to be more helpful in focusing you on the actions you want your reader to take.  Why? questions, as you will see in the examples below, tend to encourage greater exposition of the problem instead of getting straight to the answer.  And they invariably lead to deductive arguments on the Key Line level.  They also lead to relatively frivolous discussion of the subject at hand.  You will be pleased to know that, in most cases, they can be easily converted to a How? question.<br/>\n            But unless you are a real expert in your subject, you would be wise to avoid it.'
	    }
	};

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-6',
	        blocks: [{
	            index: '1',
	            task: 'S = Tv viewing is down by 6.4% and 3.1% ',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C =Translates into millions of people ',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = What can millions being doing instead?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '3',
	            title: 'Why happen?'
	        }, {
	            index: '1',
	            title: 'X has occurred'
	        }, {
	            index: '2',
	            title: 'Is a major change'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 4,
	        note: '\n        This is the most straightforward way to read this introduction. But many people believe that (a) the Situation and the Complication as stated say the same thing, and therefore the Situation is implied. Still others say, no, the Complication is implied.\n        Here are the other two ways you could read it.\n        <div class="scq__note-title">Situation Implied</div>\n        <div class="scq__note">\n            <div>\n                S = (People used to watch TV all the time)\n                C = Have stopped watching\n                Q = What doing instead?\n            </div>\n            <div>\n                S = Stopped doing X\n                C = Must be doing non-X\n                Q = What is non-X?\n            </div>\n        </div>\n        <div class="scq__note-title">Complication Implied</div>\n        <div class="scq__note">\n            <div>\n                S = People have stopped doing X\n                C = (Must be doing something else)\n                Q = What doing ?\n            </div>\n            <div>\n                S = Stopped doing X\n                C = Clearly doing something else\n                Q = What is it?\n            </div>\n        </div>\n\n        '
	    }
	};

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-7',
	        blocks: [{
	            index: '1',
	            task: 'S = 83% of MI graduates cheated',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = 17% didn’t',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = Why not',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '3',
	            title: 'Why not?'
	        }, {
	            index: '2',
	            title: 'Y doesn’t'
	        }, {
	            index: '1',
	            title: 'X happens'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'This one was included (a) to amuse you and (b) because the ease with which you are able to pick out the points should give you confidence that you are indeed learning how to see the structure lurking in an introduction! But it also illustrates the clever technique of bringing up the opposite of the question people would expect you to ask. The futility of having a Why? question at the top still applies, however.'
	    }
	};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'diagram4b2-8',
	    blocks: [{
	      index: '1',
	      task: 'S = CFOs often allow last year’s budget target to influence the setting of this year’s goal - an unconscious bias called anchoring',
	      title: "S = "
	    }, {
	      index: '2',
	      task: 'C = Common attempts to overcome the anchor do not work well',
	      title: "C = "
	    }, {
	      index: '3',
	      task: 'Q = What does work?',
	      title: "Q = "
	    }],
	    answers: [{
	      index: '2',
	      title: 'Difficult to solve'
	    }, {
	      index: '3',
	      title: 'What do?'
	    }, {
	      index: '1',
	      title: 'Have problem'
	    }],
	    title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	    correctAnswers: 3,
	    note: '\n          Were you annoyed by the length of this introduction?  How long should an introduction be?  How long should a man\u2019s legs be? (Long enough to reach the ground).  This one is unnecessarily long and ponderous, partly because it has a double SCQ.  It first forces you to ask a question to which you do not yet want the answer (\u201CWhat happened?\u201D).  Then it makes you absorb the answer, before it presents a new Complication (Few solutions available).  You are then expected to ask \u201CWhat works\u201D to solve the problem, when in fact the problem hasn\u2019t actually been stated.\n          Is the subject of the article \u201Cbudgeting\u201D or \u201Canchoring\u201D.  It\u2019s probably anchoring, so I would have said the structure should be:\n          S = Anchoring is a well-known psychological bias\n          C = Happens a lot in budgeting, causes bad problem (not stated in the current introduction)\n          Q = How fix?\n          A = Re-anchor.\n        '
	  }
	};

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-9',
	        blocks: [{
	            index: '1',
	            task: 'S = Are surrounded by amazing objects',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = Required creative skills to create',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = How did our species acquire such skills?',
	            title: "Q = "
	        }],
	        answers: [{
	            index: '2',
	            title: 'Required Z'
	        }, {
	            index: '3',
	            title: 'How acquire Z?'
	        }, {
	            index: '1',
	            title: 'Surrounded by X'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: 'This is an example of an introduction trying to generate a question that no one would ask. The technique of using an anecdote from the author\u2019s life to try to draw the reader in is a perfectly legitimate one. It\u2019s just that this story is not very interesting, and doesn\u2019t really lead us to want to know how the world acquired our technology. But getting the structure down to its bare bones instantly reveals the lack of a justification for including it.'
	    }
	};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-10',
	        blocks: [{
	            index: '1',
	            task: 'S = Product developers constantly strive to keep quality and cost in line with demands for faster delivery',
	            title: "S = "
	        }, {
	            index: '2',
	            task: 'C = Still get schedule slippages, “firefighting,” and inferior quality',
	            title: "C = "
	        }, {
	            index: '3',
	            task: 'Q = Adopt integrated, holistic approach',
	            title: "Q = "
	        }, {
	            index: '4',
	            task: '',
	            title: "A ="
	        }],
	        answers: [{
	            index: '3',
	            title: 'What do?'
	        }, {
	            index: '1',
	            title: 'Want to achieve X plus Y and Z'
	        }, {
	            index: '2',
	            title: 'Don’t achieve'
	        }, {
	            index: '4',
	            title: 'Change approach'
	        }],
	        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	        correctAnswers: 3,
	        note: '\n            You can see easily that the Complication is wrong here: it breaks the rule that you cannot put your thinking in the introduction. Here it falls into the trap of including information that the reader might not know or agree with in advance \u2013 that the problem is managers making isolated improvements instead of looking at the process as a dynamic whole. That insight resulted from his analysis and thus belongs below, in the body. In fact, it is his main point. The problem is actually that all the parts of the process are intertwined.\n            <div class="scq__note">\n                <div>\n                    <span>S = Want to do X, Y, Z, but can\u2019t</span>\n                    <span>Approach problem by doing A B C</span>\n                </div>\n                <div>\n                    <span>C = Problem is all three parts intertwined</span>\n                    <span>Doesn\u2019t work</span>\n                </div>\n                <div>\n                    <span>Q = What do?</span>\n                    <span>How change</span>\n                </div>\n                <div>\n                    <span>A = Make those parts work together</span>\n                    <span>Adopt X Y Z approach</span>\n                </div>\n            </div>\n            Getting the statement of the SCQ down to its simplest lets you see how silly the logic is: they don\u2019t use the right approach, so the answer is to use the right approach\n        ',
	        noteHeight: '300px',
	        noteTitle: '139px'
	    }
	};

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'diagram4b2-11',
	    blocks: [{
	      index: '1',
	      task: 'S = Belief is that entrepreneurs succeed either because they plan and execute carefully, or because they possess a wacky self-belief that leads them to bet long odds',
	      title: "S = "
	    }, {
	      index: '2',
	      task: 'C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
	      title: "C = "
	    }, {
	      index: '3',
	      task: 'Q = How do they succeed?',
	      title: "Q = "
	    }, {
	      index: '4',
	      task: 'A = They blend two contradictory skills – careful analytical thinking and a willingness to push boundaries',
	      title: "A = No",
	      disabled: true
	    }],
	    answers: [{
	      index: '2',
	      title: 'But X does not do either A or B'
	    }, {
	      index: '3',
	      title: 'How succeed?'
	    }, {
	      index: '1',
	      title: 'Believe X succeeds because of A or B'
	    }],
	    title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
	    correctAnswers: 3
	  }
	};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4b2-12',
	        blocks: [{
	            task: 'S = Planning to enter market with Thynne, but need IFA membership',
	            title: "S = ",
	            model: '',
	            answer: 'Want to do X, but need Y',
	            disableEdit: false,
	            modelName: 's'
	        }, {
	            task: 'C = Thynne not seen as attractive to IFA',
	            title: "C = ",
	            model: '',
	            answer: 'See problem in getting Y',
	            disableEdit: false,
	            modelName: 'c'
	        }, {
	            task: 'Q = Can it be made attractive?',
	            title: "Q = ",
	            model: '',
	            answer: 'Can we get Y?',
	            disableEdit: false,
	            modelName: 'q'
	        }],
	        title: 'Read the summary of the introduction (SCQ), and look at the pyramid it leads to. Translate to the simplest structure, and take a stab at writing the full introduction in prose',
	        correctAnswers: 4,
	        note: '\n        This is an example of a \u201Ccan we/should we\u201D document, and generally presages the presentation of research results. Whenever you do research, both the searching and the writing are greatly expedited if you begin with a \u201Cresearchable question.\u201D I define a researchable question as one that demands a yes-or-no answer. \u201CHow should we reorganize,\u201D is not a researchable question because, before you can do the really good thinking about the question, you first have to define (a) the problem to which the reorganization is the solution, (b) the alternative ways the problem could be solved, (c) the criteria you would use to judge between them, and finally (d) the real question, which might be \u201CShould we reorganize functionally?\u201D\n        The great value of having a yes-no question is that (a) you know when you are finished with the research, and (b) you can make up the answer before you do any actual research, so as to be able to judge whether it is worth doing the research at all. Years ago, in New York, I did a course for S&H Green Stamps (trading stamps popular in the United States from the 1930s until the late 1980s). One of the attendees turned out to have been a very experienced research person, and it was he who explained this technique to me by telling a story. \u201CTornabuoni Watches, a chain of luxury retail stores in New York City, became worried in the early 1980s by the sudden arrival and huge success of Swatch Watches, Switzerland\u2019s attempt to tear back the analog market from the Japanese digital stranglehold, whose watches Tornabuoni sold. Tornabuoni was considering seriously whether it should enter that market, and asked my friend to \u201Cfind out how big the Swatch market is now and how big it will be 5 years?\u201D. \u201CSure,\u201D he said, I can tell you right now, \u201Cit will be about $20 million, give or take $1m.\u201D (this was in the 80s, when even $1 million was real money). \u201CWow,\u201D they said, \u201Cthat\u2019s terrific news.\u201D\n        \u201CWait,\u201D my friend said, \u201Cnow that you have that information, what are you going to do with it?\u201D \u201CWe\u2019ll start looking into selling Swatches,\u201D they said... Then my friend suggested that before they did so, they think about what would be involved. Tornabuoni\u2019s were luxury shops, located on only the best corners on Park, Madison, and Fifth Avenues. Were they going to sell out of the same shops, or would they have to set up others? Were they going to manufacture in the same factories, or would they have to set up new? Would they use the same sales people? The same advertising agency? The same marketing approach? In the end, the $20m looked like peanuts, and they gave up the idea.\n        So back to my example of \u201CShould we reorganize functionally?\u201D Suppose you make up the answer as Yes. Again, though, before you start the research, ask your requester why he wants that information? That will help you gather the data in a way that will make it easy to structure the key line points. Because you will be having this kind of structure.<br>\n        Q = Should we reorganize functionally?<br>\n        A = We should reorganize functionally<br>\n        You assume the answer, and the next question (which will be either either Why? or How?) will guide your research. If it disproves the answer, you change it.\n        ',
	        image: '4c2-d-5.png',
	        withPaper: true,
	        correctAnswer: '\n          <p>AMP is planning to enter the Life and Pensions market by purchasing and turning around a small provider available at low cost. Thynne is not doing well in the market, partly because it has not been accepted as a member of the body of Independent Financial Advisor panels.</p>\n          <p>Thynne\u2019s attempts at membership have been unsuccessful thus far because the IFA sees Thynne as an average performer with inadequate capital and an uncertain future. If AMP is to make a success of Thynne, therefore, it must convince the IFA to accept it as a member.</p>\n          <p>We believe that Thynne could be made attractive to the channel, but it would require considerable effort by AMP to addresses the internal problems of Thynne. AMP would also need to boost its own and Thynne\u2019s standing with the community.</p>\n          <ol>\n            <li>Restore faith in Thynne\u2019s financial stability and investment performance</li>\n            <li>Resolve Thynne\u2019s serious service and administrative problems</li>\n            <li>Address both Thynne\u2019s and AMP\u2019s image in the marketplace</li>\n            <li>Successfully cultivate IFA members to accept Thynne to their panels</li>\n          </ol>\n        '
	    }
	};

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(759);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./spottingSCQ.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./spottingSCQ.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit4b-2 .unit-header+.exercise{padding-bottom:150px}.unit4b-2 ol{font-weight:700}.unit4b-2 #exercise5 .simplest__structure-block:nth-child(5) .simplest__structure-box{border:none;height:1px}.unit4b-2 #diagram4b2-12 .simplest__structure-block .simplest__structure-task{color:#050e61!important}.unit4b-2 #diagram4b2-12 .simplest__structure-block .simplest__structure-box span,.unit4b-2 #diagram4b2-12 .simplest__structure-block .simplest__structure-box textarea{color:#050e61!important;background-color:transparent!important}.unit4b-2 .submit{position:static}.unit4b-2 .exercise-menu{list-style-type:upper-roman}.unit4b-2 .exercise-menu>li{font-family:Source Sans Pro,sans pro,Arial,serif;font-size:18px;line-height:28px;font-weight:400}.unit4b-2 .scq__note{display:flex;flex-direction:column}.unit4b-2 .scq__note div{display:flex}.unit4b-2 .scq__note div span:first-child{width:50%}.unit4b-2 .scq__note div span:last-child{width:50%;padding-left:3%}.unit4b-2 .scq__note div:last-child{margin-left:0!important}.unit4b-2 .scq__note-reverse{display:flex;flex-direction:column}.unit4b-2 .scq__note-reverse div{display:flex}.unit4b-2 .scq__note-reverse div span:first-child{width:35%}.unit4b-2 .scq__note-reverse div span:last-child{width:65%;padding-left:3%}.unit4b-2 .scq__note-reverse div:last-child{margin-left:0!important}.unit4b-2 .scq__note-reverse div:first-child span{font-weight:700}.unit4b-2 .documents-standard{display:flex;width:100%}.unit4b-2 .documents-standard span{flex:1;text-decoration:underline;text-align:center}.unit4b-2 .not-bold-list li{font-weight:400}.unit4b-2 .paper-header div{padding:0!important}.unit4b-2 .paper-header div:last-child{width:50%;align-items:flex-start}.unit4b-2 .paper-header div:last-child p{width:auto}.unit4b-2 .paper-header div p:first-child{margin-top:-17px;margin-bottom:12px}.unit4b-2 .horizontal-line{height:2px;padding:0!important;width:100%;background:#000}.unit4b-2 .documents-show-row{display:flex;width:100%;justify-content:space-around;margin-top:20px}.unit4b-2 .documents-show-row .documents-show-element{border:1px solid #000;padding:12px 15px;min-width:410px}.unit4b-2 .documents-show-row .documents-show-element__title{font-weight:700}.unit4b-2 .documents-show-row .documents-show-element__scq{margin-top:13px;display:flex;flex-direction:column}.unit4b-2 .documents-show-row .documents-show-element__scq span{max-width:360px}.unit4b-2 .complication-question{border:2px solid #000}.unit4b-2 .complication-question__row{width:100%;display:flex}.unit4b-2 .complication-question__row .complication-question__element{flex:1;border:1px solid #000;display:flex;flex-direction:column;padding:3px 5px}.unit4b-2 .complication-question__row .complication-question__element span{margin-left:21px}.unit4b-2 .complication-question__row .complication-question__element:last-child span,.unit4b-2 .complication-question__row .complication-question__element span:first-child{margin-left:0!important}.unit4b-2 .complication-question__title{text-transform:uppercase;font-weight:700;margin:0 auto}.unit4b-2 #exercise12 .diagram-box{border-color:#fff}.unit4b-2 #exercise12 .diagram-box p{text-align:left}.unit4b-2 #exercise12 .connector__line{stroke:#fff;stroke-width:3}.unit4b-2 #exercise12 .simplest__structure-box,.unit4b-2 #exercise12 .simplest__structure-task{color:#050e61}.unit4__subtitle{max-width:1085px;color:#fff;margin-top:10px;font-size:45px;letter-spacing:1.6px;line-height:50px;margin:0 auto;padding:27px 80px 20px}.unit4__subtitle span{color:#f0e527}", ""]);
	
	// exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _applyingSCQProcess = __webpack_require__(761);
	
	var _applyingSCQProcess2 = _interopRequireDefault(_applyingSCQProcess);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyingSCQProcessModule = _angular2.default.module('applyingSCQProcess', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.applyingSCQProcess', {
	    url: '/courses/4/4c1/applying-scq-process',
	    component: 'applyingSCQProcess',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('applyingSCQProcess', _applyingSCQProcess2.default).name;
	
	exports.default = applyingSCQProcessModule;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _applyingSCQProcess = __webpack_require__(762);
	
	var _applyingSCQProcess2 = _interopRequireDefault(_applyingSCQProcess);
	
	var _applyingSCQProcess3 = __webpack_require__(763);
	
	var _applyingSCQProcess4 = _interopRequireDefault(_applyingSCQProcess3);
	
	__webpack_require__(765);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyingSCQProcess = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _applyingSCQProcess2.default,
	  controller: _applyingSCQProcess4.default
	};
	
	exports.default = applyingSCQProcess;

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-4 unit4c\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>applying-scq-process.course-name</h1>\n  </course-header>\n\n  <section class=\"unit-wrapper\">\n    <h2 class=\"unit-section-title margin20\" translate>\n      applying-scq-process.unit-title\n    </h2>\n    <p class=\"intro intro-1\" translate>applying-scq-process.exercise-intro</p>\n  </section>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background margin-60\">\n    <span translate>applying-scq-process.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper exercise-wrapper \">\n      <p class=\"exercise-number\" translate>applying-scq-process.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>applying-scq-process.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>applying-scq-process.exercise-1.description</p>\n      <p class=\"exercise-title--small\">Original memo</p>\n      <div class=\"grey-paper grey-paper-first\" translate>applying-scq-process.exercise-1.demo</div>\n\n      <p class=\"exercise-description\">The problem with this memo is that it does not make entirely clear what specifically it wants the recipients to do.\n        <br>\n        What it does say specifically is:\n        <ul class=\"exercise-list\" style=\"margin-top: 0;\">\n          <li>- Send us a profile of a problem chain</li>\n          <li>- Here’s what a problem chain looks like</li>\n          <li>- Follow these criteria in identifying one</li>\n          <li>- Send me the name of the chain on the attached form by August 11</li>\n          <li>- Work with the bottler to gather performance data</li>\n          <li>- Send the data by August 15</li>\n        </ul>\n      </p>\n      <p class=\"exercise-description\">Now that you have all the facts, we simply\n        follow the process for working out a new structure for the memo to the Field Sales Force.</p>\n      <p class=\"exercise-description exercise-description-title\">Step 1 – Identify the subject of the document</p>\n      <p class=\"exercise-description\">We know we are writing to the Field Sales Force. We have a number of choices of subject here. Is it</p>\n      <ul class=\"exercise-list\">\n        <li>The Space Management Problem?</li>\n        <li>The Space Management Program?</li>\n        <li>The Field Sales Meeting?</li>\n      </ul>\n      <p class=\"exercise-description\">The author of the original document thought it was the Field Sales Meeting. To decide, take each one and say, “As you\n        know,...\" and then put the subject in a sentence, follow it through, and see what it would force you to be writing\n        about. For example,</p>\n\n      <div class=\"exercise-situation\">\n        <div>\n          <div class=\"exercise-situation-title\">Space Management Problem</div>\n        </div>\n        <div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Situation</b></div>\n            <div class=\"exercise-situation-col\">\n              As you know we have a space management problem, where our shelf space in a number of chains is below our share of market\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\">So what?</div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Complication</b></div>\n            <div class=\"exercise-situation-col\">\n              We have come up with a Space Management Program to deal with this problem\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Question</b></div>\n            <div class=\"exercise-situation-col\">\n              How do we implement the Program?\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <p class=\"exercise-description\">That can’t be it, because they already know how we will implement the Program: we will teach them how to give a presentation\n        on it. So perhaps the subject is the Space Management Program.</p>\n\n      <div class=\"divider\"></div>\n\n      <div class=\"exercise-situation\">\n        <div>\n          <div class=\"exercise-situation-title\">Space Management Program</div>\n        </div>\n        <div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Situation</b></div>\n            <div class=\"exercise-situation-col\">\n              As you know, we have developed a new Space Management Program to deal  with problem chains\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\">So what?</div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Complication</b></div>\n            <div class=\"exercise-situation-col\">\n              At the Field Sales Meeting, we will teach you how to give a presentation on it to problem chains in your area\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\">So what?</div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Question</b></div>\n            <div class=\"exercise-situation-col\">\n              ?\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <p class=\"exercise-description\">Oops, that won’t work either, as all we have is information for the Situation, not the Complication. So let’s try Field\n        Sales Meeting as the subject.</p>\n\n      <div class=\"divider\"></div>\n\n      <div class=\"exercise-situation\">\n        <div>\n          <div class=\"exercise-situation-title\">Space Management Program</div>\n        </div>\n        <div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Situation</b></div>\n            <div class=\"exercise-situation-col\">\n              As you know, at the Field Sales Meeting we plan to teach you how to give a  presentation on the new Space Management Program\n              to problem chains in your area\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\">So what?</div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Complication</b></div>\n            <div class=\"exercise-situation-col\">\n              Want to tailor your presentation to a problem chain in your region, but to do so we need some information from you in advance.\n            </div>\n          </div>\n          <div class=\"exercise-situation-row\">\n            <div class=\"exercise-situation-col\"><b>Question</b></div>\n            <div class=\"exercise-situation-col\">\n              (What do you want me to do?)\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"exercise-description piramid__title clearfix\">\n        <p>And then it is easy to structure this message around how they should go about collecting and transmitting the data.</p>\n        <img src=\"/assets/images/4c1-1.png\">\n      </div>\n\n      <p class=\"exercise-description\">\n        And once you have structured your pyramid, it is relatively easy to put it in writing, either in memo form, or as a presentation,\n        or as a speech. You want to make sure, however, that when you do put it in writing you make the Key Line points stand\n        out in the introduction. That ensures that your reader grasps your entire thinking in the first few seconds of reading,\n        because now he knows that nothing else you say will do anything but explain or defend the listed points.<br><br>\n      </p>\n\n      <p class=\"exercise-title--small\">Restructured as a memo</p>\n\n      <div class=\"grey-paper\">\n        <div>\n          <p class=\"grey__paper-title--small\">\n            Subject: August Field Sales Meeting\n          </p>\n          <p>\n            As you know, at the August Field Sales Meeting we plan to introduce you to the new Space Management Program,\n            designed to\n            make optimum use of shelf space in supermarkets whose beverage sections are less than potentially\n            profitable. We\n            also plan to teach you how to design and give a presentation on the new Program to supermarket chains in\n            your area.\n            To tailor the presentation to your region, we need you to send us some information in advance:\n          </p>\n          <ul class=\"grey-paper__list\">\n            <li>- Select a suitable problem chain in your area</li>\n            <li>- Work with the bottler to collect performance data on stores in the chain</li>\n            <li>- Summarize and return the data on the form attached by August 15</li>\n          </ul>\n\n          <p class=\"grey__paper-title\">SELECTING THE CHAIN</p>\n\n          <p>The chain you select should be both locally important and present a problem for us.</p>\n          <ul class=\"grey-paper__list\">\n            <li>- Locally important chains are in a market where the headquarters are located and where they are\n              important to the local\n              bottler. Some examples (which may or may not be problem chains) are:\n              <ol>\n                <li>White Stores in Knoxville, Tennessee (39 stores, 16.6% share of all commodity dollar volume)</li>\n                <li>Dahl’s Food Markets of Des Moines, Iowa, (9 stores, 29.1% of food store volume)</li>\n                <li>Rousauer’s of Spokane, Washington (29 stores, 20.1% of the ACV.)</li>\n              </ol>\n            </li>\n            <li>- A chain with a problem is one in which (a) our share of space is below our share of market, and (b)\n              the stores\n              are not completely vertically stacked. In addition, the bottler should be aware of the problem, and be\n              willing\n              to assist you in conducting the research on performance\n            </li>\n          </ul>\n\n          <p>When you have selected your problem chain, please send me the name on the enclosed form no later than July\n            11.</p>\n\n          <p class=\"grey__paper-title\">COLLECTING THE DATA</p>\n          <p>You will need to work with the bottler to gather the necessary data on performance:</p>\n          <ul class=\"grey-paper__list\">\n            <li>- Shelf space for each brand and size. The key bottler should be able to help you conduct a shelf space\n              survey\n              in 9-10 stores. If the chain has only a few stores (4-8), do all the stores.\n            </li>\n            <li>- Share of market. Conduct a share-of-market study in 3 or 4 stores. Also compile A. C. Nielsen data on\n              the major\n              market or franchise, if available, including share of market in detail plus distribution and out-of-stock.\n            </li>\n            <li>- Local bottler sales. Obtain the local bottler’s yearly sales to the chain.</li>\n          </ul>\n\n          <p class=\"grey__paper-title\">SUMMARIZING THE DATA</p>\n\n          <p>We need the data from each store organized by size, individual brand, total shelf space, and total share of\n            market\n            for the chain – laid out as shown on the attached spreadsheet. Please get your summary to us by August&nbsp;15.</p>\n\n          <div class=\"pater__divider\">\n            * * *\n          </div>\n\n          <p>As a result of our August meeting, you will each have a compelling story that, with the bottler’s approval,\n            can be\n            presented to the selected problem chain in your region. With this as a guide, you can continue working with\n            the\n            bottler to prepare similar presentations for other key local chains.</p>\n        </div>\n      </div>\n\n      <p style=\"margin-bottom: 30px;\" class=\"exercise-title--small\">Restructured as a slide presentation</p>\n\n<!--      <div class=\"slide__presentation\">-->\n\n<!--        <div ng-if=\"vm.step === 1\" class=\"slide__presentation-1\">-->\n<!--          <div class=\"objective\">-->\n<!--            <div class=\"objective__title\">-->\n<!--              <div class=\"objective__title-wrapper\">-->\n<!--                PRogram objective-->\n<!--              </div>-->\n<!--            </div>-->\n<!--            <div class=\"objective__message\">-->\n<!--              Help you make optimum use of the shelf space in the supermarkets-->\n<!--            </div>-->\n<!--          </div>-->\n<!--          <div class=\"objective\">-->\n<!--            <div class=\"objective__title\">-->\n<!--              <div class=\"objective__title-wrapper\">-->\n<!--                Meeting objective-->\n<!--              </div>-->\n<!--            </div>-->\n<!--            <div class=\"objective__message\">-->\n<!--              Teach you to design and give a presentation on the new program to Problem Chains in your area-->\n<!--            </div>-->\n<!--          </div>-->\n<!--          <div class=\"objective\">-->\n<!--            <div class=\"objective__title\">-->\n<!--              <div class=\"objective__title-wrapper\">-->\n<!--                What we need from you-->\n<!--              </div>-->\n<!--            </div>-->\n<!--            <div class=\"objective__message\">-->\n<!--              The profile of a problem Chain in your area-->\n<!--              <ul>-->\n<!--                <li>Now-July 1: Select a Problem Chain</li>-->\n<!--                <li>July 1-Aug 15: Collect performance data on stores in the chain</li>-->\n<!--                <li>Aug 15: Summarize and return the data</li>-->\n<!--              </ul>-->\n<!--            </div>-->\n<!--          </div>-->\n<!--        </div>-->\n<!--        <div ng-if=\"vm.step === 2\" class=\"slide__presentation-2\">-->\n<!--          <div class=\"slide__presentation-2__title\">We want to tailor our tried and tested presentation to your region</div>-->\n<!--          <Ul>-->\n<!--            <li>By July 1 select a Problem Chain in your area</li>-->\n<!--            <li>Work with the Bottler to collect performance data on stores in the chain</li>-->\n<!--            <li>Summarize and return the data by August 15</li>-->\n<!--          </Ul>-->\n<!--        </div>-->\n<!--        <div ng-if=\"vm.step === 3\" class=\"slide__presentation-3\">-->\n<!--          <div class=\"slide__presentation-3__title\">SELECT THE CHAIN</div>-->\n<!--          <p class=\"slide__presentation-3__text\">-->\n<!--            It should be both locally important and present a problem for us<br> <b>Locally Important</b>: Where the HQ is-->\n<!--            located/where they are<br> important to the bottler, for example:-->\n<!--          </p>-->\n<!--          <div class=\"slide__presentation-3__list-wrapper\">-->\n<!--            <ul>-->\n<!--              <li>White stores in Knoxville, IN (39 stores, 16.6% share of all commodity dollar volume)</li>-->\n<!--              <li>Dahl’s Food Markets of Des Moines, IA (9 stores, 29.1% of food store volume</li>-->\n<!--              <li>Rosanner’s of spokane, WA (29 stores, 20.1% of the ACV)</li>-->\n<!--            </ul>-->\n<!--          </div>-->\n<!--          <p class=\"slide__presentation-3__text\">-->\n<!--            <b>Imprtant to the Bottler</b>: A chain with a problem-->\n<!--          </p>-->\n<!--          <div class=\"slide__presentation-3__list-wrapper\">-->\n<!--            <ul>-->\n<!--              <li>Our share of space is below our share of market</li>-->\n<!--              <li>The stores re not completely vertically stacked </li>-->\n<!--              <li>The bottler is aware of the problem and willing to assist you in conducting the research</li>-->\n<!--            </ul>-->\n<!--          </div>-->\n<!--        </div>-->\n\n<!--      </div>-->\n\n<!--      <div class=\"slide__presentation-buttons\">-->\n<!--        <button ng-click=\"vm.prevStep()\" ng-disabled=\"vm.step === 1\" class=\"finish-button\"> < PREVIOUS</button>-->\n<!--        <button ng-click=\"vm.nextStep()\" ng-disabled=\"vm.step === 3\" class=\"finish-button\">NEXT SLIDE  ></button>-->\n<!--      </div>-->\n\n\n      <carousel-slider data=\"vm.carouselImages\"></carousel-slider>\n\n      <div style=\"margin-top: -280px; bottom: auto;\" class=\"simplest__structure-note\">\n        <div class=\"simplest__structure-text\">\n          <p>In general, when you transpose your pyramid to paper, you start at the top of the pyramid and work down each leg\n            in turn, making the point above before you state the ideas grouped below. You MUST do it that way because there\n            is a third constraint operating in people’s minds that I call Gestalt. “Gestalt” refers to a set theories of perception\n            that were developed in the 1920s. It says that people have an automatic tendency to impose order out of chaos.\n            Hence the tendency to see pictures in the constellations of the stars.</p>\n          <p>In other words, those things that appear together will always be presumed by the mind as belonging together. So that\n            in the box below, you don’t see 6 dots. . .</p>\n          <br><br>\n          <img src=\"/assets/images/applyingSCQProcess.png\">\n          <br>\n          <br>\n          <p>. . . you see two groups of three. You can’t help it.</p>\n          <br>\n          <br>\n          <p>By the same token, someone reading will naturally presume that those ideas that appear together belong together.\n            And if you don’t tell him in advance how they are meant to go together. That is, if you don’t give him the idea\n            at the top before you give him the ones below - one of three things is going to happen.</p>\n          <ul>\n            <li>He won’t understand what you’re trying to tell him</li>\n            <li>He’ll get the wrong idea of what you’re trying to tell him, or</li>\n            <li>He will take longer to understand what you’re trying to tell him.</li>\n          </ul>\n          <p>The way you make sure the reader sees the ideas as you mean him to see them is always to give him the idea above\n            before you give him the ideas grouped below. Because the point above creates the framework within which to judge\n            how the ideas that follow are meant to relate. </p>\n          <p>And finally, use headings to help people see where the major structural points are. In doing so, though, you want\n            to make sure you word headings at the same level of abstraction in the same grammatical form. And differ the form\n            by level of abstraction.</p>\n        </div>\n        <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n      </div>\n\n    </div>\n  </section>\n  <unit-finish\n    on-button-click=\"vm.onSectionFinish()\"\n    congratulation-message=\"'applying-scq-process.congratulation-message'\" finish-section=\"'applying-scq-process.finish-section'\"\n    final-description=\"'applying-scq-process.final-description'\"\n    next-course-button=\"'applying-scq-process.next-course-button'\"\n    dashboard-button=\"'applying-scq-process.dashboard-button'\"\n    next-course=\"'course.practiceInSeeing3'\">\n  </unit-finish>\n\n    <pyramid-builder section-title=\"{{ 'applying-scq-process.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _carouselImages = __webpack_require__(764);
	
	var _carouselImages2 = _interopRequireDefault(_carouselImages);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var applyingSCQProcess = function (_CourseController) {
	  applyingSCQProcess.$inject = ["helperService", "$sce", "courseService", "$scope"];
	  (0, _inherits3.default)(applyingSCQProcess, _CourseController);
	
	  function applyingSCQProcess(helperService, $sce, courseService, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, applyingSCQProcess);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (applyingSCQProcess.__proto__ || (0, _getPrototypeOf2.default)(applyingSCQProcess)).call(this, helperService, $sce, courseService, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce, courseService: courseService });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764715');
	    _this.step = 1;
	    _this.carouselImages = _carouselImages2.default;
	    _this.isUnit = true;
	    _this.introCounted = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(applyingSCQProcess, [{
	    key: "nextStep",
	    value: function nextStep() {
	      this.step++;
	    }
	  }, {
	    key: "prevStep",
	    value: function prevStep() {
	      this.step--;
	    }
	  }, {
	    key: "onSectionFinish",
	    value: function onSectionFinish() {
	      if (this.courseData.is_completed) {
	        return;
	      }
	      var params = {
	        statisticableId: this.courseData.intro_id,
	        statisticableType: 'UnitIntro',
	        secondsSpent: Math.floor((Date.now() - this.unitStart) / 1000),
	        completed: true,
	        attempts: 0,
	        hintsUsed: 0,
	        rightAnswers: 0
	      };
	      this.courseService.sendUserStatistic(params);
	      this.courseData.is_completed = true;
	    }
	  }]);
	  return applyingSCQProcess;
	}(_course2.default);
	
	exports.default = applyingSCQProcess;

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['/assets/carousel-images/4c1_slide_1.png', '/assets/carousel-images/4c1_slide_2.png', '/assets/carousel-images/4c1_slide_3.png'];

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(766);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./applyingSCQProcess.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./applyingSCQProcess.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit4c #slider{width:76%!important}.unit4c .bordered{border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4c .grey-paper__list>li{text-indent:-10px;line-height:28px}.unit4c .grey-paper__list ol>li{text-indent:0}.unit4c .grey__paper-title{font-size:18px}.unit4c .exercise-list{font-family:Source Sans Pro,Arial,\"serif\";list-style:none}.unit4c .exercise-description-title{font-weight:700;padding:15px 0}.unit4c .simplest__structure-text li,.unit4c .simplest__structure-text p,.unit4c .simplest__structure-text ul{font-family:Times New Roman}.unit4c .intro .structure img{margin:20px 0}.unit4c .classic-structure p{margin-bottom:10px;font-weight:700}.unit4c .classic-structure span{display:inline-block;font-weight:700;float:left}.unit4c .classic-structure span:nth-child(odd){width:50%;margin-left:10%}.unit4c .classic-structure span:nth-child(2n){width:40%}.unit4c .classic-structure span:last-child{margin-bottom:30px}.unit4c .grey-paper-first:after{bottom:-99px!important}.unit4c .grey-paper{background-image:url(/assets/images/grey-paper.png);padding:40px 60px}.unit4c .grey-paper h5{text-align:center;font-size:24px}.unit4c .grey-paper:before{content:\"\";position:absolute;top:28px;right:10px;left:auto;width:51px;height:46%;background:#000;box-shadow:0 0 20px 10px rgba(0,0,0,.6);opacity:.6;transform:skew(-2deg);z-index:-1}.unit4c .grey-paper:after{content:\"\";position:absolute;left:49px;top:auto;bottom:-68px;width:94.6%;height:100px;background:url(\"/assets/images/paper-shadow-bottom.png\") no-repeat;z-index:1;background-size:contain;right:auto;box-shadow:none;transform:none}.unit4c .questions{width:65%;margin:0 auto;font-weight:700}.unit4c .intro-2 ul{margin:0}.unit4c .intro-2 p:last-child{border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4c .patterns p{font-size:48px;line-height:55px;margin-bottom:20px;color:#050e61;font-family:Nexa-Bold,sans pro,\"serif\"}.unit4c .patterns table{width:100%;background-color:#fff;border-collapse:collapse;border:3px solid #000;border-radius:5px;color:#000}.unit4c .patterns table td,.unit4c .patterns table th{width:25%;vertical-align:top;border:1px solid #000;padding:10px;text-align:left}.unit4c .patterns table td{height:200px}.unit4c .patterns table th{height:60px}.unit4c .patterns table thead{background-color:#fff}.slide__presentation{background:#fcf390;border:2px solid #1e2977;padding:30px;border-radius:15px;height:640px;display:flex;align-items:center}.slide__presentation-1{display:flex;flex-direction:column}.slide__presentation-1 .objective{display:flex;justify-content:space-between}.slide__presentation-1 .objective .objective__title{flex:0 0 70%}.slide__presentation-1 .objective .objective__message{flex:0 0 30%;font-family:Nexa-light,sans pro,\"serif\"}.slide__presentation-1 .objective .objective__title-wrapper{font-size:40px;color:#1e2977;background:#fff;width:400px;height:130px;margin-bottom:40px;display:flex;align-items:center;padding-left:10px;text-transform:uppercase;line-height:40px;position:relative;border:4px solid #1e2977;border-right:0}.slide__presentation-1 .objective .objective__title-wrapper:after,.slide__presentation-1 .objective .objective__title-wrapper:before{left:100%;top:50%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.slide__presentation-1 .objective .objective__title-wrapper:after{border-left-color:#fff;border-width:60px;margin-top:-60px}.slide__presentation-1 .objective .objective__title-wrapper:before{border-color:rgba(194,225,245,0);border-left-color:#1e2977;border-width:65px;margin-top:-65px}.slide__presentation-buttons{display:flex;text-align:center;margin:30px 0;justify-content:center}.slide__presentation-buttons button{cursor:pointer;outline:none;border-radius:7px;padding:5px 10px 1px!important;margin:0 10px}.slide__presentation-buttons .finish-button:disabled{background-color:#ededed}.slide__presentation-2{padding:100px;line-height:40px}.slide__presentation-2 .slide__presentation-2__title{font-size:38px;color:#1e2977}.slide__presentation-2 ul{color:#1e2977;font-size:28px}.slide__presentation-3{color:#1e2977;padding:40px}.slide__presentation-3 .slide__presentation-3__title{font-size:40px}.slide__presentation-3 .slide__presentation-3__list-wrapper{color:#1e2977;background:#fff;border:3px solid #1e2977;font-family:Nexa-light,sans pro,\"serif\"}.slide__presentation-3 .slide__presentation-3__list-wrapper li{margin:10px 0;font-size:20px}.slide__presentation-3 .slide__presentation-3__text{margin:20px 0;font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _practiceInSeeing = __webpack_require__(768);
	
	var _practiceInSeeing2 = _interopRequireDefault(_practiceInSeeing);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceInSeeing3Module = _angular2.default.module('practiceInSeeing3', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.practiceInSeeing3', {
	    url: '/courses/4/4c2/optional-exercises-in-applying-scq',
	    component: 'practiceInSeeing3',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('practiceInSeeing3', _practiceInSeeing2.default).name;
	
	exports.default = practiceInSeeing3Module;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _practiceInSeeing = __webpack_require__(769);
	
	var _practiceInSeeing2 = _interopRequireDefault(_practiceInSeeing);
	
	var _practiceInSeeing3 = __webpack_require__(770);
	
	var _practiceInSeeing4 = _interopRequireDefault(_practiceInSeeing3);
	
	__webpack_require__(775);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceInSeeing3Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _practiceInSeeing2.default,
	  controller: _practiceInSeeing4.default
	};
	
	exports.default = practiceInSeeing3Component;

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-4 unit4a-3\">\n\n  <course-header>\n    <h1 class=\"unit-name\" translate>practice-in-seeing-3.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>practice-in-seeing-3.unit-section-title</span>\n  </h2>\n\n  <section class=\"exercise\">\n    <div class=\"unit-wrapper\">\n      <div class=\"intro\">\n        <p translate>practice-in-seeing-3.exercise-intro</p>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">practice-in-seeing-3.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">practice-in-seeing-3.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">practice-in-seeing-3.menu-list.exercise-3</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">practice-in-seeing-3.menu-list.exercise-4</a></li>\n        </ol>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\" id=\"exercise-1\">\n      <p class=\"exercise-number\" translate>practice-in-seeing-3.exercise-1.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing-3.exercise-1.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing-3.exercise-1.description</p>\n      <br/>\n      <div class=\"show-diagram\">\n        <div class=\"diagram-box\">\n          <p>Implement a system for ensuring your suppliers deliver at the appropriate cost and quality for our\n            needs</p>\n        </div>\n        <div class=\"connector\">\n          <svg>\n            <line x1=\"499\" y1=\"-1\" x2=\"160\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"387\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"614\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"840\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n          </svg>\n        </div>\n        <div class=\"diagram-slots\">\n          <div class=\"diagram-box\">\n            <p>Identify the qualified suppliers available to you</p>\n          </div>\n          <div class=\"diagram-box\">\n            <p>Determine means of choosing between them</p>\n          </div>\n          <div class=\"diagram-box\">\n            <p>Evaluate perfomance against clear criteria</p>\n          </div>\n          <div class=\"diagram-box\">\n            <p>Periodically review need for new suppliers</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise1\" on-finish=\"vm.sendStatistic($event)\"finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper exercise-wrapper_topoffset\" id=\"exercise-2\">\n      <p class=\"exercise-number\" translate>practice-in-seeing-3.exercise-2.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing-3.exercise-2.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing-3.exercise-2.description</p>\n      <div class=\"memo-paper--yelow\">\n        <div class=\"note__table\">\n          <div class=\"note__table-title\">\n            Data Center Relocation issues\n          </div>\n          <div class=\"unit__table unit__table-1-2\">\n            <div class=\"unit__table-row unit__table-sub__header\">\n              <div></div>\n              <div>DATA CENTER RELOCATION ISSUES</div>\n            </div>\n            <div class=\"unit__table-row unit__table-header\">\n              <div>ASSUMPTION</div>\n              <div>NEED TO THINK ABOUT</div>\n            </div>\n            <div class=\"unit__table-row\">\n              <div>\n                New York City will be as easy to operate in\n              </div>\n              <div>\n                <ul>\n                  <li>Shut downs of equipment more probable</li>\n                  <li>Employees live in NJ, can’t respond as quickly to problems</li>\n                  <li>Labor relations not so good in New York</li>\n                  <li>Other companies in New York are moving away</li>\n                  <li>Disaster Recovery scenario would have to encompass the entire building, not just the DC unit</li>\n                  <li>Risk of business loss</li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"unit__table-row\">\n              <div>No extra staffing costs</div>\n              <div>\n                <ul>\n                  <li>Higher turnover will adversely affect operations</li>\n                  <li>Replacements will be difficult to find</li>\n                  <li>Will take months to train</li>\n                  <li>Fewer staff, so projects will take longer</li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"unit__table-row\">\n              <div>No extra equipment costs</div>\n              <div>\n                <ul>\n                  <li>Less raised floor space requires server virtualization</li>\n                  <li>Reduced space raises environment (cooling) issues</li>\n                  <li>Most servers near end of warranties, not worth reinstalling, must be  replaced with servers that meet\n                    new energy/heat/space reqs.</li>\n                  <li>Urban site more vulnerable to disaster than rural, must upgrade Bank’s  disaster recovery program</li>\n                  <li>All DC repair work done on week ends, will be more costly</li>\n                  <li>Need to compensate employees for reverse commute</li>\n                </ul>\n              </div>\n            </div>\n            <div class=\"unit__table-row\">\n              <div>DC can’t accommodate FCB’s planned growth</div>\n              <div>\n                <ul>\n                  <li>The DC can accommodate substantial growth without any retrofit</li>\n                  <li>DC could easily become The Global Facility and accommodate many  additional needs</li>\n                  <li>DC could be configured to handle disaster recovery plan for NY </li>\n                </ul>\n              </div>\n            </div>\n          </div>\n        </div>\n        <!-- <div translate>practice-in-seeing-3.exercise-2.note</div> -->\n      </div>\n      <p class=\"exercise-description\" translate>practice-in-seeing-3.exercise-2.description-2</p>\n      <br/>\n      <div class=\"show-diagram\">\n        <div class=\"diagram-box\">\n          <p>A review of these assumptions suggests that moving from Princeton may be a mistake</p>\n        </div>\n        <div class=\"connector\">\n          <svg>\n            <line x1=\"499\" y1=\"-1\" x2=\"275\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"499\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"725\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n          </svg>\n        </div>\n        <div class=\"diagram-slots\">\n          <div class=\"diagram-box\">\n            <p>New York is a riskier environment than Princeton to do business in</p>\n          </div>\n          <div class=\"diagram-box\">\n            <p>Cost of the move is likely to be much greater than stated</p>\n          </div>\n          <div class=\"diagram-box\">\n            <p>Princeton can easily accommodate substantial growth without retrofit costs</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise2\" on-finish=\"vm.sendStatistic($event)\"finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper exercise-wrapper_topoffset\" id=\"exercise-3\">\n      <p class=\"exercise-number\" translate>practice-in-seeing-3.exercise-3.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing-3.exercise-3.title</p>\n      <p class=\"exercise-description\">\n        <div class=\"memo-paper\">\n          <div translate>practice-in-seeing-3.exercise-3.description</div>\n        </div>\n      </p>\n      <br/>\n      <div class=\"show-diagram\">\n        <div class=\"diagram-box text-center\">\n          <p>Do both</p>\n        </div>\n        <div class=\"connector\">\n          <svg>\n            <line x1=\"499\" y1=\"-1\" x2=\"275\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n            <line x1=\"499\" y1=\"-1\" x2=\"725\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n          </svg>\n        </div>\n        <div class=\"diagram-slots\">\n          <div class=\"show-diagram\">\n            <div class=\"diagram-box\">\n              <p>Capitalize the cost of preparing the land</p>\n            </div>\n            <div class=\"connector\">\n              <svg>\n                <line x1=\"146\" y1=\"-1\" x2=\"35\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n                <line x1=\"146\" y1=\"-1\" x2=\"255\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n              </svg>\n            </div>\n            <div class=\"diagram-slots\">\n              <div class=\"diagram-box\">\n                <p>Cost is mandatory</p>\n              </div>\n              <div class=\"diagram-box\">\n                <p>Property expected to sell at a loss</p>\n              </div>\n            </div>\n          </div>\n          <div class=\"show-diagram\">\n            <div class=\"diagram-box\">\n              <p>Expense the cost of preparing the building</p>\n            </div>\n            <div class=\"connector\">\n              <svg>\n                <line x1=\"146\" y1=\"-1\" x2=\"35\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n                <line x1=\"146\" y1=\"-1\" x2=\"255\" y2=\"101\" style=\"stroke: rgb(8, 8, 8);stroke-width:3;\"/>\n              </svg>\n            </div>\n            <div class=\"diagram-slots\">\n              <div class=\"diagram-box\">\n                <p>Meets criteria for capitalizing a cost</p>\n              </div>\n              <div class=\"diagram-box\">\n                <p>Large enough to make a material difference</p>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise3\" on-finish=\"vm.sendStatistic($event)\"finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper exercise-wrapper_topoffset\" id=\"exercise-4\">\n      <p class=\"exercise-number\" translate>practice-in-seeing-3.exercise-4.number</p>\n      <p class=\"exercise-title\" translate>practice-in-seeing-3.exercise-4.title</p>\n      <p class=\"exercise-description\" translate>practice-in-seeing-3.exercise-4.description</p>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise4\" on-finish=\"vm.sendStatistic($event)\"finished-exercises=\"vm.isCompleted\" user-exercise-answers=\"vm.exerciseUserAnswers\"></scq-diagram>\n      </div>\n    </div>\n\n    <div class=\"unit-wrapper exercise-wrapper\">\n      <p class=\"exercise-description\" translate>practice-in-seeing-3.exercise-4.description-2</p>\n    </div>\n\n  </section>\n\n  <unit-finish\n    on-button-click=\"vm.onSectionFinish()\"\n    congratulation-message=\"'practice-in-seeing-3.congratulation-message'\" finish-section=\"'practice-in-seeing-3.finish-section'\"\n    final-description=\"'practice-in-seeing-3.final-description'\"\n    next-course-button=\"'practice-in-seeing-3.next-course-button'\"\n    dashboard-button=\"'practice-in-seeing-3.dashboard-button'\"\n    next-course=\"'course.defineProblem'\">\n  </unit-finish>\n\n  <pyramid-builder section-title=\"{{ 'practice-in-seeing-3.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(771);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(772);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(773);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(774);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PracticeInSeeing3ArgumentsController = function (_CourseController) {
	  PracticeInSeeing3ArgumentsController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(PracticeInSeeing3ArgumentsController, _CourseController);
	
	  function PracticeInSeeing3ArgumentsController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PracticeInSeeing3ArgumentsController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PracticeInSeeing3ArgumentsController.__proto__ || (0, _getPrototypeOf2.default)(PracticeInSeeing3ArgumentsController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322764720');
	    // this.helperService.initIntercom();
	
	    var lang = 'en';
	
	    _this.exercise1 = _exercise2.default[lang];
	    _this.exercise2 = _exercise4.default[lang];
	    _this.exercise3 = _exercise6.default[lang];
	    _this.exercise4 = _exercise8.default[lang];
	    _this.isUnit = true;
	    _this.exerciseIdsStart = 'diagram4c2-';
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  return PracticeInSeeing3ArgumentsController;
	}(_course2.default);
	
	exports.default = PracticeInSeeing3ArgumentsController;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4c2-1',
	        blocks: [{
	            task: 'S = Orlando’s decentralized purchasing process spends $600 million/year on products and services. No formal supplier evaluation/qualification process.',
	            title: "S = ",
	            answer: 'We do X in Y way now',
	            modelName: 's'
	        }, {
	            task: 'C = Risk we may be paying more, getting less good service.',
	            title: "C = ",
	            answer: 'Have a problem',
	            modelName: 'c'
	        }, {
	            task: 'Q = (What do about it?)',
	            title: "Q = What should we do?",
	            answer: ' ',
	            disableEdit: true
	        }],
	        title: 'Type in roughly what the Situation and Complication should say',
	        note: 'This is a classic structure, used whenever you write to tell someone how to do something properly (as opposed to how to do it at all).  You always begin by reminding them how they do it now.'
	    }
	};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4c2-2',
	        blocks: [{
	            task: 'S = Bank planning to move Data Center to NY',
	            title: "S = ",
	            answer: 'Planning to do X ',
	            modelName: 's'
	        }, {
	            task: 'C = Move predicated on three assumptions',
	            title: "C = ",
	            answer: 'Based on belief in Y ',
	            modelName: 'c'
	        }, {
	            task: 'Q = (Are these assumptions correct?)',
	            title: "Q = Is belief in Y sound?",
	            answer: ' ',
	            disableEdit: true
	        }],
	        title: 'Type in roughly what the Situation and Complication should say'
	    }
	};

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4c2-3',
	        blocks: [{
	            task: 'S = Want to sell 40 acres of property in Oklahoma, valued at $2.66k. But first must clean up the land and buldings, contaminated with abstestos. Cost is $350,000',
	            title: "S = ",
	            answer: 'Need to do X',
	            modelName: 's'
	        }, {
	            task: 'C = The $350,000 can be either expensed or capitalized ',
	            title: "C = ",
	            answer: 'Have two choices of how',
	            modelName: 'c'
	        }, {
	            task: 'Q = Which?',
	            title: "Q = Which",
	            answer: ' ',
	            disableEdit: true
	        }],
	        title: 'Type in roughly what the Situation and Complication should say',
	        note: '\n        Whenever you have alternatives, they always go in the Complication, and the Question is always Which? You never bring up alternatives simply to reject them.\n        They must always be known in advance by the reader (or accepted as true), and the purpose of the document is to present the argument for the alternative chosen.\n        This particular document argues for doing both alternatives. The more likely situation is that you will be comparing alternatives, selecting one, and arguing why that alternative is better than others.\n        '
	    }
	};

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'diagram4c2-4',
	        blocks: [{
	            task: 'S = Domestic Bank’s strategy is to build an integrated system to support customer service, cut cots, provide timely management information.',
	            title: "S = ",
	            answer: 'Want to do X',
	            modelName: 's'
	        }, {
	            task: 'C = Can go about integration in two ways: develop a single, technically integrated system, or use best of breed products tied together in a cohesive manner.',
	            title: "C = ",
	            answer: 'Have alternative ways to do it',
	            modelName: 'c'
	        }, {
	            task: 'Q = (Which will we use?)',
	            title: "Q = Which is best?",
	            answer: ' ',
	            disableEdit: true
	        }],
	        title: 'Type in roughly what the Situation and Complication should say',
	        note: 'You will note that the original document is structured around the analysis the writer conducted, going through the advantages and disadvantages of each approach.  You never want to show lists of advantages and disadvantages (or pros and cons) in your document.  You want to use those frameworks in doing your analysis, but you want to present only the results of the analysis to your reader, as we’ve done here.  There are generally three ways you can show the results, depending your data.'
	    }
	};

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(776);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceInSeeing3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceInSeeing3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit4a-3 .intro ol{font-weight:700;border-bottom:3px solid #fcf390;padding-bottom:45px}.unit4a-3 .unit-header+.exercise{padding-bottom:150px}.unit4a-3 .exercise .exercise-wrapper.exercise-wrapper_topoffset{padding-top:120px}.unit4a-3 .simplest__structure-block{color:#050e61}.unit4a-3 .scq-diagram-dnd-wrapper .submit{position:static}.note__table{color:#000}.note__table-title{font-size:34px;color:#000}", ""]);
	
	// exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _defineProblem = __webpack_require__(778);
	
	var _defineProblem2 = _interopRequireDefault(_defineProblem);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defineProblemModule = _angular2.default.module('defineProblem', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.defineProblem', {
	    url: '/courses/5/5a/define-a-problem',
	    component: 'defineProblem',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('defineProblem', _defineProblem2.default).name;
	
	exports.default = defineProblemModule;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProblem = __webpack_require__(779);
	
	var _defineProblem2 = _interopRequireDefault(_defineProblem);
	
	var _defineProblem3 = __webpack_require__(780);
	
	var _defineProblem4 = _interopRequireDefault(_defineProblem3);
	
	__webpack_require__(788);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defineProblemComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _defineProblem2.default,
	  controller: _defineProblem4.default
	};
	
	exports.default = defineProblemComponent;

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-5 unit5a\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>define-a-problem.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>define-a-problem.unit-section-title</span>\n  </h2>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>define-a-problem.intro</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">define-a-problem.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">define-a-problem.menu-list.exercise-2</a></li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-1\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-topic\" translate>define-a-problem.exercise-description</div>\n      </plain-text>\n      <plain-text>\n        <div style=\"margin: 0;\" class=\"exercise-title\" translate>define-a-problem.exercise-1.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>define-a-problem.exercise-1.text-1</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\">\n          <div translate>define-a-problem.exercise-1.blue-paper</div>\n        </div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>define-a-problem.exercise-1.text-2</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-3\" translate>define-a-problem.exercise-1.text-3</div>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <step-diagram2 data=\"vm.exercise1\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise2', 'exercise-2', $event)\" completed=\"vm.isCompleted['1']\"></step-diagram2>\n      </div>\n    </div>\n\n    <div class=\"intro\">\n      <div ng-if=\"vm.showAdditionalBlock1\" class=\"additional-block-text unit-wrapper\">\n        <plain-text>\n          <div class=\"exercise-text-1\" style=\"margin: 0;\" translate>define-a-problem.exercise-1.text-4</div>\n        </plain-text>\n      </div>\n    </div>\n\n  </section>\n\n  <section class=\"intro intro-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>define-a-problem.intro-2</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-2\">\n    <div class=\"unit-wrapper\" style=\"padding-bottom: 0;\">\n      <plain-text>\n        <div class=\"exercise-topic\" style=\"margin-bottom: 20px;\" translate>define-a-problem.exercise-description</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-title\" style=\"margin-bottom: 20px;\" translate>define-a-problem.exercise-2.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>define-a-problem.exercise-2.text-1</div>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <step-diagram2 data=\"vm.exercise2\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise3', 'exercise-3', $event)\" completed=\"vm.isCompleted['2']\"></step-diagram2>\n      </div>\n    </div>\n\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-3\">\n    <div class=\"unit-wrapper\" style=\"margin-top: -25px; padding-top: 50px;\">\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>define-a-problem.exercise-2.text-2</div>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <div class=\"unit-wrapper\">\n        <scq-diagram data=\"vm.exercise3\"></scq-diagram>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'define-a-problem.congratulation-message'\" finish-section=\"'define-a-problem.finish-section'\"\n      final-description=\"'define-a-problem.final-description'\" next-course-button=\"'define-a-problem.next-course-button'\"\n      dashboard-button=\"'define-a-problem.dashboard-button'\"\n      next-course=\"'course.practiceDefiningProblem'\">\n    </unit-finish>\n  </section>\n\n  <pyramid-builder ng-if=\"!vm.isActivePyramidBuilderDemo\"\n                   pyramid-data=\"vm.deafultPyramidData\"\n                   section-title=\"{{ 'define-a-problem.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.isActivePyramidBuilderDemo\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\"\n                   on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'define-a-problem.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(785);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(786);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(787);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefineProblemController = function (_CourseController) {
	  DefineProblemController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(DefineProblemController, _CourseController);
	
	  function DefineProblemController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, DefineProblemController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (DefineProblemController.__proto__ || (0, _getPrototypeOf2.default)(DefineProblemController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322793936');
	    var lang = 'en';
	    _this.exercise1 = _exercise2.default[lang];
	    _this.exercise2 = _exercise4.default[lang];
	    _this.exercise3 = _exercise6.default[lang];
	
	    _this.deafultPyramidData = {
	      scheme: {
	        model: {
	          textarea: ''
	        },
	        children: [{}, {}, {}]
	      },
	      scq: {
	        s: '',
	        c: '',
	        q: ''
	      }
	    };
	    _this.isUnit = true;
	    _this.isCompleted = {};
	    _this.complexExercises = {
	      1: {
	        attempts: 0,
	        hintsUsed: 0,
	        rightAnswers: 0
	      },
	      2: {
	        attempts: 0,
	        hintsUsed: 0,
	        rightAnswers: 0
	      }
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(DefineProblemController, [{
	    key: 'courseDataReceived',
	    value: function courseDataReceived() {
	      (0, _get3.default)(DefineProblemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DefineProblemController.prototype), 'courseDataReceived', this).call(this);
	      if (this.isCompleted['1']) {
	        this.showAdditionalBlock1 = true;
	      }
	      if (this.isCompleted['2']) {
	        this.defineScqAnswers('exercise3', {
	          howToDefineAProblem: {
	            scq: {
	              s: 'Unable to finish Rationalization Program in time allotted',
	              c: 'Clearly must be cut, but want to achieve maximum savings possible',
	              q: 'How cut?'
	            }
	          }
	        }, 'howToDefineAProblem', true);
	      }
	      this.$scope.$apply();
	    }
	  }, {
	    key: 'onSubmitScqDiagramDndFramework',
	    value: function onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
	      if (this.isCompleted['1'] && nextExercise === 'exercise2' || nextExercise === 'exercise3' && this.isCompleted['2']) {
	        return;
	      }
	      (0, _get3.default)(DefineProblemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DefineProblemController.prototype), 'onSubmitScqDiagramDndFramework', this).call(this, nextExercise, nextExerciseLink, pyramidData);
	    }
	  }, {
	    key: 'onClosePyramidBuilder',
	    value: function onClosePyramidBuilder(event) {
	      if (!this.isActivePyramidBuilderDemo) return;
	      if (this.nextExercise === 'exercise3') {
	        this.onFinishExercise('2');
	        (0, _get3.default)(DefineProblemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(DefineProblemController.prototype), 'onClosePyramidBuilder', this).call(this, event);
	      } else {
	        this.isActivePyramidBuilderDemo = false;
	        if (this.nextExercise !== 'exercise2') {
	          this.showNextExercise();
	        } else {
	          this.showAdditionalBlock1 = true;
	          this.onFinishExercise('1');
	        }
	      }
	    }
	  }]);
	  return DefineProblemController;
	}(_course2.default);
	
	exports.default = DefineProblemController;

/***/ }),
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise_1',
	    diagram: '\n          <div class="two-columns angular-ngAnimate 5a-exercise-1">\n            <div ng-show="vm.activeIndex <= 1" class="first-step-text">\n             <p style="margin:7px 0;" class="yellow-text">The first thing you need to do...</p>\n            </div>\n            <div>\n              <div ng-show="vm.activeIndex >= 1" style="width: 440px;" class="step__diagram-content angular-ngAnimate" ng-style="{\'background-image\': vm.activeIndex === 1 ? \'url(\\\'/assets/images/5a-1-step-1-bg.png\\\')\' : \'\'}">\n                <div class="step__diagram-title">\n                  <p>The first thing you need to do is identify the arena within which the problem is taking place.</p>\n                  <p style="margin:7px 0;" class="yellow-text">Visualize the Situation</p>\n                </div>\n                <div style="padding: 0;" class="step__diagram-content small-white-text__list">\n                  <p class="step__diagram-content-header" style="margin-bottom: 10px;">SITUATION (OPENING SCENE)</p>\n                  <div class="step__diagram-step-1-table">\n                    <img style="height: 180px; object-fit: contain;" src="/assets/images/5a-step1-diagram.png" alt="Original Structure">\n                  </div>\n                  <p style="margin-bottom: 10px; margin-top: 10px;" class="yellow-text">Let\u2019s review what you know that is going on now in the company.</p>\n                  <p class="small-white-text">We know the company\u2019s name</p>\n                  <p class="small-white-text">That it is large, with many divisions</p>\n                  <p class="small-white-text">We know how much it spends annually on procurement ($600m)</p>\n                  <p class="small-white-text">Amd that they purchase from hundreds of suppliers</p>\n                  <p class="small-white-text">We know there is no centralized control over who buys what from whom</p>\n                  <p class="small-white-text">And that the VP believes that supppliers are too much in control</p>\n                  <p class="small-white-text">He also thinks Orlando may be paying too much, and getting poor service</p>\n                  <p class="small-white-text">He naturally wants to pay fair price and receive preferential service</p>\n                </div>\n               </div>\n            </div>\n\n            <div style="padding-top: 66px;" class="second-column">\n              <div style="display: flex">\n                <div ng-show="vm.activeIndex >= 2" class="angular-ngAnimate" style="padding: 7px 0 0 7px" ng-style="{\'background-image\': vm.activeIndex <= 2 ? \'url(\\\'/assets/images/5a-1-step-2-bg.png\\\')\' : \'\'}">\n                  <div class="step__diagram-title">\n                    <p style="margin-top: 6px; margin-left: 10px;" class="yellow-text">State what we don\u2019t like about the Situation (R1)</p>\n                  </div>\n                  <div class="step__diagram-content" style=" align-items: center; padding: 15px 10px;">\n                    <p class="step__diagram-content-header">R1</p>\n                    <div class="step-3__box">\n                      <p class="step-3__box-text">Risk that paying more, getting inferior service</p>\n                    </div>\n                  </div>\n                </div>\n                <div ng-show="vm.activeIndex >= 3" style="background-size: cover; padding: 7px 0 0 7px;" class="angular-ngAnimate" ng-style="{\'background-image\': vm.activeIndex <= 3 ? \'url(\\\'/assets/images/5a-1-step-3-bg.png\\\')\' : \'\'}">\n                  <div class="step__diagram-title">\n                    <p style="margin-top: 6px; margin-left: 10px;" class="yellow-text">State what we want instead (R2)</p>\n                  </div>\n                  <div class="step__diagram-content"\n                       style="align-items: center; padding: 15px 10px;">\n                    <p class="step__diagram-content-header">R2</p>\n                    <div class="step-3__box">\n                      <p class="step-3__box-text">Highest quality products and services at lowest reasonable price</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show="vm.activeIndex >= 4" class="angular-ngAnimate" style="display: flex; flex-direction: column; align-items: center;">\n                <svg height="150" width="300" style="margin-top: -18px; margin-bottom: -32px;">\n                  <line x1="25" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>\n                  <line x1="280" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>\n                </svg>\n                <div class="step__diagram-content" style="background-image: url(\'/assets/images/5a-1-step-4-bg.png\'); align-items: center; background-size: cover; padding: 15px 10px; margin-top: 28px">\n                  <p class="step__diagram-content-header">SOLUTION</p>\n                  <div class="step-3__box" style="width: 217px">\n                    <p class="step-3__box-text">Make sure company sources products and services only from qualified suppliers</p>\n                  </div>\n                  <div class="step__diagram-title">\n                    <p style="max-width: initial; margin-top: 20px;" class="yellow-text">State how you will get from R1 to R2 (if you know it)</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>',
	    steps: 4,
	    startStep: 0,
	    // note: 'Step 6 is not applicable here',
	    pyramidData: {
	      exerciseNumber: 1,
	      scheme: 'empty',
	      scq: {
	        s: 'We do X in Y way now',
	        c: 'Have a problem',
	        q: 'What should we do?'
	      },
	      instruction: 'Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write. To do this please open the Minto Framework button below-right, as this is an example, we have pre-filled the SCQ boxes with the school solution for you this time.',
	      tourData: {
	        steps: [{
	          element: 'pyramid-step-1',
	          text: 'Adjust Scale and Opacity depend on your needs'
	        }, {
	          element: 'pyramid-step-2',
	          text: 'Use Scroll to navigate thru Exercise layer',
	          direction: 'top'
	        }, {
	          element: 'pyramid-step-3',
	          text: 'Fill in the text for SCQ',
	          direction: 'bottom'
	        }, {
	          element: 'pyramid-step-4',
	          text: 'After you\'re done, press Submit button to continue the exercise',
	          direction: 'top'
	        }]
	      }
	    }
	  }
	};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise_2',
	    diagram: '\n          <div class="two-columns angular-ngAnimate">\n            <div>\n              <div ng-show="vm.activeIndex >= 1" style="width: 440px;" class="step__diagram-content angular-ngAnimate" ng-style="{\'background-image\': vm.activeIndex === 1 ? \'url(\\\'/assets/images/5a-1-step-1-bg.png\\\')\' : \'\'}">\n                <div class="step__diagram-title">\n                  <p>The first thing you need to do is identify the arena within which the problem is taking place.</p>\n                  <p class="yellow-text">Visualize the Situation</p>\n                </div>\n                <div style="padding: 0;" class="step__diagram-content">\n                  <p class="step__diagram-content-header" style="margin-bottom: 35px;">SITUATION (OPENING SCENE)</p>\n                  <div class="step__diagram-step-1-table">\n                        <p class="small-white-text">Branches completed (17%)</p>\n                        <div class="block">\n                            <p style="width: 17%;">30</p>\n                            <p style="margin-left: 25px;">143 BRANCHES</p>\n                        </div>\n                        <p class="small-white-text" style="margin-top: 10px;">Months spent (41%)</p>\n                        <div class="block">\n                            <p style="width: 41%;">5 months</p>\n                            <p>7 months</p>\n                        </div>\n                  </div>\n                  <p style="margin-bottom: 20px; margin-top: 60px;" class="yellow-text">Let\u2019s review what you know that is going on now in the company.</p>\n                  <p class="small-white-text">Cannot extend time</p>\n                  <p class="small-white-text">Cannot expand team</p>\n                </div>\n               </div>\n            </div>\n\n            <div class="second-column">\n              <div style="display: flex">\n                <div ng-show="vm.activeIndex >= 2" class="angular-ngAnimate" style="padding: 15px 0 0 15px" ng-style="{\'background-image\': vm.activeIndex <= 2 ? \'url(\\\'/assets/images/5a-1-step-2-bg.png\\\')\' : \'\'}">\n                  <div class="step__diagram-title">\n                    <p class="yellow-text">State what we don\u2019t like about the Situation (R1)</p>\n                  </div>\n                  <div class="step__diagram-content" style=" align-items: center; padding: 15px 10px;">\n                    <p class="step__diagram-content-header">R1</p>\n                    <div class="step-3__box">\n                      <p class="step-3__box-text">Will not achieve goal in time remaining</p>\n                    </div>\n                  </div>\n                </div>\n                <div ng-show="vm.activeIndex >= 3" style="background-size: cover; padding: 15px 0 0 15px" class="angular-ngAnimate" ng-style="{\'background-image\': vm.activeIndex <= 3 ? \'url(\\\'/assets/images/5a-1-step-3-bg.png\\\')\' : \'\'}">\n                  <div class="step__diagram-title">\n                    <p class="yellow-text">State what we want instead (R2)</p>\n                  </div>\n                  <div class="step__diagram-content"\n                       style="align-items: center; padding: 15px 10px;">\n                    <p class="step__diagram-content-header">R2</p>\n                    <div class="step-3__box">\n                      <p class="step-3__box-text">Achieve maximum savings possible in time remaining</p>\n                    </div>\n                  </div>\n                </div>\n              </div>\n              <div ng-show="vm.activeIndex >= 4" class="angular-ngAnimate" style="display: flex; flex-direction: column; align-items: center;">\n                <svg height="150" width="300" style="margin-top: -18px; margin-bottom: -32px;">\n                  <line x1="25" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>\n                  <line x1="290" y1="0" x2="150" y2="140" stroke-width="3" stroke="#ffffff"/>\n                </svg>\n                <div class="step__diagram-content" style="background-image: url(\'/assets/images/5a-1-step-4-bg.png\'); align-items: center; background-size: cover; padding: 15px 10px; margin-top: 28px">\n                  <p class="step__diagram-content-header">SOLUTION</p>\n                  <div class="step-3__box" style="width: 217px">\n                    <p class="step-3__box-text">Implement only high benefit proposals </p>\n                  </div>\n                  <div class="step__diagram-title">\n                    <p style="max-width: initial; margin-top: 20px;" class="yellow-text">State how you will get from R1 to R2 (if you know it)</p>\n                  </div>\n                </div>\n              </div>\n            </div>\n          </div>',
	    steps: 4,
	    startStep: 1,
	    title: 'Step one is to visualize the situation in which the team finds itself. Show what is going on?',
	    pyramidData: {
	      exerciseNumber: 2,
	      scq: {
	        s: 'Unable to finish Rationalization Program in time allotted',
	        c: 'Clearly must be cut, but want to achieve maximum savings possible',
	        q: 'How cut?'
	      },
	      scheme: {
	        model: {
	          textarea: 'To cut Rationalization Program to manageable size, we should implement only high benefit proposals'
	        },
	        children: [{
	          model: {
	            textarea: 'Adhere to the June deadline for those projects in the present backlog that require low capital expenditure'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Rigorously reappraise the remaining projects in the backlog to eliminate those that will yield low benefits'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Set realistic deadlines for completing the second group of projects'
	          },
	          children: []
	        }]
	      },
	      instruction: 'Now you have a very clear picture of the problem and its solution in your mind. You also have an indication of the question that document has to be structured to answer. You are ready to write.'
	    }
	  }
	};

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise3',
	        blocks: [{
	            title: "S = ",
	            answer: ' ',
	            disableEdit: true,
	            hidePlaceHolder: true
	        }, {
	            title: "C = ",
	            answer: ' ',
	            disableEdit: true,
	            hidePlaceHolder: true
	        }, {
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true,
	            hidePlaceHolder: true
	        }],
	        pyramid: {
	            exerciseNumber: 3,
	            pyramidHeader: 'To cut Rationalization Program to manageable size, we should implement only high benefit proposals',
	            pyramidBody: ['Adhere to the June deadline for those projects in the present backlog that require low capital expenditure', 'Rigorously reappraise the remaining projects in the backlog to eliminate those that will yield low benefits', 'Set realistic deadlines for completing the second group of projects']
	        },
	        hideSubmit: true,
	        prefilledAnswer: true
	    }
	};

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(789);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./defineProblem.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./defineProblem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit5a:before{background-image:url(/assets/images/section-5-bg-new.png)!important;background-position-y:-340px!important}.unit5a .exercise-text-1 ul{list-style:none}.unit5a .arrowAnim-third{position:absolute;margin-top:150px!important;margin-left:122px;transform:rotate(-38deg)!important}.unit5a .arrowAnim{width:110px;height:40px;display:flex;justify-content:center;align-items:center;margin-top:49px;transform:rotate(180deg)}.unit5a .arrowAnim .arrow{width:20px;height:20px;border:4px solid;border-color:#000 transparent transparent #000;transform:rotate(-45deg)}.unit5a .arrowAnim .arrowSliding{position:absolute;animation:slide 4s linear infinite}.unit5a .arrowAnim .delay1{animation-delay:1s}.unit5a .arrowAnim .delay2{animation-delay:2s}.unit5a .arrowAnim .delay3{animation-delay:3s}@keyframes slide{0%{opacity:0;transform:translateX(50px)}20%{opacity:1;transform:translateX(30px)}80%{opacity:1;transform:translateX(-30px)}to{opacity:0;transform:translateX(-50px)}}.unit5a .additional-block-text{padding:25px 80px;animation-name:blinking;animation-duration:1s;border:2px dashed transparent;animation-iteration-count:1000000;margin-top:25px;border-radius:15px}@keyframes blinking{0%{border-color:transparent}to{border-color:darkred}}.unit5a .diagram{background-image:url(/assets/images/section-5-bg-new.png)}.unit5a .diagram-title{color:#050e61;font-size:22px;text-decoration:underline;font-family:Nexa-Bold,sans pro,\"serif\";text-decoration-color:#050e61}.unit5a .desc-diagram-wrapper{border-radius:15px;border:3px solid #050e61;padding:15px;display:flex;justify-content:space-around}.unit5a .desc-diagram-wrapper img{object-fit:contain}.unit5a .desc-diagram-wrapper__block{display:flex;flex-direction:column;align-items:center}.unit5a .desc-diagram-wrapper__block__path{stroke:#050e61;fill:none;stroke-width:2px;stroke-dasharray:5px;animation:moveDashedPath 5s linear reverse infinite}@keyframes moveDashedPath{to{stroke-dashoffset:100}}.unit5a .desc-diagram-wrapper__block svg{width:100%;height:100px;margin-bottom:10px}.unit5a .desc-diagram-wrapper__block svg line{stroke:#050e61;stroke-width:3px}.unit5a .desc-diagram-wrapper__content-block p{color:#050e61;font-size:21px;font-family:Nexa-Bold,sans pro,\"serif\"}.unit5a .desc-diagram-wrapper__content-block .block{border-radius:15px;border:3px solid #050e61;padding:10px;color:#050e61}.unit5a .intro .unit-wrapper ol{padding-bottom:75px;margin-bottom:0;border-bottom:3px solid #f0e527}.unit5a .intro+.exercise>.unit-wrapper{padding-top:0}.unit5a .intro-2 p{padding-bottom:75px;margin-bottom:0;border-bottom:3px solid #f0e527}.unit5a .blue-paper{color:#050e61}.unit5a .exercise .exercise-text-2{font-family:Source Sans Pro,sans pro,Arial,serif;font-weight:700;margin-bottom:0}.unit5a .exercise-text-4{position:relative;top:140px}.unit5a .exercise-text-4 p{font-size:24px;font-family:Source Sans Pro,sans pro,Arial,serif;color:#050e61;font-weight:700}.unit5a .diagram-desc{max-width:500px}.unit5a .submit{top:0;left:0}", ""]);
	
	// exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _practiceDefiningProblem = __webpack_require__(791);
	
	var _practiceDefiningProblem2 = _interopRequireDefault(_practiceDefiningProblem);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceDefiningProblemModule = _angular2.default.module('practiceDefiningProblem', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.practiceDefiningProblem', {
	    url: '/courses/5/5b/practice-defining-problem',
	    component: 'practiceDefiningProblem',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('practiceDefiningProblem', _practiceDefiningProblem2.default).name;
	
	exports.default = practiceDefiningProblemModule;

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _practiceDefiningProblem = __webpack_require__(792);
	
	var _practiceDefiningProblem2 = _interopRequireDefault(_practiceDefiningProblem);
	
	var _practiceDefiningProblem3 = __webpack_require__(793);
	
	var _practiceDefiningProblem4 = _interopRequireDefault(_practiceDefiningProblem3);
	
	__webpack_require__(801);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceDefiningProblemComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _practiceDefiningProblem2.default,
	  controller: _practiceDefiningProblem4.default
	};
	
	exports.default = practiceDefiningProblemComponent;

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	module.exports = "`<div class=\"unit unit-5 unit5b\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>practice-defining-problem.course-name</h1>\n  </course-header>\n\n  <course-video lecture-title=\"'practice-defining-problem.course-video.lecture-title'\" />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>practice-defining-problem.unit-section-title</span>\n  </h2>\n\n  <section class=\"intro intro-1\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem.intro</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">practice-defining-problem.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">practice-defining-problem.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">practice-defining-problem.menu-list.exercise-3</a></li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise exercise-1\" id=\"exercise-1\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-number\" translate>practice-defining-problem.exercise-1.number</div>\n        <div class=\"exercise-title\" translate>practice-defining-problem.exercise-1.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem.exercise-1.text-1</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper blue-paper-1\" translate>practice-defining-problem.exercise-1.blue-paper</div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>practice-defining-problem.exercise-1.text-2</div>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n      <modiagram-5-5-B-1-ex-1 data=\"vm.exercise1\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise2', 'exercise1-2', $event)\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-5-5-B-1-ex-1>\n    </div>\n    <div ng-if=\"vm.exercise2Show\" id=\"exercise1-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram-5-5-B-1-ex-2 data=\"vm.exercise2\"></modiagram-5-5-B-1-ex-2>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"intro intro-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem.intro-2</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise exercise-2\" id=\"exercise-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-number\" translate>practice-defining-problem.exercise-2.number</div>\n        <div class=\"exercise-title\" translate>practice-defining-problem.exercise-2.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem.exercise-2.text-1</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\" translate>practice-defining-problem.exercise-2.blue-paper</div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>practice-defining-problem.exercise-2.text-2</div>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n      <modiagram-5-5-B-1-ex-3 data=\"vm.exercise3\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise4', 'exercise2-2', $event)\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-5-5-B-1-ex-3>\n    </div>\n    <div ng-if=\"vm.exercise4Show\" id=\"exercise2-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram-5-5-B-1-ex-4 data=\"vm.exercise4\"></modiagram-5-5-B-1-ex-4>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"intro intro-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem.exercise-2.intro-2</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-3\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-number\" translate>practice-defining-problem.exercise-3.number</div>\n        <div class=\"exercise-title\" translate>practice-defining-problem.exercise-3.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem.exercise-3.text-1</div>\n      </plain-text>\n      <plain-text>\n        <carousel-slider data=\"vm.carouselImages\"></carousel-slider>\n<!--        <img src=\"/assets/carousel-images/5b_3_slide_4.png\" alt=\"\">-->\n      </plain-text>\n<!--      <plain-text>-->\n<!--        <img src=\"/assets/carousel-images/5b_3_slide_5.png\" alt=\"\">-->\n<!--      </plain-text>-->\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>practice-defining-problem.exercise-3.text-2</div>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n        <modiagram-5-5-B-1-ex-5  data=\"vm.exercise5\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise6', 'exercise3-2', $event)\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\" finished-exercises=\"vm.isCompleted\"></modiagram-5-5-B-1-ex-5>\n    </div>\n\n    <div ng-if=\"vm.exercise6Show\" id=\"exercise3-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram-5-5-B-1-ex-6 data=\"vm.exercise6\"></modiagram-5-5-B-1-ex-6>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"intro intro-3\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem.intro-3</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\">\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'practice-defining-problem.congratulation-message'\" finish-section=\"'practice-defining-problem.finish-section'\"\n      final-description=\"'practice-defining-problem.final-description'\" next-course-button=\"'practice-defining-problem.next-course-button'\"\n      dashboard-button=\"'practice-defining-problem.dashboard-button'\" next-course=\"'course.definingMoreComplexProblems'\">\n    </unit-finish>\n  </section>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 1\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 2\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 3\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 0\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _exercise = __webpack_require__(794);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(795);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(796);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(797);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(798);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(799);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	var _carouselImages = __webpack_require__(800);
	
	var _carouselImages2 = _interopRequireDefault(_carouselImages);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PracticeDefiningProblemController = function (_CourseController) {
	  PracticeDefiningProblemController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(PracticeDefiningProblemController, _CourseController);
	
	  function PracticeDefiningProblemController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PracticeDefiningProblemController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PracticeDefiningProblemController.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblemController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/325082699');
	    // this.helperService.initIntercom();
	    _this.lang = 'en';
	    _this.exercise1 = _exercise2.default[_this.lang];
	    _this.exercise2 = _exercise4.default[_this.lang];
	    _this.exercise3 = _exercise6.default[_this.lang];
	    _this.exercise4 = _exercise8.default[_this.lang];
	    _this.exercise5 = _exercise10.default[_this.lang];
	    _this.exercise6 = _exercise12.default[_this.lang];
	    _this.carouselImages = _carouselImages2.default;
	    _this.isUnit = true;
	    _this.isUnitFive = true;
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(PracticeDefiningProblemController, [{
	    key: 'onSubmitScqDiagramDndFramework',
	    value: function onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
	      if (this.isCompleted['1'] && nextExercise === 'exercise1-2' || nextExercise === 'exercise2-2' && this.isCompleted['2'] || nextExercise === 'exercise3-2' && this.isCompleted['3']) {
	        return;
	      }
	      this.complexExercises[pyramidData.exerciseNumber] = _.cloneDeep(pyramidData.model);
	      (0, _get3.default)(PracticeDefiningProblemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblemController.prototype), 'onSubmitScqDiagramDndFramework', this).call(this, nextExercise, nextExerciseLink, pyramidData);
	    }
	  }, {
	    key: 'onClosePyramidBuilder',
	    value: function onClosePyramidBuilder(event) {
	      if (!this.isActivePyramidBuilderDemo) return;
	      var userAnswer = event.store[event.key].scq;
	      this.onFinishExercise(this.nextExercise === 'exercise2' && !this.isCompleted['1'] ? '1' : this.nextExercise === 'exercise4' && !this.isCompleted['2'] ? '2' : this.nextExercise === 'exercise6' && !this.isCompleted['3'] ? '3' : '0', userAnswer);
	      (0, _get3.default)(PracticeDefiningProblemController.prototype.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblemController.prototype), 'onClosePyramidBuilder', this).call(this, event);
	    }
	  }]);
	  return PracticeDefiningProblemController;
	}(_course2.default);
	
	exports.default = PracticeDefiningProblemController;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise1',
	        answers: [{
	            title: '<div class="box-title">High sales force productivity</div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Despite investment, sales force productivity figures remain where they were 10 years ago</div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Low sales force productivity limits-ability to</div>\n                        <div>- Offset slow market growth</div>\n                        <div>- Out-sell competitors</div>\n                        <div>- Out-maneuver online sellers</div>\n                ',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Interview 25 CEOs of billion dollar companies with sales forces</div>\n                    <div>- What is behind the low productivity?</div>\n                    <div>- What can we do about it?</div>\n                ',
	            answer: 4,
	            hasArrow: true
	        }],
	        image: '5b1-1.png'
	    }
	};

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise2',
	        subtitle: 'SUGGESTED STRUCTURE <br> THE SALES FORCE EFFECTIVENESS PARADOX',
	        blocks: [{
	            task: 'Low sales force productivity is causing problems',
	            title: "S = ",
	            answer: ' ',
	            note: 'Sit, DE, R1, R2',
	            disableEdit: true
	        }, {
	            task: 'Interviewed 25 CEOs to pinpoint reasons, identify what can be done about it',
	            title: "C = ",
	            answer: ' ',
	            note: 'Sol',
	            disableEdit: true
	        }, {
	            task: '(What conclude?)',
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true
	        }],
	        image: '5b1-2.png',
	        withoutAnswers: true,
	        hideTaskTitle: true,
	        submitButton: 'switch'
	    }
	};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise3',
	        answers: [{
	            title: '<div class="box-title">Unisys mainframe becoming obsolete</div>\n                      <div>\n                        - Able to support CIF and Deposit systems for only 3-4 more years\n                      </div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">In danger of being put at competitive disadvantage</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Change approach to technology delivery</div>\n                      <div>\n                        - Upgrade\n                      </div>\n                      <div>\n                        - Migrate\n                      </div>\n                      <div>\n                        - Outsource\n                      </div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Remain competitive in the marketplace</div>',
	            answer: 3,
	            hasArrow: true
	        }],
	        image: 'section-5b-3.png'
	    }
	};

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise4',
	        subtitle: 'SUGGESTED STRUCTURE <br> ANALYSIS OF TECHNOLOGY ALTERNATIVES',
	        blocks: [{
	            task: 'Must replace Unisys HW in next 3-4 years',
	            title: "S = ",
	            answer: ' ',
	            note: 'Sit, DE, R1, R2',
	            disableEdit: true
	        }, {
	            task: 'Can either upgrade, migrate to new system, or outsource. Would rather not outsource.',
	            title: "C = ",
	            answer: ' ',
	            note: 'Sol',
	            disableEdit: true
	        }, {
	            task: 'What do?',
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true
	        }],
	        image: '5b2-4.png',
	        withoutAnswers: true,
	        hideTaskTitle: true,
	        submitButton: 'switch'
	    }
	};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise5',
	        answers: [{
	            title: '<div class="box-title">Unhappy with the rankings</div>\n                      <div>\n                          #5 In business relationship\n                      </div>\n                      <div>\n                          #4 in Personnel/organization\n                      </div>\n                      <div>\n                          #4 in Category/Business Development\n                      </div>\n                      <div>\n                          #3 in Retail Execution\n                      </div>\n                      <div>\n                          #2 in Supply Chain Management\n                      </div>\n                      <div>\n                          #2 in overall performance\n                      </div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Set up teams to determine steps needed to move up</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Regain #2 and move toward #1</div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Identified likely causes of the low ratings</div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Annual survey by Advantage International</div>\n                      <div>\n                          - Interviewed 47 manufacturers about Winters\n                      </div>\n                      <div>\n                          - Compared us to 6 competitors\n                      </div>',
	            answer: 5,
	            hasArrow: true
	        }],
	        image: 'section-5b-5.png'
	    }
	};

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise6',
	        subtitle: 'SUGGESTED STRUCTURE <br> ANALYSIS OF TECHNOLOGY ALTERNATIVES',
	        blocks: [{
	            task: 'Annual Survey shows us behind in 4 out of 6 measures',
	            title: "S = ",
	            answer: ' ',
	            note: 'DE, R1',
	            disableEdit: true
	        }, {
	            task: 'Have identified causes, set up team to work on changes needed',
	            title: "C = ",
	            answer: ' ',
	            note: 'Sol, R2',
	            disableEdit: true
	        }, {
	            task: 'What BE doing?',
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true
	        }],
	        image: '5b2-6.png',
	        withoutAnswers: true,
	        hideTaskTitle: true,
	        submitButton: 'switch'
	    }
	};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ['/assets/carousel-images/5b_3_slide_1.png', '/assets/carousel-images/5b_3_slide_2.png', '/assets/carousel-images/5b_3_slide_3.png', '/assets/carousel-images/5b_3_slide_4.png', '/assets/carousel-images/5b_3_slide_5.png', '/assets/carousel-images/5b_3_slide_6.png', '/assets/carousel-images/5b_3_slide_7.png'];

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(802);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceDefiningProblem.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceDefiningProblem.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit5b .intro__introduction li,.unit5b .intro__introduction p{font-family:Plantagenet!important;font-size:19px!important}.unit5b #diagram4-5b-2 .scq-diagram .scq-block,.unit5b #diagram6-5b-3 .scq-diagram .scq-block{border-color:#fff}.unit5b #diagram4-5b-2 .scq-diagram .scq-block p,.unit5b #diagram6-5b-3 .scq-diagram .scq-block p{color:#fff}.unit5b #diagram4-5b-2 .scq-diagram svg line,.unit5b #diagram6-5b-3 .scq-diagram svg line{stroke:#fff}.unit5b #diagram1-5b-5 .hovered,.unit5b #diagram3-5b-5 .hovered,.unit5b #diagram5-5b-5 .hovered{background-color:hsla(0,0%,100%,.3)}.unit5b .simplest__structure-framework__diagram-box{display:flex;align-items:center;justify-content:center}.unit5b .intro .unit-wrapper ol{padding-bottom:75px;margin-bottom:0;border-bottom:3px solid #f0e527}.unit5b .intro__title{color:#050e61;text-transform:uppercase;font-weight:400;margin-block-end:1.33em;font-size:27px}.unit5b .intro__introduction{text-transform:none;color:#000;font-weight:700;padding:40px 25px 40px 40px}.unit5b .exercise-text-1 ol{font-weight:700;margin-top:0}.unit5b .scq-diagram .scq-block{border-color:#050e61}.unit5b .scq-diagram svg line{stroke:#050e61}.unit5b .scq-diagram-dnd-wrapper .submit{position:static}.unit5b .blue-paper p{font-weight:700}.unit5b .structure-answers{width:37%}.unit5b .structure-answers .simplest__structure-answer--dropped{font-size:12px}.unit5b .structure-answers .simplest__structure-answer--dropped.simplest__structure-framework-answer{min-height:0}.unit5b .structure-answers__title{height:auto;text-transform:uppercase;font-size:16px;margin-top:-15px}.unit5b .structure-answers .simplest__structure-block{color:#fff}.unit5b .simplest__structure__with-note{margin-top:76px}.unit5b .simplest__submit{bottom:45px;right:68px}.unit5b .framework-diagram__title{padding-left:80px}.unit5b .simplest__structure-framework-box.r1-block__box,.unit5b .simplest__structure-framework-box.r2-block__box{height:150px!important}", ""]);
	
	// exports


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _practiceDefiningProblem = __webpack_require__(804);
	
	var _practiceDefiningProblem2 = _interopRequireDefault(_practiceDefiningProblem);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceDefiningProblem2Module = _angular2.default.module('practiceDefiningProblem2', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.definingMoreComplexProblems', {
	    url: '/courses/5/5c/defining-more-complex-problems',
	    component: 'practiceDefiningProblem2',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('practiceDefiningProblem2', _practiceDefiningProblem2.default).name;
	
	exports.default = practiceDefiningProblem2Module;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _practiceDefiningProblem = __webpack_require__(805);
	
	var _practiceDefiningProblem2 = _interopRequireDefault(_practiceDefiningProblem);
	
	var _practiceDefiningProblem3 = __webpack_require__(806);
	
	var _practiceDefiningProblem4 = _interopRequireDefault(_practiceDefiningProblem3);
	
	__webpack_require__(815);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var practiceDefiningProblem2Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _practiceDefiningProblem2.default,
	  controller: _practiceDefiningProblem4.default
	};
	
	exports.default = practiceDefiningProblem2Component;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"course5-5c\" class=\"unit unit-5 unit5c\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>practice-defining-problem-2.course-name</h1>\n  </course-header>\n\n  <course-video lecture-title=\"'practice-defining-problem-2.course-video.lecture-title'\" />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>practice-defining-problem-2.unit-section-title</span>\n  </h2>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem-2.intro</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">practice-defining-problem-2.menu-list.exercise-1</a>\n          </li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">practice-defining-problem-2.menu-list.exercise-2</a>\n          </li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">practice-defining-problem-2.menu-list.exercise-3</a>\n          </li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-4')\">practice-defining-problem-2.menu-list.exercise-4</a>\n          </li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-1\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>practice-defining-problem-2.exercise-1.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem-2.exercise-1.text-1</div>\n      </plain-text>\n      <plain-text style=\"position: relative\">\n        <div class=\"blue-paper\">\n          <h5 style=\"line-height: 33px\" class=\"blue-paper-title\" translate>practice-defining-problem-2.exercise-1.blue-paper-title</h5>\n          <br>\n          <br>\n          <span translate>practice-defining-problem-2.exercise-1.blue-paper</span>\n        </div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\">\n          <h5 style=\"line-height: 33px\" class=\"blue-paper-title\" translate>practice-defining-problem-2.exercise-1.proposed-strategy-title</h5>\n          <br>\n          <br>\n          <span translate>practice-defining-problem-2.exercise-1.proposed-strategy</span>\n        </div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-C-1-Ex-1 data=\"vm.exercise1\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise2', 'exercise1-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-C-1-Ex-1>\n    </div>\n    <div ng-if=\"vm.exercise2Show\" id=\"exercise1-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-C-1-Ex-2 data=\"vm.exercise2\"></modiagram5-5-C-1-Ex-2>\n      </div>\n    </div>\n    <!--<plain-text>-->\n      <!--<div class=\"exercise-text-3\" translate>practice-defining-problem-2.exercise-1.text-3</div>-->\n    <!--</plain-text>-->\n  </section>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem-2.exercise-1.intro-1</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>practice-defining-problem-2.exercise-2.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem-2.exercise-2.text-1</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"blue-block\" translate>practice-defining-problem-2.exercise-2.blue-block</div>\n      </plain-text>\n      <!--<plain-text>-->\n        <!--<div class=\"exercise-text-2\" translate>practice-defining-problem-2.exercise-2.text-2</div>-->\n      <!--</plain-text>-->\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-C-1-Ex-3 data=\"vm.exercise3\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise4', 'exercise2-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-C-1-Ex-3>\n    </div>\n    <div ng-if=\"vm.exercise4Show\"  id=\"exercise2-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-C-1-Ex-4 data=\"vm.exercise4\"></modiagram5-5-C-1-Ex-4>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem-2.exercise-2.intro-2</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-3\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>practice-defining-problem-2.exercise-3.title</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\">\n          <h5 style=\"line-height: 33px; padding-bottom: 19px;\" class=\"blue-paper-title\" translate>practice-defining-problem-2.exercise-3.blue-paper-title</h5>\n          <br>\n          <span translate>practice-defining-problem-2.exercise-3.blue-paper</span>\n        </div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem-2.exercise-3.text-1</div>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-C-1-Ex-5 data=\"vm.exercise5\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise6', 'exercise3-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-C-1-Ex-5>\n    </div>\n    <div ng-if=\"vm.exercise6Show\" id=\"exercise3-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-C-1-Ex-6 data=\"vm.exercise6\"></modiagram5-5-C-1-Ex-6>\n      </div>\n    </div>\n  </section>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>practice-defining-problem-2.exercise-3.intro-3</div>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-4\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>practice-defining-problem-2.exercise-4.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>practice-defining-problem-2.exercise-4.text-1</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"blue-paper new_blue_paper\" translate>practice-defining-problem-2.exercise-4.blue-paper</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>practice-defining-problem-2.exercise-4.text-2</div>\n      </plain-text>\n      <plain-text>\n        <div style=\"font-size: 36px\" translate>practice-defining-problem-2.exercise-4.blue-paper-additional-header</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"blue-paper grey-paper paper-with-header\" translate>practice-defining-problem-2.exercise-4.blue-paper-2</div>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-C-1-Ex-7 data=\"vm.exercise7\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise8', 'exercise4-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-C-1-Ex-7>\n    </div>\n    <div ng-if=\"vm.exercise8Show\"  id=\"exercise4-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-C-1-Ex-8 data=\"vm.exercise8\"></modiagram5-5-C-1-Ex-8>\n      </div>\n    </div>\n  </section>\n\n  <section ng-if=\"vm.exercise8Show\" class=\"intro intro-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div style=\"font-size: 18px; margin-bottom: 20px;\" translate>practice-defining-problem-2.wording-introduction-paper.desc</div>\n      </plain-text>\n      <plain-text>\n        <full-wording-introduction-paper button-text=\"'practice-defining-problem-2.wording-introduction-paper.revealIntroduction'\"\n                                         diagram-id=\"'fullWordingIntroduction1'\"\n                                         minto-introduction=\"'practice-defining-problem-2.intro-4'\"\n                                         header=\"'practice-defining-problem-2.wording-introduction-paper.header'\"\n                                         on-introduction-finish=\"vm.onIntroductionFinish($event)\"\n                                         finished-exercises=\"vm.isCompleted\"\n                                         clear-diagram-id=\"4\"\n                                         user-exercise-answers=\"vm.exerciseUserAnswers\"\n                                         show-next=\"vm.introductionShowNextExercise('unit5c-finish', $event, '4')\" />\n      </plain-text>\n    </div>\n  </section>\n\n  <section id=\"unit5c-finish\" class=\"exercise\">\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'practice-defining-problem-2.congratulation-message'\"\n      finish-section=\"'practice-defining-problem-2.finish-section'\"\n      final-description=\"'practice-defining-problem-2.final-description'\"\n      next-course-button=\"'practice-defining-problem-2.next-course-button'\"\n      dashboard-button=\"'practice-defining-problem-2.dashboard-button'\"\n      next-course=\"'course.writingAGoodProposal'\">\n    </unit-finish>\n  </section>\n\n<!--  <pyramid-builder ng-if=\"!vm.isActivePyramidBuilderDemo\" section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\" pyramid-data=\"vm.pyramidData\"></pyramid-builder>-->\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 1\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n    is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n    section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 2\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n    is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n    section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 3\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n    is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n    section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 0\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n    is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n    section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	var _exercise = __webpack_require__(807);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(808);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(809);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(810);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(811);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(812);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	var _exercise13 = __webpack_require__(813);
	
	var _exercise14 = _interopRequireDefault(_exercise13);
	
	var _exercise15 = __webpack_require__(814);
	
	var _exercise16 = _interopRequireDefault(_exercise15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PracticeDefiningProblem2Controller = function (_CourseController) {
	  PracticeDefiningProblem2Controller.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(PracticeDefiningProblem2Controller, _CourseController);
	
	  function PracticeDefiningProblem2Controller(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, PracticeDefiningProblem2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (PracticeDefiningProblem2Controller.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblem2Controller)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/325082707');
	    // this.helperService.initIntercom();
	    _this.lang = 'en';
	    _this.exercise1 = _exercise2.default[_this.lang];
	    _this.exercise2 = _exercise4.default[_this.lang];
	    _this.exercise3 = _exercise6.default[_this.lang];
	    _this.exercise4 = _exercise8.default[_this.lang];
	    _this.exercise5 = _exercise10.default[_this.lang];
	    _this.exercise6 = _exercise12.default[_this.lang];
	    _this.exercise7 = _exercise14.default[_this.lang];
	    _this.exercise8 = _exercise16.default[_this.lang];
	    _this.isUnit = true;
	    _this.isUnitFive = true;
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(PracticeDefiningProblem2Controller, [{
	    key: 'onSubmitScqDiagramDndFramework',
	    value: function onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
	      if (this.isCompleted['1'] && nextExercise === 'exercise1-2' || nextExercise === 'exercise2-2' && this.isCompleted['2'] || nextExercise === 'exercise3-2' && this.isCompleted['3'] || nextExercise === 'exercise4-2' && this.isCompleted['4']) {
	        return;
	      }
	      this.complexExercises[pyramidData.exerciseNumber] = _.cloneDeep(pyramidData.model);
	      (0, _get3.default)(PracticeDefiningProblem2Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblem2Controller.prototype), 'onSubmitScqDiagramDndFramework', this).call(this, nextExercise, nextExerciseLink, pyramidData);
	    }
	  }, {
	    key: 'onClosePyramidBuilder',
	    value: function onClosePyramidBuilder(event) {
	      if (!this.isActivePyramidBuilderDemo) return;
	      var userAnswer = event.store[event.key].scq;
	      if (this.nextExercise === 'exercise8' && !this.isCompleted['4']) {
	        this.complexExercises['4'].pyramidBuilderAnswer = userAnswer;
	      } else {
	        this.onFinishExercise(this.nextExercise === 'exercise2' && !this.isCompleted['1'] ? '1' : this.nextExercise === 'exercise4' && !this.isCompleted['2'] ? '2' : this.nextExercise === 'exercise6' && !this.isCompleted['3'] ? '3' : '0', userAnswer);
	      }
	      (0, _get3.default)(PracticeDefiningProblem2Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(PracticeDefiningProblem2Controller.prototype), 'onClosePyramidBuilder', this).call(this, event);
	    }
	  }]);
	  return PracticeDefiningProblem2Controller;
	}(_course2.default);
	
	exports.default = PracticeDefiningProblem2Controller;

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise1',
	        answers: [{
	            title: '\n                <div class="box-title">Could be an opportunity for TLS</div>\n                <div>\n                    - Addresses our age group\n                </div>\n                <div>\n                    - No dominant player there\n                </div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Identify possible strategy to make it happen</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Close the gaps, emerge as dominant player</div>',
	            answer: 3,
	            hasArrow: true
	        }],
	        image: '5b1-1.png'
	    }
	};

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise2',
	        subtitle: 'SUGGESTED STRUCTURE <br> LOCATION BASED LEARNING STRATEGY',
	        blocks: [{
	            task: 'Location-Based Learning is $12m, market, experiencing healthy growth. Addresses same market Turner does, has no dominant players.',
	            title: "S = ",
	            answer: ' ',
	            note: 'Sit, DE R1',
	            disableEdit: true
	        }, {
	            task: 'Research indicates a gap in the offerings of both segments that Turner might fill, if it could differentiate its offering sufficiently to become the dominant player.',
	            title: "C = ",
	            answer: ' ',
	            note: 'Sol, R2',
	            disableEdit: true
	        }, {
	            task: 'How differentiate itself to become dominant player?',
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true
	        }],
	        image: '5c1-2.png',
	        withoutAnswers: true,
	        hideTaskTitle: true,
	        submitButton: 'switch'
	    }
	};

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise3',
	    answers: [{
	      title: '\n                <div class="box-title">Health care market changing, plans moving beyond simple insurance to</div>\n                <div>\n                 - Managing medical costs<br/>\n                 - Owning provider care organizations<br/>\n                 - Developing, packaging, marketing, selling \u201Chealthcare products\u201D\n                </div>',
	      answer: 1,
	      hasArrow: true
	    }, {
	      title: '<div class="box-title">Upgrade the present systems</div>',
	      answer: 2,
	      hasArrow: true
	    }, {
	      title: '<div class="box-title">Take advantage of commonalities to cut costs of new systems</div>',
	      answer: 3,
	      hasArrow: true
	    }, {
	      title: '\n                <div class="box-title">Too expensive for each State to do alone</div>\n                <div>\n                \t- Wasteful to build 4 separate systems\n                </div>',
	      answer: 4,
	      hasArrow: true
	    }],
	    image: '5b1-1.png'
	  }
	};

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise4',
	    subtitle: 'SUGGESTED STRUCTURE<br/>EXECUTIVE SUMMARY CASCADE GROUP',
	    blocks: [{
	      task: 'Operating with old, obsolete IT systems, but costs too high to replace in each state.',
	      title: "S = ",
	      answer: ' ',
	      note: 'Sit, DE R1',
	      disableEdit: true
	    }, {
	      task: 'Given commonalities, wonder if a single system could work for all.',
	      title: "C = ",
	      answer: ' ',
	      note: 'Sol, R2',
	      disableEdit: true
	    }, {
	      task: 'Could Eastwood develop a single system?',
	      title: "Q = ",
	      answer: ' ',
	      disableEdit: true
	    }],
	    image: '5c1-6.png',
	    withoutAnswers: true,
	    hideTaskTitle: true,
	    submitButton: 'switch'
	  }
	};

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise5',
	    answers: [{
	      title: '\n                <div class="box-title">Enter the SEI&M market</div>',
	      answer: 1,
	      hasArrow: true
	    }, {
	      title: '<div class="box-title">In danger of being broken up</div>',
	      answer: 2,
	      hasArrow: true
	    }, {
	      title: '<div class="box-title"> Not easy to be successful</div>\n                <div>\n                 - Highly competitive<br/>\n                 - Many niches<br/>\n                </div>',
	      answer: 3,
	      hasArrow: true
	    }, {
	      title: '\n                <div class="box-title">Internal demand for services slowing</div>',
	      answer: 4,
	      hasArrow: true
	    }, {
	      title: '\n                <div class="box-title">Avoid being broken up</div>\n                <div>\n                \t- Make use of expertise<br/>\n                \t- Make money\n                </div>',
	      answer: 5,
	      hasArrow: true
	    }, {
	      title: '\n                <div class="box-title">Come up with right strategy based on our strengths</div>',
	      answer: 6,
	      hasArrow: true
	    }, {
	      title: '<div class="box-title">Be successful in mktpl</div>',
	      answer: 7
	    }]
	  }
	};

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise6',
	    subtitle: 'SUGGESTED STRUCTURE<br/>EXECUTIVE SUMMARY CASCADE GROUP',
	    blocks: [{
	      task: 'ISG is planning to enter the external SEI&M market',
	      title: "S = ",
	      answer: ' ',
	      note: '',
	      disableEdit: true
	    }, {
	      task: 'Highly competitive, need strategy to be successful.',
	      title: "C = ",
	      answer: ' ',
	      note: 'Sol, R2',
	      disableEdit: true
	    }, {
	      task: '(What should the strategy be?)',
	      title: "Q = ",
	      answer: ' ',
	      disableEdit: true
	    }],
	    withoutAnswers: true,
	    hideTaskTitle: true,
	    submitButton: 'switch'
	  }
	};

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise7',
	        answers: [{
	            title: '<div class="box-title">Need 500 more people</div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Build a separate facility to house the new entrants</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Demand for 1 million hours a year over each of the next 5 years</div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Handle the growing work load efficiently</div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Can\u2019t absorb in present facility without loss of productivity</div>',
	            answer: 5,
	            hasArrow: true
	        }],
	        image: '5b1-1.png'
	    }
	};

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise6',
	        subtitle: 'SUGGESTED STRUCTURE <br> PROPOSAL TO SPIRIT TELECOMS',
	        blocks: [{
	            task: 'Need to build separate production unit to accommodate growth',
	            title: "S = ",
	            answer: ' ',
	            note: 'Sit, DE R1',
	            disableEdit: true
	        }, {
	            task: 'Want up and running in 6 months with minimum disruption to existing operations',
	            title: "C = ",
	            answer: ' ',
	            note: 'Sol, R2',
	            disableEdit: true
	        }, {
	            task: '(Can you help us to do that?)',
	            title: "Q = ",
	            answer: ' ',
	            disableEdit: true
	        }],
	        image: '5d1-2.png',
	        withoutAnswers: true,
	        hideTaskTitle: true,
	        submitButton: 'switch'
	    }
	};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(816);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceDefiningProblem2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./practiceDefiningProblem2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#course5-5c .blue-paper-title{text-align:center;border-bottom:3px solid #000;padding:45px 0 35px}.unit5c .grey-paper li,.unit5c .grey-paper p,.unit5c .intro__introduction li,.unit5c .intro__introduction p{font-family:Plantagenet!important;font-size:19px!important}.unit5c .diagram-header{display:flex;align-items:center;justify-content:center}.unit5c .diagram-header p{align-items:center}.unit5c .blue-paper-header{position:absolute;top:125px;display:flex;flex-direction:column;justify-content:flex-start;width:100%}.unit5c .blue-paper-header>div{width:100%;display:flex}.unit5c .blue-paper-header>div p{flex:1}.unit5c .sheet-of-paper__long-bg{position:relative;top:0;left:0;max-width:none;width:100%;height:75px;margin-top:-78px;z-index:2;background-position-y:-940px}.unit5c .paper-with-header{background-image:url(\"/assets/images/sheet-of-paper.png\");padding:240px 122px 0}.unit5c .blue-paper-2__summary{font-weight:700;font-size:22px}.unit5c .blue-paper-2-header{text-align:center!important}.unit5c .grey-paper{padding-bottom:40px;background-size:100% 104%}.unit5c #diagram2-5c-1 .scq-diagram .scq-block,.unit5c #diagram4-5c-2 .scq-diagram .scq-block,.unit5c #diagram6-5c-5 .scq-diagram .scq-block{border-color:#fff}.unit5c #diagram2-5c-1 .scq-diagram .scq-block p,.unit5c #diagram4-5c-2 .scq-diagram .scq-block p,.unit5c #diagram6-5c-5 .scq-diagram .scq-block p{color:#fff}.unit5c #diagram2-5c-1 .scq-diagram svg line,.unit5c #diagram4-5c-2 .scq-diagram svg line,.unit5c #diagram6-5c-5 .scq-diagram svg line{stroke:#fff}.unit5c .simplest__structure-framework__diagram-box{background-color:#fff;min-height:50px;width:75px}.unit5c .simplest__structure-framework__diagram-box p{color:#050e61;text-align:left}.unit5c .proposed-strategy{margin-top:120px;margin-left:40px;margin-right:40px;border-radius:20px;border:4px solid #050e61;padding:55px 30px 35px}.unit5c .proposed-strategy__title{width:510px;font-size:33px;letter-spacing:2px;color:#000;font-family:Nexa-Bold,sans pro,\"serif\";font-weight:700;border-bottom:2px solid #000;padding-bottom:2px;line-height:30px}.unit5c .proposed-strategy__sub-title{margin-top:30px;font-size:18px;font-family:Source Sans Pro,sans pro,Arial,serif;font-weight:400}.unit5c .proposed-strategy .points-list{margin-top:30px}.unit5c .proposed-strategy .points-list .sub-list{margin:5px 0 0;padding:0 0 0 36px}.unit5c .proposed-strategy .points-list .sub-list__item{margin-top:5px;font-family:Source Sans Pro,sans pro,Arial,serif}.unit5c .proposed-strategy .points-list .sub-list .sub-list{list-style:none;padding-inline-start:0}.unit5c .proposed-strategy .points-list .sub-list .sub-list li:before{content:\"-\";margin:0 10px}.unit5c .proposed-strategy .points-list .list-item{margin-top:15px;font-family:Source Sans Pro,sans pro,Arial,serif}.unit5c .proposed-strategy .points-list .list-item__number{display:inline-block;min-width:20px;margin-right:10px}.unit5c .exercise-text-2__title{font-size:22px;color:#050e61;font-family:Source Sans Pro;line-height:30px;font-weight:700}.unit5c .intro .unit-wrapper ol{padding-bottom:75px;margin-bottom:0;border-bottom:3px solid #f0e527}.unit5c .intro__title{color:#050e61;text-transform:uppercase;font-weight:400}.unit5c .intro__introduction{font-weight:700;padding:40px 25px 40px 40px}.unit5c .intro-2__introduction,.unit5c .intro-3 p{padding:25px}.unit5c .exercise-text-1 ul{margin-top:0}.unit5c .second-exercise__blue-paper{color:#2c2c2c;font-weight:400;padding-top:60px;padding-bottom:60px}.unit5c .second-exercise__blue-paper,.unit5c .second-exercise__blue-paper li{font-family:Source Sans Pro,sans pro,Arial,serif}.unit5c .second-exercise__blue-paper-title{font-weight:700}.unit5c .second-exercise__blue-paper-underline{text-decoration:underline}.unit5c .blue-block{border-radius:19px;background-color:rgba(61,99,138,.16);border:4px solid #050e61;padding:40px 30px 30px;letter-spacing:1px;color:#050e61;font-family:Source Sans Pro,sans pro,Arial,serif;font-weight:400;line-height:24px}.unit5c .blue-block ol>li{margin:0;padding:0 0 0 28px;text-indent:-28px;list-style-type:none;counter-increment:item}.unit5c .blue-block ol>li:before{display:inline-block;width:1em;padding-right:.5em;font-weight:700;text-align:right;content:counter(item) \".\"}", ""]);
	
	// exports


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _writingProposalsPlans = __webpack_require__(818);
	
	var _writingProposalsPlans2 = _interopRequireDefault(_writingProposalsPlans);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var writingProposalsPlansModule = _angular2.default.module('writingProposalsPlans', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.writingAGoodProposal', {
	    url: '/courses/5/5d/writing-a-good-proposal',
	    component: 'writingProposalsPlans',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('writingProposalsPlans', _writingProposalsPlans2.default).name;
	
	exports.default = writingProposalsPlansModule;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _writingProposalsPlans = __webpack_require__(819);
	
	var _writingProposalsPlans2 = _interopRequireDefault(_writingProposalsPlans);
	
	var _writingProposalsPlans3 = __webpack_require__(820);
	
	var _writingProposalsPlans4 = _interopRequireDefault(_writingProposalsPlans3);
	
	__webpack_require__(827);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var writingProposalsPlansComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _writingProposalsPlans2.default,
	  controller: _writingProposalsPlans4.default
	};
	
	exports.default = writingProposalsPlansComponent;

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit-5 unit5d\">\n  <course-header>\n    <h1 class=\"unit-name\" translate>writing-proposals-plans.course-name</h1>\n  </course-header>\n\n  <course-video lecture-title=\"'writing-proposals-plans.course-video.lecture-title'\" />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>writing-proposals-plans.unit-section-title</span>\n  </h2>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div translate>writing-proposals-plans.intro</div>\n        <ul class=\"key-list\">\n          <li><p class=\"key\" translate>writing-proposals-plans.key-list.key-1</p></li>\n          <li><p class=\"key\" translate>writing-proposals-plans.key-list.key-2</p></li>\n          <li><p class=\"key\" translate>writing-proposals-plans.key-list.key-3</p></li>\n        </ul>\n      </plain-text>\n<!--      <plain-text>-->\n<!--        <div translate>writing-proposals-plans.first-image</div>-->\n<!--      </plain-text>-->\n<!--      <plain-text>-->\n<!--        <div class=\"intro-second-diagram\" translate>writing-proposals-plans.second-image</div>-->\n<!--      </plain-text>-->\n      <plain-text>\n        <div class=\"intro-second-text\" translate>writing-proposals-plans.intro-second-text</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"intro-third-text\" translate>writing-proposals-plans.intro-third-text</div>\n        <ol class=\"anchors-menu\">\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-1')\">writing-proposals-plans.menu-list.exercise-1</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-2')\">writing-proposals-plans.menu-list.exercise-2</a></li>\n          <li><a translate class=\"anchor\" href=\"\" ng-click=\"vm.gotoAnchor('exercise-3')\">writing-proposals-plans.menu-list.exercise-3</a></li>\n        </ol>\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-1\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>writing-proposals-plans.exercise-1.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>writing-proposals-plans.exercise-1.text-1</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"blue-paper grey-paper\" translate>writing-proposals-plans.exercise-1.blue-paper</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-2\" translate>writing-proposals-plans.exercise-1.text-2</div>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-D-1-Ex-1 data=\"vm.exercise1\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise2', 'exercise1-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-D-1-Ex-1>\n    </div>\n    <div ng-if=\"vm.exercise2Show\" id=\"exercise1-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-D-1-Ex-2 data=\"vm.exercise2\"></modiagram5-5-D-1-Ex-2>\n      </div>\n    </div>\n  </section>\n\n  <section ng-if=\"vm.exercise2Show\" class=\"intro intro-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div style=\"font-size: 18px; margin-bottom: 20px;\" translate>writing-proposals-plans.wording-introduction-paper.desc</div>\n      </plain-text>\n      <plain-text>\n        <full-wording-introduction-paper button-text=\"'writing-proposals-plans.wording-introduction-paper.revealIntroduction'\"\n                                         diagram-id=\"'fullWordingIntroduction1'\"\n                                         minto-introduction=\"'writing-proposals-plans.exercise-1.intro-2'\"\n                                         header=\"'writing-proposals-plans.wording-introduction-paper.header'\"\n                                         next=\"vm.introductionShowNextExercise('exercise-2')\"\n                                         show-footer-bg=\"true\"\n                                         finished-exercises=\"vm.isCompleted\"\n                                         clear-diagram-id=\"1\"\n                                         user-exercise-answers=\"vm.exerciseUserAnswers\"\n                                         show-next=\"vm.introductionShowNextExercise('exercise-2', $event, '1')\" />\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-2\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>writing-proposals-plans.exercise-2.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>writing-proposals-plans.exercise-2.text-1</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\" translate>writing-proposals-plans.exercise-2.blue-paper</div>\n        <div style=\"right: 16px\" class=\"blue-paper__right-shadow\"></div>\n        <div style=\"left: 28px;\" class=\"blue-paper__left-shadow\"></div>\n        <br/>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>writing-proposals-plans.exercise-2.text-2</div>\n      </plain-text>\n      <plain-text style=\"position: relative\">\n        <div class=\"blue-paper disable-bold-font\" translate>writing-proposals-plans.exercise-2.blue-paper-2</div>\n        <div style=\"right: 16px\" class=\"blue-paper__right-shadow\"></div>\n        <div style=\"left: 28px;\" class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <br/>\n        <br/>\n      </plain-text>\n    </div>\n    <div class=\"diagram\">\n      <modiagram5-5-D-1-Ex-3 data=\"vm.exercise3\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise4', 'exercise2-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-D-1-Ex-3>\n    </div>\n    <div ng-if=\"vm.exercise4Show\" id=\"exercise2-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-D-1-Ex-4 data=\"vm.exercise4\"></modiagram5-5-D-1-Ex-4>\n      </div>\n    </div>\n  </section>\n\n  <section ng-if=\"vm.exercise4Show\" class=\"intro intro-2 intro-3\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div style=\"font-size: 18px; margin-bottom: 20px;\" translate>writing-proposals-plans.wording-introduction-paper.desc</div>\n      </plain-text>\n      <plain-text>\n        <full-wording-introduction-paper button-text=\"'writing-proposals-plans.wording-introduction-paper.revealIntroduction'\"\n                                         diagram-id=\"'fullWordingIntroduction2'\"\n                                         minto-introduction=\"'writing-proposals-plans.intro-2'\"\n                                         header=\"'writing-proposals-plans.wording-introduction-paper.header'\"\n                                         finished-exercises=\"vm.isCompleted\"\n                                         show-footer-bg=\"true\"\n                                         clear-diagram-id=\"2\"\n                                         user-exercise-answers=\"vm.exerciseUserAnswers\"\n                                         show-next=\"vm.introductionShowNextExercise('exercise-3', $event, '2')\" />\n      </plain-text>\n    </div>\n  </section>\n\n  <section class=\"exercise\" id=\"exercise-3\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div class=\"exercise-title\" translate>writing-proposals-plans.exercise-3.title</div>\n      </plain-text>\n      <plain-text>\n        <div class=\"exercise-text-1\" translate>writing-proposals-plans.exercise-3.text-1</div>\n      </plain-text>\n      <plain-text style=\"position:relative;\">\n        <div class=\"blue-paper\" translate>writing-proposals-plans.exercise-3.blue-paper</div>\n        <div class=\"blue-paper__right-shadow\"></div>\n        <div style=\"left: 18px;\" class=\"blue-paper__left-shadow\"></div>\n        <br/>\n      </plain-text>\n      <plain-text style=\"position: relative\">\n        <div class=\"blue-paper disable-bold-font\" translate>writing-proposals-plans.exercise-3.blue-paper-2</div>\n        <div style=\"right: 21px\" class=\"blue-paper__right-shadow\"></div>\n        <div style=\"left: 35px;\" class=\"blue-paper__left-shadow\"></div>\n      </plain-text>\n      <plain-text>\n        <br/>\n        <br/>\n        <p translate>writing-proposals-plans.exercise-3.text-3</p>\n      </plain-text>\n    </div>\n\n    <div class=\"diagram\">\n      <modiagram5-5-D-1-Ex-5 data=\"vm.exercise5\" on-submit=\"vm.onSubmitScqDiagramDndFramework('exercise6', 'exercise3-2', $event)\" finished-exercises=\"vm.isCompleted\" set-pyramid-data=\"vm.savePyramidBuilderData($event)\"></modiagram5-5-D-1-Ex-5>\n    </div>\n    <div ng-if=\"vm.exercise6Show\" id=\"exercise3-2\" class=\"diagram\" style=\"margin-top: 100px; background-position: 0 15%;\">\n      <div class=\"unit-wrapper\">\n        <modiagram5-5-D-1-Ex-6 data=\"vm.exercise6\"></modiagram5-5-D-1-Ex-6>\n      </div>\n    </div>\n  </section>\n\n  <section ng-if=\"vm.exercise6Show\" class=\"intro intro-2 intro-4\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div style=\"font-size: 18px; margin-bottom: 20px;\" translate>writing-proposals-plans.wording-introduction-paper.desc</div>\n      </plain-text>\n      <plain-text>\n        <full-wording-introduction-paper button-text=\"'writing-proposals-plans.wording-introduction-paper.revealIntroduction'\"\n                                         diagram-id=\"'fullWordingIntroduction3'\"\n                                         minto-introduction=\"'writing-proposals-plans.intro-3'\"\n                                         header=\"'writing-proposals-plans.wording-introduction-paper.header'\"\n                                         finished-exercises=\"vm.isCompleted\"\n                                         show-footer-bg=\"true\"\n                                         clear-diagram-id=\"3\"\n                                         user-exercise-answers=\"vm.exerciseUserAnswers\"\n                                         show-next=\"vm.introductionShowNextExercise('unit5d-finish', $event, '3')\" />\n      </plain-text>\n    </div>\n  </section>\n\n  <section id=\"unit5d-finish\" class=\"exercise\">\n    <unit-finish\n      on-button-click=\"vm.onSectionFinish()\"\n      congratulation-message=\"'writing-proposals-plans.congratulation-message'\"\n      finish-section=\"'writing-proposals-plans.finish-section'\"\n      final-description=\"'writing-proposals-plans.final-description'\"\n      next-course-button=\"'writing-proposals-plans.next-course-button'\"\n      dashboard-button=\"'writing-proposals-plans.dashboard-button'\"\n      next-course=\"'graduation'\">\n    </unit-finish>\n  </section>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 1\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 2\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 3\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 4\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n\n  <pyramid-builder ng-if=\"vm.enablePyramidBuilter === 0\" on-close-pyramid-builder=\"vm.onClosePyramidBuilder($event)\"\n                   is-active-demo=\"vm.isActivePyramidBuilderDemo\" pyramid-data=\"vm.pyramidData\"\n                   section-title=\"{{ 'practice-defining-problem-2.course-title' | translate }}\"></pyramid-builder>\n</div>\n\n</div>\n"

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	var _exercise = __webpack_require__(821);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(822);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(823);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(824);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(825);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(826);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WritingProposalsPlansController = function (_CourseController) {
	  WritingProposalsPlansController.$inject = ["courseService", "helperService", "$sce", "$scope"];
	  (0, _inherits3.default)(WritingProposalsPlansController, _CourseController);
	
	  function WritingProposalsPlansController(courseService, helperService, $sce, $scope) {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, WritingProposalsPlansController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (WritingProposalsPlansController.__proto__ || (0, _getPrototypeOf2.default)(WritingProposalsPlansController)).call(this, courseService, helperService, $sce, $scope));
	
	    (0, _assign2.default)(_this, { helperService: helperService, $sce: $sce });
	    _this.videoUrl = _this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/325082719');
	    // this.helperService.initIntercom();
	    _this.lang = 'en';
	    _this.exercise1 = _exercise2.default[_this.lang];
	    _this.exercise2 = _exercise4.default[_this.lang];
	    _this.exercise3 = _exercise6.default[_this.lang];
	    _this.exercise4 = _exercise8.default[_this.lang];
	    _this.exercise5 = _exercise10.default[_this.lang];
	    _this.exercise6 = _exercise12.default[_this.lang];
	    _this.isUnit = true;
	    _this.isUnitFive = true;
	    _this.exerciseUserAnswers = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(WritingProposalsPlansController, [{
	    key: 'onSubmitScqDiagramDndFramework',
	    value: function onSubmitScqDiagramDndFramework(nextExercise, nextExerciseLink, pyramidData) {
	      if (this.isCompleted['1'] && nextExercise === 'exercise1-2' || nextExercise === 'exercise2-2' && this.isCompleted['2'] || nextExercise === 'exercise3-2' && this.isCompleted['3']) {
	        return;
	      }
	      this.complexExercises[pyramidData.exerciseNumber] = _.cloneDeep(pyramidData.model);
	      (0, _get3.default)(WritingProposalsPlansController.prototype.__proto__ || (0, _getPrototypeOf2.default)(WritingProposalsPlansController.prototype), 'onSubmitScqDiagramDndFramework', this).call(this, nextExercise, nextExerciseLink, pyramidData);
	    }
	  }, {
	    key: 'onClosePyramidBuilder',
	    value: function onClosePyramidBuilder(event) {
	      if (!this.isActivePyramidBuilderDemo) return;
	      var userAnswer = event.store[event.key].scq;
	      this.complexExercises[this.nextExercise === 'exercise2' ? '1' : this.nextExercise === 'exercise4' ? '2' : this.nextExercise === 'exercise6' ? '3' : '0'].pyramidBuilderAnswer = userAnswer;
	      (0, _get3.default)(WritingProposalsPlansController.prototype.__proto__ || (0, _getPrototypeOf2.default)(WritingProposalsPlansController.prototype), 'onClosePyramidBuilder', this).call(this, event);
	    }
	  }]);
	  return WritingProposalsPlansController;
	}(_course2.default);
	
	exports.default = WritingProposalsPlansController;

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise1',
	        answers: [{
	            title: '<div class="box-title">Offer Risk Management Study - RM benchmarking service, updated periodically, with analytical insights into developing Credit Risk trends</div>\n                        <div>\n                            - Risk performance benchmarks\n                        </div>\n                        <div>\n                            - Forecast of CR trends\n                        </div>\n                        <div>\n                            - Impact of best practices on business and organizational performance\n\n                        </div>\n                        <div>\n                            - Decision support tool (modeling and scoring) in shaping credit risk policy, market strategy\n                        </div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Difficult to develop strategies to optimize portfolio risk</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Better risk policy formulation and management</div>\n                        <div>\n                            - Meaningful perspective on key underpinnings of RM practices\n                        </div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Issuers asking us for insights on</div>\n                        <div>\n                            - CH risk activities in other banks\n                        </div>\n                        <div>\n                            - Practices they are adopting\n                        </div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Current Risk Management benchmarking offerings rovide only rear view mirror on past or recent performance</div>\n                        <div>\n                            - No projections of Credit Risk trends\n                        </div>\n                        <div>\n                            - No insights into CH risk profiles in post-acquisition stage of the credit life cycle\n                        </div>',
	            answer: 5,
	            hasArrow: true
	        }],
	        image: '5b1-1.png'
	    }
	};

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise2',
	    blocks: [{
	      task: 'Current Risk Management benchmarks/processes misstate actual risk positions, unreliable for developing card-marketing strategies.',
	      title: "S = ",
	      prop: 's',
	      answer: ' ',
	      note: 'DE, Sit',
	      disableEdit: true
	    }, {
	      task: 'Have developed new benchmarks/processes that will correct the problems, need you to participate in pilot trial.',
	      title: "C = ",
	      prop: 'c',
	      answer: ' ',
	      note: 'R1, R2, Sol',
	      disableEdit: true
	    }, {
	      task: 'Should we?',
	      title: "Q = ",
	      prop: 'q',
	      answer: ' ',
	      disableEdit: true
	    }],
	    subtitle: 'SUGGESTED STRUCTURE RISK MANAGEMENT STUDY BENCHMARK ADVANTAGE',
	    image: '5d4-2.png',
	    withoutAnswers: true,
	    hideTaskTitle: true,
	    submitButton: 'switch'
	  }
	};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise3',
	        answers: [{
	            title: '<div class="box-title">Risk that PCI work on data transfer will be delayed by efforts to align to 4 planned implementations</div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Transferred business activities up</div>\n                <div>\n                  - With minimum duplication of\n                </div>\n                <div>\n                  - With minimum delay\n                </div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Real possibility of duplicating</div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Plan the activities for the five projects together</div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Several SWCP conversion programs are  being implemented at the same time, which also require data conversion work</div>\n                    <div>\n                      - Global Manufacturing SAP\n                    </div>\n                    <div>\n                      - Engineering\n                    </div>\n                    <div>\n                      - IT infrastructure development\n                    </div>\n                    <div>\n                      - eProcurement\n                    </div>',
	            answer: 5,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Our data transfer activities must align with theirs</div>\n                    <div>\n                      - Must coincide, where feasible, with their transfer and rollout tasks\n                    </div>',
	            answer: 6,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Hire an additional manager to coordinate activities with the Site Closure Program Manager, the mana gers at the receiving sites, and the various implementation teams</div>',
	            answer: 7,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Align the activities of the 5 projects</div>\n                        <div>\n                          - 5 projects\n                        </div>\n                        <div>\n                          - 5 sets of managers\n                        </div>\n                        <div>\n                          - 5 implementation teams\n                        </div>\n                        <div>\n                          - 5 Local Responsible People\n                        </div>',
	            answer: 8,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Still have IS systems up and running before transfer of business operations</div> ',
	            answer: 9,
	            hasArrow: true
	        }],
	        image: 'section-5d-5.png'
	    }
	};

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise4',
	    subtitle: 'SUGGESTED STRUCTURE <br> PCI ENERGY SERVICES GROUP',
	    blocks: [{
	      task: 'Siemens expects PCI to have IS for three new Westinghouse plant additions to SWPC\u2019s Network converted and running immediately before rollout of the newly merged company. ',
	      title: "S = ",
	      prop: 's',
	      answer: ' ',
	      note: 'Sit, DE R1',
	      disableEdit: true
	    }, {
	      task: 'PCI also has four other major IS data conversion projects to complete for SWPC in the same period, which Siemens wants without duplication or delay.  Creates risk that IS data conversion will not be in place in time for Westinghouse transfers',
	      title: "C = ",
	      prop: 'c',
	      answer: ' ',
	      note: 'Sol, R2',
	      disableEdit: true
	    }, {
	      task: 'How eliminate the risk?',
	      title: "Q = ",
	      prop: 'q',
	      answer: ' ',
	      disableEdit: true
	    }],
	    image: '5d6-3.png',
	    withoutAnswers: true,
	    hideTaskTitle: true,
	    submitButton: 'switch'
	  }
	};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise5',
	        answers: [{
	            title: '<div class="box-title">Difficult to develop compelling business case for entering</div>',
	            answer: 1,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Other assumptions may be wrong</div>',
	            answer: 2,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Grow through externally and internally sourced products</div>\n                        <div>Develop blockbuster products</div>',
	            answer: 3,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Get external validation of potential future development and best practice from Chinese-based expert</div>',
	            answer: 4,
	            hasArrow: true
	        }, {
	            title: '<div class="box-title">Slade affiliate in China says that Marketing & Sales will turn out to be a set % of net sales all along the process</div>',
	            answer: 5,
	            hasArrow: true
	        }],
	        image: 'section-5d-5.png'
	    }
	};

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  en: {
	    id: 'exercise6',
	    subtitle: 'SUGGESTED STRUCTURE <br> PCI ENERGY SERVICES GROUP',
	    blocks: [{
	      task: 'Want to grow in China. Difficult to develop compelling business case, whether to allocate selling expenses or not.',
	      title: "S = ",
	      answer: ' ',
	      note: '',
	      disableEdit: true
	    }, {
	      task: 'Not so in other emerging markets.',
	      title: "C = ",
	      answer: ' ',
	      note: 'Sol, R2',
	      disableEdit: true
	    }, {
	      task: 'Is this inherent characteristic of Chinese pharma market? How improve profitability and performance in China?',
	      title: "Q = ",
	      answer: ' ',
	      disableEdit: true
	    }],
	    image: '5d6-3.png',
	    withoutAnswers: true,
	    hideTaskTitle: true,
	    submitButton: 'switch',
	    note: 'Would that Slade had sent the R FP in this form.  But even if it didn’t, your turning it into this form gives a tactful way to enlighten them on what they really want to know, and to see reasonable parameters for how you will help them.'
	  }
	};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(828);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./writingProposalsPlans.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./writingProposalsPlans.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit5d #diagram2-5d-2 .scq-diagram .scq-block,.unit5d #diagram4-5d-2 .scq-diagram .scq-block,.unit5d #diagram6-5d-2 .scq-diagram .scq-block{border-color:#fff}.unit5d #diagram2-5d-2 .scq-diagram .scq-block p,.unit5d #diagram4-5d-2 .scq-diagram .scq-block p,.unit5d #diagram6-5d-2 .scq-diagram .scq-block p{color:#fff}.unit5d #diagram2-5d-2 .scq-diagram svg line,.unit5d #diagram4-5d-2 .scq-diagram svg line,.unit5d #diagram6-5d-2 .scq-diagram svg line{stroke:#fff}.unit5d .disable-bold-font>p{font-family:Source Sans Pro,sans pro,Arial,serif}.unit5d .disable-bold-font h5{font-size:30px}.unit5d .diagram-with-scq-text .scq-diagram-body .scq-block{max-width:166px}.unit5d .diagram-with-scq-text .scq-text .scq-block{width:380px}.unit5d .diagram-with-scq-text .scq-text .scq-block p{font-size:18px;line-height:18px}.unit5d #exercise-1 .second-diagram .scq-diagram-body .scq-block{max-width:166px}.unit5d #exercise-1 .desc-scq-diagram .scq-block{border-color:#050e61}.unit5d #exercise-1 .desc-scq-diagram svg line{stroke:#050e61}.unit5d .intro{font-size:24px}.unit5d .intro .unit-wrapper{border-bottom:3px solid #f0e527}.unit5d .intro .unit-wrapper ul{margin-block-start:0;padding-bottom:75px;margin-bottom:0}.unit5d .intro .unit-wrapper ul li{font-weight:400}.unit5d .intro .unit-wrapper .intro-second-diagram{margin:75px 0}.unit5d .intro .unit-wrapper .intro-second-text,.unit5d .intro .unit-wrapper .intro-third-text{margin-bottom:38px}.unit5d .intro__title{color:#050e61;text-transform:uppercase;font-weight:400;margin-block-end:1.33em;font-size:27px}.unit5d .intro__introduction{text-transform:none;color:#000;font-weight:700;padding:40px 25px 40px 40px}.unit5d .diagram1-5d-1,.unit5d .diagram3-5d-2,.unit5d .diagram5-5d-3{min-height:1120px}.unit5d .diagram1-5d-1 .framework-diagram .simplest__submit,.unit5d .diagram3-5d-2 .framework-diagram .simplest__submit,.unit5d .diagram5-5d-3 .framework-diagram .simplest__submit{bottom:-20px;right:5.8vw}.unit5d .diagram1-5d-1 .framework-diagram .simplest__structure-answers,.unit5d .diagram3-5d-2 .framework-diagram .simplest__structure-answers,.unit5d .diagram5-5d-3 .framework-diagram .simplest__structure-answers{width:37%}.unit5d .diagram1-5d-1 .framework-diagram .r1-block__box,.unit5d .diagram3-5d-2 .framework-diagram .r1-block__box,.unit5d .diagram5-5d-3 .framework-diagram .r1-block__box{height:190px!important}.unit5d .diagram1-5d-1 .framework-diagram__title,.unit5d .diagram3-5d-2 .framework-diagram__title,.unit5d .diagram5-5d-3 .framework-diagram__title{text-align:left;padding:40px 120px 20px;font-size:22px;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-weight:700}.unit5d .diagram1-5d-1 .framework-diagram .divider-dashed,.unit5d .diagram3-5d-2 .framework-diagram .divider-dashed,.unit5d .diagram5-5d-3 .framework-diagram .divider-dashed{background-image:linear-gradient(90deg,#fff 65%,hsla(0,0%,100%,0) 0);background-position:top right 18px;background-size:20px 4px;height:4px;margin-top:50px;margin-bottom:50px;width:80%;position:relative;left:10%;background-repeat:repeat-x}.unit5d .diagram1-5d-1 .r1-block__top-part,.unit5d .diagram3-5d-2 .r1-block__top-part,.unit5d .diagram5-5d-3 .r1-block__top-part{position:relative;top:8px}.unit5d .diagram1-5d-1 .r1-block__bottom-part,.unit5d .diagram3-5d-2 .r1-block__bottom-part,.unit5d .diagram5-5d-3 .r1-block__bottom-part{top:-1px;border-top-right-radius:0;border-top-left-radius:0}.unit5d .exercise-3-blue-paper-list li{font-family:Source Sans Pro,sans pro,Arial,serif}.unit5d .intro-2 .sheet-of-paper{height:790px}.unit5d .intro-3 .sheet-of-paper{height:800px;padding:154px 105px 0 119px!important}.unit5d .intro-3 .sheet-of-paper .correct-paper-answer ul{list-style:none;padding-bottom:0}.unit5d .intro-3 .sheet-of-paper .correct-paper-answer ul>li{text-indent:20px}.unit5d .intro-4 .sheet-of-paper{height:900px}.unit5d #diagram2-5d-2 .desc-scq-diagram .scq-block,.unit5d #diagram4-5d-2 .desc-scq-diagram .scq-block{border-color:#fff!important;max-width:170px}.unit5d #diagram2-5d-2 .desc-scq-diagram .scq-block p,.unit5d #diagram4-5d-2 .desc-scq-diagram .scq-block p{color:#fff}.unit5d #diagram2-5d-2 .desc-scq-diagram svg line,.unit5d #diagram4-5d-2 .desc-scq-diagram svg line{stroke:#fff!important}.unit5d #diagram2-5d-2 .desc-scq-diagram .scq-diagram-body__list li,.unit5d #diagram4-5d-2 .desc-scq-diagram .scq-diagram-body__list li{color:#fff}.unit5d .blue-paper-2__summary{font-weight:700;font-size:22px}.unit5d .blue-paper-2-header{text-align:center!important}.unit5d .spirit-facts-blue-paper li{padding-left:25px;margin-bottom:38px}.unit5d .spirit-facts-blue-paper li:last-child{margin-bottom:0}.unit5d .blue-paper-third-list{margin-inline-start:40px;list-style:none}.unit5d .blue-paper-third-list li{text-indent:20px;margin-left:15px;margin-bottom:0!important}.unit5d .blue-paper-third-list li,.unit5d .ex3-blue-paper-1.first-list li{font-family:Source Sans Pro,sans pro,Arial,serif}.unit5d .ex3-blue-paper-1 li{padding-left:0!important;margin-bottom:0!important}.unit5d .simplest__structure-block{color:#fff}", ""]);
	
	// exports


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularjs = __webpack_require__(9);
	
	var _angularjs2 = _interopRequireDefault(_angularjs);
	
	var _lecture = __webpack_require__(830);
	
	var _lecture2 = _interopRequireDefault(_lecture);
	
	var _identifyingLogicaOrder = __webpack_require__(835);
	
	var _identifyingLogicaOrder2 = _interopRequireDefault(_identifyingLogicaOrder);
	
	var _core = __webpack_require__(505);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _module = _angular2.default.module('unit6', [_angularjs2.default]).config(["$stateProvider", function ($stateProvider) {
	  "ngInject";
	
	  $stateProvider.state('course.6lecture', {
	    url: '/courses/6/looking-critically-at-groupings',
	    component: 'lecture',
	    resolve: { authenticate: _core.authenticate }
	  }).state('course.identifyingLogicaOrder', {
	    url: '/courses/6/identifying-logica-order',
	    component: 'identifyingLogicaOrder',
	    resolve: { authenticate: _core.authenticate }
	  });
	}]).component('lecture', _lecture2.default).component('identifyingLogicaOrder', _identifyingLogicaOrder2.default).name;
	
	exports.default = _module;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lecture = __webpack_require__(831);
	
	var _lecture2 = _interopRequireDefault(_lecture);
	
	var _lecture3 = __webpack_require__(832);
	
	var _lecture4 = _interopRequireDefault(_lecture3);
	
	__webpack_require__(833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lectureComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _lecture2.default,
	  controller: _lecture4.default
	};
	
	exports.default = lectureComponent;

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit__6 unit__6-lecture\">\n\n  <course-header>\n    <h1 class=\"unit-name\" translate>6lecture.course-name</h1>\n  </course-header>\n\n  <course-video />\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div>\n          <p>Once you have worked out the structure of your pyramid and written the first draft, you need to look critically\n            at the various groupings of ideas you have brought together at lower levels. The likelihood is that, in many\n            places, you will simply have listed roughly similar points (reasons, problems, issues) rather than brought together\n            ideas that, when grouped, support a clear point.</p>\n          <br>\n          <p>The technique is to check that</p>\n          <ul>\n            <li>The ideas in each grouping do logically belong together in that grouping</li>\n            <li>They are all there - i.e. nothing left out</li>\n            <li>The point above the grouping states an insight drawn directly from the grouping</li>\n          </ul>\n\n          <p>You will generally not find it difficult to impose order and make summaries if the reasoning is deductive. The\n            second point in the grouping will always comment on the first, the third point will generally state the implication\n            of the first two points existing in the world at the same time. The argument will be complete, and to summarize\n            you simply take the last point, put it above, and add a “because” to cover the rest. </p>\n          <br>\n          <p><img src=\"/assets/images/unit-6-lecture-1.png\" alt=\"\"></p>\n          <br>\n          <p>But when the reasoning is inductive, the argument is incomplete without the summary point. Indeed, the act of summarizing\n            is the act of completing the thinking.\n            <br>\n          </p>\n          <br>\n          <p><img src=\"/assets/images/unit-6-lecture-2.png\" alt=\"\"></p>\n          <br>\n          <p>The task is complicated by the fact that you have three possible ways to order the ideas, depending on how you\n            derived them, and you have two possible ways to summarize them, depending on the type of ideas with which you\n            are dealing.</p>\n          <br>\n          <p>The exercises that follow will give you plenty of practice in both finding the underlying order in an inductive\n            grouping, and conducting a critical analysis of the thinking it represents.</p>\n        </div>\n      </plain-text>\n    </div>\n  </section>\n\n  <unit-finish congratulation-message=\"''\" finish-section=\"''\" final-description=\"''\" next-course-button=\"'6lecture.next-course-button'\"\n    dashboard-button=\"'define-a-problem.dashboard-button'\" next-course=\"course.identifyingLogicaOrder\"></unit-finish>\n    <pyramid-builder section-title=\"{{ '6lecture.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LectureController = function LectureController(helperService, $sce) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, LectureController);
	  (0, _assign2.default)(this, { helperService: helperService, $sce: $sce });
	  this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	};
	LectureController.$inject = ["helperService", "$sce"];
	
	exports.default = LectureController;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(834);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./lecture.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./lecture.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit__6 .unit-header,.unit__6 .unit-section-title{background-image:url(\"/assets/images/unit-6-bg.png\");background-background-size:contain}.unit__6 .marked,.unit__6 .unit-name{color:#fff}.unit__6 .video{border:5px solid #050e61;color:#050e61}.unit__6 .finish{border-top:3px solid #050e61;border-bottom:3px solid #050e61}.unit__6 .finish-button{background:#050e61}.unit__6 .diagram{background-image:url(\"/assets/images/unit-6-bg.png\")}.unit__6 .divider{border-color:#050e61}.unit__6 .intro-list{max-width:400px}", ""]);
	
	// exports


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _identifyingLogicaOrder = __webpack_require__(836);
	
	var _identifyingLogicaOrder2 = _interopRequireDefault(_identifyingLogicaOrder);
	
	var _identifyingLogicaOrder3 = __webpack_require__(837);
	
	var _identifyingLogicaOrder4 = _interopRequireDefault(_identifyingLogicaOrder3);
	
	__webpack_require__(844);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var identifyingLogicaOrderComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _identifyingLogicaOrder2.default,
	  controller: _identifyingLogicaOrder4.default
	};
	
	exports.default = identifyingLogicaOrderComponent;

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit unit__6 unit__6-lecture\">\n\n  <course-header>\n    <h1 class=\"unit-name\" translate>identifyingLogicaOrder.course-name</h1>\n  </course-header>\n\n  <course-video />\n\n  <h2 class=\"unit-section-title background\">\n    <span translate>identifyingLogicaOrder.exercises.title</span>\n  </h2>\n\n  <section class=\"intro\">\n    <div class=\"unit-wrapper\">\n      <plain-text>\n        <div>\n          <p>As you know by now, inductively related groupings of ideas can be created in only one of three ways, each of which\n            dictates a logical order:</p>\n          <br>\n          <div class=\"intro-list\">\n            <div>\n              <p>• By devising a process</p>\n              <p>• By dividing a whole</p>\n              <p>• By creating a class</p>\n            </div>\n            <div>\n              <p>Time order</p>\n              <p>Structural order</p>\n              <p>Degree order</p>\n            </div>\n          </div>\n          <br>\n          <p>Identify which order the groupings of ideas that follow reflect.</p>\n        </div>\n      </plain-text>\n      <div class=\"divider\"></div>\n    </div>\n  </section>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise1\"></checkbox-diagram>\n    </div>\n  </div>\n\n  <div class=\"unit-wrapper\">\n    <div class=\"divider\"></div>\n  </div>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise2\"></checkbox-diagram>\n    </div>\n  </div>\n\n  <div class=\"unit-wrapper\">\n    <div class=\"divider\"></div>\n  </div>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise3\"></checkbox-diagram>\n    </div>\n  </div>\n\n  <div class=\"unit-wrapper\">\n    <div class=\"divider\"></div>\n  </div>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise4\"></checkbox-diagram>\n    </div>\n  </div>\n\n  <div class=\"unit-wrapper\">\n    <div class=\"divider\"></div>\n  </div>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise5\"></checkbox-diagram>\n    </div>\n  </div>\n\n  <div class=\"unit-wrapper\">\n    <div class=\"divider\"></div>\n  </div>\n\n  <div class=\"diagram  checkbox-diagram\">\n    <div class=\"unit-wrapper\">\n      <checkbox-diagram data=\"vm.exercise6\"></checkbox-diagram>\n    </div>\n  </div>\n\n\n  <unit-finish on-button-click=\"vm.onSectionFinish()\"\n                 congratulation-message=\"'identifyingLogicaOrder.congratulation-message'\" finish-section=\"'identifyingLogicaOrder.finish-section'\"\n    final-description=\"'identifyingLogicaOrder.final-description'\" next-course-button=\"'identifyingLogicaOrder.next-course-button'\"\n    dashboard-button=\"'identifyingLogicaOrder.dashboard-button'\" next-course=\"course.cementingTheRules\"></unit-finish>\n    <pyramid-builder section-title=\"{{ 'identifyingLogicaOrder.course-title' | translate }}\"></pyramid-builder>\n</div>\n"

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _exercise = __webpack_require__(838);
	
	var _exercise2 = _interopRequireDefault(_exercise);
	
	var _exercise3 = __webpack_require__(839);
	
	var _exercise4 = _interopRequireDefault(_exercise3);
	
	var _exercise5 = __webpack_require__(840);
	
	var _exercise6 = _interopRequireDefault(_exercise5);
	
	var _exercise7 = __webpack_require__(841);
	
	var _exercise8 = _interopRequireDefault(_exercise7);
	
	var _exercise9 = __webpack_require__(842);
	
	var _exercise10 = _interopRequireDefault(_exercise9);
	
	var _exercise11 = __webpack_require__(843);
	
	var _exercise12 = _interopRequireDefault(_exercise11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IdentifyingLogicaOrderController = function IdentifyingLogicaOrderController(helperService, $sce) {
	  "ngInject";
	
	  (0, _classCallCheck3.default)(this, IdentifyingLogicaOrderController);
	  (0, _assign2.default)(this, { helperService: helperService, $sce: $sce });
	  this.videoUrl = this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/5aov7rXM3Vw?enablejsapi=1');
	
	  this.lang = 'en';
	
	  this.exercise1 = _exercise2.default[this.lang];
	  this.exercise2 = _exercise4.default[this.lang];
	  this.exercise3 = _exercise6.default[this.lang];
	  this.exercise4 = _exercise8.default[this.lang];
	  this.exercise5 = _exercise10.default[this.lang];
	  this.exercise6 = _exercise12.default[this.lang];
	};
	IdentifyingLogicaOrderController.$inject = ["helperService", "$sce"];
	
	exports.default = IdentifyingLogicaOrderController;

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise1',
	        title: 'To get early warning of market shifts, we need to',
	        titles: ['Define the market segments', ' Assess competitive position in each segment', 'Track changes in position over time'],
	        answers: [{
	            title: 'Have a problem'
	        }, {
	            title: 'Know the solution'
	        }, {
	            title: 'How implement?'
	        }],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: true,
	            box2: false,
	            box3: false
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'The reasoning here is cause-and-effect. If I define the segments, assess competitive position in each segment, and track changes in position over time, I will get early warning of market shifts. The summary of a set of actions is always the direct effect of carrying out the actions.'
	    }
	};

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise2',
	        title: 'Computer installations are down because of internal inefficiencies',
	        titles: ['Insufficient supply of product', ' Underdeveloped marketing plans', ' Unavailable software'],
	        answers: [{
	            title: 'Have a problem'
	        }, {
	            title: 'Know the solution'
	        }, {
	            title: 'How implement?'
	        }],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: false,
	            box2: false,
	            box3: true
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'A company can have both internal inefficiencies and external ones. These three points were originally created by visualizing the process required to install computers (produce the hardware, add the software, develop a marketing plan, sell, service.  The author then classified the first three as Internal Inefficiencies, the others as External Inefficiencies.  Putting the first point first implies that, in the writer’s mind, it is the major cause of the problem.'
	    }
	};

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise3',
	        title: 'We can eliminate losses in the Board Mill Operation',
	        titles: ['Find cheaper supplies of waste paper', 'Cut the cost of board product', 'Close one of the solid case factories'],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: false,
	            box2: true,
	            box3: false
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'The Board Mill operation consists of three waste paper plants, two board production plants, and four solid case factories. The order of the actions reflects the visualization of this structure. The fact that the structure shows the operations in process order is not relevant. The ideas are not in time order, nor in degree order, but in the order in which they appear on the structure.'
	    }
	};

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise4',
	        title: 'Telecom’s billing system must be designed to be useful to all parties',
	        titles: ['Meet outside customer needs', 'Satisfy internal management requirements', 'Conform to outside regulations'],
	        answers: [{
	            title: 'Have a problem'
	        }, {
	            title: 'Know the solution'
	        }, {
	            title: 'How implement?'
	        }],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: true,
	            box2: false,
	            box3: false
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'This is another example of time order.  The billing system must have all three components (produce figures for management, produce figures for the customer, produce figures for the regulators), but the design should reflect consideration of what’s easiest for the customer before thinking about the other users.'
	    }
	};

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise5',
	        title: 'We need to determine whether to manage freight internally',
	        titles: ['Build a model of the cost structure if we do it internally', 'Determine cost/service differences of doing it externally', 'Document the differences'],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: true,
	            box2: false,
	            box3: false
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'Time order, again based on visualizing a cause-effect process.  You build the model, assess the differences, and then document them, so that you can determine whether to manage freight internally.'
	    }
	};

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    en: {
	        id: 'exercise6',
	        title: 'You should not consider a vendor capture strategy',
	        titles: [' Your warehouses are neither large enough nor ideally located', 'Even if they were, the approach requires double handling', 'Even if you accept that, the possible admin-mileage savings are negligible'],
	        boxes: [{
	            name: 'box1',
	            title: 'Time'
	        }, {
	            name: 'box2',
	            title: 'Structure'
	        }, {
	            name: 'box3',
	            title: 'Degree'
	        }],
	        correctAnswers: {
	            box1: false,
	            box2: true,
	            box3: false
	        },
	        userAnswers: {
	            box1: false,
	            box2: false,
	            box3: false
	        },
	        text: 'This is a particular form of structural order.  You imagine yourself going first to the location, then inside the building to look at the approach, then inside the approach to assess the savings that result.  I call this a “vertical” structure, in contrast to the “horizontal” structure illustrated in the Board Mill example above.'
	    }
	};

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(845);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./identifyingLogicaOrder.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./identifyingLogicaOrder.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(2);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _header = __webpack_require__(847);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _nav = __webpack_require__(851);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _footer = __webpack_require__(854);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _stepDiagram = __webpack_require__(857);
	
	var _stepDiagram2 = _interopRequireDefault(_stepDiagram);
	
	var _stepDiagram3 = __webpack_require__(860);
	
	var _stepDiagram4 = _interopRequireDefault(_stepDiagram3);
	
	var _scqDiagram = __webpack_require__(863);
	
	var _scqDiagram2 = _interopRequireDefault(_scqDiagram);
	
	var _scqDiagram3 = __webpack_require__(866);
	
	var _scqDiagram4 = _interopRequireDefault(_scqDiagram3);
	
	var _scqDiagramDndFramework = __webpack_require__(871);
	
	var _scqDiagramDndFramework2 = _interopRequireDefault(_scqDiagramDndFramework);
	
	var _highlightDiagram = __webpack_require__(874);
	
	var _highlightDiagram2 = _interopRequireDefault(_highlightDiagram);
	
	var _checkboxDiagram = __webpack_require__(877);
	
	var _checkboxDiagram2 = _interopRequireDefault(_checkboxDiagram);
	
	var _pyramidBuilder = __webpack_require__(882);
	
	var _pyramidBuilder2 = _interopRequireDefault(_pyramidBuilder);
	
	var _magnifier = __webpack_require__(886);
	
	var _magnifier2 = _interopRequireDefault(_magnifier);
	
	var _arrowTooltip = __webpack_require__(891);
	
	var _arrowTooltip2 = _interopRequireDefault(_arrowTooltip);
	
	var _fullWordingIntroductionPaper = __webpack_require__(896);
	
	var _fullWordingIntroductionPaper2 = _interopRequireDefault(_fullWordingIntroductionPaper);
	
	var _treeRenderer = __webpack_require__(901);
	
	var _treeRenderer2 = _interopRequireDefault(_treeRenderer);
	
	var _buttonDraggable = __webpack_require__(917);
	
	var _buttonDraggable2 = _interopRequireDefault(_buttonDraggable);
	
	var _button = __webpack_require__(918);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _numberMinMax = __webpack_require__(920);
	
	var _numberMinMax2 = _interopRequireDefault(_numberMinMax);
	
	var _factory = __webpack_require__(921);
	
	var _diagram = __webpack_require__(923);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(928);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	var _diagram5 = __webpack_require__(931);
	
	var _diagram6 = _interopRequireDefault(_diagram5);
	
	var _diagram7 = __webpack_require__(934);
	
	var _diagram8 = _interopRequireDefault(_diagram7);
	
	var _diagram9 = __webpack_require__(939);
	
	var _diagram10 = _interopRequireDefault(_diagram9);
	
	var _diagram11 = __webpack_require__(944);
	
	var _diagram12 = _interopRequireDefault(_diagram11);
	
	var _diagram13 = __webpack_require__(947);
	
	var _diagram14 = _interopRequireDefault(_diagram13);
	
	var _diagram15 = __webpack_require__(950);
	
	var _diagram16 = _interopRequireDefault(_diagram15);
	
	var _diagram17 = __webpack_require__(955);
	
	var _diagram18 = _interopRequireDefault(_diagram17);
	
	var _diagram19 = __webpack_require__(960);
	
	var _diagram20 = _interopRequireDefault(_diagram19);
	
	var _diagram21 = __webpack_require__(964);
	
	var _diagram22 = _interopRequireDefault(_diagram21);
	
	var _diagram23 = __webpack_require__(967);
	
	var _diagram24 = _interopRequireDefault(_diagram23);
	
	var _diagram25 = __webpack_require__(970);
	
	var _diagram26 = _interopRequireDefault(_diagram25);
	
	var _diagram27 = __webpack_require__(976);
	
	var _diagram28 = _interopRequireDefault(_diagram27);
	
	var _diagram29 = __webpack_require__(982);
	
	var _diagram30 = _interopRequireDefault(_diagram29);
	
	var _diagram31 = __webpack_require__(987);
	
	var _diagram32 = _interopRequireDefault(_diagram31);
	
	var _diagram33 = __webpack_require__(992);
	
	var _diagram34 = _interopRequireDefault(_diagram33);
	
	var _diagram35 = __webpack_require__(997);
	
	var _diagram36 = _interopRequireDefault(_diagram35);
	
	var _diagram37 = __webpack_require__(1002);
	
	var _diagram38 = _interopRequireDefault(_diagram37);
	
	var _diagram39 = __webpack_require__(1007);
	
	var _diagram40 = _interopRequireDefault(_diagram39);
	
	var _diagram41 = __webpack_require__(1012);
	
	var _diagram42 = _interopRequireDefault(_diagram41);
	
	var _diagram43 = __webpack_require__(1017);
	
	var _diagram44 = _interopRequireDefault(_diagram43);
	
	var _diagram45 = __webpack_require__(1022);
	
	var _diagram46 = _interopRequireDefault(_diagram45);
	
	var _diagram47 = __webpack_require__(1027);
	
	var _diagram48 = _interopRequireDefault(_diagram47);
	
	var _diagram49 = __webpack_require__(1032);
	
	var _diagram50 = _interopRequireDefault(_diagram49);
	
	var _diagram51 = __webpack_require__(1037);
	
	var _diagram52 = _interopRequireDefault(_diagram51);
	
	var _diagram53 = __webpack_require__(1042);
	
	var _diagram54 = _interopRequireDefault(_diagram53);
	
	var _diagram55 = __webpack_require__(1047);
	
	var _diagram56 = _interopRequireDefault(_diagram55);
	
	var _diagram57 = __webpack_require__(1052);
	
	var _diagram58 = _interopRequireDefault(_diagram57);
	
	var _diagram59 = __webpack_require__(1057);
	
	var _diagram60 = _interopRequireDefault(_diagram59);
	
	var _diagram61 = __webpack_require__(1062);
	
	var _diagram62 = _interopRequireDefault(_diagram61);
	
	var _diagram63 = __webpack_require__(1067);
	
	var _diagram64 = _interopRequireDefault(_diagram63);
	
	var _diagram65 = __webpack_require__(1072);
	
	var _diagram66 = _interopRequireDefault(_diagram65);
	
	var _diagram67 = __webpack_require__(1077);
	
	var _diagram68 = _interopRequireDefault(_diagram67);
	
	var _diagram69 = __webpack_require__(1082);
	
	var _diagram70 = _interopRequireDefault(_diagram69);
	
	var _diagram71 = __webpack_require__(1087);
	
	var _diagram72 = _interopRequireDefault(_diagram71);
	
	var _diagram73 = __webpack_require__(1092);
	
	var _diagram74 = _interopRequireDefault(_diagram73);
	
	var _diagram75 = __webpack_require__(1097);
	
	var _diagram76 = _interopRequireDefault(_diagram75);
	
	var _diagram77 = __webpack_require__(1102);
	
	var _diagram78 = _interopRequireDefault(_diagram77);
	
	var _diagram79 = __webpack_require__(1107);
	
	var _diagram80 = _interopRequireDefault(_diagram79);
	
	var _diagram81 = __webpack_require__(1113);
	
	var _diagram82 = _interopRequireDefault(_diagram81);
	
	var _diagram83 = __webpack_require__(1118);
	
	var _diagram84 = _interopRequireDefault(_diagram83);
	
	var _diagram85 = __webpack_require__(1123);
	
	var _diagram86 = _interopRequireDefault(_diagram85);
	
	var _diagram87 = __webpack_require__(1128);
	
	var _diagram88 = _interopRequireDefault(_diagram87);
	
	var _diagram89 = __webpack_require__(1133);
	
	var _diagram90 = _interopRequireDefault(_diagram89);
	
	var _diagram91 = __webpack_require__(1138);
	
	var _diagram92 = _interopRequireDefault(_diagram91);
	
	var _diagram93 = __webpack_require__(1143);
	
	var _diagram94 = _interopRequireDefault(_diagram93);
	
	var _diagram95 = __webpack_require__(1148);
	
	var _diagram96 = _interopRequireDefault(_diagram95);
	
	var _diagram97 = __webpack_require__(1153);
	
	var _diagram98 = _interopRequireDefault(_diagram97);
	
	var _diagram99 = __webpack_require__(1158);
	
	var _diagram100 = _interopRequireDefault(_diagram99);
	
	var _diagram101 = __webpack_require__(1163);
	
	var _diagram102 = _interopRequireDefault(_diagram101);
	
	var _diagram103 = __webpack_require__(1168);
	
	var _diagram104 = _interopRequireDefault(_diagram103);
	
	var _diagram105 = __webpack_require__(1173);
	
	var _diagram106 = _interopRequireDefault(_diagram105);
	
	var _diagram107 = __webpack_require__(1178);
	
	var _diagram108 = _interopRequireDefault(_diagram107);
	
	var _diagram109 = __webpack_require__(1183);
	
	var _diagram110 = _interopRequireDefault(_diagram109);
	
	var _diagram111 = __webpack_require__(1188);
	
	var _diagram112 = _interopRequireDefault(_diagram111);
	
	var _diagram113 = __webpack_require__(1193);
	
	var _diagram114 = _interopRequireDefault(_diagram113);
	
	var _diagram115 = __webpack_require__(1198);
	
	var _diagram116 = _interopRequireDefault(_diagram115);
	
	var _diagram117 = __webpack_require__(1203);
	
	var _diagram118 = _interopRequireDefault(_diagram117);
	
	var _diagram119 = __webpack_require__(1208);
	
	var _diagram120 = _interopRequireDefault(_diagram119);
	
	var _diagram121 = __webpack_require__(1213);
	
	var _diagram122 = _interopRequireDefault(_diagram121);
	
	var _diagram123 = __webpack_require__(1218);
	
	var _diagram124 = _interopRequireDefault(_diagram123);
	
	var _diagram125 = __webpack_require__(1223);
	
	var _diagram126 = _interopRequireDefault(_diagram125);
	
	var _diagram127 = __webpack_require__(1228);
	
	var _diagram128 = _interopRequireDefault(_diagram127);
	
	var _diagram129 = __webpack_require__(1233);
	
	var _diagram130 = _interopRequireDefault(_diagram129);
	
	var _diagram131 = __webpack_require__(1238);
	
	var _diagram132 = _interopRequireDefault(_diagram131);
	
	var _diagram133 = __webpack_require__(1243);
	
	var _diagram134 = _interopRequireDefault(_diagram133);
	
	var _diagram135 = __webpack_require__(1248);
	
	var _diagram136 = _interopRequireDefault(_diagram135);
	
	var _diagram137 = __webpack_require__(1253);
	
	var _diagram138 = _interopRequireDefault(_diagram137);
	
	var _diagram139 = __webpack_require__(1258);
	
	var _diagram140 = _interopRequireDefault(_diagram139);
	
	var _diagram141 = __webpack_require__(1263);
	
	var _diagram142 = _interopRequireDefault(_diagram141);
	
	var _diagram143 = __webpack_require__(1268);
	
	var _diagram144 = _interopRequireDefault(_diagram143);
	
	var _diagram145 = __webpack_require__(1273);
	
	var _diagram146 = _interopRequireDefault(_diagram145);
	
	var _diagram147 = __webpack_require__(1278);
	
	var _diagram148 = _interopRequireDefault(_diagram147);
	
	var _diagram149 = __webpack_require__(1283);
	
	var _diagram150 = _interopRequireDefault(_diagram149);
	
	var _diagram151 = __webpack_require__(1288);
	
	var _diagram152 = _interopRequireDefault(_diagram151);
	
	var _diagram153 = __webpack_require__(1293);
	
	var _diagram154 = _interopRequireDefault(_diagram153);
	
	var _diagram155 = __webpack_require__(1298);
	
	var _diagram156 = _interopRequireDefault(_diagram155);
	
	var _diagram157 = __webpack_require__(1303);
	
	var _diagram158 = _interopRequireDefault(_diagram157);
	
	var _diagram159 = __webpack_require__(1308);
	
	var _diagram160 = _interopRequireDefault(_diagram159);
	
	var _diagram161 = __webpack_require__(1313);
	
	var _diagram162 = _interopRequireDefault(_diagram161);
	
	var _diagram163 = __webpack_require__(1318);
	
	var _diagram164 = _interopRequireDefault(_diagram163);
	
	var _diagram165 = __webpack_require__(1323);
	
	var _diagram166 = _interopRequireDefault(_diagram165);
	
	var _diagram167 = __webpack_require__(1328);
	
	var _diagram168 = _interopRequireDefault(_diagram167);
	
	var _diagram169 = __webpack_require__(1333);
	
	var _diagram170 = _interopRequireDefault(_diagram169);
	
	var _diagram171 = __webpack_require__(1338);
	
	var _diagram172 = _interopRequireDefault(_diagram171);
	
	var _diagram173 = __webpack_require__(1343);
	
	var _diagram174 = _interopRequireDefault(_diagram173);
	
	var _diagram175 = __webpack_require__(1348);
	
	var _diagram176 = _interopRequireDefault(_diagram175);
	
	var _diagram177 = __webpack_require__(1353);
	
	var _diagram178 = _interopRequireDefault(_diagram177);
	
	var _diagram179 = __webpack_require__(1358);
	
	var _diagram180 = _interopRequireDefault(_diagram179);
	
	var _diagram181 = __webpack_require__(1363);
	
	var _diagram182 = _interopRequireDefault(_diagram181);
	
	var _diagram183 = __webpack_require__(1368);
	
	var _diagram184 = _interopRequireDefault(_diagram183);
	
	var _diagram185 = __webpack_require__(1373);
	
	var _diagram186 = _interopRequireDefault(_diagram185);
	
	var _diagram187 = __webpack_require__(1378);
	
	var _diagram188 = _interopRequireDefault(_diagram187);
	
	var _diagram189 = __webpack_require__(1383);
	
	var _diagram190 = _interopRequireDefault(_diagram189);
	
	var _diagram191 = __webpack_require__(1388);
	
	var _diagram192 = _interopRequireDefault(_diagram191);
	
	var _diagram193 = __webpack_require__(1394);
	
	var _diagram194 = _interopRequireDefault(_diagram193);
	
	var _diagram195 = __webpack_require__(1399);
	
	var _diagram196 = _interopRequireDefault(_diagram195);
	
	var _diagram197 = __webpack_require__(1404);
	
	var _diagram198 = _interopRequireDefault(_diagram197);
	
	var _diagram199 = __webpack_require__(1409);
	
	var _diagram200 = _interopRequireDefault(_diagram199);
	
	var _diagram201 = __webpack_require__(1414);
	
	var _diagram202 = _interopRequireDefault(_diagram201);
	
	var _diagram203 = __webpack_require__(1419);
	
	var _diagram204 = _interopRequireDefault(_diagram203);
	
	var _diagram205 = __webpack_require__(1424);
	
	var _diagram206 = _interopRequireDefault(_diagram205);
	
	var _diagram207 = __webpack_require__(1429);
	
	var _diagram208 = _interopRequireDefault(_diagram207);
	
	var _diagram209 = __webpack_require__(1434);
	
	var _diagram210 = _interopRequireDefault(_diagram209);
	
	var _diagram211 = __webpack_require__(1439);
	
	var _diagram212 = _interopRequireDefault(_diagram211);
	
	var _diagram213 = __webpack_require__(1444);
	
	var _diagram214 = _interopRequireDefault(_diagram213);
	
	var _diagram215 = __webpack_require__(1449);
	
	var _diagram216 = _interopRequireDefault(_diagram215);
	
	var _diagram217 = __webpack_require__(1454);
	
	var _diagram218 = _interopRequireDefault(_diagram217);
	
	var _diagram219 = __webpack_require__(1459);
	
	var _diagram220 = _interopRequireDefault(_diagram219);
	
	var _diagram221 = __webpack_require__(1464);
	
	var _diagram222 = _interopRequireDefault(_diagram221);
	
	var _diagram223 = __webpack_require__(1469);
	
	var _diagram224 = _interopRequireDefault(_diagram223);
	
	var _diagram225 = __webpack_require__(1474);
	
	var _diagram226 = _interopRequireDefault(_diagram225);
	
	var _diagram227 = __webpack_require__(1479);
	
	var _diagram228 = _interopRequireDefault(_diagram227);
	
	var _carouselSlider = __webpack_require__(1484);
	
	var _carouselSlider2 = _interopRequireDefault(_carouselSlider);
	
	var _introductionPopup = __webpack_require__(1489);
	
	var _introductionPopup2 = _interopRequireDefault(_introductionPopup);
	
	var _testDrivePopup = __webpack_require__(1494);
	
	var _testDrivePopup2 = _interopRequireDefault(_testDrivePopup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Popups
	
	
	//Unit 5 diagrams
	
	
	//Unit 3 diagrams
	
	
	//Unit 2 diagrams
	
	
	// Tree diagram
	var components = _angular2.default.module('minto.components', []);
	
	// Tree diagram
	
	
	//Carousel
	
	
	//Unit 4 diagrams
	
	//end
	
	//Unit 1 diagrams
	components.factory('treeDiagramRendererFactory', _factory.treeDiagramRendererFactory);
	components.factory('treeDiagramFactory', _factory.treeDiagramFactory);
	components.directive('treeDiagram', _treeRenderer2.default);
	components.directive('buttonDraggable', _buttonDraggable2.default);
	components.directive('button', _button2.default);
	components.directive('numberMinMax', _numberMinMax2.default);
	// end
	
	components.component('moHeader', _header2.default);
	components.component('moNav', _nav2.default);
	components.component('moFooter', _footer2.default);
	
	components.component('stepDiagram', _stepDiagram2.default);
	components.component('stepDiagram2', _stepDiagram4.default);
	components.component('scqDiagram', _scqDiagram2.default);
	components.component('scqDiagramDnd', _scqDiagram4.default);
	components.component('scqDiagramDndFramework', _scqDiagramDndFramework2.default);
	components.component('highlightDiagram', _highlightDiagram2.default);
	components.component('checkboxDiagram', _checkboxDiagram2.default);
	components.component('pyramidBuilder', _pyramidBuilder2.default);
	components.component('magnifierComponent', _magnifier2.default);
	components.component('arrowTooltipComponent', _arrowTooltip2.default);
	components.component('fullWordingIntroductionPaper', _fullWordingIntroductionPaper2.default);
	
	//
	// Popups
	components.component('introductionPopup', _introductionPopup2.default);
	components.component('testDrivePopup', _testDrivePopup2.default);
	
	//
	// 1A
	components.component('modiagram11A1Ex1', _diagram2.default);
	components.component('modiagram11A1Ex2', _diagram4.default);
	components.component('modiagram11A1Ex3', _diagram6.default);
	components.component('modiagram11A1Ex4', _diagram8.default);
	
	//
	// 1B
	components.component('modiagram11B1Ex1', _diagram10.default);
	components.component('modiagram11B1Ex2', _diagram12.default);
	components.component('modiagram11B1Ex3', _diagram14.default);
	components.component('modiagram11B1Ex4', _diagram16.default);
	
	//
	// 1C
	components.component('modiagram11C1Ex1', _diagram18.default);
	components.component('modiagram11C1Ex2', _diagram20.default);
	components.component('modiagram11C1Ex3', _diagram22.default);
	components.component('modiagram11C1Ex4', _diagram24.default);
	
	//
	// 1D
	components.component('modiagram11D1Ex1', _diagram26.default);
	components.component('modiagram11D1Ex2', _diagram28.default);
	components.component('modiagram11D1Ex3', _diagram30.default);
	components.component('modiagram11D1Ex4', _diagram32.default);
	components.component('modiagram11D1Ex5', _diagram34.default);
	
	//
	// 2B
	components.component('modiagram22B1Ex1', _diagram36.default);
	components.component('modiagram22B1Ex2', _diagram38.default);
	components.component('modiagram22B1Ex3', _diagram40.default);
	components.component('modiagram22B1Ex4', _diagram42.default);
	components.component('modiagram22B1Ex5', _diagram44.default);
	components.component('modiagram22B1Ex6', _diagram46.default);
	components.component('modiagram22B1Ex7', _diagram48.default);
	components.component('modiagram22B1Ex72', _diagram50.default);
	components.component('modiagram22B1Ex8', _diagram52.default);
	components.component('modiagram22B1Ex9', _diagram54.default);
	
	//
	// 3A1
	components.component('modiagram33A1Ex1', _diagram56.default);
	components.component('modiagram33A1Ex2', _diagram58.default);
	components.component('modiagram33A1Ex3', _diagram60.default);
	components.component('modiagram33A1Ex4', _diagram62.default);
	components.component('modiagram33A1Ex5', _diagram64.default);
	components.component('modiagram33A1Ex6', _diagram66.default);
	components.component('modiagram33A1Ex7', _diagram68.default);
	components.component('modiagram33A1Ex8', _diagram70.default);
	components.component('modiagram33A1Ex9', _diagram72.default);
	components.component('modiagram33A1Ex10', _diagram74.default);
	components.component('modiagram33A1Ex11', _diagram76.default);
	components.component('modiagram33A1Ex12', _diagram78.default);
	// 3A2
	components.component('modiagram33A2Ex1', _diagram80.default);
	components.component('modiagram33A2Ex2', _diagram82.default);
	components.component('modiagram33A2Ex3', _diagram84.default);
	components.component('modiagram33A2Ex4', _diagram86.default);
	components.component('modiagram33A2Ex5', _diagram88.default);
	// 3A3
	components.component('modiagram33A3Ex1', _diagram90.default);
	components.component('modiagram33A3Ex2', _diagram92.default);
	components.component('modiagram33A3Ex3', _diagram94.default);
	components.component('modiagram33A3Ex4', _diagram96.default);
	components.component('modiagram33A3Ex5', _diagram98.default);
	components.component('modiagram33A3Ex6', _diagram100.default);
	// 3B1
	components.component('modiagram33B1Ex1', _diagram102.default);
	components.component('modiagram33B1Ex2', _diagram104.default);
	components.component('modiagram33B1Ex3', _diagram106.default);
	components.component('modiagram33B1Ex4', _diagram108.default);
	components.component('modiagram33B1Ex5', _diagram110.default);
	components.component('modiagram33B1Ex6', _diagram112.default);
	components.component('modiagram33B1Ex7', _diagram114.default);
	// 3B2
	components.component('modiagram33B2Ex1', _diagram116.default);
	components.component('modiagram33B2Ex2', _diagram118.default);
	components.component('modiagram33B2Ex3', _diagram120.default);
	components.component('modiagram33B2Ex4', _diagram122.default);
	components.component('modiagram33B2Ex5', _diagram124.default);
	// 3B3
	components.component('modiagram33B3Ex1', _diagram126.default);
	components.component('modiagram33B3Ex2', _diagram128.default);
	components.component('modiagram33B3Ex3', _diagram130.default);
	components.component('modiagram33B3Ex4', _diagram132.default);
	components.component('modiagram33B3Ex5', _diagram134.default);
	components.component('modiagram33B3Ex6', _diagram136.default);
	components.component('modiagram33B3Ex7', _diagram138.default);
	// 3B4
	components.component('modiagram33B4Ex1', _diagram140.default);
	components.component('modiagram33B4Ex2', _diagram142.default);
	components.component('modiagram33B4Ex3', _diagram144.default);
	components.component('modiagram33B4Ex4', _diagram146.default);
	components.component('modiagram33B4Ex5', _diagram148.default);
	
	//
	// 4a
	components.component('modiagram44aEx1', _diagram150.default);
	components.component('modiagram44aEx2', _diagram152.default);
	components.component('modiagram44aEx3', _diagram154.default);
	components.component('modiagram44aEx4', _diagram156.default);
	components.component('modiagram44aEx5', _diagram158.default);
	
	//
	// 4B1
	components.component('modiagram44B1Ex1', _diagram160.default);
	components.component('modiagram44B1Ex2', _diagram162.default);
	//
	// 4B2
	components.component('modiagram44B2Ex1', _diagram164.default);
	components.component('modiagram44B2Ex2', _diagram166.default);
	components.component('modiagram44B2Ex3', _diagram168.default);
	components.component('modiagram44B2Ex4', _diagram170.default);
	components.component('modiagram44B2Ex5', _diagram172.default);
	components.component('modiagram44B2Ex6', _diagram174.default);
	//
	// 4C
	components.component('modiagram44C1Ex1', _diagram176.default);
	components.component('modiagram44C1Ex2', _diagram178.default);
	components.component('modiagram44C1Ex3', _diagram180.default);
	components.component('modiagram44C1Ex4', _diagram182.default);
	//
	// 5A
	components.component('modiagram55A1Ex1', _diagram184.default);
	components.component('modiagram55A1Ex2', _diagram186.default);
	components.component('modiagram55A1Ex3', _diagram188.default);
	//
	// 5B
	components.component('modiagram55B1Ex1', _diagram190.default);
	components.component('modiagram55B1Ex2', _diagram192.default);
	components.component('modiagram55B1Ex3', _diagram194.default);
	components.component('modiagram55B1Ex4', _diagram196.default);
	components.component('modiagram55B1Ex5', _diagram198.default);
	components.component('modiagram55B1Ex6', _diagram200.default);
	//
	// 5C
	components.component('modiagram55C1Ex1', _diagram202.default);
	components.component('modiagram55C1Ex2', _diagram204.default);
	components.component('modiagram55C1Ex3', _diagram206.default);
	components.component('modiagram55C1Ex4', _diagram208.default);
	components.component('modiagram55C1Ex5', _diagram210.default);
	components.component('modiagram55C1Ex6', _diagram212.default);
	components.component('modiagram55C1Ex7', _diagram214.default);
	components.component('modiagram55C1Ex8', _diagram216.default);
	//
	// 5D
	components.component('modiagram55D1Ex1', _diagram218.default);
	components.component('modiagram55D1Ex2', _diagram220.default);
	components.component('modiagram55D1Ex3', _diagram222.default);
	components.component('modiagram55D1Ex4', _diagram224.default);
	components.component('modiagram55D1Ex5', _diagram226.default);
	components.component('modiagram55D1Ex6', _diagram228.default);
	//
	// Carousel slider
	components.component('carouselSlider', _carouselSlider2.default);
	
	exports.default = components;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _header = __webpack_require__(848);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _header3 = __webpack_require__(849);
	
	var _header4 = _interopRequireDefault(_header3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './courseHeader.scss';
	
	var headerComponent = {
	  bindings: {
	    title: '@'
	  },
	  controllerAs: 'vm',
	  template: _header2.default,
	  controller: _header4.default
	};
	
	exports.default = headerComponent;

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports = "<header class=\"header CoverImage FlexEmbed FlexEmbed--3by1\" id=\"top-header\">\n    <div class=\"header-box wrapper\">\n        <a class=\"header-logo\" tabindex=\"-1\" ui-sref=\"site.homepage\" ng-include\n            src=\"'/assets/images/minto_logo_white.svg'\"></a>\n        <p ng-if=\"vm.title\" class=\"header-caption\" ng-bind=\"'header.' + vm.title | translate\"></p>\n        <p class=\"header-version\">{{vm.version}}</p>\n    </div>\n</header>"

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _versions = __webpack_require__(850);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeaderController = function HeaderController() {
	    "ngInject";
	
	    (0, _classCallCheck3.default)(this, HeaderController);
	    this.version = "version: " + _versions.versions.version;
	};
	
	exports.default = HeaderController;

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var versions = exports.versions = { version: '1.0.1322' };

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _nav = __webpack_require__(852);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _nav3 = __webpack_require__(853);
	
	var _nav4 = _interopRequireDefault(_nav3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './nav.sass';
	
	var navComponent = {
	  bindings: {
	    sticky: '<'
	  },
	  controllerAs: 'vm',
	  template: _nav2.default,
	  controller: _nav4.default
	};
	
	exports.default = navComponent;

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports = "<aside class=\"side-nav-box\">\n\t<nav class=\"side-nav\" ng-class=\"{'side-nav--stickytop': vm.sticky}\">\n\t\t<a ui-sref-active=\"side-nav__item--current\" ui-sref=\"site.{{item}}\" ng-repeat=\"item in vm.navItems\" class=\"side-nav__item\"\n\t\t ng-bind=\"::'nav.' + item | translate\"></a>\n\t</nav>\n</aside>"

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavController = function () {
	  NavController.$inject = ["$state"];
	  function NavController($state) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, NavController);
	    this.$state = $state;
	    this.navItems = ['concept', 'live_course', 'online_course', 'workbook_course', 'summary_app', 'textbook', 'barbara_minto', 'contact'];
	  }
	
	  (0, _createClass3.default)(NavController, [{
	    key: 'goTo',
	    value: function goTo(item) {
	      this.$state.go('site.' + item);
	    }
	  }]);
	  return NavController;
	}();
	
	exports.default = NavController;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _footer = __webpack_require__(855);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _footer3 = __webpack_require__(856);
	
	var _footer4 = _interopRequireDefault(_footer3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var footerComponent = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _footer2.default,
	  controller: _footer4.default
	};
	
	exports.default = footerComponent;

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports = "<footer class=\"footer\">\n  <div class=\"footer-container\">\n    <img class=\"footer-logo\" src=\"/assets/images/footer-logo.png\" alt=\"Minto Logo\" ng-click=\"vm.handleGotoAnchor()\">\n    <div>\n      <ul class=\"footer-list\">\n        <!--<li>Terms & Conditions</li>-->\n        <li>Privacy Policy</li>\n      </ul>\n      <ul class=\"footer-list\">\n        <li>Minto Books International,</li>\n        <li class=\"footer-list__small-left-indent\">Inc. 19 Cadogan Place,</li>\n        <li class=\"footer-list__small-left-indent\">London,</li>\n        <li class=\"footer-list__small-left-indent\">SW1X 9SA,</li>\n        <li class=\"footer-list__small-left-indent\">UK</li>\n        <li class=\"footer-list__item-left-indent\">\n          <a tabindex=\"-1\" href=\"tel:+44 (0)207 235 6274\">Tel: +44 (0)207 235 6274</a>\n        </li>\n        <li class=\"footer-list__item-left-indent\">\n          <a tabindex=\"-1\" ui-sref=\"site.contact\" class=\"finish-button\">Contact us</a>\n        </li>\n      </ul>\n    </div>\n\n    <!--<nav class=\"footer-nav\">-->\n      <!--&lt;!&ndash;<a ui-sref=\"auth.login\" ng-if=\"!vm.authService.authenticated\" class=\"footer-nav__item footer-nav__item__login\" ng-bind=\"'footer.logIn' | translate\"></a>&ndash;&gt;-->\n      <!--<a ng-click=\"vm.logOut()\" ng-if=\"vm.authService.authenticated\" class=\"footer-nav__item\" ng-bind=\"'footer.logOut' | translate\"></a>-->\n      <!--<a ui-sref=\"site.press\" class=\"footer-nav__item\" ng-bind=\"'footer.press' | translate\"></a>-->\n      <!--<a ui-sref=\"site.tc\" class=\"footer-nav__item\" ng-bind=\"'footer.tc' | translate\"></a>-->\n      <!--<a ui-sref=\"site.policies\" class=\"footer-nav__item\" ng-bind=\"'footer.policies' | translate\"></a>-->\n      <!--<div class=\"footer-subnav language__select\">-->\n\n        <!--<a href=\"\" class=\"footer-nav__item\" ng-bind=\"'footer.language' | translate\"></a>-->\n        <!--<img src=\"/assets/images/footer-checkbox.png\" alt=\"\" class=\"footer-subnav__img1\">-->\n\n        <!--<div class=\"drop-up\">-->\n          <!--<div class=\"drop-up-container\">-->\n            <!--&lt;!&ndash;<select name=\"repeatSelect\" id=\"repeatSelect\" ng-model=\"vm.activeLanguage\" ng-change=\"vm.changeLanguage()\">-->\n              <!--<option ng-repeat=\"item in vm.languages\" value=\"{{item.key}}\" ng-bind=\"item.value\"></option>-->\n            <!--</select>&ndash;&gt;-->\n            <!--<div class=\"lang-container\" ng-repeat=\"item in vm.languages\">-->\n              <!--<label ng-bind=\"item.value\"></label>-->\n              <!--<input ng-change=\"vm.changeLanguage()\" id=\"{{item.key}}\" type=\"radio\" name=\"lang\" value=\"{{item.key}}\" ng-model=\"vm.activeLanguage\">-->\n            <!--</div>-->\n            <!--&lt;!&ndash;<div class=\"lang-container\">-->\n              <!--<label for=\"es\">Spanish</label>-->\n              <!--<input ng-change=\"vm.changeLanguage()\" id=\"es\" type=\"radio\" name=\"lang\" value=\"{{item.key}}\" ng-model=\"vm.activeLanguage\">-->\n            <!--</div>&ndash;&gt;-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n      <!--<div class=\"footer-subnav share-buttons\">-->\n        <!--<a href=\"\" class=\"footer-nav__item\" ng-bind=\"'footer.share' | translate\"></a>-->\n        <!--<img src=\"/assets/images/footer-checkbox.png\" alt=\"\" class=\"footer-subnav__img2\">-->\n        <!--<div class=\"drop-up\">-->\n          <!--<div class=\"drop-up-container\">-->\n            <!--<div class=\"fb-share-button\" data-href=\"http://barbaraminto.com\" data-layout=\"button\" data-size=\"small\" data-mobile-iframe=\"true\">-->\n              <!--<a class=\"fb-xfbml-parse-ignore\" target=\"_blank\" href=\"https://www.facebook.com/sharer/sharer.php?u=http%3A%2F%2Fbarbaraminto.com%2F&amp;src=sdkpreparse\">Share</a>-->\n            <!--</div>-->\n            <!--<a class=\"twitter-share-button\" href=\"https://twitter.com/intent/tweet\">Tweet</a>-->\n            <!--<script type=\"IN/Share\"></script>-->\n          <!--</div>-->\n        <!--</div>-->\n      <!--</div>-->\n    <!--</nav>-->\n  </div>\n</footer>\n"

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _uiHelper = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterController = function () {
	  FooterController.$inject = ["$translate", "authService", "helperService"];
	  function FooterController($translate, authService, helperService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FooterController);
	    (0, _assign2.default)(this, { $translate: $translate, authService: authService, helperService: helperService });
	  }
	
	  (0, _createClass3.default)(FooterController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.helperService.getCurrentLang().then(function (lang) {
	        return _this.activeLanguage = lang;
	      });
	      this.languages = [{ key: 'en', value: 'English' }, { key: 'es', value: 'Spanish' }];
	    }
	  }, {
	    key: 'logOut',
	    value: function logOut() {
	      this.authService.logOut();
	    }
	  }, {
	    key: 'changeLanguage',
	    value: function changeLanguage() {
	      this.helperService.changeLanguage(this.activeLanguage);
	    }
	  }, {
	    key: 'handleGotoAnchor',
	    value: function handleGotoAnchor() {
	      (0, _uiHelper.gotoAnchor)('header');
	    }
	  }]);
	  return FooterController;
	}();
	
	exports.default = FooterController;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stepDiagram = __webpack_require__(858);
	
	var _stepDiagram2 = _interopRequireDefault(_stepDiagram);
	
	var _stepDiagram3 = __webpack_require__(859);
	
	var _stepDiagram4 = _interopRequireDefault(_stepDiagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stepDiagramComponent = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _stepDiagram2.default,
	  controller: _stepDiagram4.default
	};
	
	exports.default = stepDiagramComponent;

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports = "<div ng-click=\"vm.handleDiagramClick($event)\" class=\"step__diagram\" id=\"{{vm.data.id}}\">\n    <div class=\"step__diagram-header\">\n        <div class=\"step__diagram-title\">{{vm.data.title}}</div>\n    </div>\n\n    <div class=\"diagram-body\" ng-class=\"{showDocument: vm.showDocument}\">\n\n        <div ng-show=\"vm.data.showPaperStep <= vm.currentStateNumber\" class=\"sheet-of-paper\">\n<!--          <div class=\"paper-header\">-->\n<!--            <div>-->\n<!--              <p>TO:</p>-->\n<!--              <p>FROM:</p>-->\n<!--            </div>-->\n<!--            <div>-->\n<!--              <p>DATE:</p>-->\n<!--              <p>SUBJECT:</p>-->\n<!--            </div>-->\n<!--          </div>-->\n\n<!--          <hr class=\"horizontal-line\"/>-->\n\n          <div ng-show=\"vm.data.showPaperStep + 1 <= vm.currentStateNumber\" class=\"correct-paper-answer\" ng-bind-html=\"vm.correctPaperAnswer\"></div>\n\n          <div class=\"student-paper-answer\">\n            <textarea ng-style=\"{color: vm.data.showPaperStep + 1 <= vm.currentStateNumber ? 'gray' : 'black'}\"\n                      ng-model=\"vm.modelValues.paper\"\n                      class=\"student-paper-answer__field\"\n                      placeholder=\"Enter text...\"\n                      rows=\"13\"></textarea>\n          </div>\n        </div>\n\n        <div class=\"diagram-body__diagram\">\n            <div class=\"task-wrapper\">\n                <div ng-hide=\"vm.isFirst || vm.hideInfoBox\" class=\"task\">\n                    <div class=\"task-number\"> <span ng-style=\"vm.number.style\" ng-bind=\"vm.number.text\"></span> </div>\n                    <div class=\"task-title\" ng-hide=\"vm.title.showInput\" ng-style=\"vm.title.style\" ng-bind=\"vm.title.text\"></div>\n                    <textarea ng-show=\"vm.title.showInput\"\n                              style=\"margin-top: 4px; margin-left: 8px; width: 240px;\"\n                              ng-model=\"vm.modelValues.title\"\n                              rows=\"{{vm.title.rows}}\"\n                              ng-value=\"vm.title.text\"\n                              placeholder=\"Enter text...\"\n                              class=\"answers-input\"\n                              type=\"text\" />\n                </div>\n                <div ng-show=\"vm.hideInfoBox\" class=\"task\">\n                    <div class=\"task-title\" ng-class=\"{'end-text-animation': vm.endText.text}\">{{vm.endText.text}}</div>\n                </div>\n                <div ng-if=\"vm.additionalInfoBox.text\" ng-style=\"vm.additionalInfoBox.style\" class=\"task additionalInfoBox\">\n                    <div class=\"task-title\" style=\"opacity: 1\">{{vm.additionalInfoBox.text}}</div>\n                </div>\n            </div>\n            <svg class=\"arrows\" ng-bind-html=\"vm.arrows\">\n            </svg>\n            <div class=\"answers\">\n                <div class=\"answers__box\" ng-mouseenter=\"vm.showStudentAnswer('s', true, true)\" ng-mouseleave=\"vm.showStudentAnswer('s', false, true)\">\n                    <div class=\"answers__box-title\">{{vm.data.sTitle}}</div>\n<!--                    <div ng-hide=\"vm.data.waitPyramidQuestionInput ? !vm.scqTogglerWhenWaitInput.s : vm.s.showInput\" class=\"answers__box-text\"  ng-style=\"vm.s.style\">{{vm.s.text}}</div>-->\n<!--                    <textarea placeholder=\"Enter text...\" ng-show=\"vm.data.waitPyramidQuestionInput ? (vm.s.showInput && vm.scqTogglerWhenWaitInput.s) : vm.s.showInput\" class=\"answers-input\" type=\"text\" />-->\n                  <div ng-hide=\"vm.s.showInput\" class=\"answers__box-text\" ng-style=\"vm.s.style\">{{vm.s.text}}</div>\n                  <textarea ng-model=\"vm.modelValues.s\" placeholder=\"Enter text...\" ng-show=\"vm.s.showInput\" class=\"answers-input\" type=\"text\" />\n                </div>\n                <div class=\"answers__box\" ng-mouseenter=\"vm.showStudentAnswer('c', true, true)\" ng-mouseleave=\"vm.showStudentAnswer('c', false, true)\">\n                    <div class=\"answers__box-title\">{{vm.data.cTitle}}</div>\n                    <div ng-hide=\"vm.c.showInput\" class=\"answers__box-text\" ng-style=\"vm.c.style\">{{vm.c.text}}</div>\n                    <textarea ng-model=\"vm.modelValues.c\" placeholder=\"Enter text...\" ng-show=\"vm.c.showInput\" class=\"answers-input\" type=\"text\" />\n                </div>\n                <div class=\"answers__box\" ng-mouseenter=\"vm.showStudentAnswer('q', true, true)\" ng-mouseleave=\"vm.showStudentAnswer('q', false, true)\">\n                    <div class=\"answers__box-title\">{{vm.data.qTitle}}</div>\n                    <div ng-hide=\"vm.q.showInput\" class=\"answers__box-text\" ng-style=\"vm.q.style\">{{vm.q.text}}</div>\n                    <textarea ng-model=\"vm.modelValues.q\" placeholder=\"Enter text...\" ng-show=\"vm.q.showInput\" class=\"answers-input\" type=\"text\" />\n                </div>\n                <div ng-if=\"vm.showSoWhatText\" class=\"so_what_text\">So what?</div>\n            </div>\n        </div>\n\n        <svg ng-if=\"!vm.data.waitPyramidQuestionInput || pyramidQuestion.length >= 3\"\n             class=\"diagram-body__right-arrows\"\n             ng-hide=\"vm.hideInfoBox\"\n             ng-bind-html=\"vm.rightArrows\">\n        </svg>\n\n        <div class=\"diagram-body__pyramid\">\n            <div class=\"pyramid-question\"\n                 ng-class=\"{'show-pyramid': vm.pyramidQuestion && !vm.hideInfoBox}\"\n                 ng-mouseenter=\"vm.showStudentAnswer('showPyramidQuestionField', true, false)\"\n                 ng-mouseleave=\"vm.showStudentAnswer('showPyramidQuestionField', false, false)\">\n              <p style=\"margin-right: 4px;\">{{vm.data.qTitle}}</p>\n              <p ng-hide=\"vm.showPyramidQuestionField\">{{vm.data.pyramidQuestionText}}</p>\n              <textarea ng-model=\"vm.modelValues.pyramidQuestion\" maxlength=\"12\" placeholder=\"Enter text...\" ng-model=\"pyramidQuestion\" ng-show=\"vm.showPyramidQuestionField\" style=\"margin-top: 1px;\" class=\"answers-input show-pyramid\" type=\"text\" />\n            </div>\n\n            <div class=\"pyramid-box\" style=\"min-height: 142px\">\n                <div\n                  ng-mouseenter=\"vm.showPyramidHead(false)\"\n                  ng-mouseleave=\"vm.showPyramidHead(true)\"\n                >\n                  <p class=\"text\" ng-hide=\"vm.showSchoolSolutionPyramid && vm.pyramid.hideText\" ng-style=\"vm.pyramid.style\">{{vm.pyramid.text}}</p>\n                  <p ng-show=\"vm.showSchoolSolutionPyramid\" style=\"max-width: 100%\" class=\"answers-input\">{{vm.pyramid.headerAnswer}}</p>\n                  <textarea ng-show=\"!vm.showSchoolSolutionPyramid\" ng-model=\"vm.modelValues.pyramidHeader\" style=\"max-width: 100%\" rows=\"4\" placeholder=\"Enter text...\" ng-show=\"vm.pyramid.showInput\" class=\"answers-input\" type=\"text\" />\n                </div>\n                <div ng-if=\"!vm.data.waitPyramidQuestionInput || pyramidQuestion.length >= 3\"\n                     style=\"border-color: black\" class=\"pyramid-box additional-pyramid-box\"\n                     ng-class=\"{'show-pyramid': vm.showAditionalBox}\">\n                  <p class=\"text\">{{vm.data.sTitle + vm.data.additionalBoxText.s}}</p>\n                  <p class=\"text\">{{vm.data.cTitle + vm.data.additionalBoxText.c}}</p>\n                  <p class=\"text\">{{vm.data.qTitle + vm.data.additionalBoxText.q}}</p>\n                </div>\n            </div>\n\n            <div class=\"pyramid-connectors\">\n              <ng-template ng-if=\"vm.showPyramid\" ng-bind-html=\"vm.connectors\"></ng-template>\n            </div>\n\n            <div class=\"pyramid-blocks\"></div>\n\n          <div class=\"pyramid-steps\"\n               ng-class=\"{'show-pyramid': vm.pyramidQuestion && !vm.data.hideStepsText}\">Steps</div>\n        </div>\n    </div>\n\n    <div class=\"step__diagram-slider\">\n        <div ng-click=\"vm.prev()\" ng-disabled=\"vm.isFirst\" class=\"step__diagram-slider__button\">❮ Previous</div>\n        <div ng-click=\"vm.next()\" ng-disabled=\"vm.isLast\" ng-class=\"{'blinking-animation': vm.isBlinkingAnimation}\" class=\"step__diagram-slider__button\">Next ❯</div>\n    </div>\n</div>\n"

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(209);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import statesMockUp from './step-diagram-mockup';
	
	var StepDiagramController = function (_CourseController) {
	  StepDiagramController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$sce", "$scope", "$compile"];
	  (0, _inherits3.default)(StepDiagramController, _CourseController);
	
	  function StepDiagramController(courseService, diagramService, $translate, $timeout, $sce, $scope, $compile) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, StepDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (StepDiagramController.__proto__ || (0, _getPrototypeOf2.default)(StepDiagramController)).call(this, courseService, diagramService, $translate));
	
	    (0, _assign2.default)(_this, { $sce: $sce, $timeout: $timeout, $scope: $scope, $compile: $compile });
	    _this.isStepDiagram = true;
	    _this.currentStateNumber = 0;
	    _this.isFirst = true;
	    _this.isBlinkingAnimation = false;
	    _this.showPyramid = true;
	    _this.showSchoolSolutionPyramid = false;
	    _this.$scope.pyramidQuestion = '';
	    _this.modelValues = {
	      title: '',
	      s: '',
	      c: '',
	      q: '',
	      pyramidQuestion: '',
	      pyramidHeader: '',
	      paper: ''
	    };
	    _this.model = {};
	    return _this;
	  }
	
	  (0, _createClass3.default)(StepDiagramController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      // const arrayOfKeys = ['pyramid','s','c','q','title','number'];
	      // const newStates = Object.assign({}, statesMockUp[this.lang], this.data);
	      // newStates.tasks = statesMockUp[this.lang].tasks.map((item, index) => {
	      //   const state = Object.assign({}, item, this.data.tasks[index]);
	      //   arrayOfKeys.forEach((key) => {
	      //     Object.assign(state[key], item[key]);
	      //   });
	      //   return state;
	      // });
	      // this.data = newStates;
	      this.diagramId = this.data.id;
	      this.clearDiagramId = this.diagramId.replace('exercise', '');
	      this.correctPaperAnswer = this.$sce.trustAsHtml(this.data.correctPaperAnswer);
	      this.connectors = this.$sce.trustAsHtml(this.data.connectors);
	      this.changeState();
	      this.$timeout(function () {
	        _this2.insertPyramidBody();
	      }, 100);
	      if (this.data.waitPyramidQuestionInput) {
	        this.scqTogglerWhenWaitInput = {};
	        var scq = ['s', 'c', 'q'];
	        scq.forEach(function (item) {
	          _this2.scqTogglerWhenWaitInput[item] = false;
	        });
	        this.watching = this.$scope.$watch('pyramidQuestion', function () {
	          if (_this2.$scope.pyramidQuestion.length >= 3) {
	            scq.forEach(function (item) {
	              _this2.scqTogglerWhenWaitInput[item] = true;
	              _this2.currentStateNumber !== 0 && _this2.shouldSCQShowAnswer(item);
	            });
	          } else {
	            scq.forEach(function (item) {
	              _this2.scqTogglerWhenWaitInput[item] = false;
	              _this2.currentStateNumber !== 0 && _this2.shouldSCQShowAnswer(item);
	            });
	          }
	        });
	      }
	      (0, _get3.default)(StepDiagramController.prototype.__proto__ || (0, _getPrototypeOf2.default)(StepDiagramController.prototype), '$onInit', this).call(this);
	    }
	  }, {
	    key: 'shouldSCQShowAnswer',
	    value: function shouldSCQShowAnswer(field) {
	      if (this[field].showInput && !this.data.waitPyramidQuestionInput || this.data.waitPyramidQuestionInput && this.currentStateNumber >= 7 && this.scqTogglerWhenWaitInput[field] || this.data.waitPyramidQuestionInput && this.currentStateNumber < 7 && this[field].showInput) {
	
	        this[field].showInput = false;
	      } else {
	        this[field].showInput = true;
	      }
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      (0, _get3.default)(StepDiagramController.prototype.__proto__ || (0, _getPrototypeOf2.default)(StepDiagramController.prototype), '$onDestroy', this).call(this);
	      if (typeof this.watching === 'function') {
	        this.watching();
	      }
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      if (this.currentStateNumber > 1) {
	        this.currentStateNumber--;
	        this.changeState();
	      }
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      if (this.currentStateNumber + 1 !== this.data.tasks.length) {
	        this.currentStateNumber++;
	        this.changeState();
	      }
	    }
	  }, {
	    key: 'toogleadditionalInfoBox',
	    value: function toogleadditionalInfoBox(additionalInfoBox) {
	      var _this3 = this;
	
	      if (additionalInfoBox.text !== this.additionalInfoBox.text) {
	        this.additionalInfoBox.style = {
	          'animation-name': !additionalInfoBox.text ? 'fadeOut' : 'fadeIn',
	          'animation-duration': '1s',
	          'animation-fill-mode': 'forwards'
	        };
	
	        this.$timeout(function () {
	          _this3.additionalInfoBox.text = additionalInfoBox.text;
	        }, !additionalInfoBox.text ? 100 : 0);
	      }
	    }
	  }, {
	    key: 'showStudentAnswer',
	    value: function showStudentAnswer(input, show, object) {
	      var pyramidQuestionLengthValid = this.data.waitPyramidQuestionInput ? this.$scope.pyramidQuestion.length >= 3 : true;
	      var shouldUpdate = this.checkAnswer && this.checkAnswer[input] && pyramidQuestionLengthValid;
	      if (object && shouldUpdate) {
	        this[input].showInput = show;
	      } else if (shouldUpdate || input === 'showPyramidQuestionField' && this.currentStateNumber >= 8) {
	        this[input] = show;
	      }
	    }
	  }, {
	    key: 'showPyramidHead',
	    value: function showPyramidHead(status) {
	      if (!this.pyramid.headerAnswer) {
	        return;
	      }
	      this.showSchoolSolutionPyramid = status;
	    }
	  }, {
	    key: 'handleDiagramClick',
	    value: function handleDiagramClick(event) {
	      var _this4 = this;
	
	      if (this.isBlinkingEffect && event.target.tagName.toLowerCase() !== 'textarea' && !event.target.classList.contains('step__diagram-slider__button')) {
	        this.isBlinkingAnimation = true;
	        setTimeout(function () {
	          _this4.isBlinkingAnimation = false;
	          _this4.$scope.$apply();
	        }, 2000);
	      }
	    }
	  }, {
	    key: 'changeState',
	    value: function changeState() {
	      var _this5 = this;
	
	      var newState = (0, _assign2.default)({}, this.data.tasks[this.currentStateNumber]);
	      (0, _assign2.default)(this.model, (0, _extends3.default)({}, _.cloneDeep(newState), { modelValues: this.modelValues }));
	      if (newState.isLast) {
	        this.onFinish({
	          $event: {
	            diagram: this.clearDiagramId,
	            attempts: 0,
	            hintsUsed: 0,
	            rightAnswers: 0,
	            userAnswers: this.model
	          }
	        });
	      }
	      if (!newState.isFirst) {
	        this.animate(newState);
	        var isFirst = newState.isFirst,
	            isLast = newState.isLast,
	            showSoWhatText = newState.showSoWhatText,
	            isBlinkingEffect = newState.isBlinkingEffect,
	            pyramidQuestion = newState.pyramidQuestion,
	            showPyramid = newState.showPyramid,
	            pyramidDelay = newState.pyramidDelay,
	            arrows = newState.arrows,
	            rightArrows = newState.rightArrows,
	            hideInfoBox = newState.hideInfoBox,
	            endText = newState.endText,
	            additionalInfoBox = newState.additionalInfoBox,
	            showAditionalBox = newState.showAditionalBox,
	            showPyramidQuestionField = newState.showPyramidQuestionField,
	            checkAnswer = newState.checkAnswer,
	            showDocument = newState.showDocument;
	
	
	        (0, _assign2.default)(this, {
	          isFirst: isFirst,
	          isLast: isLast,
	          isBlinkingEffect: isBlinkingEffect,
	          pyramidQuestion: pyramidQuestion,
	          showAditionalBox: showAditionalBox,
	          checkAnswer: checkAnswer,
	          showDocument: showDocument,
	          showPyramidQuestionField: showPyramidQuestionField,
	          showSoWhatText: showSoWhatText,
	          arrows: this.$sce.trustAsHtml(arrows),
	          rightArrows: this.$sce.trustAsHtml(rightArrows)
	        });
	
	        this.$timeout.cancel(this.showPyramidTimeout);
	        this.$timeout.cancel(this.showEndTextTimeout);
	
	        if (showPyramid && pyramidDelay) {
	          this.showPyramidTimeout = this.$timeout(function () {
	            _this5.showPyramid = showPyramid;
	
	            _this5.$scope.$apply();
	          }, pyramidDelay);
	        } else {
	          (0, _assign2.default)(this, { showPyramid: showPyramid });
	        }
	
	        if (hideInfoBox && endText.delay) {
	          this.showEndTextTimeout = this.$timeout(function () {
	            (0, _assign2.default)(_this5, { hideInfoBox: hideInfoBox, endText: endText });
	            _this5.showPyramid = showPyramid;
	
	            _this5.$scope.$apply();
	          }, endText.delay);
	        } else {
	          (0, _assign2.default)(this, { hideInfoBox: hideInfoBox, endText: endText });
	        }
	
	        if (additionalInfoBox) {
	          this.toogleadditionalInfoBox(additionalInfoBox);
	        }
	
	        if (this.data.waitPyramidQuestionInput && this.currentStateNumber < 7) {
	          this.$scope.pyramidQuestion = '';
	        }
	      } else {
	        (0, _assign2.default)(this, newState);
	      }
	    }
	  }, {
	    key: 'insertPyramidBody',
	    value: function insertPyramidBody() {
	      var _this6 = this;
	
	      var pyramidBlocksWrapper = angular.element('#' + this.data.id + ' .pyramid-blocks');
	      pyramidBlocksWrapper.html(this.data.pyramidBlocks);
	      this.$compile(pyramidBlocksWrapper)(this.$scope);
	      this.$timeout(function () {
	        _this6.showPyramidBody = true;
	      }, 0);
	    }
	  }, {
	    key: 'checkSCQInputShow',
	    value: function checkSCQInputShow(key, keyObject) {
	      var validKey = ['s', 'c', 'q', 'pyramid', 'title'];
	      if (validKey.includes(key) && keyObject.showInput) {
	        if (this.data.waitPyramidQuestionInput && this.currentStateNumber >= 7 && this.$scope.pyramidQuestion.length >= 3) {
	          this[key].showInput = false;
	        } else {
	          this[key].showInput = true;
	        }
	
	        if (key === 'title') {
	          this[key].rows = keyObject.rows;
	        }
	      } else {
	        this[key].showInput = false;
	      }
	    }
	  }, {
	    key: 'animate',
	    value: function animate(newState) {
	      var _this7 = this;
	
	      var exceptions = ['arrows', 'isFirst', 'isLast', 'isBlinkingEffect', 'pyramidQuestion', 'rightArrows', 'pyramidDelay', 'hideInfoBox', 'endText', 'additionalInfoBox', 'showAditionalBox', 'showPyramidQuestionField', 'checkAnswer', 'showDocument'];
	
	      var _loop = function _loop(key) {
	        if (!exceptions.includes(key)) {
	          if (key === 'pyramid') {
	            if (newState[key].headerAnswer) {
	              _this7[key].headerAnswer = newState[key].headerAnswer;
	              _this7[key].hideText = newState[key].hideText || false;
	              _this7.showSchoolSolutionPyramid = true;
	            } else {
	              _this7[key].headerAnswer = '';
	              _this7[key].hideText = false;
	              _this7.showSchoolSolutionPyramid = false;
	            }
	          }
	          if (_this7[key].text === '' && newState[key].text !== '') {
	            _this7.checkSCQInputShow(key, newState[key]);
	            _this7[key].text = newState[key].text;
	            _this7.$timeout(function () {
	              _this7[key].style = {
	                'animation-name': key !== 'pyramid' ? 'fadeIn' : 'slideIn',
	                'animation-duration': '0.5s',
	                'animation-fill-mode': 'forwards'
	              };
	            }, newState[key].delay);
	          } else if (_this7[key].text !== newState[key].text) {
	            _this7.$timeout(function () {
	              _this7[key].style = {
	                'animation-name': key !== 'pyramid' ? 'fadeOut' : 'slideOut',
	                'animation-duration': '0.5s',
	                'animation-fill-mode': 'forwards'
	              };
	              _this7.$timeout(function () {
	                _this7.checkSCQInputShow(key, newState[key]);
	                _this7[key].text = newState[key].text;
	                _this7[key].style = {
	                  'animation-name': key !== 'pyramid' ? 'fadeIn' : 'slideIn',
	                  'animation-duration': '0.5s',
	                  'animation-fill-mode': 'forwards'
	                };
	              }, 500);
	            }, newState[key].delay);
	          } else if (newState[key].showInput) {
	            _this7.checkSCQInputShow(key, newState[key]);
	          }
	        }
	      };
	
	      for (var key in newState) {
	        _loop(key);
	      }
	    }
	  }]);
	  return StepDiagramController;
	}(_course2.default);
	
	exports.default = StepDiagramController;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stepDiagram = __webpack_require__(861);
	
	var _stepDiagram2 = _interopRequireDefault(_stepDiagram);
	
	var _stepDiagram3 = __webpack_require__(862);
	
	var _stepDiagram4 = _interopRequireDefault(_stepDiagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stepDiagramComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    completed: '<',
	    onSubmit: '&'
	  },
	  controllerAs: 'vm',
	  template: _stepDiagram2.default,
	  controller: _stepDiagram4.default
	};
	
	exports.default = stepDiagramComponent;

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"step__diagram--2\" id=\"{{vm.diagram.id}}\">\n  <div class=\"step__diagram-header\">\n    <div ng-if=\"vm.diagram.title\" class=\"step__diagram-main-title\">\n      <p ng-bind=\"vm.diagram.title\"></p>\n    </div>\n  </div>\n\n  <div class=\"step__diagram-body\">\n  </div>\n\n  <div class=\"step__diagram-buttons\">\n    <button ng-style=\"{'visibility': vm.activeIndex < 1 ? 'hidden' : 'visible'}\" ng-click=\"vm.moveSlide(-1)\">\n      <img src=\"/assets/images/left-arrow.png\">\n    </button>\n    <div class=\"pyramid-builder-demo__animation \" ng-if=\"!vm.isAnimationShowed && vm.diagram.id === 'exercise_1'\">\n      <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -3s\"></div>\n      <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -2s\"></div>\n      <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -1s\"></div>\n      <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -0s\"></div>\n    </div>\n    <button ng-click=\"vm.moveSlide(1)\">\n      <img src=\"/assets/images/right-arrow.png\">\n    </button>\n  </div>\n\n  <div class=\"simplest__structure-note\" ng-if=\"vm.diagram.note\">\n    <div class=\"simplest__structure-text\" ng-bind=\"vm.diagram.note\"></div>\n    <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n  </div>\n\n</div>\n"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StepDiagram2Controller = function () {
	  StepDiagram2Controller.$inject = ["$sce", "$compile", "$scope", "$window"];
	  function StepDiagram2Controller($sce, $compile, $scope, $window) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, StepDiagram2Controller);
	    this.pyramidBuilderIsActivated = false;
	    this.isAnimationShowed = false;
	
	    (0, _assign2.default)(this, { $sce: $sce, $compile: $compile, $scope: $scope, $window: $window });
	  }
	
	  (0, _createClass3.default)(StepDiagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      this.diagram = this.data;
	      this.activeIndex = this.diagram.startStep || 0;
	      setTimeout(function () {
	        var diagramBody = angular.element('#' + _this.diagram.id + ' .step__diagram-body');
	        diagramBody.html(_this.diagram.diagram);
	        _this.$compile(diagramBody)(_this.$scope);
	        _this.$scope.$apply();
	      }, 200);
	
	      // setTimeout(() => {
	      //   const offsetTop = $('#' + this.diagram.id).offset().top;
	      //   $(window).on('scroll', () => {
	      //     const pagePosition = this.$window.scrollY + this.$window.innerHeight * 0.66
	      //
	      //     if (pagePosition >= offsetTop) {
	      //       setTimeout(() => {
	      //         this.showFirstSlide = true
	      //         this.$scope.$apply()
	      //       }, 500)
	      //     }
	      //   })
	      // }, 300)
	    }
	  }, {
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      var interval = setInterval(function () {
	        if (_this2.completed) {
	          _this2.isAnimationShowed = true;
	          _this2.activeIndex = _this2.diagram.steps;
	          _this2.scrolled = true;
	          clearInterval(interval);
	          _this2.$scope.$apply();
	        }
	      }, 100);
	    }
	  }, {
	    key: 'moveSlide',
	    value: function moveSlide(number) {
	      var _this3 = this;
	
	      this.isAnimationShowed = true;
	      var newActiveIndex = this.activeIndex + number;
	      if (newActiveIndex >= this.diagram.startStep && newActiveIndex <= this.diagram.steps) {
	        this.activeIndex = newActiveIndex;
	      }
	
	      if (!this.pyramidBuilderIsActivated && this.activeIndex === newActiveIndex && this.diagram.steps === newActiveIndex) {
	        this.scrolled = false;
	
	        $(window).on('scroll', function () {
	          if (!_this3.scrolled) {
	            _this3.onSubmit({ $event: _this3.diagram.pyramidData });
	            _this3.scrolled = true;
	            _this3.pyramidBuilderIsActivated = true;
	            _this3.$scope.$apply();
	          }
	        });
	      }
	    }
	  }]);
	  return StepDiagram2Controller;
	}();
	
	exports.default = StepDiagram2Controller;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scqDiagram = __webpack_require__(864);
	
	var _scqDiagram2 = _interopRequireDefault(_scqDiagram);
	
	var _scqDiagram3 = __webpack_require__(865);
	
	var _scqDiagram4 = _interopRequireDefault(_scqDiagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scqDiagramComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _scqDiagram2.default,
	  controller: _scqDiagram4.default
	};
	
	exports.default = scqDiagramComponent;

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit-diagram simplest__structure-diagram scq-diagram-dnd-wrapper\"\n     ng-class=\"{\n        growLayout: vm.diagramComplete && vm.data.withPaper,\n       'growLayout_static': vm.isStatic && vm.diagramId.includes('diagram4b2-') && !vm.isUserAnswerExpanded\n     }\"\n     id=\"{{vm.diagramId}}\">\n\n    <div class=\"sheet-of-paper\"\n         ng-class=\"{'sheet-of-paper__static': vm.isStatic}\"\n         ng-show=\"vm.diagramComplete && vm.data.withPaper\">\n\n      <div id=\"check-lines\" style=\"position: absolute; opacity: 0;\"></div>\n\n      <div ng-if=\"vm.isUserAnswerExpanded\"\n           class=\"sheet-of-paper__long-bg\"\n           ng-style=\"{height: vm.expandedBgHeight}\"></div>\n\n      <div ng-show=\"vm.paperAnswer\" style=\"margin-top: 15px;\" class=\"correct-paper-answer\" ng-bind-html=\"vm.data.correctAnswer\">\n      </div>\n\n      <div class=\"student-paper-answer\">\n        <textarea ng-style=\"{color: vm.paperAnswer ? 'rgba(0, 0, 0, 0.75)' : 'rgb(0, 0, 0)'}\"\n                  class=\"student-paper-answer__field\"\n                  placeholder=\"Enter text...\"\n                  ng-model=\"vm.model.paper\"\n                  rows=\"{{vm.studentAnswerRows}}\"></textarea>\n        <span ng-if=\"vm.paperAnswer && vm.isUserAnswerBigger && !vm.isUserAnswerExpanded\"\n              class=\"student-paper-answer__field student-paper-answer__expand\"\n              ng-click=\"vm.expandUserAnswer()\">...</span>\n      </div>\n    </div>\n    <div class=\"sheet-of-paper sheet-of-paper__shadow\" ng-show=\"vm.diagramComplete && vm.data.withPaper\"></div>\n\n    <div class=\"simplest__structure-title\" ng-bind=\"vm.data.title\" ng-if=\"vm.data.title\"></div>\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" style=\"justify-content: space-between;\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n        <div ng-if=\"block.task\" ng-class=\"{'hide': vm.hideTaskTitle}\" class=\"simplest__structure-task\" ng-bind-html=\"block.task\"></div>\n        <div class=\"simplest__structure-box\">\n            <span ng-bind=\"block.title\"></span>\n            <textarea ng-model=\"block.model\" placeholder=\"{{block.hidePlaceHolder ? '' : '...'}}\" ng-disabled=\"vm.diagramComplete || block.disableEdit\"></textarea>\n            <!-- <span ng-bind=\"block.note\"></span> -->\n        </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n        <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n        <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete && !vm.data.hideSubmit\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete && !vm.data.withPaper || vm.data.hideSubmit\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete && vm.data.withPaper && vm.paperAnswer\" id=\"next\" ng-click=\"vm.next()\" class=\"simplest__structure-btn button-with-paper anchor\" ng-bind=\"'next' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete && vm.data.withPaper && !vm.paperAnswer\"\n                ng-click=\"vm.showPaperAnswer()\"\n                ng-class=\"\"\n                class=\"simplest__structure-btn button-with-paper-anim anchor\"\n                ng-bind=\"'show' | translate\"></button>\n    </div>\n    <div class=\"simplest__structure-image\" ng-if=\"vm.data.image && vm.diagramId !== 'exercise12'\">\n        <img ng-src=\"{{ '/assets/images/' + vm.data.image}}\">\n    </div>\n    <!-- new logic -->\n    <div class=\"show-diagram\" ng-if=\"vm.data.pyramid\">\n      <div class=\"diagram-box\">\n        <p ng-bind=\"vm.data.pyramid.pyramidHeader\"></p>\n      </div>\n      <div class=\"connector\">\n        <svg ng-if=\"vm.data.pyramid.pyramidBody.length === 4\">\n          <line x1=\"499\" y1=\"-1\" x2=\"160\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"387\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"614\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"840\" y2=\"101\" class=\"connector__line\"/>\n        </svg>\n        <svg ng-if=\"vm.data.pyramid.pyramidBody.length === 3\">\n          <line x1=\"499\" y1=\"-1\" x2=\"270\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"499\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"724\" y2=\"101\" class=\"connector__line\"/>\n        </svg>\n      </div>\n      <div class=\"diagram-slots\">\n        <div class=\"diagram-box\" ng-repeat=\"text in vm.data.pyramid.pyramidBody\">\n          <p ng-bind=\"text\"></p>\n        </div>\n      </div>\n    </div>\n    <!-- old logic -->\n    <div ng-style=\"{transform: vm.diagramComplete && vm.data.withPaper ? 'translateX(-100vw)' : 0}\" style=\"transition-delay: 3s; transition-duration: 2s\" class=\"show-diagram\" ng-if=\"vm.diagramId === 'exercise12'\">\n      <div class=\"diagram-box\">\n        <p>Thynne could be made attractive to channel, but would require considerable effort</p>\n      </div>\n      <div class=\"connector\">\n        <svg>\n          <line x1=\"499\" y1=\"-1\" x2=\"160\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"387\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"614\" y2=\"101\" class=\"connector__line\"/>\n          <line x1=\"499\" y1=\"-1\" x2=\"840\" y2=\"101\" class=\"connector__line\"/>\n        </svg>\n      </div>\n      <div class=\"diagram-slots\">\n        <div class=\"diagram-box\">\n          <p>Need to restore faith in its financial stability and investment performance</p>\n        </div>\n        <div class=\"diagram-box\">\n          <p>Need to resolve serious service and administrative problems</p>\n        </div>\n        <div class=\"diagram-box\">\n          <p>Need to address both Thynne's and ADA's image in the marketplace</p>\n        </div>\n        <div class=\"diagram-box\">\n          <p>Need to stress commitment of both ADA and Thynne the channel</p>\n        </div>\n      </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(486);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScqDiagramController = function (_CourseController) {
	  ScqDiagramController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(ScqDiagramController, _CourseController);
	
	  function ScqDiagramController(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ScqDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScqDiagramController.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramController)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.$timeout = $timeout;
	    _this.paperAnswer = false;
	    _this.studentAnswerRows = 23;
	    _this.expandedBgHeight = '0px';
	    _this.isSCQ = true;
	    _this.model = {
	      s: '',
	      c: '',
	      q: '',
	      a: '',
	      paper: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(ScqDiagramController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramId = this.data.id;
	      this.hideTaskTitle = this.data.hideTaskTitle;
	    }
	  }, {
	    key: 'showPaperAnswer',
	    value: function showPaperAnswer(diagramId) {
	      this.paperAnswer = true;
	      this.studentAnswerRows = 4;
	
	      var textField = $(document.querySelector('#' + (diagramId || this.diagramId) + ' .student-paper-answer__field'));
	      var inputText = textField.val();
	      var inputWidth = textField.css('width');
	      this.inputLineHeight = parseInt(textField.css('line-height').slice(0, -2));
	
	      var div = document.querySelector('#' + (diagramId || this.diagramId) + ' #check-lines');
	      var textarea = document.createElement('textarea');
	      textarea.classList.add('student-paper-answer__field');
	      textarea.value = inputText;
	      textarea.style.width = inputWidth;
	
	      div.appendChild(textarea);
	      var scrollHeight = textarea.scrollHeight;
	
	      div.parentNode.removeChild(div);
	
	      this.userAnswerRowsCount = Math.floor(scrollHeight / this.inputLineHeight);
	
	      this.isUserAnswerBigger = this.userAnswerRowsCount > 6;
	    }
	  }, {
	    key: 'expandUserAnswer',
	    value: function expandUserAnswer(diagramId) {
	      this.studentAnswerRows = this.userAnswerRowsCount;
	
	      var scqDiagram = $('#' + (diagramId || this.diagramId));
	      var diagramHeight = scqDiagram.height();
	
	      scqDiagram.removeClass('growLayout');
	      var growHeight = this.userAnswerRowsCount * this.inputLineHeight + 16;
	      scqDiagram.height(diagramHeight + growHeight);
	      this.isUserAnswerExpanded = true;
	      this.expandedBgHeight = growHeight + 'px';
	      //  move buttons
	      var nextButton = $(document.querySelector('#' + (diagramId || this.diagramId) + ' #next'));
	      nextButton.css({ top: diagramHeight + growHeight - 520 + 'px' });
	    }
	  }, {
	    key: 'showUserAnswear',
	    value: function showUserAnswear(block) {
	      if (this.diagramComplete) {
	        block.model = block.userAnswer;
	      }
	    }
	  }, {
	    key: 'hideUserAnswear',
	    value: function hideUserAnswear(block) {
	      if (this.diagramComplete) {
	        block.model = block.answer;
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.data.blocks.forEach(function (block) {
	        _this2.model[block.modelName] = block.model;
	      });
	      this.amountCorrectAnswers = this.data.correctAnswers;
	      this.submitCount++;
	      this.courseService.play('buttonClick');
	      if (this.hideTaskTitle) {
	        this.hideTaskTitle = false;
	      } else {
	        var time = 500;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var block = _step.value;
	
	            block.userAnswer = block.model;
	            _this2.$timeout(function () {
	              return block.model = block.answer;
	            }, time);
	            time += 500;
	          };
	
	          for (var _iterator = (0, _getIterator3.default)(this.data.blocks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      this.finishExercise();
	      this.diagramComplete = true;
	    }
	  }, {
	    key: 'showUserAnswers',
	    value: function showUserAnswers() {}
	  }, {
	    key: 'isNeedToShowTaskTitle',
	    value: function isNeedToShowTaskTitle() {
	      return this.showTaskTitle;
	    }
	  }]);
	  return ScqDiagramController;
	}(_course2.default);
	
	exports.default = ScqDiagramController;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scqDiagram = __webpack_require__(867);
	
	var _scqDiagram2 = _interopRequireDefault(_scqDiagram);
	
	var _scqDiagram3 = __webpack_require__(868);
	
	var _scqDiagram4 = _interopRequireDefault(_scqDiagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scqDiagramComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _scqDiagram2.default,
	  controller: _scqDiagram4.default
	};
	
	exports.default = scqDiagramComponent;

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"scq-diagram-dnd\" class=\"unit-diagram simplest__structure-diagram\">\n\n  <div id=\"{{vm.diagramId}}\">\n      <div class=\"simplest__structure-title\" ng-bind=\"vm.data.title\" ng-if=\"vm.data.title\"></div>\n\n      <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\">\n          <div class=\"simplest__structure-task\" ng-bind=\"block.task\"></div>\n          <div class=\"simplest__structure-box-styles\" ng-class=\"{'simplest__structure-box': !block.disabled}\" data-index=\"{{block.index}}\">\n              <span ng-bind=\"block.title\"></span>\n          </div>\n\n      </div>\n\n      <div class=\"simplest__structure-answers-wrapper\">\n        <div class=\"simplest__structure-answer-repeat\" ng-style=\"{width: vm.data.answers.length === 4 ? '213px' : '292px'}\" ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.index}}\" data-index=\"{{answer.index}}\"\n               class=\" simplest__structure-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\"></div>\n            </div>\n          </div>\n        </div>\n      </div>\n\n      <div class=\"simplest__structure-note\" ng-style=\"{height: vm.data.noteHeight || ''}\" ng-if=\"vm.data.note\">\n          <div class=\"simplest__structure-text\" ng-bind-html=\"vm.data.note\"></div>\n          <div class=\"simplest__structure-note__title\" ng-style=\"{bottom: vm.data.noteTitle || ''}\">NOTE from Barbara</div>\n      </div>\n\n      <div class=\"submit\">\n          <button ng-if=\"!vm.diagramComplete && !vm.submited\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n      </div>\n  </div>\n</div>\n"

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScqDiagramController = function (_FrameworkCourseContr) {
	  ScqDiagramController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(ScqDiagramController, _FrameworkCourseContr);
	
	  function ScqDiagramController(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ScqDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScqDiagramController.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramController)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.scqDiagram = true;
	    return _this;
	  }
	
	  // $postLink() {
	  //   setTimeout(() => this.diagramService.initSCQDiagram(this.diagramId), 1000);
	  // }
	
	  (0, _createClass3.default)(ScqDiagramController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.amountCorrectAnswers = this.data.answers.length;
	      this.diagramId = this.data.id;
	      (0, _get3.default)(ScqDiagramController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramController.prototype), '$onInit', this).call(this);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      var callNotFromHint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
	      this.submitCount++;
	      var boxesWithIncorectAnswers = $('#' + this.diagramId + ' .answer__incorrect');
	      var boxesWithCorectAnswers = $('#' + this.diagramId + ' .answer__correct');
	      // if ((boxesWithCorectAnswers.length + boxesWithIncorectAnswers.length) === this.data.blocks.length) {
	      this.submited = true;
	      // }
	
	      if (!boxesWithIncorectAnswers.length && boxesWithCorectAnswers.length === this.amountCorrectAnswers) {
	        this.courseService.play('buttonClick');
	        this.diagramComplete = true;
	        this.diagramService.disableSCQDiagram(this.diagramId);
	        setTimeout(function () {
	          return _this2.courseService.play('exerciseComplete');
	        }, 500);
	        this.finishExercise();
	      } else if (callNotFromHint) {
	        this.courseService.play('wrongAnswer');
	      }
	    }
	  }, {
	    key: 'hint',
	    value: function hint() {
	      var submit = this.submit;
	      submit = submit.bind(this);
	      (0, _get3.default)(ScqDiagramController.prototype.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramController.prototype), 'hint', this).call(this, true, submit);
	    }
	  }]);
	  return ScqDiagramController;
	}(_frameworkCourse2.default);
	
	exports.default = ScqDiagramController;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(464);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	var _resizeObserver = __webpack_require__(870);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrameworkCourseController = function (_CourseController) {
	  FrameworkCourseController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(FrameworkCourseController, _CourseController);
	
	  function FrameworkCourseController(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FrameworkCourseController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FrameworkCourseController.__proto__ || (0, _getPrototypeOf2.default)(FrameworkCourseController)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { $timeout: $timeout });
	    _this.diagramId = _this.diagramService.guid();
	    return _this;
	  }
	
	  (0, _createClass3.default)(FrameworkCourseController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this2 = this;
	
	      if (this.setPyramidData) {
	        this.bindScrollForPyramidBuilderData();
	        // handling page resize
	        var ro = new _resizeObserver.ResizeObserver(function () {
	          _this2.bindScrollForPyramidBuilderData();
	        });
	        ro.observe(document.querySelector('.unit'));
	      }
	      (0, _get3.default)(FrameworkCourseController.prototype.__proto__ || (0, _getPrototypeOf2.default)(FrameworkCourseController.prototype), '$onInit', this).call(this);
	    }
	  }, {
	    key: 'bindScrollForPyramidBuilderData',
	    value: function bindScrollForPyramidBuilderData() {
	      var _this3 = this;
	
	      try {
	        var offSetTop = $('#' + this.exerciseId).offset().top;
	        var halfOfWindowScreen = $(window).height() / 2;
	        $(window).off('scroll.' + this.exerciseId);
	        $(window).on('scroll.' + this.exerciseId, function () {
	          if (window.scrollY + halfOfWindowScreen >= offSetTop) {
	            _this3.setPyramidData({ $event: _this3.pyramidData });
	          }
	        });
	      } catch (e) {}
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      var _this4 = this;
	
	      setTimeout(function () {
	        if (_this4.isCompleted[_this4.clearDiagramId]) return;
	        _this4.diagramService.initSCQDiagram(_this4.diagramId, true, _this4.first);
	      }, 1000);
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      this.diagramService.clearScrollHandler();
	    }
	
	    // second param is for don't call wrongAnswer sound if we called method from hint
	
	  }, {
	    key: 'submit',
	    value: function submit(pyramidData) {
	      var _this5 = this;
	
	      var callNotFromHint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      callNotFromHint && this.submitCount++;
	      var boxesWithIncorectAnswers = $('#' + this.diagramId + ' .answer__incorrect');
	      var boxesWithCorectAnswers = $('#' + this.diagramId + ' .answer__correct');
	      this.submited = true;
	      if (boxesWithCorectAnswers.length === this.amountCorrectAnswers) {
	        // if (true) {
	        this.courseService.play('buttonClick');
	        this.diagramComplete = true;
	        this.diagramService.disableSCQDiagram(this.diagramId);
	        if (!this.scqDiagram) {
	          setTimeout(function () {
	            _this5.courseService.play('exerciseComplete');
	          }, 1000);
	          this.$timeout(function () {
	            pyramidData.model = {
	              attempts: _this5.submitCount,
	              hintsUsed: _this5.hintCount,
	              rightAnswers: 1
	            };
	            _this5.onSubmit({ $event: pyramidData });
	          }, 1000);
	        }
	      } else if (callNotFromHint) {
	        this.courseService.play('wrongAnswer');
	      }
	    }
	  }, {
	    key: 'hint',
	    value: function hint() {
	      var callChildSubmit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var childSubmitFunc = arguments[1];
	
	      this.hintCount++;
	      this.courseService.play('buttonClick');
	
	      var selector = '#' + this.diagramId + ' .answer__incorrect';
	      var elements = $(selector).toArray();
	      if (!elements.length) {
	        if (callChildSubmit && childSubmitFunc) {
	          childSubmitFunc(false);
	        } else if (this.isFiveSection) {
	          this.submit(this.pyramidData, false);
	        }
	      }
	      var simpleSeparatop = [];
	      var solutionSeparatop = [];
	
	      elements.forEach(function (element) {
	        var parentBlock = $(element).parent();
	        var simpleSeparator = parentBlock.find('.simple-separator')[0];
	        var solutionSeparator = parentBlock.find('.solution-separator')[0];
	
	        if (simpleSeparator) {
	          simpleSeparatop.push(simpleSeparator);
	        } else if (solutionSeparator) {
	          solutionSeparatop.push([].concat((0, _toConsumableArray3.default)($(solutionSeparator).children().toArray())));
	        }
	      });
	
	      elements.forEach(function (slot) {
	        if ($(slot).hasClass('r1-block__top-part')) {
	          $(slot).css({ 'border-color': 'red red transparent red', 'z-index': '6' });
	        } else if ($(slot).hasClass('r1-block__bottom-part')) {
	          $(slot).css({ 'border-color': 'transparent red red red', 'z-index': '6' });
	        } else {
	          $(slot).css({ 'border-color': 'red', 'z-index': '6' });
	        }
	      });
	
	      $(simpleSeparatop).css({ 'border-color': 'red', 'z-index': '6' });
	
	      solutionSeparatop.forEach(function (line) {
	        if ($(line).hasClass('top-line')) {
	          $(line).css({ 'background-image': 'linear-gradient(to right, red 50%, rgba(255, 255, 255, 0) 0%)', 'z-index': '6' });
	        } else {
	          $(line).css({ 'background-image': 'linear-gradient(to right, red 65%, rgba(255, 255, 255, 0) 0%)', 'z-index': '6' });
	        }
	      });
	
	      setTimeout(function () {
	        $(simpleSeparatop).attr('style', '');
	        $(elements).attr('style', '');
	        solutionSeparatop.forEach(function (line) {
	          $(line).attr('style', '');
	        });
	      }, 200);
	    }
	  }]);
	  return FrameworkCourseController;
	}(_course2.default);
	
	exports.default = FrameworkCourseController;

/***/ }),
/* 870 */,
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _scqDiagramDndFramework = __webpack_require__(872);
	
	var _scqDiagramDndFramework2 = _interopRequireDefault(_scqDiagramDndFramework);
	
	var _scqDiagramDndFramework3 = __webpack_require__(873);
	
	var _scqDiagramDndFramework4 = _interopRequireDefault(_scqDiagramDndFramework3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scqDiagramComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<'
	  },
	  controllerAs: 'vm',
	  template: _scqDiagramDndFramework2.default,
	  controller: _scqDiagramDndFramework4.default
	};
	
	exports.default = scqDiagramComponent;

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit-diagram simplest__structure-framework scq-diagram-dnd-framework-wrapper\" style=\"padding-left: 0; padding-right: 0;\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-framework__title\" ng-bind=\"vm.data.title\" ng-if=\"vm.data.title\"></div>\n\n    <div class=\"simplest__structure-framework__tasks\">\n        <div>\n            <div>SITUATION</div>\n            <div class=\"simplest__structure-framework__image\">\n                <img ng-src=\"{{'/assets/images/' + vm.data.image}}\" alt=\"\">\n            </div>\n            <div class=\"white\">DISTURBING EVENT</div>\n            <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div>\n            <div class=\"flex-row\">\n                <div>\n                    <div class=\"center\">R1</div>\n                    <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box simplest__structure-square\"></div>\n                </div>\n                <div>\n                    <div class=\"center\">R2</div>\n                    <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box simplest__structure-square\"></div>\n                </div>\n            </div>\n            <div class=\"simplest__structure-framework__solution\">\n                <div class=\"white\">SOLUTION</div>\n                <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n            </div>\n            <div class=\"submit\">\n                <button ng-if=\"!vm.diagramComplete && !vm.submited\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n                <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n                <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n                <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n            </div>\n        </div>\n    </div>\n\n    <div class=\"simplest__structure-answers simplest__structure-framework-answers\">\n        <div ng-repeat=\"answer in vm.data.answers\">\n            <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\" ng-bind-html=\"answer.title\"></div>\n        </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScqDiagramController = function (_CourseController) {
	  ScqDiagramController.$inject = ["courseService", "diagramService", "$translate"];
	  (0, _inherits3.default)(ScqDiagramController, _CourseController);
	
	  function ScqDiagramController(courseService, diagramService, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ScqDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScqDiagramController.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramController)).call(this, courseService, diagramService, $translate));
	
	    _this.diagramId = _this.diagramService.guid();
	    return _this;
	  }
	
	  (0, _createClass3.default)(ScqDiagramController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        return _this2.diagramService.initSCQDiagram(_this2.diagramId, true);
	      }, 1000);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this3 = this;
	
	      var boxesWithIncorectAnswers = $('#' + this.diagramId + ' .answer__incorrect');
	      var boxesWithCorectAnswers = $('#' + this.diagramId + ' .answer__correct');
	      this.submited = true;
	      if (boxesWithCorectAnswers.length === 4) {
	        this.courseService.play('buttonClick');
	        this.diagramComplete = true;
	        this.diagramService.disableSCQDiagram(this.diagramId);
	        setTimeout(function () {
	          return _this3.courseService.play('exerciseComplete');
	        }, 500);
	        this.finishExercise();
	      } else {
	        this.courseService.play('wrongAnswer');
	      }
	    }
	  }, {
	    key: 'hint',
	    value: function hint() {
	      this.courseService.play('buttonClick');
	      var selector = '#' + this.diagramId + ' .answer__incorrect';
	      $(selector).css('border-color', 'red');
	      setTimeout(function () {
	        return $(selector).css('border-color', 'white');
	      }, 200);
	    }
	  }]);
	  return ScqDiagramController;
	}(_course2.default);
	
	exports.default = ScqDiagramController;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _highlightDiagram = __webpack_require__(875);
	
	var _highlightDiagram2 = _interopRequireDefault(_highlightDiagram);
	
	var _highlightDiagram3 = __webpack_require__(876);
	
	var _highlightDiagram4 = _interopRequireDefault(_highlightDiagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var highlightDiagramComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _highlightDiagram2.default,
	  controller: _highlightDiagram4.default
	};
	
	exports.default = highlightDiagramComponent;

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"highlight__diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"highlight__diagram-title\" ng-bind=\"vm.data.title\" ng-if=\"vm.data.title\"></div>\n    <div class=\"highlight__diagram-number\" ng-bind=\"vm.data.number + '.'\"></div>\n\n    <div class=\"highlight__diagram-block--wrapper\">\n        <div class=\"highlight__diagram-block\"\n             ng-class=\"{'highlight__diagram-interactive-box': vm.data.interactiveBoxNumber.includes($index)}\"\n             ng-repeat=\"block in vm.data.blocks track by $index\">\n            <div class=\"simplest__structure-task\" highlite-word words=\"block.task.question\" select=\"block.selectAvailable\" ng-if=\"!vm.diagramComplete && !block.example\"></div>\n            <div class=\"simplest__structure-task\" ng-bind-html=\"block.task.answer\" ng-if=\"block.example || vm.diagramComplete\"></div>\n        </div>\n    </div>\n\n    <div class=\"submit\" ng-if=\"!vm.data.example\">\n        <button ng-if=\"!vm.submited\" ng-click=\"vm.submit()\" class=\"highlight__diagram-btn\" ng-bind=\"'submit' | translate\"></button>\n\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n\n        <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.correct()\" class=\"highlight__diagram-btn anchor\" ng-bind=\"'correct' | translate\"></button>\n\n        <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(197);
	
	var _from2 = _interopRequireDefault(_from);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HighlightDiagramController = function (_CourseController) {
	  HighlightDiagramController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$sce", "audioService", "$scope"];
	  (0, _inherits3.default)(HighlightDiagramController, _CourseController);
	
	  function HighlightDiagramController(courseService, diagramService, $translate, $timeout, $sce, audioService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, HighlightDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (HighlightDiagramController.__proto__ || (0, _getPrototypeOf2.default)(HighlightDiagramController)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.$timeout = $timeout;
	    _this.$sce = $sce;
	    _this.answers = 0;
	    _this.audioService = audioService;
	    _this.isHighlight = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(HighlightDiagramController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.diagramId = '' + this.data.diagramId;
	      this.clearDiagramId = '' + this.data.diagramId;
	      if (this.data.example) {
	        this.diagramComplete = true;
	      }
	      this.amountCorrectAnswers = this.data.answers.split(' ').length;
	      (0, _get3.default)(HighlightDiagramController.prototype.__proto__ || (0, _getPrototypeOf2.default)(HighlightDiagramController.prototype), '$onInit', this).call(this);
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      this.submitCount++;
	      this.submited = true;
	      var answers = $('#' + this.diagramId + ' .highlight__answer');
	
	      var answersArr = [];
	      (0, _from2.default)(answers).forEach(function (element) {
	        answersArr.push(element.textContent);
	      });
	      var currAnswer = answersArr.join(' ');
	
	      if (this.data.answers === currAnswer) {
	        this.audioService.play('buttonClick');
	        this.diagramComplete = true;
	        this.audioService.play('exerciseComplete');
	        this.finishExercise();
	      } else {
	        this.audioService.play('wrongAnswer');
	      }
	    }
	  }, {
	    key: 'correct',
	    value: function correct() {
	      this.hintCount++;
	      this.audioService.play('buttonClick');
	      this.diagramComplete = true;
	      this.finishExercise();
	    }
	  }, {
	    key: 'toggleAnswer',
	    value: function toggleAnswer($event) {
	      $($event.currentTarget).hasClass('highlight__answer') ? this.answers-- : this.answers++;
	      $($event.currentTarget).toggleClass('highlight__answer');
	    }
	  }, {
	    key: 'renderTask',
	    value: function renderTask(task) {
	      return this.$sce.trustAsHtml(task);
	    }
	  }]);
	  return HighlightDiagramController;
	}(_course2.default);
	
	exports.default = HighlightDiagramController;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _checkboxDiagram = __webpack_require__(878);
	
	var _checkboxDiagram2 = _interopRequireDefault(_checkboxDiagram);
	
	var _checkboxDiagram3 = __webpack_require__(879);
	
	var _checkboxDiagram4 = _interopRequireDefault(_checkboxDiagram3);
	
	__webpack_require__(880);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var checkBoxComponent = {
	  bindings: {
	    data: '<',
	    onComplete: '<'
	  },
	  controllerAs: 'vm',
	  template: _checkboxDiagram2.default,
	  controller: _checkboxDiagram4.default
	};
	
	exports.default = checkBoxComponent;

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit-diagram checkbox__diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"checkbox__diagram-title\" ng-bind=\"vm.data.title\" ng-if=\"vm.data.title\"></div>\n\n    <div class=\"checkbox__diagram-tasks\">\n        <div class=\"checkbox__diagram-tasks__titles\">\n            <div class=\"checkbox__diagram-task__title\" ng-repeat=\"title in vm.data.titles\" ng-bind=\"title\"></div>\n        </div>\n\n        <div class=\"checkbox__diagram-tasks__box\">\n            <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n                <div class=\"checkbox__wrapper\" ng-repeat=\"box in vm.data.boxes\">\n                    <div class=\"checkbox\">\n                        <input type=\"checkbox\" ng-click=\"vm.playCheckboxSound()\" name=\"{{box.name}}\" ng-model=\"vm.userAnswers[box.name]\" id=\"rule-{{vm.diagramId}}-{{box.name}}\"\n                            ng-disabled=\"vm.diagramComplete\" />\n                        <label for=\"rule-{{vm.diagramId}}-{{box.name}}\"></label>\n                    </div>\n                    <label for=\"rule-{{vm.diagramId}}-{{box.name}}\" class=\"checkbox-description\">{{box.title}}</label>\n                </div>\n            </form>\n            <div class=\"checkbox__diagram-answer__text\" ng-bind=\"vm.data.text\" ng-show=\"vm.diagramComplete\"></div>\n            <div class=\"submit\">\n                <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit__button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n                <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit__button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n                <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit__button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n                <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"submit__button\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n            </div>\n        </div>\n    </div>\n</div>"

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxDiagramController = function (_CourseController) {
	  CheckboxDiagramController.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(CheckboxDiagramController, _CourseController);
	
	  function CheckboxDiagramController(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CheckboxDiagramController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (CheckboxDiagramController.__proto__ || (0, _getPrototypeOf2.default)(CheckboxDiagramController)).call(this, courseService, diagramService, $translate));
	
	    _this.checkboxes = true;
	    _this.$timeout = $timeout;
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(CheckboxDiagramController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.diagramId = this.data.id;
	      this.userAnswers = this.data.userAnswers;
	      this.correctAnswers = this.data.correctAnswers;
	    }
	  }, {
	    key: 'showUserAnswers',
	    value: function showUserAnswers() {}
	  }]);
	  return CheckboxDiagramController;
	}(_course2.default);
	
	exports.default = CheckboxDiagramController;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(881);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkbox-diagram.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./checkbox-diagram.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".checkbox-diagram{min-height:320px!important}.checkbox-diagram .unit-wrapper{overflow:visible!important}.checkbox__diagram-tasks{display:flex;justify-content:space-between}.checkbox__wrapper>label{cursor:pointer;display:block;padding-left:40px;text-align:left;color:#fff;font-size:1rem;text-shadow:0 0 1px #191919}.checkbox__wrapper .checkbox input+label{height:20px;width:20px;border-radius:7px;box-shadow:none}.checkbox__wrapper .checkbox input+label:after{box-shadow:none;border-radius:3px;height:14px;width:14px}.checkbox__diagram-title{text-align:left;font-size:22px;margin-bottom:50px}.checkbox__diagram-task__title{text-align:left;color:#fff;margin-bottom:10px;text-shadow:0 0 1px #191919}.checkbox__diagram-tasks__box{width:300px;position:relative}.checkbox__diagram-answer__text{font-size:14px;text-align:left;color:#fff;border-top:1px solid;margin-top:25px;padding-top:12px;text-shadow:0 0 1px #191919}.checkbox__diagram-tasks .checkboxes-task{width:200px;margin:0 auto}.checkbox__diagram-tasks .submit{position:absolute;top:100px;right:-115px;margin:0}.submit__button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#f0e527;border-radius:10px;padding:5px 10px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}", ""]);
	
	// exports


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _pyramidBuilder = __webpack_require__(883);
	
	var _pyramidBuilder2 = _interopRequireDefault(_pyramidBuilder);
	
	var _pyramidBuilder3 = __webpack_require__(884);
	
	var _pyramidBuilder4 = _interopRequireDefault(_pyramidBuilder3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pyramidBuilderComponent = {
	  bindings: {
	    data: '<',
	    isActiveDemo: '<',
	    sectionTitle: '@',
	    onClosePyramidBuilder: '&',
	    pyramidData: '<',
	    enableScroll: '@'
	  },
	  controllerAs: 'vm',
	  template: _pyramidBuilder2.default,
	  controller: _pyramidBuilder4.default
	};
	
	exports.default = pyramidBuilderComponent;

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pyramid-builder-demo\">\n  <div class=\"pyramid-builder-demo__modal\" ng-if=\"vm.isActiveDemo && !vm.open\">\n    <div class=\"pyramid-builder-demo__modal-instruction\" ng-bind-html=\"vm.pyramidData.instruction\" ng-if=\"vm.pyramidData.instruction\">\n    </div>\n  </div>\n  <div class=\"pyramid-builder-demo__animation\" ng-if=\"vm.isActiveDemo && !vm.open\">\n    <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -3s\"></div>\n    <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -2s\"></div>\n    <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -1s\"></div>\n    <div class=\"pyramid-builder-demo__circle\" style=\"animation-delay: -0s\"></div>\n  </div>\n</div>\n\n<div ng-if=\"vm.isActiveDemo\" class=\"open-pyramid-builder\" ng-click=\"vm.toggle()\">\n  <div id=\"pyramid-step-4\" class=\"open-pyramid-builder__label\">\n    <button ng-if=\"vm.open\">SUBMIT</button>\n    <span ng-if=\"!vm.open\">To complete this exercise please click to open the Minto Framework</span>\n  </div>\n  <div ng-if=\"!vm.open\" class=\"open-pyramid-builder__circle\">\n    <!-- <svg ng-if=\"vm.open\" class=\"tabs-logo open-pyramid-builder__logo\" width=\"35px\"\n      xmlns=\" http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\" />\n      <path d=\"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z\" fill=\"#ffffff\" />\n    </svg> -->\n    <img src=\"../../../assets/images/tabs-logo.png\" alt=\"minto logo\" class=\"tabs-logo open-pyramid-builder__logo\">\n  </div>\n</div>\n<div ng-if=\"!vm.isActiveDemo\" class=\"open-pyramid-builder\" ng-click=\"vm.toggle()\">\n  <div class=\"open-pyramid-builder__circle\">\n    <img src=\"../../../assets/images/tabs-logo.png\" alt=\"minto logo\" class=\"tabs-logo open-pyramid-builder__logo\">\n  </div>\n</div>\n\n<div class=\"pyramid__builder\" ng-class=\"{ 'open': vm.open }\">\n\n    <div class=\"pyramid__options\" ng-class=\"{ 'open': vm.optionsOpen }\">\n        <div class=\"pyramid__options-title\">\n            Pyramid Options\n\n            <button ng-click=\"vm.optionsOpen = !vm.optionsOpen\">\n                <i class=\"fa fa-pencil\" aria-hidden=\"true\"></i>\n                <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n            </button>\n\n        </div>\n        <div class=\"pyramid__options-title__input\">\n            <input placeholder=\"Enter Title\" type=\"text\" name=\"piramid__title\" ng-model=\"vm.activePyramid.title\">\n        </div>\n\n        <div class=\"pyramid__options-piramid margin-bottom-10\">\n            <div class=\"pyramid__options-subtitle\">\n                <div ng-class=\"{'active': vm.activePyramid.pyramid.active}\" ng-click=\"vm.toggleVisible(vm.activePyramid.pyramid)\"></div>\n                Pyramid\n            </div>\n            <div class=\"pyramid__options-controls\">\n                <div class=\"pyramid__options-subtitle\">\n                    <label class=\"pyramid__options__input-sm\">\n                        Select number of boxes\n                        <input placeholder=\"Enter Title\" type=\"number\" ng-model=\"vm.activePyramid.pyramid.number\" ng-change=\"vm.onBoxesNumberChange()\"\n                            min=\"0\" max=\"5\" number-min-max>\n                    </label>\n                </div>\n                <div class=\"pyramid__options-subtitle\">\n                    <div ng-class=\"{'active': vm.activePyramid.pyramid.question.active}\" ng-click=\"vm.toggleTreeQ()\"></div>\n                    Question\n                </div>\n                <div class=\"pyramid__options-subtitle\">\n                    <div ng-class=\"{'active': vm.renderer.tree.selectedNode.data.deductive}\" ng-click=\"vm.setDeductive()\"></div>\n                    Deductive layout\n                </div>\n            </div>\n        </div>\n\n        <div class=\"pyramid__options-piramid margin-bottom-10\">\n            <div class=\"pyramid__options-subtitle\">\n                <div ng-class=\"{'active': vm.activePyramid.scq.active}\" ng-click=\"vm.toggleVisible(vm.activePyramid.scq)\"></div>\n                SCQ\n            </div>\n        </div>\n\n        <div class=\"pyramid__options-piramid margin-bottom-10\">\n            <div class=\"pyramid__options-subtitle\">\n                <div ng-class=\"{'active': vm.activePyramid.problemDefinition.active}\" ng-click=\"vm.toggleVisible(vm.activePyramid.problemDefinition)\"></div>\n                Problem Definition\n            </div>\n            <div class=\"pyramid__options-controls\">\n                <div class=\"pyramid__options-subtitle\">\n                    <div ng-class=\"{'active': vm.activePyramid.problemDefinition.secondLayer.active}\" ng-click=\"vm.toggleVisible(vm.activePyramid.problemDefinition.secondLayer)\"></div>\n                    Second Layer\n                </div>\n            </div>\n        </div>\n\n        <div class=\"pyramid__options-style\" ng-if=\"vm.showSlider\">\n            <div id=\"pyramid-step-1\">\n                <span ng-bind=\"vm.getScaleValue()\"></span>\n                <rzslider rz-slider-model=\"vm.scale.value\" rz-slider-options=\"vm.scale.options\"></rzslider>\n                <!-- <div class=\"pyramid__options-counter\">\n                    <div class=\"pyramid__options-counter__model\" ng-bind=\"vm.getScaleValue()\"></div>\n                    <div class=\"pyramid__options-counter__control\">\n                        <span ng-click=\"vm.zoomPyramid(true)\">></span>\n                        <span ng-click=\"vm.zoomPyramid(false)\">></span>\n                    </div>\n                </div> -->\n            </div>\n            <div>\n                <span ng-bind=\"vm.getOpacity()\"></span>\n                <rzslider rz-slider-model=\"vm.opacity.value\" rz-slider-options=\"vm.opacity.options\"></rzslider>\n                <!-- <div class=\"pyramid__options-counter\">\n                    <div class=\"pyramid__options-counter__model\" ng-bind=\"vm.getOpacity()\"></div>\n                    <div class=\"pyramid__options-counter__control\">\n                        <span ng-click=\"vm.updateOpacity(true)\">></span>\n                        <span ng-click=\"vm.updateOpacity(false)\">></span>\n                    </div>\n                </div> -->\n            </div>\n        </div>\n\n        <div ng-if=\"!vm.isActiveDemo\" class=\"pyramid__options-footer\">\n            <div class=\"pyramid__options-disabled\">\n              <button ng-click=\"vm.savePyramid()\">Save Pyramid</button>\n              <span>- comming soon!</span>\n            </div>\n            <div class=\"pyramid__options-disabled\">\n              <button>Load Pyramid</button>\n              <span>- comming soon!</span>\n            </div>\n            <!-- <button ng-click=\"vm.generatePDF()\">Export</button> -->\n            <button ng-click=\"vm.toggle()\">Close Minto Tool</button>\n        </div>\n\n    </div>\n\n    <div class=\"pyramid__builder-wrapper\" ng-style=\"{'background': 'rgba(9, 104, 172, ' + vm.opacity.value + ')'}\">\n        <uib-tabset active=\"vm.active\" class=\"tabs__wrapper\">\n            <uib-tab class=\"{{ vm.pyramidBuilderService.store[key].editableMode ? 'editable__mode' : ''}}\"\n                ng-repeat=\"(key, pyramid) in vm.pyramidBuilderService.store\"\n                ng-if=\"!vm.isActiveDemo || vm.isActiveDemo && vm.activePyramid.pyramid.active\"\n                select=\"vm.setActiviPyramid(key)\"\n                index=\"pyramid.guid\">\n                <uib-tab-heading>\n                    <div class=\"tab__title\" ng-click=\"vm.setActiviPyramid(key)\">\n                      <img src=\"../../../assets/images/tabs-logo.png\" alt=\"minto logo\" class=\"tabs-logo\" ng-if=\"!pyramid.editableMode\">\n                      <div ng-dblclick=\"pyramid.editableMode = true\" ng-if=\"!pyramid.editableMode\"\n                          ng-bind=\"pyramid.title\" class=\"tabs-text\"></div>\n                      <div ng-if=\"pyramid.editableMode\">\n                          <input type=\"text\" ng-model=\"pyramid.title\">\n                          <span ng-click=\"pyramid.editableMode = false\">&#10004;</span>\n                      </div>\n                    </div>\n                    <div class=\"tab__title_close\"\n                      ng-click=\"vm.closeTab($event, key)\">&times;</div>\n                  </uib-tab-heading>\n\n                <div class=\"flex pyramid__builder-body\">\n                    <div>\n                        <div ng-show=\"pyramid.problemDefinition.active\">\n                            <textarea ng-model=\"pyramid.problemDefinition.situation\" placeholder=\"SITUATION (Opening scene)\"\n                                class=\"pyramid__builder-situation margin-bottom-50 _no_drag\"></textarea>\n                            <textarea ng-model=\"pyramid.problemDefinition.disturbing\" placeholder=\"DISTURBING EVENT\" class=\"pyramid__builder-disturbing__event _no_drag\"></textarea>\n                        </div>\n                    </div>\n                    <div>\n                        <div ng-show=\"pyramid.problemDefinition.active\">\n                            <div class=\"pyramid__builder-r margin-bottom-30\">\n                                <div class=\"flex\">\n                                    <textarea ng-model=\"pyramid.problemDefinition.r11\" placeholder=\"R1\" class=\"pyramid__builder-r__left _no_drag\"></textarea>\n                                    <textarea ng-model=\"pyramid.problemDefinition.r12\" placeholder=\"R2\" class=\"pyramid__builder-r__right _no_drag\"></textarea>\n                                </div>\n                                <div class=\"r__arrow-1\"></div>\n                                <div class=\"r__arrow-2\"></div>\n                                <textarea ng-model=\"pyramid.problemDefinition.solution\" placeholder=\"SOLUTION\" class=\"pyramid__builder-r__situation _no_drag\"></textarea>\n                            </div>\n                            <div class=\"pyramid__builder-r margin-bottom-50\" ng-show=\"pyramid.problemDefinition.secondLayer.active\">\n                                <div class=\"flex\">\n                                    <textarea ng-model=\"pyramid.problemDefinition.r21\" placeholder=\"R1\" class=\"pyramid__builder-r__left _no_drag\"></textarea>\n                                    <textarea ng-model=\"pyramid.problemDefinition.r22\" placeholder=\"R2\" class=\"pyramid__builder-r__right _no_drag\"></textarea>\n                                </div>\n                                <div class=\"r__arrow-1\"></div>\n                                <div class=\"r__arrow-2\"></div>\n                                <textarea ng-model=\"pyramid.problemDefinition.solution2\" placeholder=\"SOLUTION\" class=\"pyramid__builder-r__situation _no_drag\"></textarea>\n                            </div>\n                        </div>\n                        <div ng-show=\"pyramid.scq.active\" class=\"pyramid__builder-scq\">\n                            <div id=\"pyramid-step-3\" class=\"pyramid__builder-scqWrap\">\n                                <div class=\"pyramid__builder-scq-header\" ng-if=\"vm.activePyramid.scq['s-header']\">\n                                  <p ng-bind=\"vm.activePyramid.scq['s-header']\"></p>\n                                </div>\n                                <div class=\"pyramid__builder-scq__box _no_drag\">\n                                  <div class=\"pyramid__builder-scq__box-title\">S =</div>\n                                  <textarea ng-bind=\"vm.activePyramid.scq.s\"\n                                            ng-model=\"pyramid.scq.s\"></textarea>\n                                </div>\n                                <div class=\"pyramid__builder-scq-header\" ng-if=\"vm.activePyramid.scq['c-header']\">\n                                  <p ng-bind=\"vm.activePyramid.scq['c-header']\"></p>\n                                </div>\n                                <div class=\"pyramid__builder-scq__box _no_drag\">\n                                  <div class=\"pyramid__builder-scq__box-title\">C =</div>\n                                  <textarea ng-bind=\"vm.activePyramid.scq.c\"\n                                            ng-model=\"pyramid.scq.c\"></textarea>\n                                </div>\n                                <div class=\"pyramid__builder-scq-header\" ng-if=\"vm.activePyramid.scq['q-header']\">\n                                  <p ng-bind=\"vm.activePyramid.scq['q-header']\"></p>\n                                </div>\n                                <div class=\"pyramid__builder-scq__box _no_drag\">\n                                  <div class=\"pyramid__builder-scq__box-title\">Q =</div>\n                                  <textarea ng-bind=\"vm.activePyramid.scq.q\"\n                                            ng-model=\"pyramid.scq.q\"></textarea>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if=\"vm.activePyramid.additionalBox\"\n                  class=\"pyramid__builder__additional-pyramid-box\">\n                  <p ng-bind=\"vm.activePyramid.additionalBox\"></p>\n                </div>\n\n                <tree-diagram ng-if=\"vm.activePyramid.pyramid.scheme\"\n                  ng-show=\"vm.activePyramid.pyramid.active\"\n                  class=\"pyramid__builder-tree__diagram\"\n                  renderer=\"vm.treeDiagram.renderer\"\n                  ng-class=\"{'scq__active': vm.activePyramid.scq.active}\">\n                </tree-diagram>\n            </uib-tab>\n        </uib-tabset>\n    </div>\n\n    <button ng-click=\"vm.toggle()\"\n      class=\"pyramid__builder-toggle\">Open</button>\n\n    <div id=\"pyramid-step-2\"></div>\n</div>\n"

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(206);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _uxTour = __webpack_require__(885);
	
	var _uxTour2 = _interopRequireDefault(_uxTour);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DRAGGIN_SIZE = 40; //import domtoimage from 'dom-to-image';
	
	var PyramidBuilderController = function () {
	  PyramidBuilderController.$inject = ["pyramidBuilderService", "$cookies", "$scope", "treeDiagramRendererFactory", "treeDiagramFactory", "$timeout", "$compile"];
	  function PyramidBuilderController(pyramidBuilderService, $cookies, $scope, treeDiagramRendererFactory, treeDiagramFactory, $timeout, $compile) {
	    'ngInject';
	
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, PyramidBuilderController);
	    (0, _assign2.default)(this, { pyramidBuilderService: pyramidBuilderService, $cookies: $cookies, $scope: $scope, treeDiagramRendererFactory: treeDiagramRendererFactory, treeDiagramFactory: treeDiagramFactory, $timeout: $timeout, $compile: $compile });
	
	    this.showSlider = true;
	    this.store = this.pyramidBuilderService.store;
	    this.scale = {
	      value: 0.9,
	      options: {
	        floor: 0.2,
	        ceil: 2,
	        step: 0.01,
	        precision: 2,
	        onChange: function onChange() {
	          return _this.renderer.tree.zoomTo(_this.scale.value);
	        }
	      }
	    };
	    this.opacity = {
	      value: 0.9,
	      options: {
	        floor: 0.2,
	        ceil: 1,
	        step: 0.05,
	        precision: 2
	      }
	    };
	
	    this.activePyramid = {};
	  }
	
	  (0, _createClass3.default)(PyramidBuilderController, [{
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      if (this.pyramidData) this.pyramidBuilderService.deletePyramid(this.key);
	    }
	  }, {
	    key: 'init',
	    value: function init() {
	      var _this2 = this;
	
	      var scale = 0.9;
	      var opacity = 0.9;
	
	      var pyramidSettings = this.$cookies.getObject('pyramidSettings');
	      if (pyramidSettings) {
	        scale = pyramidSettings.scale || scale;
	        opacity = pyramidSettings.opacity || opacity;
	      }
	
	      if (this.pyramidData) {
	        this.pyramidBuilderService.inited = true;
	
	        if (this.pyramidData.scale && this.pyramidData.scale.k) {
	          this.scale.value = this.pyramidData.scale.k;
	          scale = this.pyramidData.scale;
	        } else {
	          this.scale.value = this.pyramidData.scale;
	          scale = this.pyramidData.scale || scale;
	        }
	      }
	
	      this.pyramidBuilderService.init(this.sectionTitle, scale).then(function (data) {
	        _this2.key = data.key;
	        _this2.activePyramid = data;
	        _this2.opacity.value = _this2.pyramidBuilderService.store.opacity || opacity;
	        if (_this2.pyramidData) {
	          _this2.activePyramid.pyramid.question.active = false;
	          _this2.activePyramid.pyramid.scheme = _this2.pyramidData.scheme;
	          _this2.opacity.value = _this2.pyramidData.opacity || opacity;
	          _this2.activePyramid.additionalBox = _this2.pyramidData.additionalBox;
	          if (_this2.pyramidData.scq) {
	            _this2.activePyramid.scq = _this2.pyramidData.scq;
	            _this2.activePyramid.scq.active = true;
	          }
	        }
	
	        _this2.active = _this2.activePyramid.guid;
	      }).then(function () {
	        $('.pyramid__options').draggable();
	        _this2.$timeout(function () {
	          // this.updateSlider();
	          _this2.createTreeDiagram();
	        });
	
	        if (_this2.pyramidData) {
	          _this2.pyramidBuilderService.inited = false;
	          if (_this2.pyramidData.tourData) {
	            _this2.optionsOpen = true;
	            var tour = new _uxTour2.default();
	            _this2.$timeout(function () {
	              return tour.start(_this2.pyramidData.tourData);
	            });
	          }
	        }
	        _this2.inited = true;
	      });
	    }
	
	    // updateSlider() {
	    //   $($('.rz-pointer-min')[0]).css('left', (380 / 180) * this.scale.value * 100 - 27);
	    //   $($('.rz-pointer-min')[1]).css('left', 315);
	    // }
	
	  }, {
	    key: 'getScaleValue',
	    value: function getScaleValue() {
	      return 'Scale ' + Math.floor(this.scale.value * 100) + '% ';
	    }
	  }, {
	    key: 'getOpacity',
	    value: function getOpacity() {
	      return 'Opacity ' + Math.floor(this.opacity.value * 100) + '%';
	    }
	  }, {
	    key: 'updateOpacity',
	    value: function updateOpacity(increase) {
	      if (!increase) {
	        this.opacity -= 0.05;
	      } else if (this.opacity !== 1) {
	        this.opacity += 0.05;
	      }
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle() {
	      this.open = !this.open;
	
	      if (!this.isActiveDemo) {
	        if (this.open) {
	          $('body').addClass('pyramid__builder--open');
	        } else {
	          $('body').removeClass('pyramid__builder--open');
	        }
	      }
	
	      if (this.inited && this.isActiveDemo) {
	        this.activePyramid.scq.active = true;
	      }
	
	      if (!this.open) {
	        this.$cookies.putObject('pyramidSettings', { opacity: this.opacity.value, scale: this.scale.value });
	
	        if (this.isActiveDemo) {
	          this.onClosePyramidBuilder({
	            $event: {
	              store: this.pyramidBuilderService.store,
	              guid: this.active,
	              key: this.key
	            }
	          });
	        }
	
	        this.pyramidBuilderService.deletePyramid(this.key);
	        this.isActiveDemo = false;
	      } else {
	        this.init();
	      }
	    }
	  }, {
	    key: 'toggleVisible',
	    value: function toggleVisible(prop) {
	      prop.active = !prop.active;
	    }
	  }, {
	    key: 'generatePDF',
	    value: function generatePDF() {
	      var doc = new jsPDF();
	      var pyramid = $('.content-item.active .pyramid__builder-body');
	      pyramid.css('background', '#0868ac');
	
	      function filter(node) {
	        return node.tagName !== 'i';
	      }
	
	      //domtoimage.toPng(node)
	      //  .then(function (dataUrl) {
	      //    var img = new Image();
	      //    img.src = dataUrl;
	      //    document.body.appendChild(img);
	      //  })
	      //  .catch(function (error) {
	      //    console.error('oops, something went wrong!', error);
	      //  });
	
	      // domtoimage.toSvg(pyramid[0], { filter: filter })
	      //   .then(function (dataUrl) {
	      //     doc.addImage(dataUrl, 'JPEG', 0, 0);
	      //     doc.save(`${this.activePyramid.title}.pdf`);
	      //   });
	
	      // html2canvas(pyramid[0], { width: 1200, height: 920 }).then(canvas => {
	      //   var data = canvas.toDataURL();
	      //   // console.log(data);
	      //   window.open(canvas.toDataURL("image/png"));
	      //   // doc.addImage(data, 'JPEG', 0, 0);
	      //   // doc.save(`${this.activePyramid.title}.pdf`);
	      // });
	    }
	  }, {
	    key: 'createTreeDiagram',
	    value: function createTreeDiagram() {
	      var _this3 = this;
	
	      this.renderer = this.treeDiagramRendererFactory.getInstance(this.activePyramid.pyramid.question.active, this.activePyramid.pyramid.zoom, this.activePyramid.pyramid.scheme, !this.isActiveDemo);
	
	      this.treeDiagram = this.treeDiagramFactory.getInstance(this.exercise, this.renderer);
	
	      this.renderer.questionFlag = this.activePyramid.pyramid.question.active;
	
	      this.active = this.activePyramid.guid;
	
	      // on mouse wheel event
	      this.renderer.onZoom = function (scale) {
	        _this3.scale.value = Math.ceil(scale.k * 100) / 100;
	        _this3.$scope.$broadcast('rzSliderForceRender');
	        _this3.$scope.$broadcast('reCalcViewDimensions');
	        // FIXME: slider delay when this.zoom.value changed programaticaly
	        _this3.activePyramid.pyramid.zoom = scale;
	      };
	
	      this.renderer.onSelectItem = function (item) {
	        _this3.$timeout(function () {
	          _this3.activePyramid.pyramid.number = item.children ? item.children.length : 0;
	          _this3.renderer.tree.selectedNode.data.deductive = item.data.deductive;
	        });
	      };
	
	      // this.updateData = false;
	    }
	  }, {
	    key: 'closeTab',
	    value: function closeTab(event, key) {
	      event.preventDefault();
	
	      if ((0, _keys2.default)(this.pyramidBuilderService.store).length === 1) {
	        this.toggle();
	        return;
	      }
	
	      this.pyramidBuilderService.deletePyramid(key);
	    }
	  }, {
	    key: 'toggleTreeQ',
	    value: function toggleTreeQ() {
	      this.activePyramid.pyramid.question.active = !this.activePyramid.pyramid.question.active;
	      this.renderer.tree.toggleQuestions(this.activePyramid.pyramid.question.active);
	    }
	  }, {
	    key: 'setDeductive',
	    value: function setDeductive() {
	      this.renderer.tree.changeDeductive();
	    }
	  }, {
	    key: 'onBoxesNumberChange',
	    value: function onBoxesNumberChange() {
	      this.renderer.tree.changeChildsNodeCount(this.renderer.tree.selectedNode, this.activePyramid.pyramid.number);
	    }
	  }, {
	    key: 'setActiviPyramid',
	    value: function setActiviPyramid(activePyramidKey) {
	      var _this4 = this;
	
	      this.$timeout(function () {
	        if (!_this4.renderer) return;
	
	        (0, _keys2.default)(_this4.pyramidBuilderService.store).forEach(function (key) {
	          if (key !== 'opacity' && key !== 'scale') {
	            _this4.pyramidBuilderService.store[key].pyramid.active = key == activePyramidKey;
	          }
	        });
	
	        _this4.activePyramid = _this4.pyramidBuilderService.store[activePyramidKey];
	        // if (!this.activePyramid) {
	
	        //   return;
	        // }
	
	        _this4.renderer.questionFlag = _this4.activePyramid.pyramid.question.active;
	        _this4.renderer.zoom = _this4.activePyramid.pyramid.zoom;
	
	        _this4.renderer.scheme = _this4.activePyramid.pyramid.scheme;
	        setTimeout(function () {
	          _this4.renderer.render();
	        });
	      });
	    }
	  }, {
	    key: 'savePyramid',
	    value: function savePyramid() {
	      this.pyramidBuilderService.save(this.opacity.value);
	    }
	  }]);
	  return PyramidBuilderController;
	}();
	
	exports.default = PyramidBuilderController;

/***/ }),
/* 885 */,
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _magnifier = __webpack_require__(887);
	
	var _magnifier2 = _interopRequireDefault(_magnifier);
	
	var _magnifier3 = __webpack_require__(888);
	
	var _magnifier4 = _interopRequireDefault(_magnifier3);
	
	__webpack_require__(889);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var magnifierComponent = {
	  bindings: {
	    imageSource: '<',
	    resultMagnifierStyles: '<',
	    unShowPercent: '<'
	  },
	  controllerAs: 'vm',
	  template: _magnifier2.default,
	  controller: _magnifier4.default
	};
	
	exports.default = magnifierComponent;

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports = "<!--<div class=\"magnifier-component\" ng-mouseover=\"vm.toggleMagnifier($event, true)\" ng-mouseleave=\"vm.toggleMagnifier($event, false)\">-->\n<div class=\"magnifier-component\" {{vm.unShowPercent !== 0 && ng-mousemove=\"vm.handleMouseMove($event)\"}} ng-mouseover=\"vm.toggleMagnifier($event, true)\" ng-mouseleave=\"vm.toggleMagnifier($event, false)\">\n  <div class=\"img-magnifier-container\">\n    <div id=\"{{vm.magnifierLensId}}\" class=\"img-magnifier-glass\" ng-class=\"{'img-zoom-lens_hidden': !vm.isVisible}\"></div>\n    <img id=\"{{vm.magnifierImageId}}\" src=\"{{vm.imageSource}}\" alt=\"Original structure\" />\n  </div>\n  <div id=\"{{vm.magnifierBG}}\"  class=\"magnifier-bg\"  ng-class=\"{'img-zoom-lens_hidden': !vm.isVisible}\"></div>\n  <!--<div id=\"{{vm.magnifierResultId}}\" class=\"img-zoom-result\" ng-style=\"vm.resultMagnifierStyles\" ng-class=\"{'img-zoom-result_hidden': !vm.isVisible}\"></div>-->\n</div>\n"

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _uiHelper = __webpack_require__(212);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MagnifierController = function () {
	  function MagnifierController() {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, MagnifierController);
	    this.isVisible = false;
	    this.componentId = (0, _uiHelper.guid)();
	    this.magnifierImageId = 'magnifier-image-' + this.componentId;
	    this.magnifierResultId = 'magnifier-result-' + this.componentId;
	    this.magnifierLensId = 'magnifier-lens-' + this.componentId;
	    this.magnifierBG = 'magnifier-bg-' + this.componentId;
	  }
	
	  (0, _createClass3.default)(MagnifierController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      var _this = this;
	
	      // setTimeout(() => {this.imageZoom(this.magnifierImageId, this.magnifierResultId, this.magnifierLensId)}, 1000);
	      setTimeout(function () {
	        _this.magnify(_this.magnifierImageId, 3.4);
	      }, 1000);
	    }
	  }, {
	    key: 'toggleMagnifier',
	    value: function toggleMagnifier($event, value) {
	      this.isVisible = value;
	    }
	  }, {
	    key: 'handleMouseMove',
	    value: function handleMouseMove($event) {
	      var img = document.getElementById(this.magnifierImageId);
	
	      var minPosition = $(img).offset().top + img.clientHeight * this.unShowPercent;
	
	      if (minPosition <= $event.pageY) {
	        this.isVisible = true;
	      } else {
	        this.isVisible = false;
	      }
	    }
	
	    // imageZoom(imgID, resultID, lensId) {
	    //   let img, lens, result, cx, cy;
	    //   img = document.getElementById(imgID);
	    //   result = document.getElementById(resultID);
	    //   lens = document.getElementById(lensId);
	    //   /* Calculate the ratio between result DIV and lens: */
	    //   cx = result.offsetWidth / lens.offsetWidth;
	    //   cy = result.offsetHeight / lens.offsetHeight;
	    //   /* Set background properties for the result DIV */
	    //   result.style.backgroundImage = "url('" + img.src + "')";
	    //   result.style.backgroundSize = (img.width * cx) + "px " + (img.height * cy) + "px";
	    //   /* Execute a function when someone moves the cursor over the image, or the lens: */
	    //   lens.addEventListener("mousemove", moveLens);
	    //   img.addEventListener("mousemove", moveLens);
	    //   /* And also for touch screens: */
	    //   lens.addEventListener("touchmove", moveLens);
	    //   img.addEventListener("touchmove", moveLens);
	    //   function moveLens(e) {
	    //     let pos, x, y;
	    //     /* Prevent any other actions that may occur when moving over the image */
	    //     e.preventDefault();
	    //     /* Get the cursor's x and y positions: */
	    //     pos = getCursorPos(e);
	    //     /* Calculate the position of the lens: */
	    //     x = pos.x - (lens.offsetWidth / 2);
	    //     y = pos.y - (lens.offsetHeight / 2);
	    //     /* Prevent the lens from being positioned outside the image: */
	    //     if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
	    //     if (x < 0) {x = 0;}
	    //     if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
	    //     if (y < 0) {y = 0;}
	    //     /* Set the position of the lens: */
	    //     lens.style.left = x + "px";
	    //     lens.style.top = y + "px";
	    //     /* Display what the lens "sees": */
	    //     result.style.backgroundPosition = "-" + (x * cx) + "px -" + (y * cy) + "px";
	    //   }
	    //   function getCursorPos(e) {
	    //     let a, x = 0, y = 0;
	    //     e = e || window.event;
	    //     /* Get the x and y positions of the image: */
	    //     a = img.getBoundingClientRect();
	    //     /* Calculate the cursor's x and y coordinates, relative to the image: */
	    //     x = e.pageX - a.left;
	    //     y = e.pageY - a.top;
	    //     /* Consider any page scrolling: */
	    //     x = x - window.pageXOffset;
	    //     y = y - window.pageYOffset;
	    //     return {x : x, y : y};
	    //   }
	    // }
	
	  }, {
	    key: 'magnify',
	    value: function magnify(imgID, zoom) {
	      var img, glass, w, h, bw, magnifier;
	      img = document.getElementById(imgID);
	      glass = document.getElementById(this.magnifierLensId);
	      magnifier = document.getElementById(this.magnifierBG);
	
	      /* Create magnifier glass: */
	      // glass = document.createElement("DIV");
	      // glass.setAttribute("class", "img-magnifier-glass");
	
	      /* Insert magnifier glass: */
	      img.parentElement.insertBefore(glass, img);
	
	      /* Set background properties for the magnifier glass: */
	      glass.style.backgroundImage = "url('" + img.src + "')";
	      glass.style.backgroundRepeat = "no-repeat";
	      glass.style.backgroundSize = img.width * zoom + "px " + img.height * zoom + "px";
	      bw = 3;
	      w = glass.offsetWidth / 2;
	      h = glass.offsetHeight / 2;
	
	      /* Execute a function when someone moves the magnifier glass over the image: */
	      glass.addEventListener("mousemove", moveMagnifier);
	      img.addEventListener("mousemove", moveMagnifier);
	      magnifier.addEventListener("mousemove", moveMagnifier);
	
	      /*and also for touch screens:*/
	      glass.addEventListener("touchmove", moveMagnifier);
	      img.addEventListener("touchmove", moveMagnifier);
	      magnifier.addEventListener("touchmove", moveMagnifier);
	
	      function moveMagnifier(e) {
	        var pos, x, y;
	        /* Prevent any other actions that may occur when moving over the image */
	        e.preventDefault();
	        /* Get the cursor's x and y positions: */
	        pos = getCursorPos(e);
	        x = pos.x;
	        y = pos.y;
	        /* Prevent the magnifier glass from being positioned outside the image: */
	        if (x > img.width - w / zoom) {
	          x = img.width - w / zoom;
	        }
	        if (x < w / zoom) {
	          x = w / zoom;
	        }
	        if (y > img.height - h / zoom) {
	          y = img.height - h / zoom;
	        }
	        if (y < h / zoom) {
	          y = h / zoom;
	        }
	        /* Set the position of the magnifier glass: */
	        glass.style.left = x - w + "px";
	        glass.style.top = y - h + "px";
	        /* Set the position of the magnifier background: */
	        magnifier.style.left = x - w + 40 + "px";
	        magnifier.style.top = y - h + 80 + "px";
	        /* Display what the magnifier glass "sees": */
	        glass.style.backgroundPosition = "-" + (x * zoom - w + bw) + "px -" + (y * zoom - h + bw) + "px";
	      }
	
	      function getCursorPos(e) {
	        var a,
	            x = 0,
	            y = 0;
	        e = e || window.event;
	        /* Get the x and y positions of the image: */
	        a = img.getBoundingClientRect();
	        /* Calculate the cursor's x and y coordinates, relative to the image: */
	        x = e.pageX - a.left;
	        y = e.pageY - a.top;
	        /* Consider any page scrolling: */
	        x = x - window.pageXOffset;
	        y = y - window.pageYOffset;
	        return { x: x, y: y };
	      }
	    }
	  }]);
	  return MagnifierController;
	}();
	
	exports.default = MagnifierController;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(890);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./magnifier.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./magnifier.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".magnifier-component{display:flex;position:relative}.magnifier-component .magnifier-bg{background-image:url(\"/assets/images/magnifier.png\");height:300px;width:480px;position:absolute;background-size:contain;background-repeat:no-repeat;z-index:1;transform:rotate(229deg)}.magnifier-component .img-magnifier-container{position:relative}.magnifier-component .img-magnifier-glass{position:absolute;border:1px solid #ccc;background-color:#fff;cursor:none;width:300px;height:300px;border-radius:50%;box-shadow:0 0 10px -1px #000;z-index:3}.magnifier-component .img-magnifier-glass_hidden{visibility:hidden}.magnifier-component .img-zoom-container{position:relative}.magnifier-component .img-zoom-lens{position:absolute;border:1px solid #d4d4d4;width:170px;height:120px;background:#ccc;opacity:.5}.magnifier-component .img-zoom-lens_hidden{visibility:hidden}.magnifier-component .img-zoom-result{position:absolute;border:1px solid #d4d4d4;width:250px;height:250px;right:0}.magnifier-component .img-zoom-result_hidden{visibility:hidden}", ""]);
	
	// exports


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrowTooltip = __webpack_require__(892);
	
	var _arrowTooltip2 = _interopRequireDefault(_arrowTooltip);
	
	var _arrowTooltip3 = __webpack_require__(893);
	
	var _arrowTooltip4 = _interopRequireDefault(_arrowTooltip3);
	
	__webpack_require__(894);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var arrowTooltipComponent = {
	  bindings: {
	    tooltipText: '<',
	    tooltipStyles: '<'
	  },
	  controllerAs: 'vm',
	  template: _arrowTooltip2.default,
	  controller: _arrowTooltip4.default
	};
	
	exports.default = arrowTooltipComponent;

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"minto-arrow-tooltip\" ng-style=\"vm.tooltipStyles['minto-arrow-tooltip']\">\n  <svg height=\"30\" width=\"40\" xmlns=\"http://www.w3.org/2000/svg\">\n    <circle cx=\"10\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <circle cx=\"17\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <circle cx=\"24\" cy=\"20\" r=\"2\" fill=\"#050e61\"/>\n    <polyline stroke=\"#050e61\" fill=\"none\" points=\"30,12 35,17 30,22\" stroke-width=\"3\"/>\n  </svg>\n  <div ng-bind-html=\"vm.tooltipText\" class=\"minto-arrow-tooltip__text\"></div>\n</div>\n"

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ArrowTooltipController = function ArrowTooltipController() {
	  'ngInject';
	
	  (0, _classCallCheck3.default)(this, ArrowTooltipController);
	};
	
	exports.default = ArrowTooltipController;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(895);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./arrow-tooltip.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./arrow-tooltip.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".minto-arrow-tooltip{position:relative;display:inline-block}.minto-arrow-tooltip__text{visibility:hidden;background-color:#fff;color:#050e61;border-radius:6px;padding:10px;position:absolute;z-index:1;min-width:300px;top:30px}.minto-arrow-tooltip:hover .minto-arrow-tooltip__text{visibility:visible}", ""]);
	
	// exports


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _fullWordingIntroductionPaper = __webpack_require__(897);
	
	var _fullWordingIntroductionPaper2 = _interopRequireDefault(_fullWordingIntroductionPaper);
	
	var _fullWordingIntroductionPaper3 = __webpack_require__(898);
	
	var _fullWordingIntroductionPaper4 = _interopRequireDefault(_fullWordingIntroductionPaper3);
	
	__webpack_require__(899);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fullWordingIntroductionPaperComponent = {
	  bindings: {
	    // buttonText: '<',
	    diagramId: '<',
	    mintoIntroduction: '<',
	    header: '<',
	    showNext: '&',
	    finishedExercises: '<',
	    clearDiagramId: '<',
	    userExerciseAnswers: '<',
	    showFooterBg: '<'
	  },
	  controllerAs: 'vm',
	  template: _fullWordingIntroductionPaper2.default,
	  controller: _fullWordingIntroductionPaper4.default
	};
	
	exports.default = fullWordingIntroductionPaperComponent;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports = "<!-- next id used for styles -->\n<div id=\"fullWordingIntroductionPaper\">\n  <div id=\"{{vm.diagramId}}\">\n    <div class=\"sheet-of-paper\">\n\n      <!--    <div class=\"paper-header\">-->\n      <!--      <div>-->\n      <!--        <p>TO:</p>-->\n      <!--        <p>FROM:</p>-->\n      <!--      </div>-->\n      <!--      <div>-->\n      <!--        <p>DATE:</p>-->\n      <!--        <p>SUBJECT: <span ng-bind=\"vm.header | translate\"></span></p>-->\n      <!--      </div>-->\n      <!--    </div>-->\n\n      <!--    <hr class=\"horizontal-line\"/>-->\n\n      <div id=\"check-lines\" style=\"position: absolute; opacity: 0;\"></div>\n\n      <div class=\"paper-date\">{{vm.currentDate}}</div>\n\n<!--      <div ng-if=\"vm.isUserAnswerExpanded\"-->\n<!--           class=\"sheet-of-paper__long-bg\"-->\n<!--           ng-style=\"{height: vm.expandedBgHeight}\"></div>-->\n\n      <div ng-if=\"vm.showMintoIntroduction\" class=\"correct-paper-answer\"\n           ng-bind-html=\"vm.mintoIntroduction | translate\"/>\n\n      <div class=\"paper-subject\" style=\"\n          position: absolute;\n          top: 312px;\n          left: 187px;\n          font-size: 18px;\n      \"> </div>\n      <div class=\"student-paper-answer\">\n        <textarea ng-if=\"!vm.showMintoIntroduction\" ng-model=\"vm.userAnswerInput\" class=\"student-paper-answer__field\" placeholder=\"Enter your text...\"\n                  rows=\"{{vm.studentAnswerRows}}\"></textarea>\n<!--        <span ng-if=\"vm.showMintoIntroduction && vm.isUserAnswerBigger && !vm.isUserAnswerExpanded\"-->\n<!--              class=\"student-paper-answer__field student-paper-answer__expand\"-->\n<!--              ng-click=\"vm.expandUserAnswer()\">...</span>-->\n      </div>\n    </div>\n    <div ng-if=\"vm.showFooterBg\" class=\"sheet-of-paper_footer-bg\"></div>\n\n    <div style=\"display: flex; justify-content: flex-end;\">\n      <button class=\"simplest__structure-btn\" ng-click=\"vm.toogleMintoIntroduction()\"\n              ng-bind=\"vm.buttonText | translate\"></button>\n      <button ng-if=\"vm.showMintoIntroduction\" class=\"simplest__structure-btn\" id=\"next\" ng-click=\"vm.showNext({ $event: { fullwordingIntroduction: vm.userAnswerInput }})\"\n              ng-bind=\"'next' | translate\"></button>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FullWordingIntroductionPaperController = function (_CourseController) {
	  FullWordingIntroductionPaperController.$inject = ["courseService", "helperService", "$translate", "$scope"];
	  (0, _inherits3.default)(FullWordingIntroductionPaperController, _CourseController);
	
	  function FullWordingIntroductionPaperController(courseService, helperService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, FullWordingIntroductionPaperController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (FullWordingIntroductionPaperController.__proto__ || (0, _getPrototypeOf2.default)(FullWordingIntroductionPaperController)).call(this, courseService, helperService, $translate, $scope));
	
	    _this.showMintoIntroduction = false;
	    _this.fullWordingOfIntroduction = true;
	    _this.studentAnswerRows = 12;
	    _this.expandedBgHeight = '0px';
	    _this.userAnswerInput = '';
	    _this.userAnswer = 'VIEW YOUR TEXT';
	    _this.schoolAnswer = 'VIEW SCHOOL SOLUTION';
	    _this.buttonText = _this.schoolAnswer;
	
	    var date = new Date();
	    var dateOptions = { month: 'long', day: 'numeric', year: 'numeric' };
	    _this.currentDate = date.toLocaleDateString('en-EN', dateOptions);
	    return _this;
	  }
	
	  (0, _createClass3.default)(FullWordingIntroductionPaperController, [{
	    key: 'toogleMintoIntroduction',
	    value: function toogleMintoIntroduction() {
	      this.showMintoIntroduction = !this.showMintoIntroduction;
	      this.buttonText = this.showMintoIntroduction ? this.userAnswer : this.schoolAnswer;
	      // this.studentAnswerRows = 4
	      //
	      // const textField = $(document.querySelector(`#${this.diagramId} .student-paper-answer__field`))
	      // const inputText = textField.val()
	      // const inputWidth = textField.css('width')
	      // this.inputLineHeight = parseInt(textField.css('line-height').slice(0, -2))
	      //
	      // const div = document.querySelector(`#${this.diagramId} #check-lines`)
	      // const textarea = document.createElement('textarea')
	      // textarea.classList.add('student-paper-answer__field')
	      // textarea.value = inputText
	      // textarea.style.width = inputWidth
	      //
	      // div.appendChild(textarea)
	      // const scrollHeight = textarea.scrollHeight
	      //
	      // div.parentNode.removeChild(div);
	      //
	      // this.userAnswerRowsCount = Math.floor(scrollHeight / this.inputLineHeight)
	      //
	      // this.isUserAnswerBigger = this.userAnswerRowsCount > 4
	    }
	  }, {
	    key: 'expandUserAnswer',
	    value: function expandUserAnswer() {
	      this.studentAnswerRows = this.userAnswerRowsCount;
	
	      var fullWording = $('#' + this.diagramId);
	      var diagramHeight = fullWording.height();
	
	      var growHeight = this.userAnswerRowsCount * this.inputLineHeight + 16;
	      fullWording.height(diagramHeight + growHeight);
	      this.isUserAnswerExpanded = true;
	      this.expandedBgHeight = growHeight + 'px';
	      //  move buttons
	      var nextButton = $(document.querySelector('#' + this.diagramId + ' #next'));
	      nextButton.css({ top: diagramHeight + growHeight - 660 + 'px', position: 'relative' });
	    }
	  }]);
	  return FullWordingIntroductionPaperController;
	}(_course2.default);
	
	exports.default = FullWordingIntroductionPaperController;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(900);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fullWordingIntroductionPaper.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./fullWordingIntroductionPaper.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#fullWordingIntroductionPaper{display:flex;flex-direction:column;overflow:hidden}#fullWordingIntroductionPaper .paper-header div:last-child{width:50%;align-items:flex-start}#fullWordingIntroductionPaper .paper-header div p{width:auto}#fullWordingIntroductionPaper ul li{font-size:18px!important;line-height:19px!important}#fullWordingIntroductionPaper .student-paper-answer{position:relative}#fullWordingIntroductionPaper .student-paper-answer__expand{right:-6px}#fullWordingIntroductionPaper .sheet-of-paper__long-bg{top:572px;z-index:auto;width:100%}#fullWordingIntroductionPaper .sheet-of-paper{position:relative;padding:360px 117px 0 116px!important;animation-name:none;transform:none;margin-left:0}#fullWordingIntroductionPaper .sheet-of-paper,#fullWordingIntroductionPaper .sheet-of-paper_footer-bg{max-width:none;width:100%;background:url(\"/assets/images/FullWordingIntroductionPaper.png\");background-size:cover;background-repeat:no-repeat}#fullWordingIntroductionPaper .sheet-of-paper_footer-bg{height:40px;background-position:0 -1130px;padding:0 117px 0 116px!important}#fullWordingIntroductionPaper .student-paper-answer__field{font-family:Times New Roman!important}#fullWordingIntroductionPaper .paper-date{position:absolute;top:267px;right:178px;font-size:18px}#fullWordingIntroductionPaper .simplest__structure-btn{border-color:#050e61;border-radius:15px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:18px;margin-top:15px;margin-right:43px}#fullWordingIntroductionPaper .correct-paper-answer{border-bottom:none}#fullWordingIntroductionPaper .correct-paper-answer p{margin-bottom:12px;line-height:19px}#fullWordingIntroductionPaper .correct-paper-answer p:last-child{margin-bottom:0}", ""]);
	
	// exports


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _treeDiagram = __webpack_require__(902);
	
	var _treeDiagram2 = _interopRequireDefault(_treeDiagram);
	
	var _treeRenderer = __webpack_require__(903);
	
	var _treeRenderer2 = _interopRequireDefault(_treeRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return {
	    restrict: 'E',
	    replace: true,
	    template: _treeDiagram2.default,
	    link: function link($scope, $element, $attributes) {
	      var renderer = $scope.$eval($attributes.renderer);
	
	      if (!renderer instanceof _treeRenderer2.default) {
	        throw new TypeError('"Renderer" must be an instance of TreeDiagramRenderer');
	      }
	    }
	  };
	};

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"unit-diagram tree-diagram\"></div>"

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _pyramidRendererView = __webpack_require__(904);
	
	var _pyramidRendererView2 = _interopRequireDefault(_pyramidRendererView);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeDiagramRenderer = function () {
	  function TreeDiagramRenderer(questions, scheme, zoom, mouseWheelZoom) {
	    (0, _classCallCheck3.default)(this, TreeDiagramRenderer);
	
	    this.scheme = scheme || [];
	    this.questionFlag = questions;
	    this.zoom = zoom;
	    this.mouseWheelZoom = mouseWheelZoom;
	    this.options = {
	      xAxisOffset: 50,
	      yAxisOffset: 120,
	      droppable: true
	    };
	  }
	
	  (0, _createClass3.default)(TreeDiagramRenderer, [{
	    key: 'destroy',
	    value: function destroy() {
	      this.children.length = 0;
	      this.destroySVG();
	    }
	  }, {
	    key: 'getByModel',
	    value: function getByModel(model) {
	      return this.children.find(function (leaf) {
	        return leaf.model === model;
	      });
	    }
	  }, {
	    key: 'setModelAt',
	    value: function setModelAt(i, model) {
	      if (this.children[i]) {
	        this.children[i].model = model;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!this.scheme || this.scheme.length < 1) return;
	
	      this.tree = new _pyramidRendererView2.default({
	        duration: 1000,
	        rectangle: {
	          recWidth: 165,
	          recHeight: 110,
	          spaceBetweenRecX: 70,
	          spaceBetweenRecY: 280
	        },
	        zoom: this.zoom,
	        mouseWheelZoom: this.mouseWheelZoom,
	        questionsEnabled: this.questionFlag,
	        clickHandler: this.onSelectItem,
	        zoomHandler: this.onZoom
	      });
	      this.tree.init(this.scheme);
	      this.scheme = this.tree.treeScheme;
	    }
	
	    /**
	     * Callback handler
	     */
	
	  }, {
	    key: 'onSelectItem',
	    value: function onSelectItem() {}
	  }, {
	    key: 'onMouseWheel',
	    value: function onMouseWheel() {}
	  }]);
	  return TreeDiagramRenderer;
	}();
	
	exports.default = TreeDiagramRenderer;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _d3Custom = __webpack_require__(905);
	
	var _d3Custom2 = _interopRequireDefault(_d3Custom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tree = function () {
	  function Tree(options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Tree);
	
	    this.duration = options.duration;
	    this.rectangleProperties = options.rectangle;
	    this.counter = 0;
	    this.questionFlag = options.questionsEnabled;
	    this.clickHandler = options.clickHandler;
	    this.zoomHandler = options.zoomHandler;
	    this.treemap = _d3Custom2.default.tree().nodeSize([this.rectangleProperties.recWidth + this.rectangleProperties.spaceBetweenRecX, 0]);
	    // .separation(function(a,b){
	    //   return a.parrent==b.parrent?1:1
	    // });
	
	    // Set very large size SVG
	    var wrapper = _d3Custom2.default.select('.content-item.active .pyramid__builder-tree__diagram');
	    var svgWidth = 100000;
	    if (wrapper.select('svg').empty()) {
	      this.svgEl = wrapper.append('svg').attr('class', 'pyramid').attr('width', svgWidth + 'px').style('margin-left', '-50000px');
	      this.svgEl.append('svg:defs');
	    } else {
	      return;
	    }
	
	    // Create inner group element and translate to center
	    var svgCenterX = svgWidth / 2 + $(window).outerWidth() / 2 - this.rectangleProperties.recWidth / 2; // calculate centerX
	    this.svg = this.svgEl.append('g').attr('transform', 'translate(' + svgCenterX + ',' + 0 + ')'); // center group wrapper Xaxis
	
	    // Change group translate on window resize
	    window.addEventListener("resize", function () {
	      svgCenterX = svgWidth / 2 + $(window).outerWidth() / 2 - _this.rectangleProperties.recWidth / 2; // calculate centerX
	      _this.svg.attr('transform', 'translate(' + svgCenterX + ',' + 0 + ')');
	    }, true);
	
	    this.treeDepth = 0;
	
	    // zoom
	    this.zoom = {
	      scale: options.zoom,
	      d3: _d3Custom2.default.zoom()
	      // range of scale
	      .scaleExtent([0.2, 2])
	      // wheel sensivity
	      .wheelDelta(function () {
	        return -_d3Custom2.default.event.deltaY * (_d3Custom2.default.event.deltaMode ? 120 : 1) / 1000;
	      })
	      // d3 zoom event
	      .on('zoom', function () {
	        _this.zoom.scale = _d3Custom2.default.event.transform;
	        _this.zoomHandler(_this.zoom.scale);
	        _d3Custom2.default.select('.tab-content').style('transform', 'translate(' + _this.zoom.scale.x + 'px,' + _this.zoom.scale.y + 'px) scale(' + _this.zoom.scale.k + ')');
	      })
	      // filter to disable zoom events on '_no_drag' class
	      .filter(function () {
	        return !_d3Custom2.default.event.path[0].closest('._no_drag') || _d3Custom2.default.event.type == 'wheel';
	      }),
	      element: _d3Custom2.default.select('.tabs__wrapper')
	      // disable zoom on dblclick
	    };this.zoom.element.call(this.zoom.d3).on("dblclick.zoom", null);
	
	    if (!options.mouseWheelZoom) {
	      this.zoom.element.on("wheel.zoom", null);
	    }
	  }
	
	  (0, _createClass3.default)(Tree, [{
	    key: 'init',
	    value: function init(data) {
	      var _this2 = this;
	
	      // set zoom
	      setTimeout(function () {
	        _this2.zoom.element.transition().duration(1300).call(_this2.zoom.d3.transform, _d3Custom2.default.zoomIdentity.translate(_this2.zoom.scale.x, _this2.zoom.scale.y).scale(_this2.zoom.scale.k));
	      }, 500);
	
	      if (!this.svgEl || data === 'empty') return;
	
	      this.root = _d3Custom2.default.hierarchy(data[0] || data);
	      this.root.x0 = 0;
	      this.root.y0 = 0;
	      this.selectedNode = this.root;
	      // this.clickHandler(this.selectedNode);
	
	      this.treeScheme = this.root;
	
	      this.update(this.root);
	    }
	  }, {
	    key: 'zoomTo',
	    value: function zoomTo(scale) {
	      this.zoomHandler(scale);
	      this.zoom.d3.scaleTo(this.zoom.element, scale);
	    }
	  }, {
	    key: 'changeDeductive',
	    value: function changeDeductive() {
	      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedNode;
	
	      selected.data.deductive = !selected.data.deductive;
	      this.update(selected);
	    }
	  }, {
	    key: 'changeChildsNodeCount',
	    value: function changeChildsNodeCount() {
	      var selected = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectedNode;
	      var numberFromInput = arguments[1];
	
	      var numberOfChildNodes = selected.children ? selected.children.length : 0;
	      var diffBetweenNodesCount = numberFromInput - numberOfChildNodes;
	      if (Math.abs(numberFromInput > 5)) {
	        return;
	      }
	      // if selected node have empty children Array
	      if (!selected.children) {
	        selected.children = [];
	        selected.data.children = [];
	      }
	
	      //if add Nodes
	      if (diffBetweenNodesCount > 0) {
	
	        // create new Node model object
	        var newNodeObj = {
	          model: null,
	          children: []
	        };
	
	        // creates new Node
	        do {
	          var newNode = _d3Custom2.default.hierarchy(newNodeObj);
	          newNode.depth = selected.depth + 1;
	          newNode.height = selected.height + 1;
	          newNode.parent = selected;
	          selected.children.push(newNode);
	          selected.data.children.push(newNode.data);
	          diffBetweenNodesCount--;
	        } while (diffBetweenNodesCount > 0);
	      } else {
	        // if remove Nodes
	        selected.children.splice(diffBetweenNodesCount);
	        selected.data.children.splice(diffBetweenNodesCount);
	      }
	      if (selected.children.length == 0) {
	        selected.children = null;
	        selected.data.children = null;
	        this.update(selected);
	      } else {
	        this.update(selected);
	      }
	    }
	  }, {
	    key: 'toggleQuestions',
	    value: function toggleQuestions(activeFlag) {
	      var textareas = _d3Custom2.default.selectAll('.pyramid__builder-wrapper .pyramid__node_wrp textarea');
	      var questions = _d3Custom2.default.selectAll('.pyramid__builder-wrapper .pyramid__node_wrp .pyramid__node_q');
	      if (activeFlag) {
	        this.questionFlag = true;
	        textareas.transition().duration(this.duration).style('height', '80px');
	
	        questions.transition().duration(this.duration / 2).style('height', '30px').delay(this.duration / 2).transition().duration(this.duration).style('padding', '2px 4px 3px');
	      } else {
	        this.questionFlag = false;
	        textareas.transition().duration(this.duration).style('height', '105px');
	
	        questions.transition().duration(this.duration / 2).style('padding', '0px 4px 0px').style('height', '0px');
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update(source) {
	      var _this3 = this;
	
	      // Create object that store tree scheme assigns the x and y position for the nodes
	      this.treeScheme = this.treemap(this.root);
	
	      // compute the new tree layout.
	      var nodes = this.treeScheme.descendants().reverse(); // reversed for NODES element z-index (parents on top)
	      var links = this.treeScheme.descendants().slice(1).reverse(); // reversed for LINKS element z-index (links under NODES)
	
	      // recalculate svg height
	      var treeDepth = _d3Custom2.default.max(nodes, function (d) {
	        return +d.depth;
	      });
	
	      var delay = treeDepth > this.treeDepth ? 0 : this.duration;
	      setTimeout(function () {
	        _this3.svgEl.attr('height', treeDepth * _this3.rectangleProperties.spaceBetweenRecY + _this3.rectangleProperties.recHeight + 1550);
	      }, delay);
	      this.treeDepth = treeDepth;
	
	      // normalize for fixed-depth.
	      nodes.forEach(function (d) {
	        d.y = d.depth * _this3.rectangleProperties.spaceBetweenRecY;
	      });
	
	      // ### LINKS
	      // update the links...
	      var link = this.svg.selectAll('line.pyramid__link').data(links, function (d) {
	        return d.id || (d.id = ++_this3.counter);
	      });
	
	      // enter any new links at the parent's previous position.
	      var linkEnter = link.enter().insert("line", ":first-child").attr('class', 'pyramid__link').attr('x1', function (d) {
	        return source.x0 + _this3.rectangleProperties.recWidth / 2;
	      }).attr('y1', function (d) {
	        if (d.parent.data.deductive) {
	          return source.y0 + _this3.rectangleProperties.recHeight - 12;
	        } else {
	          return source.y0 + _this3.rectangleProperties.recHeight - 3;
	        }
	      }).attr('x2', function (d) {
	        return source.x0 + _this3.rectangleProperties.recWidth / 2;
	      }).attr('y2', function (d) {
	        return source.y0 + _this3.rectangleProperties.recHeight;
	      });
	
	      var linkUpdate = linkEnter.merge(link);
	
	      // transition back to the parent element position
	      linkUpdate.transition().duration(this.duration).attr('x1', function (d) {
	        // check if parent is deductive (same logic used for next points)
	        if (d.parent.data.deductive) {
	          // get children object from parent from id
	          var thisChild = d.parent.children.find(function (obj) {
	            return obj.id === d.id;
	          });
	          // get this Node index
	          var i = d.parent.children.indexOf(thisChild) + 1;
	          // check if this Node child not last
	          if (i < d.parent.children.length) {
	            return d.parent.children[i].x;
	          } else {
	            // if last child Node
	            if (i <= 2) {
	              // if child count <=2  centering parent x point
	              return d.parent.x + _this3.rectangleProperties.recWidth / 2;
	            } else {
	              return d.parent.x + _this3.rectangleProperties.recWidth;
	            }
	          }
	        } else {
	          return d.parent.x + _this3.rectangleProperties.recWidth / 2;
	        }
	      }).attr('y1', function (d) {
	        if (d.parent.data.deductive) {
	          var thisChild = d.parent.children.find(function (obj) {
	            return obj.id === d.id;
	          });
	          var i = d.parent.children.indexOf(thisChild) + 1;
	          if (i < d.parent.children.length) {
	            return d.y + _this3.rectangleProperties.recHeight / 2;
	          } else {
	            return d.parent.y + _this3.rectangleProperties.recHeight;
	          }
	        } else {
	          return d.parent.y + _this3.rectangleProperties.recHeight - 2;
	        }
	      }).attr('x2', function (d) {
	        if (d.parent.data.deductive) {
	          var thisChild = d.parent.children.find(function (obj) {
	            return obj.id === d.id;
	          });
	          var i = d.parent.children.indexOf(thisChild) + 1;
	          if (i < d.parent.children.length) {
	            return d.x;
	          } else {
	            return d.x + _this3.rectangleProperties.recWidth / 2;
	          }
	        } else {
	          return d.x + _this3.rectangleProperties.recWidth / 2;
	        }
	      }).attr('y2', function (d) {
	        if (d.parent.data.deductive) {
	          var thisChild = d.parent.children.find(function (obj) {
	            return obj.id === d.id;
	          });
	          var i = d.parent.children.indexOf(thisChild) + 1;
	          if (i < d.parent.children.length) {
	            return d.y + _this3.rectangleProperties.recHeight / 2;
	          } else {
	            return d.y + 2;
	          }
	        } else {
	          return d.y + 2;
	        }
	      })
	      // add marker arrow to line
	      .attr('marker-start', function (d) {
	        // if root element
	        var markerId = !d.parent.parent ? 0 : d.parent.id;
	
	        if (d.parent.data.deductive) {
	          if (_this3.svgEl.select('#arrow_' + markerId).empty()) {
	            _this3.svgEl.select('defs').append('svg:marker').attr('id', 'arrow_' + markerId).attr('viewBox', '0 -5 10 10').attr('refX', 9).attr('opacity', 0).attr('markerWidth', 6).attr('markerHeight', 6).attr('orient', 'auto-start-reverse').append('svg:path').attr('d', 'M0,-5L10,0L0,5').attr('fill', '#fff');
	          }
	        }
	
	        return 'url(#arrow_' + markerId + ')';
	      })
	      // deductive arrow transition
	      .on('start', function (d) {
	        // if root element
	        var markerId = !d.parent.parent ? 0 : d.parent.id;
	
	        if (d.parent.data.deductive) {
	          _d3Custom2.default.select('#arrow_' + markerId).transition().duration(_this3.duration).attr('opacity', 1);
	        } else {
	          _d3Custom2.default.select('#arrow_' + markerId).transition().duration(_this3.duration).attr('opacity', 0);
	        }
	      });
	
	      // remove any exiting links
	      var linkExit = link.exit().transition().duration(this.duration).attr('x1', function (d) {
	        if (d.parent.data.deductive && d.parent.children) {
	          var thisChild = d.parent.children.find(function (obj) {
	            return obj.id === d.id;
	          });
	          var i = d.parent.children.indexOf(thisChild) + 1;
	
	          if (i <= 2) {
	            // if child count <=2  centering parent x point
	            return d.parent.x + _this3.rectangleProperties.recWidth / 2 - 5;
	          } else {
	            return d.parent.x + _this3.rectangleProperties.recWidth - 5;
	          }
	        } else {
	          return source.x + _this3.rectangleProperties.recWidth / 2;
	        }
	      }).attr('y1', function (d) {
	        return source.y + _this3.rectangleProperties.recHeight - 3;
	      }).attr('x2', function (d) {
	        return source.x + _this3.rectangleProperties.recWidth / 2;
	      }).attr('y2', function (d) {
	        return source.y;
	      }).remove();
	
	      // NODES
	      // update the nodes
	      var node = this.svg.selectAll('g.pyramid__node').data(nodes, function (d) {
	        return d.id || (d.id = ++_this3.counter);
	      });
	
	      // enter any new modes at the parent's previous position.
	      var nodeEnter = node.enter().append('g').attr('class', 'pyramid__node').attr('pointer-events', 'none').attr('transform', function () {
	        return 'translate(' + source.x0 + ',' + source.y0 + ')';
	      }).on('click', function (d) {
	        _this3.selectedNode = d;
	        _this3.clickHandler(_this3.selectedNode);
	      });
	
	      // add rect for the nodes
	      nodeEnter.append('rect').attr('class', 'pyramid__node').attr('width', this.rectangleProperties.recWidth).attr('height', this.rectangleProperties.recHeight).attr('rx', 8);
	
	      // add html for the nodes
	      nodeEnter.append('foreignObject')
	      // Node btns events
	      .on('click', function (d) {
	        // plus
	        if (_d3Custom2.default.event.target.closest('.pyramid__node_btnsPlus')) {
	          var currentChildrenCount = d.children ? d.children.length + 1 : 1;
	          _this3.changeChildsNodeCount(d, currentChildrenCount);
	        }
	        // minus
	        if (_d3Custom2.default.event.target.closest('.pyramid__node_btnsMinus')) {
	          var index = d.parent.children.map(function (x) {
	            return x.id;
	          }).indexOf(d.id);
	
	          d.parent.children.splice(index, 1);
	          d.parent.data.children.splice(index, 1);
	          // if children array is empty change to null
	          if (!d.parent.children.length) d.parent.children = null;
	
	          _this3.update(d.parent);
	        }
	      }).attr('width', this.rectangleProperties.recWidth + 20).attr('height', this.rectangleProperties.recHeight).attr('xlmns', 'http://www.w3.org/1999/xhtml').append('xhtml:body').append('div').attr('class', 'pyramid__node_wrp _no_drag').html(function (d) {
	        // set model if null
	        if (!d.data.model) {
	          d.data.model = {
	            textarea: '',
	            question: ''
	          };
	        }
	        // if Node has'nt parent element (if root Node)
	        var minusBtnHtml = d.parent ? '<div class="pyramid__node_btnsMinus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M24 11c0-0.6-0.4-1-1-1H1c-0.6 0-1 0.4-1 1v2c0 0.6 0.4 1 1 1h22c0.6 0 1-0.4 1-1V11z"/></svg></div>' : '';
	        var plusBtnHtml = '<div class="pyramid__node_btnsPlus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m23 10h-8.5c-0.3 0-0.5-0.2-0.5-0.5v-8.5c0-0.6-0.4-1-1-1h-2c-0.6 0-1 0.4-1 1v8.5c0 0.3-0.2 0.5-0.5 0.5h-8.5c-0.6 0-1 0.4-1 1v2c0 0.6 0.4 1 1 1h8.5c0.3 0 0.5 0.2 0.5 0.5v8.5c0 0.6 0.4 1 1 1h2c0.6 0 1-0.4 1-1v-8.5c0-0.3 0.2-0.5 0.5-0.5h8.5c0.6 0 1-0.4 1-1v-2c0-0.6-0.4-1-1-1z"/></svg></div>';
	
	        // Render new item textarea and question whithout/whith styling
	        var questionStyling = void 0;
	        if (_this3.questionFlag) {
	          questionStyling = '<textarea autocomplete="nope" name="textarea_' + d.id + '">' + d.data.model.textarea + '</textarea><div class="pyramid__node_q"><p>Q:</p><input autocomplete="nope" type="text" value="' + d.data.model.question + '" name="input_' + d.id + '"></div>';
	        } else {
	          questionStyling = '<textarea style="height: 105px;" autocomplete="nope" name="textarea_' + d.id + '">' + d.data.model.textarea + '</textarea><div class="pyramid__node_q" style="height: 0px; padding: 0px 4px;"><p>Q:</p><input autocomplete="nope" type="text" value="' + d.data.model.question + '" name="input_' + d.id + '"></div>';
	        }
	
	        // return html of foreightObject
	        return questionStyling + '<div class="pyramid__node_btns">' + minusBtnHtml + plusBtnHtml + '</div>';
	      })
	      // textarea onchange event
	      .select('textarea').on('change', function (d) {
	        d.data.model.textarea = _d3Custom2.default.event.target.value;
	        _this3.clickHandler(d);
	      });
	
	      // show Node btn on hover
	      _d3Custom2.default.selectAll('.pyramid__node').on('mouseenter', function (d) {
	        _d3Custom2.default.select(this).select('.pyramid__node_btns').style('opacity', 1);
	      }).on('mouseleave', function (d) {
	        _d3Custom2.default.select(this).select('.pyramid__node_btns').style('opacity', 0);
	      })
	      // input onchange event
	      .select('input').on('change', function (d) {
	        d.data.model.question = _d3Custom2.default.event.target.value;
	        _this3.clickHandler(d);
	      });
	
	      // update
	      var nodeUpdate = nodeEnter.merge(node);
	
	      // transition to the proper position for the node
	      nodeUpdate.attr('pointer-events', 'all').transition().duration(this.duration).attr('transform', function (d) {
	        return 'translate(' + d.x + ',' + d.y + ')';
	      });
	
	      // update the node attributes and style
	      nodeUpdate.select('g.pyramid__node').attr('width', this.rectangleProperties.recWidth).attr('height', this.rectangleProperties.recHeight).attr('rx', 8);
	
	      // if Node has > 5 childrens hide plus btn
	      nodeUpdate.select('.pyramid__node_btnsPlus').style('display', function (d) {
	        if (d.children) {
	          if (d.children.length > 4) {
	            return 'none';
	          } else {
	            return 'block';
	          }
	        } else {
	          return 'block';
	        }
	      });
	
	      // remove any exiting nodes
	      var nodeExit = node.exit().attr('pointer-events', 'none').transition().duration(this.duration).attr('transform', function (d) {
	        return 'translate(' + source.x + ',' + source.y + ')';
	      }).remove();
	
	      // store the old positions for transition.
	      nodes.forEach(function (d) {
	        d.x0 = d.x;
	        d.y0 = d.y;
	      });
	    }
	  }]);
	  return Tree;
	}();
	
	exports.default = Tree;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _d3Zoom = __webpack_require__(906);
	
	var _d3Hierarchy = __webpack_require__(915);
	
	var _d3Selection = __webpack_require__(909);
	
	var _d3Array = __webpack_require__(916);
	
	exports.default = {
	  zoom: _d3Zoom.zoom,
	  zoomIdentity: _d3Zoom.zoomIdentity,
	  tree: _d3Hierarchy.tree,
	  hierarchy: _d3Hierarchy.hierarchy,
	  select: _d3Selection.select,
	  selectAll: _d3Selection.selectAll,
	  max: _d3Array.max,
	  get event() {
	    return _d3Selection.event;
	  }
	};

/***/ }),
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      $element.draggable({
	        cursor: 'hand',
	        scroll: false,
	        revert: function revert(event, ui) {
	          $(this).data("uiDraggable").originalPosition = {
	            top: 0,
	            left: 0
	          };
	          return !event;
	        }
	      });
	    }
	  };
	};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _button = __webpack_require__(919);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      var diagram = $scope.$eval($attributes.diagram);
	      diagram.registerButton(new _button2.default($element));
	    }
	  };
	};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Button = function () {
	  function Button(element) {
	    (0, _classCallCheck3.default)(this, Button);
	
	    this.element = element;
	  }
	
	  (0, _createClass3.default)(Button, [{
	    key: 'revert',
	    value: function revert() {
	      console.log('revert', this.element);
	      this.element.data('dropped', false);
	      this.element.animate(this.element.data("uiDraggable").originalPosition, "slow");
	    }
	  }, {
	    key: 'moveToElement',
	    value: function moveToElement(leafElement) {
	      var $leafElement = $(leafElement);
	
	      this.element.position({
	        my: 'left top',
	        at: 'center',
	        of: $leafElement,
	        using: function using(position) {
	          $(this).animate(position, 'slow', 'linear');
	        }
	      });
	    }
	  }, {
	    key: 'id',
	    get: function get() {
	      return +this.element.attr('data-item');
	    }
	  }]);
	  return Button;
	}();
	
	exports.default = Button;

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      $element.on('keydown keyup', function (e) {
	        var isMax = Number($element.val()) > Number($attributes.max);
	        var isMin = Number($element.val()) < Number($attributes.min);
	
	        console.log(isMin, isMax, $element.val());
	
	        if (isMax || isMin && e.keyCode != 46 && e.keyCode != 8) {
	          e.preventDefault();
	          $element.val(isMax ? $attributes.max : $attributes.min);
	        }
	      });
	    }
	  };
	};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	treeDiagramFactory.$inject = ["$timeout", "audioService"];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.treeDiagramRendererFactory = treeDiagramRendererFactory;
	exports.treeDiagramFactory = treeDiagramFactory;
	
	var _treeRenderer = __webpack_require__(903);
	
	var _treeRenderer2 = _interopRequireDefault(_treeRenderer);
	
	var _treeDiagram = __webpack_require__(922);
	
	var _treeDiagram2 = _interopRequireDefault(_treeDiagram);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function treeDiagramRendererFactory() {
	  return {
	    getInstance: function getInstance(questions, zoom, scheme, mouseWheelZoom) {
	      return new _treeRenderer2.default(questions, scheme, zoom, mouseWheelZoom);
	    }
	  };
	}
	
	function treeDiagramFactory($timeout, audioService) {
	  "ngInject";
	
	  return {
	    getInstance: function getInstance(exercise, renderer) {
	      return new _treeDiagram2.default(exercise, renderer, $timeout, audioService);
	    }
	  };
	}

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(465);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _button = __webpack_require__(919);
	
	var _button2 = _interopRequireDefault(_button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeDiagram = function () {
	  function TreeDiagram(exercise, renderer, $timeout, audioService) {
	    (0, _classCallCheck3.default)(this, TreeDiagram);
	
	    this.exercise = exercise;
	    this.buttons = [];
	    this.renderer = renderer;
	    this.$timeout = $timeout;
	    this.audioService = audioService;
	    this.renderer.onDropItem = this._onDropAnswer.bind(this);
	    this.renderer.onOverlapItem = this._onOverlapAnswer.bind(this);
	  }
	
	  /**
	   * @returns {Promise}
	   */
	
	
	  (0, _createClass3.default)(TreeDiagram, [{
	    key: 'autocomplete',
	    value: function autocomplete() {
	      this._fillCorrectAnswers();
	      return this._autocompleteAnswersAsync();
	    }
	
	    /**
	     * @returns {Boolean}
	     */
	
	  }, {
	    key: 'complete',
	    value: function complete() {
	      return this._checkFinalAnswer();
	    }
	
	    /**
	     * @returns {Promise}
	     */
	
	  }, {
	    key: 'restart',
	    value: function restart() {
	      this.renderer.empty();
	      return this._restartAnswersAsync();
	    }
	  }, {
	    key: 'registerButton',
	    value: function registerButton(button) {
	      if (button instanceof _button2.default) {
	        this.buttons.push(button);
	      }
	    }
	  }, {
	    key: '_findButtonById',
	    value: function _findButtonById(id) {
	      return this.buttons.find(function (button) {
	        return button.id === id;
	      });
	    }
	  }, {
	    key: '_onDropAnswer',
	    value: function _onDropAnswer() {
	      this.audioService.play('tab');
	    }
	  }, {
	    key: '_onOverlapAnswer',
	    value: function _onOverlapAnswer(data) {
	      this.audioService.play('tab');
	
	      if (data.previous) {
	        var previousButton = this._findButtonById(data.previous);
	
	        if (previousButton) {
	          previousButton.revert();
	        }
	      }
	    }
	  }, {
	    key: '_checkFinalAnswer',
	    value: function _checkFinalAnswer() {
	      var correctAnswers = this.exercise.answer;
	      var userAnswers = this.renderer.flatten();
	      return correctAnswers.every(function (correctAnswer, i) {
	        return correctAnswer === userAnswers[i];
	      });
	    }
	  }, {
	    key: '_fillCorrectAnswers',
	    value: function _fillCorrectAnswers() {
	      var _this = this;
	
	      this.exercise.answer.forEach(function (correctAnswer, i) {
	        _this.renderer.setModelAt(i, correctAnswer);
	      });
	    }
	  }, {
	    key: '_restartAnswersAsync',
	    value: function _restartAnswersAsync() {
	      var _this2 = this;
	
	      var asyncList = this.buttons.map(function (button, i) {
	        return _this2.$timeout(function () {
	          button.revert();
	        }, 1000 * i);
	      });
	
	      return _promise2.default.all(asyncList);
	    }
	  }, {
	    key: '_autocompleteAnswersAsync',
	    value: function _autocompleteAnswersAsync() {
	      var _this3 = this;
	
	      var asyncList = this.buttons.map(function (button, i) {
	        var leaf = _this3.renderer.getByModel(button.id);
	        return _this3.$timeout(function () {
	          button.moveToElement(leaf.element);
	        }, 1000 * i);
	      });
	
	      return _promise2.default.all(asyncList);
	    }
	  }]);
	  return TreeDiagram;
	}();
	
	exports.default = TreeDiagram;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(924);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(925);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(926);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1a1-1\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1a-diagram1.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <div class=\"slot\" data-item=\"1_1\" id=\"slot_1_1\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" data-item=\"1_2\" id=\"slot_1_2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"1_3\" id=\"slot_1_3\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"1_4\" id=\"slot_1_4\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"1_3\" id=\"element_1_3\" translate>1a-diagram1.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"1_2\" id=\"element_1_2\" translate>1a-diagram1.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"1_1\" id=\"element_1_1\" translate>1a-diagram1.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"1_4\" id=\"element_1_4\" translate>1a-diagram1.element_1_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <!--<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.reset()\" class=\"submit-exercise-button\" ng-bind=\"'reset' | translate\"></button>-->\n    <p ng-if=\"vm.diagramCompleteOnce && vm.diagramComplete\" class=\"diagram-message\" translate>1a-diagram1.diagram-message</p>\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1a-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce && vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1a1-1';
	    _this.submitBtn = 'diagram1a1-1-submit';
	    _this.nextBtn = 'diagram1a1-2-next';
	    _this.diagramNumber = 2;
	    _this.demo = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(927);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(929);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(930);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './diagram2.scss';
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1a1-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1a-diagram2.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <div class=\"slot\" data-item=\"2_1\" id=\"slot_2_1\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" data-item=\"2_2\" id=\"slot_2_2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"2_3\" id=\"slot_2_3\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"2_4\" id=\"slot_2_4\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"2_3\" id=\"element_2_3\" translate>1a-diagram2.element_2_3</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"2_2\" id=\"element_2_2\" translate>1a-diagram2.element_2_2</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"2_1\" id=\"element_2_1\" translate>1a-diagram2.element_2_1</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"2_4\" id=\"element_2_4\" translate>1a-diagram2.element_2_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <!--<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.reset()\" class=\"submit-exercise-button\" ng-bind=\"'reset' | translate\"></button>-->\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1a-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce && vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1a1-2';
	    _this.submitBtn = 'diagram1a1-2-submit';
	    _this.nextBtn = 'diagram1a1-3-next';
	    _this.diagramNumber = 2;
	    _this.demo = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(932);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(933);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './diagram2.scss';
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1a1-3\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1a-diagram3.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <div class=\"slot\" data-item=\"3_1\" id=\"slot_3_1\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" data-item=\"3_2\" id=\"slot_3_2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"3_3\" id=\"slot_3_3\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"3_4\" id=\"slot_3_4\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"3_1\" id=\"element_3_1\" translate>1a-diagram3.element_3_1</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"3_2\" id=\"element_3_2\" translate>1a-diagram3.element_3_2</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"3_4\" id=\"element_3_4\" translate>1a-diagram3.element_3_3</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"3_3\" id=\"element_3_3\" translate>1a-diagram3.element_3_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <!--<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.reset()\" class=\"submit-exercise-button\" ng-bind=\"'reset' | translate\"></button>-->\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1a-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce && vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1a1-3';
	    _this.submitBtn = 'diagram1a1-3-submit';
	    _this.nextBtn = 'diagram1a1-4-next';
	    _this.diagramNumber = 3;
	    _this.demo = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(935);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(936);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(937);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1a1-4\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1a-diagram4.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"6\">\n          <div class=\"slot\" data-item=\"4_1\" id=\"slot_4_1\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"6\" class=\"separator\">\n          <svg height=\"94px\" width=\"1124px\"  class=\"diagram-connector s1a-color\">\n            <path d=\"M 180 94 l 382 -94\"></path>\n            <path d=\"M 562 94 l 0 -94\"></path>\n            <path d=\"M 944 94 l -382 -94\"></path>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"2\">\n          <div class=\"slot\" data-item=\"4_2\" id=\"slot_4_2\"></div>\n        </td>\n        <td colspan=\"2\">\n          <div class=\"slot\" data-item=\"4_3\" id=\"slot_4_3\"></div>\n        </td>\n        <td colspan=\"2\">\n          <div class=\"slot\" data-item=\"4_4\" id=\"slot_4_4\"></div>\n        </td>\n      </tr>\n      <tr class=\"short-separator\">\n        <td colspan=\"2\" class=\"separator\">\n          <svg height=\"30px\" width=\"372px\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 90 30 l 101 -33\"></path>\n            <path d=\"M 280 30 l -101 -33\"></path>\n          </svg>\n        </td>\n        <td colspan=\"2\" class=\"separator\">\n          <svg height=\"30px\" width=\"372px\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 90 30 l 101 -33\"></path>\n            <path d=\"M 280 30 l -101 -33\"></path>\n          </svg>\n        </td>\n        <td colspan=\"2\" class=\"separator\">\n          <!-- <svg height=\"160px\" width=\"372px\" style=\"overflow: visible;\" class=\"diagram-connector s1a-color\">\n            <path d=\"M 186 138 l 0 -138\" stroke=red></path>\n            <path d=\"M -92 138 l 374 0\" stroke=blue></path>\n            <path d=\"M -92 163 l 0 -26\" stroke=yellow></path>\n            <path d=\"M 93 163 l 0 -26\" stroke=cyan></path>\n            <path d=\"M 281 163 l 0 -26\" stroke=black></path>\n          </svg> -->\n          <svg height=\"160px\" width=\"372px\" style=\"overflow: visible;\" class=\"diagram-connector s1a-color\">\n              <path d=\"M 93 163 l 94 -164\"></path>\n              <path d=\"M 280 163 l -93 -164\"></path>\n              <path d=\"M -92 163 l 279 -165\"></path>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" data-item=\"4_5\" id=\"slot_4_5\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"4_6\" id=\"slot_4_6\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"4_7\" id=\"slot_4_7\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"4_8\" id=\"slot_4_8\"></div>\n        </td>\n        <td></td>\n        <td></td>\n      </tr>\n      <tr class=\"middle-separator\">\n        <td colspan=\"6\" class=\"separator\"></td>\n      </tr>\n      <tr>\n        <td></td>\n        <td></td>\n        <td></td>\n        <td>\n          <div class=\"slot\" data-item=\"4_9\" id=\"slot_4_9\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"4_10\" id=\"slot_4_10\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" data-item=\"4_11\" id=\"slot_4_11\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"huge-diagram_answers\">\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"4_11\" id=\"element_4_11\" translate>1a-diagram4.element_4_11</div>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"4_1\" id=\"element_4_1\" translate>1a-diagram4.element_4_1</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_5\" id=\"element_4_5\" translate>1a-diagram4.element_4_5</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_6\" id=\"element_4_6\" translate>1a-diagram4.element_4_6</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_2\" id=\"element_4_2\" translate>1a-diagram4.element_4_2</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_7\" id=\"element_4_7\" translate>1a-diagram4.element_4_7</div>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"element\" data-item=\"4_8\" id=\"element_4_8\" translate>1a-diagram4.element_4_8</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_3\" id=\"element_4_3\" translate>1a-diagram4.element_4_3</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_9\" id=\"element_4_9\" translate>1a-diagram4.element_4_9</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_10\" id=\"element_4_10\" translate>1a-diagram4.element_4_10</div>\n        </td>\n        <td>\n          <div class=\"element\" data-item=\"4_4\" id=\"element_4_4\" translate>1a-diagram4.element_4_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1a-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce && vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1a1-4';
	    _this.submitBtn = 'diagram1a1-4-submit';
	    _this.nextBtn = 'diagram1a1-final-next';
	    _this.diagramNumber = 4;
	    _this.demo = true;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(938);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1a .diagram .unit-wrapper.wide{max-width:1183px;padding:44px 0 45px}.unit1a .diagram .unit-wrapper.wide .submit{margin-right:3%}.unit1a .diagram .unit-wrapper.wide .huge-diagram_answers{position:relative;top:-150px;height:170px}.unit1a .diagram .unit-wrapper.wide .short-separator td{height:25px}.unit1a .diagram .unit-wrapper.wide .middle-separator td{height:45px}", ""]);
	
	// exports


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(940);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(941);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(942);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1b1-1\" class='unit-diagram'>\n  <p class=\"diagram-task\" translate>1b-diagram1.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n          <td colspan=\"3\">\n            <div class=\"slot\" id=\"slot_1_4\" data-item=\"1_4\" number=\"4\"></div>\n          </td>\n      </tr>\n      <tr>\n        <td colspan='3' class='separator'>\n          <svg height='94px' width='556px' class='diagram-connector s1c-color'>\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" id=\"slot_1_1\" data-item=\"1_1\" number=\"1\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_1_2\" data-item=\"1_2\" number=\"2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_1_3\" data-item=\"1_3\" number=\"3\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" data-item=\"1_1\" number=\"1\" translate>1b-diagram1.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" data-item=\"1_3\" number=\"3\" translate>1b-diagram1.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" data-item=\"1_2\" number=\"2\" translate>1b-diagram1.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_4\" data-item=\"1_4\" number=\"4\" translate>1b-diagram1.fixed-answer</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'hint' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1b1-1';
	    _this.submitBtn = 'diagram1b1-1-submit';
	    _this.nextBtn = 'diagram1b1-2-next';
	    _this.diagramNumber = 1;
	    _this.amountCorrectAnswers = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(943);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1b{align-items:center;justify-content:center}", ""]);
	
	// exports


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(945);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(946);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './diagram2.scss';
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1b1-2\" class='unit-diagram'>\n  <p class=\"diagram-task\" translate>1b-diagram2.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan='3'>\n          <div class=\"slot\" id=\"slot_2_4\" data-item=\"2_4\" number=\"4\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan='3' class='separator'>\n          <svg height='94px' width='556px' class='diagram-connector s1c-color'>\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" id=\"slot_2_1\" data-item=\"2_1\" number=\"1\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_2_2\" data-item=\"2_2\" number=\"2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_2_3\" data-item=\"2_3\" number=\"3\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_2_4\" data-item=\"2_4\"  number=\"4\" translate>1b-diagram2.fixed-answer</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_2_3\" data-item=\"2_3\" number=\"3\" translate>1b-diagram2.element_2_2</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_2_2\" data-item=\"2_2\" number=\"2\" translate>1b-diagram2.element_2_3</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_2_1\" data-item=\"2_1\" number=\"1\" translate>1b-diagram2.element_2_1</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'hint' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1b1-2';
	    _this.submitBtn = 'diagram1b1-2-submit';
	    _this.nextBtn = 'diagram1b1-3-next';
	    _this.diagramNumber = 2;
	    _this.amountCorrectAnswers = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(948);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(949);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './diagram2.scss';
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1b1-3\" class='unit-diagram'>\n  <p class=\"diagram-task\" translate>1b-diagram3.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan='4'>\n          <div class=\"slot\" id=\"slot_3_5\" data-item=\"3_5\" number=\"5\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan='4' class='separator'>\n          <svg height='94px' width='750px' class='diagram-connector s1c-color'>\n            <path d=\"M 93 94 l 282 -94\"></path>\n            <path d=\"M 282 94 l 92 -94\"></path>\n            <path d=\"M 468 94 l -92 -94\"></path>\n            <path d=\"M 657 94 l -282 -94\"></path>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" id=\"slot_3_1\" data-item=\"3_1\" number=\"1\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_3_2\" data-item=\"3_2\" number=\"2\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_3_3\" data-item=\"3_3\" number=\"3\"></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_3_4\" data-item=\"3_4\" number=\"4\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_3_3\" data-item=\"3_3\" number=\"3\" translate>1b-diagram3.element_3_3</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_3_1\" data-item=\"3_1\" number=\"1\" translate>1b-diagram3.element_3_1</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_3_5\" data-item=\"3_5\" number=\"5\" translate>1b-diagram3.fixed-answer</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_3_2\" data-item=\"3_2\" number=\"2\" translate>1b-diagram3.element_3_2</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_3_4\" data-item=\"3_4\" number=\"4\" translate>1b-diagram3.element_3_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'hint' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1b1-3';
	    _this.submitBtn = 'diagram1b1-3-submit';
	    _this.nextBtn = 'diagram1b1-4-next';
	    _this.diagramNumber = 3;
	    _this.amountCorrectAnswers = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(951);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(952);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1b1-4\" class='unit-diagram'>\n  <p class=\"diagram-task\" translate>1b-diagram4.diagram-task</p>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan='3'>\n          <div class=\"slot\" id=\"slot_4_3\" data-item=\"4_3\" number=\"3\"></div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan='3' class='separator'>\n          <svg height='94px' width='556px' class='diagram-connector s1c-color'>\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"slot\" id=\"slot_4_1\" data-item=\"4_1\" number=\"1\"></div>\n        </td>\n        <td>\n          <div class='empty-draggable-box'></div>\n        </td>\n        <td>\n          <div class=\"slot\" id=\"slot_4_2\" data-item=\"4_2\" number=\"2\"></div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_4_1\" data-item=\"4_1\" number=\"1\" translate>1b-diagram4.element_4_1</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_4_3\" data-item=\"4_3\" number=\"3\" translate>1b-diagram4.fixed-answer</div>\n        </td>\n        <!-- <td>\n          <div class='empty-draggable-box'></div>\n        </td> -->\n        <td>\n          <div class=\"element\" id=\"element_4_2\" data-item=\"4_2\" number=\"2\" translate>1b-diagram4.element_4_2</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'hint' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle | translate\"></button>\n    <button ng-if=\"vm.diagramCompleteOnce\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1b1-4';
	    _this.submitBtn = 'diagram1b1-4-submit';
	    _this.nextBtn = 'diagram1b1-final-next';
	    _this.diagramNumber = 4;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(954);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1b .empty-draggable-box{width:165px;border:none!important}", ""]);
	
	// exports


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(956);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(957);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(958);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1c1-1\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1c-diagram1.diagram-task</p>\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box1\" ng-model=\"vm.userAnswers.box1\" id=\"rule-1c1-1-1\" ng-disabled=\"vm.diagramComplete\" />\n      <label for=\"rule-1c1-1-1\"></label>\n    </div>\n    <label for=\"rule-1c1-1-1\" class=\"checkbox-description\" translate>1c-diagram1.rule1</label>\n\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box2\" ng-model=\"vm.userAnswers.box2\" id=\"rule-1c1-1-2\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n      <label for=\"rule-1c1-1-2\"></label>\n    </div>\n    <label for=\"rule-1c1-1-2\" class=\"checkbox-description\" translate>1c-diagram1.rule2</label>\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box3\" ng-model=\"vm.userAnswers.box3\" id=\"rule-1c1-1-3\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n      <label for=\"rule-1c1-1-3\"></label>\n    </div>\n    <label for=\"rule-1c1-1-3\" class=\"checkbox-description\" translate>1c-diagram1.rule3</label>\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n        <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n        <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1c1-1';
	    _this.submitBtn = 'diagram1c1-1-submit';
	    _this.nextBtn = 'diagram1c1-1-next';
	    _this.diagramNumber = 1;
	    _this.checkboxes = true;
	    _this.userAnswers = {
	      box1: false,
	      box2: false,
	      box3: false
	    };
	    _this.correctAnswers = {
	      box1: true,
	      box2: true,
	      box3: true
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(959);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1c .unit-video .video{background-image:url(https://i.vimeocdn.com/video/710442955.webp?mw=1200&mh=675&q=70)}.unit1c .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61}.unit1c .diagram-task{float:none;width:60%;text-align:left;color:#050e61;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:33px;padding-left:5px}.unit1c .checkboxes-task{padding:25px 25px 25px 145px}.unit1c .checkboxes-task.ng-valid-answear .checkbox-description{cursor:default}.unit1c .checkboxes-task .checkbox-description{cursor:pointer;display:block;padding-left:50px;text-align:left;color:#050e61;font-size:1.2rem}.unit1c .checkboxes-task .checkbox{position:relative}.unit1c .checkboxes-task .checkbox input+label{position:absolute;top:13px;display:block;height:22px;width:22px;border:3px solid #fff;border-radius:9px;z-index:2;cursor:pointer}.unit1c .checkboxes-task .checkbox input+label:after{content:\"\";position:absolute;display:block;top:0;left:0;box-shadow:inset 0 0 3px 0 #000;height:16px;width:16px;border:none;border-radius:9px;background:#fff;z-index:1;opacity:0;transition:opacity .2s}.unit1c .checkboxes-task .checkbox input:disabled+label{cursor:default}.unit1c .checkboxes-task input[type=checkbox]{opacity:0}.unit1c .checkboxes-task input[type=checkbox]:checked+label:after{opacity:1}.unit1c .checkboxes-task input[type=radio]{opacity:0}.unit1c .checkboxes-task input[type=radio]:checked+label:after,.unit1c .checkboxes-task input[type=radio]:hover+label:after{opacity:1}.unit1c .submit{width:100%;text-align:right}.unit1c .submit .hint-exercise-button{opacity:1;transition:opacity 2s ease-in}.unit1c .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#fc922c;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit1c .wrong+label{box-shadow:0 0 2px 2px red!important}.unit1c .correct+label{border:2px solid #fff}", ""]);
	
	// exports


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(961);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(962);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 961 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1c1-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1c-diagram2.diagram-task</p>\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box1\" ng-model=\"vm.userAnswers.box1\" id=\"rule-1c1-2-1\" ng-disabled=\"vm.diagramComplete\" />\n      <label for=\"rule-1c1-2-1\"></label>\n    </div>\n    <label for=\"rule-1c1-2-1\" class=\"checkbox-description\" translate>1c-diagram2.rule1</label>\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box2\" ng-model=\"vm.userAnswers.box2\" id=\"rule-1c1-2-2\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n      <label for=\"rule-1c1-2-2\"></label>\n    </div>\n    <label for=\"rule-1c1-2-2\" class=\"checkbox-description\" translate>1c-diagram2.rule2</label>\n    <div class=\"checkbox\">\n      <input type=\"checkbox\" name=\"box3\" ng-model=\"vm.userAnswers.box3\" id=\"rule-1c1-2-3\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n      <label for=\"rule-1c1-2-3\"></label>\n    </div>\n    <label for=\"rule-1c1-2-3\" class=\"checkbox-description\" translate>1c-diagram2.rule3</label>\n    <div class=\"submit\">\n      <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n      <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n      <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(963);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1c1-2';
	    _this.submitBtn = 'diagram1c1-2-submit';
	    _this.nextBtn = 'diagram1c1-3-next';
	    _this.diagramNumber = 2;
	    _this.checkboxes = true;
	    _this.userAnswers = {
	      box1: false,
	      box2: false,
	      box3: false
	    };
	    _this.correctAnswers = {
	      box1: true,
	      box2: true,
	      box3: true
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 963 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = submitAction;
	function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
	  var elements = document.querySelectorAll('#' + diagram_id + ' input');
	  var correct_elements = document.querySelectorAll('#' + diagram_id + ' input[data-correct]');
	
	  for (var i = 0; i < elements.length; i++) {
	    removeOldClass(elements[i]);
	    if (elements[i].hasAttribute('data-correct') && elements[i].checked) {
	      elements[i].classList.add('correct');
	    } else if (elements[i].hasAttribute('data-correct') && !elements[i].checked || !elements[i].hasAttribute('data-correct') && elements[i].checked) {
	      elements[i].classList.add('wrong');
	    };
	  };
	
	  var correct_answers_counter = document.querySelectorAll('#' + diagram_id + ' .correct').length;
	  var incorrect_answers_counter = document.querySelectorAll('#' + diagram_id + ' .wrong').length;
	  var next_button = document.getElementById(next_btn);
	
	  if (correct_answers_counter == correct_elements.length && incorrect_answers_counter == 0) {
	    disabledCheckboxes(elements);
	    submit_btn.style = 'display: none;';
	    next_button.style = 'display: inline-block; opacity: 1;';
	  };
	}
	
	function removeOldClass(el) {
	  el.classList.remove('correct', 'wrong');
	}
	
	function disabledCheckboxes(arr) {
	  for (var i = 0; i < arr.length; i++) {
	    arr[i].disabled = true;
	  };
	}
	
	function submit(diagram_id, submit_btn, next_btn) {
	  var action_button = document.getElementById(submit_btn);
	
	  action_button.addEventListener('click', function (el) {
	    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
	  });
	}
	
	function submitAction(diagram_id, submit_btn, next_btn) {
	  submit(diagram_id, submit_btn, next_btn);
	}

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(965);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(966);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import './diagram2.scss';
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1c1-3\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1c-diagram3.diagram-task</p>\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box1\" ng-model=\"vm.userAnswers.box1\" id=\"rule-1c1-3-1\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-1c1-3-1\"></label>\n    </div>\n    <label for=\"rule-1c1-3-1\" class=\"checkbox-description\" translate>1c-diagram3.rule1</label>\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box2\" ng-model=\"vm.userAnswers.box2\" id=\"rule-1c1-3-2\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n        <label for=\"rule-1c1-3-2\"></label>\n    </div>\n    <label for=\"rule-1c1-3-2\" class=\"checkbox-description\" translate>1c-diagram3.rule2</label>\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box3\" ng-model=\"vm.userAnswers.box3\" id=\"rule-1c1-3-3\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n        <label for=\"rule-1c1-3-3\"></label>\n    </div>\n    <label for=\"rule-1c1-3-3\" class=\"checkbox-description\" translate>1c-diagram3.rule3</label>\n    <div class=\"submit\">\n        <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n        <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n        <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(963);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1c1-3';
	    _this.submitBtn = 'diagram1c1-3-submit';
	    _this.nextBtn = 'diagram1c1-4-next';
	    _this.diagramNumber = 3;
	    _this.checkboxes = true;
	    _this.userAnswers = {
	      box1: false,
	      box2: false,
	      box3: false
	    };
	    _this.correctAnswers = {
	      box1: true,
	      box2: true,
	      box3: true
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(968);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(969);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1c1-4\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1c-diagram4.diagram-task</p>\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box1\" ng-model=\"vm.userAnswers.box1\" id=\"rule-1c1-4-1\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-1c1-4-1\"></label>\n    </div>\n    <label for=\"rule-1c1-4-1\" class=\"checkbox-description\" translate>1c-diagram4.rule1</label>\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box2\" ng-model=\"vm.userAnswers.box2\" id=\"rule-1c1-4-2\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n        <label for=\"rule-1c1-4-2\"></label>\n    </div>\n    <label for=\"rule-1c1-4-2\" class=\"checkbox-description\" translate>1c-diagram4.rule2</label>\n    <div class=\"checkbox\">\n        <input type=\"checkbox\" name=\"box3\" ng-model=\"vm.userAnswers.box3\" id=\"rule-1c1-4-3\" ng-disabled=\"vm.diagramComplete\" data-correct/>\n        <label for=\"rule-1c1-4-3\"></label>\n    </div>\n    <label for=\"rule-1c1-4-3\" class=\"checkbox-description\" translate>1c-diagram4.rule3</label>\n    <div class=\"submit\">\n        <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n        <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n        <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n  </form>\n</div>\n"

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(963);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1c1-4';
	    _this.submitBtn = 'diagram1c1-4-submit';
	    _this.nextBtn = 'diagram1c1-final-next';
	    _this.diagramNumber = 4;
	    _this.checkboxes = true;
	    _this.userAnswers = {
	      box1: false,
	      box2: false,
	      box3: false
	    };
	    _this.correctAnswers = {
	      box1: false,
	      box2: true,
	      box3: true
	    };
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(971);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(972);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(974);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1d1-1\" class=\"unit-diagram\">\n\t<p class=\"diagram-task\" translate>1d-diagram1.diagram-task</p>\n  <ol class=\"diagram-description\" translate>1d-diagram1.diagram-description</ol>\n\t<div id=\"slots\">\n\t\t<table class=\"slots\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"3\" style=\"position: relative;\">\n\t\t\t\t\t<textarea class=\"answer-field\" ng-model=\"vm.model.boxOne\"></textarea>\n\t\t\t\t\t<div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram1.fixed-answer1</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"3\" class=\"separator\">\n\t\t\t\t\t<svg height=\"94px\" width=\"556px\" class=\"diagram-connector s1d-color\">\n\t\t\t\t\t\t<path d=\"M 102 94 l 176 -94\"/>\n\t\t\t\t\t\t<path d=\"M 278 94 l 0 -94\"/>\n\t\t\t\t\t\t<path d=\"M 454 94 l -176 -94\"/>\n\t\t\t\t\t</svg>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>1d-diagram1.fixed-answer2</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>1d-diagram1.fixed-answer3</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>1d-diagram1.fixed-answer4</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n\t<div class=\"submit\">\n\t\t<button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n\t\t<button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n\t</div>\n</div>\n"

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(973);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1d1-1';
	    _this.submitBtn = 'diagram1d1-1-submit';
	    _this.nextBtn = 'diagram1d1-2-next';
	    _this.diagramNumber = 1;
	    _this.amountCorrectAnswers = 1;
	    _this.model = {
	      boxOne: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = submitAction;
	function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
	  var textarea = document.querySelectorAll('#' + diagram_id + ' .answer-field')[0];
	  var answer = document.querySelectorAll('#' + diagram_id + ' .hint')[0];
	  var next_button = document.getElementById(next_btn);
	
	  if (textarea.value) {
	    textarea.disabled = true;
	    answer.style = 'opacity: 1;';
	    submit_btn.style = 'display: none;';
	    next_button.style = 'display: inline-block; opacity: 1;';
	  } else textarea.focus();
	}
	
	function submit(diagram_id, submit_btn, next_btn) {
	  var action_button = document.getElementById(submit_btn);
	
	  action_button.addEventListener('click', function (el) {
	    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
	  });
	}
	
	function submitAction(diagram_id, submit_btn, next_btn) {
	  submit(diagram_id, submit_btn, next_btn);
	}

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(975);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1d .unit-video .video{background-image:url(https://i.vimeocdn.com/video/710442760.webp?mw=1200&mh=675&q=70)}", ""]);
	
	// exports


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(977);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(978);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(980);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1d1-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1d-diagram2.diagram-task</p>\n  <ol style=\"left: 46px;\" class=\"diagram-description\" translate>1d-diagram2.diagram-description</ol>\n  <ol style=\"left: 52%;\" class=\"diagram-description\" translate>1d-diagram2.diagram-description2</ol>\n  <div id=\"slots\" class=\"slots\">\n    <div class=\"slots__diagram\" style=\"position: relative\">\n      <div class=\"fields-margin\">\n        <textarea class=\"answer-field\" ng-model=\"vm.model.boxOne\"></textarea>\n        <div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram2.fixed-answer1</div>\n      </div>\n      <div class=\"separator\">\n        <svg height=\"94px\" width=\"426px\" class=\"diagram-connector s1d-color\">\n          <path d=\"M 30 93 l 125 -94\"/>\n          <path d=\"M 279 93 l -125 -94\"/>\n        </svg>\n      </div>\n      <div class=\"slots__diagram_answers\">\n        <div class=\"fixed-answer space_between_answers\" translate>1d-diagram2.fixed-answer3</div>\n        <div class=\"fixed-answer\" translate>1d-diagram2.fixed-answer4</div>\n      </div>\n    </div>\n    <div class=\"slots__diagram\" style=\"position: relative\">\n      <div class=\"fields-margin\">\n        <textarea class=\"answer-field\" ng-model=\"vm.model.boxTwo\"></textarea>\n        <div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram2.fixed-answer2</div>\n      </div>\n      <div class=\"separator\">\n        <svg height=\"94px\" width=\"426px\" class=\"diagram-connector s1d-color\">\n          <path d=\"M 30 93 l 125 -94\"/>\n          <path d=\"M 279 93 l -125 -94\"/>\n        </svg>\n      </div>\n      <div class=\"slots__diagram_answers\">\n        <div class=\"fixed-answer space_between_answers\" translate>1d-diagram2.fixed-answer5</div>\n        <div class=\"fixed-answer\" translate>1d-diagram2.fixed-answer6</div>\n      </div>\n    </div>\n  </div>\n  <div class=\"submit\">\n     <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram = __webpack_require__(979);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1d1-2';
	    _this.submitBtn = 'diagram1d1-2-submit';
	    _this.nextBtn = 'diagram1d1-3-next';
	    _this.diagramNumber = 2;
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber, false, { slotsQuery: '.slot' });
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = submitAction;
	function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
	  var textarea = document.querySelectorAll('#' + diagram_id + ' .answer-field');
	  var answer = document.querySelectorAll('#' + diagram_id + ' .hint');
	  var next_button = document.getElementById(next_btn);
	
	  for (var i = 0; i < textarea.length; i++) {
	    if (!textarea[i].value) {
	      textarea[i].focus();
	      return;
	    } else {
	      textarea[i].disabled = true;
	      answer[i].style = 'opacity: 1;';
	    }
	  }
	
	  submit_btn.style = 'display: none;';
	  next_button.style = 'display: inline-block; opacity: 1;';
	}
	
	function submit(diagram_id, submit_btn, next_btn) {
	  var action_button = document.getElementById(submit_btn);
	
	  action_button.addEventListener('click', function (el) {
	    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
	  });
	}
	
	function submitAction(diagram_id, submit_btn, next_btn) {
	  submit(diagram_id, submit_btn, next_btn);
	}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(981);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1d #diagram1d1-2{padding-top:75px;min-height:579px;max-width:1440px;margin:0 auto;position:relative}.unit1d #diagram1d1-2 .diagram-task{margin-left:23px}@media (min-width:1420px){.unit1d #diagram1d1-2 .hint-static{left:54.7%!important}}@media (min-width:1320px) and (max-width:1419px){.unit1d #diagram1d1-2 .hint-static{left:54.8%!important}}@media (min-width:1220px) and (max-width:1319px){.unit1d #diagram1d1-2 .hint-static{left:55%!important}}@media (min-width:1120px) and (max-width:1219px){.unit1d #diagram1d1-2 .hint-static{left:55.4%!important}}@media (max-width:1119px){.unit1d #diagram1d1-2 .hint-static{left:56%!important}}.unit1d #diagram1d1-2 .diagram-description{width:25%;top:194px;left:58px}.unit1d #diagram1d1-2 .slots{display:flex;flex-direction:row;width:100%}.unit1d #diagram1d1-2 .slots .fields-margin{margin-left:250px}.unit1d #diagram1d1-2 .slots__diagram{width:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;margin-right:0}.unit1d #diagram1d1-2 .slots__diagram .separator{margin-top:-2px;margin-right:67px}.unit1d #diagram1d1-2 .slots__diagram_answers{display:flex;flex-direction:row;justify-content:center;margin-left:230px}.unit1d #diagram1d1-2 .slots__diagram_answers .space_between_answers{margin-right:75px}.unit1d #diagram1d1-2 .submit{margin-right:3%}.unit1d #diagram1d1-2 #slots .hint{right:30px}", ""]);
	
	// exports


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(983);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(984);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(985);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1d1-3\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1d-diagram3.diagram-task</p>\n  <ol class=\"diagram-description\" translate>1d-diagram3.diagram-description</ol>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n          <textarea class=\"answer-field\" ng-model=\"vm.model.boxOne\"></textarea>\n          <div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram3.fixed-answer1</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"12\" class=\"separator\">\n          <svg height=\"144px\" width=\"750px\">\n            <defs>\n              <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\" class=\"s1d-arrow\">\n                <path d=\"M0,1.5 L0,4.5 L6,3 z\"/>\n              </marker>\n            </defs>\n            <line x1=\"657\" y1=\"93\" x2=\"389\" y2=\"4\" stroke-width=\"3\" marker-end=\"url(#arrow)\" class=\"s1d-color\"></line>\n            <line x1=\"170\" y1=\"136\" x2=\"273\" y2=\"136\" stroke-width=\"3\" marker-end=\"url(#arrow)\" class=\"s1d-color\"></line>\n            <line x1=\"450\" y1=\"136\" x2=\"553\" y2=\"136\" stroke-width=\"3\" marker-end=\"url(#arrow)\" class=\"s1d-color\"></line>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"4\" style=\"text-align: left;\">\n          <div class=\"fixed-answer\" translate>1d-diagram3.fixed-answer2</div>\n        </td>\n        <td colspan=\"4\">\n          <div class=\"fixed-answer\" translate>1d-diagram3.fixed-answer3</div>\n        </td>\n        <td colspan=\"4\" style=\"text-align: right;\">\n          <div class=\"fixed-answer\" translate>1d-diagram3.fixed-answer4</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"12\" class=\"middle-separator separator\">\n          <svg height=\"50px\" width=\"780px\" class=\"diagram-connector s1d-color\">\n            <!--<line x1=\"90\" y1=\"23\" x2=\"325\" y2=\"23\"></line>-->\n            <!--<line x1=\"470\" y1=\"23\" x2=\"655\" y2=\"23\"></line>-->\n\n            <line x1=\"370\" y1=\"0\" x2=\"425\" y2=\"50\"></line>\n            <line x1=\"370\" y1=\"0\" x2=\"225\" y2=\"50\"></line>\n            <!--<line x1=\"91\" y1=\"22\" x2=\"91\" y2=\"50\"></line>-->\n\n            <!--<line x1=\"471\" y1=\"22\" x2=\"471\" y2=\"50\"></line>-->\n            <line x1=\"655\" y1=\"0\" x2=\"795\" y2=\"56\"></line>\n            <line x1=\"655\" y1=\"0\" x2=\"600\" y2=\"50\"></line>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\">\n          <div class=\"fixed-answer horizontal-align\" translate>1d-diagram3.fixed-answer5</div>\n        </td>\n        <td colspan=\"3\">\n          <div class=\"fixed-answer horizontal-align\" translate>1d-diagram3.fixed-answer6</div>\n        </td>\n        <td colspan=\"3\">\n          <div class=\"fixed-answer horizontal-align\" translate>1d-diagram3.fixed-answer7</div>\n        </td>\n        <td colspan=\"3\">\n          <div class=\"fixed-answer horizontal-align\" translate>1d-diagram3.fixed-answer8</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n     <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(973);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1d1-3';
	    _this.submitBtn = 'diagram1d1-3-submit';
	    _this.nextBtn = 'diagram1d1-4-next';
	    _this.diagramNumber = 3;
	    _this.amountCorrectAnswers = 1;
	    _this.model = {
	      boxOne: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(986);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1d #diagram1d1-3{position:relative}.unit1d #diagram1d1-3 .middle-separator{height:45px}.unit1d #diagram1d1-3 #slots .hint{right:50%;margin-right:-190px}.unit1d #diagram1d1-3 .horizontal-align{position:relative;left:144px}", ""]);
	
	// exports


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(988);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(989);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(990);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1d1-4\" class='unit-diagram'>\n  <p class=\"diagram-task\" translate>1d-diagram4.diagram-task</p>\n  <ol class=\"diagram-description\" translate>1d-diagram4.diagram-description</ol>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan='3' style='position: relative;'>\n          <textarea class='answer-field' ng-model=\"vm.model.boxOne\"></textarea>\n          <div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram4.fixed-answer1</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan='3' class='separator'>\n          <svg height='94px' width='556px' class=\"diagram-connector s1d-color\">\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram4.fixed-answer2</div>\n        </td>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram4.fixed-answer3</div>\n        </td>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram4.fixed-answer4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n     <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(973);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1d1-4';
	    _this.submitBtn = 'diagram1d1-4-submit';
	    _this.nextBtn = 'diagram1d1-5-next';
	    _this.diagramNumber = 4;
	    _this.amountCorrectAnswers = 1;
	    _this.model = {
	      boxOne: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(991);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit1d .empty-draggable-box{width:165px;border:none!important}", ""]);
	
	// exports


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(993);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(994);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(995);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1d1-5\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>1d-diagram5.diagram-task</p>\n  <ol class=\"diagram-description\" translate>1d-diagram5.diagram-description</ol>\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\" style=\"position: relative;\">\n          <textarea class=\"answer-field\" ng-model=\"vm.model.boxOne\"></textarea>\n          <div class=\"fixed-answer hint\" ng-class=\"{'hint-static': vm.isStatic}\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>1d-diagram5.fixed-answer1</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\" class=\"diagram-connector s1d-color\">\n            <path d=\"M 102 94 l 176 -94\"/>\n            <path d=\"M 278 94 l 0 -94\"/>\n            <path d=\"M 454 94 l -176 -94\"/>\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram5.fixed-answer2</div>\n        </td>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram5.fixed-answer3</div>\n        </td>\n        <td>\n          <div class=\"fixed-answer\" translate>1d-diagram5.fixed-answer4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <div class=\"submit\">\n     <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(973);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	    _this.diagramId = 'diagram1d1-5';
	    _this.submitBtn = 'diagram1d1-5-submit';
	    _this.nextBtn = 'diagram1d1-final-next';
	    _this.diagramNumber = 5;
	    _this.amountCorrectAnswers = 1;
	    _this.model = {
	      boxOne: ''
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(996);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(998);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(999);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1000);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 998 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-1\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram1.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n\n    <div class=\"question-title\" translate>2b-diagram1.checkboxes.title</div>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-1-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-1-1\"></label>\n    </div>\n    <label for=\"rule-2b-1-1\" class=\"checkbox-description\" translate>2b-diagram1.checkboxes.checkbox-1</label>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-1-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-1-2\"></label>\n    </div>\n    <label for=\"rule-2b-1-2\" class=\"checkbox-description\" translate>2b-diagram1.checkboxes.checkbox-2</label>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-1-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-1-3\"></label>\n    </div>\n    <label for=\"rule-2b-1-3\" class=\"checkbox-description\" translate>2b-diagram1.checkboxes.checkbox-3</label>\n\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram1.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram1.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram1.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram1.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-1';
	    _this.submitBtn = 'diagram1-2b-2-submit';
	    _this.nextBtn = 'diagram1-2b-2-next';
	    _this.diagramNumber = 1;
	    _this.radioButtons = true;
	    _this.correctAnswer = '2';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1001);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit-2.unit2b .unit-diagram{text-align:center;user-select:none;min-height:100%;color:#050e61;position:relative}.unit-2.unit2b .diagram-task{float:left;width:100%;text-align:left;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:130px;padding-left:5px}.unit-2.unit2b .checkboxes-task{position:absolute;padding:0;top:80px}.unit-2.unit2b .checkboxes-task .question-title{font-size:45px;line-height:68px;color:#050e61;display:block}.unit-2.unit2b .checkboxes-task .checkbox-description{cursor:pointer;display:block;margin-left:40px;text-align:left;color:#050e61;font-size:1.2rem}.unit-2.unit2b .checkboxes-task .checkbox{position:relative;height:5px}.unit-2.unit2b .checkboxes-task .checkbox input+label{position:absolute;top:4px;display:block;height:22px;width:22px;border:3px solid #fff;border-radius:9px;box-shadow:0 0 3px rgba(0,0,0,.5);z-index:2;cursor:pointer}.unit-2.unit2b .checkboxes-task .checkbox input+label:after{content:\"\";position:absolute;display:block;top:0;left:0;box-shadow:inset 0 0 3px 0 #000;height:16px;width:16px;border:none;border-radius:9px;background:#fff;z-index:1;opacity:0;transition:opacity .2s}.unit-2.unit2b .checkboxes-task .checkbox input:disabled+label{cursor:default}.unit-2.unit2b .checkboxes-task input[type=checkbox]{opacity:0}.unit-2.unit2b .checkboxes-task input[type=checkbox]:checked+label:after{opacity:1}.unit-2.unit2b .checkboxes-task input[type=radio]{opacity:0}.unit-2.unit2b .checkboxes-task input[type=radio]:checked+label:after,.unit-2.unit2b .checkboxes-task input[type=radio]:hover+label:after{opacity:1}.unit-2.unit2b .submit{width:100%;padding-left:10%}.unit-2.unit2b .submit .hint-exercise-button{opacity:1;transition:opacity 2s ease-in}.unit-2.unit2b .submit .next-exercise-button,.unit-2.unit2b .submit .submit-exercise-button{float:right}.unit-2.unit2b .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}.unit-2.unit2b .slots{margin:0 auto}.unit-2.unit2b #slots{width:auto;height:auto;padding:20px;font-family:Arial,Helvetica,sans-serif;line-height:normal;margin:0 auto}.unit-2.unit2b #slots td{font-size:0}.unit-2.unit2b .separator{position:relative;height:88px}.unit-2.unit2b .separator svg{position:absolute;top:-2px;left:0;z-index:2;overflow:visible}.unit-2.unit2b #elements{width:auto;height:auto;margin:54px auto 0;text-align:center}.unit-2.unit2b #elements td{padding:10px}.unit-2.unit2b .slots td{padding:0 10px;font-size:0}.unit-2.unit2b #slots div{display:inline-block;width:165px;height:84px;padding:4px;padding-bottom:0;border:3px solid #a7dec3;border-radius:15px;margin:0 0 0 10px;background:#a7dec3;transition:all .2s ease;overflow:auto}.unit-2.unit2b #elements div:first-child,.unit-2.unit2b #slots div:first-child{margin-left:0}.unit-2.unit2b #slots div.hovered{background:hsla(0,0%,100%,.3)}.unit-2.unit2b .element{display:inline-block;width:167px;height:86px;padding:4px 8px;border-radius:13px;border:2px solid #a7dec3;margin:0 0 0 10px;background:#a7dec3;font-size:14px;line-height:16px;cursor:move;text-align:left;box-shadow:2px 2px 2px rgba(0,0,0,.2);transition:transform .3s,box-shadow .3s,border .3s,background .3s}.unit-2.unit2b .element[data-answer]{transform:scale(1) translate(-8px,-4px)}.unit-2.unit2b .element.ui-draggable.ui-draggable-dragging{transform:scale(1.1);transform-origin:50% 50%}.unit-2.unit2b .wrong{box-shadow:0 0 5px 2px red}.unit-2.unit2b .correct{border:2px solid #fff}", ""]);
	
	// exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1003);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1004);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1005);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram2.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n\n    <div class=\"question-title\" translate>2b-diagram2.checkboxes.title</div>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-2-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-2-1\"></label>\n    </div>\n    <label for=\"rule-2b-2-1\" class=\"checkbox-description\" translate>2b-diagram2.checkboxes.checkbox-1</label>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-2-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-2-2\"></label>\n    </div>\n    <label for=\"rule-2b-2-2\" class=\"checkbox-description\" translate>2b-diagram2.checkboxes.checkbox-2</label>\n\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-2-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-2-3\"></label>\n    </div>\n    <label for=\"rule-2b-2-3\" class=\"checkbox-description\" translate>2b-diagram2.checkboxes.checkbox-3</label>\n\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram2.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram2.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram2.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram2.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-2';
	    _this.submitBtn = 'diagram2-2b-2-submit';
	    _this.nextBtn = 'diagram2-2b-2-next';
	    _this.diagramNumber = 2;
	    _this.radioButtons = true;
	    _this.correctAnswer = '1';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1006);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".unit2b #slots .fixed-answer{line-height:14px}", ""]);
	
	// exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1008);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1009);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1010);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-3\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram3.diagram-task</p>\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram3.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-3-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-3-1\"></label>\n    </div>\n    <label for=\"rule-2b-3-1\" class=\"checkbox-description\" translate>2b-diagram3.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-3-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-3-2\"></label>\n    </div>\n    <label for=\"rule-2b-3-2\" class=\"checkbox-description\" translate>2b-diagram3.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-3-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-3-3\"></label>\n    </div>\n    <label for=\"rule-2b-3-3\" class=\"checkbox-description\" translate>2b-diagram3.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"4\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram3.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"4\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 276 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 100 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -80 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 654 94 l -280 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer text-spacing\" translate>2b-diagram3.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer text-spacing\" translate>2b-diagram3.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer text-spacing\" translate>2b-diagram3.elements.four</div>\n        </td>\n        <td>\n          <div id=\"slot_1_5\" class=\"fixed-answer text-spacing\" translate>2b-diagram3.elements.five</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-3';
	    _this.submitBtn = 'diagram3-2b-2-submit';
	    _this.nextBtn = 'diagram3-2b-2-next';
	    _this.diagramNumber = 3;
	    _this.radioButtons = true;
	    _this.correctAnswer = '3';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1011);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2b1-3 #slots .text-spacing{display:flex;flex-direction:column;justify-content:space-between}", ""]);
	
	// exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1013);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1014);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1015);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-4\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram4.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram4.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-4-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-4-1\"></label>\n    </div>\n    <label for=\"rule-2b-4-1\" class=\"checkbox-description\" translate>2b-diagram4.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-4-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-4-2\"></label>\n    </div>\n    <label for=\"rule-2b-4-2\" class=\"checkbox-description\" translate>2b-diagram4.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-4-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-4-3\"></label>\n    </div>\n    <label for=\"rule-2b-4-3\" class=\"checkbox-description\" translate>2b-diagram4.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram4.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 132 94 l 146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 424 94 l -146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram4.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram4.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-4';
	    _this.submitBtn = 'diagram4-2b-2-submit';
	    _this.nextBtn = 'diagram4-2b-2-next';
	    _this.diagramNumber = 4;
	    _this.radioButtons = true;
	    _this.correctAnswer = '1';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1016);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2b1-4 table.slots{width:560px}", ""]);
	
	// exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1018);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1019);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1020);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-5\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram5.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram5.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-5-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-5-1\"></label>\n    </div>\n    <label for=\"rule-2b-5-1\" class=\"checkbox-description\" translate>2b-diagram5.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-5-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-5-2\"></label>\n    </div>\n    <label for=\"rule-2b-5-2\" class=\"checkbox-description\" translate>2b-diagram5.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-5-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-5-3\"></label>\n    </div>\n    <label for=\"rule-2b-5-3\" class=\"checkbox-description\" translate>2b-diagram5.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram5.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram5.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram5.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram5.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-5';
	    _this.submitBtn = 'diagram5-2b-2-submit';
	    _this.nextBtn = 'diagram5-2b-2-next';
	    _this.diagramNumber = 5;
	    _this.radioButtons = true;
	    _this.correctAnswer = '2';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1021);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1023);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1024);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1025);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-6\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram6.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram6.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-6-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-6-1\"></label>\n    </div>\n    <label for=\"rule-2b-6-1\" class=\"checkbox-description\" translate>2b-diagram6.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-6-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-6-2\"></label>\n    </div>\n    <label for=\"rule-2b-6-2\" class=\"checkbox-description\" translate>2b-diagram6.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-6-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-6-3\"></label>\n    </div>\n    <label for=\"rule-2b-6-3\" class=\"checkbox-description\" translate>2b-diagram6.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram6.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram6.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram6.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram6.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n</div>\n"

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_CourseController) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram6Controller, _CourseController);
	
	  function Diagram6Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-6';
	    _this.submitBtn = 'diagram6-2b-2-submit';
	    _this.nextBtn = 'diagram6-2b-2-next';
	    _this.diagramNumber = 6;
	    _this.radioButtons = true;
	    _this.correctAnswer = '3';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram6Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram6Controller;
	}(_course2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1026);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1028);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1029);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1030);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram7Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram7Component;

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-7_1-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram7.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram7.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-7-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-7-1\"></label>\n    </div>\n    <label for=\"rule-2b-7-1\" class=\"checkbox-description\" translate>2b-diagram7.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-7-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-7-2\"></label>\n    </div>\n    <label for=\"rule-2b-7-2\" class=\"checkbox-description\" translate>2b-diagram7.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-7-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-7-3\"></label>\n    </div>\n    <label for=\"rule-2b-7-3\" class=\"checkbox-description\" translate>2b-diagram7.checkboxes.checkbox-3</label>\n  </form>\n\n   <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram7.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 132 94 l 146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 424 94 l -146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram7.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram7.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram7Controller = function (_CourseController) {
	  Diagram7Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram7Controller, _CourseController);
	
	  function Diagram7Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram7Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram7Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram7Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-7_1-2';
	    _this.submitBtn = 'diagram7-2b-2-submit';
	    _this.nextBtn = 'diagram7-2b-2-next';
	    _this.diagramNumber = 7;
	    _this.clearDiagramId = '7';
	    _this.radioButtons = true;
	    _this.correctAnswer = '2';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram7Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram7Controller;
	}(_course2.default);
	
	exports.default = Diagram7Controller;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1031);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2b1-7_1-2 table.slots{width:560px}", ""]);
	
	// exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1033);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1034);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1035);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram8Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram8Component;

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-7_2-2\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram8.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram8.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-8-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-8-1\"></label>\n    </div>\n    <label for=\"rule-2b-8-1\" class=\"checkbox-description\" translate>2b-diagram8.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-8-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-8-2\"></label>\n    </div>\n    <label for=\"rule-2b-8-2\" class=\"checkbox-description\" translate>2b-diagram8.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-8-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-8-3\"></label>\n    </div>\n    <label for=\"rule-2b-8-3\" class=\"checkbox-description\" translate>2b-diagram8.checkboxes.checkbox-3</label>\n  </form>\n\n   <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram8.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 132 94 l 146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 424 94 l -146 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram8.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram8.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram8Controller = function (_CourseController) {
	  Diagram8Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram8Controller, _CourseController);
	
	  function Diagram8Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram8Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram8Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram8Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-7_2-2';
	    _this.submitBtn = 'diagram8-2b-2-submit';
	    _this.nextBtn = 'diagram8-2b-2-next';
	    _this.diagramNumber = 8;
	    _this.clearDiagramId = '7';
	    _this.radioButtons = true;
	    _this.correctAnswer = '1';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram8Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram8Controller;
	}(_course2.default);
	
	exports.default = Diagram8Controller;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1036);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2b1-7_2-2 table.slots{width:560px}", ""]);
	
	// exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1038);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1039);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1040);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram9Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram9Component;

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-8\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram9.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram9.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-9-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-9-1\"></label>\n    </div>\n    <label for=\"rule-2b-9-1\" class=\"checkbox-description\" translate>2b-diagram9.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-9-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-9-2\"></label>\n    </div>\n    <label for=\"rule-2b-9-2\" class=\"checkbox-description\" translate>2b-diagram9.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-9-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-9-3\"></label>\n    </div>\n    <label for=\"rule-2b-9-3\" class=\"checkbox-description\" translate>2b-diagram9.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram9.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram9.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram9.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram9.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram9Controller = function (_CourseController) {
	  Diagram9Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram9Controller, _CourseController);
	
	  function Diagram9Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram9Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram9Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram9Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-8';
	    _this.submitBtn = 'diagram9-2b-2-submit';
	    _this.nextBtn = 'diagram9-2b-2-next';
	    _this.diagramNumber = 9;
	    _this.radioButtons = true;
	    _this.correctAnswer = '2';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram9Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram9Controller;
	}(_course2.default);
	
	exports.default = Diagram9Controller;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1041);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram9.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram9.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1043);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1044);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1045);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram10Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram10Component;

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2b1-9\" class=\"unit-diagram\">\n  <p class=\"diagram-task\" translate>2b-diagram10.diagram-task</p>\n\n  <form class=\"checkboxes-task\" name=\"vm.diagramForm\">\n    <div class=\"question-title\" translate>2b-diagram10.checkboxes.title</div>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-10-1\" ng-disabled=\"vm.diagramComplete\" value=\"1\"/>\n      <label for=\"rule-2b-10-1\"></label>\n    </div>\n    <label for=\"rule-2b-10-1\" class=\"checkbox-description\" translate>2b-diagram10.checkboxes.checkbox-1</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-10-2\" ng-disabled=\"vm.diagramComplete\" value=\"2\" data-correct/>\n      <label for=\"rule-2b-10-2\"></label>\n    </div>\n    <label for=\"rule-2b-10-2\" class=\"checkbox-description\" translate>2b-diagram10.checkboxes.checkbox-2</label>\n    <div class=\"checkbox\">\n      <input type=\"radio\" name=\"group1\" ng-model=\"vm.userAnswer\" id=\"rule-2b-10-3\" ng-disabled=\"vm.diagramComplete\" value=\"3\" data-correct/>\n      <label for=\"rule-2b-10-3\"></label>\n    </div>\n    <label for=\"rule-2b-10-3\" class=\"checkbox-description\" translate>2b-diagram10.checkboxes.checkbox-3</label>\n  </form>\n\n  <div id=\"slots\">\n    <table class=\"slots\">\n      <tr>\n        <td colspan=\"3\">\n          <p class=\"question\">Q</p>\n          <div id=\"slot_1_1\" class=\"fixed-answer\" translate>2b-diagram10.elements.one</div>\n        </td>\n      </tr>\n      <tr>\n        <td colspan=\"3\" class=\"separator\">\n          <svg height=\"94px\" width=\"556px\">\n            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n          </svg>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div id=\"slot_1_2\" class=\"fixed-answer\" translate>2b-diagram10.elements.two</div>\n        </td>\n        <td>\n          <div id=\"slot_1_3\" class=\"fixed-answer\" translate>2b-diagram10.elements.three</div>\n        </td>\n        <td>\n          <div id=\"slot_1_4\" class=\"fixed-answer\" translate>2b-diagram10.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram10Controller = function (_CourseController) {
	  Diagram10Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram10Controller, _CourseController);
	
	  function Diagram10Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram10Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram10Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram10Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram2b1-9';
	    _this.submitBtn = 'diagram10-2b-2-submit';
	    _this.nextBtn = 'diagram10-2b-2-next';
	    _this.diagramNumber = 10;
	    _this.radioButtons = true;
	    _this.correctAnswer = '2';
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram10Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram10Controller;
	}(_course2.default);
	
	exports.default = Diagram10Controller;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1046);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram10.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram10.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1048);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1049);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1050);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-3a1\"  class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram1-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram1-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram1-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram1-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n</div>\n"

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram1-3a1';
	    _this.submitBtn = 'diagram1-3a1-submit';
	    _this.nextBtn = 'diagram1-3a1-next';
	    _this.diagramNumber = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1051);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1053);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1054);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1055);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram2-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram2-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram2-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram2-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller() {
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this));
	
	    _this.diagramId = 'diagram2-3a1';
	    _this.submitBtn = 'diagram2-3a1-3-submit';
	    _this.nextBtn = 'diagram2-3a1-3-next';
	    _this.diagramNumber = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1056);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1058);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1059);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1060);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram3-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram3-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram3-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram3-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller() {
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this));
	
	    _this.diagramId = 'diagram3-3a1';
	    _this.submitBtn = 'diagram3-3a1-3-submit';
	    _this.nextBtn = 'diagram3-3a1-3-next';
	    _this.diagramNumber = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1061);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1063);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1064);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1065);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram4-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram4-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram4-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram4-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller() {
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this));
	
	    _this.diagramId = 'diagram4-3a1-3';
	    _this.submitBtn = 'diagram4-3a1-3-submit';
	    _this.nextBtn = 'diagram4-3a1-3-next';
	    _this.diagramNumber = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1066);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1068);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1069);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1070);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram5-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram5-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram5-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram5-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller() {
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this));
	
	    _this.diagramId = 'diagram5-3a1-3';
	    _this.submitBtn = 'diagram5-3a1-3-submit';
	    _this.nextBtn = 'diagram5-3a1-3-next';
	    _this.diagramNumber = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1071);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1073);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1074);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1075);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram6-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram6-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram6-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram6-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram6-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram6Controller, _CourseController);
	
	  function Diagram6Controller() {
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this));
	
	    _this.diagramId = 'diagram6-3a1-3';
	    _this.submitBtn = 'diagram6-3a1-3-submit';
	    _this.nextBtn = 'diagram6-3a1-3-next';
	    _this.diagramNumber = 6;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram6Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram6Controller;
	}(_course2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1076);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1078);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1079);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1080);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram7Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram7Component;

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram7-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram7-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram7-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram7-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram7-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram7Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram7Controller, _CourseController);
	
	  function Diagram7Controller() {
	    (0, _classCallCheck3.default)(this, Diagram7Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram7Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram7Controller)).call(this));
	
	    _this.diagramId = 'diagram7-3a1-3';
	    _this.submitBtn = 'diagram7-3a1-3-submit';
	    _this.nextBtn = 'diagram7-3a1-3-next';
	    _this.diagramNumber = 7;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram7Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram7Controller;
	}(_course2.default);
	
	exports.default = Diagram7Controller;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1081);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1083);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1084);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1085);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram8Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram8Component;

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram8-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram8-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram8-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram8-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram8-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram8Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram8Controller, _CourseController);
	
	  function Diagram8Controller() {
	    (0, _classCallCheck3.default)(this, Diagram8Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram8Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram8Controller)).call(this));
	
	    _this.diagramId = 'diagram8-3a1-3';
	    _this.submitBtn = 'diagram8-3a1-3-submit';
	    _this.nextBtn = 'diagram8-3a1-3-next';
	    _this.diagramNumber = 8;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram8Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram8Controller;
	}(_course2.default);
	
	exports.default = Diagram8Controller;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1086);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1088);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1089);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1090);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram9Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram9Component;

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram9-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram9-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram9-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram9-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram9-3a1.elements.three</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram9Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram9Controller, _CourseController);
	
	  function Diagram9Controller() {
	    (0, _classCallCheck3.default)(this, Diagram9Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram9Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram9Controller)).call(this));
	
	    _this.diagramId = 'diagram9-3a1-3';
	    _this.submitBtn = 'diagram9-3a1-3-submit';
	    _this.nextBtn = 'diagram9-3a1-3-next';
	    _this.diagramNumber = 9;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram9Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram9Controller;
	}(_course2.default);
	
	exports.default = Diagram9Controller;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1091);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram9.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram9.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1093);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1094);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1095);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram10Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram10Component;

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram10-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram10-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram10-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram10-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram10-3a1.elements.three</div>\n        </td>\n                <td>\n          <div class=\"element\" id=\"element_1_4\" translate>diagram10-3a1.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram10Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram10Controller, _CourseController);
	
	  function Diagram10Controller() {
	    (0, _classCallCheck3.default)(this, Diagram10Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram10Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram10Controller)).call(this));
	
	    _this.diagramId = 'diagram10-3a1-3';
	    _this.submitBtn = 'diagram10-3a1-3-submit';
	    _this.nextBtn = 'diagram10-3a1-3-next';
	    _this.diagramNumber = 10;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram10Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram10Controller;
	}(_course2.default);
	
	exports.default = Diagram10Controller;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1096);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram10.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram10.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1098);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1099);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram11Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram11Component;

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram11-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram11-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram11-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram11-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram11-3a1.elements.three</div>\n        </td>\n                <td>\n          <div class=\"element\" id=\"element_1_4\" translate>diagram11-3a1.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram11Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram11Controller, _CourseController);
	
	  function Diagram11Controller() {
	    (0, _classCallCheck3.default)(this, Diagram11Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram11Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram11Controller)).call(this));
	
	    _this.diagramId = 'diagram11-3a1-3';
	    _this.submitBtn = 'diagram11-3a1-3-submit';
	    _this.nextBtn = 'diagram11-3a1-3-next';
	    _this.diagramNumber = 10;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram11Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram11Controller;
	}(_course2.default);
	
	exports.default = Diagram11Controller;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1101);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram11.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram11.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1103);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1104);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1105);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram12Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram12Component;

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram12-3a1\" class=\"unit-diagram\">\n  <p class=\"diagram-number\" translate>diagram12-3a1.diagram-number</p>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element\" id=\"element_1_1\" translate>diagram12-3a1.elements.one</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_2\" translate>diagram12-3a1.elements.two</div>\n        </td>\n        <td>\n          <div class=\"element\" id=\"element_1_3\" translate>diagram12-3a1.elements.three</div>\n        </td>\n                <td>\n          <div class=\"element\" id=\"element_1_4\" translate>diagram12-3a1.elements.four</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n  <diagram-complete complete-title=\"'diagram2-3a1.submit-title'\" next-title=\"'diagram2-3a1.submit-title'\"></diagram-complete>\n</div>"

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram12Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram12Controller, _CourseController);
	
	  function Diagram12Controller() {
	    (0, _classCallCheck3.default)(this, Diagram12Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram12Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram12Controller)).call(this));
	
	    _this.diagramId = 'diagram12-3a1-3';
	    _this.submitBtn = 'diagram12-3a1-3-submit';
	    _this.nextBtn = 'diagram12-3a1-3-next';
	    _this.diagramNumber = 10;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram12Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram12Controller;
	}(_course2.default);
	
	exports.default = Diagram12Controller;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1106);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram12.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram12.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1108);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1109);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a2-1\" class='unit-diagram'>\n    <p class=\"diagram-task\" translate>diagram1-3a2.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\">\n                    <textarea ng-disabled=\"vm.isStatic\"class=\"answer-field\" placeholder=\"...type here\" ng-model=\"vm.model.boxOne\"></textarea>\n                    <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram1-3a2.fixed-answer1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"92px\" width=\"750px\">\n                        <line x1=\"280\" y1=\"93\" x2=\"280\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\"> </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\">\n                    <div ng-if=\"!vm.edit\" class=\"answer-field\" ng-click=\"vm.onFocusPreFill()\" ng-bind-html=\"('diagram1-3a2.pre-fill' | translate) + ' <span>...type here</span>'\"></div>\n                    <textarea ng-disabled=\"vm.isStatic\"ng-if=\"vm.edit\" class=\"answer-field pre-filed\" ng-blur=\"vm.onBlurPreFill($event)\" ng-model=\"vm.model.boxTwo\" translate>diagram1-3a2.pre-fill</textarea>\n                    <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram1-3a2.fixed-answer2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"200px\" width=\"750px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"470\" y1=\"93\" x2=\"280\" y2=\"4\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"173\" y1=\"165\" x2=\"182\" y2=\"165\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"360\" y1=\"165\" x2=\"370\" y2=\"165\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 144px;\" translate>diagram1-3a2.fixed-answer3</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 144px;\" translate>diagram1-3a2.fixed-answer4</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 144px;\" translate>diagram1-3a2.fixed-answer5</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram1-3a2.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _diagram_logic = __webpack_require__(1110);
	
	var _diagram_logic2 = _interopRequireDefault(_diagram_logic);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$filter", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $filter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a2-1';
	    _this.submitBtn = 'diagram3a2-1-submit';
	    _this.nextBtn = 'diagram3a2-1-next';
	    _this.diagramNumber = 1;
	    _this.deductive = true;
	    _this.diagramIDPrefiled = 'diagram1-3a2';
	    _this.defaultPrefiled = $filter('translate')(_this.diagramIDPrefiled + '.pre-fill') + ' ';
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: _this.defaultPrefiled
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = submitAction;
	function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
	  var textarea = document.querySelectorAll('#' + diagram_id + ' .answer-field')[0];
	  var answer = document.querySelectorAll('#' + diagram_id + ' .hint')[0];
	  var next_button = document.getElementById(next_btn);
	
	  if (textarea.value) {
	    textarea.disabled = true;
	    answer.style = 'opacity: 1;';
	    submit_btn.style = 'display: none;';
	    next_button.style = 'display: inline-block; opacity: 1;';
	  } else textarea.focus();
	}
	
	function submit(diagram_id, submit_btn, next_btn) {
	  var action_button = document.getElementById(submit_btn);
	
	  action_button.addEventListener('click', function (el) {
	    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
	  });
	}
	
	function submitAction(diagram_id, submit_btn, next_btn) {
	  submit(diagram_id, submit_btn, next_btn);
	}

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1112);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a2-1 #slots .fixed-answer,#diagram3a2-1 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-1 #slots .fixed-answer:focus,#diagram3a2-1 #slots .fixed-answer:hover,#diagram3a2-1 .element:focus,#diagram3a2-1 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-1 #slots .answer-field,#diagram3a2-1 #slots div[id]{height:90px}#diagram3a2-1 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-1 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-1 #slots .hint{position:absolute;top:-15px;right:90px;border:2px solid #a7dec3;background:#a7dec3;transition:all .4s;opacity:1;z-index:3;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1114);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1115);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a2-2\" class='unit-diagram'>\n    <p class=\"diagram-task\" translate>diagram2-3a2.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                    <textarea ng-disabled=\"vm.isStatic\"class=\"answer-field\" placeholder=\"...type here\" ng-model=\"vm.model.boxOne\"></textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram2-3a2.fixed-answer1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <line x1=\"280\" y1=\"93\" x2=\"280\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\"> </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                  <div ng-if=\"!vm.edit\" class=\"answer-field\" ng-click=\"vm.onFocusPreFill()\" ng-bind-html=\"('diagram2-3a2.pre-fill' | translate) + ' <span>...type here</span>'\"></div>\n                  <textarea ng-disabled=\"vm.isStatic\"ng-if=\"vm.edit\" class=\"answer-field pre-filed\" ng-blur=\"vm.onBlurPreFill($event)\" ng-model=\"vm.model.boxTwo\" translate>diagram2-3a2.pre-fill</textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram2-3a2.fixed-answer2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"470\" y1=\"93\" x2=\"280\" y2=\"4\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"173\" y1=\"136\" x2=\"182\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"360\" y1=\"136\" x2=\"370\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram2-3a2.fixed-answer3</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram2-3a2.fixed-answer4</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram2-3a2.fixed-answer5</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <line x1=\"280\" y1=\"93\" x2=\"280\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\"> </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram2-3a2.fixed-answer6</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram1-3a2.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$filter", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $filter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a2-2';
	    _this.submitBtn = 'diagram3a2-2-submit';
	    _this.nextBtn = 'diagram3a2-2-next';
	    _this.diagramNumber = 2;
	    _this.deductive = true;
	    _this.diagramIDPrefiled = 'diagram2-3a2';
	    _this.defaultPrefiled = $filter('translate')(_this.diagramIDPrefiled + '.pre-fill') + ' ';
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: _this.defaultPrefiled
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1117);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a2-2 #slots .fixed-answer,#diagram3a2-2 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-2 #slots .fixed-answer:focus,#diagram3a2-2 #slots .fixed-answer:hover,#diagram3a2-2 .element:focus,#diagram3a2-2 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-2 #slots .answer-field,#diagram3a2-2 #slots div[id]{height:90px}#diagram3a2-2 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-2 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-2 #slots .hint{position:absolute;top:-15px;right:90px;border:2px solid #a7dec3;background:#a7dec3;transition:all .4s;opacity:1;z-index:3;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1119);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1120);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1121);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a2-3\" class='unit-diagram'>\n    <p class=\"diagram-task\" translate>diagram3-3a2.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                    <textarea ng-disabled=\"vm.isStatic\"class=\"answer-field\" placeholder=\"...type here\" ng-model=\"vm.model.boxOne\"></textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3-3a2.fixed-answer1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <line x1=\"280\" y1=\"93\" x2=\"280\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\" </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                  <div ng-if=\"!vm.edit\" class=\"answer-field\" ng-click=\"vm.onFocusPreFill()\" ng-bind-html=\"('diagram3-3a2.pre-fill' | translate) + ' <span>...type here</span>'\"></div>\n                  <textarea ng-disabled=\"vm.isStatic\"ng-if=\"vm.edit\" class=\"answer-field pre-filed\" ng-blur=\"vm.onBlurPreFill($event)\" ng-model=\"vm.model.boxTwo\" translate>diagram3-3a2.pre-fill</textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3-3a2.fixed-answer2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"200px\" width=\"750px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"470\" y1=\"93\" x2=\"280\" y2=\"4\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"173\" y1=\"165\" x2=\"182\" y2=\"165\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"360\" y1=\"165\" x2=\"370\" y2=\"165\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 144px;\" translate>diagram3-3a2.fixed-answer3</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 144px;\" translate>diagram3-3a2.fixed-answer4</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\"  style=\"height: 144px;\" translate>diagram3-3a2.fixed-answer5</div>\n                </td>\n            </tr>\n\n        </table>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram1-3a2.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$filter", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $filter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a2-3';
	    _this.submitBtn = 'diagram3a2-3-submit';
	    _this.nextBtn = 'diagram3a2-3-next';
	    _this.diagramNumber = 3;
	    _this.deductive = true;
	    _this.diagramIDPrefiled = 'diagram3-3a2';
	    _this.defaultPrefiled = $filter('translate')(_this.diagramIDPrefiled + '.pre-fill') + ' ';
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: _this.defaultPrefiled
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1122);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a2-3 #slots .fixed-answer,#diagram3a2-3 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-3 #slots .fixed-answer:focus,#diagram3a2-3 #slots .fixed-answer:hover,#diagram3a2-3 .element:focus,#diagram3a2-3 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-3 #slots .answer-field,#diagram3a2-3 #slots div[id]{height:90px}#diagram3a2-3 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-3 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-3 #slots .hint{position:absolute;top:-15px;right:90px;border:2px solid #a7dec3;background:#a7dec3;transition:all .4s;opacity:1;z-index:3;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1124);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1125);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1126);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a2-4\" class='unit-diagram'>\n    <p class=\"diagram-task\" translate>diagram4-3a2.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                    <textarea ng-disabled=\"vm.isStatic\"class=\"answer-field\" placeholder=\"...type here\" ng-model=\"vm.model.boxOne\"></textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram4-3a2.fixed-answer1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <line x1=\"280\" y1=\"93\" x2=\"280\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\"> </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                  <div ng-if=\"!vm.edit\" class=\"answer-field\" ng-click=\"vm.onFocusPreFill()\" ng-bind-html=\"('diagram4-3a2.pre-fill' | translate) + ' <span>...type here</span>'\"></div>\n                  <textarea ng-disabled=\"vm.isStatic\"ng-if=\"vm.edit\" class=\"answer-field pre-filed\" ng-blur=\"vm.onBlurPreFill($event)\" ng-model=\"vm.model.boxTwo\" translate>diagram4-3a2.pre-fill</textarea>\n                    <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\"  translate>diagram4-3a2.fixed-answer2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"470\" y1=\"93\" x2=\"280\" y2=\"4\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"173\" y1=\"136\" x2=\"182\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"360\" y1=\"136\" x2=\"370\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 120px;\" translate>diagram4-3a2.fixed-answer3</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 120px;\" translate>diagram4-3a2.fixed-answer4</div>\n                </td>\n                <td colspan=\"4\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 120px;\" translate>diagram4-3a2.fixed-answer5</div>\n                </td>\n            </tr>\n\n        </table>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram1-3a2.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$filter", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $filter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a2-4';
	    _this.submitBtn = 'diagram3a2-4-submit';
	    _this.nextBtn = 'diagram3a2-4-next';
	    _this.diagramNumber = 4;
	    _this.deductive = true;
	    _this.diagramIDPrefiled = 'diagram4-3a2';
	    _this.defaultPrefiled = $filter('translate')(_this.diagramIDPrefiled + '.pre-fill') + ' ';
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: _this.defaultPrefiled
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1127);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a2-4 #slots .fixed-answer,#diagram3a2-4 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-4 #slots .fixed-answer:focus,#diagram3a2-4 #slots .fixed-answer:hover,#diagram3a2-4 .element:focus,#diagram3a2-4 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-4 #slots .answer-field,#diagram3a2-4 #slots div[id]{height:90px}#diagram3a2-4 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-4 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-4 #slots .hint{position:absolute;top:-15px;right:90px;border:2px solid #a7dec3;background:#a7dec3;transition:all .4s;opacity:1;z-index:3;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1129);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1130);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a2-5\" class='unit-diagram'>\n    <p class=\"diagram-task\" translate>diagram5-3a2.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                    <textarea ng-disabled=\"vm.isStatic\"class=\"answer-field\" placeholder=\"...type here\" ng-model=\"vm.model.boxOne\"></textarea>\n                    <div class=\"fixed-answer hint\"  ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram5-3a2.fixed-answer1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <line x1=\"470\" y1=\"93\" x2=\"470\" y2=\"0\" stroke=\"#fff\" stroke-width=\"3\" </line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" style=\"position: relative;\" border=\"1\">\n                  <div ng-if=\"!vm.edit\" class=\"answer-field\" ng-click=\"vm.onFocusPreFill()\" ng-bind-html=\"('diagram5-3a2.pre-fill' | translate) + ' <span>...type here</span>'\"></div>\n                  <textarea ng-disabled=\"vm.isStatic\"ng-if=\"vm.edit\" class=\"answer-field pre-filed\" ng-blur=\"vm.onBlurPreFill($event)\" ng-model=\"vm.model.boxTwo\" translate>diagram5-3a2.pre-fill</textarea>\n                    <div class=\"fixed-answer hint\" style=\"height: 104px\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram5-3a2.fixed-answer2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"750px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"900\" y1=\"143\" x2=\"480\" y2=\"4\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"173\" y1=\"136\" x2=\"278\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"455\" y1=\"136\" x2=\"653\" y2=\"136\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"1\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 110px;\" translate>diagram5-3a2.fixed-answer3</div>\n                </td>\n                <td colspan=\"5\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 110px;\" translate>diagram5-3a2.fixed-answer4</div>\n                </td>\n                <td colspan=\"6\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" style=\"height: 110px;\" translate>diagram5-3a2.fixed-answer5</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"144px\" width=\"1000px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"476\" y1=\"93\" x2=\"370\" y2=\"-1\" stroke=\"#fff\" stroke-width=\"3\"></line>\n                        <line x1=\"270\" y1=\"93\" x2=\"370\" y2=\"-1\" stroke=\"#fff\" stroke-width=\"3\"></line>\n                        <line x1=\"650\" y1=\"93\" x2=\"750\" y2=\"-1\" stroke=\"#fff\" stroke-width=\"3\"></line>\n                        <line x1=\"850\" y1=\"93\" x2=\"750\" y2=\"-1\" stroke=\"#fff\" stroke-width=\"3\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"2\" style=\"position: relative;\" style=\"text-align: left;\"></td>\n                <td colspan=\"2\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram5-3a2.fixed-answer6</div>\n                </td>\n                <td colspan=\"2\" style=\"position: relative;\" style=\"text-align: left;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram5-3a2.fixed-answer7</div>\n                </td>\n                <td colspan=\"2\" style=\"position: relative;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram5-3a2.fixed-answer8</div>\n                </td>\n                <td colspan=\"2\" style=\"position: relative;\" style=\"text-align: right;\">\n                    <div class=\"fixed-answer fixed-answer-bg\" translate>diagram5-3a2.fixed-answer9</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram1-3a2.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram1-3a2.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$filter", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $filter, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a2-5';
	    _this.submitBtn = 'diagram3a2-5-submit';
	    _this.nextBtn = 'diagram3a2-5-next';
	    _this.diagramNumber = 5;
	    _this.deductive = true;
	    _this.diagramIDPrefiled = 'diagram5-3a2';
	    _this.defaultPrefiled = $filter('translate')(_this.diagramIDPrefiled + '.pre-fill') + ' ';
	    _this.amountCorrectAnswers = 2;
	    _this.model = {
	      boxOne: '',
	      boxTwo: _this.defaultPrefiled
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a2-5 #slots .fixed-answer,#diagram3a2-5 .element{border:2px solid #fff;background:transparent;height:90px}#diagram3a2-5 #slots .fixed-answer:focus,#diagram3a2-5 #slots .fixed-answer:hover,#diagram3a2-5 .element:focus,#diagram3a2-5 .element:hover{z-index:100;background:#a7dec3}#diagram3a2-5 #slots .answer-field,#diagram3a2-5 #slots div[id]{height:90px}#diagram3a2-5 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:5px 10px 3px;color:#fff;cursor:pointer;outline:none;text-decoration:none}#diagram3a2-5 .diagram-task{float:left;width:100%;text-align:left;text-shadow:none;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-size:20px;padding-bottom:70px;padding-left:5px}#diagram3a2-5 #slots .hint{position:absolute;top:-15px;right:280px;border:2px solid #a7dec3;background:#a7dec3;opacity:1;z-index:3;font-size:12px}", ""]);
	
	// exports


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1134);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1135);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1136);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-1\" class=\"unit-diagram unit3a3\">\n\n  <div class=\"diagram-task\" translate>diagram3a3-1.diagram-task</div>\n  <div class=\"unit-diagram-descriptionbox\">\n    <div class=\"list-element\" id=\"element_1_1\">\n      <div class=\"list-element__number\">1.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-1.diagram-description.1</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_2\">\n      <div class=\"list-element__number\">2.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-1.diagram-description.2</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_3\">\n      <div class=\"list-element__number\">3.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-1.diagram-description.3</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_4\">\n      <div class=\"list-element__number\">4.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-1.diagram-description.4</div>\n    </div>\n  </div>\n\n  <div class=\"unit-diagram-box\">\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-1.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator separator_hidden'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div id=\"slot_1_1\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-1.elements.two</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_2\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-1.elements.three</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_3\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-1.elements.four</div>\n            <div class=\"long-arr\">\n              <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n              <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-1';
	    _this.submitBtn = 'diagram3a3-1-submit';
	    _this.nextBtn = 'diagram3a3-1-next';
	    _this.diagramNumber = 1;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1137);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1139);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1140);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1141);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-2\" class=\"unit-diagram\">\n\n  <div class=\"diagram-task\" translate>diagram3a3-2.diagram-task</div>\n  <div class=\"unit-diagram-descriptionbox\">\n    <div class=\"list-element\" id=\"element_1_1\">\n      <div class=\"list-element__number\">1.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-2.diagram-description.1</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_2\">\n      <div class=\"list-element__number\">2.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-2.diagram-description.2</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_3\">\n      <div class=\"list-element__number\">3.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-2.diagram-description.3</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_4\">\n      <div class=\"list-element__number\">4.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-2.diagram-description.4</div>\n    </div>\n  </div>\n\n  <div class=\"unit-diagram-box\">\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-2.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator separator_hidden'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div id=\"slot_1_1\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-2.elements.two</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_2\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-2.elements.three</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_3\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-2.elements.four</div>\n            <div class=\"long-arr\">\n              <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n              <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-2';
	    _this.submitBtn = 'diagram3a3-2-submit';
	    _this.nextBtn = 'diagram3a3-2-next';
	    _this.diagramNumber = 2;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1142);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1144);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1145);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1146);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-3\" class=\"unit-diagram\">\n  <div class=\"diagram-task\" translate>diagram3a3-3.diagram-task</div>\n  <div class=\"unit-diagram-descriptionbox\">\n    <div class=\"list-element\" id=\"element_1_1\">\n      <div class=\"list-element__number\">1.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-3.diagram-description.1</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_2\">\n      <div class=\"list-element__number\">2.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-3.diagram-description.2</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_3\">\n      <div class=\"list-element__number\">3.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-3.diagram-description.3</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_4\">\n      <div class=\"list-element__number\">4.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-3.diagram-description.4</div>\n    </div>\n    <!--<div class=\"list-element\" id=\"element_1_1\" translate>diagram3a3-3.diagram-description.1</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_2\" translate>diagram3a3-3.diagram-description.2</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_3\" translate>diagram3a3-3.diagram-description.3</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_4\" translate>diagram3a3-3.diagram-description.4</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_5\" translate>diagram3a3-3.diagram-description.5</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_6\" translate>diagram3a3-3.diagram-description.6</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_7\" translate>diagram3a3-3.diagram-description.7</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_8\" translate>diagram3a3-3.diagram-description.8</div>-->\n    <!--<div class=\"list-element\" id=\"element_1_9\" translate>diagram3a3-3.diagram-description.9</div>-->\n  </div>\n\n  <div class=\"unit-diagram-box\">\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-3.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator separator_hidden'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div id=\"slot_1_1\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-3.elements.two</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_2\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-3.elements.three</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_3\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-3.elements.four</div>\n            <div class=\"long-arr\">\n              <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n              <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-3';
	    _this.submitBtn = 'diagram3a3-3-submit';
	    _this.nextBtn = 'diagram3a3-3-next';
	    _this.diagramNumber = 3;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1147);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1149);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1150);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-4\" class=\"unit-diagram\">\n    <div class=\"diagram-task\" translate>diagram3a3-4.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3a3-4.diagram-description.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3a3-4.diagram-description.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3a3-4.diagram-description.3</div>\n      </div>\n    </div>\n\n    <div class=\"unit-diagram-box\">\n\n        <div id=\"slots\">\n            <table class=\"slots\">\n                <tr>\n                    <td colspan=\"4\">\n                        <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-4.elements.one</div>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan='4' class='separator separator_hidden'>\n                        <svg height='94px' width='556px'>\n                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        </svg>\n                    </td>\n                </tr>\n                <tr>\n                    <td>\n                      <div id=\"slot_1_1\"></div>\n                      <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-4.elements.two</div>\n                        <div class=\"element-arr\">\n                            <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                        </div>\n                    </td>\n                    <td>\n                        <div id=\"slot_1_2\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-4.elements.three</div>\n                        <div class=\"element-arr\">\n                            <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                        </div>\n                    </td>\n                    <td>\n                        <div id=\"slot_1_3\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-4.elements.four</div>\n                        <div class=\"element-arr\">\n                            <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                        </div>\n                    </td>\n                    <td>\n                        <div id=\"slot_1_4\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-4.elements.five</div>\n                        <div class=\"long-arr\">\n                            <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n                            <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n                        </div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-4';
	    _this.submitBtn = 'diagram3a3-4-submit';
	    _this.nextBtn = 'diagram3a3-4-next';
	    _this.diagramNumber = 4;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1152);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a3-4 .long-arr-part1_short{width:295px;transform:rotate(17deg);left:-18px}#diagram3a3-4 .long-arr-part2_short{left:-25px;top:-6.8px;transform:rotate(25deg)}", ""]);
	
	// exports


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1154);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1155);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1156);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-5\" class=\"unit-diagram\">\n\n  <div class=\"diagram-task\" translate>diagram3a3-5.diagram-task</div>\n  <div class=\"unit-diagram-descriptionbox\">\n    <div class=\"list-element\" id=\"element_1_1\">\n      <div class=\"list-element__number\">1.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-5.diagram-description.1</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_2\">\n      <div class=\"list-element__number\">2.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-5.diagram-description.2</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_3\">\n      <div class=\"list-element__number\">3.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-5.diagram-description.3</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_4\">\n      <div class=\"list-element__number\">4.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-5.diagram-description.4</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_5\">\n      <div class=\"list-element__number\">5.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-5.diagram-description.5</div>\n    </div>\n  </div>\n\n  <div class=\"unit-diagram-box\">\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-5.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator separator_hidden'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div id=\"slot_1_1\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-5.elements.two</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_2\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-5.elements.three</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_3\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>\n              diagram3a3-5.elements.four\n            </div>\n            <div class=\"long-arr\">\n              <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n              <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\"\n            ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\"\n            ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\"\n            ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-5';
	    _this.submitBtn = 'diagram3a3-5-submit';
	    _this.nextBtn = 'diagram3a3-5-next';
	    _this.diagramNumber = 5;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1157);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1159);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1160);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1161);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3a3-6\" class=\"unit-diagram\">\n\n  <div class=\"diagram-task\" translate>diagram3a3-6.diagram-task</div>\n  <div class=\"unit-diagram-descriptionbox\">\n    <div class=\"list-element\" id=\"element_1_1\">\n      <div class=\"list-element__number\">1.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.1</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_2\">\n      <div class=\"list-element__number\">2.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.2</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_3\">\n      <div class=\"list-element__number\">3.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.3</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_4\">\n      <div class=\"list-element__number\">4.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.4</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_5\">\n      <div class=\"list-element__number\">5.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.5</div>\n    </div>\n    <div class=\"list-element\" id=\"element_1_6\">\n      <div class=\"list-element__number\">6.</div>\n      <div class=\"list-element__description\" translate>diagram3a3-6.diagram-description.6</div>\n    </div>\n  </div>\n\n  <div class=\"unit-diagram-box\">\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\">\n            <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-6.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator separator_hidden'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div id=\"slot_1_1\" class=\"fixed-answer fixed-answer_blue\" translate>diagram3a3-6.elements.two</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_2\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-6.elements.three</div>\n            <div class=\"element-arr\">\n              <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n            </div>\n          </td>\n          <td>\n            <div id=\"slot_1_3\"></div>\n            <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3a3-6.elements.four</div>\n            <div class=\"long-arr\">\n              <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n              <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3a3-6';
	    _this.submitBtn = 'diagram3a3-6-submit';
	    _this.nextBtn = 'diagram3a3-6-next';
	    _this.diagramNumber = 6;
	    _this.deductive = true;
	    _this.deductiveSpecialModel = true;
	    _this.amountCorrectAnswers = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1162);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3a3-6 #slots div[id]{height:174px}#diagram3a3-6 .element-list_drop,#diagram3a3-6 .fixed-answer{height:174px!important}", ""]);
	
	// exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1164);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1165);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-1\" class=\"unit-diagram\">\n\t<div class=\"checkboxes-task\">\n\t\t<div class=\"question-title\" translate>diagram3b1-1.checkboxes.title</div>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio\" id=\"rule-3b1-1-1\" />\n\t\t\t<label for=\"rule-3b1-1-1\"></label>\n\t\t</div>\n\t\t<label for=\"rule-3b1-1-1\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes.checkbox-1</label>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio\" id=\"rule-3b1-1-2\" data-correct checked/>\n\t\t\t<label for=\"rule-3b1-1-2\"></label>\n\t\t</div>\n\t\t<label for=\"rule-3b1-1-2\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes.checkbox-2</label>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio\" id=\"rule-3b1-1-3\" data-correct/>\n\t\t\t<label for=\"rule-3b1-1-3\"></label>\n\t\t</div>\n\t\t<label for=\"rule-3b1-1-3\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes.checkbox-3</label>\n\t</div>\n\n\t<div id=\"slots\">\n\t\t<table class=\"slots\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"4\" style=\"position: relative;\">\n\t\t\t\t\t<div class=\"fixed-answer\" translate>diagram3b1-1.elements.one</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td colspan='4' class='separator'>\n\t\t\t\t\t<svg height='94px' width='750px'>\n\t\t\t\t\t\t<path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>diagram3b1-1.elements.two</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>diagram3b1-1.elements.three</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>diagram3b1-1.elements.four</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"fixed-answer\" translate>diagram3b1-1.elements.five</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n\n\t<div class=\"checkboxes-task checkboxes-task-2\">\n\n\t\t<div class=\"question-title\" translate>diagram3b1-1.checkboxes-bottom.title</div>\n\n\n\t\t<div class=\"checkboxes-task-item\">\n\t\t\t<div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio2\" id=\"rule-3b1-1-4\" />\n\t\t\t\t<label for=\"rule-3b1-1-4\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-1-4\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes-bottom.checkbox-1</label>\n\t\t</div>\n\n\t\t<div class=\"checkboxes-task-item\">\n\t\t\t<div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio2\" id=\"rule-3b1-1-5\" data-correct checked/>\n\t\t\t\t<label for=\"rule-3b1-1-5\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-1-5\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes-bottom.checkbox-2</label>\n\t\t</div>\n\n\t\t<div class=\"checkboxes-task-item\">\n\t\t\t<div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" ng-disabled=\"true\" name=\"radio2\" id=\"rule-3b1-1-6\" data-correct/>\n\t\t\t\t<label for=\"rule-3b1-1-6\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-1-6\" class=\"checkbox-description\" translate>diagram3b1-1.checkboxes-bottom.checkbox-3</label>\n\t\t</div>\n\n\t</div>\n</div>\n"

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-1';
	    _this.submitBtn = 'diagram3b1-1-submit';
	    _this.nextBtn = 'diagram3b1-1-next';
	    _this.diagramNumber = 1;
	    _this.correctAnswer = [2, 2];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1167);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1169);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1170);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1171);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-2\" class=\"unit-diagram\">\n\n  <form class=\"\" name=\"vm.diagramForm\">\n\n    <div id=\"checkboxes-task-2\" class=\"checkboxes-task\">\n      <div class=\"question-title\" translate>diagram3b1-2.checkboxes.title</div>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-2-1\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-2-1\"></label>\n      </div>\n      <label for=\"rule-3b1-2-1\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes.checkbox-1</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-2-2\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-2-2\"></label>\n      </div>\n      <label for=\"rule-3b1-2-2\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes.checkbox-2</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-2-3\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-2-3\"></label>\n      </div>\n      <label for=\"rule-3b1-2-3\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes.checkbox-3</label>\n    </div>\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"3\">\n            <div class=\"fixed-answer\" translate>diagram3b1-2.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan=\"3\" class=\"separator\">\n            <svg height=\"94px\" width=\"556px\">\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-2.elements.two</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-2.elements.three</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-2.elements.four</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <div class=\"checkboxes-task checkboxes-task-2\">\n      <div class=\"question-title\" translate>diagram3b1-2.checkboxes-bottom.title</div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-2-4\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-2-4\"></label>\n        </div>\n        <label for=\"rule-3b1-2-4\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes-bottom.checkbox-1</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-2-5\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-2-5\"></label>\n        </div>\n        <label for=\"rule-3b1-2-5\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes-bottom.checkbox-2</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-2-6\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-2-6\"></label>\n        </div>\n        <label for=\"rule-3b1-2-6\" class=\"checkbox-description\" translate>diagram3b1-2.checkboxes-bottom.checkbox-3</label>\n      </div>\n    </div>\n\n  </form>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-2';
	    _this.submitBtn = 'diagram3b1-2-submit';
	    _this.nextBtn = 'diagram3b1-2-next';
	    _this.diagramNumber = 2;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [2, 2];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1172);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1174);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1175);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1176);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-3\" class=\"unit-diagram\">\n\n  <form class=\"\" name=\"vm.diagramForm\">\n\n    <div id=\"checkboxes-task-3\" class=\"checkboxes-task\">\n      <div class=\"question-title\" translate>diagram3b1-3.checkboxes.title</div>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-3-1\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-3-1\"></label>\n      </div>\n      <label for=\"rule-3b1-3-1\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes.checkbox-1</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-3-2\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-3-2\"></label>\n      </div>\n      <label for=\"rule-3b1-3-2\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes.checkbox-2</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-3-3\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-3-3\"></label>\n      </div>\n      <label for=\"rule-3b1-3-3\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes.checkbox-3</label>\n    </div>\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"3\">\n            <div class=\"fixed-answer\" translate>diagram3b1-3.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan=\"3\" class=\"separator\">\n            <svg height=\"94px\" width=\"556px\">\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-3.elements.two</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-3.elements.three</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-3.elements.four</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <div class=\"checkboxes-task checkboxes-task-2\">\n      <div class=\"question-title\" translate>diagram3b1-3.checkboxes-bottom.title</div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-3-4\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-3-4\"></label>\n        </div>\n        <label for=\"rule-3b1-3-4\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes-bottom.checkbox-1</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-3-5\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-3-5\"></label>\n        </div>\n        <label for=\"rule-3b1-3-5\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes-bottom.checkbox-2</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-3-6\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-3-6\"></label>\n        </div>\n        <label for=\"rule-3b1-3-6\" class=\"checkbox-description\" translate>diagram3b1-3.checkboxes-bottom.checkbox-3</label>\n      </div>\n    </div>\n\n  </form>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-3';
	    _this.submitBtn = 'diagram3b1-3-submit';
	    _this.nextBtn = 'diagram3b1-3-next';
	    _this.diagramNumber = 3;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [2, 2];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1177);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1179);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1180);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-4\" class=\"unit-diagram\">\n\n\t\t<form class=\"\" name=\"vm.diagramForm\">\n\n\t\t  <div id=\"checkboxes-task-4\" class=\"checkboxes-task\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-4.checkboxes.title</div>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-4-1\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-4-1\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-4-1\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes.checkbox-1</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-4-2\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-4-2\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-4-2\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes.checkbox-2</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-4-3\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-4-3\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-4-3\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes.checkbox-3</label>\n\t\t  </div>\n\n\t\t  <div id=\"slots\">\n\t\t\t<table class=\"slots\">\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\">\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-4.elements.one</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\" class=\"separator\">\n\t\t\t\t  <svg height=\"94px\" width=\"556px\">\n\t\t\t\t\t<path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t  </svg>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-4.elements.two</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-4.elements.three</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-4.elements.four</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t</table>\n\t\t  </div>\n\n\t\t  <div class=\"checkboxes-task checkboxes-task-2\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-4.checkboxes-bottom.title</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-4-4\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-4-4\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-4-4\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes-bottom.checkbox-1</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-4-5\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-4-5\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-4-5\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes-bottom.checkbox-2</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-4-6\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-4-6\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-4-6\" class=\"checkbox-description\" translate>diagram3b1-4.checkboxes-bottom.checkbox-3</label>\n\t\t\t</div>\n\t\t  </div>\n\n\t\t</form>\n\n\t\t<div class=\"submit\">\n\t\t  <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n\t\t  <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n\t\t</div>\n\n\t  </div>\n"

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-4';
	    _this.submitBtn = 'diagram3b1-4-submit';
	    _this.nextBtn = 'diagram3b1-4-next';
	    _this.diagramNumber = 4;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [1, 1];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1182);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b1-4.unit-diagram .checkboxes-task .checkbox-description{max-width:260px}", ""]);
	
	// exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1184);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1185);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-5\" class=\"unit-diagram\">\n\n\t\t<form class=\"\" name=\"vm.diagramForm\">\n\n\t\t  <div id=\"checkboxes-task-5\" class=\"checkboxes-task\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-5.checkboxes.title</div>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-5-1\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-5-1\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-5-1\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes.checkbox-1</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-5-2\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-5-2\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-5-2\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes.checkbox-2</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-5-3\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-5-3\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-5-3\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes.checkbox-3</label>\n\t\t  </div>\n\n\t\t  <div id=\"slots\">\n\t\t\t<table class=\"slots\">\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\">\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-5.elements.one</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\" class=\"separator\">\n\t\t\t\t  <svg height=\"94px\" width=\"556px\">\n\t\t\t\t\t<path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t  </svg>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-5.elements.two</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-5.elements.three</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-5.elements.four</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t</table>\n\t\t  </div>\n\n\t\t  <div class=\"checkboxes-task checkboxes-task-2\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-5.checkboxes-bottom.title</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-5-4\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-5-4\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-5-4\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes-bottom.checkbox-1</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-5-5\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-5-5\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-5-5\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes-bottom.checkbox-2</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-5-6\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-5-6\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-5-6\" class=\"checkbox-description\" translate>diagram3b1-5.checkboxes-bottom.checkbox-3</label>\n\t\t\t</div>\n\t\t  </div>\n\n\t\t</form>\n\n\t\t<div class=\"submit\">\n\t\t  <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n\t\t  <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n\t\t</div>\n\n\t  </div>\n"

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-5';
	    _this.submitBtn = 'diagram3b1-5-submit';
	    _this.nextBtn = 'diagram3b1-5-next';
	    _this.diagramNumber = 5;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [1, 1];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1187);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1189);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1190);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-6\" class=\"unit-diagram\">\n\n\t\t<form class=\"\" name=\"vm.diagramForm\">\n\n\t\t  <div id=\"checkboxes-task-6\" class=\"checkboxes-task\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-6.checkboxes.title</div>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-6-1\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-6-1\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-6-1\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes.checkbox-1</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-6-2\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-6-2\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-6-2\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes.checkbox-2</label>\n\n\t\t\t<div class=\"checkbox\">\n\t\t\t  <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-6-3\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t  <label for=\"rule-3b1-6-3\"></label>\n\t\t\t</div>\n\t\t\t<label for=\"rule-3b1-6-3\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes.checkbox-3</label>\n\t\t  </div>\n\n\t\t  <div id=\"slots\">\n\t\t\t<table class=\"slots\">\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\">\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-6.elements.one</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td colspan=\"3\" class=\"separator\">\n\t\t\t\t  <svg height=\"94px\" width=\"556px\">\n\t\t\t\t\t<path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t\t<path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n\t\t\t\t  </svg>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t  <tr>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-6.elements.two</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-6.elements.three</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t  <div class=\"fixed-answer\" translate>diagram3b1-6.elements.four</div>\n\t\t\t\t</td>\n\t\t\t  </tr>\n\t\t\t</table>\n\t\t  </div>\n\n\t\t  <div class=\"checkboxes-task checkboxes-task-2\">\n\t\t\t<div class=\"question-title\" translate>diagram3b1-6.checkboxes-bottom.title</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-6-4\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-6-4\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-6-4\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes-bottom.checkbox-1</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-6-5\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-6-5\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-6-5\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes-bottom.checkbox-2</label>\n\t\t\t</div>\n\n\t\t\t<div class=\"checkboxes-task-item\">\n\t\t\t  <div class=\"checkbox\">\n\t\t\t\t<input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-6-6\" ng-disabled=\"vm.diagramComplete\" />\n\t\t\t\t<label for=\"rule-3b1-6-6\"></label>\n\t\t\t  </div>\n\t\t\t  <label for=\"rule-3b1-6-6\" class=\"checkbox-description\" translate>diagram3b1-6.checkboxes-bottom.checkbox-3</label>\n\t\t\t</div>\n\t\t  </div>\n\n\t\t</form>\n\n\t\t<div class=\"submit\">\n\t\t  <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n\t\t  <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n\t\t  <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n\t\t</div>\n\n\t  </div>\n"

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_CourseController) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram6Controller, _CourseController);
	
	  function Diagram6Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-6';
	    _this.submitBtn = 'diagram3b1-6-submit';
	    _this.nextBtn = 'diagram3b1-6-next';
	    _this.diagramNumber = 6;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [1, 1];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram6Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram6Controller;
	}(_course2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1194);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1195);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1196);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram7Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram7Component;

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b1-7\" class=\"unit-diagram\">\n\n  <form class=\"\" name=\"vm.diagramForm\">\n\n    <div id=\"checkboxes-task-7\" class=\"checkboxes-task\">\n      <div class=\"question-title\" translate>diagram3b1-7.checkboxes.title</div>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"1\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-7-1\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-7-1\"></label>\n      </div>\n      <label for=\"rule-3b1-7-1\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes.checkbox-1</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"2\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-7-2\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-7-2\"></label>\n      </div>\n      <label for=\"rule-3b1-7-2\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes.checkbox-2</label>\n\n      <div class=\"checkbox\">\n        <input type=\"radio\" name=\"radio\" ng-value=\"3\" ng-model=\"vm.userAnswers[0]\" id=\"rule-3b1-7-3\" ng-disabled=\"vm.diagramComplete\" />\n        <label for=\"rule-3b1-7-3\"></label>\n      </div>\n      <label for=\"rule-3b1-7-3\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes.checkbox-3</label>\n    </div>\n\n    <div id=\"slots\">\n      <table class=\"slots\">\n        <tr>\n          <td colspan=\"4\" style=\"position: relative;\">\n            <div class=\"fixed-answer\" translate>diagram3b1-7.elements.one</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='4' class='separator'>\n            <svg height='94px' width='750px'>\n              <path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n              <path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n              <path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n              <path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-7.elements.two</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-7.elements.three</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-7.elements.four</div>\n          </td>\n          <td>\n            <div class=\"fixed-answer\" translate>diagram3b1-7.elements.five</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <div class=\"checkboxes-task checkboxes-task-2\">\n      <div class=\"question-title\" translate>diagram3b1-7.checkboxes-bottom.title</div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"1\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-7-4\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-7-4\"></label>\n        </div>\n        <label for=\"rule-3b1-7-4\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes-bottom.checkbox-1</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"2\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-7-5\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-7-5\"></label>\n        </div>\n        <label for=\"rule-3b1-7-5\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes-bottom.checkbox-2</label>\n      </div>\n\n      <div class=\"checkboxes-task-item\">\n        <div class=\"checkbox\">\n          <input type=\"radio\" name=\"radio2\" ng-value=\"3\" ng-model=\"vm.userAnswers[1]\" id=\"rule-3b1-7-6\" ng-disabled=\"vm.diagramComplete\" />\n          <label for=\"rule-3b1-7-6\"></label>\n        </div>\n        <label for=\"rule-3b1-7-6\" class=\"checkbox-description\" translate>diagram3b1-7.checkboxes-bottom.checkbox-3</label>\n      </div>\n    </div>\n\n  </form>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'1c-diagram1.hint-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.complete-title' | translate\"></button>\n\n    <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1c-diagram1.resubmit-title' | translate\"></button>\n\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram7Controller = function (_CourseController) {
	  Diagram7Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram7Controller, _CourseController);
	
	  function Diagram7Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram7Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram7Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram7Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b1-7';
	    _this.submitBtn = 'diagram3b1-7-submit';
	    _this.nextBtn = 'diagram3b1-7-next';
	    _this.diagramNumber = 7;
	    _this.radioButtonGroups = true;
	    _this.correctAnswers = [3, 3];
	    _this.userAnswers = [,];
	    _this.amountCorrectAnswers = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram7Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram7Controller;
	}(_course2.default);
	
	exports.default = Diagram7Controller;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1199);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1200);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1201);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b2-1\" class='unit-diagram'>\n\n    <div class=\"diagram-task\" translate style=\"float: none\">diagram3a3-1.diagram-task</div>\n    <div class=\"diagram3b2-1\">\n      <div class=\"unit-diagram-descriptionbox diagram3b2-1__description-box\">\n        <div class=\"list-element\" id=\"element_1_1\">\n          <div class=\"list-element__number\">1.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-1.diagram-description-1</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_2\">\n          <div class=\"list-element__number\">2.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-1.diagram-description-2</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_3\">\n          <div class=\"list-element__number\">3.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-1.diagram-description-3</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_4\">\n          <div class=\"list-element__number\">4.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-1.diagram-description-4</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_5\">\n          <div class=\"list-element__number\">5.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-1.diagram-description-5</div>\n        </div>\n      </div>\n\n      <div id=\"slots\">\n        <p class=\"diagram-task diagram-task_diagramm3b2 diagram-task_diagramm3b2_4 exercise-1\" style=\"left: -10px; top: 42px;\" translate>diagram3b2-1.diagram-task</p>\n        <p class=\"diagram-hint diagram-hint_diagramm3b2 diagram-task_diagramm3b2_4 exercise-1\" style=\"left: -40px\" translate>diagram3b2-1.diagram-hint</p>\n        <table class=\"slots\">\n          <tr>\n            <td colspan='3'>\n              <div class=\"fixed-answer fixed-answer_blue\" translate style=\"margin-bottom: 87px\">diagram3b2-1.fixed-answer</div>\n            </td>\n          </tr>\n          <tr>\n            <td colspan='3' class='separator diagram3b2-1__separator'>\n              <svg style=\"top: 6px;\" height='94px' width='556px'>\n                <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              </svg>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"exercise-1\">\n              <div id=\"slot_1_1\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_1\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-1.diagram-description-1</div>\n            </td>\n            <td class=\"exercise-1\">\n              <div id=\"slot_1_2\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_2\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-1.diagram-description-2</div>\n            </td>\n            <td class=\"exercise-1\">\n              <div id=\"slot_1_3\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_5\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-1.diagram-description-5</div>\n            </td>\n          </tr>\n          <tr>\n            <td colspan='3' class='separator'>\n              <svg height='94px' width='556px'>\n                <line x1=\"290\" y1=\"0\" x2=\"90\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n                <line x1=\"290\" y1=\"0\" x2=\"510\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              </svg>\n            </td>\n          </tr>\n          <tr>\n            <td colspan=\"2\" class=\"exercise-1\">\n              <div id=\"slot_1_4\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_4\" style=\"right: 86px;\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-1.diagram-description-4</div>\n            </td>\n            <td class=\"exercise-1\" style=\"position: relative; right: 95px;\">\n              <div id=\"slot_1_5\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_3\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-1.diagram-description-3</div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b2-1';
	    _this.submitBtn = 'diagram3b2-1-submit';
	    _this.nextBtn = 'diagram3b2-1-next';
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.greyAnswers = true;
	    _this.diagramNumber = 1;
	    _this.amountCorrectAnswers = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: 'submit',
	    value: function submit() {
	      (0, _get3.default)(Diagram1Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller.prototype), 'submit', this).call(this);
	    }
	  }, {
	    key: 'hideAnswer',
	    value: function hideAnswer() {
	      (0, _get3.default)(Diagram1Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller.prototype), 'hideAnswer', this).call(this);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1202);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#slots .fixed-answer.fixed-answer_blue,#slots div[id].element.element_section3b2{border:2px solid #fff;background:#a7dec3;overflow:auto;min-height:84px}.unit3b-2 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:6px 10px 2px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit3b-2 #slots .hint{position:absolute;top:55px;right:-10px;transition:all .4s;opacity:1;z-index:3}.unit3b-2 .unit-diagram{padding-top:40px}", ""]);
	
	// exports


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1204);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1205);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1206);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b2-2\" class='unit-diagram'>\n\n  <div class=\"diagram-task\" translate style=\"float: none\">diagram3a3-1.diagram-task</div>\n  <div class=\"diagram3b2-2\">\n    <div class=\"unit-diagram-descriptionbox diagram3b2-2__description-box\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-2.diagram-description-6</div>\n      </div>\n    </div>\n\n    <div id=\"slots\">\n      <p class=\"diagram-task diagram-task_diagramm3b2 diagram-task_diagramm3b2_4 exercise-1\" style=\"left: -10px\"\n         translate>diagram3b2-2.diagram-task</p>\n      <p class=\"diagram-hint diagram-hint_diagramm3b2 diagram-task_diagramm3b2_4 exercise-1\" style=\"left: -40px\"\n         translate>diagram3b2-2.diagram-hint</p>\n      <table class=\"slots\">\n        <tr>\n          <td colspan='3'>\n            <div class=\"fixed-answer fixed-answer_blue\" translate style=\"margin-bottom: 87px\">\n              diagram3b2-2.fixed-answer\n            </div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator diagram3b2-2__separator'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td class=\"exercise-1\">\n            <div id=\"slot_1_1\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_1\"\n                 ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-2.diagram-description-1\n            </div>\n          </td>\n          <td class=\"exercise-1\">\n            <div id=\"slot_1_2\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_2\"\n                 ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-2.diagram-description-2\n            </div>\n          </td>\n          <td class=\"exercise-1\">\n            <div id=\"slot_1_3\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_4\"\n                 ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-2.diagram-description-4\n            </div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator'>\n            <svg height='94px' width='556px'>\n              <line x1=\"490\" y1=\"0\" x2=\"90\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              <line x1=\"490\" y1=\"0\" x2=\"490\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td style=\"left: 200px\" class=\"exercise-1\">\n            <div id=\"slot_1_4\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_5\"\n                 ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-2.diagram-description-5\n            </div>\n          </td>\n          <td style=\"left: 200px\" class=\"exercise-1\">\n            <div id=\"slot_1_5\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_6\"\n                 ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-2.diagram-description-6\n            </div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n    <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\"\n            ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n    <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\"\n            ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n    <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\"\n            ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b2-2';
	    _this.submitBtn = 'diagram3b2-2-submit';
	    _this.nextBtn = 'diagram3b2-2-next';
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.greyAnswers = true;
	    _this.diagramNumber = 2;
	    _this.amountCorrectAnswers = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: 'submit',
	    value: function submit() {
	      (0, _get3.default)(Diagram2Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller.prototype), 'submit', this).call(this);
	    }
	  }, {
	    key: 'hideAnswer',
	    value: function hideAnswer() {
	      (0, _get3.default)(Diagram2Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller.prototype), 'hideAnswer', this).call(this);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1207);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".second-line{top:280px!important;left:-10px!important}", ""]);
	
	// exports


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1209);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1210);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1211);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b2-3\" class='unit-diagram'>\n\n    <div class=\"diagram-task\" translate style=\"float: none\">diagram3a3-1.diagram-task</div>\n    <div class=\"diagram3b2-3 diagram-wrapper\">\n      <div class=\"unit-diagram-descriptionbox diagram3b2-4__description-box diagram-wrapper__description-box\">\n        <div class=\"list-element\" id=\"element_1_1\">\n          <div class=\"list-element__number\">1.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_1</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_2\">\n          <div class=\"list-element__number\">2.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_2</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_3\">\n          <div class=\"list-element__number\">3.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_3</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_4\">\n          <div class=\"list-element__number\">4.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_4</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_5\">\n          <div class=\"list-element__number\">5.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_5</div>\n        </div>\n        <div class=\"list-element\" id=\"element_1_6\">\n          <div class=\"list-element__number\">6.</div>\n          <div class=\"list-element__description\" translate>diagram3b2-3.element_3_6</div>\n        </div>\n      </div>\n      <div id=\"slots\">\n        <p class=\"diagram-task diagram-task_diagramm3b2 diagram-task_diagramm3b2_3\" translate>diagram3b2-3.diagram-task</p>\n        <p class=\"diagram-hint diagram-hint_diagramm3b2 diagram-hint_diagramm3b2_3\" translate>diagram3b2-3.diagram-hint</p>\n        <table class=\"slots\">\n          <tr>\n            <td colspan='4'>\n              <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3b2-3.fixed-answer</div>\n            </td>\n          </tr>\n          <tr>\n            <td colspan='4' class='separator'>\n              <svg height='94px' width='750px' style=\"z-index: 0; left: 15px\">\n                <path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                <path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                <path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                <path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n              </svg>\n            </td>\n          </tr>\n          <tr>\n            <td class=\"exercise-3\">\n              <div id=\"slot_1_1\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_1\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_1</div>\n            </td>\n            <td class=\"exercise-3\">\n              <div id=\"slot_1_2\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_2\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_2</div>\n            </td>\n            <td class=\"exercise-3\">\n              <div id=\"slot_1_3\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_3\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_3</div>\n            </td>\n            <td class=\"exercise-3\">\n              <div id=\"slot_1_4\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_4\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_4</div>\n            </td>\n          </tr>\n          <tr>\n            <td colspan='3' class='separator'>\n              <svg height='94px' width='656px'>\n                <line x1=\"490\" y1=\"0\" x2=\"290\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n                <line x1=\"490\" y1=\"0\" x2=\"690\" y2=\"200\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"/>\n              </svg>\n            </td>\n          </tr>\n          <tr>\n            <td style=\"left: 295px\" class=\"exercise-1\">\n              <div id=\"slot_1_5\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_5\"\n                   ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_5\n              </div>\n            </td>\n            <td style=\"left: 297px\" class=\"exercise-1\">\n              <div id=\"slot_1_6\" translate></div>\n              <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_6\"\n                   ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-3.answer_3_6\n              </div>\n            </td>\n          </tr>\n        </table>\n      </div>\n    </div>\n    <div class=\"submit\">\n      <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b2-3.hide-title' | translate\"></button>\n      <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b2-3.complete-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'diagram3b2-3.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b2-3';
	    _this.submitBtn = 'diagram3b2-3-submit';
	    _this.nextBtn = 'diagram3b2-3-next';
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.greyAnswers = true;
	    _this.diagramNumber = 3;
	    _this.amountCorrectAnswers = 6;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1212);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b2-3 .submit{margin-right:2%}", ""]);
	
	// exports


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1214);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1215);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b2-4\" class='unit-diagram'>\n\n  <div class=\"diagram-task\" translate style=\"float: none\">diagram3a3-1.diagram-task</div>\n  <div class=\"diagram3b2-4 diagram-wrapper\">\n    <div class=\"unit-diagram-descriptionbox diagram3b2-4__description-box diagram-wrapper__description-box\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-6</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_7\">\n        <div class=\"list-element__number\">7.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-4.diagram-description-7</div>\n      </div>\n    </div>\n\n    <div id=\"slots\">\n      <p class=\"diagram-task diagram-task_diagramm3b2 diagram-task_diagramm3b2_4 exercise-4\" translate>diagram3b2-4.diagram-task</p>\n      <p class=\"diagram-hint diagram-hint_diagramm3b2 diagram-task_diagramm3b2_4 exercise-4\" translate>diagram3b2-4.diagram-hint</p>\n      <table class=\"slots\">\n        <tr>\n          <td colspan='3'>\n            <div class=\"fixed-answer fixed-answer_blue\" translate style=\"margin-bottom: 87px\">diagram3b2-4.fixed-answer</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator diagram3b2-4__separator'>\n            <svg height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td class=\"exercise-4\">\n            <div id=\"slot_1_1\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_1\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-4.diagram-description-1</div>\n          </td>\n          <td class=\"exercise-4\">\n            <div id=\"slot_1_2\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_2\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-4.diagram-description-4</div>\n          </td>\n          <td class=\"exercise-4\">\n            <div id=\"slot_1_3\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_4_3\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-4.diagram-description-6</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n  <div class=\"submit\">\n      <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n      <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n  </div>\n\n</div>\n"

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b2-4';
	    _this.submitBtn = 'diagram3b2-4-submit';
	    _this.nextBtn = 'diagram3b2-4-next';
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.greyAnswers = true;
	    _this.diagramNumber = 4;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: 'submit',
	    value: function submit() {
	      (0, _get3.default)(Diagram4Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller.prototype), 'submit', this).call(this);
	    }
	  }, {
	    key: 'hideAnswer',
	    value: function hideAnswer() {
	      (0, _get3.default)(Diagram4Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller.prototype), 'hideAnswer', this).call(this);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1217);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b2-4 .submit{margin-right:3%;margin-top:50px}.diagram3b2-4__separator{position:absolute;top:106px;left:34px}.diagram3b2-4 .long-arr{width:182px;left:-101px;transform:rotate(26deg);top:-92px}.diagram3b2-4 .long-arr__long-arr-part1{transform:none;width:195px}.diagram3b2-4 .long-arr__long-arr-part2{transform:none;top:39px}", ""]);
	
	// exports


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1219);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1220);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1221);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b2-5\" class='unit-diagram'>\n\n  <div class=\"diagram-task\" translate style=\"float: none\">diagram3a3-1.diagram-task</div>\n  <div class=\"diagram3b2-5\">\n    <div class=\"unit-diagram-descriptionbox diagram3b2-5__description-box\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-6</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_7\">\n        <div class=\"list-element__number\">7.</div>\n        <div class=\"list-element__description\" translate>diagram3b2-5.diagram-description-7</div>\n      </div>\n    </div>\n\n    <div id=\"slots\">\n      <p class=\"diagram-task diagram-task_diagramm3b2 diagram-task_diagramm3b2_4 exercise-5\" style=\"left: 160px\" translate>diagram3b2-5.diagram-task</p>\n      <p class=\"diagram-hint diagram-hint_diagramm3b2 diagram-task_diagramm3b2_4 exercise-5\" style=\"left: -60px\" translate>diagram3b2-5.diagram-hint</p>\n      <table class=\"slots\">\n        <tr>\n          <td colspan='3'>\n            <div class=\"fixed-answer fixed-answer_blue\" translate style=\"margin-bottom: 87px\">diagram3b2-5.fixed-answer</div>\n          </td>\n        </tr>\n        <tr>\n          <td colspan='3' class='separator diagram3b2-5__separator'>\n            <svg style=\"top: 6px;\" height='94px' width='556px'>\n              <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n            </svg>\n          </td>\n        </tr>\n        <tr>\n          <td class=\"exercise-5\">\n            <div id=\"slot_1_1\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_5_1\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-5.diagram-description-2</div>\n          </td>\n          <td class=\"exercise-5\">\n            <div id=\"slot_1_2\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_5_2\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-5.diagram-description-3</div>\n          </td>\n          <td class=\"exercise-5\">\n            <div id=\"slot_1_3\" translate></div>\n            <div class=\"fixed-answer hint element element_section3b2\" id=\"element_5_3\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b2-5.diagram-description-7</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n  </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.hide-title' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'1d-diagram1.complete-title' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'1a-diagram1.next-title' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(781);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b2-5';
	    _this.submitBtn = 'diagram3b2-5-submit';
	    _this.nextBtn = 'diagram3b2-5-next';
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.greyAnswers = true;
	    _this.diagramNumber = 5;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: 'submit',
	    value: function submit() {
	      (0, _get3.default)(Diagram5Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller.prototype), 'submit', this).call(this);
	    }
	  }, {
	    key: 'hideAnswer',
	    value: function hideAnswer() {
	      (0, _get3.default)(Diagram5Controller.prototype.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller.prototype), 'hideAnswer', this).call(this);
	    }
	  }, {
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1222);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1224);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1225);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-1\" class='unit-diagram'>\n\n\t<p class=\"diagram-task\" translate>diagram3b3-1.diagram-task</p>\n\t<div id=\"slots\">\n\t\t<table class=\"slots\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"4\">\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_1_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-1.element_1_2</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td colspan='4' class='separator separator_section3b3-4parts' ng-show=\"ansverType == 'Inductive'\">\n\t\t\t\t\t<svg height='94px' width='750px' style=\"top: 38px\">\n\t\t\t\t\t\t<path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_1_2\" translate>diagram3b3-1.element_1_4</div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_1_3\" translate>diagram3b3-1.element_1_1</div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"1_3\"  id=\"slot_1_3\" number=\"4\"></div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"1_5\"  id=\"slot_1_5\" number=\"5\"></div>\n\t\t\t\t\t<div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<div class=\"long-arr-part1\"></div>\n\t\t\t\t\t\t<div class=\"long-arr-part2\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element blue-element\" id=\"element_1_1\" number=\"1\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-1.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_1_2\" number=\"2\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-1.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" id=\"element_1_3\" data-item=\"1_3\" number=\"3\" translate>diagram3b3-1.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_1_4\" number=\"4\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-third-element': vm.movePoints}\" translate>diagram3b3-1.element_1_4</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" id=\"element_1_5\" data-item=\"1_5\" number=\"5\" translate>diagram3b3-1.element_1_5</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\t<form class=\"section3b3-form\" id=\"section3b3-form1\" action=\"#\" novalidate>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-1_radio\" id=\"diagram3b3-1_checkbox1\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Inductive\" />\n\t\t\t<label class=\"radio-button\" for=\"diagram3b3-1_checkbox1\"></label>\n\t\t</div>\n\t\t<label for=\"diagram3b3-1_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-1_radio\" id=\"diagram3b3-1_checkbox2\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Deductive\" />\n\t\t\t<label class=\"radio-button\" for=\"diagram3b3-1_checkbox2\"></label>\n\t\t</div>\n\t\t<label for=\"diagram3b3-1_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n\t</form>\n\n\n    <div class=\"submit\">\n      <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n      <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-1.hint-title' | translate\"></button>\n      <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-1.resubmit-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-1';
	    _this.submitBtn = 'diagram3b3-1-submit';
	    _this.nextBtn = 'diagram3b3-1-next';
	    _this.diagramNumber = 1;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1227);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".element.element_section_blue{border:2px solid #fff;background:#a7dec3;overflow:auto;min-height:84px;position:relative}.section3b3-form{display:flex;justify-content:center;align-items:center;margin-bottom:40px;margin-top:120px}.checkbox-description.checkbox-description_section3b3{margin-left:10px;margin-top:15px;margin-right:80px}.checkbox-description.checkbox-description_section3b3:last-of-type{margin-right:0}.unit3b-3 .exercise .exercise-number{margin-top:90px}.unit3b-3 .exercise .exercise-number_first{margin-top:0;margin-bottom:0}.unit3b-3 .submit{float:none;margin:0;position:absolute;bottom:-50px;right:0}.unit3b-3 .submit button{display:inline-block;margin:0 10px;border:2px solid #fff;text-transform:uppercase;background:#a7dec3;border-radius:10px;padding:6px 10px 2px;color:#fff;cursor:pointer;outline:none;text-decoration:none;transition:opacity .5s,display .1s .5s;opacity:1}.unit3b-3 #diagram3b3-6 .slots{margin-bottom:90px}.unit3b-3 .slots td{position:relative;padding:0 15px}.unit3b-3 .slots td #slot_1_1{margin-bottom:87px}.unit3b-3 .slots tr .separator{position:absolute;top:185px}.unit3b-3 .separator.separator_section3b3-3parts svg,.unit3b-3 .separator.separator_section3b3-4parts svg{left:15px}.unit3b-3 .separator.separator_section3b3-2parts.separator_section3b3-2parts_down svg{left:-80px;top:172px}.unit3b-3 .separator.separator_2parts svg{top:172px;left:-85px}.unit3b-3 .slots tr .separator.separator_hidden{display:none;position:relative;top:0}.unit3b-3 .slots-addbox{position:absolute;left:170px;top:448px}#diagram3b3-1 #slots div[id],#diagram3b3-1 .element{height:124px}#diagram3b3-1 .move-first-element{transform:translate(270px,-212px)}#diagram3b3-1 .move-second-element{transform:translate(181px,-427px)}#diagram3b3-1 .move-third-element{transform:translate(-488px,-212px)}", ""]);
	
	// exports


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1229);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1230);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-2\" class='unit-diagram'>\n\n\t<p class=\"diagram-task\" translate>diagram3b3-2.diagram-task</p>\n\t<div id=\"slots\">\n\t\t<table class=\"slots\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"4\">\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_2_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-2.element_1_2</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td colspan='4' class='separator separator_section3b3-4parts' ng-show=\"ansverType == 'Inductive'\">\n\t\t\t\t\t<svg height='94px' width='750px' style=\"top: 48px\">\n\t\t\t\t\t\t<path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_2_2\" translate>diagram3b3-2.element_1_4</div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_2_3\" translate>diagram3b3-2.element_1_1</div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"2_3\" id=\"slot_2_3\" number=\"4\"></div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"2_5\" id=\"slot_2_5\" number=\"5\"></div>\n\t\t\t\t\t<div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<div class=\"long-arr-part1\"></div>\n\t\t\t\t\t\t<div class=\"long-arr-part2\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</table>\n\t</div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element blue-element\" id=\"element_2_1\" number=\"1\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-2.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_2_2\" number=\"2\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-2.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"2_3\" id=\"element_2_3\" number=\"3\" translate>diagram3b3-2.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_2_4\" number=\"4\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-third-element': vm.movePoints}\" translate>diagram3b3-2.element_1_4</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"2_5\" id=\"element_2_5\" number=\"5\" translate>diagram3b3-2.element_1_5</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n\t<form class=\"section3b3-form\" id=\"section3b3-form2\" action=\"#\" novalidate>\n\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-2_radio\" id=\"diagram3b3-2_checkbox1\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Inductive\"\n\t\t\t/>\n\t\t\t<label class=\"radio-button\" for=\"diagram3b3-2_checkbox1\"></label>\n\t\t</div>\n\t\t<label for=\"diagram3b3-2_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n\t\t<div class=\"checkbox\">\n\t\t\t<input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-2_radio\" id=\"diagram3b3-2_checkbox2\" value=\"Deductive\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Deductive\"\n\t\t\t/>\n\t\t\t<label class=\"radio-button\" for=\"diagram3b3-2_checkbox2\"></label>\n\t\t</div>\n\t\t<label for=\"diagram3b3-2_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n\t</form>\n\n\n\t<div class=\"submit\">\n\t\t <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-2.hint-title' | translate\"></button>\n\t\t<button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-2.resubmit-title' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n\t</div>\n\n</div>\n"

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-2';
	    _this.submitBtn = 'diagram3b3-2-submit';
	    _this.nextBtn = 'diagram3b3-2-next';
	    _this.diagramNumber = 2;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1232);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-2 #slots div[id],#diagram3b3-2 .element{height:135px}#diagram3b3-2 .move-first-element{transform:translate(270px,-223px)}#diagram3b3-2 .move-second-element{transform:translate(181px,-449px)}#diagram3b3-2 .move-third-element{transform:translate(-488px,-223px)}", ""]);
	
	// exports


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1234);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1235);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1236);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-3\" class='unit-diagram'>\n\n    <p class=\"diagram-task\" translate>diagram3b3-3.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"4\">\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_3_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-3.element_1_2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan='3' class='separator separator_section3b3-3parts' ng-show=\"ansverType == 'Inductive'\">\n                    <svg height='94px' width='556px'>\n                        <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_3_2\" translate>diagram3b3-3.element_1_4</div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"3_3\" id=\"slot_3_3\" number=\"3\"></div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"3_1\" id=\"slot_3_1\" number=\"4\"></div>\n                    <div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<div class=\"long-arr-part1 long-arr-part1_short \"></div>\n\t\t\t\t\t\t<div class=\"long-arr-part2 long-arr-part2_short\"></div>\n\t\t\t\t\t</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"3_1\" id=\"element_3_1\" number=\"1\" translate>diagram3b3-3.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_3_2\" number=\"2\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-3.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"3_3\" id=\"element_3_3\" number=\"3\" translate>diagram3b3-3.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_3_4\" number=\"4\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-3.element_1_4</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n    <form class=\"section3b3-form\" id=\"section3b3-form3\" action=\"#\" novalidate>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-3_radio\" id=\"diagram3b3-3_checkbox1\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Inductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-3_checkbox1\"></label>\n        </div>\n        <label for=\"diagram3b3-3_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-3_radio\" id=\"diagram3b3-3_checkbox2\" value=\"Deductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Deductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-3_checkbox2\"></label>\n        </div>\n        <label for=\"diagram3b3-3_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n    </form>\n\n\n\t<div class=\"submit\">\n\t\t <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-3.hint-title' | translate\"></button>\n\t\t<button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-3.resubmit-title' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n\t</div>\n\n</div>\n"

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-3';
	    _this.submitBtn = 'diagram3b3-3-submit';
	    _this.nextBtn = 'diagram3b3-3-next';
	    _this.diagramNumber = 3;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1237);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-3 .move-first-element{transform:translate(93px,-347px)}#diagram3b3-3 .move-second-element{transform:translate(-479px,-174px)}", ""]);
	
	// exports


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1239);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1240);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1241);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1239 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-4\" class='unit-diagram'>\n\n    <p class=\"diagram-task\" translate>diagram3b3-4.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"4\">\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_4_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-4.element_1_3</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan='3' class='separator separator_section3b3-3parts' ng-show=\"ansverType == 'Inductive'\">\n                    <svg height='94px' width='556px' style=\"z-index: 0\">\n                        <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_4_2\" translate>diagram3b3-4.element_1_2</div>\n                  <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"4_4\" id=\"slot_4_4\" number=\"3\"></div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"4_1\" id=\"slot_4_1\" number=\"4\"></div>\n                    <div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n                        <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n                    </div>\n                </td>\n            </tr>\n        </table>\n    </div>\n    <div>\n      <table id=\"elements\">\n        <tr>\n          <td>\n            <div class=\"element blue-element drag-element\" data-item=\"4_1\" id=\"element_4_1\" number=\"1\" translate>diagram3b3-4.element_1_1</div>\n          </td>\n          <td>\n            <div class=\"element blue-element\" id=\"element_4_2\" number=\"2\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-4.element_1_2</div>\n          </td>\n          <td>\n            <div class=\"element blue-element\" id=\"element_4_3\" number=\"3\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-4.element_1_3</div>\n          </td>\n          <td>\n            <div class=\"element blue-element drag-element\" data-item=\"4_4\" id=\"element_4_4\" number=\"4\" translate>diagram3b3-4.element_1_4</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n\n    <form class=\"section3b3-form\" id=\"section3b3-form4\" action=\"#\" novalidate>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-4_radio\" id=\"diagram3b3-4_checkbox1\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Inductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-4_checkbox1\"></label>\n        </div>\n        <label for=\"diagram3b3-4_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-4_radio\" id=\"diagram3b3-4_checkbox2\" value=\"Deductive\" ng-model=\"ansverType\"  data-answer=\"true\" value=\"Deductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-4_checkbox2\"></label>\n        </div>\n        <label for=\"diagram3b3-4_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n    </form>\n\n\n    <div class=\"submit\">\n      <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n      <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'diagram3b3-4.hint-title' | translate\"></button>\n      <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-4.resubmit-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-4';
	    _this.submitBtn = 'diagram3b3-4-submit';
	    _this.nextBtn = 'diagram3b3-4-next';
	    _this.diagramNumber = 4;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1242);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-4 .move-first-element{transform:translate(-105px,-173px)}#diagram3b3-4 .move-second-element{transform:translate(-94px,-347px)}", ""]);
	
	// exports


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1244);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1245);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-5\" class='unit-diagram'>\n\n    <p class=\"diagram-task\" translate>diagram3b3-5.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"4\">\n                <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_5_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-5.element_1_1</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan='3' class='separator separator_section3b3-3parts' ng-show=\"ansverType == 'Inductive'\">\n                    <svg height='94px' width='556px' style=\"z-index: 0\">\n                        <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_5_2\" translate>diagram3b3-5.element_1_4</div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"5_2\" id=\"slot_5_2\" number=\"3\"></div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"5_3\" id=\"slot_5_3\" number=\"4\"></div>\n                    <div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <div class=\"long-arr-part1 long-arr-part1_short \"></div>\n                        <div class=\"long-arr-part2 long-arr-part2_short\"></div>\n                    </div>\n                </td>\n            </tr>\n        </table>\n    </div>\n    <div>\n      <table id=\"elements\">\n        <tr>\n          <td>\n            <div class=\"element blue-element\" id=\"element_5_1\" number=\"1\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-5.element_1_1</div>\n          </td>\n          <td>\n            <div class=\"element blue-element drag-element\" data-item=\"5_2\" id=\"element_5_2\" number=\"2\" translate>diagram3b3-5.element_1_2</div>\n          </td>\n          <td>\n            <div class=\"element blue-element drag-element\" data-item=\"5_3\" id=\"element_5_3\" number=\"3\" translate>diagram3b3-5.element_1_3</div>\n          </td>\n          <td>\n            <div class=\"element blue-element\" id=\"element_5_4\" number=\"4\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-5.element_1_4</div>\n          </td>\n        </tr>\n      </table>\n    </div>\n    <form class=\"section3b3-form\" id=\"section3b3-form5\" action=\"#\" novalidate>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-5_radio\" id=\"diagram3b3-5_checkbox1\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Inductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-5_checkbox1\"></label>\n        </div>\n        <label for=\"diagram3b3-5_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-5_radio\" id=\"diagram3b3-5_checkbox2\" value=\"Deductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Deductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-5_checkbox2\"></label>\n        </div>\n        <label for=\"diagram3b3-5_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n    </form>\n\n\n    <div class=\"submit\">\n      <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n      <button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"hint-exercise-button\" ng-bind=\"'diagram3b3-5.hint-title' | translate\"></button>\n      <button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-5.resubmit-title' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-5';
	    _this.submitBtn = 'diagram3b3-5-submit';
	    _this.nextBtn = 'diagram3b3-5-next';
	    _this.diagramNumber = 5;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1247);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-5 .move-first-element{transform:translate(280px,-349px)}#diagram3b3-5 .move-second-element{transform:translate(-479px,-173px)}", ""]);
	
	// exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1249);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1250);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1251);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1249 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-6\" class='unit-diagram'>\n\n    <p class=\"diagram-task\" translate>diagram3b3-6.diagram-task</p>\n    <div id=\"slots\">\n\t\t<table class=\"slots\">\n\t\t\t<tr>\n\t\t\t\t<td colspan=\"4\">\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_6_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-6.element_1_3</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td colspan='4' class='separator separator_section3b3-4parts' ng-show=\"ansverType == 'Inductive'\">\n\t\t\t\t\t<svg height='94px' width='750px' style=\"top: 17px\">\n\t\t\t\t\t\t<path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t\t<path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_6_2\" translate>diagram3b3-6.element_1_5</div>\n          <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n          <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_6_3\" translate>diagram3b3-6.element_1_1</div>\n          <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"6_4\" id=\"slot_6_4\" number=\"4\"></div>\n\t\t\t\t\t<div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<div class=\"slot slot-empty\" data-item=\"6_2\" id=\"slot_6_2\" number=\"5\"></div>\n\t\t\t\t\t<div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n\t\t\t\t\t\t<div class=\"long-arr-part1\"></div>\n\t\t\t\t\t\t<div class=\"long-arr-part2\"></div>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n            <td colspan='4' class='separator separator_section3b3-2parts separator_section3b3-2parts_down' ng-show=\"(ansverType === 'Inductive') || (ansverType == 'Deductive')\">\n                <svg height='94px' width='750px' style=\"margin-top: 40px;\">\n                    <path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                    <path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                </svg>\n            </td>\n            <tr class=\"slots-addbox\">\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"6_6\" id=\"slot_6_6\" number=\"6\"></div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"6_7\" id=\"slot_6_7\" number=\"7\"></div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element blue-element\" id=\"element_6_1\" number=\"1\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-6.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"6_2\" id=\"element_6_2\" number=\"2\" translate>diagram3b3-6.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_6_3\" number=\"3\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-6.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"6_4\" id=\"element_6_4\" number=\"4\" translate>diagram3b3-6.element_1_4</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_6_5\" number=\"5\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-third-element': vm.movePoints}\" translate>diagram3b3-6.element_1_5</div>\n        </td>\n      </tr>\n      <tr>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"6_6\" id=\"element_6_6\" number=\"6\" translate>diagram3b3-6.element_1_6</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"6_7\" id=\"element_6_7\" number=\"7\" translate>diagram3b3-6.element_1_7</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n    <form class=\"section3b3-form\" id=\"section3b3-form6\" action=\"#\" novalidate>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-6_radio\" id=\"diagram3b3-6_checkbox2\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Inductive\"/>\n            <label class=\"radio-button\" for=\"diagram3b3-6_checkbox2\"></label>\n        </div>\n        <label for=\"diagram3b3-6_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-6_radio\" id=\"diagram3b3-6_checkbox1\" value=\"Deductive\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Deductive\"/>\n            <label class=\"radio-button\" for=\"diagram3b3-6_checkbox1\"></label>\n        </div>\n        <label for=\"diagram3b3-6_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n    </form>\n\n\n\t<div class=\"submit\">\n\t\t <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-6.hint-title' | translate\"></button>\n\t\t<button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-6.resubmit-title' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n\t</div>\n\n</div>\n"

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_CourseController) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram6Controller, _CourseController);
	
	  function Diagram6Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-6';
	    _this.submitBtn = 'diagram3b3-6-submit';
	    _this.nextBtn = 'diagram3b3-6-next';
	    _this.diagramNumber = 6;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram6Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram6Controller;
	}(_course2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1252);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-6 .element{padding:4px 2px}#diagram3b3-6 #slots div[id],#diagram3b3-6 .element{height:104px;width:168px}#diagram3b3-6 #slots #slot_6_1{margin-bottom:0}#diagram3b3-6 #slots .slots-addbox{top:487px}#diagram3b3-6 .move-first-element{transform:translate(268px,-436px)}#diagram3b3-6 .move-second-element{transform:translate(-12px,-631px)}#diagram3b3-6 .move-third-element{transform:translate(-693px,-436px)}#diagram3b3-6 #elements{margin-top:204px}", ""]);
	
	// exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1254);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1255);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1256);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram7Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram7Component;

/***/ }),
/* 1254 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b3-7\" class='unit-diagram'>\n\n    <p class=\"diagram-task\" translate>diagram3b3-7.diagram-task</p>\n    <div id=\"slots\">\n        <table class=\"slots\">\n            <tr>\n                <td colspan=\"4\">\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_7_1\" style=\"margin-bottom: 87px\" translate>diagram3b3-7.element_1_2</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan='4' class='separator separator_section3b3-4parts' ng-show=\"ansverType == 'Inductive'\">\n                    <svg height='94px' width='750px' style=\"top: 33px\">\n                        <path d=\"M 93 94 l 282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                        <path d=\"M 282 94 l 92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                        <path d=\"M 468 94 l -92 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                        <path d=\"M 657 94 l -282 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\"></path>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td>\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_7_2\" translate>diagram3b3-7.element_1_4</div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                  <div class=\"fixed-answer blue-element\" ng-class=\"{'hide-answer': !vm.showFixedAnswers}\" id=\"fixedElement_7_3\" translate>diagram3b3-7.element_1_1</div>\n                  <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"7_5\" id=\"slot_7_5\" number=\"4\"></div>\n                    <div class=\"element-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <img src=\"../../../../../../assets/images/deductive-arr.png\" alt=\"\">\n                    </div>\n                </td>\n                <td>\n                    <div class=\"slot slot-empty\" data-item=\"7_3\" id=\"slot_7_3\" number=\"5\"></div>\n                    <div class=\"long-arr\" ng-show=\"ansverType == 'Deductive'\">\n                        <div class=\"long-arr-part1\"></div>\n                        <div class=\"long-arr-part2\"></div>\n                    </div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n  <div>\n    <table id=\"elements\">\n      <tr>\n        <td>\n          <div class=\"element blue-element\" id=\"element_7_1\" number=\"1\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-first-element': vm.movePoints}\" translate>diagram3b3-7.element_1_1</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_7_2\" number=\"2\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-second-element': vm.movePoints}\" translate>diagram3b3-7.element_1_2</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"7_3\" id=\"element_7_3\" number=\"3\" translate>diagram3b3-7.element_1_3</div>\n        </td>\n        <td>\n          <div class=\"element blue-element\" id=\"element_7_4\" number=\"4\" ng-hide=\"vm.showFixedAnswers\" ng-class=\"{'move-third-element': vm.movePoints}\" translate>diagram3b3-7.element_1_4</div>\n        </td>\n        <td>\n          <div class=\"element blue-element drag-element\" data-item=\"7_5\" id=\"element_7_5\" number=\"5\" translate>diagram3b3-7.element_1_5</div>\n        </td>\n      </tr>\n    </table>\n  </div>\n\n    <form class=\"section3b3-form\" id=\"section3b3-form7\" action=\"#\" novalidate>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-7_radio\" id=\"diagram3b3-7_checkbox1\" value=\"Inductive\" ng-model=\"ansverType\" data-answer=\"false\" value=\"Inductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-7_checkbox1\"></label>\n        </div>\n        <label for=\"diagram3b3-7_checkbox1\" class=\"checkbox-description checkbox-description_section3b3\">Inductive</label>\n\n        <div class=\"checkbox\">\n            <input type=\"radio\" ng-disabled=\"vm.diagramComplete\"  name=\"diagram3b3-7_radio\" id=\"diagram3b3-7_checkbox2\" value=\"Deductive\" ng-model=\"ansverType\" data-answer=\"true\" value=\"Deductive\"\n            />\n            <label class=\"radio-button\" for=\"diagram3b3-7_checkbox2\"></label>\n        </div>\n        <label for=\"diagram3b3-7_checkbox2\" class=\"checkbox-description checkbox-description_section3b3\">Deductive</label>\n\n    </form>\n\n\n\t<div class=\"submit\">\n\t\t <button ng-if=\"!vm.diagramComplete && !vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"vm.submitTitle ? vm.submitTitle : 'submit' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramHint && !vm.diagramComplete\" ng-click=\"vm.hint()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-7.hint-title' | translate\"></button>\n\t\t<button ng-if=\"!vm.diagramComplete && vm.diagramHint\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'diagram3b3-7.resubmit-title' | translate\"></button>\n\t\t<button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n\t</div>\n\n</div>\n"

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram7Controller = function (_CourseController) {
	  Diagram7Controller.$inject = ["courseService", "diagramService", "$scope", "$translate"];
	  (0, _inherits3.default)(Diagram7Controller, _CourseController);
	
	  function Diagram7Controller(courseService, diagramService, $scope, $translate) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram7Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram7Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram7Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService, $scope: $scope });
	
	    _this.diagramId = 'diagram3b3-7';
	    _this.submitBtn = 'diagram3b3-7-submit';
	    _this.nextBtn = 'diagram3b3-7-next';
	    _this.diagramNumber = 7;
	    _this.highlightOnlyIncorect = true;
	    _this.fixedAnswersDiagram = true;
	    // this.inducivedeductive = true;
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram7Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram7Controller;
	}(_course2.default);
	
	exports.default = Diagram7Controller;

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1257);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b3-7 #slots div[id],#diagram3b3-7 .element{height:120px}#diagram3b3-7 .move-first-element{transform:translate(270px,-208px)}#diagram3b3-7 .move-second-element{transform:translate(181px,-419px)}#diagram3b3-7 .move-third-element{transform:translate(-488px,-208px)}", ""]);
	
	// exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1259);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1260);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1261);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b4-1\" class=\"unit-diagram unit3b-4\">\n\n    <div class=\"diagram-task\" translate>diagram3b4-1.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.6</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_7\">\n        <div class=\"list-element__number\">7.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-1.diagram-answers.7</div>\n      </div>\n        <!--<div class=\"list-element draggable\" id=\"element_1_1\" translate>diagram3b4-1.diagram-answers.1</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_2\" translate>diagram3b4-1.diagram-answers.2</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_3\" translate>diagram3b4-1.diagram-answers.3</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_4\" translate>diagram3b4-1.diagram-answers.4</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_5\" translate>diagram3b4-1.diagram-answers.5</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_6\" translate>diagram3b4-1.diagram-answers.6</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_7\" translate>diagram3b4-1.diagram-answers.7</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_8\" translate>diagram3b4-1.diagram-answers.8</div>-->\n        <!--<div class=\"list-element draggable\" id=\"element_1_9\" translate>diagram3b4-1.diagram-answers.9</div>-->\n    </div>\n\n    <div class=\"unit-diagram-box\">\n        <div id=\"slots\">\n            <table class=\"slots\">\n                <tr>\n                    <td colspan=\"3\">\n                        <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3b4-1.diagram-peak</div>\n                        <p class=\"diagram-hint\" translate>diagram3b4-1.diagram-hint</p>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan='3' class='separator'>\n                        <svg height='94px' width='556px'>\n                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        </svg>\n                    </td>\n                </tr>\n                <tr>\n                    <td class=\"slot_1_1\">\n                        <div id=\"slot_1_1\" class=\"droppable\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-1.diagram-answers.1</div>\n                    </td>\n                    <td class=\"slot_1_2\">\n                        <div id=\"slot_1_2\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-1.diagram-answers.4</div>\n                    </td>\n                    <td class=\"slot_1_3\">\n                        <div id=\"slot_1_3\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-1.diagram-answers.7</div>\n                    </td>\n                </tr>\n            </table>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'hide' | translate\"></button>\n      <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'reveal' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b4-1';
	    _this.submitBtn = 'diagram3b4-1-submit';
	    _this.nextBtn = 'diagram3b4-1-next';
	    _this.greyAnswers = true;
	    _this.diagramNumber = 1;
	    _this.reveal = true;
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-1 .unit-diagram-descriptionbox{position:absolute;right:-5%;z-index:3;top:0}#diagram3b4-1 .diagram-hint{float:none;position:absolute;top:32px;left:37%;width:auto;padding:0;text-align:center;text-shadow:none;font-weight:700}#diagram3b4-1 td.slot_1_1 .long-arr,#diagram3b4-1 td.slot_1_2 .long-arr,#diagram3b4-1 td.slot_1_3 .long-arr{width:165px;right:50%;left:0;transform:translateX(68%)}#diagram3b4-1 td.slot_1_4 .long-arr,#diagram3b4-1 td.slot_1_5 .long-arr,#diagram3b4-1 td.slot_1_6 .long-arr{width:165px;left:15px}#diagram3b4-1 td.slot_1_5 .separator{position:absolute;top:-108%;left:-94%}#diagram3b4-1 td.slot_1_1 .long-arr .long-arr-part1{width:310px;transform:rotate(-18deg);left:73px;top:41px}#diagram3b4-1 td.slot_1_2 .long-arr .long-arr-part1{width:95px;transform:rotate(90deg);left:33px;top:42px}#diagram3b4-1 td.slot_1_3 .long-arr .long-arr-part1{width:310px;transform:rotate(18deg);left:-222px;top:41px}#diagram3b4-1 td.slot_1_4 .long-arr .long-arr-part1{width:200px;transform:rotate(-28deg);left:87px;top:42px}#diagram3b4-1 td.slot_1_5 .long-arr .long-arr-part1{width:95px;transform:rotate(90deg);left:33px;top:42px}#diagram3b4-1 td.slot_1_6 .long-arr .long-arr-part1{width:200px;transform:rotate(28deg);left:-127px;top:42px}#diagram3b4-1 td.slot_1_7 .long-arr .long-arr-part1{width:400px;transform:rotate(13.5deg);left:-113px;top:43px}#diagram3b4-1 td.slot_1_8 .long-arr .long-arr-part1{width:305px;transform:rotate(18deg);left:-15px;top:43px}#diagram3b4-1 td.slot_1_9 .long-arr .long-arr-part1{width:490px;transform:rotate(11deg);left:-200px;top:43px}", ""]);
	
	// exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1264);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1265);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1266);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1264 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b4-2\" class=\"unit-diagram unit3b-4\">\n\n    <div class=\"diagram-task\" translate>diagram3b4-2.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.6</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_7\">\n        <div class=\"list-element__number\">7.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-2.diagram-answers.7</div>\n      </div>\n    </div>\n\n    <div class=\"unit-diagram-box\">\n\n        <div id=\"slots\">\n            <table class=\"slots\">\n                <tr>\n                    <td colspan=\"6\">\n                        <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3b4-2.diagram-peak</div>\n                        <p class=\"diagram-hint\" translate>diagram3b4-2.diagram-hint</p>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan='6' class='separator'>\n                        <svg height='94px' width='556px'>\n                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        </svg>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_1\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-2.diagram-answers.3</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_2\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-2.diagram-answers.5</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_3\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-2.diagram-answers.7</div>\n                    </td>\n                </tr>\n\n            </table>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'hide' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'reveal' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b4-2';
	    _this.submitBtn = 'diagram3b4-2-submit';
	    _this.nextBtn = 'diagram3b4-2-next';
	    _this.greyAnswers = true;
	    _this.diagramNumber = 2;
	    _this.reveal = true;
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1267);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-2 .slots td{padding:0 10px}#diagram3b4-2 .diagram-hint{float:none;position:absolute;top:32px;left:23%;width:auto;padding:0;text-align:center;text-shadow:none;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1269);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1270);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b4-3\" class=\"unit-diagram unit3b-4\">\n\n    <div class=\"diagram-task\" translate>diagram3b4-3.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-3.diagram-answers.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-3.diagram-answers.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-3.diagram-answers.3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-3.diagram-answers.4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-3.diagram-answers.5</div>\n      </div>\n    </div>\n\n    <div class=\"unit-diagram-box\">\n\n        <div id=\"slots\">\n            <table class=\"slots\">\n                <tr>\n                    <td colspan=\"6\">\n                        <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3b4-3.diagram-peak</div>\n                        <p class=\"diagram-hint\" translate>diagram3b4-3.diagram-hint</p>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan='6' class='separator'>\n                        <svg height='94px' width='556px'>\n                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        </svg>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_1\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-3.diagram-answers.1</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_2\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-3.diagram-answers.2</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_3\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-3.diagram-answers.3</div>\n                    </td>\n                </tr>\n\n            </table>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'hide' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'reveal' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b4-3';
	    _this.submitBtn = 'diagram3b4-3-submit';
	    _this.nextBtn = 'diagram3b4-3-next';
	    _this.greyAnswers = true;
	    _this.diagramNumber = 3;
	    _this.reveal = true;
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1272);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-3 .slots td{padding:0 10px}#diagram3b4-3 .diagram-hint{float:none;position:absolute;top:20px;left:15%;width:auto;padding:0;text-align:left;text-shadow:none;font-weight:700}", ""]);
	
	// exports


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1274);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1275);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1276);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b4-4\" class=\"unit-diagram unit3b-4\">\n\n    <div class=\"diagram-task\" translate>diagram3b4-4.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-4.diagram-answers.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-4.diagram-answers.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-4.diagram-answers.3</div>\n      </div>\n    </div>\n\n    <div class=\"unit-diagram-box\">\n\n        <div id=\"slots\">\n            <table class=\"slots\">\n                <tr>\n                    <td colspan=\"6\">\n                        <div class=\"fixed-answer fixed-answer_blue\" translate>diagram3b4-4.diagram-peak</div>\n                        <p class=\"diagram-hint\" translate>diagram3b4-4.diagram-hint</p>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan='6' class='separator'>\n                        <svg height='94px' width='556px'>\n                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 278 94 l 0 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                        </svg>\n                    </td>\n                </tr>\n                <tr>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_1\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-4.diagram-answers.1</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_2\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-4.diagram-answers.3</div>\n                    </td>\n                    <td colspan=\"2\">\n                        <div id=\"slot_1_3\"></div>\n                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-4.diagram-answers.2</div>\n                    </td>\n                </tr>\n<!--                <tr ng-style=\"{opacity: vm.firstPartCompleted ? 1 : 0}\">-->\n<!--                    <td colspan='6' class='separator separator_hidden'>-->\n<!--                        <svg height='94px' width='556px'>-->\n<!--                            <path d=\"M 102 94 l 176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />-->\n<!--                            <path d=\"M 454 94 l -176 -94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />-->\n<!--                        </svg>-->\n<!--                    </td>-->\n<!--                </tr>-->\n<!--                <tr ng-style=\"{opacity: vm.firstPartCompleted ? 1 : 0}\">-->\n<!--                    <td colspan='2' class=\"slot_1_4\">-->\n<!--                        <div id=\"slot_1_4\"></div>-->\n<!--                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer && vm.secondPartCompleted\" translate>diagram3b4-4.diagram-answers.4</div>-->\n<!--                        <div class=\"long-arr\">-->\n<!--                            <div class=\"long-arr-part1\"></div>-->\n<!--                        </div>-->\n<!--                    </td>-->\n<!--                    <td colspan='2' class=\"slot_1_5\">-->\n<!--                        <div id=\"slot_1_5\"></div>-->\n<!--                        <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer && vm.secondPartCompleted\" translate>diagram3b4-4.diagram-answers.5</div>-->\n<!--                        <div class=\"long-arr\">-->\n<!--                            <div class=\"long-arr-part1\"></div>-->\n<!--                        </div>-->\n<!--                    </td>-->\n<!--                </tr>-->\n\n            </table>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'hide' | translate\"></button>\n      <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'reveal' | translate\"></button>\n      <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b4-4';
	    _this.submitBtn = 'diagram3b4-4-submit';
	    _this.nextBtn = 'diagram3b4-4-next';
	    _this.greyAnswers = true;
	    _this.diagramNumber = 4;
	    _this.reveal = true;
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1277);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-4 .unit-diagram-descriptionbox{right:0}#diagram3b4-4 .slots td{padding:0 10px}#diagram3b4-4 .diagram-hint{float:none;position:absolute;top:32px;left:50px;width:130px;padding:0;text-align:left;text-shadow:none;font-weight:700}#diagram3b4-4 .separator2-3b4{display:block;position:relative;left:185px;top:-1px}", ""]);
	
	// exports


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1279);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1280);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1281);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<',
	    userExerciseAnswers: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3b4-5\" class=\"unit-diagram unit3b-4\">\n\n    <div class=\"diagram-task\" translate>diagram3b4-5.diagram-task</div>\n    <div class=\"unit-diagram-descriptionbox\">\n      <div class=\"list-element\" id=\"element_1_1\">\n        <div class=\"list-element__number\">1.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.1</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_2\">\n        <div class=\"list-element__number\">2.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.2</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_3\">\n        <div class=\"list-element__number\">3.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.3</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_4\">\n        <div class=\"list-element__number\">4.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.4</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_5\">\n        <div class=\"list-element__number\">5.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.5</div>\n      </div>\n      <div class=\"list-element\" id=\"element_1_6\">\n        <div class=\"list-element__number\">6.</div>\n        <div class=\"list-element__description\" translate>diagram3b4-5.diagram-answers.6</div>\n      </div>\n    </div>\n\n    <div class=\"unit-diagram-box\">\n        <div id=\"slots\">\n          <div class=\"slots\">\n            <div>\n              <div class=\"fixed-answer fixed-answer_blue fixed-answer_peak\" translate>diagram3b4-5.diagram-peak</div>\n              <p class=\"diagram-hint\" translate>diagram3b4-5.diagram-hint</p>\n            </div>\n            <div class=\"mt-5\">\n              <svg height='94px' width='640'>\n                <line x1=\"320\" y1=\"0\" x2=\"100\" y2=\"94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                <line x1=\"320\" y1=\"0\" x2=\"320\" y2=\"94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n                <line x1=\"320\" y1=\"0\" x2=\"550\" y2=\"94\" stroke=\"white\" stroke-width=\"3\" fill=\"none\" />\n              </svg>\n            </div>\n            <div class=\"unit-diagram-box__answers mt-5\">\n              <div class=\"slot_1_1 unit-diagram-box__slot\">\n                <div id=\"slot_1_1\" class=\"slot\"></div>\n                <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-5.diagram-answers.2</div>\n              </div>\n              <div class=\"slot_1_2 unit-diagram-box__slot\">\n                <div id=\"slot_1_2\" class=\"slot\"></div>\n                <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-5.diagram-answers.4</div>\n              </div>\n              <div class=\"slot_1_3 unit-diagram-box__slot\">\n                <div id=\"slot_1_3\" class=\"slot\"></div>\n                <div class=\"fixed-answer hint\" ng-if=\"vm.diagramComplete && vm.showAnswer\" translate>diagram3b4-5.diagram-answers.5</div>\n              </div>\n            </div>\n\n            <!--\n              <div class=\"unit-diagram-box__slot\">\n                <ol class=\"desc-list\">\n                  <li translate>diagram3b4-5.diagram-description.1</li>\n                  <li translate>diagram3b4-5.diagram-description.2</li>\n                  <li translate>diagram3b4-5.diagram-description.3</li>\n                  <li translate>diagram3b4-5.diagram-description.4</li>\n                  <li translate>diagram3b4-5.diagram-description.5</li>\n                  <li translate>diagram3b4-5.diagram-description.6</li>\n                </ol>\n              </div> -->\n          </div>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"vm.showAnswer && !vm.isStatic\" ng-click=\"vm.hideAnswer()\" class=\"submit-exercise-button\" ng-bind=\"'hide' | translate\"></button>\n        <button ng-if=\"!vm.showAnswer\" ng-click=\"vm.submit()\" class=\"submit-exercise-button\" ng-bind=\"'reveal' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"next-exercise-button anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>\n"

/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, null, $scope));
	
	    (0, _assign2.default)(_this, { diagramService: diagramService, courseService: courseService });
	
	    _this.diagramId = 'diagram3b4-5';
	    _this.submitBtn = 'diagram3b4-5-submit';
	    _this.nextBtn = 'diagram3b4-5-next';
	    _this.greyAnswers = true;
	    _this.diagramNumber = 5;
	    _this.reveal = true;
	    _this.deductiveSpecialModel = true;
	    _this.correctElementStyled = {
	      'background-color': 'rgb(123, 123, 123)'
	    };
	    _this.amountCorrectAnswers = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.initDraggableList(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber, false, { slotsQuery: '.slot' });
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1282);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3b4-5 #slots .fixed-answer.fixed-answer_blue.fixed-answer_peak{width:225px}#diagram3b4-5 #slots{max-width:670px}#diagram3b4-5 .fixed-answer,#diagram3b4-5 .fixed-answer.fixed-answer_short{background-color:#a7dec3;border-color:#a7dec3}#diagram3b4-5 .fixed-answer.fixed-answer_short{width:120px}#diagram3b4-5 .unit-diagram-descriptionbox{right:0;top:40px}#diagram3b4-5 .unit-diagram-box{display:block}#diagram3b4-5 .unit-diagram-box .mt-5{margin-top:-5px}#diagram3b4-5 .unit-diagram-box__answers{display:flex;justify-content:space-around}#diagram3b4-5 .unit-diagram-box__slot{position:relative}#diagram3b4-5 .unit-diagram-box .connectors{display:flex}#diagram3b4-5 .unit-diagram-box .connectors__item{position:relative;left:-48px}#diagram3b4-5 .unit-diagram-box__fixed-answers{display:flex;justify-content:space-around;margin-left:3%}#diagram3b4-5 .diagram-hint{float:none;position:absolute;top:24%;left:9%;width:auto;padding:0;text-align:center;text-shadow:none;font-weight:700}#diagram3b4-5 .slots td{padding:0 5px}#diagram3b4-5 .slots tr:nth-child(5){transform:translateX(-17%)}#diagram3b4-5 .desc-list{border:3px solid #fff;padding:10px 0 10px 28px;border-radius:15px;margin-top:75px}#diagram3b4-5 .desc-list li{text-align:left}#diagram3b4-5 .desc-list li:nth-child(2),#diagram3b4-5 .desc-list li:nth-child(4){margin-bottom:10px}#diagram3b4-5 td.slot_1_1 .long-arr,#diagram3b4-5 td.slot_1_2 .long-arr,#diagram3b4-5 td.slot_1_3 .long-arr{width:165px;right:50%;left:0;transform:translateX(68%)}#diagram3b4-5 td.slot_1_4 .long-arr,#diagram3b4-5 td.slot_1_5 .long-arr,#diagram3b4-5 td.slot_1_6 .long-arr{width:165px;left:15px}#diagram3b4-5 td.slot_1_1 .fixed-answer.hint,#diagram3b4-5 td.slot_1_2 .fixed-answer.hint,#diagram3b4-5 td.slot_1_3 .fixed-answer.hint{right:25px}#diagram3b4-5 td.slot_1_1{left:-100px}#diagram3b4-5 td.slot_1_2{left:82px}#diagram3b4-5 td.slot_1_3{right:-100px}#diagram3b4-5 td.slot_1_5 .separator{position:absolute;top:-108%;left:-94%}#diagram3b4-5 td.slot_1_1 .long-arr .long-arr-part1{width:390px;transform:rotate(-14deg);left:3px;top:42px}#diagram3b4-5 td.slot_1_2 .long-arr .long-arr-part1{width:130px;transform:rotate(46deg);left:-90px;top:42px}#diagram3b4-5 td.slot_1_3 .long-arr .long-arr-part1{width:385px;transform:rotate(14deg);left:-362px;top:43px}#diagram3b4-5 td.slot_1_4 .long-arr .long-arr-part1{width:133px;transform:rotate(-45deg);left:33px;top:42px}#diagram3b4-5 td.slot_1_5 .long-arr .long-arr-part1{width:100px;transform:rotate(68deg);left:-17px;top:42px}#diagram3b4-5 td.slot_1_6 .long-arr .long-arr-part1{width:200px;transform:rotate(28deg);left:-127px;top:42px}#diagram3b4-5 td.slot_1_7 .long-arr .long-arr-part1{width:174px;transform:rotate(-33deg);left:242px;top:43px}#diagram3b4-5 td.slot_1_8 .long-arr .long-arr-part1{width:96px;transform:rotate(102deg);left:211px;top:43px}#diagram3b4-5 td.slot_1_9 .long-arr .long-arr-part1{width:135px;transform:rotate(43deg);left:120px;top:43px}#diagram3b4-5 td.slot_1_10 .long-arr .long-arr-part1{width:40px;transform:rotate(90deg);left:370px;top:69px}#diagram3b4-5 td.slot_1_11 .long-arr .long-arr-part1{width:40px;transform:rotate(90deg);left:422px;top:69px}#diagram3b4-5 td.slot_1_12 .long-arr .long-arr-part1{width:40px;transform:rotate(90deg);left:475px;top:69px}#diagram3b4-5 td.slot_1_13 .long-arr .long-arr-part1{width:300px;transform:rotate(90deg);left:402px;top:-59px}#diagram3b4-5 td.slot_1_13 .long-arr .long-arr-part2{width:558px;transform:rotate(180deg);left:-7.5px;top:48px;border:none;height:4px;background-color:#fff}", ""]);
	
	// exports


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1284);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1285);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-4a-4\" class=\"unit-diagram simplest__structure-diagram\">\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.blocks\">\n        <div class=\"simplest__structure-task\" ng-bind=\"block.task | translate\"></div>\n        <div class=\"simplest__structure-box\">\n            <textarea ng-model=\"block.model\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>"

/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.diagramId = 'diagram1-4a-4';
	    _this.submitBtn = 'diagram1-4a-4-submit';
	    _this.nextBtn = 'diagram1-4a-4-next';
	    _this.diagramNumber = 1;
	
	    _this.simplist = true;
	
	    _this.blocks = [{
	      task: 'diagram4-1-1.s',
	      answer: 'diagram4-1-1.s-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-1.c',
	      answer: 'diagram4-1-1.c-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-1.q',
	      answer: 'diagram4-1-1.q-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-1.a',
	      answer: 'diagram4-1-1.a-a',
	      model: ''
	    }];
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1287);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1289);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1290);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1291);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-4a-4\" class=\"unit-diagram simplest__structure-diagram\">\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.blocks\">\n        <div class=\"simplest__structure-task\" ng-bind=\"block.task | translate\"></div>\n        <div class=\"simplest__structure-box\">\n            <textarea ng-model=\"block.model\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>"

/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.diagramId = 'diagram2-4a-4';
	    _this.submitBtn = 'diagram2-4a-4-submit';
	    _this.nextBtn = 'diagram2-4a-4-next';
	    _this.diagramNumber = 2;
	
	    _this.simplist = true;
	
	    _this.blocks = [{
	      task: 'diagram4-1-2.s',
	      answer: 'diagram4-1-2.s-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-2.c',
	      answer: 'diagram4-1-2.c-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-2.q',
	      answer: 'diagram4-1-2.q-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-2.a',
	      answer: 'diagram4-1-2.a-a',
	      model: ''
	    }];
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1292);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1294);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1295);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1296);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-4a-4\" class=\"unit-diagram simplest__structure-diagram\">\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.blocks\">\n        <div class=\"simplest__structure-task\" ng-bind=\"block.task | translate\"></div>\n        <div class=\"simplest__structure-box\" ng-if=\"block.answer\">\n            <textarea ng-model=\"block.model\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>"

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.diagramId = 'diagram3-4a-4';
	    _this.submitBtn = 'diagram3-4a-4-submit';
	    _this.nextBtn = 'diagram3-4a-4-next';
	    _this.diagramNumber = 3;
	
	    _this.simplist = true;
	
	    _this.blocks = [{
	      task: 'diagram4-1-3.s',
	      answer: 'diagram4-1-3.s-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-3.c',
	      answer: 'diagram4-1-3.c-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-3.q',
	      answer: 'diagram4-1-3.q-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-3.a'
	    }];
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1297);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1299);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1300);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1301);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-4a-4\" class=\"unit-diagram simplest__structure-diagram\">\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.blocks\">\n        <div class=\"simplest__structure-task\" ng-bind=\"block.task | translate\"></div>\n        <div class=\"simplest__structure-box\" ng-if=\"block.answer\">\n            <textarea ng-model=\"block.model\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>"

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.diagramId = 'diagram4-4a-4';
	    _this.submitBtn = 'diagram4-4a-4-submit';
	    _this.nextBtn = 'diagram4-4a-4-next';
	    _this.diagramNumber = 4;
	
	    _this.simplist = true;
	
	    _this.blocks = [{
	      task: 'diagram4-1-4.s',
	      answer: 'diagram4-1-4.s-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-4.c',
	      answer: 'diagram4-1-4.c-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-4.q',
	      answer: 'diagram4-1-4.q-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-4.a'
	    }];
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1304);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1305);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1306);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-4a-4\" class=\"unit-diagram simplest__structure-diagram\">\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.blocks\">\n        <div class=\"simplest__structure-task\" ng-bind=\"block.task | translate\"></div>\n        <div class=\"simplest__structure-box\">\n            <textarea ng-model=\"block.model\"></textarea>\n        </div>\n    </div>\n\n    <div class=\"submit\">\n        <button ng-if=\"!vm.diagramComplete\" ng-click=\"vm.submit()\" class=\"simplest__structure-btn\" ng-bind=\"'simplest_structure' | translate\"></button>\n        <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'next' | translate\"></button>\n    </div>\n\n</div>"

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.diagramId = 'diagram5-4a-4';
	    _this.submitBtn = 'diagram5-4a-4-submit';
	    _this.nextBtn = 'diagram5-4a-4-next';
	    _this.diagramNumber = 5;
	
	    _this.simplist = true;
	
	    _this.blocks = [{
	      task: 'diagram4-1-5.s',
	      answer: 'diagram4-1-5.s-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-5.c',
	      answer: 'diagram4-1-5.c-a',
	      model: ''
	    }, {
	      task: 'diagram4-1-5.q',
	      answer: 'diagram4-1-5.q-a',
	      model: ''
	    }];
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1307);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1309);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1310);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1311);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-4b1-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram1-4b1-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller() {
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this));
	
	    _this.diagramId = 'diagram1-4b1-4';
	    _this.submitBtn = 'diagram1-4b1-4-submit';
	    _this.nextBtn = 'diagram1-4b1-4-next';
	    _this.diagramNumber = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1312);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1314);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1315);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1316);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-4b1-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram2-4b1-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller() {
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this));
	
	    _this.diagramId = 'diagram2-4b1-4';
	    _this.submitBtn = 'diagram2-4b1-4-submit';
	    _this.nextBtn = 'diagram2-4b1-4-next';
	    _this.diagramNumber = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1317);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1319);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1320);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1321);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram1-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller() {
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this));
	
	    _this.diagramId = 'diagram1-4b2-4';
	    _this.submitBtn = 'diagram1-4b2-4-submit';
	    _this.nextBtn = 'diagram1-4b2-4-next';
	    _this.diagramNumber = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1322);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1324);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1325);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1326);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram2-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller() {
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this));
	
	    _this.diagramId = 'diagram2-4b2-4';
	    _this.submitBtn = 'diagram2-4b2-4-submit';
	    _this.nextBtn = 'diagram2-4b2-4-next';
	    _this.diagramNumber = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1327);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1329);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1330);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1331);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram3-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller() {
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this));
	
	    _this.diagramId = 'diagram3-4b2-4';
	    _this.submitBtn = 'diagram3-4b2-4-submit';
	    _this.nextBtn = 'diagram3-4b2-4-next';
	    _this.diagramNumber = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1332);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1334);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1335);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1336);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram4-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller() {
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this));
	
	    _this.diagramId = 'diagram4-4b2-4';
	    _this.submitBtn = 'diagram4-4b2-4-submit';
	    _this.nextBtn = 'diagram4-4b2-4-next';
	    _this.diagramNumber = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1337);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1339);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1340);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1341);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram5-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram5Controller, _CourseController);
	
	  function Diagram5Controller() {
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this));
	
	    _this.diagramId = 'diagram5-4b2-4';
	    _this.submitBtn = 'diagram5-4b2-4-submit';
	    _this.nextBtn = 'diagram5-4b2-4-next';
	    _this.diagramNumber = 5;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram5Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram5Controller;
	}(_course2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1342);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1344);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1345);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1346);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram6-4b2-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram6-4b2-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram6Controller, _CourseController);
	
	  function Diagram6Controller() {
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this));
	
	    _this.diagramId = 'diagram6-4b2-4';
	    _this.submitBtn = 'diagram6-4b2-4-submit';
	    _this.nextBtn = 'diagram6-4b2-4-next';
	    _this.diagramNumber = 6;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram6Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram6Controller;
	}(_course2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1347);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1349);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1350);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1351);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {},
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-4c-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram1-4c-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller() {
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this));
	
	    _this.diagramId = 'diagram1-4c-4';
	    _this.submitBtn = 'diagram1-4c-4-submit';
	    _this.nextBtn = 'diagram1-4c-4-next';
	    _this.diagramNumber = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1352);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1354);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1355);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1356);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-4c-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram2-4c-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller() {
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this));
	
	    _this.diagramId = 'diagram2-4c-4';
	    _this.submitBtn = 'diagram2-4c-4-submit';
	    _this.nextBtn = 'diagram2-4c-4-next';
	    _this.diagramNumber = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1357);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1359);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1360);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1361);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-4c-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram3-4c-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller() {
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this));
	
	    _this.diagramId = 'diagram3-4c-4';
	    _this.submitBtn = 'diagram3-4c-4-submit';
	    _this.nextBtn = 'diagram3-4c-4-next';
	    _this.diagramNumber = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1362);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1364);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1365);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1366);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-4c-4\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram4-4c-4-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram4Controller, _CourseController);
	
	  function Diagram4Controller() {
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this));
	
	    _this.diagramId = 'diagram4-4c-4';
	    _this.submitBtn = 'diagram4-4c-4-submit';
	    _this.nextBtn = 'diagram4-4c-4-next';
	    _this.diagramNumber = 4;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram4Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram4Controller;
	}(_course2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1367);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1369);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1370);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1371);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-5a-5\" class=\"unit-diagram\">\n    <p class=\"diagram-task\" translate>diagram1-5a-5.diagram-task</p>\n\n    <div id=\"slots\">\n        <table class=\"slots steps\">\n            <tr>\n                <td colspan=\"3\">\n                    <div id=\"step1\" class=\"step\" translate>diagram1-5a-5.step-1</div>\n                </td>\n                <td colspan=\"3\">\n                </td>\n                <td colspan=\"3\">\n                    <div id=\"step3\" class=\"step\" translate>diagram1-5a-5.step-2</div>\n                </td>\n                <td colspan=\"3\">\n                    <div id=\"step4\" class=\"step\" translate>diagram1-5a-5.step-3</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"95\" y1=\"0\" x2=\"95\" y2=\"8\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"174\" y1=\"50\" x2=\"210\" y2=\"-10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"384\" y1=\"-20\" x2=\"392\" y2=\"-20\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"500\" y1=\"0\" x2=\"415\" y2=\"20\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"3\">\n                    <div id=\"step2\" class=\"step\" translate>diagram1-5a-5.step-4</div>\n                </td>\n                <td colspan=\"3\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram1-5a-5.step-5</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <line x1=\"400\" y1=\"0\" x2=\"400\" y2=\"10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"6\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram1-5a-5.step-6</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <line x1=\"400\" y1=\"0\" x2=\"400\" y2=\"10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"6\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram1-5a-5.step-7</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <p class=\"step-task\" translate>diagram1-5a-5.step-task</p>\n\n    <div class=\"situation\">\n        <div class=\"situation-title\" translate>diagram1-5a-5.situation.title</div>\n        <div class=\"situation-text\" translate>diagram1-5a-5.situation.text</div>\n    </div>\n\n</div>\n"

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram1Controller, _CourseController);
	
	  function Diagram1Controller() {
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this));
	
	    _this.diagramId = 'diagram1-5a-5';
	    _this.submitBtn = 'diagram1-5a-5-submit';
	    _this.nextBtn = 'diagram1-5a-5-next';
	    _this.diagramNumber = 1;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram1Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram1Controller;
	}(_course2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1372);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram1-5a-5 .step-task{color:#f0e527;text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1374);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1375);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1376);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-5a-5\" class=\"unit-diagram\">\n    <p class=\"diagram-task\" translate>diagram2-5a-5.diagram-task</p>\n\n    <div id=\"slots\">\n        <table class=\"slots steps\">\n            <tr>\n                <td colspan=\"3\">\n                    <div id=\"step1\" class=\"step\" translate>diagram2-5a-5.step-1</div>\n                </td>\n                <td colspan=\"3\">\n                </td>\n                <td colspan=\"3\">\n                    <div id=\"step3\" class=\"step\" translate>diagram2-5a-5.step-2</div>\n                </td>\n                <td colspan=\"3\">\n                    <div id=\"step4\" class=\"step\" translate>diagram2-5a-5.step-3</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <defs>\n                            <marker id=\"arrow\" markerWidth=\"10\" markerHeight=\"10\" refX=\"0\" refY=\"3\" orient=\"auto\" markerUnits=\"strokeWidth\">\n                                <path d=\"M0,1.5 L0,4.5 L6,3 z\" fill=\"#fff\" />\n                            </marker>\n                        </defs>\n                        <line x1=\"95\" y1=\"0\" x2=\"95\" y2=\"8\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"174\" y1=\"50\" x2=\"210\" y2=\"-10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"384\" y1=\"-20\" x2=\"392\" y2=\"-20\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                        <line x1=\"500\" y1=\"0\" x2=\"415\" y2=\"20\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"3\">\n                    <div id=\"step2\" class=\"step\" translate>diagram2-5a-5.step-4</div>\n                </td>\n                <td colspan=\"3\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram2-5a-5.step-5</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <line x1=\"400\" y1=\"0\" x2=\"400\" y2=\"10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"6\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram2-5a-5.step-6</div>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"12\" class=\"separator\">\n                    <svg height=\"94px\" width=\"556px\">\n                        <line x1=\"400\" y1=\"0\" x2=\"400\" y2=\"10\" stroke=\"#fff\" stroke-width=\"3\" marker-end=\"url(#arrow)\"></line>\n                    </svg>\n                </td>\n            </tr>\n            <tr>\n                <td colspan=\"6\">\n                </td>\n                <td colspan=\"6\">\n                    <div id=\"step5\" class=\"step\" translate>diagram2-5a-5.step-7</div>\n                </td>\n            </tr>\n        </table>\n    </div>\n\n    <p class=\"step-task\" translate>diagram2-5a-5.step-task</p>\n\n    <div class=\"situation\">\n        <div class=\"situation-title\" translate>diagram2-5a-5.situation.title</div>\n        <div class=\"situation-text\" translate>diagram2-5a-5.situation.text</div>\n    </div>\n\n</div>"

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram2Controller, _CourseController);
	
	  function Diagram2Controller() {
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this));
	
	    _this.diagramId = 'diagram2-5a-5';
	    _this.submitBtn = 'diagram2-5a-5-submit';
	    _this.nextBtn = 'diagram2-5a-5-next';
	    _this.diagramNumber = 2;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram2Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram2Controller;
	}(_course2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1377);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2-5a-5 .step-task{color:#f0e527;text-align:left}", ""]);
	
	// exports


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1379);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1380);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1381);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-5a-5\" class='unit-diagram'>\n\n    <div class=\"submit\">\n        <a id=\"diagram3-5a-5-submit\">Complete</a>\n        <a ng-click=\"vm.goToNext()\" class=\"next-exercise-button anchor\">Next</a>\n    </div>\n\n</div>"

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_CourseController) {
	  (0, _inherits3.default)(Diagram3Controller, _CourseController);
	
	  function Diagram3Controller() {
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this));
	
	    _this.diagramId = 'diagram3-5a-5';
	    _this.submitBtn = 'diagram3-5a-5-submit';
	    _this.nextBtn = 'diagram3-5a-5-next';
	    _this.diagramNumber = 3;
	    return _this;
	  }
	
	  (0, _createClass3.default)(Diagram3Controller, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramService.init(this.diagramId, this.submitBtn, this.nextBtn, this.diagramNumber);
	    }
	  }]);
	  return Diagram3Controller;
	}(_course2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1382);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1384);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1385);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<' },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-5b-5\" class='unit-diagram scq-diagram-dnd-framework-wrapper'>\n\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram1.title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram1.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"240px\">\n            <line x1=\"200\" y1=\"78\" x2=\"57\" y2=\"162\"/>\n            <line x1=\"200\" y1=\"78\" x2=\"340\" y2=\"162\"/>\n            <line x1=\"155\" y1=\"202\" x2=\"245\" y2=\"202\"/>\n            <path d=\"M 156 202 L 167 194 L 167 210 Z\"></path>\n          </svg>\n          <div class=\"simplest__structure-framework__diagram-box simplest__structure-framework__diagram-box-top\">\n            <p translate>diagram1.diagram-header</p>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram1.left-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram1.right-box</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram1.bottom-box-points</div>\n        <p class=\"simplest__structure-framework__situation-desc\" translate>diagram1.situation-desc</p>\n        <p style=\"margin-top: 15px;\" class=\"simplest__structure-framework__situation-desc situation-desc\" translate>diagram1.situation-desc-short</p>\n        <div style=\"margin: 30px 0\">\n          <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n<!--          <button ng-if=\"vm.diagramComplete\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram3.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.answer}}\" data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component tooltip-text=\"answer.title\"></arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_FrameworkCourseContr) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _FrameworkCourseContr);
	
	  function Diagram1Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 4;
	    _this.first = true;
	    _this.clearDiagramId = 1;
	    _this.exerciseId = 'exercise-1';
	    _this.pyramidData = {
	      exerciseNumber: 1,
	      scheme: {
	        model: {
	          textarea: 'Corporations need to reshape their sales forces’ day-to-day activities to match each customer’s lifetime value'
	        },
	        children: [{
	          model: {
	            textarea: 'Identify the specific customers and markets you want your sales growth to come from'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Judge the structural potency of your proposition to those sourcec vs competitors\' offerings'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Allocate sales capacity to match the lifetime value of the opportunity'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Only then provide bespoke "by the field for the field" sales tools'
	          },
	          children: []
	        }]
	      },
	      instruction: '<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>\n                    <ol>\n                     <li>Situation = Sit</li>\n                     <li>Disturbing Event = DE</li>\n                     <li>Result 1 = R1</li>\n                     <li>Result 2 = R2</li>\n                     <li>Solution = Sol</li>\n                    </ol>\n                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written. Now open the Minto Framework and fill in the SCQ.</p>',
	      scq: {
	        's-header': 'Sit, DE, R1',
	        'c-header': 'Sol, R2'
	      },
	      opacity: 0.5
	    };
	    return _this;
	  }
	
	  return Diagram1Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1387);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram1-5b-5 .simplest__structure-framework__bottom-box-points>ul>li{font-size:13px}#diagram1-5b-5 .simplest__structure-framework__bottom-box-points>ul{margin-right:2px}#diagram1-5b-5 .simplest__structure-framework__diagram-box{width:160px}", ""]);
	
	// exports


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1389);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1390);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<',
	    onComplete: '<' },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-5b-2\" class='unit-diagram scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>Corporations need to reshape their sales forces’ day-to-day activities to match each customer’s lifetime value</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Identify the specific customers and markets you want your sales growth to come from</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Judge the structural potency of your proposition to those sourcec vs competitors' offerings</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Allocate sales capacity to match the lifetime value of the opportunity</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Only then provide bespoke \"by the field for the field\" sales tools</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_ScqDiagramCourseCont) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram2Controller, _ScqDiagramCourseCont);
	
	  function Diagram2Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram2Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(486);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _course = __webpack_require__(196);
	
	var _course2 = _interopRequireDefault(_course);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScqDiagramCourseController = function (_CourseController) {
	  ScqDiagramCourseController.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(ScqDiagramCourseController, _CourseController);
	
	  function ScqDiagramCourseController(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, ScqDiagramCourseController);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (ScqDiagramCourseController.__proto__ || (0, _getPrototypeOf2.default)(ScqDiagramCourseController)).call(this, courseService, diagramService, $translate, $scope));
	
	    _this.$timeout = $timeout;
	    _this.showSchoolAnswer = {
	      0: true,
	      1: true,
	      2: true
	    };
	
	    return _this;
	  }
	
	  (0, _createClass3.default)(ScqDiagramCourseController, [{
	    key: '$postLink',
	    value: function $postLink() {
	      this.diagramId = this.data.id;
	      this.hideTaskTitle = this.data.hideTaskTitle;
	    }
	  }, {
	    key: 'showUserAnswear',
	    value: function showUserAnswear(block) {
	      if (this.diagramComplete) {
	        block.model = block.userAnswer;
	      }
	    }
	  }, {
	    key: 'hideUserAnswear',
	    value: function hideUserAnswear(block) {
	      if (this.diagramComplete) {
	        block.model = block.answer;
	      }
	    }
	  }, {
	    key: 'submit',
	    value: function submit() {
	      var _this2 = this;
	
	      this.courseService.play('buttonClick');
	      if (this.hideTaskTitle) {
	        this.hideTaskTitle = false;
	      } else {
	        var time = 500;
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var block = _step.value;
	
	            block.userAnswer = block.model;
	            _this2.$timeout(function () {
	              return block.model = block.answer;
	            }, time);
	            time += 500;
	          };
	
	          for (var _iterator = (0, _getIterator3.default)(this.data.blocks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      this.finishExercise();
	      this.diagramComplete = true;
	    }
	
	    // switch() {
	    //   this.courseService.play('buttonClick');
	    //   this.showSchoolAnswer = !this.showSchoolAnswer;
	    //   this.diagramComplete = true;
	    // }
	
	  }, {
	    key: 'showUserAnswers',
	    value: function showUserAnswers() {}
	  }, {
	    key: 'isNeedToShowTaskTitle',
	    value: function isNeedToShowTaskTitle() {
	      return this.showTaskTitle;
	    }
	  }]);
	  return ScqDiagramCourseController;
	}(_course2.default);
	
	exports.default = ScqDiagramCourseController;

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1393);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram4-5b-2 .simplest__text-area{height:85px}", ""]);
	
	// exports


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1395);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1396);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1397);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<' },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-5b-5\" class='unit-diagram scq-diagram-dnd-framework-wrapper'>\n\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram3.title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram3.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"324px\">\n            <line x1=\"200\" y1=\"78\" x2=\"200\" y2=\"162\"/>\n            <line x1=\"220\" y1=\"238\" x2=\"340\" y2=\"321\"/>\n            <line x1=\"180\" y1=\"238\" x2=\"60\" y2=\"321\"/>\n            <path d=\"M 180 239 L 173 254 L 160 240 Z\"/>\n            <path d=\"M 220 239 L 228 254 L 239 240 Z\"/>\n          </svg>\n          <div class=\"simplest__structure-framework__diagram-box simplest__structure-framework__diagram-box-top\">\n            <p translate>diagram3.diagram-header</p>\n          </div>\n          <div style=\"margin-top: 80px; width: 160px\" class=\"simplest__structure-framework__diagram-box simplest__structure-framework__diagram-box-top\">\n            <p translate>diagram3.situation-second-row</p>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3.left-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3.right-box</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram3.bottom-box-points</div>\n        <p class=\"simplest__structure-framework__situation-desc\" translate>diagram3.situation-desc</p>\n        <div style=\"margin: 30px 0\">\n          <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram3.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.answer}}\" data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component tooltip-text=\"answer.title\"></arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_FrameworkCourseContr) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _FrameworkCourseContr);
	
	  function Diagram3Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 4;
	    _this.exerciseId = 'exercise-2';
	    _this.clearDiagramId = 2;
	    _this.pyramidData = {
	      exerciseNumber: 2,
	      scheme: {
	        model: {
	          textarea: 'We should think seriously about negotating to develop an outsourcing relationship'
	        },
	        children: [{
	          model: {
	            textarea: 'Upgrading will not address the present system\'s deficiencies'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Migrating to a new system would be high cost, without solving all of the problems'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Outsourcing provides a better product at a cost much lower than the present $12m'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Two highly rated vendors are avaible to do the job'
	          },
	          children: []
	        }]
	      },
	      instruction: '<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>\n                    <ol>\n                     <li>Situation = Sit</li>\n                     <li>Disturbing Event = DE</li>\n                     <li>Result 1 = R1</li>\n                     <li>Result 2 = R2</li>\n                     <li>Solution = Sol</li>\n                    </ol>\n                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written.</p>',
	      scq: {
	        's-header': 'Sit, DE, R1, R2',
	        'c-header': 'Sol'
	      },
	      additionalBox: 'Believe we should nevertheless think seriously about negotiating to develop an outsourcing relationship',
	      opacity: 0.5
	    };
	    return _this;
	  }
	
	  return Diagram3Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1398);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3-5b-5 .simplest__structure-framework__bottom-box-points{margin:20px 0;display:block}#diagram3-5b-5 .simplest__structure-framework__bottom-box-points p{font-family:Nexa-Bold,sans pro,\"serif\";color:#fff;font-size:16px;line-height:18px}#diagram3-5b-5 .simplest__structure-framework__bottom-box-points p:last-child{margin-left:5px}", ""]);
	
	// exports


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1400);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1401);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1402);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<',
	    onComplete: '<' },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-5b-2\" class='unit-diagram scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>We should think seriously about negotating to develop an outsourcing relationship</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Upgrading will not address the present system's deficiencies</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Migrating to a new system would be high cost, without solving all of the problems</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Outsourcing provides a better product at a cost much lower than the present $12m</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Two highly rated vendors are avaible to do the job</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_ScqDiagramCourseCont) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram4Controller, _ScqDiagramCourseCont);
	
	  function Diagram4Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram4Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1403);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1405);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1406);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-5b-5\" class='unit-diagram diagram5-5b-5 scq-diagram-dnd-framework-wrapper'>\n\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram5.title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest__structure-framework-triple simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram5.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"315px\">\n            <line x1=\"196\" y1=\"25\" x2=\"106\" y2=\"67\"/>\n            <line x1=\"196\" y1=\"109\" x2=\"106\" y2=\"67\"/>\n            <line x1=\"106\" y1=\"290\" x2=\"145\" y2=\"290\"/>\n            <line x1=\"255\" y1=\"290\" x2=\"290\" y2=\"290\"/>\n            <path d=\"M 145 290 L 115 295 L 115 285 Z\"></path>\n            <path d=\"M 293 290 L 263 295 L 263 285 Z\"></path>\n          </svg>\n          <div class=\"simplest__structure-framework__diagram-top-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box simplest__structure-framework__diagram-header\">\n              <p translate>diagram5.diagram-header</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-top-bottom__desc\">\n              <div class=\"simplest__structure-framework__diagram-box\">\n                <p translate>diagram5.top-box-desc-top</p>\n              </div>\n              <div style=\"margin-top: 34px;\" class=\"simplest__structure-framework__diagram-box\">\n                <p translate>diagram5.top-box-desc-bottom</p>\n              </div>\n              <div class=\"simplest__structure-framework__top-box-points\" translate>diagram5.top-box-points</div>\n            </div>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5.left-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5.middle-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5.right-box</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram5.bottom-box-points</div>\n        <p class=\"simplest__structure-framework__situation-desc\" translate>diagram5.situation-desc</p>\n        <div style=\"margin: 30px 0\">\n          <div data-index=\"5\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"[4, 2]\" class=\"simplest__structure-box top_box simplest__structure-framework-box\"></div>\n          <div data-index=\"[4, 2]\" class=\"simplest__structure-box bottom_box simplest__structure-framework-box\"></div>\n          <div class=\"solution-separator\">\n            <div class=\"bottom-line\"></div>\n          </div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram5.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.answer}}\" data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component tooltip-text=\"answer.title\"\n                                         tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-10px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n\n</div>\n"

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_FrameworkCourseContr) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _FrameworkCourseContr);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 5;
	    _this.exerciseId = 'exercise-3';
	    _this.clearDiagramId = 3;
	    _this.pyramidData = {
	      exerciseNumber: 3,
	      scheme: {
	        model: {
	          textarea: 'They will be focusing on how to make it easier for customers and mfrs. to do business with C&S at every level'
	        },
	        children: [{
	          model: {
	            textarea: 'Improve working relationships with manufacturers'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Ensure S&G points of contact are communicated to the vendor/broker community'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Provide effective cate-gory management and marketing solutions to both customers and manufacturers'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Tie our merchandising programs directly to customer performance'
	          },
	          children: []
	        }]
	      },
	      instruction: '<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>\n                    <ol>\n                     <li>Situation = Sit</li>\n                     <li>Disturbing Event = DE</li>\n                     <li>Result 1 = R1</li>\n                     <li>Result 2 = R2</li>\n                     <li>Solution = Sol</li>\n                    </ol>\n                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written.</p>',
	      scq: {
	        's-header': 'DE, R1',
	        'c-header': 'Sol, R2'
	      },
	      // additionalBox: 'SUGGESTED STRUCTURE 2014 ADVANTAGE SURVEY RESULTS AND ACTION PLAN',
	      opacity: 0.5
	    };
	    return _this;
	  }
	
	  return Diagram5Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1408);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram5-5b-5{min-height:906px}#diagram5-5b-5 .simplest__structure-framework__bottom-box-points>ul>li{font-size:13px}#diagram5-5b-5 .simplest__submit{bottom:10px}", ""]);
	
	// exports


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1410);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1411);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1412);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<',
	    onComplete: '<' },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram6-5b-3\" class='unit-diagram scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>They will be focusing on how to make it easier for customers and mfrs. to do business with C&S at every level</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Improve working relationships with manufacturers</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Ensure S&G points of contact are communicated to the vendor/broker community</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Provide effective cate-gory management and marketing solutions to both customers and manufacturers</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Tie our merchandising programs directly to customer performance</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n</div>\n"

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_ScqDiagramCourseCont) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram6Controller, _ScqDiagramCourseCont);
	
	  function Diagram6Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram6Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1413);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "", ""]);
	
	// exports


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1415);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1416);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1417);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-5c-1\" class='unit-diagram diagram1-5c-1 scq-diagram-dnd-framework-wrapper'>\n\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram1-5c.title</p>\n\n    <p class=\"framework-diagram__exercise-title\" translate>diagram1-5c.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest__structure-framework-triple simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram1-5c.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"201px\">\n            <line x1=\"127\" y1=\"61\" x2=\"55\" y2=\"153\"/>\n            <line x1=\"127\" y1=\"61\" x2=\"195\" y2=\"153\"/>\n          </svg>\n          <div class=\"diagram-header simplest__structure-framework__diagram-box\">\n            <p translate>diagram1-5c.diagram-header</p>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram1-5c.left-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram1-5c.middle-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram1-5c.right-box</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram1-5c.bottom-box-points</div>\n        <div class=\"simplest__structure-framework__diagram__summarize-bottom-box\">\n          <div class=\"simplest__structure-framework__diagram__summarize-bottom-box__dashed-top\"></div>\n          <div class=\"simplest__structure-framework__diagram__summarize-bottom-box__dashed-bottom\">\n            <p translate>diagram1-5c.bottom-box-points-summarize</p>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram1-5c.situation-desc-points</div>\n        <p class=\"simplest__structure-framework__situation-desc situation-desc\" translate>diagram1-5c.situation-desc</p>\n        <div style=\"margin: 30px 0\">\n          <div class=\"simplest__structure-framework-box structure-box-list\" translate>diagram1-5c.structure-box</div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram1-5c.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.answer}}\" data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component tooltip-text=\"answer.title\"></arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_FrameworkCourseContr) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _FrameworkCourseContr);
	
	  function Diagram1Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 3;
	    _this.first = true;
	    _this.clearDiagramId = 1;
	    _this.exerciseId = 'exercise-1';
	    _this.pyramidData = {
	      exerciseNumber: 1,
	      scheme: {
	        model: {
	          textarea: 'Should be able to build on our existing market presence to emerge as market leader'
	        },
	        children: [{
	          model: {
	            textarea: 'Focus on K-5 enrichment curriculum in the Arts and Sciences'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Offer innovative hybrid-fee-based model'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Market directly through RI\'s Kids\' Place stores'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Keep tight control over operations and costs'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'Sit',
	        'c-header': 'R1, DE, R2'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram1Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1418);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram1-5c-1 .situation-title{text-align:left}#diagram1-5c-1 .simplest__structure-framework__diagram-box-bottom{margin-top:90px}#diagram1-5c-1 .structure-box-list{height:100px!important}#diagram1-5c-1 .diagram-header{margin-right:147px;width:150px;min-height:62px}.diagram1-5c-1.unit-diagram{min-height:773px}.diagram1-5c-1 .simplest__submit{bottom:350px!important}", ""]);
	
	// exports


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1420);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1421);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-5c-1\" class='unit-diagram diagram2-5c-1 scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>Should be able to build on our existing market presence to emerge as market leader</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Focus on K-5 enrichment curriculum in the Arts and Sciences</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Offer innovative hybrid-fee-based model</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Market directly through RI's Kids' Place stores</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Keep tight control over operations and costs</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_ScqDiagramCourseCont) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram2Controller, _ScqDiagramCourseCont);
	
	  function Diagram2Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram2Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1423);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram2-5c-1 .simplest__structure-box{width:440px}#diagram2-5c-1 .simplest__structure-box .simplest__text-area{height:105px;overflow:hidden}#diagram2-5c-1 .submit{top:-35px;right:0}", ""]);
	
	// exports


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1425);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1426);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1427);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-5c-2\" class='unit-diagram diagram3-5c-2 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram3-5c.title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram3-5c.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"201px\">\n            <line x1=\"200\" y1=\"48\" x2=\"35\" y2=\"132\"/>\n            <line x1=\"200\" y1=\"48\" x2=\"145\" y2=\"132\"/>\n            <line x1=\"200\" y1=\"48\" x2=\"255\" y2=\"132\"/>\n            <line x1=\"200\" y1=\"48\" x2=\"365\" y2=\"132\"/>\n          </svg>\n          <div class=\"diagram-header simplest__structure-framework__diagram-box\">\n            <p translate>diagram3-5c.diagram-header</p>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5c.first-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5c.second-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5c.third-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5c.fourth-box</p>\n            </div>\n          </div>\n        </div>\n        <p class=\"simplest__structure-framework__bottom-desc-text\" translate>diagram3-5c.desc-text</p>\n        <p style=\"margin-bottom: -23px;\" class=\"simplest__structure-framework__bottom-desc-text\" translate>diagram3-5c.desc-text-2</p>\n        <div style=\"margin-left: 15px;\" class=\"simplest__structure-framework__bottom-box-points\" translate>diagram3-5c.bottom-box-points</div>\n        <p class=\"simplest__structure-framework__situation-desc situation-desc\" translate>diagram3-5c.situation-desc</p>\n        <div style=\"padding-right: 65px; margin-top: 30px;\">\n          <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-a</div>\n            <div style=\"height: 135px !important;\" class=\"simplest__structure-framework-box structure-box-list\" translate>diagram3-5c.answers.r1-top</div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-a</div>\n            <div style=\"height: 135px !important;\" class=\"simplest__structure-framework-box structure-box-list\" translate>diagram3-5c.answers.r2-top</div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-a</div>\n          <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"divider-dashed\"></div>\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-b</div>\n            <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-b</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-b</div>\n          <div class=\"simplest__structure-framework-box structure-box-list\" translate>diagram3-5c.answers.solution-bottom</div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram3-5c.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component\n                  tooltip-text=\"answer.title\"\n                  tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-4px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_FrameworkCourseContr) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _FrameworkCourseContr);
	
	  function Diagram3Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 4;
	    _this.clearDiagramId = 2;
	    _this.exerciseId = 'exercise-2';
	    _this.pyramidData = {
	      exerciseNumber: 2,
	      scheme: {
	        model: {
	          textarea: 'Eastwood can develop a single core architecture that each Plan could adapt economically to its own market'
	        },
	        children: [{
	          model: {
	            textarea: 'It would focus on the Plans’ six common business systems'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'It would include access to eleven major functionalities'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'It would be based on a flexible, open, 4-layered architecture'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'It would be implemented smoothly in four phases'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'Sit, DE, R1-a, R2-a, Sol-a',
	        'c-header': 'R1-b, R2-b, Sol-b'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram3Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1428);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".diagram3-5c-2{min-height:980px}.diagram3-5c-2 .diagram-header{width:170px}.diagram3-5c-2 .simplest__structure-framework__bottom-box-points ul{max-width:none}.diagram3-5c-2 .simplest__structure-framework__diagram-box p{display:flex;align-items:center;justify-content:center}.diagram3-5c-2 .situation-title{text-align:center}.diagram3-5c-2 .structure-box-list ul{list-style:none;padding-inline-start:10px}.diagram3-5c-2 .framework-diagram .simplest__submit{bottom:200px}.diagram3-5c-2 .framework-diagram .simplest__structure-framework-box.r1-block__box,.diagram3-5c-2 .framework-diagram .simplest__structure-framework-box.r2-block__box{height:135px!important}.diagram3-5c-2 .framework-diagram .divider-dashed{background-image:linear-gradient(90deg,#fff 65%,hsla(0,0%,100%,0) 0);background-position:top right 18px;background-size:20px 4px;height:4px;margin-top:50px;margin-bottom:50px;width:80%;position:relative;left:10%;background-repeat:repeat-x}", ""]);
	
	// exports


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1430);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1431);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1432);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-5c-2\" class='unit-diagram scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>Eastwood can develop a single core architecture that each Plan could adapt economically to its own market</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>It would focus on the Plans’ six common business systems</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>It would include access to eleven major functionalities</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>It would be based on a flexible, open, 4-layered architecture</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>It would be implemented smoothly in four phases</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_ScqDiagramCourseCont) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram4Controller, _ScqDiagramCourseCont);
	
	  function Diagram4Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram4Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1433);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram4-5c-2 .simplest__text-area{height:85px;overflow:hidden}#diagram4-5c-2 .submit{top:-35px;right:0}", ""]);
	
	// exports


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1435);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1436);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1437);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-5c-3\" class='unit-diagram diagram5-5c-3 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram5-5c.title</p>\n\n    <p class=\"framework-diagram__exercise-title\" style=\"margin-top: 15px;\" translate>diagram5-5c.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram5-5c.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"201px\">\n            <line x1=\"127\" y1=\"61\" x2=\"127\" y2=\"127\"/>\n            <line x1=\"64\" y1=\"127\" x2=\"340\" y2=\"128\"/>\n            <line x1=\"65\" y1=\"127\" x2=\"65\" y2=\"153\"/>\n            <line x1=\"200\" y1=\"127\" x2=\"200\" y2=\"153\"/>\n            <line x1=\"340\" y1=\"127\" x2=\"340\" y2=\"153\"/>\n          </svg>\n          <div class=\"diagram-header simplest__structure-framework__diagram-box\">\n            <p translate>diagram5-5c.diagram-header</p>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5c.left-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5c.middle-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5c.right-box</p>\n            </div>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram5-5c.bottom-box-points</div>\n        <p class=\"simplest__structure-framework__situation-desc situation-desc\" translate>diagram5-5c.situation-desc</p>\n        <div style=\"padding-right: 65px; margin-top: 30px;\">\n          <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-a</div>\n            <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-a</div>\n            <div data-index=\"5\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-a</div>\n          <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"divider-dashed\"></div>\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-b</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-b</div>\n            <div data-index=\"7\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-b</div>\n          <div data-index=\"6\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram5-5c.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component\n                  tooltip-text=\"answer.title\"\n                  tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-4px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_FrameworkCourseContr) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _FrameworkCourseContr);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 7;
	    _this.clearDiagramId = 3;
	    _this.exerciseId = 'exercise-3';
	    _this.pyramidData = {
	      exerciseNumber: 3,
	      scheme: {
	        model: {
	          textarea: 'ISG’s strategy should be to move in slowly, and expand as its strengths grow'
	        },
	        children: [{
	          model: {
	            textarea: 'Start as niche provider of systems, management & maintenance in non-DOD markets'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Enter via an enabling acquisition'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Develop a srrong market-oriented organization'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Migrate from niche provider to broader market coverage'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'Sol-1, DE, R2-a',
	        'c-header': 'R1-b, R2-b'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram5Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1438);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".diagram5-5c-3{min-height:1120px}.diagram5-5c-3 .diagram-header{width:170px}.diagram5-5c-3 .simplest__structure-framework__bottom-box-points ul{max-width:none}.diagram5-5c-3 .situation-title{text-align:left}.diagram5-5c-3 .framework-diagram .simplest__submit{bottom:-20px}.diagram5-5c-3 .framework-diagram .simplest__structure-framework-box{height:95px!important}.diagram5-5c-3 .framework-diagram .simplest__structure-framework-box.r1-block__box,.diagram5-5c-3 .framework-diagram .simplest__structure-framework-box.r2-block__box{height:135px!important}.diagram5-5c-3 .framework-diagram .divider-dashed{background-image:linear-gradient(90deg,#fff 65%,hsla(0,0%,100%,0) 0);background-position:top right 18px;background-size:20px 4px;height:4px;margin-top:50px;margin-bottom:50px;width:80%;position:relative;left:10%;background-repeat:repeat-x}.diagram5-5c-3 .simplest__structure-framework__diagram-box-bottom{margin-top:90px}.diagram5-5c-3 .simplest__structure-framework__diagram-box-bottom .simplest__structure-framework__diagram-box{width:130px}.diagram5-5c-3 .simplest__structure-framework__diagram-box-bottom .simplest__structure-framework__diagram-box p{line-height:20px}.diagram5-5c-3 .structure-box-list{padding-left:10px;height:100px!important}.diagram5-5c-3 .structure-box-list li,.diagram5-5c-3 .structure-box-list p{font-size:14px;color:#fff;font-family:Nexa-Bold,sans pro,\"serif\"}.diagram5-5c-3 .structure-box-list ul{margin-block-start:9px;margin-block-end:5px;padding-inline-start:27px}.diagram5-5c-3 .diagram-header{margin-right:147px;width:120px;min-height:62px}.diagram5-5c-3 .diagram-header p{text-align:center}", ""]);
	
	// exports


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1440);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1441);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1442);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram6-5c-5\" class='unit-diagram scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>ISG’s strategy should be to move in slowly, and expand as its strengths grow</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"325\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"575\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"810\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Start as niche provider of systems, management & maintenance in non-DOD markets</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Enter via an enabling acquisition</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Develop a strong market-oriented organization</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Migrate from niche provider to broader market coverage</p>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n</div>\n"

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_ScqDiagramCourseCont) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram6Controller, _ScqDiagramCourseCont);
	
	  function Diagram6Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram6Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1443);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram6-5c-5 .scq-block{border-color:#fff}#diagram6-5c-5 .scq-block p{color:#fff}#diagram6-5c-5 .scq-diagram line{stroke:#fff}#diagram6-5c-5 .submit{top:-35px;right:0}", ""]);
	
	// exports


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1445);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1446);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1447);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram7Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram7Component;

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram7-5c-1\" class='unit-diagram diagram7-5c-1 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__title\" translate>diagram7-5c.title</p>\n\n    <p class=\"framework-diagram__exercise-title\" style=\"margin-top: 15px;\" translate>diagram7-5c.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div>\n        <div class=\"simplest__structure-framework__image simplest__image\">\n          <img src=\"/assets/images/section-5d-1.png\" alt=\"\">\n          <div style=\"padding-right: 65px; margin-top: 30px;\">\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n          </div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-a</div>\n            <div class=\"simple-separator\"></div>\n            <div data-index=\"{{[1, 5]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__top-part\"></div>\n            <div data-index=\"{{[1, 5]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__bottom-part\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-a</div>\n            <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-a</div>\n          <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"divider-dashed\"></div>\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-b</div>\n            <div class=\"simplest__structure-framework-box structure-box-list\"><p translate>diagram7-5c.answers.r1-bottom</p></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-b</div>\n            <div class=\"simplest__structure-framework-box structure-box-list\">\n              <p translate>diagram7-5c.answers.r2-bottom</p>\n              <p translate>diagram7-5c.answers.r2-bottom-2</p>\n            </div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-b</div>\n          <div class=\"simplest__structure-framework-box structure-box-list\"><p translate>diagram7-5c.answers.solution-bottom</p></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram7-5c.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div id=\"{{answer.answer}}\" data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component tooltip-text=\"answer.title\"\n                                         tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-7px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram7Controller = function (_FrameworkCourseContr) {
	  Diagram7Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram7Controller, _FrameworkCourseContr);
	
	  function Diagram7Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram7Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram7Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram7Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 5;
	    _this.clearDiagramId = 4;
	    _this.exerciseId = 'exercise-4';
	    _this.pyramidData = {
	      exerciseNumber: 4,
	      scheme: {
	        model: {
	          textarea: 'Eastwood has the qualities necessary to deliver and manage an outstanding new systems development facility for Spirit'
	        },
	        children: [{
	          model: {
	            textarea: 'We have a clear vision of the finished facility that Spirit needs'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'We will bring together the necessary levels of expertise to get the job done'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'We can move expeditiously to bring the whole project to life'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'Sit, R1-a, Sol-a',
	        'c-header': 'R1-b, R2-b, Sol-b'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram7Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram7Controller;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1448);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram7.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram7-5c-1{padding-top:40px;min-height:910px;padding-bottom:50px}#diagram7-5c-1 .framework-diagram .simplest__submit{bottom:-20px;right:5.8vw}#diagram7-5c-1 .framework-diagram .simplest__structure-answers{width:37%}#diagram7-5c-1 .framework-diagram .r1-block__box{height:190px!important}#diagram7-5c-1 .framework-diagram__title{text-align:left;font-size:22px;letter-spacing:1px;font-family:Nexa-Bold,sans pro,\"serif\";font-weight:700;padding:0 120px 20px}#diagram7-5c-1 .framework-diagram .divider-dashed{background-image:linear-gradient(90deg,#fff 65%,hsla(0,0%,100%,0) 0);background-position:top right 18px;background-size:20px 4px;height:4px;margin-top:50px;margin-bottom:50px;width:80%;position:relative;left:10%;background-repeat:repeat-x}#diagram7-5c-1 .r1-block__top-part{position:relative;top:8px}#diagram7-5c-1 .r1-block__bottom-part{top:-1px;border-top-right-radius:0;border-top-left-radius:0}#diagram7-5c-1 .simplest__submit{bottom:-20px}#diagram7-5c-1 .r2-block__box{margin-top:16px;height:133px!important}", ""]);
	
	// exports


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1450);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1451);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1452);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram8Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram8Component;

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram8-5c-2\" class='unit-diagram diagram8-5c-2 scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" style=\"margin-top: 0;\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index]\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div class=\"scq-block\">\n          <p>Eastwood has the qualities necessary to deliver and manage an outstanding new systems development facility for Spirit</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"450\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"805\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>We have a clear vision of the finished facility that Spirit needs</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>We will bring together the necessary levels of expertise to get the job done</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>We can move expeditiously to bring the whole project to life</p>\n          </div>\n        </div>\n        <div class=\"scq-diagram-body scq-diagram-body__list\">\n          <ul>\n            <li>Right people</li>\n            <li>Right configuration</li>\n            <li>Right management practices</li>\n          </ul>\n          <ul>\n            <li>SAIC for development</li>\n            <li>Bellcore for SME</li>\n            <li>HP for infrastructure</li>\n          </ul>\n          <ul>\n            <li>Plan</li>\n            <li>Build</li>\n            <li>Learn and transfer</li>\n            <li>Manage</li>\n          </ul>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram8Controller = function (_ScqDiagramCourseCont) {
	  Diagram8Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram8Controller, _ScqDiagramCourseCont);
	
	  function Diagram8Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram8Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram8Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram8Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram8Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram8Controller;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1453);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram8.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".diagram8-5c-2 .scq-diagram .scq-block{border-color:#fff}.diagram8-5c-2 .scq-diagram .scq-block p{color:#fff}.diagram8-5c-2 .scq-diagram svg line{stroke:#fff}.diagram8-5c-2 .submit{top:-35px;right:0}.diagram8-5c-2 .simplest__text-area{min-height:84px}.diagram8-5c-2 .scq-diagram-body__list ul li{color:#fff!important}", ""]);
	
	// exports


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1455);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1456);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1457);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram1-5d-1\" class='unit-diagram diagram1-5d-1 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p class=\"framework-diagram__exercise-title\" translate>diagram1-5d.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram1-5d.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <div class=\"simplest__structure-framework__diagram-box simplest__structure-framework__diagram-box-top\">\n            <p translate>diagram1-5d.diagram-header</p>\n          </div>\n        </div>\n        <div class=\"simplest__structure-framework__bottom-box-points\" translate>diagram1-5d.bottom-box-points</div>\n        <p style=\"font-size: 14px\" class=\"simplest__structure-framework__situation-desc\" translate>diagram1-5d.situation-desc</p>\n        <p style=\"margin: 30px 0;\" class=\"simplest__structure-framework__situation-desc\" translate>diagram1-5d.disturbing-event</p>\n        <div>\n          <div data-index=\"5\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div class=\"simple-separator\"></div>\n            <div data-index=\"{{[2, 4]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__top-part\">\n            </div>\n            <div data-index=\"{{[2, 4]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__bottom-part\">\n            </div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"1\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram1-5d.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component\n                  tooltip-text=\"answer.title\"\n                  tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-4px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram1Controller = function (_FrameworkCourseContr) {
	  Diagram1Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram1Controller, _FrameworkCourseContr);
	
	  function Diagram1Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram1Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram1Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram1Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 5;
	    _this.exerciseId = 'exercise-1';
	    _this.clearDiagramId = 1;
	    _this.first = true;
	    _this.pyramidData = {
	      exerciseNumber: 1,
	      scheme: {
	        model: {
	          textarea: 'Believe you would find it useful to participate in the pilot Risk Management Study'
	        },
	        children: [{
	          model: {
	            textarea: 'Will cover useful information'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Will produce a customized confidential report'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Will be updated periodically with analytical insights into developing credit risk trends.'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Will be subject to annual Steering Commit-tee review on utility/relevance of benchmarks'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Next steps – to enroll'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'DE, Sit',
	        'c-header': 'R1, R2, Sol'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram1Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram1Controller;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1458);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram1.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram1-5d-1{min-height:940px}#diagram1-5d-1 .simplest__submit{bottom:-30px!important}#diagram1-5d-1 .r2-block__box{margin-top:16px;height:133px!important}#diagram1-5d-1 .framework-diagram__exercise-title{padding-top:40px}", ""]);
	
	// exports


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1460);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1461);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1462);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram2Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram2Component;

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram2-5d-2\" class='unit-diagram diagram2-5d-2 scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea\n          ng-if=\"!vm.showSchoolAnswer[$index]\"\n          class=\"simplest__text-area\"\n          ng-class=\"['simplest__text-area_'+block.prop]\"\n          ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea\n          ng-if=\"vm.showSchoolAnswer[$index]\"\n          class=\"simplest__text-area\"\n          ng-class=\"['simplest__text-area_'+block.prop]\"\n          ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div style=\"max-width: 200px\" class=\"scq-block\">\n          <p>Believe you would find it useful to participate in the pilot Risk Management Study</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"65\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"260\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"450\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"640\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Will cover useful information</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Will produce a customized confidential report</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Will be updated periodically with analytical insights into developing credit risk trends.</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Will be subject to annual Steering Commit-tee review on utility/relevance of benchmarks</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Next steps – to enroll</p>\n          </div>\n        </div>\n\n        <div style=\"justify-content: flex-start\" class=\"scq-diagram-body scq-diagram-body__list\">\n          <ul style=\"list-style: none\">\n            <li>\n              - EconoRisk – RM benchmarking with macroeconomic analysis\n              <ul style=\"list-style-type: disc\">\n                <li>Best practices/potential impaction performance</li>\n              </ul>\n            </li>\n            <li>\n              - BARS – risk scoring and predictive analysis\n              <ul style=\"list-style-type: disc\">\n                <li>Assessment/forecast on direction of CR trends</li>\n              </ul>\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram2Controller = function (_ScqDiagramCourseCont) {
	  Diagram2Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram2Controller, _ScqDiagramCourseCont);
	
	  function Diagram2Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram2Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram2Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram2Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram2Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram2Controller;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1463);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram2.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".diagram2-5d-2 .submit{top:-35px;right:0}.diagram2-5d-2 .simplest__text-area_c,.diagram2-5d-2 .simplest__text-area_s{height:106px}.diagram2-5d-2 .simplest__text-area_c::-webkit-scrollbar,.diagram2-5d-2 .simplest__text-area_s::-webkit-scrollbar{width:0!important}", ""]);
	
	// exports


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1465);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1466);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1467);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram3Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram3Component;

/***/ }),
/* 1465 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram3-5d-1\" class='unit-diagram diagram3-5d-1 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p style=\"padding-top: 40px;\" class=\"framework-diagram__exercise-title\" translate>diagram3-5d.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram3-5d.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"450px\">\n            <line x1=\"97\" y1=\"79\" x2=\"65\" y2=\"162\"/>\n            <line x1=\"97\" y1=\"79\" x2=\"215\" y2=\"162\"/>\n            <line x1=\"350\" y1=\"79\" x2=\"300\" y2=\"346\"/>\n            <line x1=\"185\" y1=\"320\" x2=\"220\" y2=\"346\"/>\n          </svg>\n          <div style=\"margin-top: 0;\" class=\"simplest__structure-framework__diagram-box-bottom top-boxes\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5d.diagram-header-1</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5d.diagram-header-2</p>\n            </div>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5d.middle-left-box</p>\n            </div>\n            <div style=\"margin-left: 12px; margin-right: auto;\" class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram3-5d.middle-right-box</p>\n            </div>\n          </div>\n          <div class=\"bottom-box-list\" translate>diagram3-5d.bottom-box-list</div>\n          <div style=\"width: 100%;\" class=\"simplest__structure-framework__diagram-box\">\n            <p translate>diagram3-5d.bottom-box</p>\n          </div>\n        </div>\n        <p style=\"font-size: 14px\" class=\"simplest__structure-framework__situation-desc\" translate>diagram3-5d.situation-desc</p>\n        <p style=\"margin-top: 30px;\" class=\"simplest__structure-framework__situation-desc\" translate>diagram3-5d.disturbing-event</p>\n        <div>\n          <div class=\"simple-separator\"></div>\n          <div data-index=\"{{[6, 5]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__top-part\">\n          </div>\n          <div data-index=\"{{[6, 5]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__bottom-part\">\n          </div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-a</div>\n            <div class=\"simple-separator\"></div>\n            <div data-index=\"{{[1, 3]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__top-part\">\n            </div>\n            <div data-index=\"{{[1, 3]}}\" class=\"simplest__structure-box simplest__structure-framework-box r1-block__bottom-part\">\n            </div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-a</div>\n            <div data-index=\"2\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-a</div>\n          <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"divider-dashed\"></div>\n        <div class=\"flex-row\" style=\"margin-top: 35px;\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1-b</div>\n            <div data-index=\"8\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2-b</div>\n            <div data-index=\"9\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION-b</div>\n          <div data-index=\"7\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram3-5d.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component\n                  tooltip-text=\"answer.title\"\n                  tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-4px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram3Controller = function (_FrameworkCourseContr) {
	  Diagram3Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram3Controller, _FrameworkCourseContr);
	
	  function Diagram3Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram3Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram3Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram3Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 9;
	    _this.exerciseId = 'exercise-2';
	    _this.clearDiagramId = 2;
	    _this.pyramidData = {
	      exerciseNumber: 2,
	      scheme: {
	        model: {
	          textarea: 'Appoint an additional person to synchronize the activities of all 5 projects, with Program Manager, other managers, and implementation teams'
	        },
	        children: [{
	          model: {
	            textarea: 'Work with the teams to uncover duplication, align implementation dates'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Create a program plan identifying critical milestones determined'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Report on progress and achievement of the program to the PCIIT'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'Sit',
	        'c-header': 'DE, R1a. R2a, Sol, R1b, R2b, Solb'
	      }
	    };
	    return _this;
	  }
	
	  return Diagram3Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram3Controller;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1468);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram3.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram3-5d-1{min-height:1320px}#diagram3-5d-1 .r2-block__box{margin-top:16px;height:133px!important}#diagram3-5d-1 .simplest__submit{bottom:-13px}#diagram3-5d-1 .bottom-box-list{display:flex;margin-bottom:-19px}#diagram3-5d-1 .bottom-box-list ul{list-style:none}#diagram3-5d-1 .bottom-box-list ul li{color:#fff}#diagram3-5d-1 .top-boxes .simplest__structure-framework__diagram-box{width:47%}", ""]);
	
	// exports


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1470);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1471);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1472);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram4Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram4Component;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram4-5d-2\" class='unit-diagram diagram4-5d-2 scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span style=\"font-size: 15px\" ng-bind=\"block.title\"></span>\n        <textarea\n          ng-if=\"!vm.showSchoolAnswer[$index]\"\n          class=\"simplest__text-area\"\n          ng-class=\"['simplest__text-area_'+block.prop]\"\n          ng-readonly=\"block.disableEdit\"\n        >{{block.answer}}</textarea>\n        <textarea\n          ng-if=\"vm.showSchoolAnswer[$index]\"\n          class=\"simplest__text-area\"\n          ng-class=\"['simplest__text-area_'+block.prop]\"\n          ng-readonly=\"block.disableEdit\"\n        >{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div style=\"max-width: 290px\" class=\"scq-block\">\n          <p>Appoint an additional person to synchronize the activities of all 5 projects, with Program Manager, other managers, and implementation teams</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"450\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"800\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Work with the teams to uncover duplication, align implementation dates</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Create a program plan identifying critical milestones determined</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Report on progress and achievement of the program to the PCIIT</p>\n          </div>\n        </div>\n\n        <div style=\"justify-content: space-between\" class=\"scq-diagram-body scq-diagram-body__list\">\n          <ul style=\"list-style: none\">\n            <li>\n              - Review plans\n            </li>\n            <li>\n              - Identify inter-dependency of tasks and resources across the project\n            </li>\n            <li>\n              - Mitigate duplication of data conversion activities\n            </li>\n          </ul>\n          <ul style=\"list-style: none\">\n            <li>\n              - Record issues and risks\n            </li>\n            <li>\n              - Manage resolution\n            </li>\n            <li>\n              - Define countermeasures\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram4Controller = function (_ScqDiagramCourseCont) {
	  Diagram4Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram4Controller, _ScqDiagramCourseCont);
	
	  function Diagram4Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram4Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram4Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram4Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram4Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram4Controller;

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1473);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram4.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram4-5d-2 .scq-diagram-body .scq-block{max-width:230px}#diagram4-5d-2 .simplest__text-area_c{height:175px}#diagram4-5d-2 .simplest__text-area_s{height:130px}#diagram4-5d-2 .simplest__text-area_c::-webkit-scrollbar,#diagram4-5d-2 .simplest__text-area_s::-webkit-scrollbar{width:0!important}#diagram4-5d-2 ul{max-width:230px}#diagram4-5d-2 .submit{top:-35px;right:0}", ""]);
	
	// exports


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1475);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1476);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1477);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram5Component = {
	  bindings: {
	    data: '<',
	    setPyramidData: '&',
	    onSubmit: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram5Component;

/***/ }),
/* 1475 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram5-5d-1\" class='unit-diagram diagram5-5d-1 scq-diagram-dnd-framework-wrapper'>\n  <div class=\"framework-diagram\" id=\"{{vm.diagramId}}\">\n\n    <p style=\"padding-top: 40px;\" class=\"framework-diagram__exercise-title\" translate>diagram5-5d.exercise-title</p>\n\n    <div class=\"simplest__structure-framework__tasks framework-diagram__components simplest\">\n      <div class=\"simplest__structure-framework__diagram-wrapper\">\n        <p class=\"situation-title\" translate>diagram5-5d.situation-title</p>\n        <div class=\"simplest__structure-framework__diagram\">\n          <svg height=\"400px\" width=\"450px\">\n            <path d=\"M 300 320 L 305 326 L 295 326 Z\"></path>\n            <path d=\"M 380 320 L 385 326 L 375 326 Z\"></path>\n            <line x1=\"380\" y1=\"320\" x2=\"380\" y2=\"346\"/>\n            <line x1=\"300\" y1=\"320\" x2=\"300\" y2=\"346\"/>\n          </svg>\n          <div class=\"simplest__structure-framework__diagram-box\">\n            <p translate>diagram5-5d.diagram-header</p>\n          </div>\n          <p class=\"additional-text\" translate>diagram5-5d.text-1</p>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\">\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5d.first-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5d.second-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5d.third-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5d.fourth-box</p>\n            </div>\n            <div class=\"simplest__structure-framework__diagram-box\">\n              <p translate>diagram5-5d.fifth-box</p>\n            </div>\n          </div>\n          <div class=\"simplest__structure-framework__diagram-box-bottom\" translate>\n            diagram5-5d.box-desc\n          </div>\n          <div class=\"separator\" translate>\n            diagram5-5d.separator\n          </div>\n            <p style=\"font-size: 14px; margin-top: 15px; margin-right: auto;\" class=\"simplest__structure-framework__situation-desc\" translate>\n            diagram5-5d.situation-desc</p>\n          <p style=\"margin: 30px auto 30px 0;\" class=\"simplest__structure-framework__situation-desc\"\n             translate>\n            diagram5-5d.disturbing-event</p>\n          <div style=\"max-width: 400px; margin-right: auto;\" data-index=\"5\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n      </div>\n      <div class=\"simplest__middle\">\n        <div class=\"flex-row\">\n          <div class=\"r1-block\">\n            <div class=\"center r1-block__title\">R1</div>\n            <div class=\"simple-separator\"></div>\n            <div data-index=\"{{[1, 2]}}\"\n                 class=\"simplest__structure-box simplest__structure-framework-box r1-block__top-part\">\n            </div>\n            <div data-index=\"{{[1, 2]}}\"\n                 class=\"simplest__structure-box simplest__structure-framework-box r1-block__bottom-part\">\n            </div>\n          </div>\n          <div class=\"r2-block\">\n            <div class=\"center r2-block__title\">R2</div>\n            <div data-index=\"3\" class=\"simplest__structure-box simplest__structure-framework-box r2-block__box\"></div>\n          </div>\n        </div>\n        <svg class=\"simplest__connectors\">\n          <line x1=\"30%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n          <line x1=\"70%\" y1=\"0\" x2=\"50%\" y2=\"100\" stroke=\"white\" stroke-width=\"4\" stroke-linecap=\"round\"></line>\n        </svg>\n        <div class=\"simplest__structure-framework__solution\">\n          <div class=\"white\">SOLUTION</div>\n          <div data-index=\"4\" class=\"simplest__structure-box simplest__structure-framework-box\"></div>\n        </div>\n        <div class=\"submit simplest__submit\">\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"!vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'submit' | translate\"></button>\n          <button ng-if=\"!vm.diagramComplete && vm.submited\" ng-click=\"vm.hint()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'hint' | translate\"></button>\n          <button ng-class=\"{'simplest__structure-btn-disabled': vm.diagramComplete}\" ng-if=\"vm.submited\" ng-click=\"vm.submit(vm.pyramidData)\" class=\"simplest__structure-btn\" ng-bind=\"'resubmit' | translate\"></button>\n        </div>\n      </div>\n      <div class=\"simplest__structure-answers simplest__structure-framework-answers structure-answers\">\n        <div class=\"white structure-answers__title\" translate>diagram5-5d.structure-answers-title</div>\n        <div ng-repeat=\"answer in vm.data.answers\">\n          <div data-index=\"{{answer.answer}}\" class=\"simplest__structure-answer simplest__structure-framework-answer\">\n            <div class=\"simplest__structure-answer-content\">\n              <div ng-bind-html=\"answer.title\" ng-class=\"{'simplest__box-text': answer.hasArrow}\"></div>\n              <div ng-if=\"answer.hasArrow\" class=\"simplest__arrow-button\">\n                <arrow-tooltip-component\n                  tooltip-text=\"answer.title\"\n                  tooltip-styles=\"{'minto-arrow-tooltip': {'position': 'relative', 'top': '-4px'}}\">\n                </arrow-tooltip-component>\n              </div>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _frameworkCourse = __webpack_require__(869);
	
	var _frameworkCourse2 = _interopRequireDefault(_frameworkCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram5Controller = function (_FrameworkCourseContr) {
	  Diagram5Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout", "$scope"];
	  (0, _inherits3.default)(Diagram5Controller, _FrameworkCourseContr);
	
	  function Diagram5Controller(courseService, diagramService, $translate, $timeout, $scope) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram5Controller);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Diagram5Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram5Controller)).call(this, courseService, diagramService, $translate, $timeout, $scope));
	
	    _this.isFiveSection = true;
	    _this.amountCorrectAnswers = 5;
	    _this.exerciseId = 'exercise-3';
	    _this.clearDiagramId = 3;
	    _this.pyramidData = {
	      exerciseNumber: 3,
	      scheme: {
	        model: {
	          textarea: 'Essentially we want to understand what it would take for Slade to operate profitably in the Chinese Health Care market'
	        },
	        children: [{
	          model: {
	            textarea: 'Deal specifically with the issues concerning us'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Enlighten us on other factors that drive high S&M costs'
	          },
	          children: []
	        }, {
	          model: {
	            textarea: 'Draw conclusions on future development of the market'
	          },
	          children: []
	        }]
	      },
	      scq: {
	        's-header': 'DE, Sit',
	        'c-header': 'R1, R2, Sol'
	      },
	      instruction: 'This looks complex, but it is easy to deal with once you get the Situation for the problem definition laid out. The Disturbing Event is obvious once you go back to the background information I gave you at the beginning.'
	    };
	    return _this;
	  }
	
	  return Diagram5Controller;
	}(_frameworkCourse2.default);
	
	exports.default = Diagram5Controller;

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1478);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram5.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram5-5d-1{min-height:1000px}#diagram5-5d-1 .simplest__structure-framework__diagram-wrapper{width:40%}#diagram5-5d-1 .simplest__structure-framework__diagram-box-bottom ul{list-style:none;margin-block-start:0;margin-block-end:0;margin-inline-start:0;margin-inline-end:0;padding-inline-start:0}#diagram5-5d-1 .simplest__structure-framework__diagram-box-bottom ul li{font-size:14px;font-family:Nexa-Bold,sans pro,\"serif\";color:#fff}#diagram5-5d-1 .additional-text{color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";margin-top:30px;font-size:17px}#diagram5-5d-1 .separator{width:100%}#diagram5-5d-1 .separator>p{display:inline-block;margin-left:18.5%}#diagram5-5d-1 .separator p{color:#fff;font-family:Nexa-Bold,sans pro,\"serif\";font-size:15px}#diagram5-5d-1 .separator-top{border-bottom:1px solid #fff;width:100%;display:flex;justify-content:flex-end}#diagram5-5d-1 .separator-top p{display:inline-block}#diagram5-5d-1 .separator-top p:first-child{margin-right:5px}#diagram5-5d-1 .simplest__structure-framework__diagram-box-bottom{margin-top:30px}#diagram5-5d-1 .simplest__structure-framework__diagram-box-bottom .simplest__structure-framework__diagram-box{width:85px}#diagram5-5d-1 .simplest__structure-framework__diagram-box-bottom .simplest__structure-framework__diagram-box p{font-size:14px}#diagram5-5d-1 .r2-block__box{margin-top:16px;height:133px!important}#diagram5-5d-1 .bottom-box-list{display:flex;margin-bottom:-19px}#diagram5-5d-1 .bottom-box-list ul{list-style:none}#diagram5-5d-1 .bottom-box-list ul li{color:#fff}#diagram5-5d-1 .top-boxes .simplest__structure-framework__diagram-box{width:47%}#diagram5-5d-1 .submit{bottom:170px}", ""]);
	
	// exports


/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _diagram = __webpack_require__(1480);
	
	var _diagram2 = _interopRequireDefault(_diagram);
	
	var _diagram3 = __webpack_require__(1481);
	
	var _diagram4 = _interopRequireDefault(_diagram3);
	
	__webpack_require__(1482);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram6Component = {
	  bindings: {
	    data: '<',
	    onComplete: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _diagram2.default,
	  controller: _diagram4.default
	};
	
	exports.default = diagram6Component;

/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"diagram6-5d-2\" class='unit-diagram diagram6-5d-2 scq-diagram-dnd-wrapper'>\n\n  <div class=\"simplest__structure-diagram\" id=\"{{vm.diagramId}}\">\n\n    <div class=\"simplest__structure-subtitle\" ng-bind-html=\"vm.data.subtitle\" ng-if=\"vm.data.subtitle\"></div>\n\n    <div class=\"simplest__structure-block\" ng-repeat=\"block in vm.data.blocks\" ng-mouseenter=\"vm.showUserAnswear(block)\" ng-mouseleave=\"vm.hideUserAnswear(block)\">\n      <div class=\"simplest__structure-box\" ng-mouseover=\"vm.showSchoolAnswer[$index] = false\" ng-mouseleave=\"vm.showSchoolAnswer[$index] = true\">\n        <span ng-bind=\"block.title\"></span>\n        <textarea ng-if=\"!vm.showSchoolAnswer[$index] && block.answer\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.answer}}</textarea>\n        <textarea ng-if=\"vm.showSchoolAnswer[$index] || !block.answer\" class=\"simplest__text-area\" ng-readonly=\"block.disableEdit\">{{block.task}}</textarea>\n        <span ng-if=\"block.note\" ng-bind=\"block.note\" class=\"note\"></span>\n      </div>\n    </div>\n\n    <div class=\"simplest__structure-note\" ng-if=\"vm.data.note\">\n      <div class=\"simplest__structure-text\" ng-bind=\"vm.data.note\"></div>\n      <div class=\"simplest__structure-note__title\">NOTE from Barbara</div>\n    </div>\n\n<!--    <div class=\"submit\">-->\n<!--      <button ng-click=\"vm.switch()\" class=\"simplest__structure-btn\" ng-bind=\" vm.data.submitButton || 'simplest_structure' | translate\"></button>-->\n<!--      <button ng-if=\"vm.diagramComplete\" ng-class=\"{'simplest__structure-btn-disabled': vm.nextClicked}\" ng-click=\"vm.next()\" class=\"simplest__structure-btn anchor\" ng-bind=\"'complete' | translate\"></button>-->\n<!--    </div>-->\n\n    <div class=\"desc-scq-diagram\">\n      <div class=\"scq-diagram\">\n        <div style=\"max-width: 290px\" class=\"scq-block\">\n          <p>Essentially we want to understand what it would take for Slade to operate profitably in the Chinese Health Care market</p>\n        </div>\n        <svg>\n          <line x1=\"450\" y1=\"0\" x2=\"85\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"450\" y2=\"100\"/>\n          <line x1=\"450\" y1=\"0\" x2=\"800\" y2=\"100\"/>\n        </svg>\n        <div class=\"scq-diagram-body\">\n          <div class=\"scq-block\">\n            <p>Deal specifically with the issues concerning us</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Enlighten us on other factors that drive high S&M costs</p>\n          </div>\n          <div class=\"scq-block\">\n            <p>Draw conclusions on future development of the market</p>\n          </div>\n        </div>\n\n        <div style=\"justify-content: flex-start\" class=\"scq-diagram-body scq-diagram-body__list\">\n          <ul style=\"list-style: none\">\n            <li>\n              - How fast will the market grow and segment\n            </li>\n            <li>\n              - How difficult to gain access?\n            </li>\n            <li>\n              - How costly to market and sell?\n            </li>\n          </ul>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n"

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(145);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(155);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(188);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _scqDiagramCourse = __webpack_require__(1391);
	
	var _scqDiagramCourse2 = _interopRequireDefault(_scqDiagramCourse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Diagram6Controller = function (_ScqDiagramCourseCont) {
	  Diagram6Controller.$inject = ["courseService", "diagramService", "$translate", "$timeout"];
	  (0, _inherits3.default)(Diagram6Controller, _ScqDiagramCourseCont);
	
	  function Diagram6Controller(courseService, diagramService, $translate, $timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, Diagram6Controller);
	    return (0, _possibleConstructorReturn3.default)(this, (Diagram6Controller.__proto__ || (0, _getPrototypeOf2.default)(Diagram6Controller)).call(this, courseService, diagramService, $translate, $timeout));
	  }
	
	  return Diagram6Controller;
	}(_scqDiagramCourse2.default);
	
	exports.default = Diagram6Controller;

/***/ }),
/* 1482 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1483);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./diagram6.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#diagram6-5d-2 .scq-diagram-body .scq-block,#diagram6-5d-2 ul{max-width:230px}#diagram6-5d-2 li,#diagram6-5d-2 p{color:#fff}#diagram6-5d-2 .scq-block{border-color:#fff}#diagram6-5d-2 line{stroke:#fff}#diagram6-5d-2 .simplest__structure-note{left:-490px}#diagram6-5d-2 .simplest__structure-box{width:420px}#diagram6-5d-2 .simplest__text-area{height:85px;overflow:hidden}#diagram6-5d-2 .submit{top:-35px;right:0}", ""]);
	
	// exports


/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _carouselSlider = __webpack_require__(1485);
	
	var _carouselSlider2 = _interopRequireDefault(_carouselSlider);
	
	var _carouselSlider3 = __webpack_require__(1486);
	
	var _carouselSlider4 = _interopRequireDefault(_carouselSlider3);
	
	__webpack_require__(1487);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var diagram1Component = {
	  bindings: {
	    data: '<',
	    onFinish: '&',
	    finishedExercises: '<'
	  },
	  controllerAs: 'vm',
	  template: _carouselSlider2.default,
	  controller: _carouselSlider4.default
	};
	
	exports.default = diagram1Component;

/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"carousel-wrapper\">\n  <div class=\"carousel\" id=\"slider\">\n    <ul>\n      <li ng-repeat=\"src in vm.data\">\n        <img class=\"carousel__image\"\n             ng-src=\"{{src}}\"\n             alt=\"Slide\" />\n      </li>\n    </ul>\n  </div>\n\n  <div class=\"navigation-buttons\">\n    <button ng-class=\"{'navigation-buttons__disabled': vm.slideCount === 0}\" ng-click=\"vm.previous()\" class=\"navigation-buttons__previous\" translate>< PREVIOUS</button>\n    <button ng-class=\"{'navigation-buttons__disabled': vm.slideCount === vm.slidesCount}\" ng-click=\"vm.next()\" class=\"navigation-buttons__next\" translate>NEXT SLIDE ></button>\n  </div>\n</div>\n"

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CarouselSliderController = function () {
	  CarouselSliderController.$inject = ["$timeout"];
	  function CarouselSliderController($timeout) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, CarouselSliderController);
	    this.slideCount = 0;
	
	    (0, _assign2.default)(this, { $timeout: $timeout });
	
	    // this.image = angular.element('.carousel__image');
	  }
	
	  (0, _createClass3.default)(CarouselSliderController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.data = this.data.map(function (v) {
	        return v + '?' + new Date().getTime();
	      });
	      this.slidesCount = this.data.length - 1;
	      this.$timeout(function () {
	        var slideCount = $('#slider ul li').length;
	        _this.slideWidth = $('#slider ul li img').width();
	        var slideHeight = $('#slider ul li img').height();
	        var sliderUlWidth = slideCount * _this.slideWidth;
	        $('#slider').css({ width: _this.slideWidth, height: slideHeight });
	
	        $('#slider ul').css({ width: sliderUlWidth, marginLeft: -_this.slideWidth });
	
	        $('#slider ul li:last-child').prependTo('#slider ul');
	      }, 300);
	    }
	  }, {
	    key: 'previous',
	    value: function previous() {
	      this.slideCount -= 1;
	      $('#slider ul').animate({
	        left: +this.slideWidth
	      }, 400, function () {
	        $('#slider ul li:last-child').prependTo('#slider ul');
	        $('#slider ul').css('left', '');
	      });
	    }
	  }, {
	    key: 'next',
	    value: function next() {
	      this.slideCount += 1;
	      $('#slider ul').animate({
	        left: -this.slideWidth
	      }, 400, function () {
	        $('#slider ul li:first-child').appendTo('#slider ul');
	        $('#slider ul').css('left', '');
	      });
	    }
	
	    // animation(property) {
	    //   const opacity = property === 'hide' ? 0 : 1;
	    //   this.image.css({opacity: opacity, 'transition-duration': '0.5s'});
	    // }
	
	  }]);
	  return CarouselSliderController;
	}();
	
	exports.default = CarouselSliderController;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1488);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./carousel-slider.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/sass-loader/index.js!./carousel-slider.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, ".carousel-wrapper{width:100%;display:flex;flex-direction:column;justify-content:center;align-items:center;min-height:150px}.carousel-wrapper .title{margin-right:auto;color:#050e61;font-weight:700}.carousel-wrapper .carousel{width:100%!important;height:515px!important;border:5px solid #ff0;border-radius:25px;text-align:center;position:relative;overflow:hidden}.carousel-wrapper .carousel ul{list-style:none;position:relative;margin:0;padding:0}.carousel-wrapper .carousel ul li{width:max-content;height:515px;position:relative;display:block;float:left;margin:0;padding:0}.carousel-wrapper .carousel__image{margin:auto;max-width:100%;max-height:100%;border-radius:25px}.carousel-wrapper .carousel__image-show{animation-fill-mode:forwards;animation-duration:.5s;animation-name:fadeIn}.carousel-wrapper .carousel__image-hide{animation-fill-mode:forwards;animation-duration:.5s;animation-name:fadeOut}.carousel-wrapper .navigation-buttons{margin-top:30px;display:flex;flex-direction:row;justify-content:center}.carousel-wrapper .navigation-buttons__next,.carousel-wrapper .navigation-buttons__previous{border-radius:10px;background-color:#ff0;color:#050e61;outline:none;padding:9px 10px 5px;cursor:pointer}.carousel-wrapper .navigation-buttons__next{margin-left:15px}.carousel-wrapper .navigation-buttons__disabled{pointer-events:none;opacity:.4}.carousel-wrapper .navigation-buttons__previous{margin-right:15px}", ""]);
	
	// exports


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _introductionPopup = __webpack_require__(1490);
	
	var _introductionPopup2 = _interopRequireDefault(_introductionPopup);
	
	var _introductionPopup3 = __webpack_require__(1491);
	
	var _introductionPopup4 = _interopRequireDefault(_introductionPopup3);
	
	__webpack_require__(1492);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var introductionPopup = {
	  bindings: {
	    onClose: '&'
	  },
	  controllerAs: 'vm',
	  template: _introductionPopup2.default,
	  controller: _introductionPopup4.default
	};
	
	exports.default = introductionPopup;

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"introduction-popup\" ng-click=\"vm.close()\">\n  <div ng-click=\"$event.stopPropagation()\" class=\"introduction-popup__content\">\n    <p class=\"introduction-popup__title\">Introduction</p>\n    <span ng-click=\"vm.close()\" class=\"introduction-popup__close\">&times;</span>\n    <p>&nbsp;</p>\n    <p>Hello {{ vm.user }},</p>\n    <p>&nbsp;</p>\n    <p>Welcome to Minto, a course created by Barbara Minto for top tier consultants in understanding written material, identifying complex problems, and structuring solutions. It is now the standard methodology within the consulting world and forms the basis of the best in-house consultant training. </p>\n    <p>In this course, Barbara Minto will present a series of detailed lectures to you after which you will be given exercises of increasing complexity to test your understanding and comprehension of the material. This pioneer at Harvard Business School and McKinsey has been teaching this material worldwide for over 30 years and has set many, if not most of the world's top business minds on their roads to fame and fortune. You can rewatch the material as many times as you like, to extract the maximum insight from Barbara’s lectures.</p>\n    <p>&nbsp;</p>\n    <p>Though some of the material in this course is hard, you will soon discover it to be some of the most practical and insightful learning you will ever undertake. Please complete all the exercises as in doing so you will unlock your official Minto certification - you may download and print a certificate for yourself on completing the course or at any time in the future. </p>\n    <p>&nbsp;</p>\n    <p>Throughout the course you have three main additional resources to help your progress:  Firstly while on the course pages, you will see side tabs “Note from Barbara” just click on them, please read all of these as they provide insights into many of the exercises. Also you will see a hamburger symbol in the top left of your screen; clicking on this will give you access to written help material on the more complex areas of the course written by Barbara herself, and finally, you have access to the Minto private forum with posts relating to each exercise, written by course administrators and former students where there is discussion on each and every exercise at some depth, if you don’t see a solution here you may post your own questions. </p>\n    <p>This course is brand-new and should you find any error, we would very much appreciate that you contact us to highlight it at angelo@barbaraminto.com. I thank you for your help in that regard.</p>\n    <p>I hope you will enjoy Minto. It will be well worth your efforts.</p>\n    <p>&nbsp;</p>\n    <p>Angelo Valentino</p>\n  </div>\n</div>\n"

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IntroductionPopupController = function () {
	  IntroductionPopupController.$inject = ["$state", "authService"];
	  function IntroductionPopupController($state, authService) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, IntroductionPopupController);
	    (0, _assign2.default)(this, { $state: $state, authService: authService });
	    this.user = authService.userData.firstName;
	  }
	
	  (0, _createClass3.default)(IntroductionPopupController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      $('body').css('overflow', 'hidden');
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      $('body').css('overflow', 'auto');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.onClose({ $event: { name: 'introduction-popup' } });
	    }
	  }]);
	  return IntroductionPopupController;
	}();
	
	exports.default = IntroductionPopupController;

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1493);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./introduction-popup.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./introduction-popup.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#introduction-popup{position:fixed;z-index:101;padding-top:100px;left:0;top:0;right:0;bottom:0;overflow:auto;background-color:rgba(0,0,0,.7)}#introduction-popup .introduction-popup__content{background-color:#fefefe;margin:auto;padding:20px;width:80%;border-radius:15px;position:relative}#introduction-popup .introduction-popup__title{text-align:center;font-size:38px;width:calc(100% + 40px);margin-top:-20px;margin-left:-20px;padding:20px 0;background:rgba(0,0,0,.1)}#introduction-popup .introduction-popup__close{color:#aaa;position:absolute;font-size:36px;top:20px;right:20px;font-weight:700}#introduction-popup .introduction-popup__close:focus,#introduction-popup .introduction-popup__close:hover{color:#000;text-decoration:none;cursor:pointer}", ""]);
	
	// exports


/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _testDrivePopup = __webpack_require__(1495);
	
	var _testDrivePopup2 = _interopRequireDefault(_testDrivePopup);
	
	var _testDrivePopup3 = __webpack_require__(1496);
	
	var _testDrivePopup4 = _interopRequireDefault(_testDrivePopup3);
	
	__webpack_require__(1497);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var introductionPopup = {
	  bindings: {
	    onClose: '&'
	  },
	  controllerAs: 'vm',
	  template: _testDrivePopup2.default,
	  controller: _testDrivePopup4.default
	};
	
	exports.default = introductionPopup;

/***/ }),
/* 1495 */
/***/ (function(module, exports) {

	module.exports = "<div id=\"test-drive-popup\">\n  <div class=\"test-drive-popup__content\">\n    <span ng-click=\"vm.close()\" class=\"test-drive-popup__close\">&times;</span>\n    <course-video lecture-title=\"''\" video-link=\"vm.videoUrl\" video-title=\"''\"></course-video>\n  </div>\n</div>\n"

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(107);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _classCallCheck2 = __webpack_require__(150);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(151);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _constants = __webpack_require__(459);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TestDrivePopup = function () {
	  TestDrivePopup.$inject = ["$sce"];
	  function TestDrivePopup($sce) {
	    'ngInject';
	
	    (0, _classCallCheck3.default)(this, TestDrivePopup);
	    (0, _assign2.default)(this, { $sce: $sce });
	
	    this.videoUrl = this.$sce.trustAsResourceUrl(_constants.Constants.videos.testDriveUrl);
	  }
	
	  (0, _createClass3.default)(TestDrivePopup, [{
	    key: '$onInit',
	    value: function $onInit() {
	      $('body').css('overflow', 'hidden');
	    }
	  }, {
	    key: '$onDestroy',
	    value: function $onDestroy() {
	      $('body').css('overflow', 'auto');
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.onClose({ $event: { name: 'test-drive-popup' } });
	    }
	  }]);
	  return TestDrivePopup;
	}();
	
	exports.default = TestDrivePopup;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1498);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(7)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./test-drive-popup.scss", function() {
				var newContent = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/index.js!./test-drive-popup.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(6)();
	// imports
	
	
	// module
	exports.push([module.id, "#test-drive-popup{position:fixed;z-index:101;padding-top:100px;left:0;top:0;right:0;bottom:0;overflow:auto;background-color:rgba(0,0,0,.7)}#test-drive-popup #unit-video{margin:33px auto;width:calc(100% - 46px)}#test-drive-popup #unit-video video{max-height:510px!important}#test-drive-popup .test-drive-popup__content{background-color:#fefefe;margin:auto;padding:24px;border:1px solid #888;width:80%}#test-drive-popup .test-drive-popup__content .unit-wrapper{padding:0}#test-drive-popup .test-drive-popup__close{color:#aaa;float:right;font-size:28px;font-weight:700}#test-drive-popup .test-drive-popup__close:focus,#test-drive-popup .test-drive-popup__close:hover{color:#000;text-decoration:none;cursor:pointer}", ""]);
	
	// exports


/***/ })
]);


// WEBPACK FOOTER //
// app.bundle.js